import { Comment, Text, ref, watch, getCurrentScope, onScopeDispose, readonly, unref, computed, shallowRef, nextTick, getCurrentInstance, onMounted, inject, camelize, capitalize, reactive, defineComponent, openBlock, createBlock, Transition, withCtx, renderSlot, createElementBlock, createElementVNode, onUnmounted, normalizeClass, normalizeProps, guardReactiveProps, Fragment, createCommentVNode, toDisplayString, mergeProps, createVNode, resolveDynamicComponent, withDirectives, vShow, normalizeStyle, createTextVNode, provide, renderList, isRef, defineAsyncComponent, Suspense, onBeforeUnmount, Teleport, vModelSelect, withKeys, vModelText, withModifiers, useSlots, vModelDynamic, createStaticVNode, createSlots, toHandlers } from 'vue';
import { createPopper } from '@popperjs/core';
import { MenuItem, Menu, MenuButton, MenuItems, TransitionRoot, Dialog, TransitionChild, DialogOverlay, DialogPanel, DialogTitle, DialogDescription, RadioGroupLabel, RadioGroupDescription, RadioGroup, RadioGroupOption } from '@headlessui/vue';
import { DatePicker } from 'v-calendar';

const addToArray = (arr, value) => {
  if (!Array.isArray(arr)) {
    return [value];
  }
  return [...arr, value];
};
const addToArray$1 = addToArray;

const Base64 = {
  // private property
  _keyStr: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
  // public method for encoding
  encode(input) {
    let output = "";
    let chr1, chr2, chr3, enc1, enc2, enc3, enc4;
    let i = 0;
    input = Base64._utf8_encode(input);
    while (i < input.length) {
      chr1 = input.charCodeAt(i++);
      chr2 = input.charCodeAt(i++);
      chr3 = input.charCodeAt(i++);
      enc1 = chr1 >> 2;
      enc2 = (chr1 & 3) << 4 | chr2 >> 4;
      enc3 = (chr2 & 15) << 2 | chr3 >> 6;
      enc4 = chr3 & 63;
      if (isNaN(chr2)) {
        enc3 = enc4 = 64;
      } else if (isNaN(chr3)) {
        enc4 = 64;
      }
      output = output + this._keyStr.charAt(enc1) + this._keyStr.charAt(enc2) + this._keyStr.charAt(enc3) + this._keyStr.charAt(enc4);
    }
    return output;
  },
  // public method for decoding
  decode(input) {
    let output = "";
    let chr1, chr2, chr3;
    let enc1, enc2, enc3, enc4;
    let i = 0;
    input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");
    while (i < input.length) {
      enc1 = this._keyStr.indexOf(input.charAt(i++));
      enc2 = this._keyStr.indexOf(input.charAt(i++));
      enc3 = this._keyStr.indexOf(input.charAt(i++));
      enc4 = this._keyStr.indexOf(input.charAt(i++));
      chr1 = enc1 << 2 | enc2 >> 4;
      chr2 = (enc2 & 15) << 4 | enc3 >> 2;
      chr3 = (enc3 & 3) << 6 | enc4;
      output = output + String.fromCharCode(chr1);
      if (enc3 !== 64) {
        output = output + String.fromCharCode(chr2);
      }
      if (enc4 !== 64) {
        output = output + String.fromCharCode(chr3);
      }
    }
    output = Base64._utf8_decode(output);
    return output;
  },
  // private method for UTF-8 encoding
  _utf8_encode(string) {
    string = string.replace(/\r\n/g, "\n");
    let utftext = "";
    for (let n = 0; n < string.length; n++) {
      const c = string.charCodeAt(n);
      if (c < 128) {
        utftext += String.fromCharCode(c);
      } else if (c > 127 && c < 2048) {
        utftext += String.fromCharCode(c >> 6 | 192);
        utftext += String.fromCharCode(c & 63 | 128);
      } else {
        utftext += String.fromCharCode(c >> 12 | 224);
        utftext += String.fromCharCode(c >> 6 & 63 | 128);
        utftext += String.fromCharCode(c & 63 | 128);
      }
    }
    return utftext;
  },
  // private method for UTF-8 decoding
  _utf8_decode(utftext) {
    let string = "";
    let i = 0;
    let c = 0;
    let c2 = 0;
    let c3 = 0;
    while (i < utftext.length) {
      c = utftext.charCodeAt(i);
      if (c < 128) {
        string += String.fromCharCode(c);
        i++;
      } else if (c > 191 && c < 224) {
        c2 = utftext.charCodeAt(i + 1);
        string += String.fromCharCode((c & 31) << 6 | c2 & 63);
        i += 2;
      } else {
        c2 = utftext.charCodeAt(i + 1);
        c3 = utftext.charCodeAt(i + 2);
        string += String.fromCharCode((c & 15) << 12 | (c2 & 63) << 6 | c3 & 63);
        i += 3;
      }
    }
    return string;
  }
};
const Base64$1 = Base64;

const debounce$2 = (func, wait = 200) => {
  let timeout;
  const cancel = () => {
    if (timeout) {
      clearTimeout(timeout);
    }
  };
  const debounceFn = (...args) => {
    cancel();
    timeout = setTimeout(() => {
      timeout = void 0;
      func(args);
    }, wait);
    if (!wait) {
      func(args);
    }
  };
  return Object.assign(debounceFn, { cancel });
};
const debounce$3 = debounce$2;

const elementIsTargetOrTargetChild = (target, wrapper) => {
  if (!(target instanceof Element)) {
    return false;
  }
  return wrapper.contains(target);
};
const elementIsTargetOrTargetChild$1 = elementIsTargetOrTargetChild;

const filterOptions = (options, query) => {
  if (query === "") {
    return options;
  }
  return options.map((option) => {
    if (option.children) {
      const newOption = {
        ...option,
        ...{
          children: filterOptions(option.children, query)
        }
      };
      return newOption;
    }
    return option;
  }).filter((option) => {
    const foundText = String(option.text).toUpperCase().trim().includes(query.toUpperCase().trim());
    const hasChildren = option.children && option.children.length > 0;
    return hasChildren || foundText;
  });
};
const filterOptions$1 = filterOptions;

const flattenOptions = (options) => options.flatMap((option) => {
  if (option.children) {
    return flattenOptions(option.children);
  }
  return option;
});
const flattenOptions$1 = flattenOptions;

const get$3 = (object, path, defaultValue) => {
  const result = String(path).replace(/\[/g, ".").replace(/\]/g, "").split(".").reduce((objectSoFar, step) => {
    if (typeof objectSoFar === "object" || Array.isArray(objectSoFar)) {
      return objectSoFar[step];
    }
    return void 0;
  }, object);
  return result === void 0 ? defaultValue : result;
};
const get$4 = get$3;

const hasProperty = (obj, prop) => obj !== null && typeof obj === "object" && Object.prototype.hasOwnProperty.call(obj, prop);
const hasProperty$1 = hasProperty;

function hasSlot(slot, slotProps = {}) {
  if (!slot)
    return false;
  return slot(slotProps).some((vnode) => {
    if (vnode.type === Comment)
      return false;
    if (Array.isArray(vnode.children) && !vnode.children.length)
      return false;
    return vnode.type !== Text || typeof vnode.children === "string" && vnode.children.trim() !== "";
  });
}

const isEqual = (a, b) => JSON.stringify(a) === JSON.stringify(b);
const isEqual$1 = isEqual;

const isPrimitive = (value) => {
  if (value === null) {
    return true;
  }
  return !["array", "function", "object"].includes(typeof value);
};
const isPrimitive$1 = isPrimitive;

const isNumber$2 = (value) => {
  if (value === null) {
    return false;
  }
  return ["number"].includes(typeof value);
};
const isNumber$3 = isNumber$2;

const guessOptionValue = (option, valueAttribute) => {
  if (valueAttribute) {
    const value = get$4(option, valueAttribute);
    if (value === null) {
      return null;
    }
    if (typeof value === "undefined") {
      return void 0;
    }
    if (typeof value === "number" || typeof value === "string") {
      return value;
    }
    return String(value);
  }
  return option.value;
};
const guessOptionText = (option, textAttribute) => {
  if (textAttribute) {
    const text = get$4(option, textAttribute);
    if (typeof text === "undefined" || text === null) {
      return "";
    }
    if (typeof text === "number" || typeof text === "string") {
      return text;
    }
    return String(text);
  }
  return option.text;
};
const normalizeOption = (option, textAttribute, valueAttribute) => {
  if (typeof option === "string" || typeof option === "number") {
    return {
      value: option,
      text: option,
      raw: option
    };
  }
  const normalizedOption = {
    value: guessOptionValue(option, valueAttribute),
    text: guessOptionText(option, textAttribute),
    raw: option
  };
  if (option.disabled) {
    normalizedOption.disabled = true;
  }
  if (option.children) {
    normalizedOption.children = normalizeOptions(option.children, textAttribute, valueAttribute);
  }
  return normalizedOption;
};
const normalizeOptions = (options, textAttribute, valueAttribute) => {
  if (Array.isArray(options)) {
    return options.map((option) => normalizeOption(option, textAttribute, valueAttribute));
  }
  if (typeof options === "object") {
    return Object.keys(options).map((optionKey) => ({
      value: optionKey,
      text: options[optionKey]
    }));
  }
  return [];
};
const normalizeOptions$1 = normalizeOptions;

const normalizedOptionIsDisabled = (option) => option.disabled === true || option.disabled === "disabled";
const normalizedOptionIsDisabled$1 = normalizedOptionIsDisabled;

const normalizeMeasure = (measure) => {
  if (measure === null || measure === void 0) {
    return void 0;
  }
  if (typeof measure === "number") {
    return `${measure}px`;
  }
  if (String(Number(measure)) === measure) {
    return `${Number(measure)}px`;
  }
  return measure;
};
const normalizeMeasure$1 = normalizeMeasure;

const pick$2 = (object, condition = (value) => !!value) => {
  const newObject = { ...object };
  Object.keys(object).filter((key) => !condition(newObject[key], key)).forEach((key) => delete newObject[key]);
  return newObject;
};
const pick$3 = pick$2;

const isServer = () => typeof window === "undefined" || typeof document === "undefined";

const subtractFromArray = (arr, value) => {
  if (!Array.isArray(arr)) {
    return [];
  }
  const index = arr.findIndex((valueInOriginal) => isEqual$1(valueInOriginal, value));
  if (index === -1) {
    return arr;
  }
  const newArray = [...arr];
  newArray.splice(index, 1);
  return newArray;
};
const subtractFromArray$1 = subtractFromArray;

const throttle = (func, wait = 200) => {
  let isCalled = false;
  return (...args) => {
    if (!isCalled) {
      func(...args);
      isCalled = true;
      setTimeout(() => {
        isCalled = false;
      }, wait);
    }
  };
};
const throttle$1 = throttle;

const isTouchOnlyDevice = (w) => {
  if (w === void 0) {
    if (window === void 0) {
      return false;
    }
    w = window;
  }
  return !!(w.matchMedia && w.matchMedia("(any-hover: none)").matches);
};
const getIsTouch = isTouchOnlyDevice;

const getFocusableElements = (element) => Array.from(element.querySelectorAll(
  'a, button, input, textarea, select, details, [contenteditable], [tabindex]:not([tabindex="-1"])'
)).filter((el) => !el.hasAttribute("disabled"));
const getFocusableElements$1 = getFocusableElements;

function tryOnScopeDispose(fn) {
  if (getCurrentScope()) {
    onScopeDispose(fn);
    return true;
  }
  return false;
}

function toValue(r) {
  return typeof r === "function" ? r() : unref(r);
}

const isClient = typeof window !== "undefined";
const toString$3 = Object.prototype.toString;
const isObject$e = (val) => toString$3.call(val) === "[object Object]";
const noop = () => {
};
const isIOS = /* @__PURE__ */ getIsIOS();
function getIsIOS() {
  var _a;
  return isClient && ((_a = window == null ? void 0 : window.navigator) == null ? void 0 : _a.userAgent) && /* @__PURE__ */ /iP(ad|hone|od)/.test(window.navigator.userAgent);
}

function createFilterWrapper(filter, fn) {
  function wrapper(...args) {
    return new Promise((resolve, reject) => {
      Promise.resolve(filter(() => fn.apply(this, args), { fn, thisArg: this, args })).then(resolve).catch(reject);
    });
  }
  return wrapper;
}
const bypassFilter = (invoke) => {
  return invoke();
};
function throttleFilter(ms, trailing = true, leading = true, rejectOnCancel = false) {
  let lastExec = 0;
  let timer;
  let isLeading = true;
  let lastRejector = noop;
  let lastValue;
  const clear = () => {
    if (timer) {
      clearTimeout(timer);
      timer = void 0;
      lastRejector();
      lastRejector = noop;
    }
  };
  const filter = (_invoke) => {
    const duration = toValue(ms);
    const elapsed = Date.now() - lastExec;
    const invoke = () => {
      return lastValue = _invoke();
    };
    clear();
    if (duration <= 0) {
      lastExec = Date.now();
      return invoke();
    }
    if (elapsed > duration && (leading || !isLeading)) {
      lastExec = Date.now();
      invoke();
    } else if (trailing) {
      lastValue = new Promise((resolve, reject) => {
        lastRejector = rejectOnCancel ? reject : resolve;
        timer = setTimeout(() => {
          lastExec = Date.now();
          isLeading = true;
          resolve(invoke());
          clear();
        }, Math.max(0, duration - elapsed));
      });
    }
    if (!leading && !timer)
      timer = setTimeout(() => isLeading = true, duration);
    isLeading = false;
    return lastValue;
  };
  return filter;
}
function pausableFilter(extendFilter = bypassFilter) {
  const isActive = ref(true);
  function pause() {
    isActive.value = false;
  }
  function resume() {
    isActive.value = true;
  }
  const eventFilter = (...args) => {
    if (isActive.value)
      extendFilter(...args);
  };
  return { isActive: readonly(isActive), pause, resume, eventFilter };
}

function useThrottleFn(fn, ms = 200, trailing = false, leading = true, rejectOnCancel = false) {
  return createFilterWrapper(
    throttleFilter(ms, trailing, leading, rejectOnCancel),
    fn
  );
}

function refThrottled(value, delay = 200, trailing = true, leading = true) {
  if (delay <= 0)
    return value;
  const throttled = ref(value.value);
  const updater = useThrottleFn(() => {
    throttled.value = value.value;
  }, delay, trailing, leading);
  watch(value, () => updater());
  return throttled;
}

function useTimeoutFn(cb, interval, options = {}) {
  const {
    immediate = true
  } = options;
  const isPending = ref(false);
  let timer = null;
  function clear() {
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
  }
  function stop() {
    isPending.value = false;
    clear();
  }
  function start(...args) {
    clear();
    isPending.value = true;
    timer = setTimeout(() => {
      isPending.value = false;
      timer = null;
      cb(...args);
    }, toValue(interval));
  }
  if (immediate) {
    isPending.value = true;
    if (isClient)
      start();
  }
  tryOnScopeDispose(stop);
  return {
    isPending: readonly(isPending),
    start,
    stop
  };
}

var __getOwnPropSymbols$8 = Object.getOwnPropertySymbols;
var __hasOwnProp$8 = Object.prototype.hasOwnProperty;
var __propIsEnum$8 = Object.prototype.propertyIsEnumerable;
var __objRest$5 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$8.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$8)
    for (var prop of __getOwnPropSymbols$8(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$8.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
function watchWithFilter(source, cb, options = {}) {
  const _a = options, {
    eventFilter = bypassFilter
  } = _a, watchOptions = __objRest$5(_a, [
    "eventFilter"
  ]);
  return watch(
    source,
    createFilterWrapper(
      eventFilter,
      cb
    ),
    watchOptions
  );
}

var __defProp$2 = Object.defineProperty;
var __defProps$2 = Object.defineProperties;
var __getOwnPropDescs$2 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$2 = Object.getOwnPropertySymbols;
var __hasOwnProp$2 = Object.prototype.hasOwnProperty;
var __propIsEnum$2 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2 = (obj, key, value) => key in obj ? __defProp$2(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2.call(b, prop))
      __defNormalProp$2(a, prop, b[prop]);
  if (__getOwnPropSymbols$2)
    for (var prop of __getOwnPropSymbols$2(b)) {
      if (__propIsEnum$2.call(b, prop))
        __defNormalProp$2(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$2 = (a, b) => __defProps$2(a, __getOwnPropDescs$2(b));
var __objRest$1 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$2.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2)
    for (var prop of __getOwnPropSymbols$2(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$2.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
function watchPausable(source, cb, options = {}) {
  const _a = options, {
    eventFilter: filter
  } = _a, watchOptions = __objRest$1(_a, [
    "eventFilter"
  ]);
  const { eventFilter, pause, resume, isActive } = pausableFilter(filter);
  const stop = watchWithFilter(
    source,
    cb,
    __spreadProps$2(__spreadValues$2({}, watchOptions), {
      eventFilter
    })
  );
  return { stop, pause, resume, isActive };
}

function unrefElement(elRef) {
  var _a;
  const plain = toValue(elRef);
  return (_a = plain == null ? void 0 : plain.$el) != null ? _a : plain;
}

const defaultWindow = isClient ? window : void 0;
const defaultNavigator = isClient ? window.navigator : void 0;

function useEventListener(...args) {
  let target;
  let events;
  let listeners;
  let options;
  if (typeof args[0] === "string" || Array.isArray(args[0])) {
    [events, listeners, options] = args;
    target = defaultWindow;
  } else {
    [target, events, listeners, options] = args;
  }
  if (!target)
    return noop;
  if (!Array.isArray(events))
    events = [events];
  if (!Array.isArray(listeners))
    listeners = [listeners];
  const cleanups = [];
  const cleanup = () => {
    cleanups.forEach((fn) => fn());
    cleanups.length = 0;
  };
  const register = (el, event, listener, options2) => {
    el.addEventListener(event, listener, options2);
    return () => el.removeEventListener(event, listener, options2);
  };
  const stopWatch = watch(
    () => [unrefElement(target), toValue(options)],
    ([el, options2]) => {
      cleanup();
      if (!el)
        return;
      cleanups.push(
        ...events.flatMap((event) => {
          return listeners.map((listener) => register(el, event, listener, options2));
        })
      );
    },
    { immediate: true, flush: "post" }
  );
  const stop = () => {
    stopWatch();
    cleanup();
  };
  tryOnScopeDispose(stop);
  return stop;
}

let _iOSWorkaround = false;
function onClickOutside(target, handler, options = {}) {
  const { window = defaultWindow, ignore = [], capture = true, detectIframe = false } = options;
  if (!window)
    return;
  if (isIOS && !_iOSWorkaround) {
    _iOSWorkaround = true;
    Array.from(window.document.body.children).forEach((el) => el.addEventListener("click", noop));
    window.document.documentElement.addEventListener("click", noop);
  }
  let shouldListen = true;
  const shouldIgnore = (event) => {
    return ignore.some((target2) => {
      if (typeof target2 === "string") {
        return Array.from(window.document.querySelectorAll(target2)).some((el) => el === event.target || event.composedPath().includes(el));
      } else {
        const el = unrefElement(target2);
        return el && (event.target === el || event.composedPath().includes(el));
      }
    });
  };
  const listener = (event) => {
    const el = unrefElement(target);
    if (!el || el === event.target || event.composedPath().includes(el))
      return;
    if (event.detail === 0)
      shouldListen = !shouldIgnore(event);
    if (!shouldListen) {
      shouldListen = true;
      return;
    }
    handler(event);
  };
  const cleanup = [
    useEventListener(window, "click", listener, { passive: true, capture }),
    useEventListener(window, "pointerdown", (e) => {
      const el = unrefElement(target);
      if (el)
        shouldListen = !e.composedPath().includes(el) && !shouldIgnore(e);
    }, { passive: true }),
    detectIframe && useEventListener(window, "blur", (event) => {
      setTimeout(() => {
        var _a;
        const el = unrefElement(target);
        if (((_a = window.document.activeElement) == null ? void 0 : _a.tagName) === "IFRAME" && !(el == null ? void 0 : el.contains(window.document.activeElement)))
          handler(event);
      }, 0);
    })
  ].filter(Boolean);
  const stop = () => cleanup.forEach((fn) => fn());
  return stop;
}

function useMounted() {
  const isMounted = ref(false);
  if (getCurrentInstance()) {
    onMounted(() => {
      isMounted.value = true;
    });
  }
  return isMounted;
}

function useSupported(callback) {
  const isMounted = useMounted();
  return computed(() => {
    isMounted.value;
    return Boolean(callback());
  });
}

function useClipboard(options = {}) {
  const {
    navigator = defaultNavigator,
    read = false,
    source,
    copiedDuring = 1500,
    legacy = false
  } = options;
  const isClipboardApiSupported = useSupported(() => navigator && "clipboard" in navigator);
  const isSupported = computed(() => isClipboardApiSupported.value || legacy);
  const text = ref("");
  const copied = ref(false);
  const timeout = useTimeoutFn(() => copied.value = false, copiedDuring);
  function updateText() {
    if (isClipboardApiSupported.value) {
      navigator.clipboard.readText().then((value) => {
        text.value = value;
      });
    } else {
      text.value = legacyRead();
    }
  }
  if (isSupported.value && read)
    useEventListener(["copy", "cut"], updateText);
  async function copy(value = toValue(source)) {
    if (isSupported.value && value != null) {
      if (isClipboardApiSupported.value)
        await navigator.clipboard.writeText(value);
      else
        legacyCopy(value);
      text.value = value;
      copied.value = true;
      timeout.start();
    }
  }
  function legacyCopy(value) {
    const ta = document.createElement("textarea");
    ta.value = value != null ? value : "";
    ta.style.position = "absolute";
    ta.style.opacity = "0";
    document.body.appendChild(ta);
    ta.select();
    document.execCommand("copy");
    ta.remove();
  }
  function legacyRead() {
    var _a, _b, _c;
    return (_c = (_b = (_a = document == null ? void 0 : document.getSelection) == null ? void 0 : _a.call(document)) == null ? void 0 : _b.toString()) != null ? _c : "";
  }
  return {
    isSupported,
    text,
    copied,
    copy
  };
}

const _global = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
const globalKey = "__vueuse_ssr_handlers__";
const handlers = /* @__PURE__ */ getHandlers();
function getHandlers() {
  if (!(globalKey in _global))
    _global[globalKey] = _global[globalKey] || {};
  return _global[globalKey];
}
function getSSRHandler(key, fallback) {
  return handlers[key] || fallback;
}

function guessSerializerType(rawInit) {
  return rawInit == null ? "any" : rawInit instanceof Set ? "set" : rawInit instanceof Map ? "map" : rawInit instanceof Date ? "date" : typeof rawInit === "boolean" ? "boolean" : typeof rawInit === "string" ? "string" : typeof rawInit === "object" ? "object" : !Number.isNaN(rawInit) ? "number" : "any";
}

var __defProp$l = Object.defineProperty;
var __getOwnPropSymbols$o = Object.getOwnPropertySymbols;
var __hasOwnProp$o = Object.prototype.hasOwnProperty;
var __propIsEnum$o = Object.prototype.propertyIsEnumerable;
var __defNormalProp$l = (obj, key, value) => key in obj ? __defProp$l(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$l = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$o.call(b, prop))
      __defNormalProp$l(a, prop, b[prop]);
  if (__getOwnPropSymbols$o)
    for (var prop of __getOwnPropSymbols$o(b)) {
      if (__propIsEnum$o.call(b, prop))
        __defNormalProp$l(a, prop, b[prop]);
    }
  return a;
};
const StorageSerializers = {
  boolean: {
    read: (v) => v === "true",
    write: (v) => String(v)
  },
  object: {
    read: (v) => JSON.parse(v),
    write: (v) => JSON.stringify(v)
  },
  number: {
    read: (v) => Number.parseFloat(v),
    write: (v) => String(v)
  },
  any: {
    read: (v) => v,
    write: (v) => String(v)
  },
  string: {
    read: (v) => v,
    write: (v) => String(v)
  },
  map: {
    read: (v) => new Map(JSON.parse(v)),
    write: (v) => JSON.stringify(Array.from(v.entries()))
  },
  set: {
    read: (v) => new Set(JSON.parse(v)),
    write: (v) => JSON.stringify(Array.from(v))
  },
  date: {
    read: (v) => new Date(v),
    write: (v) => v.toISOString()
  }
};
const customStorageEventName = "vueuse-storage";
function useStorage(key, defaults, storage, options = {}) {
  var _a;
  const {
    flush = "pre",
    deep = true,
    listenToStorageChanges = true,
    writeDefaults = true,
    mergeDefaults = false,
    shallow,
    window = defaultWindow,
    eventFilter,
    onError = (e) => {
      console.error(e);
    }
  } = options;
  const data = (shallow ? shallowRef : ref)(defaults);
  if (!storage) {
    try {
      storage = getSSRHandler("getDefaultStorage", () => {
        var _a2;
        return (_a2 = defaultWindow) == null ? void 0 : _a2.localStorage;
      })();
    } catch (e) {
      onError(e);
    }
  }
  if (!storage)
    return data;
  const rawInit = toValue(defaults);
  const type = guessSerializerType(rawInit);
  const serializer = (_a = options.serializer) != null ? _a : StorageSerializers[type];
  const { pause: pauseWatch, resume: resumeWatch } = watchPausable(
    data,
    () => write(data.value),
    { flush, deep, eventFilter }
  );
  if (window && listenToStorageChanges) {
    useEventListener(window, "storage", update);
    useEventListener(window, customStorageEventName, updateFromCustomEvent);
  }
  update();
  return data;
  function write(v) {
    try {
      if (v == null) {
        storage.removeItem(key);
      } else {
        const serialized = serializer.write(v);
        const oldValue = storage.getItem(key);
        if (oldValue !== serialized) {
          storage.setItem(key, serialized);
          if (window) {
            window.dispatchEvent(new CustomEvent(customStorageEventName, {
              detail: {
                key,
                oldValue,
                newValue: serialized,
                storageArea: storage
              }
            }));
          }
        }
      }
    } catch (e) {
      onError(e);
    }
  }
  function read(event) {
    const rawValue = event ? event.newValue : storage.getItem(key);
    if (rawValue == null) {
      if (writeDefaults && rawInit !== null)
        storage.setItem(key, serializer.write(rawInit));
      return rawInit;
    } else if (!event && mergeDefaults) {
      const value = serializer.read(rawValue);
      if (typeof mergeDefaults === "function")
        return mergeDefaults(value, rawInit);
      else if (type === "object" && !Array.isArray(value))
        return __spreadValues$l(__spreadValues$l({}, rawInit), value);
      return value;
    } else if (typeof rawValue !== "string") {
      return rawValue;
    } else {
      return serializer.read(rawValue);
    }
  }
  function updateFromCustomEvent(event) {
    update(event.detail);
  }
  function update(event) {
    if (event && event.storageArea !== storage)
      return;
    if (event && event.key == null) {
      data.value = rawInit;
      return;
    }
    if (event && event.key !== key)
      return;
    pauseWatch();
    try {
      data.value = read(event);
    } catch (e) {
      onError(e);
    } finally {
      if (event)
        nextTick(resumeWatch);
      else
        resumeWatch();
    }
  }
}

function useFocus(target, options = {}) {
  const { initialValue = false, focusVisible = false } = options;
  const innerFocused = ref(false);
  const targetElement = computed(() => unrefElement(target));
  useEventListener(targetElement, "focus", (event) => {
    var _a, _b;
    if (!focusVisible || ((_b = (_a = event.target).matches) == null ? void 0 : _b.call(_a, ":focus-visible")))
      innerFocused.value = true;
  });
  useEventListener(targetElement, "blur", () => innerFocused.value = false);
  const focused = computed({
    get: () => innerFocused.value,
    set(value) {
      var _a, _b;
      if (!value && innerFocused.value)
        (_a = targetElement.value) == null ? void 0 : _a.blur();
      else if (value && !innerFocused.value)
        (_b = targetElement.value) == null ? void 0 : _b.focus();
    }
  });
  watch(
    targetElement,
    () => {
      focused.value = initialValue;
    },
    { immediate: true, flush: "post" }
  );
  return { focused };
}

function useLocalStorage(key, initialValue, options = {}) {
  const { window = defaultWindow } = options;
  return useStorage(key, initialValue, window == null ? void 0 : window.localStorage, options);
}

const selectClasses = (classesObject) => Object.keys(classesObject).filter((className) => !!classesObject[className]);
const removeClassesBeforeResetDirect = (classes) => {
  const pattern = /\$reset\s*/;
  const match = pattern.exec(classes);
  if (match === null) {
    return classes;
  }
  return classes.slice(match.index + match[0].length);
};
const mergeClasses = (...classes) => classes.map((className) => {
  if (typeof className === "string" || className === void 0) {
    return className;
  }
  if (Array.isArray(className)) {
    return mergeClasses(...className);
  }
  return mergeClasses(...selectClasses(className));
}).join(" ").replace(/  +/g, " ").trim();
const mergeClassesFromObject = (objectTwo, objectOne, mergeDeep = false) => {
  const temporary = {};
  for (const [key, value] of Object.entries(objectOne || {})) {
    if (isObject$e(value)) {
      temporary[key] = mergeClassesFromObject(value, get$4(objectTwo || {}, key, {}));
    } else {
      if (mergeDeep) {
        let merged = mergeClasses(
          value,
          get$4(objectTwo || {}, key, void 0)
        );
        if (merged) {
          merged = removeClassesBeforeResetDirect(merged);
        }
        temporary[key] = merged;
      } else {
        temporary[key] = removeClassesBeforeResetDirect(value);
      }
    }
  }
  return temporary;
};

const idCounter = {};
function uniqueId(prefix = "$lodash$") {
  if (!idCounter[prefix]) {
    idCounter[prefix] = 0;
  }
  const id = ++idCounter[prefix];
  if (prefix === "$lodash$") {
    return `${id}`;
  }
  return `${prefix}${id}`;
}

var commonjsGlobal$1 = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function getDefaultExportFromCjs$1 (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function getAugmentedNamespace(n) {
  if (n.__esModule) return n;
  var f = n.default;
	if (typeof f == "function") {
		var a = function a () {
			if (this instanceof a) {
				var args = [null];
				args.push.apply(args, arguments);
				var Ctor = Function.bind.apply(f, args);
				return new Ctor();
			}
			return f.apply(this, arguments);
		};
		a.prototype = f.prototype;
  } else a = {};
  Object.defineProperty(a, '__esModule', {value: true});
	Object.keys(n).forEach(function (k) {
		var d = Object.getOwnPropertyDescriptor(n, k);
		Object.defineProperty(a, k, d.get ? d : {
			enumerable: true,
			get: function () {
				return n[k];
			}
		});
	});
	return a;
}

/* eslint complexity: [2, 18], max-statements: [2, 33] */
var shams = function hasSymbols() {
	if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
	if (typeof Symbol.iterator === 'symbol') { return true; }

	var obj = {};
	var sym = Symbol('test');
	var symObj = Object(sym);
	if (typeof sym === 'string') { return false; }

	if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
	if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }

	// temp disabled per https://github.com/ljharb/object.assign/issues/17
	// if (sym instanceof Symbol) { return false; }
	// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
	// if (!(symObj instanceof Symbol)) { return false; }

	// if (typeof Symbol.prototype.toString !== 'function') { return false; }
	// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }

	var symVal = 42;
	obj[sym] = symVal;
	for (sym in obj) { return false; } // eslint-disable-line no-restricted-syntax, no-unreachable-loop
	if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }

	if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }

	var syms = Object.getOwnPropertySymbols(obj);
	if (syms.length !== 1 || syms[0] !== sym) { return false; }

	if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }

	if (typeof Object.getOwnPropertyDescriptor === 'function') {
		var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
		if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
	}

	return true;
};

var origSymbol = typeof Symbol !== 'undefined' && Symbol;
var hasSymbolSham = shams;

var hasSymbols$1 = function hasNativeSymbols() {
	if (typeof origSymbol !== 'function') { return false; }
	if (typeof Symbol !== 'function') { return false; }
	if (typeof origSymbol('foo') !== 'symbol') { return false; }
	if (typeof Symbol('bar') !== 'symbol') { return false; }

	return hasSymbolSham();
};

/* eslint no-invalid-this: 1 */

var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var slice = Array.prototype.slice;
var toStr$1 = Object.prototype.toString;
var funcType = '[object Function]';

var implementation$1 = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || toStr$1.call(target) !== funcType) {
        throw new TypeError(ERROR_MESSAGE + target);
    }
    var args = slice.call(arguments, 1);

    var bound;
    var binder = function () {
        if (this instanceof bound) {
            var result = target.apply(
                this,
                args.concat(slice.call(arguments))
            );
            if (Object(result) === result) {
                return result;
            }
            return this;
        } else {
            return target.apply(
                that,
                args.concat(slice.call(arguments))
            );
        }
    };

    var boundLength = Math.max(0, target.length - args.length);
    var boundArgs = [];
    for (var i = 0; i < boundLength; i++) {
        boundArgs.push('$' + i);
    }

    bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this,arguments); }')(binder);

    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }

    return bound;
};

var implementation = implementation$1;

var functionBind = Function.prototype.bind || implementation;

var bind$1 = functionBind;

var src = bind$1.call(Function.call, Object.prototype.hasOwnProperty);

var undefined$1;

var $SyntaxError = SyntaxError;
var $Function = Function;
var $TypeError$1 = TypeError;

// eslint-disable-next-line consistent-return
var getEvalledConstructor = function (expressionSyntax) {
	try {
		return $Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
	} catch (e) {}
};

var $gOPD = Object.getOwnPropertyDescriptor;
if ($gOPD) {
	try {
		$gOPD({}, '');
	} catch (e) {
		$gOPD = null; // this is IE 8, which has a broken gOPD
	}
}

var throwTypeError = function () {
	throw new $TypeError$1();
};
var ThrowTypeError = $gOPD
	? (function () {
		try {
			// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
			arguments.callee; // IE 8 does not throw here
			return throwTypeError;
		} catch (calleeThrows) {
			try {
				// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
				return $gOPD(arguments, 'callee').get;
			} catch (gOPDthrows) {
				return throwTypeError;
			}
		}
	}())
	: throwTypeError;

var hasSymbols = hasSymbols$1();

var getProto = Object.getPrototypeOf || function (x) { return x.__proto__; }; // eslint-disable-line no-proto

var needsEval = {};

var TypedArray = typeof Uint8Array === 'undefined' ? undefined$1 : getProto(Uint8Array);

var INTRINSICS = {
	'%AggregateError%': typeof AggregateError === 'undefined' ? undefined$1 : AggregateError,
	'%Array%': Array,
	'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined$1 : ArrayBuffer,
	'%ArrayIteratorPrototype%': hasSymbols ? getProto([][Symbol.iterator]()) : undefined$1,
	'%AsyncFromSyncIteratorPrototype%': undefined$1,
	'%AsyncFunction%': needsEval,
	'%AsyncGenerator%': needsEval,
	'%AsyncGeneratorFunction%': needsEval,
	'%AsyncIteratorPrototype%': needsEval,
	'%Atomics%': typeof Atomics === 'undefined' ? undefined$1 : Atomics,
	'%BigInt%': typeof BigInt === 'undefined' ? undefined$1 : BigInt,
	'%Boolean%': Boolean,
	'%DataView%': typeof DataView === 'undefined' ? undefined$1 : DataView,
	'%Date%': Date,
	'%decodeURI%': decodeURI,
	'%decodeURIComponent%': decodeURIComponent,
	'%encodeURI%': encodeURI,
	'%encodeURIComponent%': encodeURIComponent,
	'%Error%': Error,
	'%eval%': eval, // eslint-disable-line no-eval
	'%EvalError%': EvalError,
	'%Float32Array%': typeof Float32Array === 'undefined' ? undefined$1 : Float32Array,
	'%Float64Array%': typeof Float64Array === 'undefined' ? undefined$1 : Float64Array,
	'%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined$1 : FinalizationRegistry,
	'%Function%': $Function,
	'%GeneratorFunction%': needsEval,
	'%Int8Array%': typeof Int8Array === 'undefined' ? undefined$1 : Int8Array,
	'%Int16Array%': typeof Int16Array === 'undefined' ? undefined$1 : Int16Array,
	'%Int32Array%': typeof Int32Array === 'undefined' ? undefined$1 : Int32Array,
	'%isFinite%': isFinite,
	'%isNaN%': isNaN,
	'%IteratorPrototype%': hasSymbols ? getProto(getProto([][Symbol.iterator]())) : undefined$1,
	'%JSON%': typeof JSON === 'object' ? JSON : undefined$1,
	'%Map%': typeof Map === 'undefined' ? undefined$1 : Map,
	'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols ? undefined$1 : getProto(new Map()[Symbol.iterator]()),
	'%Math%': Math,
	'%Number%': Number,
	'%Object%': Object,
	'%parseFloat%': parseFloat,
	'%parseInt%': parseInt,
	'%Promise%': typeof Promise === 'undefined' ? undefined$1 : Promise,
	'%Proxy%': typeof Proxy === 'undefined' ? undefined$1 : Proxy,
	'%RangeError%': RangeError,
	'%ReferenceError%': ReferenceError,
	'%Reflect%': typeof Reflect === 'undefined' ? undefined$1 : Reflect,
	'%RegExp%': RegExp,
	'%Set%': typeof Set === 'undefined' ? undefined$1 : Set,
	'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols ? undefined$1 : getProto(new Set()[Symbol.iterator]()),
	'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined$1 : SharedArrayBuffer,
	'%String%': String,
	'%StringIteratorPrototype%': hasSymbols ? getProto(''[Symbol.iterator]()) : undefined$1,
	'%Symbol%': hasSymbols ? Symbol : undefined$1,
	'%SyntaxError%': $SyntaxError,
	'%ThrowTypeError%': ThrowTypeError,
	'%TypedArray%': TypedArray,
	'%TypeError%': $TypeError$1,
	'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined$1 : Uint8Array,
	'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined$1 : Uint8ClampedArray,
	'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined$1 : Uint16Array,
	'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined$1 : Uint32Array,
	'%URIError%': URIError,
	'%WeakMap%': typeof WeakMap === 'undefined' ? undefined$1 : WeakMap,
	'%WeakRef%': typeof WeakRef === 'undefined' ? undefined$1 : WeakRef,
	'%WeakSet%': typeof WeakSet === 'undefined' ? undefined$1 : WeakSet
};

var doEval = function doEval(name) {
	var value;
	if (name === '%AsyncFunction%') {
		value = getEvalledConstructor('async function () {}');
	} else if (name === '%GeneratorFunction%') {
		value = getEvalledConstructor('function* () {}');
	} else if (name === '%AsyncGeneratorFunction%') {
		value = getEvalledConstructor('async function* () {}');
	} else if (name === '%AsyncGenerator%') {
		var fn = doEval('%AsyncGeneratorFunction%');
		if (fn) {
			value = fn.prototype;
		}
	} else if (name === '%AsyncIteratorPrototype%') {
		var gen = doEval('%AsyncGenerator%');
		if (gen) {
			value = getProto(gen.prototype);
		}
	}

	INTRINSICS[name] = value;

	return value;
};

var LEGACY_ALIASES = {
	'%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
	'%ArrayPrototype%': ['Array', 'prototype'],
	'%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
	'%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
	'%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
	'%ArrayProto_values%': ['Array', 'prototype', 'values'],
	'%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
	'%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
	'%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
	'%BooleanPrototype%': ['Boolean', 'prototype'],
	'%DataViewPrototype%': ['DataView', 'prototype'],
	'%DatePrototype%': ['Date', 'prototype'],
	'%ErrorPrototype%': ['Error', 'prototype'],
	'%EvalErrorPrototype%': ['EvalError', 'prototype'],
	'%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
	'%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
	'%FunctionPrototype%': ['Function', 'prototype'],
	'%Generator%': ['GeneratorFunction', 'prototype'],
	'%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
	'%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
	'%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
	'%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
	'%JSONParse%': ['JSON', 'parse'],
	'%JSONStringify%': ['JSON', 'stringify'],
	'%MapPrototype%': ['Map', 'prototype'],
	'%NumberPrototype%': ['Number', 'prototype'],
	'%ObjectPrototype%': ['Object', 'prototype'],
	'%ObjProto_toString%': ['Object', 'prototype', 'toString'],
	'%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
	'%PromisePrototype%': ['Promise', 'prototype'],
	'%PromiseProto_then%': ['Promise', 'prototype', 'then'],
	'%Promise_all%': ['Promise', 'all'],
	'%Promise_reject%': ['Promise', 'reject'],
	'%Promise_resolve%': ['Promise', 'resolve'],
	'%RangeErrorPrototype%': ['RangeError', 'prototype'],
	'%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
	'%RegExpPrototype%': ['RegExp', 'prototype'],
	'%SetPrototype%': ['Set', 'prototype'],
	'%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
	'%StringPrototype%': ['String', 'prototype'],
	'%SymbolPrototype%': ['Symbol', 'prototype'],
	'%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
	'%TypedArrayPrototype%': ['TypedArray', 'prototype'],
	'%TypeErrorPrototype%': ['TypeError', 'prototype'],
	'%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
	'%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
	'%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
	'%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
	'%URIErrorPrototype%': ['URIError', 'prototype'],
	'%WeakMapPrototype%': ['WeakMap', 'prototype'],
	'%WeakSetPrototype%': ['WeakSet', 'prototype']
};

var bind = functionBind;
var hasOwn$2 = src;
var $concat$1 = bind.call(Function.call, Array.prototype.concat);
var $spliceApply = bind.call(Function.apply, Array.prototype.splice);
var $replace$1 = bind.call(Function.call, String.prototype.replace);
var $strSlice = bind.call(Function.call, String.prototype.slice);
var $exec = bind.call(Function.call, RegExp.prototype.exec);

/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
var rePropName$1 = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar$1 = /\\(\\)?/g; /** Used to match backslashes in property paths. */
var stringToPath$2 = function stringToPath(string) {
	var first = $strSlice(string, 0, 1);
	var last = $strSlice(string, -1);
	if (first === '%' && last !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected closing `%`');
	} else if (last === '%' && first !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected opening `%`');
	}
	var result = [];
	$replace$1(string, rePropName$1, function (match, number, quote, subString) {
		result[result.length] = quote ? $replace$1(subString, reEscapeChar$1, '$1') : number || match;
	});
	return result;
};
/* end adaptation */

var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
	var intrinsicName = name;
	var alias;
	if (hasOwn$2(LEGACY_ALIASES, intrinsicName)) {
		alias = LEGACY_ALIASES[intrinsicName];
		intrinsicName = '%' + alias[0] + '%';
	}

	if (hasOwn$2(INTRINSICS, intrinsicName)) {
		var value = INTRINSICS[intrinsicName];
		if (value === needsEval) {
			value = doEval(intrinsicName);
		}
		if (typeof value === 'undefined' && !allowMissing) {
			throw new $TypeError$1('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
		}

		return {
			alias: alias,
			name: intrinsicName,
			value: value
		};
	}

	throw new $SyntaxError('intrinsic ' + name + ' does not exist!');
};

var getIntrinsic = function GetIntrinsic(name, allowMissing) {
	if (typeof name !== 'string' || name.length === 0) {
		throw new $TypeError$1('intrinsic name must be a non-empty string');
	}
	if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
		throw new $TypeError$1('"allowMissing" argument must be a boolean');
	}

	if ($exec(/^%?[^%]*%?$/, name) === null) {
		throw new $SyntaxError('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
	}
	var parts = stringToPath$2(name);
	var intrinsicBaseName = parts.length > 0 ? parts[0] : '';

	var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
	var intrinsicRealName = intrinsic.name;
	var value = intrinsic.value;
	var skipFurtherCaching = false;

	var alias = intrinsic.alias;
	if (alias) {
		intrinsicBaseName = alias[0];
		$spliceApply(parts, $concat$1([0, 1], alias));
	}

	for (var i = 1, isOwn = true; i < parts.length; i += 1) {
		var part = parts[i];
		var first = $strSlice(part, 0, 1);
		var last = $strSlice(part, -1);
		if (
			(
				(first === '"' || first === "'" || first === '`')
				|| (last === '"' || last === "'" || last === '`')
			)
			&& first !== last
		) {
			throw new $SyntaxError('property names with quotes must have matching quotes');
		}
		if (part === 'constructor' || !isOwn) {
			skipFurtherCaching = true;
		}

		intrinsicBaseName += '.' + part;
		intrinsicRealName = '%' + intrinsicBaseName + '%';

		if (hasOwn$2(INTRINSICS, intrinsicRealName)) {
			value = INTRINSICS[intrinsicRealName];
		} else if (value != null) {
			if (!(part in value)) {
				if (!allowMissing) {
					throw new $TypeError$1('base intrinsic for ' + name + ' exists, but the property is not available.');
				}
				return void undefined$1;
			}
			if ($gOPD && (i + 1) >= parts.length) {
				var desc = $gOPD(value, part);
				isOwn = !!desc;

				// By convention, when a data property is converted to an accessor
				// property to emulate a data property that does not suffer from
				// the override mistake, that accessor's getter is marked with
				// an `originalValue` property. Here, when we detect this, we
				// uphold the illusion by pretending to see that original data
				// property, i.e., returning the value rather than the getter
				// itself.
				if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
					value = desc.get;
				} else {
					value = value[part];
				}
			} else {
				isOwn = hasOwn$2(value, part);
				value = value[part];
			}

			if (isOwn && !skipFurtherCaching) {
				INTRINSICS[intrinsicRealName] = value;
			}
		}
	}
	return value;
};

var callBindExports = {};
var callBind$1 = {
  get exports(){ return callBindExports; },
  set exports(v){ callBindExports = v; },
};

(function (module) {

	var bind = functionBind;
	var GetIntrinsic = getIntrinsic;

	var $apply = GetIntrinsic('%Function.prototype.apply%');
	var $call = GetIntrinsic('%Function.prototype.call%');
	var $reflectApply = GetIntrinsic('%Reflect.apply%', true) || bind.call($call, $apply);

	var $gOPD = GetIntrinsic('%Object.getOwnPropertyDescriptor%', true);
	var $defineProperty = GetIntrinsic('%Object.defineProperty%', true);
	var $max = GetIntrinsic('%Math.max%');

	if ($defineProperty) {
		try {
			$defineProperty({}, 'a', { value: 1 });
		} catch (e) {
			// IE 8 has a broken defineProperty
			$defineProperty = null;
		}
	}

	module.exports = function callBind(originalFunction) {
		var func = $reflectApply(bind, $call, arguments);
		if ($gOPD && $defineProperty) {
			var desc = $gOPD(func, 'length');
			if (desc.configurable) {
				// original length, plus the receiver, minus any additional arguments (after the receiver)
				$defineProperty(
					func,
					'length',
					{ value: 1 + $max(0, originalFunction.length - (arguments.length - 1)) }
				);
			}
		}
		return func;
	};

	var applyBind = function applyBind() {
		return $reflectApply(bind, $apply, arguments);
	};

	if ($defineProperty) {
		$defineProperty(module.exports, 'apply', { value: applyBind });
	} else {
		module.exports.apply = applyBind;
	}
} (callBind$1));

var GetIntrinsic$1 = getIntrinsic;

var callBind = callBindExports;

var $indexOf = callBind(GetIntrinsic$1('String.prototype.indexOf'));

var callBound$1 = function callBoundIntrinsic(name, allowMissing) {
	var intrinsic = GetIntrinsic$1(name, !!allowMissing);
	if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.') > -1) {
		return callBind(intrinsic);
	}
	return intrinsic;
};

const __viteBrowserExternal = {};

const __viteBrowserExternal$1 = /*#__PURE__*/Object.freeze(/*#__PURE__*/Object.defineProperty({
  __proto__: null,
  default: __viteBrowserExternal
}, Symbol.toStringTag, { value: 'Module' }));

const require$$0 = /*@__PURE__*/getAugmentedNamespace(__viteBrowserExternal$1);

var hasMap = typeof Map === 'function' && Map.prototype;
var mapSizeDescriptor = Object.getOwnPropertyDescriptor && hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, 'size') : null;
var mapSize = hasMap && mapSizeDescriptor && typeof mapSizeDescriptor.get === 'function' ? mapSizeDescriptor.get : null;
var mapForEach = hasMap && Map.prototype.forEach;
var hasSet = typeof Set === 'function' && Set.prototype;
var setSizeDescriptor = Object.getOwnPropertyDescriptor && hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, 'size') : null;
var setSize = hasSet && setSizeDescriptor && typeof setSizeDescriptor.get === 'function' ? setSizeDescriptor.get : null;
var setForEach = hasSet && Set.prototype.forEach;
var hasWeakMap = typeof WeakMap === 'function' && WeakMap.prototype;
var weakMapHas = hasWeakMap ? WeakMap.prototype.has : null;
var hasWeakSet = typeof WeakSet === 'function' && WeakSet.prototype;
var weakSetHas = hasWeakSet ? WeakSet.prototype.has : null;
var hasWeakRef = typeof WeakRef === 'function' && WeakRef.prototype;
var weakRefDeref = hasWeakRef ? WeakRef.prototype.deref : null;
var booleanValueOf = Boolean.prototype.valueOf;
var objectToString$2 = Object.prototype.toString;
var functionToString = Function.prototype.toString;
var $match = String.prototype.match;
var $slice = String.prototype.slice;
var $replace = String.prototype.replace;
var $toUpperCase = String.prototype.toUpperCase;
var $toLowerCase = String.prototype.toLowerCase;
var $test = RegExp.prototype.test;
var $concat = Array.prototype.concat;
var $join = Array.prototype.join;
var $arrSlice = Array.prototype.slice;
var $floor = Math.floor;
var bigIntValueOf = typeof BigInt === 'function' ? BigInt.prototype.valueOf : null;
var gOPS = Object.getOwnPropertySymbols;
var symToString = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? Symbol.prototype.toString : null;
var hasShammedSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'object';
// ie, `has-tostringtag/shams
var toStringTag = typeof Symbol === 'function' && Symbol.toStringTag && (typeof Symbol.toStringTag === hasShammedSymbols ? 'object' : 'symbol')
    ? Symbol.toStringTag
    : null;
var isEnumerable = Object.prototype.propertyIsEnumerable;

var gPO = (typeof Reflect === 'function' ? Reflect.getPrototypeOf : Object.getPrototypeOf) || (
    [].__proto__ === Array.prototype // eslint-disable-line no-proto
        ? function (O) {
            return O.__proto__; // eslint-disable-line no-proto
        }
        : null
);

function addNumericSeparator(num, str) {
    if (
        num === Infinity
        || num === -Infinity
        || num !== num
        || (num && num > -1000 && num < 1000)
        || $test.call(/e/, str)
    ) {
        return str;
    }
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === 'number') {
        var int = num < 0 ? -$floor(-num) : $floor(num); // trunc(num)
        if (int !== num) {
            var intStr = String(int);
            var dec = $slice.call(str, intStr.length + 1);
            return $replace.call(intStr, sepRegex, '$&_') + '.' + $replace.call($replace.call(dec, /([0-9]{3})/g, '$&_'), /_$/, '');
        }
    }
    return $replace.call(str, sepRegex, '$&_');
}

var utilInspect = require$$0;
var inspectCustom = utilInspect.custom;
var inspectSymbol = isSymbol$5(inspectCustom) ? inspectCustom : null;

var objectInspect = function inspect_(obj, options, depth, seen) {
    var opts = options || {};

    if (has$3(opts, 'quoteStyle') && (opts.quoteStyle !== 'single' && opts.quoteStyle !== 'double')) {
        throw new TypeError('option "quoteStyle" must be "single" or "double"');
    }
    if (
        has$3(opts, 'maxStringLength') && (typeof opts.maxStringLength === 'number'
            ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity
            : opts.maxStringLength !== null
        )
    ) {
        throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    }
    var customInspect = has$3(opts, 'customInspect') ? opts.customInspect : true;
    if (typeof customInspect !== 'boolean' && customInspect !== 'symbol') {
        throw new TypeError('option "customInspect", if provided, must be `true`, `false`, or `\'symbol\'`');
    }

    if (
        has$3(opts, 'indent')
        && opts.indent !== null
        && opts.indent !== '\t'
        && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)
    ) {
        throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    }
    if (has$3(opts, 'numericSeparator') && typeof opts.numericSeparator !== 'boolean') {
        throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    }
    var numericSeparator = opts.numericSeparator;

    if (typeof obj === 'undefined') {
        return 'undefined';
    }
    if (obj === null) {
        return 'null';
    }
    if (typeof obj === 'boolean') {
        return obj ? 'true' : 'false';
    }

    if (typeof obj === 'string') {
        return inspectString(obj, opts);
    }
    if (typeof obj === 'number') {
        if (obj === 0) {
            return Infinity / obj > 0 ? '0' : '-0';
        }
        var str = String(obj);
        return numericSeparator ? addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === 'bigint') {
        var bigIntStr = String(obj) + 'n';
        return numericSeparator ? addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }

    var maxDepth = typeof opts.depth === 'undefined' ? 5 : opts.depth;
    if (typeof depth === 'undefined') { depth = 0; }
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === 'object') {
        return isArray$j(obj) ? '[Array]' : '[Object]';
    }

    var indent = getIndent(opts, depth);

    if (typeof seen === 'undefined') {
        seen = [];
    } else if (indexOf(seen, obj) >= 0) {
        return '[Circular]';
    }

    function inspect(value, from, noIndent) {
        if (from) {
            seen = $arrSlice.call(seen);
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if (has$3(opts, 'quoteStyle')) {
                newOpts.quoteStyle = opts.quoteStyle;
            }
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }

    if (typeof obj === 'function' && !isRegExp$1(obj)) { // in older engines, regexes are callable
        var name = nameOf(obj);
        var keys = arrObjKeys(obj, inspect);
        return '[Function' + (name ? ': ' + name : ' (anonymous)') + ']' + (keys.length > 0 ? ' { ' + $join.call(keys, ', ') + ' }' : '');
    }
    if (isSymbol$5(obj)) {
        var symString = hasShammedSymbols ? $replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, '$1') : symToString.call(obj);
        return typeof obj === 'object' && !hasShammedSymbols ? markBoxed(symString) : symString;
    }
    if (isElement(obj)) {
        var s = '<' + $toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for (var i = 0; i < attrs.length; i++) {
            s += ' ' + attrs[i].name + '=' + wrapQuotes(quote(attrs[i].value), 'double', opts);
        }
        s += '>';
        if (obj.childNodes && obj.childNodes.length) { s += '...'; }
        s += '</' + $toLowerCase.call(String(obj.nodeName)) + '>';
        return s;
    }
    if (isArray$j(obj)) {
        if (obj.length === 0) { return '[]'; }
        var xs = arrObjKeys(obj, inspect);
        if (indent && !singleLineValues(xs)) {
            return '[' + indentedJoin(xs, indent) + ']';
        }
        return '[ ' + $join.call(xs, ', ') + ' ]';
    }
    if (isError(obj)) {
        var parts = arrObjKeys(obj, inspect);
        if (!('cause' in Error.prototype) && 'cause' in obj && !isEnumerable.call(obj, 'cause')) {
            return '{ [' + String(obj) + '] ' + $join.call($concat.call('[cause]: ' + inspect(obj.cause), parts), ', ') + ' }';
        }
        if (parts.length === 0) { return '[' + String(obj) + ']'; }
        return '{ [' + String(obj) + '] ' + $join.call(parts, ', ') + ' }';
    }
    if (typeof obj === 'object' && customInspect) {
        if (inspectSymbol && typeof obj[inspectSymbol] === 'function' && utilInspect) {
            return utilInspect(obj, { depth: maxDepth - depth });
        } else if (customInspect !== 'symbol' && typeof obj.inspect === 'function') {
            return obj.inspect();
        }
    }
    if (isMap$2(obj)) {
        var mapParts = [];
        mapForEach.call(obj, function (value, key) {
            mapParts.push(inspect(key, obj, true) + ' => ' + inspect(value, obj));
        });
        return collectionOf('Map', mapSize.call(obj), mapParts, indent);
    }
    if (isSet$2(obj)) {
        var setParts = [];
        setForEach.call(obj, function (value) {
            setParts.push(inspect(value, obj));
        });
        return collectionOf('Set', setSize.call(obj), setParts, indent);
    }
    if (isWeakMap(obj)) {
        return weakCollectionOf('WeakMap');
    }
    if (isWeakSet(obj)) {
        return weakCollectionOf('WeakSet');
    }
    if (isWeakRef(obj)) {
        return weakCollectionOf('WeakRef');
    }
    if (isNumber$1(obj)) {
        return markBoxed(inspect(Number(obj)));
    }
    if (isBigInt(obj)) {
        return markBoxed(inspect(bigIntValueOf.call(obj)));
    }
    if (isBoolean$1(obj)) {
        return markBoxed(booleanValueOf.call(obj));
    }
    if (isString$1(obj)) {
        return markBoxed(inspect(String(obj)));
    }
    if (!isDate(obj) && !isRegExp$1(obj)) {
        var ys = arrObjKeys(obj, inspect);
        var isPlainObject = gPO ? gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? '' : 'null prototype';
        var stringTag = !isPlainObject && toStringTag && Object(obj) === obj && toStringTag in obj ? $slice.call(toStr(obj), 8, -1) : protoTag ? 'Object' : '';
        var constructorTag = isPlainObject || typeof obj.constructor !== 'function' ? '' : obj.constructor.name ? obj.constructor.name + ' ' : '';
        var tag = constructorTag + (stringTag || protoTag ? '[' + $join.call($concat.call([], stringTag || [], protoTag || []), ': ') + '] ' : '');
        if (ys.length === 0) { return tag + '{}'; }
        if (indent) {
            return tag + '{' + indentedJoin(ys, indent) + '}';
        }
        return tag + '{ ' + $join.call(ys, ', ') + ' }';
    }
    return String(obj);
};

function wrapQuotes(s, defaultStyle, opts) {
    var quoteChar = (opts.quoteStyle || defaultStyle) === 'double' ? '"' : "'";
    return quoteChar + s + quoteChar;
}

function quote(s) {
    return $replace.call(String(s), /"/g, '&quot;');
}

function isArray$j(obj) { return toStr(obj) === '[object Array]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isDate(obj) { return toStr(obj) === '[object Date]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isRegExp$1(obj) { return toStr(obj) === '[object RegExp]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isError(obj) { return toStr(obj) === '[object Error]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isString$1(obj) { return toStr(obj) === '[object String]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isNumber$1(obj) { return toStr(obj) === '[object Number]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isBoolean$1(obj) { return toStr(obj) === '[object Boolean]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }

// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function isSymbol$5(obj) {
    if (hasShammedSymbols) {
        return obj && typeof obj === 'object' && obj instanceof Symbol;
    }
    if (typeof obj === 'symbol') {
        return true;
    }
    if (!obj || typeof obj !== 'object' || !symToString) {
        return false;
    }
    try {
        symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}

function isBigInt(obj) {
    if (!obj || typeof obj !== 'object' || !bigIntValueOf) {
        return false;
    }
    try {
        bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}

var hasOwn$1 = Object.prototype.hasOwnProperty || function (key) { return key in this; };
function has$3(obj, key) {
    return hasOwn$1.call(obj, key);
}

function toStr(obj) {
    return objectToString$2.call(obj);
}

function nameOf(f) {
    if (f.name) { return f.name; }
    var m = $match.call(functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) { return m[1]; }
    return null;
}

function indexOf(xs, x) {
    if (xs.indexOf) { return xs.indexOf(x); }
    for (var i = 0, l = xs.length; i < l; i++) {
        if (xs[i] === x) { return i; }
    }
    return -1;
}

function isMap$2(x) {
    if (!mapSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        mapSize.call(x);
        try {
            setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakMap(x) {
    if (!weakMapHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakMapHas.call(x, weakMapHas);
        try {
            weakSetHas.call(x, weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakRef(x) {
    if (!weakRefDeref || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}

function isSet$2(x) {
    if (!setSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        setSize.call(x);
        try {
            mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakSet(x) {
    if (!weakSetHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakSetHas.call(x, weakSetHas);
        try {
            weakMapHas.call(x, weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isElement(x) {
    if (!x || typeof x !== 'object') { return false; }
    if (typeof HTMLElement !== 'undefined' && x instanceof HTMLElement) {
        return true;
    }
    return typeof x.nodeName === 'string' && typeof x.getAttribute === 'function';
}

function inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = '... ' + remaining + ' more character' + (remaining > 1 ? 's' : '');
        return inspectString($slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    // eslint-disable-next-line no-control-regex
    var s = $replace.call($replace.call(str, /(['\\])/g, '\\$1'), /[\x00-\x1f]/g, lowbyte);
    return wrapQuotes(s, 'single', opts);
}

function lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: 'b',
        9: 't',
        10: 'n',
        12: 'f',
        13: 'r'
    }[n];
    if (x) { return '\\' + x; }
    return '\\x' + (n < 0x10 ? '0' : '') + $toUpperCase.call(n.toString(16));
}

function markBoxed(str) {
    return 'Object(' + str + ')';
}

function weakCollectionOf(type) {
    return type + ' { ? }';
}

function collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? indentedJoin(entries, indent) : $join.call(entries, ', ');
    return type + ' (' + size + ') {' + joinedEntries + '}';
}

function singleLineValues(xs) {
    for (var i = 0; i < xs.length; i++) {
        if (indexOf(xs[i], '\n') >= 0) {
            return false;
        }
    }
    return true;
}

function getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === '\t') {
        baseIndent = '\t';
    } else if (typeof opts.indent === 'number' && opts.indent > 0) {
        baseIndent = $join.call(Array(opts.indent + 1), ' ');
    } else {
        return null;
    }
    return {
        base: baseIndent,
        prev: $join.call(Array(depth + 1), baseIndent)
    };
}

function indentedJoin(xs, indent) {
    if (xs.length === 0) { return ''; }
    var lineJoiner = '\n' + indent.prev + indent.base;
    return lineJoiner + $join.call(xs, ',' + lineJoiner) + '\n' + indent.prev;
}

function arrObjKeys(obj, inspect) {
    var isArr = isArray$j(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for (var i = 0; i < obj.length; i++) {
            xs[i] = has$3(obj, i) ? inspect(obj[i], obj) : '';
        }
    }
    var syms = typeof gOPS === 'function' ? gOPS(obj) : [];
    var symMap;
    if (hasShammedSymbols) {
        symMap = {};
        for (var k = 0; k < syms.length; k++) {
            symMap['$' + syms[k]] = syms[k];
        }
    }

    for (var key in obj) { // eslint-disable-line no-restricted-syntax
        if (!has$3(obj, key)) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (hasShammedSymbols && symMap['$' + key] instanceof Symbol) {
            // this is to prevent shammed Symbols, which are stored as strings, from being included in the string key section
            continue; // eslint-disable-line no-restricted-syntax, no-continue
        } else if ($test.call(/[^\w$]/, key)) {
            xs.push(inspect(key, obj) + ': ' + inspect(obj[key], obj));
        } else {
            xs.push(key + ': ' + inspect(obj[key], obj));
        }
    }
    if (typeof gOPS === 'function') {
        for (var j = 0; j < syms.length; j++) {
            if (isEnumerable.call(obj, syms[j])) {
                xs.push('[' + inspect(syms[j]) + ']: ' + inspect(obj[syms[j]], obj));
            }
        }
    }
    return xs;
}

var GetIntrinsic = getIntrinsic;
var callBound = callBound$1;
var inspect = objectInspect;

var $TypeError = GetIntrinsic('%TypeError%');
var $WeakMap = GetIntrinsic('%WeakMap%', true);
var $Map = GetIntrinsic('%Map%', true);

var $weakMapGet = callBound('WeakMap.prototype.get', true);
var $weakMapSet = callBound('WeakMap.prototype.set', true);
var $weakMapHas = callBound('WeakMap.prototype.has', true);
var $mapGet = callBound('Map.prototype.get', true);
var $mapSet = callBound('Map.prototype.set', true);
var $mapHas = callBound('Map.prototype.has', true);

/*
 * This function traverses the list returning the node corresponding to the
 * given key.
 *
 * That node is also moved to the head of the list, so that if it's accessed
 * again we don't need to traverse the whole list. By doing so, all the recently
 * used nodes can be accessed relatively quickly.
 */
var listGetNode = function (list, key) { // eslint-disable-line consistent-return
	for (var prev = list, curr; (curr = prev.next) !== null; prev = curr) {
		if (curr.key === key) {
			prev.next = curr.next;
			curr.next = list.next;
			list.next = curr; // eslint-disable-line no-param-reassign
			return curr;
		}
	}
};

var listGet = function (objects, key) {
	var node = listGetNode(objects, key);
	return node && node.value;
};
var listSet = function (objects, key, value) {
	var node = listGetNode(objects, key);
	if (node) {
		node.value = value;
	} else {
		// Prepend the new node to the beginning of the list
		objects.next = { // eslint-disable-line no-param-reassign
			key: key,
			next: objects.next,
			value: value
		};
	}
};
var listHas = function (objects, key) {
	return !!listGetNode(objects, key);
};

var sideChannel = function getSideChannel() {
	var $wm;
	var $m;
	var $o;
	var channel = {
		assert: function (key) {
			if (!channel.has(key)) {
				throw new $TypeError('Side channel does not contain ' + inspect(key));
			}
		},
		get: function (key) { // eslint-disable-line consistent-return
			if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
				if ($wm) {
					return $weakMapGet($wm, key);
				}
			} else if ($Map) {
				if ($m) {
					return $mapGet($m, key);
				}
			} else {
				if ($o) { // eslint-disable-line no-lonely-if
					return listGet($o, key);
				}
			}
		},
		has: function (key) {
			if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
				if ($wm) {
					return $weakMapHas($wm, key);
				}
			} else if ($Map) {
				if ($m) {
					return $mapHas($m, key);
				}
			} else {
				if ($o) { // eslint-disable-line no-lonely-if
					return listHas($o, key);
				}
			}
			return false;
		},
		set: function (key, value) {
			if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
				if (!$wm) {
					$wm = new $WeakMap();
				}
				$weakMapSet($wm, key, value);
			} else if ($Map) {
				if (!$m) {
					$m = new $Map();
				}
				$mapSet($m, key, value);
			} else {
				if (!$o) {
					/*
					 * Initialize the linked list as an empty node, so that we don't have
					 * to special-case handling of the first node: we can always refer to
					 * it as (previous node).next, instead of something like (list).head
					 */
					$o = { key: {}, next: null };
				}
				listSet($o, key, value);
			}
		}
	};
	return channel;
};

var replace$1 = String.prototype.replace;
var percentTwenties = /%20/g;

var Format = {
    RFC1738: 'RFC1738',
    RFC3986: 'RFC3986'
};

var formats$3 = {
    'default': Format.RFC3986,
    formatters: {
        RFC1738: function (value) {
            return replace$1.call(value, percentTwenties, '+');
        },
        RFC3986: function (value) {
            return String(value);
        }
    },
    RFC1738: Format.RFC1738,
    RFC3986: Format.RFC3986
};

var formats$2 = formats$3;

var has$2 = Object.prototype.hasOwnProperty;
var isArray$i = Array.isArray;

var hexTable = (function () {
    var array = [];
    for (var i = 0; i < 256; ++i) {
        array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
    }

    return array;
}());

var compactQueue = function compactQueue(queue) {
    while (queue.length > 1) {
        var item = queue.pop();
        var obj = item.obj[item.prop];

        if (isArray$i(obj)) {
            var compacted = [];

            for (var j = 0; j < obj.length; ++j) {
                if (typeof obj[j] !== 'undefined') {
                    compacted.push(obj[j]);
                }
            }

            item.obj[item.prop] = compacted;
        }
    }
};

var arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? Object.create(null) : {};
    for (var i = 0; i < source.length; ++i) {
        if (typeof source[i] !== 'undefined') {
            obj[i] = source[i];
        }
    }

    return obj;
};

var merge$2 = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */
    if (!source) {
        return target;
    }

    if (typeof source !== 'object') {
        if (isArray$i(target)) {
            target.push(source);
        } else if (target && typeof target === 'object') {
            if ((options && (options.plainObjects || options.allowPrototypes)) || !has$2.call(Object.prototype, source)) {
                target[source] = true;
            }
        } else {
            return [target, source];
        }

        return target;
    }

    if (!target || typeof target !== 'object') {
        return [target].concat(source);
    }

    var mergeTarget = target;
    if (isArray$i(target) && !isArray$i(source)) {
        mergeTarget = arrayToObject(target, options);
    }

    if (isArray$i(target) && isArray$i(source)) {
        source.forEach(function (item, i) {
            if (has$2.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === 'object' && item && typeof item === 'object') {
                    target[i] = merge(targetItem, item, options);
                } else {
                    target.push(item);
                }
            } else {
                target[i] = item;
            }
        });
        return target;
    }

    return Object.keys(source).reduce(function (acc, key) {
        var value = source[key];

        if (has$2.call(acc, key)) {
            acc[key] = merge(acc[key], value, options);
        } else {
            acc[key] = value;
        }
        return acc;
    }, mergeTarget);
};

var assign$1 = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function (acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};

var decode$1 = function (str, decoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, ' ');
    if (charset === 'iso-8859-1') {
        // unescape never throws, no try...catch needed:
        return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    }
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};

var encode$1 = function encode(str, defaultEncoder, charset, kind, format) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) {
        return str;
    }

    var string = str;
    if (typeof str === 'symbol') {
        string = Symbol.prototype.toString.call(str);
    } else if (typeof str !== 'string') {
        string = String(str);
    }

    if (charset === 'iso-8859-1') {
        return escape(string).replace(/%u[0-9a-f]{4}/gi, function ($0) {
            return '%26%23' + parseInt($0.slice(2), 16) + '%3B';
        });
    }

    var out = '';
    for (var i = 0; i < string.length; ++i) {
        var c = string.charCodeAt(i);

        if (
            c === 0x2D // -
            || c === 0x2E // .
            || c === 0x5F // _
            || c === 0x7E // ~
            || (c >= 0x30 && c <= 0x39) // 0-9
            || (c >= 0x41 && c <= 0x5A) // a-z
            || (c >= 0x61 && c <= 0x7A) // A-Z
            || (format === formats$2.RFC1738 && (c === 0x28 || c === 0x29)) // ( )
        ) {
            out += string.charAt(i);
            continue;
        }

        if (c < 0x80) {
            out = out + hexTable[c];
            continue;
        }

        if (c < 0x800) {
            out = out + (hexTable[0xC0 | (c >> 6)] + hexTable[0x80 | (c & 0x3F)]);
            continue;
        }

        if (c < 0xD800 || c >= 0xE000) {
            out = out + (hexTable[0xE0 | (c >> 12)] + hexTable[0x80 | ((c >> 6) & 0x3F)] + hexTable[0x80 | (c & 0x3F)]);
            continue;
        }

        i += 1;
        c = 0x10000 + (((c & 0x3FF) << 10) | (string.charCodeAt(i) & 0x3FF));
        /* eslint operator-linebreak: [2, "before"] */
        out += hexTable[0xF0 | (c >> 18)]
            + hexTable[0x80 | ((c >> 12) & 0x3F)]
            + hexTable[0x80 | ((c >> 6) & 0x3F)]
            + hexTable[0x80 | (c & 0x3F)];
    }

    return out;
};

var compact = function compact(value) {
    var queue = [{ obj: { o: value }, prop: 'o' }];
    var refs = [];

    for (var i = 0; i < queue.length; ++i) {
        var item = queue[i];
        var obj = item.obj[item.prop];

        var keys = Object.keys(obj);
        for (var j = 0; j < keys.length; ++j) {
            var key = keys[j];
            var val = obj[key];
            if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
                queue.push({ obj: obj, prop: key });
                refs.push(val);
            }
        }
    }

    compactQueue(queue);

    return value;
};

var isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === '[object RegExp]';
};

var isBuffer$6 = function isBuffer(obj) {
    if (!obj || typeof obj !== 'object') {
        return false;
    }

    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};

var combine = function combine(a, b) {
    return [].concat(a, b);
};

var maybeMap = function maybeMap(val, fn) {
    if (isArray$i(val)) {
        var mapped = [];
        for (var i = 0; i < val.length; i += 1) {
            mapped.push(fn(val[i]));
        }
        return mapped;
    }
    return fn(val);
};

var utils$2 = {
    arrayToObject: arrayToObject,
    assign: assign$1,
    combine: combine,
    compact: compact,
    decode: decode$1,
    encode: encode$1,
    isBuffer: isBuffer$6,
    isRegExp: isRegExp,
    maybeMap: maybeMap,
    merge: merge$2
};

var getSideChannel = sideChannel;
var utils$1 = utils$2;
var formats$1 = formats$3;
var has$1 = Object.prototype.hasOwnProperty;

var arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + '[]';
    },
    comma: 'comma',
    indices: function indices(prefix, key) {
        return prefix + '[' + key + ']';
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};

var isArray$h = Array.isArray;
var split = String.prototype.split;
var push = Array.prototype.push;
var pushToArray = function (arr, valueOrArray) {
    push.apply(arr, isArray$h(valueOrArray) ? valueOrArray : [valueOrArray]);
};

var toISO = Date.prototype.toISOString;

var defaultFormat = formats$1['default'];
var defaults$1 = {
    addQueryPrefix: false,
    allowDots: false,
    charset: 'utf-8',
    charsetSentinel: false,
    delimiter: '&',
    encode: true,
    encoder: utils$1.encode,
    encodeValuesOnly: false,
    format: defaultFormat,
    formatter: formats$1.formatters[defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};

var isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === 'string'
        || typeof v === 'number'
        || typeof v === 'boolean'
        || typeof v === 'symbol'
        || typeof v === 'bigint';
};

var sentinel = {};

var stringify$1 = function stringify(
    object,
    prefix,
    generateArrayPrefix,
    commaRoundTrip,
    strictNullHandling,
    skipNulls,
    encoder,
    filter,
    sort,
    allowDots,
    serializeDate,
    format,
    formatter,
    encodeValuesOnly,
    charset,
    sideChannel
) {
    var obj = object;

    var tmpSc = sideChannel;
    var step = 0;
    var findFlag = false;
    while ((tmpSc = tmpSc.get(sentinel)) !== void undefined && !findFlag) {
        // Where object last appeared in the ref tree
        var pos = tmpSc.get(object);
        step += 1;
        if (typeof pos !== 'undefined') {
            if (pos === step) {
                throw new RangeError('Cyclic object value');
            } else {
                findFlag = true; // Break while
            }
        }
        if (typeof tmpSc.get(sentinel) === 'undefined') {
            step = 0;
        }
    }

    if (typeof filter === 'function') {
        obj = filter(prefix, obj);
    } else if (obj instanceof Date) {
        obj = serializeDate(obj);
    } else if (generateArrayPrefix === 'comma' && isArray$h(obj)) {
        obj = utils$1.maybeMap(obj, function (value) {
            if (value instanceof Date) {
                return serializeDate(value);
            }
            return value;
        });
    }

    if (obj === null) {
        if (strictNullHandling) {
            return encoder && !encodeValuesOnly ? encoder(prefix, defaults$1.encoder, charset, 'key', format) : prefix;
        }

        obj = '';
    }

    if (isNonNullishPrimitive(obj) || utils$1.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, defaults$1.encoder, charset, 'key', format);
            if (generateArrayPrefix === 'comma' && encodeValuesOnly) {
                var valuesArray = split.call(String(obj), ',');
                var valuesJoined = '';
                for (var i = 0; i < valuesArray.length; ++i) {
                    valuesJoined += (i === 0 ? '' : ',') + formatter(encoder(valuesArray[i], defaults$1.encoder, charset, 'value', format));
                }
                return [formatter(keyValue) + (commaRoundTrip && isArray$h(obj) && valuesArray.length === 1 ? '[]' : '') + '=' + valuesJoined];
            }
            return [formatter(keyValue) + '=' + formatter(encoder(obj, defaults$1.encoder, charset, 'value', format))];
        }
        return [formatter(prefix) + '=' + formatter(String(obj))];
    }

    var values = [];

    if (typeof obj === 'undefined') {
        return values;
    }

    var objKeys;
    if (generateArrayPrefix === 'comma' && isArray$h(obj)) {
        // we need to join elements in
        objKeys = [{ value: obj.length > 0 ? obj.join(',') || null : void undefined }];
    } else if (isArray$h(filter)) {
        objKeys = filter;
    } else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }

    var adjustedPrefix = commaRoundTrip && isArray$h(obj) && obj.length === 1 ? prefix + '[]' : prefix;

    for (var j = 0; j < objKeys.length; ++j) {
        var key = objKeys[j];
        var value = typeof key === 'object' && typeof key.value !== 'undefined' ? key.value : obj[key];

        if (skipNulls && value === null) {
            continue;
        }

        var keyPrefix = isArray$h(obj)
            ? typeof generateArrayPrefix === 'function' ? generateArrayPrefix(adjustedPrefix, key) : adjustedPrefix
            : adjustedPrefix + (allowDots ? '.' + key : '[' + key + ']');

        sideChannel.set(object, step);
        var valueSideChannel = getSideChannel();
        valueSideChannel.set(sentinel, sideChannel);
        pushToArray(values, stringify(
            value,
            keyPrefix,
            generateArrayPrefix,
            commaRoundTrip,
            strictNullHandling,
            skipNulls,
            encoder,
            filter,
            sort,
            allowDots,
            serializeDate,
            format,
            formatter,
            encodeValuesOnly,
            charset,
            valueSideChannel
        ));
    }

    return values;
};

var normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) {
        return defaults$1;
    }

    if (opts.encoder !== null && typeof opts.encoder !== 'undefined' && typeof opts.encoder !== 'function') {
        throw new TypeError('Encoder has to be a function.');
    }

    var charset = opts.charset || defaults$1.charset;
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    }

    var format = formats$1['default'];
    if (typeof opts.format !== 'undefined') {
        if (!has$1.call(formats$1.formatters, opts.format)) {
            throw new TypeError('Unknown format option provided.');
        }
        format = opts.format;
    }
    var formatter = formats$1.formatters[format];

    var filter = defaults$1.filter;
    if (typeof opts.filter === 'function' || isArray$h(opts.filter)) {
        filter = opts.filter;
    }

    return {
        addQueryPrefix: typeof opts.addQueryPrefix === 'boolean' ? opts.addQueryPrefix : defaults$1.addQueryPrefix,
        allowDots: typeof opts.allowDots === 'undefined' ? defaults$1.allowDots : !!opts.allowDots,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults$1.charsetSentinel,
        delimiter: typeof opts.delimiter === 'undefined' ? defaults$1.delimiter : opts.delimiter,
        encode: typeof opts.encode === 'boolean' ? opts.encode : defaults$1.encode,
        encoder: typeof opts.encoder === 'function' ? opts.encoder : defaults$1.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === 'boolean' ? opts.encodeValuesOnly : defaults$1.encodeValuesOnly,
        filter: filter,
        format: format,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === 'function' ? opts.serializeDate : defaults$1.serializeDate,
        skipNulls: typeof opts.skipNulls === 'boolean' ? opts.skipNulls : defaults$1.skipNulls,
        sort: typeof opts.sort === 'function' ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults$1.strictNullHandling
    };
};

var stringify_1 = function (object, opts) {
    var obj = object;
    var options = normalizeStringifyOptions(opts);

    var objKeys;
    var filter;

    if (typeof options.filter === 'function') {
        filter = options.filter;
        obj = filter('', obj);
    } else if (isArray$h(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }

    var keys = [];

    if (typeof obj !== 'object' || obj === null) {
        return '';
    }

    var arrayFormat;
    if (opts && opts.arrayFormat in arrayPrefixGenerators) {
        arrayFormat = opts.arrayFormat;
    } else if (opts && 'indices' in opts) {
        arrayFormat = opts.indices ? 'indices' : 'repeat';
    } else {
        arrayFormat = 'indices';
    }

    var generateArrayPrefix = arrayPrefixGenerators[arrayFormat];
    if (opts && 'commaRoundTrip' in opts && typeof opts.commaRoundTrip !== 'boolean') {
        throw new TypeError('`commaRoundTrip` must be a boolean, or absent');
    }
    var commaRoundTrip = generateArrayPrefix === 'comma' && opts && opts.commaRoundTrip;

    if (!objKeys) {
        objKeys = Object.keys(obj);
    }

    if (options.sort) {
        objKeys.sort(options.sort);
    }

    var sideChannel = getSideChannel();
    for (var i = 0; i < objKeys.length; ++i) {
        var key = objKeys[i];

        if (options.skipNulls && obj[key] === null) {
            continue;
        }
        pushToArray(keys, stringify$1(
            obj[key],
            key,
            generateArrayPrefix,
            commaRoundTrip,
            options.strictNullHandling,
            options.skipNulls,
            options.encode ? options.encoder : null,
            options.filter,
            options.sort,
            options.allowDots,
            options.serializeDate,
            options.format,
            options.formatter,
            options.encodeValuesOnly,
            options.charset,
            sideChannel
        ));
    }

    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? '?' : '';

    if (options.charsetSentinel) {
        if (options.charset === 'iso-8859-1') {
            // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
            prefix += 'utf8=%26%2310003%3B&';
        } else {
            // encodeURIComponent('✓')
            prefix += 'utf8=%E2%9C%93&';
        }
    }

    return joined.length > 0 ? prefix + joined : '';
};

var utils = utils$2;

var has = Object.prototype.hasOwnProperty;
var isArray$g = Array.isArray;

var defaults = {
    allowDots: false,
    allowPrototypes: false,
    allowSparse: false,
    arrayLimit: 20,
    charset: 'utf-8',
    charsetSentinel: false,
    comma: false,
    decoder: utils.decode,
    delimiter: '&',
    depth: 5,
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictNullHandling: false
};

var interpretNumericEntities = function (str) {
    return str.replace(/&#(\d+);/g, function ($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};

var parseArrayValue = function (val, options) {
    if (val && typeof val === 'string' && options.comma && val.indexOf(',') > -1) {
        return val.split(',');
    }

    return val;
};

// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var isoSentinel = 'utf8=%26%2310003%3B'; // encodeURIComponent('&#10003;')

// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var charsetSentinel = 'utf8=%E2%9C%93'; // encodeURIComponent('✓')

var parseValues = function parseQueryStringValues(str, options) {
    var obj = {};
    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, limit);
    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;

    var charset = options.charset;
    if (options.charsetSentinel) {
        for (i = 0; i < parts.length; ++i) {
            if (parts[i].indexOf('utf8=') === 0) {
                if (parts[i] === charsetSentinel) {
                    charset = 'utf-8';
                } else if (parts[i] === isoSentinel) {
                    charset = 'iso-8859-1';
                }
                skipIndex = i;
                i = parts.length; // The eslint settings do not allow break;
            }
        }
    }

    for (i = 0; i < parts.length; ++i) {
        if (i === skipIndex) {
            continue;
        }
        var part = parts[i];

        var bracketEqualsPos = part.indexOf(']=');
        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;

        var key, val;
        if (pos === -1) {
            key = options.decoder(part, defaults.decoder, charset, 'key');
            val = options.strictNullHandling ? null : '';
        } else {
            key = options.decoder(part.slice(0, pos), defaults.decoder, charset, 'key');
            val = utils.maybeMap(
                parseArrayValue(part.slice(pos + 1), options),
                function (encodedVal) {
                    return options.decoder(encodedVal, defaults.decoder, charset, 'value');
                }
            );
        }

        if (val && options.interpretNumericEntities && charset === 'iso-8859-1') {
            val = interpretNumericEntities(val);
        }

        if (part.indexOf('[]=') > -1) {
            val = isArray$g(val) ? [val] : val;
        }

        if (has.call(obj, key)) {
            obj[key] = utils.combine(obj[key], val);
        } else {
            obj[key] = val;
        }
    }

    return obj;
};

var parseObject = function (chain, val, options, valuesParsed) {
    var leaf = valuesParsed ? val : parseArrayValue(val, options);

    for (var i = chain.length - 1; i >= 0; --i) {
        var obj;
        var root = chain[i];

        if (root === '[]' && options.parseArrays) {
            obj = [].concat(leaf);
        } else {
            obj = options.plainObjects ? Object.create(null) : {};
            var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
            var index = parseInt(cleanRoot, 10);
            if (!options.parseArrays && cleanRoot === '') {
                obj = { 0: leaf };
            } else if (
                !isNaN(index)
                && root !== cleanRoot
                && String(index) === cleanRoot
                && index >= 0
                && (options.parseArrays && index <= options.arrayLimit)
            ) {
                obj = [];
                obj[index] = leaf;
            } else if (cleanRoot !== '__proto__') {
                obj[cleanRoot] = leaf;
            }
        }

        leaf = obj;
    }

    return leaf;
};

var parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) {
        return;
    }

    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;

    // The regex chunks

    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;

    // Get the parent

    var segment = options.depth > 0 && brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;

    // Stash the parent if it exists

    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
        if (!options.plainObjects && has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) {
                return;
            }
        }

        keys.push(parent);
    }

    // Loop through children appending to the array until we hit depth

    var i = 0;
    while (options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth) {
        i += 1;
        if (!options.plainObjects && has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) {
                return;
            }
        }
        keys.push(segment[1]);
    }

    // If there's a remainder, just add whatever is left

    if (segment) {
        keys.push('[' + key.slice(segment.index) + ']');
    }

    return parseObject(keys, val, options, valuesParsed);
};

var normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) {
        return defaults;
    }

    if (opts.decoder !== null && opts.decoder !== undefined && typeof opts.decoder !== 'function') {
        throw new TypeError('Decoder has to be a function.');
    }

    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    }
    var charset = typeof opts.charset === 'undefined' ? defaults.charset : opts.charset;

    return {
        allowDots: typeof opts.allowDots === 'undefined' ? defaults.allowDots : !!opts.allowDots,
        allowPrototypes: typeof opts.allowPrototypes === 'boolean' ? opts.allowPrototypes : defaults.allowPrototypes,
        allowSparse: typeof opts.allowSparse === 'boolean' ? opts.allowSparse : defaults.allowSparse,
        arrayLimit: typeof opts.arrayLimit === 'number' ? opts.arrayLimit : defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
        comma: typeof opts.comma === 'boolean' ? opts.comma : defaults.comma,
        decoder: typeof opts.decoder === 'function' ? opts.decoder : defaults.decoder,
        delimiter: typeof opts.delimiter === 'string' || utils.isRegExp(opts.delimiter) ? opts.delimiter : defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: (typeof opts.depth === 'number' || opts.depth === false) ? +opts.depth : defaults.depth,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === 'boolean' ? opts.interpretNumericEntities : defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === 'number' ? opts.parameterLimit : defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === 'boolean' ? opts.plainObjects : defaults.plainObjects,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
    };
};

var parse$3 = function (str, opts) {
    var options = normalizeParseOptions(opts);

    if (str === '' || str === null || typeof str === 'undefined') {
        return options.plainObjects ? Object.create(null) : {};
    }

    var tempObj = typeof str === 'string' ? parseValues(str, options) : str;
    var obj = options.plainObjects ? Object.create(null) : {};

    // Iterate over the keys and setup the new object

    var keys = Object.keys(tempObj);
    for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        var newObj = parseKeys(key, tempObj[key], options, typeof str === 'string');
        obj = utils.merge(obj, newObj, options);
    }

    if (options.allowSparse === true) {
        return obj;
    }

    return utils.compact(obj);
};

var stringify = stringify_1;
var parse$2 = parse$3;
var formats = formats$3;

var lib$1 = {
    formats: formats,
    parse: parse$2,
    stringify: stringify
};

const urlBuilder = (url, query) => {
  if (!url) {
    return "";
  }
  const isFullQualifiedUrl = url.startsWith("http://") || url.startsWith("https://");
  if (!isFullQualifiedUrl) {
    console.warn("The URL provided is not a full qualified URL");
    return url;
  }
  const parsedUrl = new URL(url);
  if (!query) {
    return parsedUrl.toString();
  }
  const parsedUrlParams = lib$1.parse(parsedUrl.search, { ignoreQueryPrefix: true });
  parsedUrl.search = lib$1.stringify({ ...parsedUrlParams, ...query }, { arrayFormat: "brackets" });
  return parsedUrl.toString();
};
const urlHelper = urlBuilder;

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */

var isArray$f = Array.isArray;

var isArray_1 = isArray$f;

/** Detect free variable `global` from Node.js. */

var freeGlobal$1 = typeof commonjsGlobal$1 == 'object' && commonjsGlobal$1 && commonjsGlobal$1.Object === Object && commonjsGlobal$1;

var _freeGlobal = freeGlobal$1;

var freeGlobal = _freeGlobal;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root$9 = freeGlobal || freeSelf || Function('return this')();

var _root = root$9;

var root$8 = _root;

/** Built-in value references. */
var Symbol$7 = root$8.Symbol;

var _Symbol = Symbol$7;

var Symbol$6 = _Symbol;

/** Used for built-in method references. */
var objectProto$h = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$e = objectProto$h.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString$1 = objectProto$h.toString;

/** Built-in value references. */
var symToStringTag$1 = Symbol$6 ? Symbol$6.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag$1(value) {
  var isOwn = hasOwnProperty$e.call(value, symToStringTag$1),
      tag = value[symToStringTag$1];

  try {
    value[symToStringTag$1] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString$1.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag$1] = tag;
    } else {
      delete value[symToStringTag$1];
    }
  }
  return result;
}

var _getRawTag = getRawTag$1;

/** Used for built-in method references. */

var objectProto$g = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto$g.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString$1(value) {
  return nativeObjectToString.call(value);
}

var _objectToString = objectToString$1;

var Symbol$5 = _Symbol,
    getRawTag = _getRawTag,
    objectToString = _objectToString;

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol$5 ? Symbol$5.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag$6(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

var _baseGetTag = baseGetTag$6;

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */

function isObjectLike$a(value) {
  return value != null && typeof value == 'object';
}

var isObjectLike_1 = isObjectLike$a;

var baseGetTag$5 = _baseGetTag,
    isObjectLike$9 = isObjectLike_1;

/** `Object#toString` result references. */
var symbolTag$3 = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol$4(value) {
  return typeof value == 'symbol' ||
    (isObjectLike$9(value) && baseGetTag$5(value) == symbolTag$3);
}

var isSymbol_1 = isSymbol$4;

var isArray$e = isArray_1,
    isSymbol$3 = isSymbol_1;

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey$3(value, object) {
  if (isArray$e(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol$3(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

var _isKey = isKey$3;

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */

function isObject$d(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

var isObject_1 = isObject$d;

var baseGetTag$4 = _baseGetTag,
    isObject$c = isObject_1;

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag$2 = '[object Function]',
    genTag$1 = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction$3(value) {
  if (!isObject$c(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag$4(value);
  return tag == funcTag$2 || tag == genTag$1 || tag == asyncTag || tag == proxyTag;
}

var isFunction_1 = isFunction$3;

var root$7 = _root;

/** Used to detect overreaching core-js shims. */
var coreJsData$1 = root$7['__core-js_shared__'];

var _coreJsData = coreJsData$1;

var coreJsData = _coreJsData;

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked$1(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

var _isMasked = isMasked$1;

/** Used for built-in method references. */

var funcProto$2 = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString$2 = funcProto$2.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource$2(func) {
  if (func != null) {
    try {
      return funcToString$2.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

var _toSource = toSource$2;

var isFunction$2 = isFunction_1,
    isMasked = _isMasked,
    isObject$b = isObject_1,
    toSource$1 = _toSource;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto$1 = Function.prototype,
    objectProto$f = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString$1 = funcProto$1.toString;

/** Used to check objects for own properties. */
var hasOwnProperty$d = objectProto$f.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString$1.call(hasOwnProperty$d).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative$1(value) {
  if (!isObject$b(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction$2(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource$1(value));
}

var _baseIsNative = baseIsNative$1;

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */

function getValue$1(object, key) {
  return object == null ? undefined : object[key];
}

var _getValue = getValue$1;

var baseIsNative = _baseIsNative,
    getValue = _getValue;

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative$7(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

var _getNative = getNative$7;

var getNative$6 = _getNative;

/* Built-in method references that are verified to be native. */
var nativeCreate$4 = getNative$6(Object, 'create');

var _nativeCreate = nativeCreate$4;

var nativeCreate$3 = _nativeCreate;

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear$1() {
  this.__data__ = nativeCreate$3 ? nativeCreate$3(null) : {};
  this.size = 0;
}

var _hashClear = hashClear$1;

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */

function hashDelete$1(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

var _hashDelete = hashDelete$1;

var nativeCreate$2 = _nativeCreate;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED$2 = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto$e = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$c = objectProto$e.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet$1(key) {
  var data = this.__data__;
  if (nativeCreate$2) {
    var result = data[key];
    return result === HASH_UNDEFINED$2 ? undefined : result;
  }
  return hasOwnProperty$c.call(data, key) ? data[key] : undefined;
}

var _hashGet = hashGet$1;

var nativeCreate$1 = _nativeCreate;

/** Used for built-in method references. */
var objectProto$d = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$b = objectProto$d.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas$1(key) {
  var data = this.__data__;
  return nativeCreate$1 ? (data[key] !== undefined) : hasOwnProperty$b.call(data, key);
}

var _hashHas = hashHas$1;

var nativeCreate = _nativeCreate;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED$1 = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet$1(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED$1 : value;
  return this;
}

var _hashSet = hashSet$1;

var hashClear = _hashClear,
    hashDelete = _hashDelete,
    hashGet = _hashGet,
    hashHas = _hashHas,
    hashSet = _hashSet;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash$1(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash$1.prototype.clear = hashClear;
Hash$1.prototype['delete'] = hashDelete;
Hash$1.prototype.get = hashGet;
Hash$1.prototype.has = hashHas;
Hash$1.prototype.set = hashSet;

var _Hash = Hash$1;

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */

function listCacheClear$1() {
  this.__data__ = [];
  this.size = 0;
}

var _listCacheClear = listCacheClear$1;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */

function eq$5(value, other) {
  return value === other || (value !== value && other !== other);
}

var eq_1 = eq$5;

var eq$4 = eq_1;

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf$4(array, key) {
  var length = array.length;
  while (length--) {
    if (eq$4(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

var _assocIndexOf = assocIndexOf$4;

var assocIndexOf$3 = _assocIndexOf;

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete$1(key) {
  var data = this.__data__,
      index = assocIndexOf$3(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

var _listCacheDelete = listCacheDelete$1;

var assocIndexOf$2 = _assocIndexOf;

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet$1(key) {
  var data = this.__data__,
      index = assocIndexOf$2(data, key);

  return index < 0 ? undefined : data[index][1];
}

var _listCacheGet = listCacheGet$1;

var assocIndexOf$1 = _assocIndexOf;

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas$1(key) {
  return assocIndexOf$1(this.__data__, key) > -1;
}

var _listCacheHas = listCacheHas$1;

var assocIndexOf = _assocIndexOf;

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet$1(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

var _listCacheSet = listCacheSet$1;

var listCacheClear = _listCacheClear,
    listCacheDelete = _listCacheDelete,
    listCacheGet = _listCacheGet,
    listCacheHas = _listCacheHas,
    listCacheSet = _listCacheSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache$4(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache$4.prototype.clear = listCacheClear;
ListCache$4.prototype['delete'] = listCacheDelete;
ListCache$4.prototype.get = listCacheGet;
ListCache$4.prototype.has = listCacheHas;
ListCache$4.prototype.set = listCacheSet;

var _ListCache = ListCache$4;

var getNative$5 = _getNative,
    root$6 = _root;

/* Built-in method references that are verified to be native. */
var Map$4 = getNative$5(root$6, 'Map');

var _Map = Map$4;

var Hash = _Hash,
    ListCache$3 = _ListCache,
    Map$3 = _Map;

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear$1() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map$3 || ListCache$3),
    'string': new Hash
  };
}

var _mapCacheClear = mapCacheClear$1;

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */

function isKeyable$1(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

var _isKeyable = isKeyable$1;

var isKeyable = _isKeyable;

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData$4(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

var _getMapData = getMapData$4;

var getMapData$3 = _getMapData;

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete$1(key) {
  var result = getMapData$3(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

var _mapCacheDelete = mapCacheDelete$1;

var getMapData$2 = _getMapData;

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet$1(key) {
  return getMapData$2(this, key).get(key);
}

var _mapCacheGet = mapCacheGet$1;

var getMapData$1 = _getMapData;

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas$1(key) {
  return getMapData$1(this, key).has(key);
}

var _mapCacheHas = mapCacheHas$1;

var getMapData = _getMapData;

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet$1(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

var _mapCacheSet = mapCacheSet$1;

var mapCacheClear = _mapCacheClear,
    mapCacheDelete = _mapCacheDelete,
    mapCacheGet = _mapCacheGet,
    mapCacheHas = _mapCacheHas,
    mapCacheSet = _mapCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache$3(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache$3.prototype.clear = mapCacheClear;
MapCache$3.prototype['delete'] = mapCacheDelete;
MapCache$3.prototype.get = mapCacheGet;
MapCache$3.prototype.has = mapCacheHas;
MapCache$3.prototype.set = mapCacheSet;

var _MapCache = MapCache$3;

var MapCache$2 = _MapCache;

/** Error message constants. */
var FUNC_ERROR_TEXT$1 = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize$1(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT$1);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize$1.Cache || MapCache$2);
  return memoized;
}

// Expose `MapCache`.
memoize$1.Cache = MapCache$2;

var memoize_1 = memoize$1;

var memoize = memoize_1;

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped$1(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

var _memoizeCapped = memoizeCapped$1;

var memoizeCapped = _memoizeCapped;

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath$1 = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

var _stringToPath = stringToPath$1;

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */

function arrayMap$2(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

var _arrayMap = arrayMap$2;

var Symbol$4 = _Symbol,
    arrayMap$1 = _arrayMap,
    isArray$d = isArray_1,
    isSymbol$2 = isSymbol_1;

/** Used as references for various `Number` constants. */
var INFINITY$3 = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto$2 = Symbol$4 ? Symbol$4.prototype : undefined,
    symbolToString = symbolProto$2 ? symbolProto$2.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString$2(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray$d(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap$1(value, baseToString$2) + '';
  }
  if (isSymbol$2(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY$3) ? '-0' : result;
}

var _baseToString = baseToString$2;

var baseToString$1 = _baseToString;

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString$2(value) {
  return value == null ? '' : baseToString$1(value);
}

var toString_1 = toString$2;

var isArray$c = isArray_1,
    isKey$2 = _isKey,
    stringToPath = _stringToPath,
    toString$1 = toString_1;

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath$6(value, object) {
  if (isArray$c(value)) {
    return value;
  }
  return isKey$2(value, object) ? [value] : stringToPath(toString$1(value));
}

var _castPath = castPath$6;

var isSymbol$1 = isSymbol_1;

/** Used as references for various `Number` constants. */
var INFINITY$2 = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey$6(value) {
  if (typeof value == 'string' || isSymbol$1(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY$2) ? '-0' : result;
}

var _toKey = toKey$6;

var castPath$5 = _castPath,
    toKey$5 = _toKey;

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet$4(object, path) {
  path = castPath$5(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey$5(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

var _baseGet = baseGet$4;

var getNative$4 = _getNative;

var defineProperty$2 = (function() {
  try {
    var func = getNative$4(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

var _defineProperty$1 = defineProperty$2;

var defineProperty$1 = _defineProperty$1;

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue$3(object, key, value) {
  if (key == '__proto__' && defineProperty$1) {
    defineProperty$1(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

var _baseAssignValue = baseAssignValue$3;

var baseAssignValue$2 = _baseAssignValue,
    eq$3 = eq_1;

/** Used for built-in method references. */
var objectProto$c = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$a = objectProto$c.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue$4(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty$a.call(object, key) && eq$3(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue$2(object, key, value);
  }
}

var _assignValue = assignValue$4;

/** Used as references for various `Number` constants. */

var MAX_SAFE_INTEGER$1 = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex$4(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER$1 : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

var _isIndex = isIndex$4;

var assignValue$3 = _assignValue,
    castPath$4 = _castPath,
    isIndex$3 = _isIndex,
    isObject$a = isObject_1,
    toKey$4 = _toKey;

/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */
function baseSet$1(object, path, value, customizer) {
  if (!isObject$a(object)) {
    return object;
  }
  path = castPath$4(path, object);

  var index = -1,
      length = path.length,
      lastIndex = length - 1,
      nested = object;

  while (nested != null && ++index < length) {
    var key = toKey$4(path[index]),
        newValue = value;

    if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
      return object;
    }

    if (index != lastIndex) {
      var objValue = nested[key];
      newValue = customizer ? customizer(objValue, key, nested) : undefined;
      if (newValue === undefined) {
        newValue = isObject$a(objValue)
          ? objValue
          : (isIndex$3(path[index + 1]) ? [] : {});
      }
    }
    assignValue$3(nested, key, newValue);
    nested = nested[key];
  }
  return object;
}

var _baseSet = baseSet$1;

var baseGet$3 = _baseGet,
    baseSet = _baseSet,
    castPath$3 = _castPath;

/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */
function basePickBy$1(object, paths, predicate) {
  var index = -1,
      length = paths.length,
      result = {};

  while (++index < length) {
    var path = paths[index],
        value = baseGet$3(object, path);

    if (predicate(value, path)) {
      baseSet(result, castPath$3(path, object), value);
    }
  }
  return result;
}

var _basePickBy = basePickBy$1;

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */

function baseHasIn$1(object, key) {
  return object != null && key in Object(object);
}

var _baseHasIn = baseHasIn$1;

var baseGetTag$3 = _baseGetTag,
    isObjectLike$8 = isObjectLike_1;

/** `Object#toString` result references. */
var argsTag$3 = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments$1(value) {
  return isObjectLike$8(value) && baseGetTag$3(value) == argsTag$3;
}

var _baseIsArguments = baseIsArguments$1;

var baseIsArguments = _baseIsArguments,
    isObjectLike$7 = isObjectLike_1;

/** Used for built-in method references. */
var objectProto$b = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$9 = objectProto$b.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable$1 = objectProto$b.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments$5 = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike$7(value) && hasOwnProperty$9.call(value, 'callee') &&
    !propertyIsEnumerable$1.call(value, 'callee');
};

var isArguments_1 = isArguments$5;

/** Used as references for various `Number` constants. */

var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength$3(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

var isLength_1 = isLength$3;

var castPath$2 = _castPath,
    isArguments$4 = isArguments_1,
    isArray$b = isArray_1,
    isIndex$2 = _isIndex,
    isLength$2 = isLength_1,
    toKey$3 = _toKey;

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath$1(object, path, hasFunc) {
  path = castPath$2(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey$3(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength$2(length) && isIndex$2(key, length) &&
    (isArray$b(object) || isArguments$4(object));
}

var _hasPath = hasPath$1;

var baseHasIn = _baseHasIn,
    hasPath = _hasPath;

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn$2(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

var hasIn_1 = hasIn$2;

var basePickBy = _basePickBy,
    hasIn$1 = hasIn_1;

/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */
function basePick$1(object, paths) {
  return basePickBy(object, paths, function(value, path) {
    return hasIn$1(object, path);
  });
}

var _basePick = basePick$1;

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */

function arrayPush$3(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

var _arrayPush = arrayPush$3;

var Symbol$3 = _Symbol,
    isArguments$3 = isArguments_1,
    isArray$a = isArray_1;

/** Built-in value references. */
var spreadableSymbol = Symbol$3 ? Symbol$3.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable$1(value) {
  return isArray$a(value) || isArguments$3(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

var _isFlattenable = isFlattenable$1;

var arrayPush$2 = _arrayPush,
    isFlattenable = _isFlattenable;

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten$1(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten$1(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush$2(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

var _baseFlatten = baseFlatten$1;

var baseFlatten = _baseFlatten;

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */
function flatten$1(array) {
  var length = array == null ? 0 : array.length;
  return length ? baseFlatten(array, 1) : [];
}

var flatten_1 = flatten$1;

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */

function apply$1(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

var _apply = apply$1;

var apply = _apply;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax$2 = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest$2(func, start, transform) {
  start = nativeMax$2(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax$2(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

var _overRest = overRest$2;

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */

function constant$1(value) {
  return function() {
    return value;
  };
}

var constant_1 = constant$1;

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */

function identity$4(value) {
  return value;
}

var identity_1 = identity$4;

var constant = constant_1,
    defineProperty = _defineProperty$1,
    identity$3 = identity_1;

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString$1 = !defineProperty ? identity$3 : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

var _baseSetToString = baseSetToString$1;

/** Used to detect hot functions by number of calls within a span of milliseconds. */

var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut$1(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

var _shortOut = shortOut$1;

var baseSetToString = _baseSetToString,
    shortOut = _shortOut;

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString$2 = shortOut(baseSetToString);

var _setToString = setToString$2;

var flatten = flatten_1,
    overRest$1 = _overRest,
    setToString$1 = _setToString;

/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */
function flatRest$2(func) {
  return setToString$1(overRest$1(func, undefined, flatten), func + '');
}

var _flatRest = flatRest$2;

var basePick = _basePick,
    flatRest$1 = _flatRest;

/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */
var pick = flatRest$1(function(object, paths) {
  return object == null ? {} : basePick(object, paths);
});

var pick_1 = pick;

const pick$1 = pick_1;

var ListCache$2 = _ListCache;

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear$1() {
  this.__data__ = new ListCache$2;
  this.size = 0;
}

var _stackClear = stackClear$1;

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */

function stackDelete$1(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

var _stackDelete = stackDelete$1;

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */

function stackGet$1(key) {
  return this.__data__.get(key);
}

var _stackGet = stackGet$1;

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */

function stackHas$1(key) {
  return this.__data__.has(key);
}

var _stackHas = stackHas$1;

var ListCache$1 = _ListCache,
    Map$2 = _Map,
    MapCache$1 = _MapCache;

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet$1(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache$1) {
    var pairs = data.__data__;
    if (!Map$2 || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache$1(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

var _stackSet = stackSet$1;

var ListCache = _ListCache,
    stackClear = _stackClear,
    stackDelete = _stackDelete,
    stackGet = _stackGet,
    stackHas = _stackHas,
    stackSet = _stackSet;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack$4(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack$4.prototype.clear = stackClear;
Stack$4.prototype['delete'] = stackDelete;
Stack$4.prototype.get = stackGet;
Stack$4.prototype.has = stackHas;
Stack$4.prototype.set = stackSet;

var _Stack = Stack$4;

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */

function arrayEach$2(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

var _arrayEach = arrayEach$2;

var assignValue$2 = _assignValue,
    baseAssignValue$1 = _baseAssignValue;

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject$7(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue$1(object, key, newValue);
    } else {
      assignValue$2(object, key, newValue);
    }
  }
  return object;
}

var _copyObject = copyObject$7;

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */

function baseTimes$1(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

var _baseTimes = baseTimes$1;

var isBufferExports = {};
var isBuffer$5 = {
  get exports(){ return isBufferExports; },
  set exports(v){ isBufferExports = v; },
};

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */

function stubFalse() {
  return false;
}

var stubFalse_1 = stubFalse;

(function (module, exports) {
	var root = _root,
	    stubFalse = stubFalse_1;

	/** Detect free variable `exports`. */
	var freeExports = exports && !exports.nodeType && exports;

	/** Detect free variable `module`. */
	var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;

	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined;

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;

	module.exports = isBuffer;
} (isBuffer$5, isBufferExports));

var baseGetTag$2 = _baseGetTag,
    isLength$1 = isLength_1,
    isObjectLike$6 = isObjectLike_1;

/** `Object#toString` result references. */
var argsTag$2 = '[object Arguments]',
    arrayTag$2 = '[object Array]',
    boolTag$3 = '[object Boolean]',
    dateTag$3 = '[object Date]',
    errorTag$2 = '[object Error]',
    funcTag$1 = '[object Function]',
    mapTag$6 = '[object Map]',
    numberTag$3 = '[object Number]',
    objectTag$4 = '[object Object]',
    regexpTag$3 = '[object RegExp]',
    setTag$6 = '[object Set]',
    stringTag$3 = '[object String]',
    weakMapTag$2 = '[object WeakMap]';

var arrayBufferTag$3 = '[object ArrayBuffer]',
    dataViewTag$4 = '[object DataView]',
    float32Tag$2 = '[object Float32Array]',
    float64Tag$2 = '[object Float64Array]',
    int8Tag$2 = '[object Int8Array]',
    int16Tag$2 = '[object Int16Array]',
    int32Tag$2 = '[object Int32Array]',
    uint8Tag$2 = '[object Uint8Array]',
    uint8ClampedTag$2 = '[object Uint8ClampedArray]',
    uint16Tag$2 = '[object Uint16Array]',
    uint32Tag$2 = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag$2] = typedArrayTags[float64Tag$2] =
typedArrayTags[int8Tag$2] = typedArrayTags[int16Tag$2] =
typedArrayTags[int32Tag$2] = typedArrayTags[uint8Tag$2] =
typedArrayTags[uint8ClampedTag$2] = typedArrayTags[uint16Tag$2] =
typedArrayTags[uint32Tag$2] = true;
typedArrayTags[argsTag$2] = typedArrayTags[arrayTag$2] =
typedArrayTags[arrayBufferTag$3] = typedArrayTags[boolTag$3] =
typedArrayTags[dataViewTag$4] = typedArrayTags[dateTag$3] =
typedArrayTags[errorTag$2] = typedArrayTags[funcTag$1] =
typedArrayTags[mapTag$6] = typedArrayTags[numberTag$3] =
typedArrayTags[objectTag$4] = typedArrayTags[regexpTag$3] =
typedArrayTags[setTag$6] = typedArrayTags[stringTag$3] =
typedArrayTags[weakMapTag$2] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray$1(value) {
  return isObjectLike$6(value) &&
    isLength$1(value.length) && !!typedArrayTags[baseGetTag$2(value)];
}

var _baseIsTypedArray = baseIsTypedArray$1;

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */

function baseUnary$3(func) {
  return function(value) {
    return func(value);
  };
}

var _baseUnary = baseUnary$3;

var _nodeUtilExports = {};
var _nodeUtil = {
  get exports(){ return _nodeUtilExports; },
  set exports(v){ _nodeUtilExports = v; },
};

(function (module, exports) {
	var freeGlobal = _freeGlobal;

	/** Detect free variable `exports`. */
	var freeExports = exports && !exports.nodeType && exports;

	/** Detect free variable `module`. */
	var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;

	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;

	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    // Use `util.types` for Node.js 10+.
	    var types = freeModule && freeModule.require && freeModule.require('util').types;

	    if (types) {
	      return types;
	    }

	    // Legacy `process.binding('util')` for Node.js < 10.
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());

	module.exports = nodeUtil;
} (_nodeUtil, _nodeUtilExports));

var baseIsTypedArray = _baseIsTypedArray,
    baseUnary$2 = _baseUnary,
    nodeUtil$2 = _nodeUtilExports;

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil$2 && nodeUtil$2.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray$4 = nodeIsTypedArray ? baseUnary$2(nodeIsTypedArray) : baseIsTypedArray;

var isTypedArray_1 = isTypedArray$4;

var baseTimes = _baseTimes,
    isArguments$2 = isArguments_1,
    isArray$9 = isArray_1,
    isBuffer$4 = isBufferExports,
    isIndex$1 = _isIndex,
    isTypedArray$3 = isTypedArray_1;

/** Used for built-in method references. */
var objectProto$a = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$8 = objectProto$a.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys$2(value, inherited) {
  var isArr = isArray$9(value),
      isArg = !isArr && isArguments$2(value),
      isBuff = !isArr && !isArg && isBuffer$4(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray$3(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty$8.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex$1(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

var _arrayLikeKeys = arrayLikeKeys$2;

/** Used for built-in method references. */

var objectProto$9 = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype$5(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto$9;

  return value === proto;
}

var _isPrototype = isPrototype$5;

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */

function overArg$2(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

var _overArg = overArg$2;

var overArg$1 = _overArg;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys$1 = overArg$1(Object.keys, Object);

var _nativeKeys = nativeKeys$1;

var isPrototype$4 = _isPrototype,
    nativeKeys = _nativeKeys;

/** Used for built-in method references. */
var objectProto$8 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$7 = objectProto$8.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys$2(object) {
  if (!isPrototype$4(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty$7.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

var _baseKeys = baseKeys$2;

var isFunction$1 = isFunction_1,
    isLength = isLength_1;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike$8(value) {
  return value != null && isLength(value.length) && !isFunction$1(value);
}

var isArrayLike_1 = isArrayLike$8;

var arrayLikeKeys$1 = _arrayLikeKeys,
    baseKeys$1 = _baseKeys,
    isArrayLike$7 = isArrayLike_1;

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys$7(object) {
  return isArrayLike$7(object) ? arrayLikeKeys$1(object) : baseKeys$1(object);
}

var keys_1 = keys$7;

var copyObject$6 = _copyObject,
    keys$6 = keys_1;

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign$1(object, source) {
  return object && copyObject$6(source, keys$6(source), object);
}

var _baseAssign = baseAssign$1;

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */

function nativeKeysIn$1(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

var _nativeKeysIn = nativeKeysIn$1;

var isObject$9 = isObject_1,
    isPrototype$3 = _isPrototype,
    nativeKeysIn = _nativeKeysIn;

/** Used for built-in method references. */
var objectProto$7 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$6 = objectProto$7.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn$1(object) {
  if (!isObject$9(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype$3(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty$6.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

var _baseKeysIn = baseKeysIn$1;

var arrayLikeKeys = _arrayLikeKeys,
    baseKeysIn = _baseKeysIn,
    isArrayLike$6 = isArrayLike_1;

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn$5(object) {
  return isArrayLike$6(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

var keysIn_1 = keysIn$5;

var copyObject$5 = _copyObject,
    keysIn$4 = keysIn_1;

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn$1(object, source) {
  return object && copyObject$5(source, keysIn$4(source), object);
}

var _baseAssignIn = baseAssignIn$1;

var _cloneBufferExports = {};
var _cloneBuffer = {
  get exports(){ return _cloneBufferExports; },
  set exports(v){ _cloneBufferExports = v; },
};

(function (module, exports) {
	var root = _root;

	/** Detect free variable `exports`. */
	var freeExports = exports && !exports.nodeType && exports;

	/** Detect free variable `module`. */
	var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;

	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined,
	    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

	/**
	 * Creates a clone of  `buffer`.
	 *
	 * @private
	 * @param {Buffer} buffer The buffer to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Buffer} Returns the cloned buffer.
	 */
	function cloneBuffer(buffer, isDeep) {
	  if (isDeep) {
	    return buffer.slice();
	  }
	  var length = buffer.length,
	      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

	  buffer.copy(result);
	  return result;
	}

	module.exports = cloneBuffer;
} (_cloneBuffer, _cloneBufferExports));

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */

function copyArray$2(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

var _copyArray = copyArray$2;

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */

function arrayFilter$2(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

var _arrayFilter = arrayFilter$2;

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */

function stubArray$2() {
  return [];
}

var stubArray_1 = stubArray$2;

var arrayFilter$1 = _arrayFilter,
    stubArray$1 = stubArray_1;

/** Used for built-in method references. */
var objectProto$6 = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto$6.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols$1 = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols$3 = !nativeGetSymbols$1 ? stubArray$1 : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter$1(nativeGetSymbols$1(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

var _getSymbols = getSymbols$3;

var copyObject$4 = _copyObject,
    getSymbols$2 = _getSymbols;

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols$1(source, object) {
  return copyObject$4(source, getSymbols$2(source), object);
}

var _copySymbols = copySymbols$1;

var overArg = _overArg;

/** Built-in value references. */
var getPrototype$3 = overArg(Object.getPrototypeOf, Object);

var _getPrototype = getPrototype$3;

var arrayPush$1 = _arrayPush,
    getPrototype$2 = _getPrototype,
    getSymbols$1 = _getSymbols,
    stubArray = stubArray_1;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn$2 = !nativeGetSymbols ? stubArray : function(object) {
  var result = [];
  while (object) {
    arrayPush$1(result, getSymbols$1(object));
    object = getPrototype$2(object);
  }
  return result;
};

var _getSymbolsIn = getSymbolsIn$2;

var copyObject$3 = _copyObject,
    getSymbolsIn$1 = _getSymbolsIn;

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn$1(source, object) {
  return copyObject$3(source, getSymbolsIn$1(source), object);
}

var _copySymbolsIn = copySymbolsIn$1;

var arrayPush = _arrayPush,
    isArray$8 = isArray_1;

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys$2(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray$8(object) ? result : arrayPush(result, symbolsFunc(object));
}

var _baseGetAllKeys = baseGetAllKeys$2;

var baseGetAllKeys$1 = _baseGetAllKeys,
    getSymbols = _getSymbols,
    keys$5 = keys_1;

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys$2(object) {
  return baseGetAllKeys$1(object, keys$5, getSymbols);
}

var _getAllKeys = getAllKeys$2;

var baseGetAllKeys = _baseGetAllKeys,
    getSymbolsIn = _getSymbolsIn,
    keysIn$3 = keysIn_1;

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn$2(object) {
  return baseGetAllKeys(object, keysIn$3, getSymbolsIn);
}

var _getAllKeysIn = getAllKeysIn$2;

var getNative$3 = _getNative,
    root$5 = _root;

/* Built-in method references that are verified to be native. */
var DataView$2 = getNative$3(root$5, 'DataView');

var _DataView = DataView$2;

var getNative$2 = _getNative,
    root$4 = _root;

/* Built-in method references that are verified to be native. */
var Promise$2 = getNative$2(root$4, 'Promise');

var _Promise = Promise$2;

var getNative$1 = _getNative,
    root$3 = _root;

/* Built-in method references that are verified to be native. */
var Set$2 = getNative$1(root$3, 'Set');

var _Set = Set$2;

var getNative = _getNative,
    root$2 = _root;

/* Built-in method references that are verified to be native. */
var WeakMap$2 = getNative(root$2, 'WeakMap');

var _WeakMap = WeakMap$2;

var DataView$1 = _DataView,
    Map$1 = _Map,
    Promise$1 = _Promise,
    Set$1 = _Set,
    WeakMap$1 = _WeakMap,
    baseGetTag$1 = _baseGetTag,
    toSource = _toSource;

/** `Object#toString` result references. */
var mapTag$5 = '[object Map]',
    objectTag$3 = '[object Object]',
    promiseTag = '[object Promise]',
    setTag$5 = '[object Set]',
    weakMapTag$1 = '[object WeakMap]';

var dataViewTag$3 = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView$1),
    mapCtorString = toSource(Map$1),
    promiseCtorString = toSource(Promise$1),
    setCtorString = toSource(Set$1),
    weakMapCtorString = toSource(WeakMap$1);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag$6 = baseGetTag$1;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView$1 && getTag$6(new DataView$1(new ArrayBuffer(1))) != dataViewTag$3) ||
    (Map$1 && getTag$6(new Map$1) != mapTag$5) ||
    (Promise$1 && getTag$6(Promise$1.resolve()) != promiseTag) ||
    (Set$1 && getTag$6(new Set$1) != setTag$5) ||
    (WeakMap$1 && getTag$6(new WeakMap$1) != weakMapTag$1)) {
  getTag$6 = function(value) {
    var result = baseGetTag$1(value),
        Ctor = result == objectTag$3 ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag$3;
        case mapCtorString: return mapTag$5;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag$5;
        case weakMapCtorString: return weakMapTag$1;
      }
    }
    return result;
  };
}

var _getTag = getTag$6;

/** Used for built-in method references. */

var objectProto$5 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$5 = objectProto$5.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray$1(array) {
  var length = array.length,
      result = new array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty$5.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

var _initCloneArray = initCloneArray$1;

var root$1 = _root;

/** Built-in value references. */
var Uint8Array$3 = root$1.Uint8Array;

var _Uint8Array = Uint8Array$3;

var Uint8Array$2 = _Uint8Array;

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer$3(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array$2(result).set(new Uint8Array$2(arrayBuffer));
  return result;
}

var _cloneArrayBuffer = cloneArrayBuffer$3;

var cloneArrayBuffer$2 = _cloneArrayBuffer;

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView$1(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer$2(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

var _cloneDataView = cloneDataView$1;

/** Used to match `RegExp` flags from their coerced string values. */

var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp$1(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

var _cloneRegExp = cloneRegExp$1;

var Symbol$2 = _Symbol;

/** Used to convert symbols to primitives and strings. */
var symbolProto$1 = Symbol$2 ? Symbol$2.prototype : undefined,
    symbolValueOf$1 = symbolProto$1 ? symbolProto$1.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol$1(symbol) {
  return symbolValueOf$1 ? Object(symbolValueOf$1.call(symbol)) : {};
}

var _cloneSymbol = cloneSymbol$1;

var cloneArrayBuffer$1 = _cloneArrayBuffer;

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray$2(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer$1(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

var _cloneTypedArray = cloneTypedArray$2;

var cloneArrayBuffer = _cloneArrayBuffer,
    cloneDataView = _cloneDataView,
    cloneRegExp = _cloneRegExp,
    cloneSymbol = _cloneSymbol,
    cloneTypedArray$1 = _cloneTypedArray;

/** `Object#toString` result references. */
var boolTag$2 = '[object Boolean]',
    dateTag$2 = '[object Date]',
    mapTag$4 = '[object Map]',
    numberTag$2 = '[object Number]',
    regexpTag$2 = '[object RegExp]',
    setTag$4 = '[object Set]',
    stringTag$2 = '[object String]',
    symbolTag$2 = '[object Symbol]';

var arrayBufferTag$2 = '[object ArrayBuffer]',
    dataViewTag$2 = '[object DataView]',
    float32Tag$1 = '[object Float32Array]',
    float64Tag$1 = '[object Float64Array]',
    int8Tag$1 = '[object Int8Array]',
    int16Tag$1 = '[object Int16Array]',
    int32Tag$1 = '[object Int32Array]',
    uint8Tag$1 = '[object Uint8Array]',
    uint8ClampedTag$1 = '[object Uint8ClampedArray]',
    uint16Tag$1 = '[object Uint16Array]',
    uint32Tag$1 = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag$1(object, tag, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag$2:
      return cloneArrayBuffer(object);

    case boolTag$2:
    case dateTag$2:
      return new Ctor(+object);

    case dataViewTag$2:
      return cloneDataView(object, isDeep);

    case float32Tag$1: case float64Tag$1:
    case int8Tag$1: case int16Tag$1: case int32Tag$1:
    case uint8Tag$1: case uint8ClampedTag$1: case uint16Tag$1: case uint32Tag$1:
      return cloneTypedArray$1(object, isDeep);

    case mapTag$4:
      return new Ctor;

    case numberTag$2:
    case stringTag$2:
      return new Ctor(object);

    case regexpTag$2:
      return cloneRegExp(object);

    case setTag$4:
      return new Ctor;

    case symbolTag$2:
      return cloneSymbol(object);
  }
}

var _initCloneByTag = initCloneByTag$1;

var isObject$8 = isObject_1;

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate$1 = (function() {
  function object() {}
  return function(proto) {
    if (!isObject$8(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

var _baseCreate = baseCreate$1;

var baseCreate = _baseCreate,
    getPrototype$1 = _getPrototype,
    isPrototype$2 = _isPrototype;

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject$2(object) {
  return (typeof object.constructor == 'function' && !isPrototype$2(object))
    ? baseCreate(getPrototype$1(object))
    : {};
}

var _initCloneObject = initCloneObject$2;

var getTag$5 = _getTag,
    isObjectLike$5 = isObjectLike_1;

/** `Object#toString` result references. */
var mapTag$3 = '[object Map]';

/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */
function baseIsMap$1(value) {
  return isObjectLike$5(value) && getTag$5(value) == mapTag$3;
}

var _baseIsMap = baseIsMap$1;

var baseIsMap = _baseIsMap,
    baseUnary$1 = _baseUnary,
    nodeUtil$1 = _nodeUtilExports;

/* Node.js helper references. */
var nodeIsMap = nodeUtil$1 && nodeUtil$1.isMap;

/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */
var isMap$1 = nodeIsMap ? baseUnary$1(nodeIsMap) : baseIsMap;

var isMap_1 = isMap$1;

var getTag$4 = _getTag,
    isObjectLike$4 = isObjectLike_1;

/** `Object#toString` result references. */
var setTag$3 = '[object Set]';

/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */
function baseIsSet$1(value) {
  return isObjectLike$4(value) && getTag$4(value) == setTag$3;
}

var _baseIsSet = baseIsSet$1;

var baseIsSet = _baseIsSet,
    baseUnary = _baseUnary,
    nodeUtil = _nodeUtilExports;

/* Node.js helper references. */
var nodeIsSet = nodeUtil && nodeUtil.isSet;

/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */
var isSet$1 = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

var isSet_1 = isSet$1;

var Stack$3 = _Stack,
    arrayEach$1 = _arrayEach,
    assignValue$1 = _assignValue,
    baseAssign = _baseAssign,
    baseAssignIn = _baseAssignIn,
    cloneBuffer$1 = _cloneBufferExports,
    copyArray$1 = _copyArray,
    copySymbols = _copySymbols,
    copySymbolsIn = _copySymbolsIn,
    getAllKeys$1 = _getAllKeys,
    getAllKeysIn$1 = _getAllKeysIn,
    getTag$3 = _getTag,
    initCloneArray = _initCloneArray,
    initCloneByTag = _initCloneByTag,
    initCloneObject$1 = _initCloneObject,
    isArray$7 = isArray_1,
    isBuffer$3 = isBufferExports,
    isMap = isMap_1,
    isObject$7 = isObject_1,
    isSet = isSet_1,
    keys$4 = keys_1,
    keysIn$2 = keysIn_1;

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG$1 = 1,
    CLONE_FLAT_FLAG$1 = 2,
    CLONE_SYMBOLS_FLAG$1 = 4;

/** `Object#toString` result references. */
var argsTag$1 = '[object Arguments]',
    arrayTag$1 = '[object Array]',
    boolTag$1 = '[object Boolean]',
    dateTag$1 = '[object Date]',
    errorTag$1 = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag$2 = '[object Map]',
    numberTag$1 = '[object Number]',
    objectTag$2 = '[object Object]',
    regexpTag$1 = '[object RegExp]',
    setTag$2 = '[object Set]',
    stringTag$1 = '[object String]',
    symbolTag$1 = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag$1 = '[object ArrayBuffer]',
    dataViewTag$1 = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag$1] = cloneableTags[arrayTag$1] =
cloneableTags[arrayBufferTag$1] = cloneableTags[dataViewTag$1] =
cloneableTags[boolTag$1] = cloneableTags[dateTag$1] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag$2] =
cloneableTags[numberTag$1] = cloneableTags[objectTag$2] =
cloneableTags[regexpTag$1] = cloneableTags[setTag$2] =
cloneableTags[stringTag$1] = cloneableTags[symbolTag$1] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag$1] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone$1(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG$1,
      isFlat = bitmask & CLONE_FLAT_FLAG$1,
      isFull = bitmask & CLONE_SYMBOLS_FLAG$1;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject$7(value)) {
    return value;
  }
  var isArr = isArray$7(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray$1(value, result);
    }
  } else {
    var tag = getTag$3(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer$3(value)) {
      return cloneBuffer$1(value, isDeep);
    }
    if (tag == objectTag$2 || tag == argsTag$1 || (isFunc && !object)) {
      result = (isFlat || isFunc) ? {} : initCloneObject$1(value);
      if (!isDeep) {
        return isFlat
          ? copySymbolsIn(value, baseAssignIn(result, value))
          : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack$3);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (isSet(value)) {
    value.forEach(function(subValue) {
      result.add(baseClone$1(subValue, bitmask, customizer, subValue, value, stack));
    });
  } else if (isMap(value)) {
    value.forEach(function(subValue, key) {
      result.set(key, baseClone$1(subValue, bitmask, customizer, key, value, stack));
    });
  }

  var keysFunc = isFull
    ? (isFlat ? getAllKeysIn$1 : getAllKeys$1)
    : (isFlat ? keysIn$2 : keys$4);

  var props = isArr ? undefined : keysFunc(value);
  arrayEach$1(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue$1(result, key, baseClone$1(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

var _baseClone = baseClone$1;

/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */

function last$1(array) {
  var length = array == null ? 0 : array.length;
  return length ? array[length - 1] : undefined;
}

var last_1 = last$1;

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */

function baseSlice$1(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

var _baseSlice = baseSlice$1;

var baseGet$2 = _baseGet,
    baseSlice = _baseSlice;

/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */
function parent$1(object, path) {
  return path.length < 2 ? object : baseGet$2(object, baseSlice(path, 0, -1));
}

var _parent = parent$1;

var castPath$1 = _castPath,
    last = last_1,
    parent = _parent,
    toKey$2 = _toKey;

/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */
function baseUnset$1(object, path) {
  path = castPath$1(path, object);
  object = parent(object, path);
  return object == null || delete object[toKey$2(last(path))];
}

var _baseUnset = baseUnset$1;

var baseGetTag = _baseGetTag,
    getPrototype = _getPrototype,
    isObjectLike$3 = isObjectLike_1;

/** `Object#toString` result references. */
var objectTag$1 = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto$4 = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty$4 = objectProto$4.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject$2(value) {
  if (!isObjectLike$3(value) || baseGetTag(value) != objectTag$1) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty$4.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

var isPlainObject_1 = isPlainObject$2;

var isPlainObject$1 = isPlainObject_1;

/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */
function customOmitClone$1(value) {
  return isPlainObject$1(value) ? undefined : value;
}

var _customOmitClone = customOmitClone$1;

var arrayMap = _arrayMap,
    baseClone = _baseClone,
    baseUnset = _baseUnset,
    castPath = _castPath,
    copyObject$2 = _copyObject,
    customOmitClone = _customOmitClone,
    flatRest = _flatRest,
    getAllKeysIn = _getAllKeysIn;

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */
var omit = flatRest(function(object, paths) {
  var result = {};
  if (object == null) {
    return result;
  }
  var isDeep = false;
  paths = arrayMap(paths, function(path) {
    path = castPath(path, object);
    isDeep || (isDeep = path.length > 1);
    return path;
  });
  copyObject$2(object, getAllKeysIn(object), result);
  if (isDeep) {
    result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
  }
  var length = paths.length;
  while (length--) {
    baseUnset(result, paths[length]);
  }
  return result;
});

var omit_1 = omit;

const omit$1 = omit_1;

function useAttributesAndProps(only = [], except = []) {
  const vm = getCurrentInstance();
  const props = Object.fromEntries(Object.entries(unref(vm.props)).filter(([v]) => v != null && v !== void 0));
  const attrs = Object.fromEntries(Object.entries(unref(vm.attrs)).filter(([v]) => v != null && v !== void 0));
  let merge = {
    ...props,
    ...attrs
  };
  if (only.length) {
    merge = pick$1(merge, only);
  }
  if (except.length) {
    merge = omit$1(merge, except);
  }
  const blacklist = ["variant", "variants", "classes", "variants"];
  return omit$1(merge, blacklist);
}

function useFetchsOptions(localValue, options, textAttribute, valueAttribute, normalize, searchQuery, fetchFn, prefetchFn, fetchDelay, fetchMinimumInputLength, fetchMinimumInputLengthText) {
  const { emit } = getCurrentInstance();
  const getNormalizedOptions = (rawOptions) => normalize.value ? normalizeOptions$1(rawOptions, textAttribute.value, valueAttribute.value) : rawOptions;
  const fetchedOptions = ref(getNormalizedOptions(options.value || []));
  watch(options, () => {
    fetchedOptions.value = getNormalizedOptions(options.value || []);
  });
  const optionsWereFetched = ref(false);
  const normalizedOptions = computed(() => {
    if (typeof fetchFn.value !== "function" && typeof prefetchFn.value !== "function") {
      const normalized = getNormalizedOptions(options.value || []);
      if (searchQuery.value) {
        return filterOptions$1(normalized, searchQuery.value);
      }
      return normalized;
    }
    return fetchedOptions.value;
  });
  const flattenedOptions = computed(() => flattenOptions$1(normalizedOptions.value));
  const fetchsOptions = computed(() => fetchFn.value !== void 0);
  const needsMoreCharsToFetch = computed(() => {
    if (!fetchsOptions.value) {
      return false;
    }
    if (!fetchMinimumInputLength.value) {
      return false;
    }
    return !searchQuery.value || searchQuery.value.length < fetchMinimumInputLength.value;
  });
  const fetchNextPage = ref(void 0);
  const fetchingOptions = ref(false);
  const fetchingMoreOptions = ref(false);
  const fetchedOptionsHaveMorePages = computed(() => fetchNextPage.value !== void 0);
  const fetchOptionsFn = ([nextPage]) => {
    fetchFn.value(searchQuery.value, nextPage).then((response) => {
      if (typeof response === "object" && Object.prototype.hasOwnProperty.call(response, "results")) {
        const {
          results,
          hasMorePages
        } = response;
        if (!Array.isArray(results) && results !== void 0 && typeof results !== "object") {
          throw new Error(`Response.results must be an array or object, got ${typeof results}`);
        }
        if (nextPage !== void 0 && nextPage >= 2) {
          fetchedOptions.value = fetchedOptions.value.concat(getNormalizedOptions(results));
        } else {
          fetchedOptions.value = getNormalizedOptions(results);
        }
        if (hasMorePages) {
          fetchNextPage.value = fetchNextPage.value === void 0 ? 2 : fetchNextPage.value + 1;
        } else {
          fetchNextPage.value = void 0;
        }
      } else {
        throw new Error("Options response must be an object with `results` property.");
      }
      optionsWereFetched.value = true;
      emit("fetchOptionsSuccess", response);
    }).catch((error) => {
      console.log("Failed to Fetch", error);
      emit("fetchOptionsError", error);
    }).then(() => {
      fetchingOptions.value = false;
      fetchingMoreOptions.value = false;
    });
  };
  const debouncedFetchOptions = debounce$3(fetchOptionsFn, fetchDelay.value);
  const fetchOptionsCancel = () => {
    debouncedFetchOptions.cancel();
    fetchingOptions.value = false;
    fetchingMoreOptions.value = false;
  };
  const fetchOptions = (nextPage) => {
    if (!fetchsOptions.value) {
      fetchOptionsCancel();
      return;
    }
    if (nextPage !== void 0 && nextPage >= 2) {
      fetchingMoreOptions.value = true;
    } else {
      fetchingOptions.value = true;
    }
    debouncedFetchOptions(nextPage);
  };
  const fetchMoreOptions = () => {
    fetchOptions(fetchNextPage.value);
  };
  watch(searchQuery, () => {
    if (!fetchsOptions.value || needsMoreCharsToFetch.value) {
      return;
    }
    optionsWereFetched.value = false;
    fetchOptions();
  });
  const needsMoreCharsMessage = computed(() => {
    if (typeof fetchMinimumInputLengthText.value === "string") {
      return fetchMinimumInputLengthText.value;
    }
    return fetchMinimumInputLengthText.value(fetchMinimumInputLength.value, searchQuery.value);
  });
  const prefetchOptions = () => {
    if (typeof prefetchFn.value !== "function") {
      fetchOptions();
      return;
    }
    fetchingOptions.value = true;
    prefetchFn.value(localValue.value).then((results) => {
      if (!Array.isArray(results) && results !== void 0 && typeof results !== "object") {
        throw new Error(`Response must be an array or object, got ${typeof results}`);
      }
      fetchedOptions.value = getNormalizedOptions(results);
      optionsWereFetched.value = true;
      emit("fetchOptionsSuccess", results);
    }).catch((error) => {
      console.log("Failed to Fetch", error);
      emit("fetchOptionsError", error);
    }).then(() => {
      fetchingOptions.value = false;
    });
  };
  return {
    normalizedOptions,
    flattenedOptions,
    fetchsOptions,
    needsMoreCharsToFetch,
    needsMoreCharsMessage,
    fetchingOptions,
    fetchingMoreOptions,
    fetchedOptionsHaveMorePages,
    optionsWereFetched,
    fetchOptions,
    prefetchOptions,
    fetchMoreOptions,
    fetchOptionsCancel
  };
}

function useInjectsClassesList(key = "configuration_vanilla") {
  const configuration = useInjectsConfiguration(key);
  return computed(() => configuration.classesList || {});
}

function useInjectsClassesListClass(property) {
  const configuration = useInjectsConfiguration();
  return computed(() => get$4(configuration.classesList, property, ""));
}

function useInjectsConfiguration(key = "configuration_vanilla") {
  return inject(key, {});
}

const useVariantProps = () => ({
  classes: {
    type: [String, Array, Object],
    default: void 0
  },
  fixedClasses: {
    type: [String, Array, Object],
    default: void 0
  },
  variants: {
    type: Object,
    default: void 0
  },
  variant: {
    type: String,
    default: void 0
  },
  variantError: {
    type: String,
    default: "error"
  },
  errors: {
    type: [String, void 0],
    default: void 0
  },
  feedback: {
    type: [String],
    default: void 0
  },
  name: {
    type: [String],
    required: false,
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    default(props) {
      return useDefaultName(props);
    }
  },
  autocomplete: {
    required: false,
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    default(props) {
      return props.name || false;
    }
  },
  hasItemBelow: {
    type: Boolean,
    default: false,
    required: false
  },
  hasItemAbove: {
    type: Boolean,
    default: false,
    required: false
  },
  rounded: {
    type: String,
    default: "full",
    required: false
  },
  showErrors: {
    type: Boolean,
    default: true,
    required: false
  },
  showFeedback: {
    type: Boolean,
    default: true,
    required: false
  },
  disabled: {
    type: Boolean,
    default: false,
    required: false
  }
});
const useVariantProps$1 = useVariantProps;

function useVModel(props, key) {
  const vm = getCurrentInstance();
  const localValue = ref(props[key]);
  watch(localValue, (value) => {
    if (props.disabled) {
      return;
    }
    vm?.emit(`update:${key}`, value);
  });
  watch(() => props[key], (value) => {
    localValue.value = value;
  });
  return localValue;
}

function useMultipleOptions(options, textAttribute, valueAttribute, normalize) {
  const normalizedOptions = computed(() => {
    if (!normalize.value) {
      return options.value;
    }
    return normalizeOptions$1(
      options.value,
      textAttribute.value,
      valueAttribute.value
    );
  });
  const flattenedOptions = computed(() => flattenOptions$1(normalizedOptions.value));
  return {
    normalizedOptions,
    flattenedOptions
  };
}

function useMultipleVModel(props, key, multiple) {
  const vm = getCurrentInstance();
  const isMultiple = computed(() => multiple === void 0 ? false : multiple !== null && true && multiple !== false);
  const getDefaultValue = () => {
    if (isMultiple.value) {
      return [];
    }
    return void 0;
  };
  const initialValue = props[key];
  const localValue = ref(initialValue === void 0 ? getDefaultValue() : initialValue);
  watch(localValue, (value) => {
    if (props.disabled) {
      return;
    }
    vm?.emit(`update:${key}`, value);
  });
  watch(() => props[key], (value) => {
    localValue.value = value;
  });
  const clearValue = () => {
    if (props.disabled) {
      return;
    }
    localValue.value = getDefaultValue();
  };
  watch(isMultiple, () => {
    clearValue();
  });
  return {
    localValue,
    clearValue
  };
}

const getCustomPropsFromVariant = (variants, variant) => {
  if (variant !== void 0 && variants) {
    return variants[variant];
  }
  return void 0;
};
const getShouldClearClasses = (props, key, variant) => {
  if (variant === void 0) {
    return hasProperty$1(props, key) && (props[key] === void 0 || props[key] === null);
  }
  if (props.variants !== void 0 && props.variants[variant] !== void 0) {
    const propsVariant = props.variants[variant];
    return hasProperty$1(propsVariant, key) && (propsVariant[key] === void 0 || propsVariant[key] === null);
  }
  return false;
};
const useParseVariant = (props, classesListKeys, globalConfiguration, defaultConfiguration, givenVariant) => {
  const { variants, variant, ...mainProps } = {
    ...defaultConfiguration,
    ...globalConfiguration,
    ...props
  };
  const localVariant = ref(givenVariant ?? variant);
  const classes = {};
  const fixedClasses = {};
  const clearClasses = getShouldClearClasses(props, "classes", localVariant.value);
  const clearFixedClasses = getShouldClearClasses(props, "fixedClasses", localVariant.value);
  if (clearClasses) {
    classesListKeys.forEach((classItemKey) => {
      classes[classItemKey] = void 0;
    });
  } else {
    classesListKeys.forEach((classItemKey) => {
      if (props.classes !== void 0 && hasProperty$1(props.classes, classItemKey)) {
        classes[classItemKey] = props.classes[classItemKey];
      } else if (globalConfiguration !== void 0 && globalConfiguration.classes !== void 0 && hasProperty$1(globalConfiguration.classes, classItemKey)) {
        classes[classItemKey] = globalConfiguration.classes[classItemKey];
      } else if (defaultConfiguration !== void 0 && defaultConfiguration.classes !== void 0 && hasProperty$1(defaultConfiguration.classes, classItemKey)) {
        classes[classItemKey] = defaultConfiguration.classes[classItemKey];
      }
      if (localVariant.value) {
        if (props.variants !== void 0 && props.variants[localVariant.value] !== void 0) {
          const propsVariant = props.variants[localVariant.value];
          if (propsVariant.classes && hasProperty$1(propsVariant.classes, classItemKey)) {
            classes[classItemKey] = propsVariant.classes[classItemKey];
          }
        } else if (globalConfiguration !== void 0 && globalConfiguration.variants !== void 0 && globalConfiguration.variants[localVariant.value] !== void 0) {
          const globalConfigurationVariant = globalConfiguration.variants[localVariant.value];
          if (globalConfigurationVariant.classes && hasProperty$1(globalConfigurationVariant.classes, classItemKey)) {
            classes[classItemKey] = globalConfigurationVariant.classes[classItemKey];
          }
        } else if (defaultConfiguration !== void 0 && defaultConfiguration.variants !== void 0 && defaultConfiguration.variants[localVariant.value] !== void 0) {
          const defaultConfigurationVariant = defaultConfiguration.variants[localVariant.value];
          if (defaultConfigurationVariant.classes && hasProperty$1(defaultConfigurationVariant.classes, classItemKey)) {
            classes[classItemKey] = defaultConfigurationVariant.classes[classItemKey];
          }
        }
      }
      if (props.classes !== void 0 && hasProperty$1(props.classes, classItemKey)) {
        classes[classItemKey] = props.classes[classItemKey];
      }
    });
  }
  if (clearFixedClasses) {
    classesListKeys.forEach((classItemKey) => {
      fixedClasses[classItemKey] = void 0;
    });
  } else {
    classesListKeys.forEach((classItemKey) => {
      if (props.fixedClasses !== void 0 && hasProperty$1(props.fixedClasses, classItemKey)) {
        fixedClasses[classItemKey] = props.fixedClasses[classItemKey];
      } else if (globalConfiguration !== void 0 && globalConfiguration.fixedClasses !== void 0 && hasProperty$1(globalConfiguration.fixedClasses, classItemKey)) {
        fixedClasses[classItemKey] = globalConfiguration.fixedClasses[classItemKey];
      } else if (defaultConfiguration !== void 0 && defaultConfiguration.fixedClasses !== void 0 && hasProperty$1(defaultConfiguration.fixedClasses, classItemKey)) {
        fixedClasses[classItemKey] = defaultConfiguration.fixedClasses[classItemKey];
      }
      if (localVariant.value) {
        if (props.variants !== void 0 && props.variants[localVariant.value] !== void 0) {
          const propsVariant = props.variants[localVariant.value];
          if (propsVariant.fixedClasses && hasProperty$1(propsVariant.fixedClasses, classItemKey)) {
            fixedClasses[classItemKey] = propsVariant.fixedClasses[classItemKey];
          }
        } else if (globalConfiguration !== void 0 && globalConfiguration.variants !== void 0 && globalConfiguration.variants[localVariant.value] !== void 0) {
          const globalConfigurationVariant = globalConfiguration.variants[localVariant.value];
          if (globalConfigurationVariant.fixedClasses && hasProperty$1(globalConfigurationVariant.fixedClasses, classItemKey)) {
            fixedClasses[classItemKey] = globalConfigurationVariant.fixedClasses[classItemKey];
          }
        } else if (defaultConfiguration !== void 0 && defaultConfiguration.variants !== void 0 && defaultConfiguration.variants[localVariant.value] !== void 0) {
          const defaultConfigurationVariant = defaultConfiguration.variants[localVariant.value];
          if (defaultConfigurationVariant.fixedClasses && hasProperty$1(defaultConfigurationVariant.fixedClasses, classItemKey)) {
            fixedClasses[classItemKey] = defaultConfigurationVariant.fixedClasses[classItemKey];
          }
        }
      }
    });
  }
  const customProps = getCustomPropsFromVariant(variants, localVariant.value);
  const mergedProps = {
    ...mainProps,
    ...customProps
  };
  delete mergedProps.fixedClasses;
  delete mergedProps.classes;
  const mergedClasses = {};
  classesListKeys.forEach((classItemKey) => {
    const classesForTheCurrentKey = classes[classItemKey];
    const fixedClassesForTheCurrentKey = fixedClasses[classItemKey];
    if (isObject$e(classesForTheCurrentKey)) {
      mergedClasses[classItemKey] = mergeClassesFromObject(
        fixedClassesForTheCurrentKey,
        classesForTheCurrentKey
      );
    } else {
      mergedClasses[classItemKey] = mergeClasses(
        fixedClassesForTheCurrentKey,
        classesForTheCurrentKey
      );
      if (mergedClasses[classItemKey]) {
        mergedClasses[classItemKey] = removeClassesBeforeResetDirect(mergedClasses[classItemKey]);
      }
    }
  });
  const result = pick$3(mergedClasses);
  if (Object.keys(result).length > 0) {
    mergedProps.classesList = result;
  }
  return mergedProps;
};
const useParseVariant$1 = useParseVariant;

function useDefaultName(props) {
  const vm = getCurrentInstance();
  let localName = uniqueId("vc-component-");
  if (props.name === void 0 && vm?.parent?.props?.name !== void 0 && vm?.parent?.type?.name === "VanillaInputGroup" && vm?.type.name !== "VanillaInputGroup" && vm?.type.name !== "VanillaFormLabel") {
    localName = vm.parent?.props?.name;
    return localName || uniqueId("vc-component-");
  }
  return localName;
}

function useDynamicSlots(prefix, slotName) {
  const lowercaseColumnName = slotName.toLowerCase();
  return camelize(prefix + capitalize(lowercaseColumnName.replace(/\.|\_/g, "-")));
}

/*!
 * cookie
 * Copyright(c) 2012-2014 Roman Shtylman
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */

/**
 * Module exports.
 * @public
 */

var parse_1 = parse$1;
var serialize_1 = serialize;

/**
 * Module variables.
 * @private
 */

var decode = decodeURIComponent;
var encode = encodeURIComponent;

/**
 * RegExp to match field-content in RFC 7230 sec 3.2
 *
 * field-content = field-vchar [ 1*( SP / HTAB ) field-vchar ]
 * field-vchar   = VCHAR / obs-text
 * obs-text      = %x80-FF
 */

var fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;

/**
 * Parse a cookie header.
 *
 * Parse the given cookie header string into an object
 * The object has the various cookies as keys(names) => values
 *
 * @param {string} str
 * @param {object} [options]
 * @return {object}
 * @public
 */

function parse$1(str, options) {
  if (typeof str !== 'string') {
    throw new TypeError('argument str must be a string');
  }

  var obj = {};
  var opt = options || {};
  var pairs = str.split(';');
  var dec = opt.decode || decode;

  for (var i = 0; i < pairs.length; i++) {
    var pair = pairs[i];
    var index = pair.indexOf('=');

    // skip things that don't look like key=value
    if (index < 0) {
      continue;
    }

    var key = pair.substring(0, index).trim();

    // only assign once
    if (undefined == obj[key]) {
      var val = pair.substring(index + 1, pair.length).trim();

      // quoted values
      if (val[0] === '"') {
        val = val.slice(1, -1);
      }

      obj[key] = tryDecode(val, dec);
    }
  }

  return obj;
}

/**
 * Serialize data into a cookie header.
 *
 * Serialize the a name value pair into a cookie string suitable for
 * http headers. An optional options object specified cookie parameters.
 *
 * serialize('foo', 'bar', { httpOnly: true })
 *   => "foo=bar; httpOnly"
 *
 * @param {string} name
 * @param {string} val
 * @param {object} [options]
 * @return {string}
 * @public
 */

function serialize(name, val, options) {
  var opt = options || {};
  var enc = opt.encode || encode;

  if (typeof enc !== 'function') {
    throw new TypeError('option encode is invalid');
  }

  if (!fieldContentRegExp.test(name)) {
    throw new TypeError('argument name is invalid');
  }

  var value = enc(val);

  if (value && !fieldContentRegExp.test(value)) {
    throw new TypeError('argument val is invalid');
  }

  var str = name + '=' + value;

  if (null != opt.maxAge) {
    var maxAge = opt.maxAge - 0;

    if (isNaN(maxAge) || !isFinite(maxAge)) {
      throw new TypeError('option maxAge is invalid')
    }

    str += '; Max-Age=' + Math.floor(maxAge);
  }

  if (opt.domain) {
    if (!fieldContentRegExp.test(opt.domain)) {
      throw new TypeError('option domain is invalid');
    }

    str += '; Domain=' + opt.domain;
  }

  if (opt.path) {
    if (!fieldContentRegExp.test(opt.path)) {
      throw new TypeError('option path is invalid');
    }

    str += '; Path=' + opt.path;
  }

  if (opt.expires) {
    if (typeof opt.expires.toUTCString !== 'function') {
      throw new TypeError('option expires is invalid');
    }

    str += '; Expires=' + opt.expires.toUTCString();
  }

  if (opt.httpOnly) {
    str += '; HttpOnly';
  }

  if (opt.secure) {
    str += '; Secure';
  }

  if (opt.sameSite) {
    var sameSite = typeof opt.sameSite === 'string'
      ? opt.sameSite.toLowerCase() : opt.sameSite;

    switch (sameSite) {
      case true:
        str += '; SameSite=Strict';
        break;
      case 'lax':
        str += '; SameSite=Lax';
        break;
      case 'strict':
        str += '; SameSite=Strict';
        break;
      case 'none':
        str += '; SameSite=None';
        break;
      default:
        throw new TypeError('option sameSite is invalid');
    }
  }

  return str;
}

/**
 * Try decoding a string using a decoding function.
 *
 * @param {string} str
 * @param {function} decode
 * @private
 */

function tryDecode(str, decode) {
  try {
    return decode(str);
  } catch (e) {
    return str;
  }
}

function hasDocumentCookie() {
    // Can we get/set cookies on document.cookie?
    return typeof document === 'object' && typeof document.cookie === 'string';
}
function parseCookies(cookies, options) {
    if (typeof cookies === 'string') {
        return parse_1(cookies, options);
    }
    else if (typeof cookies === 'object' && cookies !== null) {
        return cookies;
    }
    else {
        return {};
    }
}
function isParsingCookie(value, doNotParse) {
    if (typeof doNotParse === 'undefined') {
        // We guess if the cookie start with { or [, it has been serialized
        doNotParse =
            !value || (value[0] !== '{' && value[0] !== '[' && value[0] !== '"');
    }
    return !doNotParse;
}
function readCookie(value, options) {
    if (options === void 0) { options = {}; }
    var cleanValue = cleanupCookieValue(value);
    if (isParsingCookie(cleanValue, options.doNotParse)) {
        try {
            return JSON.parse(cleanValue);
        }
        catch (e) {
            // At least we tried
        }
    }
    // Ignore clean value if we failed the deserialization
    // It is not relevant anymore to trim those values
    return value;
}
function cleanupCookieValue(value) {
    // express prepend j: before serializing a cookie
    if (value && value[0] === 'j' && value[1] === ':') {
        return value.substr(2);
    }
    return value;
}

var __assign$1 = (globalThis && globalThis.__assign) || function () {
    __assign$1 = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$1.apply(this, arguments);
};
var Cookies = /** @class */ (function () {
    function Cookies(cookies, options) {
        var _this = this;
        this.changeListeners = [];
        this.HAS_DOCUMENT_COOKIE = false;
        this.cookies = parseCookies(cookies, options);
        new Promise(function () {
            _this.HAS_DOCUMENT_COOKIE = hasDocumentCookie();
        }).catch(function () { });
    }
    Cookies.prototype._updateBrowserValues = function (parseOptions) {
        if (!this.HAS_DOCUMENT_COOKIE) {
            return;
        }
        this.cookies = parse_1(document.cookie, parseOptions);
    };
    Cookies.prototype._emitChange = function (params) {
        for (var i = 0; i < this.changeListeners.length; ++i) {
            this.changeListeners[i](params);
        }
    };
    Cookies.prototype.get = function (name, options, parseOptions) {
        if (options === void 0) { options = {}; }
        this._updateBrowserValues(parseOptions);
        return readCookie(this.cookies[name], options);
    };
    Cookies.prototype.getAll = function (options, parseOptions) {
        if (options === void 0) { options = {}; }
        this._updateBrowserValues(parseOptions);
        var result = {};
        for (var name_1 in this.cookies) {
            result[name_1] = readCookie(this.cookies[name_1], options);
        }
        return result;
    };
    Cookies.prototype.set = function (name, value, options) {
        var _a;
        if (typeof value === 'object') {
            value = JSON.stringify(value);
        }
        this.cookies = __assign$1(__assign$1({}, this.cookies), (_a = {}, _a[name] = value, _a));
        if (this.HAS_DOCUMENT_COOKIE) {
            document.cookie = serialize_1(name, value, options);
        }
        this._emitChange({ name: name, value: value, options: options });
    };
    Cookies.prototype.remove = function (name, options) {
        var finalOptions = (options = __assign$1(__assign$1({}, options), { expires: new Date(1970, 1, 1, 0, 0, 1), maxAge: 0 }));
        this.cookies = __assign$1({}, this.cookies);
        delete this.cookies[name];
        if (this.HAS_DOCUMENT_COOKIE) {
            document.cookie = serialize_1(name, '', finalOptions);
        }
        this._emitChange({ name: name, value: undefined, options: options });
    };
    Cookies.prototype.addChangeListener = function (callback) {
        this.changeListeners.push(callback);
    };
    Cookies.prototype.removeChangeListener = function (callback) {
        var idx = this.changeListeners.indexOf(callback);
        if (idx >= 0) {
            this.changeListeners.splice(idx, 1);
        }
    };
    return Cookies;
}());
const Cookies$1 = Cookies;

var __defProp$1 = Object.defineProperty;
var __getOwnPropSymbols$1 = Object.getOwnPropertySymbols;
var __hasOwnProp$1 = Object.prototype.hasOwnProperty;
var __propIsEnum$1 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1 = (obj, key, value) => key in obj ? __defProp$1(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1.call(b, prop))
      __defNormalProp$1(a, prop, b[prop]);
  if (__getOwnPropSymbols$1)
    for (var prop of __getOwnPropSymbols$1(b)) {
      if (__propIsEnum$1.call(b, prop))
        __defNormalProp$1(a, prop, b[prop]);
    }
  return a;
};
function useCookies(dependencies, { doNotParse = false, autoUpdateDependencies = false } = {}, cookies = new Cookies$1()) {
  const watchingDependencies = autoUpdateDependencies ? [...dependencies || []] : dependencies;
  let previousCookies = cookies.getAll({ doNotParse: true });
  const touches = ref(0);
  const onChange = () => {
    const newCookies = cookies.getAll({ doNotParse: true });
    if (shouldUpdate(
      watchingDependencies || null,
      newCookies,
      previousCookies
    ))
      touches.value++;
    previousCookies = newCookies;
  };
  cookies.addChangeListener(onChange);
  tryOnScopeDispose(() => {
    cookies.removeChangeListener(onChange);
  });
  return {
    /**
     * Reactive get cookie by name. If **autoUpdateDependencies = true** then it will update watching dependencies
     */
    get: (...args) => {
      if (autoUpdateDependencies && watchingDependencies && !watchingDependencies.includes(args[0]))
        watchingDependencies.push(args[0]);
      touches.value;
      return cookies.get(args[0], __spreadValues$1({ doNotParse }, args[1]));
    },
    /**
     * Reactive get all cookies
     */
    getAll: (...args) => {
      touches.value;
      return cookies.getAll(__spreadValues$1({ doNotParse }, args[0]));
    },
    set: (...args) => cookies.set(...args),
    remove: (...args) => cookies.remove(...args),
    addChangeListener: (...args) => cookies.addChangeListener(...args),
    removeChangeListener: (...args) => cookies.removeChangeListener(...args)
  };
}
function shouldUpdate(dependencies, newCookies, oldCookies) {
  if (!dependencies)
    return true;
  for (const dependency of dependencies) {
    if (newCookies[dependency] !== oldCookies[dependency])
      return true;
  }
  return false;
}

var baseAssignValue = _baseAssignValue,
    eq$2 = eq_1;

/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue$2(object, key, value) {
  if ((value !== undefined && !eq$2(object[key], value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

var _assignMergeValue = assignMergeValue$2;

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */

function createBaseFor$1(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

var _createBaseFor = createBaseFor$1;

var createBaseFor = _createBaseFor;

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor$2 = createBaseFor();

var _baseFor = baseFor$2;

var isArrayLike$5 = isArrayLike_1,
    isObjectLike$2 = isObjectLike_1;

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject$1(value) {
  return isObjectLike$2(value) && isArrayLike$5(value);
}

var isArrayLikeObject_1 = isArrayLikeObject$1;

/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */

function safeGet$2(object, key) {
  if (key === 'constructor' && typeof object[key] === 'function') {
    return;
  }

  if (key == '__proto__') {
    return;
  }

  return object[key];
}

var _safeGet = safeGet$2;

var copyObject$1 = _copyObject,
    keysIn$1 = keysIn_1;

/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject$1(value) {
  return copyObject$1(value, keysIn$1(value));
}

var toPlainObject_1 = toPlainObject$1;

var assignMergeValue$1 = _assignMergeValue,
    cloneBuffer = _cloneBufferExports,
    cloneTypedArray = _cloneTypedArray,
    copyArray = _copyArray,
    initCloneObject = _initCloneObject,
    isArguments$1 = isArguments_1,
    isArray$6 = isArray_1,
    isArrayLikeObject = isArrayLikeObject_1,
    isBuffer$2 = isBufferExports,
    isFunction = isFunction_1,
    isObject$6 = isObject_1,
    isPlainObject = isPlainObject_1,
    isTypedArray$2 = isTypedArray_1,
    safeGet$1 = _safeGet,
    toPlainObject = toPlainObject_1;

/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep$1(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = safeGet$1(object, key),
      srcValue = safeGet$1(source, key),
      stacked = stack.get(srcValue);

  if (stacked) {
    assignMergeValue$1(object, key, stacked);
    return;
  }
  var newValue = customizer
    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
    : undefined;

  var isCommon = newValue === undefined;

  if (isCommon) {
    var isArr = isArray$6(srcValue),
        isBuff = !isArr && isBuffer$2(srcValue),
        isTyped = !isArr && !isBuff && isTypedArray$2(srcValue);

    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (isArray$6(objValue)) {
        newValue = objValue;
      }
      else if (isArrayLikeObject(objValue)) {
        newValue = copyArray(objValue);
      }
      else if (isBuff) {
        isCommon = false;
        newValue = cloneBuffer(srcValue, true);
      }
      else if (isTyped) {
        isCommon = false;
        newValue = cloneTypedArray(srcValue, true);
      }
      else {
        newValue = [];
      }
    }
    else if (isPlainObject(srcValue) || isArguments$1(srcValue)) {
      newValue = objValue;
      if (isArguments$1(objValue)) {
        newValue = toPlainObject(objValue);
      }
      else if (!isObject$6(objValue) || isFunction(objValue)) {
        newValue = initCloneObject(srcValue);
      }
    }
    else {
      isCommon = false;
    }
  }
  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }
  assignMergeValue$1(object, key, newValue);
}

var _baseMergeDeep = baseMergeDeep$1;

var Stack$2 = _Stack,
    assignMergeValue = _assignMergeValue,
    baseFor$1 = _baseFor,
    baseMergeDeep = _baseMergeDeep,
    isObject$5 = isObject_1,
    keysIn = keysIn_1,
    safeGet = _safeGet;

/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge$1(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  baseFor$1(source, function(srcValue, key) {
    stack || (stack = new Stack$2);
    if (isObject$5(srcValue)) {
      baseMergeDeep(object, source, key, srcIndex, baseMerge$1, customizer, stack);
    }
    else {
      var newValue = customizer
        ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
        : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }
      assignMergeValue(object, key, newValue);
    }
  }, keysIn);
}

var _baseMerge = baseMerge$1;

var identity$2 = identity_1,
    overRest = _overRest,
    setToString = _setToString;

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest$1(func, start) {
  return setToString(overRest(func, start, identity$2), func + '');
}

var _baseRest = baseRest$1;

var eq$1 = eq_1,
    isArrayLike$4 = isArrayLike_1,
    isIndex = _isIndex,
    isObject$4 = isObject_1;

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall$1(value, index, object) {
  if (!isObject$4(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike$4(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq$1(object[index], value);
  }
  return false;
}

var _isIterateeCall = isIterateeCall$1;

var baseRest = _baseRest,
    isIterateeCall = _isIterateeCall;

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner$2(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

var _createAssigner = createAssigner$2;

var baseMerge = _baseMerge,
    createAssigner$1 = _createAssigner;

/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */
var merge = createAssigner$1(function(object, source, srcIndex) {
  baseMerge(object, source, srcIndex);
});

var merge_1 = merge;

const merge$1 = merge_1;

function useFetchData$1(url, query = null, options = {}) {
  const token = useCookies().get("XSRF-TOKEN");
  const finalUrl = urlHelper(url, query);
  const finalOptions = merge$1({
    headers: {
      "Content-Type": "application/json",
      "Accept": "application/json",
      "X-Requested-With": "XMLHttpRequest",
      "X-XSRF-TOKEN": token ? decodeURIComponent(token) : ""
    },
    credentials: "include",
    ...options
  });
  return fetch(finalUrl, finalOptions).then((response) => response.json());
}

function useReplacePlaceholders(translation, replace = {}) {
  if (typeof translation === "object" || Object.keys(replace).length === 0 && replace.constructor === Object) {
    return translation;
  }
  for (const placeholder in replace) {
    try {
      translation = translation.toString().replace(`:${placeholder}`, replace[placeholder]).replace(`:${placeholder.toUpperCase()}`, replace[placeholder].toString().toUpperCase()).replace(`:${placeholder.charAt(0).toUpperCase()}${placeholder.slice(1)}`, replace[placeholder].toString().charAt(0).toUpperCase() + replace[placeholder].toString().slice(1));
    } catch (e) {
    }
  }
  return translation.toString().trim();
}

function useActivableOption(options, localValue) {
  const getActiveOption = () => {
    const selectedOption = options.value.find((option) => isEqual$1(option.value, localValue.value) && !normalizedOptionIsDisabled$1(option));
    if (selectedOption !== void 0) {
      return selectedOption;
    }
    if (options.value.length > 0) {
      return options.value.find((option) => !normalizedOptionIsDisabled$1(option)) || null;
    }
    return null;
  };
  const activeOption = ref(getActiveOption());
  const activeOptionIndex = computed(() => {
    if (activeOption.value === null) {
      return 0;
    }
    const index = options.value.findIndex((option) => isEqual$1(option.value, activeOption.value.value));
    return index < 0 ? 0 : index;
  });
  const optionIsActive = (option) => activeOption.value === null ? false : isEqual$1(activeOption.value.value, option.value);
  const setActiveOption = (option) => {
    activeOption.value = option;
  };
  const setNextOptionActive = () => {
    let newActiveOption;
    let nextIndex = activeOptionIndex.value + 1;
    while (nextIndex < options.value.length && newActiveOption === void 0) {
      const option = options.value[nextIndex];
      const optionIsDisabled = normalizedOptionIsDisabled$1(option);
      if (!optionIsDisabled) {
        newActiveOption = option;
      }
      nextIndex += 1;
    }
    if (newActiveOption) {
      setActiveOption(newActiveOption);
    }
  };
  const setPrevOptionActive = () => {
    let newActiveOption;
    let nextIndex = activeOptionIndex.value - 1;
    while (nextIndex >= 0 && newActiveOption === void 0) {
      const option = options.value[nextIndex];
      const optionIsDisabled = normalizedOptionIsDisabled$1(option);
      if (!optionIsDisabled) {
        newActiveOption = option;
      }
      nextIndex -= 1;
    }
    if (newActiveOption) {
      setActiveOption(newActiveOption);
    }
  };
  const initActiveOption = () => {
    activeOption.value = getActiveOption();
  };
  watch(options, (newOptions, oldOptions) => {
    const firstNewOption = newOptions.find((o) => !oldOptions.includes(o) && !normalizedOptionIsDisabled$1(o));
    if (firstNewOption) {
      setActiveOption(firstNewOption);
    } else {
      initActiveOption();
    }
  });
  return {
    activeOption,
    initActiveOption,
    optionIsActive,
    setActiveOption,
    setNextOptionActive,
    setPrevOptionActive
  };
}

function useSelectableOption(options, localValue, multiple, clearable) {
  const optionIsSelected = (option) => {
    if (multiple.value) {
      return Array.isArray(localValue.value) && localValue.value.some(
        (value) => isEqual$1(value, option.value) || (isNumber$3(value) || isNumber$3(option.value)) && isEqual$1(value.toString(), option.value?.toString())
      );
    }
    return isEqual$1(localValue.value, option.value);
  };
  const getSelectedOption = (currentSelectedOption) => {
    let allOptions = options.value;
    if (Array.isArray(currentSelectedOption)) {
      allOptions = allOptions.filter((option) => !currentSelectedOption.some((selectedOption2) => isEqual$1(selectedOption2.value, option.value))).concat(currentSelectedOption);
    } else if (currentSelectedOption !== void 0) {
      allOptions = allOptions.filter((option) => !isEqual$1(currentSelectedOption.value, option.value)).concat([currentSelectedOption]);
    }
    if (multiple.value) {
      if (Array.isArray(localValue.value)) {
        return allOptions.filter((option) => optionIsSelected(option));
      }
      return [];
    }
    return allOptions.find((option) => optionIsSelected(option));
  };
  const selectedOption = ref(getSelectedOption());
  const selectOption = (option) => {
    if (optionIsSelected(option)) {
      return;
    }
    if (multiple.value) {
      if (Array.isArray(localValue.value)) {
        localValue.value = addToArray$1(localValue.value, option.value);
        selectedOption.value = addToArray$1(selectedOption.value, option);
      } else {
        localValue.value = [option.value];
        selectedOption.value = [option];
      }
    } else {
      localValue.value = option.value;
      selectedOption.value = option;
    }
  };
  const toggleOption = (option) => {
    if (!multiple.value && !clearable.value && localValue.value === option.value) {
      return;
    }
    if (optionIsSelected(option)) {
      if (multiple.value) {
        localValue.value = subtractFromArray$1(localValue.value, option.value);
      } else {
        localValue.value = void 0;
      }
    } else if (multiple.value) {
      if (Array.isArray(localValue.value)) {
        localValue.value = addToArray$1(localValue.value, option.value);
      } else {
        localValue.value = [option.value];
      }
    } else {
      localValue.value = option.value;
    }
  };
  watch([options, localValue], () => {
    selectedOption.value = getSelectedOption(selectedOption.value);
  });
  const hasSelectedOption = computed(() => {
    if (multiple.value) {
      return selectedOption.value.length > 0;
    }
    return selectedOption.value !== void 0;
  });
  return {
    selectedOption,
    hasSelectedOption,
    selectOption,
    toggleOption,
    optionIsSelected
  };
}

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

/**
 * Source: ftp://ftp.unicode.org/Public/UCD/latest/ucd/SpecialCasing.txt
 */
/**
 * Lower case as a function.
 */
function lowerCase(str) {
    return str.toLowerCase();
}

// Support camel case ("camelCase" -> "camel Case" and "CAMELCase" -> "CAMEL Case").
var DEFAULT_SPLIT_REGEXP = [/([a-z0-9])([A-Z])/g, /([A-Z])([A-Z][a-z])/g];
// Remove all non-word characters.
var DEFAULT_STRIP_REGEXP = /[^A-Z0-9]+/gi;
/**
 * Normalize the string into something other libraries can manipulate easier.
 */
function noCase(input, options) {
    if (options === void 0) { options = {}; }
    var _a = options.splitRegexp, splitRegexp = _a === void 0 ? DEFAULT_SPLIT_REGEXP : _a, _b = options.stripRegexp, stripRegexp = _b === void 0 ? DEFAULT_STRIP_REGEXP : _b, _c = options.transform, transform = _c === void 0 ? lowerCase : _c, _d = options.delimiter, delimiter = _d === void 0 ? " " : _d;
    var result = replace(replace(input, splitRegexp, "$1\0$2"), stripRegexp, "\0");
    var start = 0;
    var end = result.length;
    // Trim the delimiter from around the output string.
    while (result.charAt(start) === "\0")
        start++;
    while (result.charAt(end - 1) === "\0")
        end--;
    // Transform each token independently.
    return result.slice(start, end).split("\0").map(transform).join(delimiter);
}
/**
 * Replace `re` in the input string with the replacement value.
 */
function replace(input, re, value) {
    if (re instanceof RegExp)
        return input.replace(re, value);
    return re.reduce(function (input, re) { return input.replace(re, value); }, input);
}

function dotCase(input, options) {
    if (options === void 0) { options = {}; }
    return noCase(input, __assign({ delimiter: "." }, options));
}

function snakeCase(input, options) {
    if (options === void 0) { options = {}; }
    return dotCase(input, __assign({ delimiter: "_" }, options));
}

const extractDefinedProps = (vm) => {
  const validProps = Object.keys(vm.props);
  return Object.keys(vm.vnode.props || {}).map((propName) => camelize(propName)).filter((propName) => validProps.includes(propName) && propName !== "modelValue");
};
function useAttributes(configuration) {
  const vm = getCurrentInstance();
  const computedAttributes = computed(() => {
    const availableProps = Object.keys(vm?.props ?? {});
    return pick$3(configuration, (value, key) => isPrimitive$1(value) && !availableProps.includes(String(key)));
  });
  const attributes = reactive(computedAttributes.value);
  watch(computedAttributes, (newValue) => {
    Object.keys(newValue).forEach((key) => {
      if (!isEqual$1(attributes[key], newValue[key])) {
        attributes[key] = newValue[key];
      }
    });
  });
  return attributes;
}
function useConfigurationParts(componentName) {
  const vm = getCurrentInstance();
  const variantGlobalConfiguration = inject("vanilla_configuration", {});
  const componentGlobalConfiguration = get$4(
    variantGlobalConfiguration,
    componentName,
    {}
  );
  const propsValues = computed(() => {
    const values = {};
    if (vm) {
      extractDefinedProps(vm).forEach((attributeName) => {
        const normalizedAttribute = camelize(attributeName);
        values[normalizedAttribute] = vm.props[normalizedAttribute];
      });
    }
    return values;
  });
  return {
    componentGlobalConfiguration,
    propsValues
  };
}
function useConfiguration(defaultConfiguration, componentName, modelValue = void 0, classesListKeys = void 0) {
  const vm = getCurrentInstance();
  const props = vm?.props;
  const errors = ref(props?.errors);
  const variant = ref(props?.variant);
  const hasErrors = computed(() => errors?.value !== void 0 && errors?.value !== null && errors?.value !== "");
  const globalOptions = inject("vanilla_components_options", {});
  const errorVariant = ref(props?.variantError || "error");
  if (variant.value) {
    variant.value = snakeCase(variant.value);
  }
  if (errors.value !== void 0 && errors.value !== "" && errors.value !== null) {
    variant.value = errorVariant.value;
  }
  if (modelValue !== void 0 && globalOptions.swapErrorsVariantOnModelValueChanges) {
    watch(() => modelValue?.value, () => {
      errors.value = void 0;
      variant.value = props?.variant;
    }, { deep: true });
  }
  watch(() => props?.variant, (newVariant) => {
    variant.value = newVariant;
  });
  watch(() => props?.errors, (newErrors) => {
    errors.value = newErrors;
    if (hasErrors.value) {
      variant.value = errorVariant.value;
    } else {
      variant.value = props?.variant;
    }
  }, { deep: true });
  const { propsValues, componentGlobalConfiguration } = useConfigurationParts(componentName);
  const finalClassesListKeys = classesListKeys ?? Object.keys(defaultConfiguration.classes ?? {});
  const computedConfiguration = computed(() => ({
    ...props || {},
    ...useParseVariant$1(
      propsValues.value,
      finalClassesListKeys,
      componentGlobalConfiguration,
      defaultConfiguration,
      variant.value
    )
  }));
  const configuration = reactive(computedConfiguration.value);
  watch(computedConfiguration, (newValue) => {
    Object.keys(newValue).forEach((key) => {
      configuration[key] = newValue[key];
    });
  });
  const attributes = useAttributes(configuration);
  return {
    configuration,
    attributes,
    errors,
    variant,
    hasErrors
  };
}

const __default__$Q = {
  name: "VanillaTransionable",
  inheritAttrs: true
};
const _sfc_main$$ = /* @__PURE__ */ defineComponent({
  ...__default__$Q,
  props: {
    classesList: {
      type: Object,
      default: () => ({})
    },
    enabled: {
      type: Boolean,
      default: true
    },
    duration: {
      type: [Number, String],
      default: 150
    }
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createBlock(Transition, {
        "enter-active-class": __props.classesList?.enterActiveClass,
        "enter-from-class": __props.classesList?.enterFromClass,
        "enter-to-class": __props.classesList?.enterToClass,
        "leave-active-class": __props.classesList?.leaveActiveClass,
        "leave-from-class": __props.classesList?.leaveFromClass,
        "leave-to-class": __props.classesList?.leaveToClass,
        css: __props.enabled,
        duration: __props.duration
      }, {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 8, ["enter-active-class", "enter-from-class", "enter-to-class", "leave-active-class", "leave-from-class", "leave-to-class", "css", "duration"]);
    };
  }
});

const alertConfig = {
  fixedClasses: {
    wrapper: "p-4",
    iconWrapper: "flex-shrink-0",
    icon: "h-5 w-5",
    iconRaw: "mr-2",
    contentWrapper: "flex flex-col space-y-2 items-start justify-center",
    contentWrapperWithIcon: "ml-2",
    title: "text-sm font-medium",
    text: "text-xs text-left",
    actionsWrapper: "mt-4",
    actionsContainer: "-mx-2 -my-1.5 flex",
    closeButtonWrapper: "ml-auto pl-3",
    closeButtonContainer: "-mx-1.5 -my-1.5",
    closeButton: "inline-flex rounded-md p-1.5 focus:outline-none focus:ring-2 focus:ring-offset-2",
    closeButtonIcon: "h-5 w-5",
    enterActiveClass: "transition duration-100 ease-out",
    enterFromClass: "transform scale-95 opacity-0",
    enterToClass: "transform scale-100 opacity-100",
    leaveActiveClass: "transition duration-75 ease-in",
    leaveFromClass: "transform scale-100 opacity-100",
    leaveToClass: "transform scale-95 opacity-0"
  },
  classes: {
    wrapper: "border-l-4 rounded-md  border-primary-400 bg-white dark:bg-gray-800/70",
    iconWrapper: "",
    icon: "",
    iconRaw: "",
    contentWrapper: "",
    contentWrapperWithIcon: "",
    title: "text-gray-800 dark:text-white",
    text: "text-gray-700 dark:text-gray-50",
    actionsWrapper: "",
    actionsContainer: "",
    closeButtonWrapper: "",
    closeButtonContainer: "",
    closeButton: "bg-transparent text-primary-500 hover:bg-gray-100 dark:hover:bg-gray-700 focus:ring-primary-600 focus:ring-offset-white dark:focus:ring-offset-gray-800",
    closeButtonIcon: "",
    // Transitions
    enterActiveClass: "",
    enterFromClass: "",
    enterToClass: "",
    leaveActiveClass: "",
    leaveFromClass: "",
    leaveToClass: ""
  },
  variants: {
    success: {
      classes: {
        wrapper: "border-l-4 rounded-md border-green-400 dark:border-green-600 bg-green-50 dark:bg-green-200",
        iconWrapper: "",
        icon: "text-green-400 dark:text-green-600",
        contentWrapper: "",
        contentWrapperWithIcon: "",
        title: "text-green-800 dark:text-green-900",
        text: "text-green-700 dark:text-green-900/90",
        actionsWrapper: "",
        actionsContainer: "",
        closeButtonWrapper: "",
        closeButtonContainer: "",
        closeButton: "bg-green-50 dark:bg-green-200 text-green-500 dark:text-green-700 hover:bg-green-100 dark:hover:bg-green-300 focus:ring-green-600 dark:focus:ring-green-800 focus:ring-offset-green-50 dark:focus:ring-offset-green-200",
        closeButtonIcon: ""
      }
    },
    warning: {
      classes: {
        wrapper: "border-l-4 rounded-md border-yellow-400 dark:border-yellow-600 bg-yellow-50 dark:bg-yellow-200",
        iconWrapper: "",
        icon: "text-yellow-400 dark:text-yellow-600",
        contentWrapper: "",
        contentWrapperWithIcon: "",
        title: "text-yellow-800 dark:text-yellow-900",
        text: "text-yellow-700 dark:text-yellow-900/90",
        actionsWrapper: "",
        actionsContainer: "",
        closeButtonWrapper: "",
        closeButtonContainer: "",
        closeButton: "bg-yellow-50 dark:bg-yellow-200 text-yellow-500 dark:text-yellow-700 hover:bg-yellow-100 dark:hover:bg-yellow-300 focus:ring-yellow-600 dark:focus:ring-yellow-800 focus:ring-offset-yellow-50 dark:focus:ring-offset-yellow-200",
        closeButtonIcon: ""
      }
    },
    error: {
      classes: {
        wrapper: "border-l-4 rounded-md border-red-400 dark:border-red-600 bg-red-50 dark:bg-red-200",
        iconWrapper: "",
        icon: "text-red-400 dark:text-red-600",
        contentWrapper: "",
        contentWrapperWithIcon: "",
        title: "text-red-800 dark:text-red-900",
        text: "text-red-700 dark:text-red-900/90",
        actionsWrapper: "",
        actionsContainer: "",
        closeButtonWrapper: "",
        closeButtonContainer: "",
        closeButton: "bg-red-50 dark:bg-red-200 text-red-500 dark:text-red-700 hover:bg-red-100 dark:hover:bg-red-300 focus:ring-red-600 dark:focus:ring-red-800 focus:ring-offset-red-50 dark:focus:ring-offset-red-200",
        closeButtonIcon: ""
      }
    },
    info: {
      classes: {
        wrapper: "border-l-4 rounded-md border-blue-400 dark:border-blue-600 bg-blue-50 dark:bg-blue-200",
        iconWrapper: "",
        icon: "text-blue-400 dark:text-blue-400",
        contentWrapper: "",
        contentWrapperWithIcon: "",
        title: "text-blue-800 dark:text-blue-900",
        text: "text-blue-700 dark:text-blue-900/90",
        actionsWrapper: "",
        actionsContainer: "",
        closeButtonWrapper: "",
        closeButtonContainer: "",
        closeButton: "bg-blue-50 dark:bg-blue-200 text-blue-500 dark:text-blue-700 hover:bg-blue-100 dark:hover:bg-blue-300 focus:ring-blue-600 dark:focus:ring-blue-800 focus:ring-offset-blue-50 dark:focus:ring-offset-blue-200",
        closeButtonIcon: ""
      }
    },
    muted: {
      classes: {
        wrapper: "ring-1 ring-inset rounded-md ring-primary-400/50 bg-primary-300/10 dark:bg-primary-600/10",
        iconWrapper: "",
        icon: "text-blue-400 dark:text-blue-400",
        contentWrapper: "",
        contentWrapperWithIcon: "",
        title: "font-semibold  text-primary-800 dark:text-primary-400",
        text: "text-primary-700 dark:text-primary-200",
        actionsWrapper: "",
        actionsContainer: "",
        closeButtonWrapper: "",
        closeButtonContainer: "",
        closeButton: "bg-transparent text-primary-500 hover:bg-primary-400/20 dark:hover:bg-primary-700/20 focus:ring-primary-600 focus:ring-offset-white dark:focus:ring-offset-gray-800",
        closeButtonIcon: ""
      }
    },
    warning_muted: {
      classes: {
        wrapper: "ring-1 ring-inset rounded-md ring-yellow-400/50 bg-yellow-300/10 dark:bg-yellow-600/10",
        iconWrapper: "",
        icon: "text-yellow-400 dark:text-yellow-400",
        contentWrapper: "",
        contentWrapperWithIcon: "",
        title: "text-yellow-800 dark:text-yellow-400",
        text: "text-yellow-700 dark:text-yellow-200",
        actionsWrapper: "",
        actionsContainer: "",
        closeButtonWrapper: "",
        closeButtonContainer: "",
        closeButton: "bg-transparent text-yellow-500 hover:bg-yellow-400/20 dark:hover:bg-yellow-700/20 focus:ring-yellow-600 focus:ring-offset-white dark:focus:ring-offset-gray-800",
        closeButtonIcon: ""
      }
    },
    error_muted: {
      classes: {
        wrapper: "ring-1 ring-inset rounded-md ring-red-400/50 bg-red-300/10 dark:bg-red-600/10",
        iconWrapper: "",
        icon: "text-red-400 dark:text-red-400",
        contentWrapper: "",
        contentWrapperWithIcon: "",
        title: "text-red-800 dark:text-red-400",
        text: "text-red-700 dark:text-red-200",
        actionsWrapper: "",
        actionsContainer: "",
        closeButtonWrapper: "",
        closeButtonContainer: "",
        closeButton: "bg-transparent text-red-500 hover:bg-red-400/20 dark:hover:bg-red-700/20 focus:ring-red-600 focus:ring-offset-white dark:focus:ring-offset-gray-800",
        closeButtonIcon: ""
      }
    },
    info_muted: {
      classes: {
        wrapper: "ring-1 ring-inset rounded-md ring-blue-400/50 bg-blue-300/10 dark:bg-blue-600/10",
        iconWrapper: "",
        icon: "text-blue-400 dark:text-blue-400",
        contentWrapper: "",
        contentWrapperWithIcon: "",
        title: "text-blue-800 dark:text-blue-400",
        text: "text-blue-700 dark:text-blue-200",
        actionsWrapper: "",
        actionsContainer: "",
        closeButtonWrapper: "",
        closeButtonContainer: "",
        closeButton: "bg-transparent text-blue-500 hover:bg-blue-400/20 dark:hover:bg-blue-700/20 focus:ring-blue-600 focus:ring-offset-white dark:focus:ring-offset-gray-800",
        closeButtonIcon: ""
      }
    },
    success_muted: {
      classes: {
        wrapper: "ring-1 ring-inset rounded-md  ring-green-400/50 bg-green-300/10 dark:bg-green-600/10",
        iconWrapper: "",
        icon: "text-green-400 dark:text-green-400",
        contentWrapper: "",
        contentWrapperWithIcon: "",
        title: "text-green-800 dark:text-green-400",
        text: "text-green-700 dark:text-green-200",
        actionsWrapper: "",
        actionsContainer: "",
        closeButtonWrapper: "",
        closeButtonContainer: "",
        closeButton: "bg-transparent text-green-500 hover:bg-green-400/20 dark:hover:bg-green-700/20 focus:ring-green-600 focus:ring-offset-white dark:focus:ring-offset-gray-800",
        closeButtonIcon: ""
      }
    }
  }
};
Object.keys(alertConfig.classes);

const _hoisted_1$16 = {
  viewBox: "0 0 24 24",
  width: "1.2em",
  height: "1.2em"
};
const _hoisted_2$X = /*#__PURE__*/createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75s9.75-4.365 9.75-9.75S17.385 2.25 12 2.25Zm-1.72 6.97a.75.75 0 1 0-1.06 1.06L10.94 12l-1.72 1.72a.75.75 0 1 0 1.06 1.06L12 13.06l1.72 1.72a.75.75 0 1 0 1.06-1.06L13.06 12l1.72-1.72a.75.75 0 1 0-1.06-1.06L12 10.94l-1.72-1.72Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3$C = [
  _hoisted_2$X
];

function render$t(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$16, _hoisted_3$C))
}

const XCircleIcon = { name: 'heroicons-x-circle-solid', render: render$t };
/* vite-plugin-components disabled */

const _hoisted_1$15 = {
  viewBox: "0 0 24 24",
  width: "1.2em",
  height: "1.2em"
};
const _hoisted_2$W = /*#__PURE__*/createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75s-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm13.36-1.814a.75.75 0 1 0-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094l3.75-5.25Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3$B = [
  _hoisted_2$W
];

function render$s(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$15, _hoisted_3$B))
}

const CheckCircleIcon = { name: 'heroicons-check-circle-solid', render: render$s };
/* vite-plugin-components disabled */

const _hoisted_1$14 = {
  viewBox: "0 0 24 24",
  width: "1.2em",
  height: "1.2em"
};
const _hoisted_2$V = /*#__PURE__*/createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M9.401 3.003c1.155-2 4.043-2 5.197 0l7.355 12.748c1.154 2-.29 4.5-2.599 4.5H4.645c-2.309 0-3.752-2.5-2.598-4.5L9.4 3.003ZM12 8.25a.75.75 0 0 1 .75.75v3.75a.75.75 0 0 1-1.5 0V9a.75.75 0 0 1 .75-.75Zm0 8.25a.75.75 0 1 0 0-1.5a.75.75 0 0 0 0 1.5Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3$A = [
  _hoisted_2$V
];

function render$r(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$14, _hoisted_3$A))
}

const ExclamationTriangleIcon$1 = { name: 'heroicons-exclamation-triangle-solid', render: render$r };
/* vite-plugin-components disabled */

const _hoisted_1$13 = {
  viewBox: "0 0 24 24",
  width: "1.2em",
  height: "1.2em"
};
const _hoisted_2$U = /*#__PURE__*/createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75s-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm8.706-1.442c1.146-.573 2.437.463 2.126 1.706l-.709 2.836l.042-.02a.75.75 0 0 1 .67 1.34l-.04.022c-1.147.573-2.438-.463-2.127-1.706l.71-2.836l-.042.02a.75.75 0 1 1-.671-1.34l.041-.022ZM12 9a.75.75 0 1 0 0-1.5a.75.75 0 0 0 0 1.5Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3$z = [
  _hoisted_2$U
];

function render$q(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$13, _hoisted_3$z))
}

const InformationCircleIcon$1 = { name: 'heroicons-information-circle-solid', render: render$q };
/* vite-plugin-components disabled */

const _hoisted_1$12 = {
  viewBox: "0 0 24 24",
  width: "1.2em",
  height: "1.2em"
};
const _hoisted_2$T = /*#__PURE__*/createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M5.47 5.47a.75.75 0 0 1 1.06 0L12 10.94l5.47-5.47a.75.75 0 1 1 1.06 1.06L13.06 12l5.47 5.47a.75.75 0 1 1-1.06 1.06L12 13.06l-5.47 5.47a.75.75 0 0 1-1.06-1.06L10.94 12L5.47 6.53a.75.75 0 0 1 0-1.06Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3$y = [
  _hoisted_2$T
];

function render$p(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$12, _hoisted_3$y))
}

const CloseIcon = { name: 'heroicons-x-mark-solid', render: render$p };
/* vite-plugin-components disabled */

const _hoisted_1$11 = { class: "flex" };
const _hoisted_2$S = ["innerHTML"];
const _hoisted_3$x = { class: "sr-only" };
const __default__$P = {
  name: "VanillaAlert",
  inheritAttrs: false
};
const _sfc_main$_ = /* @__PURE__ */ defineComponent({
  ...__default__$P,
  props: {
    ...useVariantProps$1(),
    modelValue: {
      type: [Boolean],
      default: true
    },
    title: {
      type: [String],
      default: void 0
    },
    text: {
      type: [String],
      default: void 0
    },
    closable: {
      type: [Boolean],
      default: false
    },
    timeout: {
      type: [Number],
      default: void 0
    },
    dismissLabel: {
      type: [String],
      default: "Dismiss"
    },
    iconRaw: {
      type: [String],
      default: void 0
    },
    icon: {
      type: [String],
      default: void 0,
      validator: (value) => {
        if (value === void 0) {
          return true;
        }
        return [
          "error",
          "success",
          "warning",
          "info"
        ].includes(value);
      }
    }
  },
  emits: [
    "update:modelValue",
    "close"
  ],
  setup(__props, { emit }) {
    const props = __props;
    const localValue = useVModel(props, "modelValue");
    const { configuration, errors, hasErrors } = useConfiguration(alertConfig, "Alert", localValue);
    const timeout = ref(void 0);
    const internalTimeout = ref(void 0);
    const main = ref();
    const close = () => {
      internalTimeout.value = setTimeout(() => {
        localValue.value = false;
        clearTimeout(timeout.value);
        emit("close");
      }, 200);
    };
    const registerTimeoutDismiss = () => {
      if (props.timeout) {
        timeout.value = setTimeout(() => {
          localValue.value = false;
          emit("close");
        }, props.timeout);
      }
    };
    watch(() => localValue.value, (value) => {
      if (value) {
        registerTimeoutDismiss();
      } else {
        clearTimeout(timeout.value);
      }
    });
    onMounted(() => {
      if (localValue.value) {
        registerTimeoutDismiss();
      }
    });
    onUnmounted(() => {
      clearTimeout(timeout.value);
      clearTimeout(internalTimeout.value);
    });
    return (_ctx, _cache) => {
      return openBlock(), createBlock(_sfc_main$$, {
        name: "transition",
        duration: "200",
        "classes-list": unref(configuration).classesList
      }, {
        default: withCtx(() => [
          unref(localValue) ? (openBlock(), createElementBlock("div", {
            key: 0,
            ref_key: "main",
            ref: main,
            class: normalizeClass(["vanilla-alert", unref(configuration).classesList.wrapper])
          }, [
            renderSlot(_ctx.$slots, "default", {}, () => [
              createElementVNode("div", _hoisted_1$11, [
                renderSlot(_ctx.$slots, "icon", normalizeProps(guardReactiveProps({
                  classes: unref(configuration).classesList.iconWrapper,
                  iconClasses: unref(configuration).classesList.icon
                })), () => [
                  props.icon || props.iconRaw ? (openBlock(), createElementBlock("div", {
                    key: 0,
                    class: normalizeClass(unref(configuration).classesList.iconWrapper)
                  }, [
                    props.icon ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
                      props.icon === "error" ? (openBlock(), createBlock(unref(XCircleIcon), {
                        key: 0,
                        class: normalizeClass(unref(configuration).classesList.icon),
                        "aria-hidden": "true"
                      }, null, 8, ["class"])) : createCommentVNode("", true),
                      props.icon === "success" ? (openBlock(), createBlock(unref(CheckCircleIcon), {
                        key: 1,
                        class: normalizeClass(unref(configuration).classesList.icon),
                        "aria-hidden": "true"
                      }, null, 8, ["class"])) : createCommentVNode("", true),
                      props.icon === "warning" ? (openBlock(), createBlock(unref(ExclamationTriangleIcon$1), {
                        key: 2,
                        class: normalizeClass(unref(configuration).classesList.icon),
                        "aria-hidden": "true"
                      }, null, 8, ["class"])) : createCommentVNode("", true),
                      props.icon === "info" ? (openBlock(), createBlock(unref(InformationCircleIcon$1), {
                        key: 3,
                        class: normalizeClass(unref(configuration).classesList.icon),
                        "aria-hidden": "true"
                      }, null, 8, ["class"])) : createCommentVNode("", true)
                    ], 64)) : createCommentVNode("", true),
                    props.iconRaw ? (openBlock(), createElementBlock("span", {
                      key: 1,
                      class: normalizeClass([
                        unref(configuration).classesList.icon,
                        unref(configuration).classesList.iconRaw
                      ]),
                      innerHTML: props.iconRaw
                    }, null, 10, _hoisted_2$S)) : createCommentVNode("", true)
                  ], 2)) : createCommentVNode("", true)
                ]),
                createElementVNode("div", {
                  class: normalizeClass([
                    unref(configuration).classesList.contentWrapper,
                    props.icon ? unref(configuration).classesList.contentWrapperWithIcon : ""
                  ])
                }, [
                  __props.title || unref(hasSlot)(_ctx.$slots.title) ? (openBlock(), createElementBlock("h3", {
                    key: 0,
                    class: normalizeClass(unref(configuration).classesList.title)
                  }, [
                    renderSlot(_ctx.$slots, "title", {}, () => [
                      createElementVNode("span", null, toDisplayString(__props.title), 1)
                    ])
                  ], 2)) : createCommentVNode("", true),
                  __props.text || unref(hasSlot)(_ctx.$slots.text) ? (openBlock(), createElementBlock("div", mergeProps({
                    key: 1,
                    class: unref(configuration).classesList.text
                  }, _ctx.$attrs), [
                    renderSlot(_ctx.$slots, "text", {}, () => [
                      createElementVNode("p", null, toDisplayString(__props.text), 1)
                    ])
                  ], 16)) : createCommentVNode("", true),
                  unref(hasSlot)(_ctx.$slots.actions) ? (openBlock(), createElementBlock("div", {
                    key: 2,
                    class: normalizeClass(unref(configuration).classesList.actionsWrapper)
                  }, [
                    createElementVNode("div", {
                      class: normalizeClass(unref(configuration).classesList.actionsContainer)
                    }, [
                      renderSlot(_ctx.$slots, "actions")
                    ], 2)
                  ], 2)) : createCommentVNode("", true)
                ], 2),
                __props.closable ? (openBlock(), createElementBlock("div", {
                  key: 0,
                  class: normalizeClass(unref(configuration).classesList.closeButtonWrapper)
                }, [
                  createElementVNode("div", {
                    class: normalizeClass(unref(configuration).classesList.closeButtonContainer)
                  }, [
                    renderSlot(_ctx.$slots, "close", normalizeProps(guardReactiveProps({ close, className: unref(configuration).classesList.closeButton })), () => [
                      createElementVNode("button", {
                        type: "button",
                        class: normalizeClass(unref(configuration).classesList.closeButton),
                        onClick: close
                      }, [
                        createElementVNode("span", _hoisted_3$x, toDisplayString(props.dismissLabel), 1),
                        createVNode(unref(CloseIcon), {
                          class: normalizeClass(unref(configuration).classesList.closeButtonIcon),
                          "aria-hidden": "true"
                        }, null, 8, ["class"])
                      ], 2)
                    ])
                  ], 2)
                ], 2)) : createCommentVNode("", true)
              ])
            ])
          ], 2)) : createCommentVNode("", true)
        ]),
        _: 3
      }, 8, ["classes-list"]);
    };
  }
});

const commonClasses = {
  // Icons and Misc
  iconsSize: "w-5 h-5",
  disabled: "opacity-60 select-none cursor-not-allowed ",
  // Inputs, selects, textarea on default _old_theme
  inputsBackground: "bg-white dark:bg-gray-900",
  inputsBackgroundDarkerOrSofter: "bg-gray-50 dark:bg-gray-800",
  inputsText: "text-sm",
  inputsTextColor: "text-gray-700 dark:text-white placeholder-gray-500/60",
  inputsBorder: "border-0",
  inputsSpacing: "px-4 py-3",
  inputsShadows: "shadow",
  inputsRing: "ring-gray-300 focus:ring-primary-600 dark:ring-white/20 dark:focus:ring-primary-600 focus-visible:ring-primary-600",
  inputsRingBase: "ring-1 ring-inset focus:ring-inset focus:ring-2",
  inputsDisabled: "disabled:opacity-50 disabled:cursor-not-allowed",
  inputsAutofill: "!autofill:bg-white !dark:autofill:bg-gray-900",
  inputsRadius: "rounded-lg",
  inputsRadiusTop: "rounded-none rounded-t-lg",
  inputsRadiusBottom: "rounded-none rounded-b-lg",
  inputsRadiusLeft: "rounded-none rounded-l-lg",
  inputsRadiusRight: "rounded-none rounded-r-lg",
  inputsRadiusTopRight: "rounded-none rounded-tr-lg",
  inputsRadiusTopLeft: "rounded-none rounded-tl-lg",
  inputsRadiusBottomLeft: "rounded-none rounded-bl-lg",
  inputsRadiusBottomRight: "rounded-none rounded-br-lg",
  inputsTransition: "transition duration-100 ease-in-out",
  // Inputs with Errors
  inputsErrorTextColor: "text-red-400 placeholder-red-400",
  inputsErrorsBackground: "bg-white dark:bg-gray-900",
  inputsErrorsBorder: "border-0",
  inputsErrorsRing: "ring-red-400 focus:ring-red-500 dark:ring-red-400 dark:focus:ring-red-500 focus-visible:ring-red-500 dark:focus-visible:ring-red-500",
  // Buttons
  buttonRing: "focus:outline-none focus:ring-2 dark:focus:ring-offset-gray-900",
  buttonSizing: "",
  buttonErrorsRing: "focus:outline-none focus:ring-2 dark:focus:ring-offset-gray-900 focus:ring-red-600",
  buttonRadius: "rounded-md",
  buttonSpacing: "px-3 py-2",
  buttonSpacingCircle: "p-2",
  buttonShadow: "shadow",
  buttonText: "text-sm font-medium whitespace-nowrap",
  buttonTransition: "transition ease-in-out duration-15",
  buttonPosition: "block justify-center inline-flex items-center",
  // Overlays & Dropdowns
  dropdownsBackground: "bg-white dark:bg-gray-900",
  dropdownsShadows: "shadow-lg",
  dropdownsRadius: "rounded-md",
  dropdownsBorder: "border border-1 border-gray-300 dark:border-gray-700",
  dropdownsRing: "ring-1 ring-gray-400/50 dark:ring-white/10",
  dropdownsFocus: "focus:outline-none focus:ring-1 dark:focus:ring-offset-gray-900",
  // Options
  optionOrItemDisabled: "opacity-50 cursor-not-allowed",
  // Positioning
  leftTop: "justify-start items-start",
  leftCenter: "justify-start items-center",
  leftBottom: "justify-start items-end",
  rightTop: "justify-end items-start",
  rightCenter: "justify-end items-center",
  rightBottom: "justify-end items-end",
  centerTop: "justify-center items-start",
  centerCenter: "justify-center items-center",
  centerBottom: "justify-center items-end"
};

const popperOptions = {
  placement: "bottom-end",
  modifiers: [
    {
      name: "offset",
      options: {
        offset: [0, 10]
      }
    }
  ],
  strategy: "absolute",
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-expect-error
  onFirstUpdate: void 0
};
const validPlacements = [
  "auto",
  "auto-start",
  "auto-end",
  "top",
  "top-start",
  "top-end",
  "bottom",
  "bottom-start",
  "bottom-end",
  "right",
  "right-start",
  "right-end",
  "left",
  "left-start",
  "left-end"
];
const sameWidthModifier = {
  name: "sameWidth",
  enabled: true,
  phase: "beforeWrite",
  requires: ["computeStyles"],
  fn: (options) => {
    const { state } = options;
    state.styles.popper.width = `${state.rects.reference.width}px`;
  },
  effect: (options) => {
    const { state } = options;
    const reference = state.elements.reference;
    state.elements.popper.style.width = `${reference.offsetWidth}px`;
  }
};

const enterAndLeave = {
  enterActiveClass: "transition-opacity duration-100 ease-out",
  enterFromClass: "transform scale-95 opacity-0",
  enterToClass: "transform scale-100 opacity-100",
  leaveActiveClass: "transition-opacity duration-100 ease-in",
  leaveFromClass: "transform scale-100 opacity-100",
  leaveToClass: "transform scale-95 opacity-0"
};

const formsConfig = {
  fixedClasses: {
    label: "",
    labelInner: "leading-none",
    errors: "",
    feedback: "",
    section: "",
    sectionDivided: "",
    sectionSpaced: "",
    sectionFilled: "",
    disabled: commonClasses.disabled
  },
  // Default Input appearance
  classes: {
    label: "block font-medium text-sm text-gray-700 dark:text-white cursor-pointer mb-1 flex items-center justify-center space-x-1",
    labelInner: "",
    errors: mergeClasses(
      "mt-2 text-xs",
      commonClasses.inputsErrorTextColor
    ),
    feedback: "mt-1 text-xs text-gray-500 opacity-75 dark:text-gray-400 cursor-pointer",
    section: "",
    sectionDivided: "divide-y divide-gray-200 dark:divide-gray-700",
    sectionSpaced: "space-y-2",
    sectionFilled: "bg-gray-50 dark:bg-gray-800/50",
    disabled: ""
  }
};
const formClassesKeys = Object.keys(formsConfig.classes);

const _hoisted_1$10 = ["innerHTML"];
const _hoisted_2$R = { key: 1 };
const __default__$O = {
  name: "VanillaFormErrors",
  inheritAttrs: true
};
const _sfc_main$Z = /* @__PURE__ */ defineComponent({
  ...__default__$O,
  props: {
    ...useVariantProps$1(),
    errors: {
      type: String,
      default: void 0,
      required: true
    },
    safe: {
      type: [Boolean],
      default: true,
      required: false
    }
  },
  setup(__props) {
    const { configuration, errors, hasErrors } = useConfiguration(formsConfig, "FormErrors");
    return (_ctx, _cache) => {
      return unref(hasErrors) ? (openBlock(), createElementBlock("div", {
        key: 0,
        class: normalizeClass(unref(configuration).classesList.errors)
      }, [
        __props.safe ? (openBlock(), createElementBlock("span", {
          key: 0,
          innerHTML: unref(errors)
        }, null, 8, _hoisted_1$10)) : (openBlock(), createElementBlock("span", _hoisted_2$R, toDisplayString(unref(errors)), 1))
      ], 2)) : createCommentVNode("", true);
    };
  }
});

const _hoisted_1$$ = ["innerHTML"];
const _hoisted_2$Q = { key: 1 };
const __default__$N = {
  name: "VanillaFormFeedback",
  inheritAttrs: true
};
const _sfc_main$Y = /* @__PURE__ */ defineComponent({
  ...__default__$N,
  props: {
    ...useVariantProps$1(),
    text: {
      type: [String, void 0],
      required: true
    },
    safe: {
      type: [Boolean],
      default: true,
      required: false
    }
  },
  emits: ["feedbackClick", "click"],
  setup(__props, { emit }) {
    const { configuration } = useConfiguration(formsConfig, "FormFeedback");
    const clicked = () => {
      emit("feedbackClick", true);
      emit("click", true);
    };
    return (_ctx, _cache) => {
      return __props.text ? (openBlock(), createElementBlock("div", {
        key: 0,
        class: normalizeClass(unref(configuration).classesList.feedback),
        onClick: clicked
      }, [
        __props.safe ? (openBlock(), createElementBlock("span", {
          key: 0,
          innerHTML: __props.text
        }, null, 8, _hoisted_1$$)) : (openBlock(), createElementBlock("span", _hoisted_2$Q, toDisplayString(__props.text), 1))
      ], 2)) : createCommentVNode("", true);
    };
  }
});

const buttonConfig = {
  fixedClasses: {
    button: mergeClasses(
      commonClasses.buttonPosition
    ),
    container: "flex items-center space-x-1",
    spinner: "-ml-1 mr-1 h-4 w-4 text-whit",
    disableOpacity: "opacity-50",
    enableOpacity: "opacity-100",
    busyOrInvalidState: "cursor-not-allowed",
    validState: "cursor-pointer",
    // Rounded / Radius
    roundedFull: "rounded-md",
    roundedCircle: "rounded-full",
    roundedTop: "rounded-t-md",
    roundedBottom: "rounded-b-md",
    roundedLeft: "rounded-l-md",
    roundedRight: "rounded-r-md",
    roundedBottomLeft: "rounded-bl-md",
    roundedBottomRight: "rounded-br-md",
    roundedTopLeft: "rounded-tl-md",
    roundedTopRight: "rounded-tr-md"
  },
  // Default Input appearance
  classes: {
    button: mergeClasses(
      commonClasses.buttonText,
      commonClasses.buttonRing,
      commonClasses.buttonSizing,
      commonClasses.buttonShadow,
      "focus:ring-offset-2 focus:ring-primary-600",
      "text-gray-700 focus:text-gray-600 dark:text-white dark:hover:text-white dark:focus:text-white",
      "bg-white dark:bg-gray-800",
      "border border-gray-300 dark:border-gray-600 dark:focus:border-primary-600"
    ),
    container: " ",
    spinner: "",
    disableOpacity: "",
    enableOpacity: "",
    busyOrInvalidState: "",
    validState: "",
    padding: commonClasses.buttonSpacing,
    paddingCircle: commonClasses.buttonSpacingCircle,
    // Rounded / Radius
    roundedFull: "",
    roundedCircle: "",
    roundedTop: "",
    roundedBottom: "",
    roundedLeft: "",
    roundedRight: "",
    roundedBottomLeft: "",
    roundedBottomRight: "",
    roundedTopLeft: "",
    roundedTopRight: ""
  },
  // Variants
  variants: {
    // Used for Errors
    error: {
      classes: {
        button: mergeClasses(
          commonClasses.buttonText,
          commonClasses.buttonRing,
          commonClasses.buttonSizing,
          commonClasses.buttonShadow,
          "focus:ring-offset-2 focus:ring-red-500",
          "text-white focus:text-gray-200",
          "bg-red-600"
        ),
        container: "",
        spinner: "",
        disableOpacity: "",
        enableOpacity: "",
        busyOrInvalidState: "",
        padding: commonClasses.buttonSpacing,
        paddingCircle: commonClasses.buttonSpacingCircle
      }
    },
    // Soft Variant for errors
    error_muted: {
      classes: {
        button: mergeClasses(
          commonClasses.buttonText,
          commonClasses.buttonRing,
          commonClasses.buttonSizing,
          commonClasses.buttonShadow,
          "focus:ring-offset-2 focus:ring-red-500 dark:focus:ring-red-400",
          "text-red-500 focus:text-red-600 dark:text-red-400",
          "bg-white dark:bg-gray-800",
          "border border-red-400 focus:border-red-400 dark:focus:border-red-400"
        ),
        container: "",
        spinner: "",
        disableOpacity: "",
        enableOpacity: "",
        busyOrInvalidState: "",
        padding: commonClasses.buttonSpacing,
        paddingCircle: commonClasses.buttonSpacingCircle
      }
    },
    // Primary
    primary: {
      classes: {
        button: mergeClasses(
          commonClasses.buttonText,
          commonClasses.buttonRing,
          commonClasses.buttonSizing,
          commonClasses.buttonShadow,
          "focus:ring-offset-2 focus:ring-primary-500",
          "text-white focus:text-gray-200",
          "bg-primary-600"
        ),
        container: "",
        spinner: "",
        disableOpacity: "",
        enableOpacity: "",
        busyOrInvalidState: "",
        padding: commonClasses.buttonSpacing,
        paddingCircle: commonClasses.buttonSpacingCircle
      }
    },
    // Success
    success: {
      classes: {
        button: mergeClasses(
          commonClasses.buttonText,
          commonClasses.buttonRing,
          commonClasses.buttonSizing,
          commonClasses.buttonShadow,
          "focus:ring-offset-2 focus:ring-green-500",
          "text-white focus:text-gray-200",
          "bg-green-600"
        ),
        container: "",
        spinner: "",
        disableOpacity: "",
        enableOpacity: "",
        busyOrInvalidState: "",
        padding: commonClasses.buttonSpacing,
        paddingCircle: commonClasses.buttonSpacingCircle
      }
    },
    // Transparent
    outline: {
      classes: {
        button: mergeClasses(
          commonClasses.buttonText,
          commonClasses.buttonRing,
          commonClasses.buttonSizing,
          // commonClasses.buttonShadow,
          "focus:ring-offset-2 focus:ring-primary-600",
          "text-gray-700 focus:text-gray-600 dark:text-white dark:hover:text-white",
          "bg-transparent",
          "border border-gray-400 dark:border-gray-600 dark:focus:border-primary-600"
        ),
        container: "",
        spinner: "",
        disableOpacity: "",
        enableOpacity: "",
        busyOrInvalidState: "",
        padding: commonClasses.buttonSpacing,
        paddingCircle: commonClasses.buttonSpacingCircle
      }
    },
    // Transparent
    transparent: {
      classes: {
        button: mergeClasses(
          commonClasses.buttonText,
          commonClasses.buttonRing,
          commonClasses.buttonSizing,
          "focus:ring-offset-2 focus:ring-primary-600",
          "text-gray-700 focus:text-gray-600 dark:text-white dark:hover:text-white",
          "bg-transparent"
        ),
        container: "",
        spinner: "",
        disableOpacity: "",
        enableOpacity: "",
        busyOrInvalidState: "",
        padding: commonClasses.buttonSpacing,
        paddingCircle: commonClasses.buttonSpacingCircle
      }
    },
    // Pagination Arrows
    pagination: {
      classes: {
        button: mergeClasses(
          commonClasses.buttonText,
          "disabled:opacity-50 disabled:cursor-not-allowed",
          "text-sm font-medium text-gray-500 dark:text-white hover:text-gray-400 dark:hover:text-gray-100",
          "px-3 py-2",
          "cursor-pointer relative inline-flex items-center bg-white dark:bg-gray-800",
          "border-0",
          "ring-1 ring-inset ring-gray-300 dark:ring-gray-600/60",
          "focus:z-10 focus:outline-none focus:ring-offset-0 focus:ring-2 focus:ring-primary-500 dark:focus:ring-primary-500",
          "-ml-px"
        ),
        container: "",
        spinner: "",
        disableOpacity: "",
        enableOpacity: "",
        busyOrInvalidState: "",
        padding: "",
        paddingCircle: commonClasses.buttonSpacingCircle
      }
    },
    // Pagination Page
    pagination_page: {
      classes: {
        button: mergeClasses(
          commonClasses.buttonText,
          "disabled:opacity-50 disabled:cursor-not-allowed",
          "text-sm font-medium text-gray-500 dark:text-white",
          "px-3 py-2",
          "cursor-pointer relative inline-flex items-center",
          "border-0",
          "bg-white dark:bg-gray-800",
          "ring-1 ring-inset ring-gray-300 dark:ring-gray-600/60",
          "focus:z-10 focus:outline-none focus:ring-offset-0 focus:ring-2 focus:ring-primary-500 dark:focus:ring-primary-500",
          "-ml-px"
        ),
        container: "",
        spinner: "",
        disableOpacity: "",
        enableOpacity: "",
        busyOrInvalidState: "",
        padding: "",
        paddingCircle: commonClasses.buttonSpacingCircle
      }
    }
  }
};
const buttonClassesKeys = Object.keys(buttonConfig.classes);

const _hoisted_1$_ = {
  viewBox: "0 0 24 24",
  width: "1.2em",
  height: "1.2em"
};
const _hoisted_2$P = /*#__PURE__*/createElementVNode("path", {
  fill: "currentColor",
  d: "M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,19a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z",
  opacity: ".25"
}, null, -1);
const _hoisted_3$w = /*#__PURE__*/createElementVNode("path", {
  fill: "currentColor",
  d: "M12,4a8,8,0,0,1,7.89,6.7A1.53,1.53,0,0,0,21.38,12h0a1.5,1.5,0,0,0,1.48-1.75,11,11,0,0,0-21.72,0A1.5,1.5,0,0,0,2.62,12h0a1.53,1.53,0,0,0,1.49-1.3A8,8,0,0,1,12,4Z"
}, [
  /*#__PURE__*/createElementVNode("animateTransform", {
    attributeName: "transform",
    dur: "0.75s",
    repeatCount: "indefinite",
    type: "rotate",
    values: "0 12 12;360 12 12"
  })
], -1);
const _hoisted_4$6 = [
  _hoisted_2$P,
  _hoisted_3$w
];

function render$o(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$_, _hoisted_4$6))
}

const LoadingIcon = { name: 'svg-spinners-180-ring-with-bg', render: render$o };
/* vite-plugin-components disabled */

const _hoisted_1$Z = { key: 0 };
const _hoisted_2$O = { key: 1 };
const __default__$M = {
  name: "VanillaButton",
  inheritAttrs: true
};
const _sfc_main$X = /* @__PURE__ */ defineComponent({
  ...__default__$M,
  props: {
    ...useVariantProps$1(),
    as: {
      type: [String, Object],
      default: "button"
    },
    asDeep: {
      type: [String],
      default: "button"
    },
    label: {
      type: [String],
      default: "Button"
    },
    loading: {
      type: [Boolean],
      default: false
    },
    disabled: {
      type: [Boolean],
      default: false
    },
    type: {
      type: [String],
      default: "button"
    },
    focusOnMount: {
      type: [Boolean],
      default: false
    }
  },
  emits: ["click"],
  setup(__props, { emit }) {
    const props = __props;
    const root = ref(null);
    const localValue = ref(props.label);
    const { configuration } = useConfiguration(buttonConfig, "Button", localValue);
    const handleClickEvent = (event) => {
      if (props.disabled || props.loading) {
        event.preventDefault();
        event.stopPropagation();
        return;
      }
      emit("click", event);
    };
    onMounted(() => {
      if (props.focusOnMount) {
        try {
          root?.value?.focus();
        } catch (e) {
          root?.value?.$el?.focus();
        }
      }
    });
    return (_ctx, _cache) => {
      return openBlock(), createBlock(resolveDynamicComponent(__props.as), mergeProps({
        ref_key: "root",
        ref: root,
        as: __props.asDeep,
        class: [
          unref(configuration).classesList.button,
          __props.disabled ? unref(configuration).classesList.disableOpacity : "",
          __props.loading || __props.disabled ? unref(configuration).classesList.busyOrInvalidState : unref(configuration).classesList.validState,
          !__props.disabled && !__props.loading ? unref(configuration).classesList.enableOpacity : "",
          props.rounded === "circle" ? unref(configuration).classesList.paddingCircle : unref(configuration).classesList.padding,
          props.rounded === "full" ? unref(configuration).classesList.roundedFull : "",
          props.rounded === "circle" ? unref(configuration).classesList.roundedCircle : "",
          props.rounded === "top" ? unref(configuration).classesList.roundedTop : "",
          props.rounded === "bottom" ? unref(configuration).classesList.roundedBottom : "",
          props.rounded === "left" ? unref(configuration).classesList.roundedLeft : "",
          props.rounded === "right" ? unref(configuration).classesList.roundedRight : "",
          props.rounded === "top-left" ? unref(configuration).classesList.roundedTopLeft : "",
          props.rounded === "top-right" ? unref(configuration).classesList.roundedTopRight : "",
          props.rounded === "bottom-left" ? unref(configuration).classesList.roundedBottomLeft : "",
          props.rounded === "bottom-right" ? unref(configuration).classesList.roundedBottomRight : ""
        ]
      }, _ctx.$attrs, {
        type: __props.type,
        disabled: __props.disabled,
        onClick: handleClickEvent
      }), {
        default: withCtx(() => [
          createElementVNode("div", {
            class: normalizeClass(unref(configuration).classesList.container)
          }, [
            renderSlot(_ctx.$slots, "default", {}, () => [
              __props.loading ? (openBlock(), createElementBlock("span", _hoisted_1$Z, [
                createVNode(unref(LoadingIcon), {
                  class: normalizeClass(unref(configuration).classesList.spinner)
                }, null, 8, ["class"])
              ])) : createCommentVNode("", true),
              !__props.loading && unref(hasSlot)(_ctx.$slots.icon) ? (openBlock(), createElementBlock("span", _hoisted_2$O, [
                renderSlot(_ctx.$slots, "icon")
              ])) : createCommentVNode("", true),
              renderSlot(_ctx.$slots, "label", {}, () => [
                createElementVNode("span", null, toDisplayString(__props.label), 1)
              ])
            ])
          ], 2)
        ]),
        _: 3
      }, 16, ["as", "class", "type", "disabled"]);
    };
  }
});

const avatarConfig = {
  fixedClasses: {
    wrapper: "",
    wrapperImageAndButtons: "",
    imageAndPreviewContainer: "flex items-center justify-center cursor-pointer",
    imagePreviewContainer: "mt-2",
    currentImage: "rounded-full object-cover",
    avatarPlaceholder: "inline-flex items-center justify-center rounded-full rounded-full p-5 border-0 ring-1",
    avatarPlaceholderText: "text-sm font-light leading-none",
    buttonsContainer: "flex items-center justify-center mt-2",
    preview: "relative shadow-sm rounded-full border-0 ring-1",
    size: "h-20 w-20"
  },
  // Default Input appearance
  classes: {
    wrapper: "relative",
    wrapperImageAndButtons: "",
    imageAndPreviewContainer: "",
    imagePreviewContainer: "",
    currentImage: "",
    avatarPlaceholder: "bg-primary-100 text-primary-800 dark:bg-gray-600 dark:text-white ring-gray-300 dark:ring-white/30",
    avatarPlaceholderText: "",
    buttonsContainer: "",
    preview: "ring-gray-300 dark:ring-white/30",
    size: ""
  },
  // Variants
  variants: {
    // Used for Errors
    error: {
      classes: {
        wrapper: "relative",
        wrapperImageAndButtons: "",
        imageAndPreviewContainer: "",
        imagePreviewContainer: "",
        currentImage: "",
        avatarPlaceholder: "bg-red-100 text-red-500 ring-red-300 dark:ring-red-500/60",
        avatarPlaceholderText: "",
        buttonsContainer: "",
        preview: "",
        size: "h-20 w-20"
      }
    }
  }
};
const avatarClassesKeys = Object.keys(avatarConfig.classes);

const _hoisted_1$Y = ["id", "name"];
const _hoisted_2$N = ["src", "alt"];
const _hoisted_3$v = {
  key: 0,
  class: "mt-2"
};
const __default__$L = {
  name: "VanillaAvatar",
  inheritAttrs: false
};
const _sfc_main$W = /* @__PURE__ */ defineComponent({
  ...__default__$L,
  props: {
    ...useVariantProps$1(),
    modelValue: {
      default: void 0
    },
    currentPhotoUrl: {
      type: [String, void 0],
      default: void 0
    },
    currentPhotoAltTag: {
      type: [String, void 0],
      default: "avatar"
    },
    avatarInitials: {
      type: [String, void 0],
      default: "Avatar"
    },
    uploadButtonLabel: {
      type: [String, void 0],
      default: "Change Profile Photo"
    },
    resetButtonLabel: {
      type: [String, void 0],
      default: "Clear Photo"
    },
    uploadButtonVariant: {
      type: [String, void 0],
      default: void 0
    },
    resetButtonVariant: {
      type: [String, void 0],
      default: void 0
    }
  },
  emits: [
    "update:modelValue",
    "previewUpdated",
    "previewReset",
    "uploadTriggered"
  ],
  setup(__props, { emit }) {
    const props = __props;
    const localValue = useVModel(props, "modelValue");
    const { configuration, errors, hasErrors } = useConfiguration(avatarConfig, "Avatar", localValue);
    const photoPreview = ref(null);
    const photoInput = ref(null);
    const updateAvatarPreview = () => {
      const reader = new FileReader();
      reader.onload = (event) => {
        photoPreview.value = event?.target?.result;
        emit("previewUpdated", photoPreview.value);
      };
      localValue.value = photoInput?.value?.files[0];
      if (localValue.value) {
        reader.readAsDataURL(localValue.value);
      }
    };
    const triggerFileUploadAction = () => {
      photoInput.value.click();
      emit("uploadTriggered", true);
    };
    const resetPhoto = () => {
      localValue.value = void 0;
      photoPreview.value = null;
      photoInput.value.value = null;
      emit("previewReset", true);
    };
    watch(() => props.currentPhotoUrl, (newValue) => {
      if (newValue) {
        photoPreview.value = null;
      }
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(["vanilla-input", unref(configuration).classesList.wrapper])
      }, [
        createElementVNode("div", {
          class: normalizeClass(unref(configuration).classesList.wrapperImageAndButtons)
        }, [
          createElementVNode("input", {
            id: _ctx.name,
            ref_key: "photoInput",
            ref: photoInput,
            name: _ctx.name,
            style: { "display": "none" },
            type: "file",
            onChange: updateAvatarPreview
          }, null, 40, _hoisted_1$Y),
          createElementVNode("div", mergeProps({
            class: unref(configuration).classesList.imageAndPreviewContainer
          }, _ctx.$attrs), [
            renderSlot(_ctx.$slots, "photo", normalizeProps(guardReactiveProps({
              currentPhotoUrl: __props.currentPhotoUrl,
              currentPhotoAltTag: __props.currentPhotoAltTag,
              avatarInitials: __props.avatarInitials,
              hasErrors: unref(hasErrors),
              triggerFileUploadAction
            })), () => [
              withDirectives(createElementVNode("div", {
                class: normalizeClass([
                  unref(configuration).classesList.imagePreviewContainer,
                  unref(configuration).classesList.size
                ]),
                onClick: triggerFileUploadAction
              }, [
                __props.currentPhotoUrl ? (openBlock(), createElementBlock("img", {
                  key: 0,
                  src: __props.currentPhotoUrl,
                  alt: __props.currentPhotoAltTag,
                  class: normalizeClass([
                    unref(configuration).classesList.currentImage,
                    unref(configuration).classesList.size
                  ])
                }, null, 10, _hoisted_2$N)) : (openBlock(), createElementBlock("span", {
                  key: 1,
                  class: normalizeClass(unref(configuration).classesList.avatarPlaceholderText)
                }, [
                  createElementVNode("span", {
                    class: normalizeClass([
                      unref(configuration).classesList.avatarPlaceholder,
                      unref(configuration).classesList.size
                    ])
                  }, toDisplayString(__props.avatarInitials), 3)
                ], 2))
              ], 2), [
                [vShow, !photoPreview.value]
              ])
            ]),
            renderSlot(_ctx.$slots, "preview", normalizeProps(guardReactiveProps({ photoPreview: photoPreview.value })), () => [
              photoPreview.value ? (openBlock(), createElementBlock("div", _hoisted_3$v, [
                createElementVNode("div", {
                  style: normalizeStyle(`background-size: cover; background-repeat: no-repeat; background-position: center center; background-image: url('${photoPreview.value}');`),
                  class: normalizeClass([
                    unref(configuration).classesList.preview,
                    unref(configuration).classesList.size
                  ])
                }, null, 6)
              ])) : createCommentVNode("", true)
            ])
          ], 16),
          createElementVNode("div", {
            class: normalizeClass(unref(configuration).classesList.buttonsContainer)
          }, [
            renderSlot(_ctx.$slots, "uploadButton", normalizeProps(guardReactiveProps({ triggerFileUploadAction, hasErrors: unref(hasErrors), photoPreview: photoPreview.value })), () => [
              !photoPreview.value ? (openBlock(), createBlock(_sfc_main$X, {
                key: 0,
                type: "button",
                variant: __props.uploadButtonVariant,
                onClick: triggerFileUploadAction
              }, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(__props.uploadButtonLabel), 1)
                ]),
                _: 1
              }, 8, ["variant"])) : createCommentVNode("", true)
            ]),
            renderSlot(_ctx.$slots, "resetButton", normalizeProps(guardReactiveProps({ resetPhoto, hasErrors: unref(hasErrors), photoPreview: photoPreview.value })), () => [
              photoPreview.value ? (openBlock(), createBlock(_sfc_main$X, {
                key: 0,
                type: "button",
                variant: __props.resetButtonVariant,
                onClick: resetPhoto
              }, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(__props.resetButtonLabel), 1)
                ]),
                _: 1
              }, 8, ["variant"])) : createCommentVNode("", true)
            ]),
            renderSlot(_ctx.$slots, "otherButtons", normalizeProps(guardReactiveProps({ resetPhoto, triggerFileUploadAction })))
          ], 2)
        ], 2),
        renderSlot(_ctx.$slots, "errors", normalizeProps(guardReactiveProps({ hasErrors: unref(hasErrors), errors: unref(errors) })), () => [
          unref(hasErrors) && props.showErrors ? (openBlock(), createBlock(_sfc_main$Z, {
            key: 0,
            errors: unref(errors)
          }, null, 8, ["errors"])) : createCommentVNode("", true)
        ]),
        renderSlot(_ctx.$slots, "feedback", normalizeProps(guardReactiveProps({ hasErrors: unref(hasErrors), feedback: props.feedback })), () => [
          !unref(hasErrors) && props.feedback && props.showFeedback ? (openBlock(), createBlock(_sfc_main$Y, {
            key: 0,
            text: props.feedback
          }, null, 8, ["text"])) : createCommentVNode("", true)
        ])
      ], 2);
    };
  }
});

const __default__$K = {
  name: "VanillaCardFooter",
  inheritAttrs: true
};
const _sfc_main$V = /* @__PURE__ */ defineComponent({
  ...__default__$K,
  props: {
    columns: {
      type: [Number, String],
      default: 1,
      required: false
    },
    type: {
      type: String,
      default: "simple",
      required: false,
      validator(value) {
        return ["simple", "grid", "split"].includes(value);
      }
    },
    align: {
      type: String,
      default: "right",
      required: false,
      validator(value) {
        return ["right", "left", "center", "none"].includes(value);
      }
    },
    border: {
      type: [Boolean, String],
      default: false,
      required: false
    }
  },
  setup(__props) {
    const classesList = useInjectsClassesList();
    return (_ctx, _cache) => {
      return __props.type === "simple" ? (openBlock(), createElementBlock("div", {
        key: 0,
        class: normalizeClass([
          __props.align === "right" ? unref(classesList).footerSimpleRight : "",
          __props.align === "left" ? unref(classesList).footerSimpleLeft : "",
          __props.align === "center" ? unref(classesList).footerSimpleCenter : "",
          __props.align === "none" || __props.align === void 0 ? unref(classesList).footerSimple : "",
          __props.border ? unref(classesList).footerBorder : ""
        ])
      }, [
        renderSlot(_ctx.$slots, "default")
      ], 2)) : __props.type === "grid" ? (openBlock(), createElementBlock("div", {
        key: 1,
        class: normalizeClass([
          __props.columns === 1 ? unref(classesList).footerWithOneGrid : "",
          __props.columns === 2 ? unref(classesList).footerWithTwoGrids : "",
          __props.columns === 3 ? unref(classesList).footerWithThreeGrids : "",
          __props.border ? unref(classesList).footerBorder : "",
          unref(classesList).footerWithGrid
        ])
      }, [
        renderSlot(_ctx.$slots, "default")
      ], 2)) : __props.type === "split" ? (openBlock(), createElementBlock("div", {
        key: 2,
        class: normalizeClass([
          __props.border ? unref(classesList).footerBorder : "",
          unref(classesList).footerSplitContainer
        ])
      }, [
        createElementVNode("div", {
          class: normalizeClass(unref(classesList).footerSplitLeft)
        }, [
          renderSlot(_ctx.$slots, "left")
        ], 2),
        createElementVNode("div", {
          class: normalizeClass(unref(classesList).footerSplitRight)
        }, [
          renderSlot(_ctx.$slots, "right")
        ], 2)
      ], 2)) : createCommentVNode("", true);
    };
  }
});

const defaultCard = {
  card: "relative bg-white shadow-lg rounded-lg dark:bg-gray-800/70 dark:text-white dark:shadow-dark-xl ring-1 ring-gray-900/10 dark:ring-white/10",
  header: "px-4 py-5 border-b border-gray-200 sm:px-6 dark:border-gray-700",
  headerInner: "flex justify-between items-center flex-wrap sm:flex-nowrap",
  titleWrapper: "flex items-center text-left",
  title: "text-lg leading-6 font-medium text-gray-800 dark:text-white",
  subtitle: "mt-1 max-w-2xl text-sm leading-5 text-gray-500 dark:text-gray-400",
  actions: "sm:ml-4 mt-4 sm:mt-0 flex space-x-1 content-center flex-wrap flex-shrink",
  body: "rounded-lg",
  bodyDivided: "sm:divide-y sm:divide-gray-200 dark:divide-gray-800",
  bodyDividedDarker: "sm:divide-y sm:divide-gray-200 dark:divide-gray-900",
  bodyDarker: "bg-gray-50 dark:bg-gray-800",
  bodyWithPadding: "px-4 sm:px-8 py-4 sm:py-8",
  footer: "px-4 py-3 flex items-center justify-center sm:justify-end text-right sm:px-6 border-t border-gray-200 dark:border-gray-700",
  footerBorder: "border-t border-gray-200 dark:border-gray-700",
  footerSimple: "p-4 sm:p-6",
  footerSimpleRight: "justify-end text-right flex items-center text-right space-x-2",
  footerSimpleLeft: "justify-start text-left flex items-center text-right space-x-2",
  footerSimpleCenter: "justify-center text-center flex items-center text-right space-x-2",
  footerWithGrid: "p-4 sm:p-6",
  footerWithOneGrid: "sm:grid sm:grid-cols-1 sm:gap-3 sm:grid-flow-row-dense",
  footerWithTwoGrids: "sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense space-y-2 sm:space-y-0",
  footerWithThreeGrids: "sm:grid sm:grid-cols-3 sm:gap-3 sm:grid-flow-row-dense",
  footerSplitContainer: "sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense w-full",
  footerSplitLeft: "flex mt-0 ml-0 items-center justify-center sm:justify-start mb-2 sm:mb-0",
  footerSplitRight: "flex mt-0 sm:mt-0 items-center justify-center sm:justify-end",
  emptyStateContainer: "flex items-center justify-center text-center px-6 py-8 rounded-lg",
  emptyState: "text-sm w-full",
  emptyIcon: "text-gray-200 dark:text-gray-600"
};
const cardConfig = {
  fixedClasses: {
    bodyDivided: "",
    title: ""
  },
  classes: {
    ...defaultCard
  },
  variants: {
    simple: {
      classes: {
        ...defaultCard,
        header: "px-4 py-5 sm:px-6",
        footer: "bg-gray-50 dark:bg-gray-800/50 px-4 py-3 flex items-center justify-end text-right sm:px-6"
      }
    }
  }
};
const cardClassesKeys = Object.keys(cardConfig.classes);

const _hoisted_1$X = ["innerHTML"];
const _hoisted_2$M = ["innerHTML"];
const __default__$J = {
  name: "VanillaCard",
  inheritAttrs: true
};
const _sfc_main$U = /* @__PURE__ */ defineComponent({
  ...__default__$J,
  props: {
    ...useVariantProps$1(),
    title: {
      type: [String],
      default: void 0
    },
    subtitle: {
      type: [String],
      default: void 0
    },
    as: {
      type: [String],
      default: "div"
    },
    bodyDivided: {
      type: [Boolean],
      default: false
    },
    bodyDarker: {
      type: [Boolean],
      default: false
    },
    bodyWithPadding: {
      type: [Boolean],
      default: false
    },
    bodyClasses: {
      type: [String],
      default: ""
    }
  },
  setup(__props) {
    const props = __props;
    const { configuration } = useConfiguration(cardConfig, "Card");
    provide("configuration_vanilla", configuration);
    return (_ctx, _cache) => {
      return openBlock(), createBlock(resolveDynamicComponent(__props.as), mergeProps({
        class: unref(configuration).classesList.card
      }, _ctx.$attrs), {
        default: withCtx(() => [
          unref(hasSlot)(_ctx.$slots.title) || unref(hasSlot)(_ctx.$slots.subtitle) || unref(hasSlot)(_ctx.$slots.actions) || props.title || props.subtitle ? (openBlock(), createElementBlock("div", {
            key: 0,
            class: normalizeClass([
              unref(configuration).classesList.header
            ])
          }, [
            createElementVNode("div", {
              class: normalizeClass([
                unref(configuration).classesList.headerInner
              ])
            }, [
              createElementVNode("div", {
                class: normalizeClass(unref(configuration).classesList.titleWrapper)
              }, [
                createElementVNode("div", null, [
                  unref(hasSlot)(_ctx.$slots.title) || __props.title !== "" ? (openBlock(), createElementBlock("h3", {
                    key: 0,
                    class: normalizeClass(unref(configuration).classesList.title)
                  }, [
                    renderSlot(_ctx.$slots, "title", {}, () => [
                      createElementVNode("span", { innerHTML: __props.title }, null, 8, _hoisted_1$X)
                    ])
                  ], 2)) : createCommentVNode("", true),
                  unref(hasSlot)(_ctx.$slots.subtitle) || __props.subtitle !== "" ? (openBlock(), createElementBlock("p", {
                    key: 1,
                    class: normalizeClass(unref(configuration).classesList.subtitle)
                  }, [
                    renderSlot(_ctx.$slots, "subtitle", {}, () => [
                      __props.subtitle !== "" ? (openBlock(), createElementBlock("span", {
                        key: 0,
                        innerHTML: __props.subtitle
                      }, null, 8, _hoisted_2$M)) : createCommentVNode("", true)
                    ])
                  ], 2)) : createCommentVNode("", true)
                ])
              ], 2),
              unref(hasSlot)(_ctx.$slots.actions) ? (openBlock(), createElementBlock("div", {
                key: 0,
                class: normalizeClass(unref(configuration).classesList.actions)
              }, [
                renderSlot(_ctx.$slots, "actions")
              ], 2)) : createCommentVNode("", true)
            ], 2)
          ], 2)) : createCommentVNode("", true),
          createElementVNode("div", {
            class: normalizeClass([
              unref(configuration).classesList.body,
              __props.bodyDivided && !__props.bodyDarker ? unref(configuration).classesList.bodyDivided : "",
              __props.bodyDivided && __props.bodyDarker ? unref(configuration).classesList.bodyDividedDarker : "",
              __props.bodyWithPadding ? unref(configuration).classesList.bodyWithPadding : "",
              __props.bodyDarker ? unref(configuration).classesList.bodyDarker : "",
              __props.bodyClasses
            ])
          }, [
            renderSlot(_ctx.$slots, "default")
          ], 2),
          unref(hasSlot)(_ctx.$slots.footer) ? (openBlock(), createElementBlock("div", {
            key: 1,
            class: normalizeClass(unref(configuration).classesList.footer)
          }, [
            renderSlot(_ctx.$slots, "footer")
          ], 2)) : createCommentVNode("", true),
          unref(hasSlot)(_ctx.$slots.footerActions) ? (openBlock(), createElementBlock("div", {
            key: 2,
            class: normalizeClass(unref(configuration).classesList.footer)
          }, [
            createVNode(_sfc_main$V, null, {
              default: withCtx(() => [
                renderSlot(_ctx.$slots, "footerActions")
              ]),
              _: 3
            })
          ], 2)) : createCommentVNode("", true),
          renderSlot(_ctx.$slots, "footerVanilla")
        ]),
        _: 3
      }, 16, ["class"]);
    };
  }
});

const __default__$I = {
  name: "VanillaCardEmptyPlaceholder",
  inheritAttrs: true
};
const _sfc_main$T = /* @__PURE__ */ defineComponent({
  ...__default__$I,
  setup(__props) {
    const classesList = useInjectsClassesList();
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(unref(classesList).emptyStateContainer)
      }, [
        createElementVNode("div", {
          class: normalizeClass(unref(classesList).emptyState)
        }, [
          renderSlot(_ctx.$slots, "default")
        ], 2)
      ], 2);
    };
  }
});

const checkboxConfig = {
  fixedClasses: {
    wrapper: "flex",
    wrapperLeftTop: "justify-start items-start",
    wrapperLeftCenter: "justify-start items-center",
    wrapperLeftBottom: "justify-start items-end",
    wrapperRightTop: "justify-end items-start",
    wrapperRightCenter: "justify-end items-center",
    wrapperRightBottom: "justify-end items-end",
    wrapperCenterTop: "justify-center items-start",
    wrapperCenterCenter: "justify-center items-center",
    wrapperCenterBottom: "justify-center items-end",
    container: "",
    checkbox: "h-5 w-5 transition duration-150 ease-in-out relative rounded",
    label: {
      label: ""
    },
    groupContainer: "grid grid-cols-1 space-y-3",
    groupCheckboxWrapper: "relative flex items-start",
    groupCheckboxWrapperNotHighlighted: "",
    groupCheckboxWrapperHighlighted: "",
    groupCheckbox: "flex items-center h-5",
    groupLabelWrapper: "ml-3 text-sm leading-5",
    groupLabelFeedback: "text-gray-500",
    disabled: commonClasses.disabled
  },
  // Default Input appearance
  classes: {
    wrapper: "",
    wrapperLeftTop: "",
    wrapperLeftCenter: "",
    wrapperLeftBottom: "",
    wrapperRightTop: "",
    wrapperRightCenter: "",
    wrapperRightBottom: "",
    wrapperCenterTop: "",
    wrapperCenterCenter: "",
    wrapperCenterBottom: "",
    container: "",
    checkbox: mergeClasses(
      "border-gray-300 text-primary-600 focus:ring-primary-500 checked:border-0",
      "dark:focus:ring-offset-gray-900 dark:border-gray-600 dark:bg-gray-900 dark:checked:bg-primary-600"
    ),
    label: {
      label: "block font-medium text-sm text-gray-700 dark:text-white cursor-pointer"
    },
    groupContainer: "",
    groupCheckboxWrapper: "",
    groupCheckboxWrapperNotHighlighted: "",
    groupCheckboxWrapperHighlighted: "",
    groupCheckbox: "",
    groupLabelWrapper: "",
    groupLabelFeedback: "",
    disabled: ""
  },
  // Variants
  variants: {
    // Used for Errors
    error: {
      classes: {
        wrapper: "",
        container: "",
        checkbox: mergeClasses(
          "text-red-600 border-red-300 placeholder-red-300 dark:bg-gray-900",
          "focus:ring-red-500",
          "checked:bg-red-600 checked:text-white",
          "dark:checked:bg-red-600 dark:focus:ring-offset-gray-900"
        ),
        label: {
          label: "block font-medium text-sm text-gray-700 dark:text-white cursor-pointer"
        },
        groupContainer: "",
        groupCheckboxWrapper: "",
        groupCheckbox: "",
        groupLabelWrapper: ""
      }
    }
  }
};
const checkboxClassesKeys = Object.keys(checkboxConfig.classes);

const _hoisted_1$W = ["id", "checked", "name", "value", "disabled"];
const __default__$H = {
  name: "VanillaCheckbox",
  inheritAttrs: false
};
const _sfc_main$S = /* @__PURE__ */ defineComponent({
  ...__default__$H,
  props: {
    ...useVariantProps$1(),
    modelValue: {
      type: [String, Number, Boolean, Array, Object, Date, Function, Symbol],
      default: void 0
    },
    checked: {
      type: [Boolean],
      default: false
    },
    value: {
      type: [String, Number, Boolean, Array, Object, Date, Function, Symbol, void 0],
      default: false
    },
    checkedValue: {
      type: [String, Number, Boolean, Array, Object, Date, Function, Symbol],
      default: true
    },
    uncheckedValue: {
      type: [String, Number, Boolean, Array, Object, Date, Function, Symbol],
      default: false
    },
    align: {
      type: [String],
      required: false,
      default: "left-top",
      validator(align) {
        return [
          "left-top",
          "left-center",
          "left-bottom",
          "right-top",
          "right-center",
          "right-bottom",
          "center-top",
          "center-center",
          "center-bottom"
        ].includes(align);
      }
    }
  },
  emits: ["click", "update:modelValue", "focus", "focusout"],
  setup(__props, { emit }) {
    const props = __props;
    const localValue = useVModel(props, "modelValue");
    const { configuration, errors, hasErrors } = useConfiguration(checkboxConfig, "Checkbox", localValue);
    const emitUpdate = (event) => {
      const isChecked2 = event.target?.checked;
      if (Array.isArray(localValue.value)) {
        const newValue = [...localValue.value];
        if (isChecked2) {
          newValue.push(props.value);
        } else {
          newValue.splice(newValue.indexOf(props.value), 1);
        }
        localValue.value = newValue;
        return;
      }
      if (typeof localValue.value === "object" && localValue.value !== null) {
        const temporaryValue = props.value;
        const temporaryObject = localValue.value;
        if (isChecked2) {
          temporaryObject[temporaryValue] = true;
        } else {
          delete temporaryObject[temporaryValue];
        }
        localValue.value = temporaryObject;
        return;
      }
      const toggleValue = isChecked2 ? props.checkedValue : props.uncheckedValue;
      localValue.value = toggleValue;
    };
    const isChecked = computed(() => {
      if (Array.isArray(localValue.value) && typeof props.value === "string") {
        return localValue.value.includes(props.value);
      }
      return localValue.value === props.checkedValue;
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(["vanilla-input", unref(configuration).classesList.container])
      }, [
        createElementVNode("div", {
          class: normalizeClass([
            unref(configuration).classesList.wrapper,
            __props.align === "left-top" ? unref(configuration).classesList.wrapperLeftTop : "",
            __props.align === "left-center" ? unref(configuration).classesList.wrapperLeftCenter : "",
            __props.align === "left-bottom" ? unref(configuration).classesList.wrapperLeftBottom : "",
            __props.align === "right-top" ? unref(configuration).classesList.wrapperRightTop : "",
            __props.align === "right-center" ? unref(configuration).classesList.wrapperRightCenter : "",
            __props.align === "right-bottom" ? unref(configuration).classesList.wrapperRightBottom : "",
            __props.align === "center-top" ? unref(configuration).classesList.wrapperCenterTop : "",
            __props.align === "center-center" ? unref(configuration).classesList.wrapperCenterCenter : "",
            __props.align === "center-bottom" ? unref(configuration).classesList.wrapperCenterBottom : ""
          ])
        }, [
          createElementVNode("input", mergeProps({
            id: _ctx.name,
            ref: "input",
            checked: unref(isChecked),
            class: [
              unref(configuration).classesList.checkbox,
              _ctx.disabled ? unref(configuration).classesList.disabled : ""
            ],
            name: _ctx.name,
            value: __props.value,
            type: "checkbox"
          }, _ctx.$attrs, {
            disabled: _ctx.disabled,
            onChange: emitUpdate,
            onClick: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("click", $event)),
            onFocus: _cache[1] || (_cache[1] = ($event) => _ctx.$emit("focus", $event)),
            onFocusout: _cache[2] || (_cache[2] = ($event) => _ctx.$emit("focusout", $event))
          }), null, 16, _hoisted_1$W),
          renderSlot(_ctx.$slots, "default", normalizeProps(guardReactiveProps({ hasErrors: unref(hasErrors), errors: unref(errors) })))
        ], 2),
        renderSlot(_ctx.$slots, "errors", normalizeProps(guardReactiveProps({ hasErrors: unref(hasErrors), errors: unref(errors) })), () => [
          unref(hasErrors) && props.showErrors ? (openBlock(), createBlock(_sfc_main$Z, {
            key: 0,
            errors: unref(errors)
          }, null, 8, ["errors"])) : createCommentVNode("", true)
        ]),
        renderSlot(_ctx.$slots, "feedback", normalizeProps(guardReactiveProps({ hasErrors: unref(hasErrors), feedback: props.feedback })), () => [
          !unref(hasErrors) && props.feedback && props.showFeedback ? (openBlock(), createBlock(_sfc_main$Y, {
            key: 0,
            text: props.feedback
          }, null, 8, ["text"])) : createCommentVNode("", true)
        ])
      ], 2);
    };
  }
});

const _hoisted_1$V = ["innerHTML"];
const _hoisted_2$L = ["textContent"];
const __default__$G = {
  name: "VanillaFormLabel",
  inheritAttrs: true
};
const _sfc_main$R = /* @__PURE__ */ defineComponent({
  ...__default__$G,
  props: {
    ...useVariantProps$1(),
    label: {
      type: [String],
      required: true
    },
    for: {
      type: [String, void 0],
      default: void 0,
      required: false
    },
    safe: {
      type: [Boolean],
      default: true,
      required: false
    },
    as: {
      type: [String],
      default: "label",
      required: false
    }
  },
  setup(__props) {
    const props = __props;
    const { configuration } = useConfiguration(formsConfig, "FormLabel");
    return (_ctx, _cache) => {
      return openBlock(), createBlock(resolveDynamicComponent(__props.as), {
        for: props.for,
        class: normalizeClass([
          unref(configuration).classesList.label,
          _ctx.disabled ? unref(configuration).classesList.disabled : ""
        ])
      }, {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "before"),
          renderSlot(_ctx.$slots, "default", {}, () => [
            __props.safe ? (openBlock(), createElementBlock("span", {
              key: 0,
              class: normalizeClass(unref(configuration).classesList.labelInner),
              innerHTML: __props.label
            }, null, 10, _hoisted_1$V)) : (openBlock(), createElementBlock("span", {
              key: 1,
              class: normalizeClass(unref(configuration).classesList.labelInner),
              textContent: toDisplayString(__props.label)
            }, null, 10, _hoisted_2$L))
          ]),
          renderSlot(_ctx.$slots, "after")
        ]),
        _: 3
      }, 8, ["for", "class"]);
    };
  }
});

const _hoisted_1$U = { class: "vanilla-checkbox-group-wrapper" };
const _hoisted_2$K = ["textContent"];
const __default__$F = {
  name: "VanillaCheckboxGroup",
  inheritAttrs: false
};
const _sfc_main$Q = /* @__PURE__ */ defineComponent({
  ...__default__$F,
  props: {
    ...useVariantProps$1(),
    modelValue: {
      type: [Array],
      default: void 0
    },
    options: {
      type: [Array, Object],
      default: void 0
    },
    normalizeOptions: {
      type: Boolean,
      default: true
    },
    valueAttribute: {
      type: String,
      default: "value"
    },
    textAttribute: {
      type: String,
      default: "text"
    },
    navigation: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: [Boolean],
      required: false,
      default: false
    }
  },
  emits: ["update:modelValue", "focus", "focusout", "click"],
  setup(__props, { emit }) {
    const props = __props;
    const { localValue } = useMultipleVModel(props, "modelValue", true);
    const { configuration, errors, hasErrors, variant } = useConfiguration(checkboxConfig, "Checkbox", localValue);
    const { normalizedOptions } = useMultipleOptions(
      computed(() => props.options),
      computed(() => props.textAttribute),
      computed(() => props.valueAttribute),
      computed(() => props.normalizeOptions)
    );
    if (!Array.isArray(localValue.value)) {
      localValue.value = [];
    }
    const root = ref(null);
    const isOptionSelected = (normalizedOption) => {
      if (Array.isArray(localValue.value)) {
        return localValue.value.includes(normalizedOption.value);
      }
      return localValue.value === normalizedOption.value;
    };
    const focusElement = (currentIndex, direction) => {
      const group = root.value?.children;
      if (group === void 0) {
        return;
      }
      const newIndex = (currentIndex + direction + group.length) % group.length;
      group[newIndex].focus();
    };
    const handleKeydown = (event, currentIndex) => {
      if (!root.value?.contains(event.target)) {
        return;
      }
      if (event.key === "ArrowLeft" || event.key === "ArrowUp") {
        focusElement(currentIndex, -1);
        return;
      }
      if (event.key === "ArrowRight" || event.key === "ArrowDown") {
        focusElement(currentIndex, 1);
      }
    };
    const generateUniqueId = (name, id) => `${props.name}_${name.toLowerCase().replace(/\s+/g, "-")}_${id}`;
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$U, [
        createElementVNode("div", {
          ref_key: "root",
          ref: root,
          class: normalizeClass(["vanilla-checkbox-group", [
            unref(configuration).classesList.container,
            unref(configuration).classesList.groupContainer,
            __props.disabled ? unref(configuration).classesList.disabled : ""
          ]])
        }, [
          (openBlock(true), createElementBlock(Fragment, null, renderList(unref(normalizedOptions), (option, index) => {
            return openBlock(), createBlock(_sfc_main$R, {
              key: index,
              for: generateUniqueId(option.value.toString(), index),
              label: option.text.toString(),
              classes: {
                label: ""
              },
              class: normalizeClass([
                unref(configuration).classesList.groupCheckboxWrapper,
                isOptionSelected(option) ? unref(configuration).classesList.groupCheckboxWrapperHighlighted : unref(configuration).classesList.groupCheckboxWrapperNotHighlighted
              ]),
              onKeydown: ($event) => handleKeydown($event, index)
            }, {
              default: withCtx(() => [
                createElementVNode("div", {
                  class: normalizeClass(unref(configuration).classesList.groupCheckbox)
                }, [
                  createVNode(_sfc_main$S, {
                    modelValue: unref(localValue),
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => isRef(localValue) ? localValue.value = $event : null),
                    name: generateUniqueId(option.value.toString(), index),
                    value: option.value,
                    variant: unref(variant),
                    disabled: __props.disabled || option?.disabled,
                    onFocus: _cache[1] || (_cache[1] = ($event) => _ctx.$emit("focus", $event)),
                    onFocusout: _cache[2] || (_cache[2] = ($event) => _ctx.$emit("focusout", $event))
                  }, null, 8, ["modelValue", "name", "value", "variant", "disabled"])
                ], 2),
                createElementVNode("div", {
                  class: normalizeClass(unref(configuration).classesList.groupLabelWrapper)
                }, [
                  createVNode(_sfc_main$R, {
                    as: "span",
                    for: generateUniqueId(option.value.toString(), index),
                    label: option.text.toString(),
                    disabled: __props.disabled || option?.disabled,
                    classes: {
                      label: unref(configuration).classesList.label.label
                    }
                  }, null, 8, ["for", "label", "disabled", "classes"]),
                  option.raw?.description ? (openBlock(), createElementBlock("span", {
                    key: 0,
                    class: normalizeClass(unref(configuration).classesList.groupLabelFeedback),
                    textContent: toDisplayString(option.raw?.description)
                  }, null, 10, _hoisted_2$K)) : createCommentVNode("", true)
                ], 2)
              ]),
              _: 2
            }, 1032, ["for", "label", "class", "onKeydown"]);
          }), 128))
        ], 2),
        renderSlot(_ctx.$slots, "errors", normalizeProps(guardReactiveProps({ hasErrors: unref(hasErrors), errors: unref(errors) })), () => [
          unref(hasErrors) && unref(errors) ? (openBlock(), createBlock(_sfc_main$Z, {
            key: 0,
            errors: unref(errors)
          }, null, 8, ["errors"])) : createCommentVNode("", true)
        ]),
        renderSlot(_ctx.$slots, "feedback", normalizeProps(guardReactiveProps({ hasErrors: unref(hasErrors), feedback: props.feedback })), () => [
          !unref(hasErrors) && props.feedback && props.showFeedback ? (openBlock(), createBlock(_sfc_main$Y, {
            key: 0,
            text: props.feedback
          }, null, 8, ["text"])) : createCommentVNode("", true)
        ])
      ]);
    };
  }
});

/** Used to stand-in for `undefined` hash values. */

var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd$1(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

var _setCacheAdd = setCacheAdd$1;

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */

function setCacheHas$1(value) {
  return this.__data__.has(value);
}

var _setCacheHas = setCacheHas$1;

var MapCache = _MapCache,
    setCacheAdd = _setCacheAdd,
    setCacheHas = _setCacheHas;

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache$1(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache$1.prototype.add = SetCache$1.prototype.push = setCacheAdd;
SetCache$1.prototype.has = setCacheHas;

var _SetCache = SetCache$1;

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */

function arraySome$1(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

var _arraySome = arraySome$1;

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */

function cacheHas$1(cache, key) {
  return cache.has(key);
}

var _cacheHas = cacheHas$1;

var SetCache = _SetCache,
    arraySome = _arraySome,
    cacheHas = _cacheHas;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$5 = 1,
    COMPARE_UNORDERED_FLAG$3 = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays$2(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$5,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG$3) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

var _equalArrays = equalArrays$2;

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */

function mapToArray$1(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

var _mapToArray = mapToArray$1;

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */

function setToArray$1(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

var _setToArray = setToArray$1;

var Symbol$1 = _Symbol,
    Uint8Array$1 = _Uint8Array,
    eq = eq_1,
    equalArrays$1 = _equalArrays,
    mapToArray = _mapToArray,
    setToArray = _setToArray;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$4 = 1,
    COMPARE_UNORDERED_FLAG$2 = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag$1 = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag$1 = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol$1 ? Symbol$1.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag$1(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array$1(object), new Uint8Array$1(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag$1:
      var convert = mapToArray;

    case setTag$1:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG$4;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG$2;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays$1(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

var _equalByTag = equalByTag$1;

var getAllKeys = _getAllKeys;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$3 = 1;

/** Used for built-in method references. */
var objectProto$3 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$3 = objectProto$3.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects$1(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$3,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty$3.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

var _equalObjects = equalObjects$1;

var Stack$1 = _Stack,
    equalArrays = _equalArrays,
    equalByTag = _equalByTag,
    equalObjects = _equalObjects,
    getTag$2 = _getTag,
    isArray$5 = isArray_1,
    isBuffer$1 = isBufferExports,
    isTypedArray$1 = isTypedArray_1;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$2 = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto$2 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$2 = objectProto$2.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep$1(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray$5(object),
      othIsArr = isArray$5(other),
      objTag = objIsArr ? arrayTag : getTag$2(object),
      othTag = othIsArr ? arrayTag : getTag$2(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer$1(object)) {
    if (!isBuffer$1(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack$1);
    return (objIsArr || isTypedArray$1(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG$2)) {
    var objIsWrapped = objIsObj && hasOwnProperty$2.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty$2.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack$1);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack$1);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

var _baseIsEqualDeep = baseIsEqualDeep$1;

var baseIsEqualDeep = _baseIsEqualDeep,
    isObjectLike$1 = isObjectLike_1;

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual$2(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike$1(value) && !isObjectLike$1(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual$2, stack);
}

var _baseIsEqual = baseIsEqual$2;

var Stack = _Stack,
    baseIsEqual$1 = _baseIsEqual;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$1 = 1,
    COMPARE_UNORDERED_FLAG$1 = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch$1(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual$1(srcValue, objValue, COMPARE_PARTIAL_FLAG$1 | COMPARE_UNORDERED_FLAG$1, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

var _baseIsMatch = baseIsMatch$1;

var isObject$3 = isObject_1;

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable$2(value) {
  return value === value && !isObject$3(value);
}

var _isStrictComparable = isStrictComparable$2;

var isStrictComparable$1 = _isStrictComparable,
    keys$3 = keys_1;

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData$1(object) {
  var result = keys$3(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable$1(value)];
  }
  return result;
}

var _getMatchData = getMatchData$1;

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */

function matchesStrictComparable$2(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

var _matchesStrictComparable = matchesStrictComparable$2;

var baseIsMatch = _baseIsMatch,
    getMatchData = _getMatchData,
    matchesStrictComparable$1 = _matchesStrictComparable;

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches$1(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable$1(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

var _baseMatches = baseMatches$1;

var baseGet$1 = _baseGet;

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get$2(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet$1(object, path);
  return result === undefined ? defaultValue : result;
}

var get_1 = get$2;

var baseIsEqual = _baseIsEqual,
    get$1 = get_1,
    hasIn = hasIn_1,
    isKey$1 = _isKey,
    isStrictComparable = _isStrictComparable,
    matchesStrictComparable = _matchesStrictComparable,
    toKey$1 = _toKey;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty$1(path, srcValue) {
  if (isKey$1(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey$1(path), srcValue);
  }
  return function(object) {
    var objValue = get$1(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

var _baseMatchesProperty = baseMatchesProperty$1;

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */

function baseProperty$1(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

var _baseProperty = baseProperty$1;

var baseGet = _baseGet;

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep$1(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

var _basePropertyDeep = basePropertyDeep$1;

var baseProperty = _baseProperty,
    basePropertyDeep = _basePropertyDeep,
    isKey = _isKey,
    toKey = _toKey;

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property$1(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

var property_1 = property$1;

var baseMatches = _baseMatches,
    baseMatchesProperty = _baseMatchesProperty,
    identity$1 = identity_1,
    isArray$4 = isArray_1,
    property = property_1;

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee$3(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity$1;
  }
  if (typeof value == 'object') {
    return isArray$4(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

var _baseIteratee = baseIteratee$3;

var baseIteratee$2 = _baseIteratee,
    isArrayLike$3 = isArrayLike_1,
    keys$2 = keys_1;

/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */
function createFind$1(findIndexFunc) {
  return function(collection, predicate, fromIndex) {
    var iterable = Object(collection);
    if (!isArrayLike$3(collection)) {
      var iteratee = baseIteratee$2(predicate);
      collection = keys$2(collection);
      predicate = function(key) { return iteratee(iterable[key], key, iterable); };
    }
    var index = findIndexFunc(collection, predicate, fromIndex);
    return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
  };
}

var _createFind = createFind$1;

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */

function baseFindIndex$1(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

var _baseFindIndex = baseFindIndex$1;

/** Used to match a single whitespace character. */

var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex$1(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

var _trimmedEndIndex = trimmedEndIndex$1;

var trimmedEndIndex = _trimmedEndIndex;

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim$1(string) {
  return string
    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
    : string;
}

var _baseTrim = baseTrim$1;

var baseTrim = _baseTrim,
    isObject$2 = isObject_1,
    isSymbol = isSymbol_1;

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber$2(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject$2(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject$2(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

var toNumber_1 = toNumber$2;

var toNumber$1 = toNumber_1;

/** Used as references for various `Number` constants. */
var INFINITY$1 = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite$1(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber$1(value);
  if (value === INFINITY$1 || value === -INFINITY$1) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

var toFinite_1 = toFinite$1;

var toFinite = toFinite_1;

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger$1(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

var toInteger_1 = toInteger$1;

var baseFindIndex = _baseFindIndex,
    baseIteratee$1 = _baseIteratee,
    toInteger = toInteger_1;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax$1 = Math.max;

/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */
function findIndex$2(array, predicate, fromIndex) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return -1;
  }
  var index = fromIndex == null ? 0 : toInteger(fromIndex);
  if (index < 0) {
    index = nativeMax$1(length + index, 0);
  }
  return baseFindIndex(array, baseIteratee$1(predicate), index);
}

var findIndex_1 = findIndex$2;

var createFind = _createFind,
    findIndex$1 = findIndex_1;

/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.find(users, function(o) { return o.age < 40; });
 * // => object for 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.find(users, { 'age': 1, 'active': true });
 * // => object for 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.find(users, ['active', false]);
 * // => object for 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.find(users, 'active');
 * // => object for 'barney'
 */
var find = createFind(findIndex$1);

var find_1 = find;

const find$1 = find_1;

var firstExports = {};
var first$1 = {
  get exports(){ return firstExports; },
  set exports(v){ firstExports = v; },
};

/**
 * Gets the first element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias first
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the first element of `array`.
 * @example
 *
 * _.head([1, 2, 3]);
 * // => 1
 *
 * _.head([]);
 * // => undefined
 */

function head(array) {
  return (array && array.length) ? array[0] : undefined;
}

var head_1 = head;

(function (module) {
	module.exports = head_1;
} (first$1));

const first = /*@__PURE__*/getDefaultExportFromCjs$1(firstExports);

/**
 * Fuse.js v6.6.2 - Lightweight fuzzy-search (http://fusejs.io)
 *
 * Copyright (c) 2022 Kiro Risk (http://kiro.me)
 * All Rights Reserved. Apache Software License 2.0
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 */

function isArray$3(value) {
  return !Array.isArray
    ? getTag$1(value) === '[object Array]'
    : Array.isArray(value)
}

// Adapted from: https://github.com/lodash/lodash/blob/master/.internal/baseToString.js
const INFINITY = 1 / 0;
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value
  }
  let result = value + '';
  return result == '0' && 1 / value == -INFINITY ? '-0' : result
}

function toString(value) {
  return value == null ? '' : baseToString(value)
}

function isString(value) {
  return typeof value === 'string'
}

function isNumber(value) {
  return typeof value === 'number'
}

// Adapted from: https://github.com/lodash/lodash/blob/master/isBoolean.js
function isBoolean(value) {
  return (
    value === true ||
    value === false ||
    (isObjectLike(value) && getTag$1(value) == '[object Boolean]')
  )
}

function isObject$1(value) {
  return typeof value === 'object'
}

// Checks if `value` is object-like.
function isObjectLike(value) {
  return isObject$1(value) && value !== null
}

function isDefined(value) {
  return value !== undefined && value !== null
}

function isBlank(value) {
  return !value.trim().length
}

// Gets the `toStringTag` of `value`.
// Adapted from: https://github.com/lodash/lodash/blob/master/.internal/getTag.js
function getTag$1(value) {
  return value == null
    ? value === undefined
      ? '[object Undefined]'
      : '[object Null]'
    : Object.prototype.toString.call(value)
}

const EXTENDED_SEARCH_UNAVAILABLE = 'Extended search is not available';

const INCORRECT_INDEX_TYPE = "Incorrect 'index' type";

const LOGICAL_SEARCH_INVALID_QUERY_FOR_KEY = (key) =>
  `Invalid value for key ${key}`;

const PATTERN_LENGTH_TOO_LARGE = (max) =>
  `Pattern length exceeds max of ${max}.`;

const MISSING_KEY_PROPERTY = (name) => `Missing ${name} property in key`;

const INVALID_KEY_WEIGHT_VALUE = (key) =>
  `Property 'weight' in key '${key}' must be a positive integer`;

const hasOwn = Object.prototype.hasOwnProperty;

class KeyStore {
  constructor(keys) {
    this._keys = [];
    this._keyMap = {};

    let totalWeight = 0;

    keys.forEach((key) => {
      let obj = createKey(key);

      totalWeight += obj.weight;

      this._keys.push(obj);
      this._keyMap[obj.id] = obj;

      totalWeight += obj.weight;
    });

    // Normalize weights so that their sum is equal to 1
    this._keys.forEach((key) => {
      key.weight /= totalWeight;
    });
  }
  get(keyId) {
    return this._keyMap[keyId]
  }
  keys() {
    return this._keys
  }
  toJSON() {
    return JSON.stringify(this._keys)
  }
}

function createKey(key) {
  let path = null;
  let id = null;
  let src = null;
  let weight = 1;
  let getFn = null;

  if (isString(key) || isArray$3(key)) {
    src = key;
    path = createKeyPath(key);
    id = createKeyId(key);
  } else {
    if (!hasOwn.call(key, 'name')) {
      throw new Error(MISSING_KEY_PROPERTY('name'))
    }

    const name = key.name;
    src = name;

    if (hasOwn.call(key, 'weight')) {
      weight = key.weight;

      if (weight <= 0) {
        throw new Error(INVALID_KEY_WEIGHT_VALUE(name))
      }
    }

    path = createKeyPath(name);
    id = createKeyId(name);
    getFn = key.getFn;
  }

  return { path, id, weight, src, getFn }
}

function createKeyPath(key) {
  return isArray$3(key) ? key : key.split('.')
}

function createKeyId(key) {
  return isArray$3(key) ? key.join('.') : key
}

function get(obj, path) {
  let list = [];
  let arr = false;

  const deepGet = (obj, path, index) => {
    if (!isDefined(obj)) {
      return
    }
    if (!path[index]) {
      // If there's no path left, we've arrived at the object we care about.
      list.push(obj);
    } else {
      let key = path[index];

      const value = obj[key];

      if (!isDefined(value)) {
        return
      }

      // If we're at the last value in the path, and if it's a string/number/bool,
      // add it to the list
      if (
        index === path.length - 1 &&
        (isString(value) || isNumber(value) || isBoolean(value))
      ) {
        list.push(toString(value));
      } else if (isArray$3(value)) {
        arr = true;
        // Search each item in the array.
        for (let i = 0, len = value.length; i < len; i += 1) {
          deepGet(value[i], path, index + 1);
        }
      } else if (path.length) {
        // An object. Recurse further.
        deepGet(value, path, index + 1);
      }
    }
  };

  // Backwards compatibility (since path used to be a string)
  deepGet(obj, isString(path) ? path.split('.') : path, 0);

  return arr ? list : list[0]
}

const MatchOptions = {
  // Whether the matches should be included in the result set. When `true`, each record in the result
  // set will include the indices of the matched characters.
  // These can consequently be used for highlighting purposes.
  includeMatches: false,
  // When `true`, the matching function will continue to the end of a search pattern even if
  // a perfect match has already been located in the string.
  findAllMatches: false,
  // Minimum number of characters that must be matched before a result is considered a match
  minMatchCharLength: 1
};

const BasicOptions = {
  // When `true`, the algorithm continues searching to the end of the input even if a perfect
  // match is found before the end of the same input.
  isCaseSensitive: false,
  // When true, the matching function will continue to the end of a search pattern even if
  includeScore: false,
  // List of properties that will be searched. This also supports nested properties.
  keys: [],
  // Whether to sort the result list, by score
  shouldSort: true,
  // Default sort function: sort by ascending score, ascending index
  sortFn: (a, b) =>
    a.score === b.score ? (a.idx < b.idx ? -1 : 1) : a.score < b.score ? -1 : 1
};

const FuzzyOptions = {
  // Approximately where in the text is the pattern expected to be found?
  location: 0,
  // At what point does the match algorithm give up. A threshold of '0.0' requires a perfect match
  // (of both letters and location), a threshold of '1.0' would match anything.
  threshold: 0.6,
  // Determines how close the match must be to the fuzzy location (specified above).
  // An exact letter match which is 'distance' characters away from the fuzzy location
  // would score as a complete mismatch. A distance of '0' requires the match be at
  // the exact location specified, a threshold of '1000' would require a perfect match
  // to be within 800 characters of the fuzzy location to be found using a 0.8 threshold.
  distance: 100
};

const AdvancedOptions = {
  // When `true`, it enables the use of unix-like search commands
  useExtendedSearch: false,
  // The get function to use when fetching an object's properties.
  // The default will search nested paths *ie foo.bar.baz*
  getFn: get,
  // When `true`, search will ignore `location` and `distance`, so it won't matter
  // where in the string the pattern appears.
  // More info: https://fusejs.io/concepts/scoring-theory.html#fuzziness-score
  ignoreLocation: false,
  // When `true`, the calculation for the relevance score (used for sorting) will
  // ignore the field-length norm.
  // More info: https://fusejs.io/concepts/scoring-theory.html#field-length-norm
  ignoreFieldNorm: false,
  // The weight to determine how much field length norm effects scoring.
  fieldNormWeight: 1
};

var Config = {
  ...BasicOptions,
  ...MatchOptions,
  ...FuzzyOptions,
  ...AdvancedOptions
};

const SPACE = /[^ ]+/g;

// Field-length norm: the shorter the field, the higher the weight.
// Set to 3 decimals to reduce index size.
function norm(weight = 1, mantissa = 3) {
  const cache = new Map();
  const m = Math.pow(10, mantissa);

  return {
    get(value) {
      const numTokens = value.match(SPACE).length;

      if (cache.has(numTokens)) {
        return cache.get(numTokens)
      }

      // Default function is 1/sqrt(x), weight makes that variable
      const norm = 1 / Math.pow(numTokens, 0.5 * weight);

      // In place of `toFixed(mantissa)`, for faster computation
      const n = parseFloat(Math.round(norm * m) / m);

      cache.set(numTokens, n);

      return n
    },
    clear() {
      cache.clear();
    }
  }
}

class FuseIndex {
  constructor({
    getFn = Config.getFn,
    fieldNormWeight = Config.fieldNormWeight
  } = {}) {
    this.norm = norm(fieldNormWeight, 3);
    this.getFn = getFn;
    this.isCreated = false;

    this.setIndexRecords();
  }
  setSources(docs = []) {
    this.docs = docs;
  }
  setIndexRecords(records = []) {
    this.records = records;
  }
  setKeys(keys = []) {
    this.keys = keys;
    this._keysMap = {};
    keys.forEach((key, idx) => {
      this._keysMap[key.id] = idx;
    });
  }
  create() {
    if (this.isCreated || !this.docs.length) {
      return
    }

    this.isCreated = true;

    // List is Array<String>
    if (isString(this.docs[0])) {
      this.docs.forEach((doc, docIndex) => {
        this._addString(doc, docIndex);
      });
    } else {
      // List is Array<Object>
      this.docs.forEach((doc, docIndex) => {
        this._addObject(doc, docIndex);
      });
    }

    this.norm.clear();
  }
  // Adds a doc to the end of the index
  add(doc) {
    const idx = this.size();

    if (isString(doc)) {
      this._addString(doc, idx);
    } else {
      this._addObject(doc, idx);
    }
  }
  // Removes the doc at the specified index of the index
  removeAt(idx) {
    this.records.splice(idx, 1);

    // Change ref index of every subsquent doc
    for (let i = idx, len = this.size(); i < len; i += 1) {
      this.records[i].i -= 1;
    }
  }
  getValueForItemAtKeyId(item, keyId) {
    return item[this._keysMap[keyId]]
  }
  size() {
    return this.records.length
  }
  _addString(doc, docIndex) {
    if (!isDefined(doc) || isBlank(doc)) {
      return
    }

    let record = {
      v: doc,
      i: docIndex,
      n: this.norm.get(doc)
    };

    this.records.push(record);
  }
  _addObject(doc, docIndex) {
    let record = { i: docIndex, $: {} };

    // Iterate over every key (i.e, path), and fetch the value at that key
    this.keys.forEach((key, keyIndex) => {
      let value = key.getFn ? key.getFn(doc) : this.getFn(doc, key.path);

      if (!isDefined(value)) {
        return
      }

      if (isArray$3(value)) {
        let subRecords = [];
        const stack = [{ nestedArrIndex: -1, value }];

        while (stack.length) {
          const { nestedArrIndex, value } = stack.pop();

          if (!isDefined(value)) {
            continue
          }

          if (isString(value) && !isBlank(value)) {
            let subRecord = {
              v: value,
              i: nestedArrIndex,
              n: this.norm.get(value)
            };

            subRecords.push(subRecord);
          } else if (isArray$3(value)) {
            value.forEach((item, k) => {
              stack.push({
                nestedArrIndex: k,
                value: item
              });
            });
          } else ;
        }
        record.$[keyIndex] = subRecords;
      } else if (isString(value) && !isBlank(value)) {
        let subRecord = {
          v: value,
          n: this.norm.get(value)
        };

        record.$[keyIndex] = subRecord;
      }
    });

    this.records.push(record);
  }
  toJSON() {
    return {
      keys: this.keys,
      records: this.records
    }
  }
}

function createIndex(
  keys,
  docs,
  { getFn = Config.getFn, fieldNormWeight = Config.fieldNormWeight } = {}
) {
  const myIndex = new FuseIndex({ getFn, fieldNormWeight });
  myIndex.setKeys(keys.map(createKey));
  myIndex.setSources(docs);
  myIndex.create();
  return myIndex
}

function parseIndex(
  data,
  { getFn = Config.getFn, fieldNormWeight = Config.fieldNormWeight } = {}
) {
  const { keys, records } = data;
  const myIndex = new FuseIndex({ getFn, fieldNormWeight });
  myIndex.setKeys(keys);
  myIndex.setIndexRecords(records);
  return myIndex
}

function computeScore$1(
  pattern,
  {
    errors = 0,
    currentLocation = 0,
    expectedLocation = 0,
    distance = Config.distance,
    ignoreLocation = Config.ignoreLocation
  } = {}
) {
  const accuracy = errors / pattern.length;

  if (ignoreLocation) {
    return accuracy
  }

  const proximity = Math.abs(expectedLocation - currentLocation);

  if (!distance) {
    // Dodge divide by zero error.
    return proximity ? 1.0 : accuracy
  }

  return accuracy + proximity / distance
}

function convertMaskToIndices(
  matchmask = [],
  minMatchCharLength = Config.minMatchCharLength
) {
  let indices = [];
  let start = -1;
  let end = -1;
  let i = 0;

  for (let len = matchmask.length; i < len; i += 1) {
    let match = matchmask[i];
    if (match && start === -1) {
      start = i;
    } else if (!match && start !== -1) {
      end = i - 1;
      if (end - start + 1 >= minMatchCharLength) {
        indices.push([start, end]);
      }
      start = -1;
    }
  }

  // (i-1 - start) + 1 => i - start
  if (matchmask[i - 1] && i - start >= minMatchCharLength) {
    indices.push([start, i - 1]);
  }

  return indices
}

// Machine word size
const MAX_BITS = 32;

function search(
  text,
  pattern,
  patternAlphabet,
  {
    location = Config.location,
    distance = Config.distance,
    threshold = Config.threshold,
    findAllMatches = Config.findAllMatches,
    minMatchCharLength = Config.minMatchCharLength,
    includeMatches = Config.includeMatches,
    ignoreLocation = Config.ignoreLocation
  } = {}
) {
  if (pattern.length > MAX_BITS) {
    throw new Error(PATTERN_LENGTH_TOO_LARGE(MAX_BITS))
  }

  const patternLen = pattern.length;
  // Set starting location at beginning text and initialize the alphabet.
  const textLen = text.length;
  // Handle the case when location > text.length
  const expectedLocation = Math.max(0, Math.min(location, textLen));
  // Highest score beyond which we give up.
  let currentThreshold = threshold;
  // Is there a nearby exact match? (speedup)
  let bestLocation = expectedLocation;

  // Performance: only computer matches when the minMatchCharLength > 1
  // OR if `includeMatches` is true.
  const computeMatches = minMatchCharLength > 1 || includeMatches;
  // A mask of the matches, used for building the indices
  const matchMask = computeMatches ? Array(textLen) : [];

  let index;

  // Get all exact matches, here for speed up
  while ((index = text.indexOf(pattern, bestLocation)) > -1) {
    let score = computeScore$1(pattern, {
      currentLocation: index,
      expectedLocation,
      distance,
      ignoreLocation
    });

    currentThreshold = Math.min(score, currentThreshold);
    bestLocation = index + patternLen;

    if (computeMatches) {
      let i = 0;
      while (i < patternLen) {
        matchMask[index + i] = 1;
        i += 1;
      }
    }
  }

  // Reset the best location
  bestLocation = -1;

  let lastBitArr = [];
  let finalScore = 1;
  let binMax = patternLen + textLen;

  const mask = 1 << (patternLen - 1);

  for (let i = 0; i < patternLen; i += 1) {
    // Scan for the best match; each iteration allows for one more error.
    // Run a binary search to determine how far from the match location we can stray
    // at this error level.
    let binMin = 0;
    let binMid = binMax;

    while (binMin < binMid) {
      const score = computeScore$1(pattern, {
        errors: i,
        currentLocation: expectedLocation + binMid,
        expectedLocation,
        distance,
        ignoreLocation
      });

      if (score <= currentThreshold) {
        binMin = binMid;
      } else {
        binMax = binMid;
      }

      binMid = Math.floor((binMax - binMin) / 2 + binMin);
    }

    // Use the result from this iteration as the maximum for the next.
    binMax = binMid;

    let start = Math.max(1, expectedLocation - binMid + 1);
    let finish = findAllMatches
      ? textLen
      : Math.min(expectedLocation + binMid, textLen) + patternLen;

    // Initialize the bit array
    let bitArr = Array(finish + 2);

    bitArr[finish + 1] = (1 << i) - 1;

    for (let j = finish; j >= start; j -= 1) {
      let currentLocation = j - 1;
      let charMatch = patternAlphabet[text.charAt(currentLocation)];

      if (computeMatches) {
        // Speed up: quick bool to int conversion (i.e, `charMatch ? 1 : 0`)
        matchMask[currentLocation] = +!!charMatch;
      }

      // First pass: exact match
      bitArr[j] = ((bitArr[j + 1] << 1) | 1) & charMatch;

      // Subsequent passes: fuzzy match
      if (i) {
        bitArr[j] |=
          ((lastBitArr[j + 1] | lastBitArr[j]) << 1) | 1 | lastBitArr[j + 1];
      }

      if (bitArr[j] & mask) {
        finalScore = computeScore$1(pattern, {
          errors: i,
          currentLocation,
          expectedLocation,
          distance,
          ignoreLocation
        });

        // This match will almost certainly be better than any existing match.
        // But check anyway.
        if (finalScore <= currentThreshold) {
          // Indeed it is
          currentThreshold = finalScore;
          bestLocation = currentLocation;

          // Already passed `loc`, downhill from here on in.
          if (bestLocation <= expectedLocation) {
            break
          }

          // When passing `bestLocation`, don't exceed our current distance from `expectedLocation`.
          start = Math.max(1, 2 * expectedLocation - bestLocation);
        }
      }
    }

    // No hope for a (better) match at greater error levels.
    const score = computeScore$1(pattern, {
      errors: i + 1,
      currentLocation: expectedLocation,
      expectedLocation,
      distance,
      ignoreLocation
    });

    if (score > currentThreshold) {
      break
    }

    lastBitArr = bitArr;
  }

  const result = {
    isMatch: bestLocation >= 0,
    // Count exact matches (those with a score of 0) to be "almost" exact
    score: Math.max(0.001, finalScore)
  };

  if (computeMatches) {
    const indices = convertMaskToIndices(matchMask, minMatchCharLength);
    if (!indices.length) {
      result.isMatch = false;
    } else if (includeMatches) {
      result.indices = indices;
    }
  }

  return result
}

function createPatternAlphabet(pattern) {
  let mask = {};

  for (let i = 0, len = pattern.length; i < len; i += 1) {
    const char = pattern.charAt(i);
    mask[char] = (mask[char] || 0) | (1 << (len - i - 1));
  }

  return mask
}

class BitapSearch {
  constructor(
    pattern,
    {
      location = Config.location,
      threshold = Config.threshold,
      distance = Config.distance,
      includeMatches = Config.includeMatches,
      findAllMatches = Config.findAllMatches,
      minMatchCharLength = Config.minMatchCharLength,
      isCaseSensitive = Config.isCaseSensitive,
      ignoreLocation = Config.ignoreLocation
    } = {}
  ) {
    this.options = {
      location,
      threshold,
      distance,
      includeMatches,
      findAllMatches,
      minMatchCharLength,
      isCaseSensitive,
      ignoreLocation
    };

    this.pattern = isCaseSensitive ? pattern : pattern.toLowerCase();

    this.chunks = [];

    if (!this.pattern.length) {
      return
    }

    const addChunk = (pattern, startIndex) => {
      this.chunks.push({
        pattern,
        alphabet: createPatternAlphabet(pattern),
        startIndex
      });
    };

    const len = this.pattern.length;

    if (len > MAX_BITS) {
      let i = 0;
      const remainder = len % MAX_BITS;
      const end = len - remainder;

      while (i < end) {
        addChunk(this.pattern.substr(i, MAX_BITS), i);
        i += MAX_BITS;
      }

      if (remainder) {
        const startIndex = len - MAX_BITS;
        addChunk(this.pattern.substr(startIndex), startIndex);
      }
    } else {
      addChunk(this.pattern, 0);
    }
  }

  searchIn(text) {
    const { isCaseSensitive, includeMatches } = this.options;

    if (!isCaseSensitive) {
      text = text.toLowerCase();
    }

    // Exact match
    if (this.pattern === text) {
      let result = {
        isMatch: true,
        score: 0
      };

      if (includeMatches) {
        result.indices = [[0, text.length - 1]];
      }

      return result
    }

    // Otherwise, use Bitap algorithm
    const {
      location,
      distance,
      threshold,
      findAllMatches,
      minMatchCharLength,
      ignoreLocation
    } = this.options;

    let allIndices = [];
    let totalScore = 0;
    let hasMatches = false;

    this.chunks.forEach(({ pattern, alphabet, startIndex }) => {
      const { isMatch, score, indices } = search(text, pattern, alphabet, {
        location: location + startIndex,
        distance,
        threshold,
        findAllMatches,
        minMatchCharLength,
        includeMatches,
        ignoreLocation
      });

      if (isMatch) {
        hasMatches = true;
      }

      totalScore += score;

      if (isMatch && indices) {
        allIndices = [...allIndices, ...indices];
      }
    });

    let result = {
      isMatch: hasMatches,
      score: hasMatches ? totalScore / this.chunks.length : 1
    };

    if (hasMatches && includeMatches) {
      result.indices = allIndices;
    }

    return result
  }
}

class BaseMatch {
  constructor(pattern) {
    this.pattern = pattern;
  }
  static isMultiMatch(pattern) {
    return getMatch(pattern, this.multiRegex)
  }
  static isSingleMatch(pattern) {
    return getMatch(pattern, this.singleRegex)
  }
  search(/*text*/) {}
}

function getMatch(pattern, exp) {
  const matches = pattern.match(exp);
  return matches ? matches[1] : null
}

// Token: 'file

class ExactMatch extends BaseMatch {
  constructor(pattern) {
    super(pattern);
  }
  static get type() {
    return 'exact'
  }
  static get multiRegex() {
    return /^="(.*)"$/
  }
  static get singleRegex() {
    return /^=(.*)$/
  }
  search(text) {
    const isMatch = text === this.pattern;

    return {
      isMatch,
      score: isMatch ? 0 : 1,
      indices: [0, this.pattern.length - 1]
    }
  }
}

// Token: !fire

class InverseExactMatch extends BaseMatch {
  constructor(pattern) {
    super(pattern);
  }
  static get type() {
    return 'inverse-exact'
  }
  static get multiRegex() {
    return /^!"(.*)"$/
  }
  static get singleRegex() {
    return /^!(.*)$/
  }
  search(text) {
    const index = text.indexOf(this.pattern);
    const isMatch = index === -1;

    return {
      isMatch,
      score: isMatch ? 0 : 1,
      indices: [0, text.length - 1]
    }
  }
}

// Token: ^file

class PrefixExactMatch extends BaseMatch {
  constructor(pattern) {
    super(pattern);
  }
  static get type() {
    return 'prefix-exact'
  }
  static get multiRegex() {
    return /^\^"(.*)"$/
  }
  static get singleRegex() {
    return /^\^(.*)$/
  }
  search(text) {
    const isMatch = text.startsWith(this.pattern);

    return {
      isMatch,
      score: isMatch ? 0 : 1,
      indices: [0, this.pattern.length - 1]
    }
  }
}

// Token: !^fire

class InversePrefixExactMatch extends BaseMatch {
  constructor(pattern) {
    super(pattern);
  }
  static get type() {
    return 'inverse-prefix-exact'
  }
  static get multiRegex() {
    return /^!\^"(.*)"$/
  }
  static get singleRegex() {
    return /^!\^(.*)$/
  }
  search(text) {
    const isMatch = !text.startsWith(this.pattern);

    return {
      isMatch,
      score: isMatch ? 0 : 1,
      indices: [0, text.length - 1]
    }
  }
}

// Token: .file$

class SuffixExactMatch extends BaseMatch {
  constructor(pattern) {
    super(pattern);
  }
  static get type() {
    return 'suffix-exact'
  }
  static get multiRegex() {
    return /^"(.*)"\$$/
  }
  static get singleRegex() {
    return /^(.*)\$$/
  }
  search(text) {
    const isMatch = text.endsWith(this.pattern);

    return {
      isMatch,
      score: isMatch ? 0 : 1,
      indices: [text.length - this.pattern.length, text.length - 1]
    }
  }
}

// Token: !.file$

class InverseSuffixExactMatch extends BaseMatch {
  constructor(pattern) {
    super(pattern);
  }
  static get type() {
    return 'inverse-suffix-exact'
  }
  static get multiRegex() {
    return /^!"(.*)"\$$/
  }
  static get singleRegex() {
    return /^!(.*)\$$/
  }
  search(text) {
    const isMatch = !text.endsWith(this.pattern);
    return {
      isMatch,
      score: isMatch ? 0 : 1,
      indices: [0, text.length - 1]
    }
  }
}

class FuzzyMatch extends BaseMatch {
  constructor(
    pattern,
    {
      location = Config.location,
      threshold = Config.threshold,
      distance = Config.distance,
      includeMatches = Config.includeMatches,
      findAllMatches = Config.findAllMatches,
      minMatchCharLength = Config.minMatchCharLength,
      isCaseSensitive = Config.isCaseSensitive,
      ignoreLocation = Config.ignoreLocation
    } = {}
  ) {
    super(pattern);
    this._bitapSearch = new BitapSearch(pattern, {
      location,
      threshold,
      distance,
      includeMatches,
      findAllMatches,
      minMatchCharLength,
      isCaseSensitive,
      ignoreLocation
    });
  }
  static get type() {
    return 'fuzzy'
  }
  static get multiRegex() {
    return /^"(.*)"$/
  }
  static get singleRegex() {
    return /^(.*)$/
  }
  search(text) {
    return this._bitapSearch.searchIn(text)
  }
}

// Token: 'file

class IncludeMatch extends BaseMatch {
  constructor(pattern) {
    super(pattern);
  }
  static get type() {
    return 'include'
  }
  static get multiRegex() {
    return /^'"(.*)"$/
  }
  static get singleRegex() {
    return /^'(.*)$/
  }
  search(text) {
    let location = 0;
    let index;

    const indices = [];
    const patternLen = this.pattern.length;

    // Get all exact matches
    while ((index = text.indexOf(this.pattern, location)) > -1) {
      location = index + patternLen;
      indices.push([index, location - 1]);
    }

    const isMatch = !!indices.length;

    return {
      isMatch,
      score: isMatch ? 0 : 1,
      indices
    }
  }
}

// ❗Order is important. DO NOT CHANGE.
const searchers = [
  ExactMatch,
  IncludeMatch,
  PrefixExactMatch,
  InversePrefixExactMatch,
  InverseSuffixExactMatch,
  SuffixExactMatch,
  InverseExactMatch,
  FuzzyMatch
];

const searchersLen = searchers.length;

// Regex to split by spaces, but keep anything in quotes together
const SPACE_RE = / +(?=(?:[^\"]*\"[^\"]*\")*[^\"]*$)/;
const OR_TOKEN = '|';

// Return a 2D array representation of the query, for simpler parsing.
// Example:
// "^core go$ | rb$ | py$ xy$" => [["^core", "go$"], ["rb$"], ["py$", "xy$"]]
function parseQuery(pattern, options = {}) {
  return pattern.split(OR_TOKEN).map((item) => {
    let query = item
      .trim()
      .split(SPACE_RE)
      .filter((item) => item && !!item.trim());

    let results = [];
    for (let i = 0, len = query.length; i < len; i += 1) {
      const queryItem = query[i];

      // 1. Handle multiple query match (i.e, once that are quoted, like `"hello world"`)
      let found = false;
      let idx = -1;
      while (!found && ++idx < searchersLen) {
        const searcher = searchers[idx];
        let token = searcher.isMultiMatch(queryItem);
        if (token) {
          results.push(new searcher(token, options));
          found = true;
        }
      }

      if (found) {
        continue
      }

      // 2. Handle single query matches (i.e, once that are *not* quoted)
      idx = -1;
      while (++idx < searchersLen) {
        const searcher = searchers[idx];
        let token = searcher.isSingleMatch(queryItem);
        if (token) {
          results.push(new searcher(token, options));
          break
        }
      }
    }

    return results
  })
}

// These extended matchers can return an array of matches, as opposed
// to a singl match
const MultiMatchSet = new Set([FuzzyMatch.type, IncludeMatch.type]);

/**
 * Command-like searching
 * ======================
 *
 * Given multiple search terms delimited by spaces.e.g. `^jscript .python$ ruby !java`,
 * search in a given text.
 *
 * Search syntax:
 *
 * | Token       | Match type                 | Description                            |
 * | ----------- | -------------------------- | -------------------------------------- |
 * | `jscript`   | fuzzy-match                | Items that fuzzy match `jscript`       |
 * | `=scheme`   | exact-match                | Items that are `scheme`                |
 * | `'python`   | include-match              | Items that include `python`            |
 * | `!ruby`     | inverse-exact-match        | Items that do not include `ruby`       |
 * | `^java`     | prefix-exact-match         | Items that start with `java`           |
 * | `!^earlang` | inverse-prefix-exact-match | Items that do not start with `earlang` |
 * | `.js$`      | suffix-exact-match         | Items that end with `.js`              |
 * | `!.go$`     | inverse-suffix-exact-match | Items that do not end with `.go`       |
 *
 * A single pipe character acts as an OR operator. For example, the following
 * query matches entries that start with `core` and end with either`go`, `rb`,
 * or`py`.
 *
 * ```
 * ^core go$ | rb$ | py$
 * ```
 */
class ExtendedSearch {
  constructor(
    pattern,
    {
      isCaseSensitive = Config.isCaseSensitive,
      includeMatches = Config.includeMatches,
      minMatchCharLength = Config.minMatchCharLength,
      ignoreLocation = Config.ignoreLocation,
      findAllMatches = Config.findAllMatches,
      location = Config.location,
      threshold = Config.threshold,
      distance = Config.distance
    } = {}
  ) {
    this.query = null;
    this.options = {
      isCaseSensitive,
      includeMatches,
      minMatchCharLength,
      findAllMatches,
      ignoreLocation,
      location,
      threshold,
      distance
    };

    this.pattern = isCaseSensitive ? pattern : pattern.toLowerCase();
    this.query = parseQuery(this.pattern, this.options);
  }

  static condition(_, options) {
    return options.useExtendedSearch
  }

  searchIn(text) {
    const query = this.query;

    if (!query) {
      return {
        isMatch: false,
        score: 1
      }
    }

    const { includeMatches, isCaseSensitive } = this.options;

    text = isCaseSensitive ? text : text.toLowerCase();

    let numMatches = 0;
    let allIndices = [];
    let totalScore = 0;

    // ORs
    for (let i = 0, qLen = query.length; i < qLen; i += 1) {
      const searchers = query[i];

      // Reset indices
      allIndices.length = 0;
      numMatches = 0;

      // ANDs
      for (let j = 0, pLen = searchers.length; j < pLen; j += 1) {
        const searcher = searchers[j];
        const { isMatch, indices, score } = searcher.search(text);

        if (isMatch) {
          numMatches += 1;
          totalScore += score;
          if (includeMatches) {
            const type = searcher.constructor.type;
            if (MultiMatchSet.has(type)) {
              allIndices = [...allIndices, ...indices];
            } else {
              allIndices.push(indices);
            }
          }
        } else {
          totalScore = 0;
          numMatches = 0;
          allIndices.length = 0;
          break
        }
      }

      // OR condition, so if TRUE, return
      if (numMatches) {
        let result = {
          isMatch: true,
          score: totalScore / numMatches
        };

        if (includeMatches) {
          result.indices = allIndices;
        }

        return result
      }
    }

    // Nothing was matched
    return {
      isMatch: false,
      score: 1
    }
  }
}

const registeredSearchers = [];

function register(...args) {
  registeredSearchers.push(...args);
}

function createSearcher(pattern, options) {
  for (let i = 0, len = registeredSearchers.length; i < len; i += 1) {
    let searcherClass = registeredSearchers[i];
    if (searcherClass.condition(pattern, options)) {
      return new searcherClass(pattern, options)
    }
  }

  return new BitapSearch(pattern, options)
}

const LogicalOperator = {
  AND: '$and',
  OR: '$or'
};

const KeyType = {
  PATH: '$path',
  PATTERN: '$val'
};

const isExpression = (query) =>
  !!(query[LogicalOperator.AND] || query[LogicalOperator.OR]);

const isPath = (query) => !!query[KeyType.PATH];

const isLeaf = (query) =>
  !isArray$3(query) && isObject$1(query) && !isExpression(query);

const convertToExplicit = (query) => ({
  [LogicalOperator.AND]: Object.keys(query).map((key) => ({
    [key]: query[key]
  }))
});

// When `auto` is `true`, the parse function will infer and initialize and add
// the appropriate `Searcher` instance
function parse(query, options, { auto = true } = {}) {
  const next = (query) => {
    let keys = Object.keys(query);

    const isQueryPath = isPath(query);

    if (!isQueryPath && keys.length > 1 && !isExpression(query)) {
      return next(convertToExplicit(query))
    }

    if (isLeaf(query)) {
      const key = isQueryPath ? query[KeyType.PATH] : keys[0];

      const pattern = isQueryPath ? query[KeyType.PATTERN] : query[key];

      if (!isString(pattern)) {
        throw new Error(LOGICAL_SEARCH_INVALID_QUERY_FOR_KEY(key))
      }

      const obj = {
        keyId: createKeyId(key),
        pattern
      };

      if (auto) {
        obj.searcher = createSearcher(pattern, options);
      }

      return obj
    }

    let node = {
      children: [],
      operator: keys[0]
    };

    keys.forEach((key) => {
      const value = query[key];

      if (isArray$3(value)) {
        value.forEach((item) => {
          node.children.push(next(item));
        });
      }
    });

    return node
  };

  if (!isExpression(query)) {
    query = convertToExplicit(query);
  }

  return next(query)
}

// Practical scoring function
function computeScore(
  results,
  { ignoreFieldNorm = Config.ignoreFieldNorm }
) {
  results.forEach((result) => {
    let totalScore = 1;

    result.matches.forEach(({ key, norm, score }) => {
      const weight = key ? key.weight : null;

      totalScore *= Math.pow(
        score === 0 && weight ? Number.EPSILON : score,
        (weight || 1) * (ignoreFieldNorm ? 1 : norm)
      );
    });

    result.score = totalScore;
  });
}

function transformMatches(result, data) {
  const matches = result.matches;
  data.matches = [];

  if (!isDefined(matches)) {
    return
  }

  matches.forEach((match) => {
    if (!isDefined(match.indices) || !match.indices.length) {
      return
    }

    const { indices, value } = match;

    let obj = {
      indices,
      value
    };

    if (match.key) {
      obj.key = match.key.src;
    }

    if (match.idx > -1) {
      obj.refIndex = match.idx;
    }

    data.matches.push(obj);
  });
}

function transformScore(result, data) {
  data.score = result.score;
}

function format(
  results,
  docs,
  {
    includeMatches = Config.includeMatches,
    includeScore = Config.includeScore
  } = {}
) {
  const transformers = [];

  if (includeMatches) transformers.push(transformMatches);
  if (includeScore) transformers.push(transformScore);

  return results.map((result) => {
    const { idx } = result;

    const data = {
      item: docs[idx],
      refIndex: idx
    };

    if (transformers.length) {
      transformers.forEach((transformer) => {
        transformer(result, data);
      });
    }

    return data
  })
}

class Fuse {
  constructor(docs, options = {}, index) {
    this.options = { ...Config, ...options };

    if (
      this.options.useExtendedSearch &&
      !true
    ) {
      throw new Error(EXTENDED_SEARCH_UNAVAILABLE)
    }

    this._keyStore = new KeyStore(this.options.keys);

    this.setCollection(docs, index);
  }

  setCollection(docs, index) {
    this._docs = docs;

    if (index && !(index instanceof FuseIndex)) {
      throw new Error(INCORRECT_INDEX_TYPE)
    }

    this._myIndex =
      index ||
      createIndex(this.options.keys, this._docs, {
        getFn: this.options.getFn,
        fieldNormWeight: this.options.fieldNormWeight
      });
  }

  add(doc) {
    if (!isDefined(doc)) {
      return
    }

    this._docs.push(doc);
    this._myIndex.add(doc);
  }

  remove(predicate = (/* doc, idx */) => false) {
    const results = [];

    for (let i = 0, len = this._docs.length; i < len; i += 1) {
      const doc = this._docs[i];
      if (predicate(doc, i)) {
        this.removeAt(i);
        i -= 1;
        len -= 1;

        results.push(doc);
      }
    }

    return results
  }

  removeAt(idx) {
    this._docs.splice(idx, 1);
    this._myIndex.removeAt(idx);
  }

  getIndex() {
    return this._myIndex
  }

  search(query, { limit = -1 } = {}) {
    const {
      includeMatches,
      includeScore,
      shouldSort,
      sortFn,
      ignoreFieldNorm
    } = this.options;

    let results = isString(query)
      ? isString(this._docs[0])
        ? this._searchStringList(query)
        : this._searchObjectList(query)
      : this._searchLogical(query);

    computeScore(results, { ignoreFieldNorm });

    if (shouldSort) {
      results.sort(sortFn);
    }

    if (isNumber(limit) && limit > -1) {
      results = results.slice(0, limit);
    }

    return format(results, this._docs, {
      includeMatches,
      includeScore
    })
  }

  _searchStringList(query) {
    const searcher = createSearcher(query, this.options);
    const { records } = this._myIndex;
    const results = [];

    // Iterate over every string in the index
    records.forEach(({ v: text, i: idx, n: norm }) => {
      if (!isDefined(text)) {
        return
      }

      const { isMatch, score, indices } = searcher.searchIn(text);

      if (isMatch) {
        results.push({
          item: text,
          idx,
          matches: [{ score, value: text, norm, indices }]
        });
      }
    });

    return results
  }

  _searchLogical(query) {

    const expression = parse(query, this.options);

    const evaluate = (node, item, idx) => {
      if (!node.children) {
        const { keyId, searcher } = node;

        const matches = this._findMatches({
          key: this._keyStore.get(keyId),
          value: this._myIndex.getValueForItemAtKeyId(item, keyId),
          searcher
        });

        if (matches && matches.length) {
          return [
            {
              idx,
              item,
              matches
            }
          ]
        }

        return []
      }

      const res = [];
      for (let i = 0, len = node.children.length; i < len; i += 1) {
        const child = node.children[i];
        const result = evaluate(child, item, idx);
        if (result.length) {
          res.push(...result);
        } else if (node.operator === LogicalOperator.AND) {
          return []
        }
      }
      return res
    };

    const records = this._myIndex.records;
    const resultMap = {};
    const results = [];

    records.forEach(({ $: item, i: idx }) => {
      if (isDefined(item)) {
        let expResults = evaluate(expression, item, idx);

        if (expResults.length) {
          // Dedupe when adding
          if (!resultMap[idx]) {
            resultMap[idx] = { idx, item, matches: [] };
            results.push(resultMap[idx]);
          }
          expResults.forEach(({ matches }) => {
            resultMap[idx].matches.push(...matches);
          });
        }
      }
    });

    return results
  }

  _searchObjectList(query) {
    const searcher = createSearcher(query, this.options);
    const { keys, records } = this._myIndex;
    const results = [];

    // List is Array<Object>
    records.forEach(({ $: item, i: idx }) => {
      if (!isDefined(item)) {
        return
      }

      let matches = [];

      // Iterate over every key (i.e, path), and fetch the value at that key
      keys.forEach((key, keyIndex) => {
        matches.push(
          ...this._findMatches({
            key,
            value: item[keyIndex],
            searcher
          })
        );
      });

      if (matches.length) {
        results.push({
          idx,
          item,
          matches
        });
      }
    });

    return results
  }
  _findMatches({ key, value, searcher }) {
    if (!isDefined(value)) {
      return []
    }

    let matches = [];

    if (isArray$3(value)) {
      value.forEach(({ v: text, i: idx, n: norm }) => {
        if (!isDefined(text)) {
          return
        }

        const { isMatch, score, indices } = searcher.searchIn(text);

        if (isMatch) {
          matches.push({
            score,
            key,
            value: text,
            idx,
            norm,
            indices
          });
        }
      });
    } else {
      const { v: text, n: norm } = value;

      const { isMatch, score, indices } = searcher.searchIn(text);

      if (isMatch) {
        matches.push({ score, key, value: text, norm, indices });
      }
    }

    return matches
  }
}

Fuse.version = '6.6.2';
Fuse.createIndex = createIndex;
Fuse.parseIndex = parseIndex;
Fuse.config = Config;

{
  Fuse.parseQuery = parse;
}

{
  register(ExtendedSearch);
}

var baseFor = _baseFor,
    keys$1 = keys_1;

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn$1(object, iteratee) {
  return object && baseFor(object, iteratee, keys$1);
}

var _baseForOwn = baseForOwn$1;

var isArrayLike$2 = isArrayLike_1;

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach$1(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike$2(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

var _createBaseEach = createBaseEach$1;

var baseForOwn = _baseForOwn,
    createBaseEach = _createBaseEach;

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach$2 = createBaseEach(baseForOwn);

var _baseEach = baseEach$2;

var baseEach$1 = _baseEach;

/**
 * The base implementation of `_.filter` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function baseFilter$1(collection, predicate) {
  var result = [];
  baseEach$1(collection, function(value, index, collection) {
    if (predicate(value, index, collection)) {
      result.push(value);
    }
  });
  return result;
}

var _baseFilter = baseFilter$1;

var arrayFilter = _arrayFilter,
    baseFilter = _baseFilter,
    baseIteratee = _baseIteratee,
    isArray$2 = isArray_1;

/**
 * Iterates over elements of `collection`, returning an array of all elements
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * **Note:** Unlike `_.remove`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 * @see _.reject
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': true },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * _.filter(users, function(o) { return !o.active; });
 * // => objects for ['fred']
 *
 * // The `_.matches` iteratee shorthand.
 * _.filter(users, { 'age': 36, 'active': true });
 * // => objects for ['barney']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.filter(users, ['active', false]);
 * // => objects for ['fred']
 *
 * // The `_.property` iteratee shorthand.
 * _.filter(users, 'active');
 * // => objects for ['barney']
 *
 * // Combining several predicates using `_.overEvery` or `_.overSome`.
 * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
 * // => objects for ['fred', 'barney']
 */
function filter(collection, predicate) {
  var func = isArray$2(collection) ? arrayFilter : baseFilter;
  return func(collection, baseIteratee(predicate));
}

var filter_1 = filter;

const filter$1 = filter_1;

var eachExports = {};
var each$1 = {
  get exports(){ return eachExports; },
  set exports(v){ eachExports = v; },
};

var identity = identity_1;

/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */
function castFunction$1(value) {
  return typeof value == 'function' ? value : identity;
}

var _castFunction = castFunction$1;

var arrayEach = _arrayEach,
    baseEach = _baseEach,
    castFunction = _castFunction,
    isArray$1 = isArray_1;

/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _.forEach([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */
function forEach(collection, iteratee) {
  var func = isArray$1(collection) ? arrayEach : baseEach;
  return func(collection, castFunction(iteratee));
}

var forEach_1 = forEach;

(function (module) {
	module.exports = forEach_1;
} (each$1));

const each = /*@__PURE__*/getDefaultExportFromCjs$1(eachExports);

const allCountries = [["Afghanistan", "af", "93"], ["Albania", "al", "355"], ["Algeria", "dz", "213"], ["American Samoa", "as", "1684"], ["Andorra", "ad", "376"], ["Angola", "ao", "244"], ["Anguilla", "ai", "1264"], ["Antigua and Barbuda", "ag", "1268"], ["Argentina", "ar", "54"], ["Armenia", "am", "374"], ["Aruba", "aw", "297"], ["Australia", "au", "61", 0], ["Austria", "at", "43"], ["Azerbaijan", "az", "994"], ["Bahamas", "bs", "1242"], ["Bahrain", "bh", "973"], ["Bangladesh", "bd", "880"], ["Barbados", "bb", "1246"], ["Belarus", "by", "375"], ["Belgium", "be", "32"], ["Belize", "bz", "501"], ["Benin", "bj", "229"], ["Bermuda", "bm", "1441"], ["Bhutan", "bt", "975"], ["Bolivia", "bo", "591"], ["Bosnia", "ba", "387"], ["Botswana", "bw", "267"], ["Brazil", "br", "55"], ["British Indian Ocean Territory", "io", "246"], ["British Virgin Islands", "vg", "1284"], ["Brunei", "bn", "673"], ["Bulgaria", "bg", "359"], ["Burkina Faso", "bf", "226"], ["Burundi", "bi", "257"], ["Cambodia", "kh", "855"], ["Cameroon", "cm", "237"], ["Canada", "ca", "1", 1, ["204", "226", "236", "249", "250", "289", "306", "343", "365", "387", "403", "416", "418", "431", "437", "438", "450", "506", "514", "519", "548", "579", "581", "587", "604", "613", "639", "647", "672", "705", "709", "742", "778", "780", "782", "807", "819", "825", "867", "873", "902", "905"]], ["Cape Verde", "cv", "238"], ["Caribbean Netherlands", "bq", "599", 1], ["Cayman Islands", "ky", "1345"], ["Central African Republic", "cf", "236"], ["Chad", "td", "235"], ["Chile", "cl", "56"], ["China", "cn", "86"], ["Christmas Island", "cx", "61", 2], ["Cocos Islands", "cc", "61", 1], ["Colombia", "co", "57"], ["Comoros", "km", "269"], ["Congo", "cd", "243"], ["Congo (Republic)", "cg", "242"], ["Cook Islands", "ck", "682"], ["Costa Rica", "cr", "506"], ["Côte d’Ivoire", "ci", "225"], ["Croatia", "hr", "385"], ["Cuba", "cu", "53"], ["Curaçao", "cw", "599", 0], ["Cyprus", "cy", "357"], ["Czech Republic", "cz", "420"], ["Denmark", "dk", "45"], ["Djibouti", "dj", "253"], ["Dominica", "dm", "1767"], ["Dominican Republic", "do", "1", 2, ["809", "829", "849"]], ["Ecuador", "ec", "593"], ["Egypt", "eg", "20"], ["El Salvador", "sv", "503"], ["Equatorial Guinea", "gq", "240"], ["Eritrea", "er", "291"], ["Estonia", "ee", "372"], ["Ethiopia", "et", "251"], ["Falkland Islands", "fk", "500"], ["Faroe Islands", "fo", "298"], ["Fiji", "fj", "679"], ["Finland", "fi", "358", 0], ["France", "fr", "33"], ["French Guiana", "gf", "594"], ["French Polynesia", "pf", "689"], ["Gabon", "ga", "241"], ["Gambia", "gm", "220"], ["Georgia", "ge", "995"], ["Germany", "de", "49"], ["Ghana", "gh", "233"], ["Gibraltar", "gi", "350"], ["Greece", "gr", "30"], ["Greenland", "gl", "299"], ["Grenada", "gd", "1473"], ["Guadeloupe", "gp", "590", 0], ["Guam", "gu", "1671"], ["Guatemala", "gt", "502"], ["Guernsey", "gg", "44", 1], ["Guinea", "gn", "224"], ["Guinea-Bissau", "gw", "245"], ["Guyana", "gy", "592"], ["Haiti", "ht", "509"], ["Honduras", "hn", "504"], ["Hong Kong", "hk", "852"], ["Hungary", "hu", "36"], ["Iceland", "is", "354"], ["India", "in", "91"], ["Indonesia", "id", "62"], ["Iran", "ir", "98"], ["Iraq", "iq", "964"], ["Ireland", "ie", "353"], ["Isle of Man", "im", "44", 2], ["Israel", "il", "972"], ["Italy", "it", "39", 0], ["Jamaica", "jm", "1876"], ["Japan", "jp", "81"], ["Jersey", "je", "44", 3], ["Jordan", "jo", "962"], ["Kazakhstan", "kz", "7", 1], ["Kenya", "ke", "254"], ["Kiribati", "ki", "686"], ["Kosovo", "xk", "383"], ["Kuwait", "kw", "965"], ["Kyrgyzstan", "kg", "996"], ["Laos", "la", "856"], ["Latvia", "lv", "371"], ["Lebanon", "lb", "961"], ["Lesotho", "ls", "266"], ["Liberia", "lr", "231"], ["Libya", "ly", "218"], ["Liechtenstein", "li", "423"], ["Lithuania", "lt", "370"], ["Luxembourg", "lu", "352"], ["Macau", "mo", "853"], ["Macedonia", "mk", "389"], ["Madagascar", "mg", "261"], ["Malawi", "mw", "265"], ["Malaysia", "my", "60"], ["Maldives", "mv", "960"], ["Mali", "ml", "223"], ["Malta", "mt", "356"], ["Marshall Islands", "mh", "692"], ["Martinique", "mq", "596"], ["Mauritania", "mr", "222"], ["Mauritius", "mu", "230"], ["Mayotte", "yt", "262", 1], ["Mexico", "mx", "52"], ["Micronesia", "fm", "691"], ["Moldova", "md", "373"], ["Monaco", "mc", "377"], ["Mongolia", "mn", "976"], ["Montenegro", "me", "382"], ["Montserrat", "ms", "1664"], ["Morocco", "ma", "212", 0], ["Mozambique", "mz", "258"], ["Myanmar ", "mm", "95"], ["Namibia", "na", "264"], ["Nauru", "nr", "674"], ["Nepal", "np", "977"], ["Netherlands", "nl", "31"], ["New Caledonia", "nc", "687"], ["New Zealand", "nz", "64"], ["Nicaragua", "ni", "505"], ["Niger", "ne", "227"], ["Nigeria", "ng", "234"], ["Niue", "nu", "683"], ["Norfolk Island", "nf", "672"], ["North Korea", "kp", "850"], ["Northern Mariana Islands", "mp", "1670"], ["Norway", "no", "47", 0], ["Oman", "om", "968"], ["Pakistan", "pk", "92"], ["Palau", "pw", "680"], ["Palestine", "ps", "970"], ["Panama", "pa", "507"], ["Papua New Guinea", "pg", "675"], ["Paraguay", "py", "595"], ["Peru", "pe", "51"], ["Philippines", "ph", "63"], ["Poland", "pl", "48"], ["Portugal", "pt", "351"], ["Puerto Rico", "pr", "1", 3, ["787", "939"]], ["Qatar", "qa", "974"], ["Réunion", "re", "262", 0], ["Romania", "ro", "40"], ["Russia", "ru", "7", 0], ["Rwanda", "rw", "250"], ["Saint Barthélemy", "bl", "590", 1], ["Saint Helena", "sh", "290"], ["Saint Kitts and Nevis", "kn", "1869"], ["Saint Lucia", "lc", "1758"], ["Saint Martin", "mf", "590", 2], ["Saint Pierre and Miquelon", "pm", "508"], ["Saint Vincent and the Grenadines", "vc", "1784"], ["Samoa", "ws", "685"], ["San Marino", "sm", "378"], ["São Tomé & Príncipe", "st", "239"], ["Saudi Arabia", "sa", "966"], ["Senegal", "sn", "221"], ["Serbia", "rs", "381"], ["Seychelles", "sc", "248"], ["Sierra Leone", "sl", "232"], ["Singapore", "sg", "65"], ["Sint Maarten", "sx", "1721"], ["Slovakia", "sk", "421"], ["Slovenia", "si", "386"], ["Solomon Islands", "sb", "677"], ["Somalia", "so", "252"], ["South Africa", "za", "27"], ["South Korea", "kr", "82"], ["South Sudan", "ss", "211"], ["Spain", "es", "34"], ["Sri Lanka", "lk", "94"], ["Sudan", "sd", "249"], ["Suriname", "sr", "597"], ["Svalbard and Jan Mayen", "sj", "47", 1], ["Swaziland", "sz", "268"], ["Sweden", "se", "46"], ["Switzerland", "ch", "41"], ["Syria", "sy", "963"], ["Taiwan", "tw", "886"], ["Tajikistan", "tj", "992"], ["Tanzania", "tz", "255"], ["Thailand", "th", "66"], ["Timor-Leste", "tl", "670"], ["Togo", "tg", "228"], ["Tokelau", "tk", "690"], ["Tonga", "to", "676"], ["Trinidad and Tobago", "tt", "1868"], ["Tunisia", "tn", "216"], ["Turkey", "tr", "90"], ["Turkmenistan", "tm", "993"], ["Turks and Caicos Islands", "tc", "1649"], ["Tuvalu", "tv", "688"], ["U.S. Virgin Islands", "vi", "1340"], ["Uganda", "ug", "256"], ["Ukraine", "ua", "380"], ["United Arab Emirates", "ae", "971"], ["United Kingdom", "gb", "44", 0], ["United States", "us", "1", 0], ["Uruguay", "uy", "598"], ["Uzbekistan", "uz", "998"], ["Vanuatu", "vu", "678"], ["Vatican City", "va", "39", 1], ["Venezuela", "ve", "58"], ["Vietnam (Việt Nam)", "vn", "84"], ["Wallis and Futuna", "wf", "681"], ["Western Sahara", "eh", "212", 1], ["Yemen", "ye", "967"], ["Zambia", "zm", "260"], ["Zimbabwe", "zw", "263"], ["Åland Islands", "ax", "358", 1]];
const countryCodes = allCountries.map((country) => ({
  name: country[0],
  iso2: country[1].toString().toUpperCase(),
  dialCode: country[2],
  priority: country[3] || 0,
  areaCodes: country[4] || null
}));
const countries = countryCodes.map((country) => ({
  value: country.iso2,
  label: country.name,
  name: country.name,
  name_raw: country.name,
  dialCode: country.dialCode,
  iso2: country.iso2
}));
const filterCountriesByName = function(query = "", currentValue = "", collection = [], minCharacters = 2, favoriteCountries = ["US", "GB", "PT", "FR", "DE"]) {
  if (query === void 0 || query === "" || query.length < minCharacters) {
    return filter$1(collection, (country) => {
      return favoriteCountries.includes(country.value) || country.value === unref(currentValue);
    });
  }
  const options = {
    includeScore: false,
    threshold: 0.3,
    keys: ["name_raw"]
  };
  const fuse = new Fuse(collection, options);
  const results = fuse.search(query);
  const filtered = [];
  each(results, (result) => {
    filtered.push(result.item);
  });
  return filtered;
};

const _sfc_main$P = {
  components: {
    FlagAc: defineAsyncComponent(() => import('./FlagAC-b2f93881.js')),
    FlagAd: defineAsyncComponent(() => import('./FlagAD-25c75b43.js')),
    FlagAe: defineAsyncComponent(() => import('./FlagAE-cb71ecbd.js')),
    FlagAf: defineAsyncComponent(() => import('./FlagAF-1266a728.js')),
    FlagAg: defineAsyncComponent(() => import('./FlagAG-ccb1fe12.js')),
    FlagAi: defineAsyncComponent(() => import('./FlagAI-6dc0208b.js')),
    FlagAl: defineAsyncComponent(() => import('./FlagAL-67d7e464.js')),
    FlagAm: defineAsyncComponent(() => import('./FlagAM-fa576467.js')),
    FlagAo: defineAsyncComponent(() => import('./FlagAO-908477d1.js')),
    FlagAq: defineAsyncComponent(() => import('./FlagAQ-a6735d94.js')),
    FlagAr: defineAsyncComponent(() => import('./FlagAR-7afff67f.js')),
    FlagAs: defineAsyncComponent(() => import('./FlagAS-ff6af0c1.js')),
    FlagAt: defineAsyncComponent(() => import('./FlagAT-1979eecd.js')),
    FlagAu: defineAsyncComponent(() => import('./FlagAU-3cc85e0f.js')),
    FlagAw: defineAsyncComponent(() => import('./FlagAW-e3f84c58.js')),
    FlagAx: defineAsyncComponent(() => import('./FlagAX-6efabfd4.js')),
    FlagAz: defineAsyncComponent(() => import('./FlagAZ-d6260d9e.js')),
    FlagBa: defineAsyncComponent(() => import('./FlagBA-fc7ee94b.js')),
    FlagBb: defineAsyncComponent(() => import('./FlagBB-582539dd.js')),
    FlagBd: defineAsyncComponent(() => import('./FlagBD-bf8b3c0b.js')),
    FlagBe: defineAsyncComponent(() => import('./FlagBE-fc8266a7.js')),
    FlagBf: defineAsyncComponent(() => import('./FlagBF-2f20f25f.js')),
    FlagBg: defineAsyncComponent(() => import('./FlagBG-11c79c7f.js')),
    FlagBh: defineAsyncComponent(() => import('./FlagBH-ecc9f1c4.js')),
    FlagBi: defineAsyncComponent(() => import('./FlagBI-407ba123.js')),
    FlagBj: defineAsyncComponent(() => import('./FlagBJ-301a5a07.js')),
    FlagBl: defineAsyncComponent(() => import('./FlagBL-26a0e8ec.js')),
    FlagBm: defineAsyncComponent(() => import('./FlagBM-a37d04f5.js')),
    FlagBn: defineAsyncComponent(() => import('./FlagBN-e06899fb.js')),
    FlagBo: defineAsyncComponent(() => import('./FlagBO-8496187c.js')),
    FlagBq: defineAsyncComponent(() => import('./FlagBQ-a169cb7a.js')),
    FlagBr: defineAsyncComponent(() => import('./FlagBR-8b7b4388.js')),
    FlagBs: defineAsyncComponent(() => import('./FlagBS-6e046663.js')),
    FlagBt: defineAsyncComponent(() => import('./FlagBT-274ed0f9.js')),
    FlagBv: defineAsyncComponent(() => import('./FlagBV-aab5c738.js')),
    FlagBw: defineAsyncComponent(() => import('./FlagBW-c0bdf696.js')),
    FlagBy: defineAsyncComponent(() => import('./FlagBY-f0b8506d.js')),
    FlagBz: defineAsyncComponent(() => import('./FlagBZ-72484246.js')),
    FlagCa: defineAsyncComponent(() => import('./FlagCA-5afb5d7d.js')),
    FlagCc: defineAsyncComponent(() => import('./FlagCC-a3a8c3fd.js')),
    FlagCd: defineAsyncComponent(() => import('./FlagCD-b3da3740.js')),
    FlagCf: defineAsyncComponent(() => import('./FlagCF-38ae6832.js')),
    FlagCg: defineAsyncComponent(() => import('./FlagCG-bf681129.js')),
    FlagCh: defineAsyncComponent(() => import('./FlagCH-c6448aaf.js')),
    FlagCi: defineAsyncComponent(() => import('./FlagCI-35f428b5.js')),
    FlagCk: defineAsyncComponent(() => import('./FlagCK-9dc9147c.js')),
    FlagCl: defineAsyncComponent(() => import('./FlagCL-788a958b.js')),
    FlagCm: defineAsyncComponent(() => import('./FlagCM-09ec1515.js')),
    FlagCn: defineAsyncComponent(() => import('./FlagCN-6f9879bf.js')),
    FlagCo: defineAsyncComponent(() => import('./FlagCO-9195f8e2.js')),
    FlagCr: defineAsyncComponent(() => import('./FlagCR-c04a7154.js')),
    FlagCu: defineAsyncComponent(() => import('./FlagCU-b061a92c.js')),
    FlagCv: defineAsyncComponent(() => import('./FlagCV-fe9b7b61.js')),
    FlagCw: defineAsyncComponent(() => import('./FlagCW-6e43d8eb.js')),
    FlagCx: defineAsyncComponent(() => import('./FlagCX-85f904d0.js')),
    FlagCy: defineAsyncComponent(() => import('./FlagCY-32e97f19.js')),
    FlagCz: defineAsyncComponent(() => import('./FlagCZ-9f3c6347.js')),
    FlagDe: defineAsyncComponent(() => import('./FlagDE-1c995daf.js')),
    FlagDj: defineAsyncComponent(() => import('./FlagDJ-700a4590.js')),
    FlagDk: defineAsyncComponent(() => import('./FlagDK-b8ed02ad.js')),
    FlagDm: defineAsyncComponent(() => import('./FlagDM-817b8479.js')),
    FlagDo: defineAsyncComponent(() => import('./FlagDO-ee304d89.js')),
    FlagDz: defineAsyncComponent(() => import('./FlagDZ-e2a3764f.js')),
    FlagEc: defineAsyncComponent(() => import('./FlagEC-053b42be.js')),
    FlagEe: defineAsyncComponent(() => import('./FlagEE-4cb07cc4.js')),
    FlagEg: defineAsyncComponent(() => import('./FlagEG-3b88e5b6.js')),
    FlagEh: defineAsyncComponent(() => import('./FlagEH-910eb85e.js')),
    FlagEr: defineAsyncComponent(() => import('./FlagER-a9f5737e.js')),
    FlagEs: defineAsyncComponent(() => import('./FlagES-9d60248c.js')),
    FlagEt: defineAsyncComponent(() => import('./FlagET-3f4cff3d.js')),
    FlagEu: defineAsyncComponent(() => import('./FlagEU-7f96caf8.js')),
    FlagFi: defineAsyncComponent(() => import('./FlagFI-911213af.js')),
    FlagFj: defineAsyncComponent(() => import('./FlagFJ-19746bd9.js')),
    FlagFk: defineAsyncComponent(() => import('./FlagFK-bf6db032.js')),
    FlagFm: defineAsyncComponent(() => import('./FlagFM-04526de4.js')),
    FlagFo: defineAsyncComponent(() => import('./FlagFO-f45ef979.js')),
    FlagFr: defineAsyncComponent(() => import('./FlagFR-ad1fdc2f.js')),
    FlagGa: defineAsyncComponent(() => import('./FlagGA-e951af13.js')),
    FlagGb: defineAsyncComponent(() => import('./FlagGB-1a7d6c57.js')),
    FlagGd: defineAsyncComponent(() => import('./FlagGD-cbc5f64f.js')),
    FlagGeab: defineAsyncComponent(() => import('./FlagGEAB-a75be042.js')),
    FlagGeos: defineAsyncComponent(() => import('./FlagGEOS-9594cd31.js')),
    FlagGe: defineAsyncComponent(() => import('./FlagGE-46e86f7e.js')),
    FlagGf: defineAsyncComponent(() => import('./FlagGF-2c079c6d.js')),
    FlagGg: defineAsyncComponent(() => import('./FlagGG-f98dfdaf.js')),
    FlagGh: defineAsyncComponent(() => import('./FlagGH-18bcdc7a.js')),
    FlagGi: defineAsyncComponent(() => import('./FlagGI-21a9b59b.js')),
    FlagGl: defineAsyncComponent(() => import('./FlagGL-1a75a6d0.js')),
    FlagGm: defineAsyncComponent(() => import('./FlagGM-66c1c2ab.js')),
    FlagGn: defineAsyncComponent(() => import('./FlagGN-56ba7d3d.js')),
    FlagGp: defineAsyncComponent(() => import('./FlagGP-0410cfb1.js')),
    FlagGq: defineAsyncComponent(() => import('./FlagGQ-220a6d43.js')),
    FlagGr: defineAsyncComponent(() => import('./FlagGR-b0804fcb.js')),
    FlagGs: defineAsyncComponent(() => import('./FlagGS-d5ff8323.js')),
    FlagGt: defineAsyncComponent(() => import('./FlagGT-cf99a0be.js')),
    FlagGu: defineAsyncComponent(() => import('./FlagGU-529e6155.js')),
    FlagGw: defineAsyncComponent(() => import('./FlagGW-a66c3560.js')),
    FlagGy: defineAsyncComponent(() => import('./FlagGY-332b660a.js')),
    FlagHk: defineAsyncComponent(() => import('./FlagHK-4c17bef7.js')),
    FlagHm: defineAsyncComponent(() => import('./FlagHM-38e8918f.js')),
    FlagHn: defineAsyncComponent(() => import('./FlagHN-53c19554.js')),
    FlagHr: defineAsyncComponent(() => import('./FlagHR-68563429.js')),
    FlagHt: defineAsyncComponent(() => import('./FlagHT-4ee8f4c8.js')),
    FlagHu: defineAsyncComponent(() => import('./FlagHU-3fcebf51.js')),
    FlagId: defineAsyncComponent(() => import('./FlagID-924ec217.js')),
    FlagIe: defineAsyncComponent(() => import('./FlagIE-10855c63.js')),
    FlagIl: defineAsyncComponent(() => import('./FlagIL-8d9bd596.js')),
    FlagIm: defineAsyncComponent(() => import('./FlagIM-cdf5a13d.js')),
    FlagIn: defineAsyncComponent(() => import('./FlagIN-8bc2a55c.js')),
    FlagIo: defineAsyncComponent(() => import('./FlagIO-462d9499.js')),
    FlagIq: defineAsyncComponent(() => import('./FlagIQ-5edb311b.js')),
    FlagIr: defineAsyncComponent(() => import('./FlagIR-d430fe55.js')),
    FlagIs: defineAsyncComponent(() => import('./FlagIS-2ca502db.js')),
    FlagIt: defineAsyncComponent(() => import('./FlagIT-8600b9ef.js')),
    FlagJe: defineAsyncComponent(() => import('./FlagJE-67576b9d.js')),
    FlagJm: defineAsyncComponent(() => import('./FlagJM-3b7c4a2e.js')),
    FlagJo: defineAsyncComponent(() => import('./FlagJO-1880cc4d.js')),
    FlagJp: defineAsyncComponent(() => import('./FlagJP-c4a84331.js')),
    FlagKe: defineAsyncComponent(() => import('./FlagKE-6cc8f18d.js')),
    FlagKg: defineAsyncComponent(() => import('./FlagKG-ef548740.js')),
    FlagKh: defineAsyncComponent(() => import('./FlagKH-80b67c23.js')),
    FlagKi: defineAsyncComponent(() => import('./FlagKI-3f56b02d.js')),
    FlagKm: defineAsyncComponent(() => import('./FlagKM-04ae14c3.js')),
    FlagKn: defineAsyncComponent(() => import('./FlagKN-9cb9b105.js')),
    FlagKp: defineAsyncComponent(() => import('./FlagKP-aacd2ced.js')),
    FlagKr: defineAsyncComponent(() => import('./FlagKR-fb5e1f58.js')),
    FlagKw: defineAsyncComponent(() => import('./FlagKW-d9d1391a.js')),
    FlagKy: defineAsyncComponent(() => import('./FlagKY-bcad5544.js')),
    FlagKz: defineAsyncComponent(() => import('./FlagKZ-07f8e9b7.js')),
    FlagLa: defineAsyncComponent(() => import('./FlagLA-87f13b39.js')),
    FlagLb: defineAsyncComponent(() => import('./FlagLB-e6d19c9f.js')),
    FlagLc: defineAsyncComponent(() => import('./FlagLC-54d21786.js')),
    FlagLi: defineAsyncComponent(() => import('./FlagLI-bdbe3ea6.js')),
    FlagLk: defineAsyncComponent(() => import('./FlagLK-8499e515.js')),
    FlagLr: defineAsyncComponent(() => import('./FlagLR-5a3da812.js')),
    FlagLs: defineAsyncComponent(() => import('./FlagLS-0aeb201a.js')),
    FlagLt: defineAsyncComponent(() => import('./FlagLT-c0b96169.js')),
    FlagLu: defineAsyncComponent(() => import('./FlagLU-63228279.js')),
    FlagLv: defineAsyncComponent(() => import('./FlagLV-d3f6e2f1.js')),
    FlagLy: defineAsyncComponent(() => import('./FlagLY-e7e317d2.js')),
    FlagMa: defineAsyncComponent(() => import('./FlagMA-024e0a5c.js')),
    FlagMc: defineAsyncComponent(() => import('./FlagMC-da026ca2.js')),
    FlagMd: defineAsyncComponent(() => import('./FlagMD-cd14cc0c.js')),
    FlagMe: defineAsyncComponent(() => import('./FlagME-b532becd.js')),
    FlagMf: defineAsyncComponent(() => import('./FlagMF-9e6dfac2.js')),
    FlagMg: defineAsyncComponent(() => import('./FlagMG-2a7b2464.js')),
    FlagMh: defineAsyncComponent(() => import('./FlagMH-79ef7756.js')),
    FlagMk: defineAsyncComponent(() => import('./FlagMK-9c654092.js')),
    FlagMl: defineAsyncComponent(() => import('./FlagML-659482df.js')),
    FlagMm: defineAsyncComponent(() => import('./FlagMM-84d670d0.js')),
    FlagMn: defineAsyncComponent(() => import('./FlagMN-3358304a.js')),
    FlagMo: defineAsyncComponent(() => import('./FlagMO-933b6d45.js')),
    FlagMp: defineAsyncComponent(() => import('./FlagMP-7a98749e.js')),
    FlagMq: defineAsyncComponent(() => import('./FlagMQ-70ca9d5b.js')),
    FlagMr: defineAsyncComponent(() => import('./FlagMR-e7c5bb69.js')),
    FlagMs: defineAsyncComponent(() => import('./FlagMS-62ffe3b9.js')),
    FlagMt: defineAsyncComponent(() => import('./FlagMT-4e9b1652.js')),
    FlagMu: defineAsyncComponent(() => import('./FlagMU-374a2b53.js')),
    FlagMv: defineAsyncComponent(() => import('./FlagMV-af6b0b5c.js')),
    FlagMw: defineAsyncComponent(() => import('./FlagMW-c39bff46.js')),
    FlagMx: defineAsyncComponent(() => import('./FlagMX-ede4c086.js')),
    FlagMy: defineAsyncComponent(() => import('./FlagMY-5311e85b.js')),
    FlagMz: defineAsyncComponent(() => import('./FlagMZ-9de150a5.js')),
    FlagNa: defineAsyncComponent(() => import('./FlagNA-4dceaca4.js')),
    FlagNc: defineAsyncComponent(() => import('./FlagNC-74ab4a5b.js')),
    FlagNe: defineAsyncComponent(() => import('./FlagNE-0072ee1d.js')),
    FlagNf: defineAsyncComponent(() => import('./FlagNF-9f528983.js')),
    FlagNg: defineAsyncComponent(() => import('./FlagNG-6bceb10a.js')),
    FlagNi: defineAsyncComponent(() => import('./FlagNI-5a92ec7d.js')),
    FlagNl: defineAsyncComponent(() => import('./FlagNL-23a17c94.js')),
    FlagNo: defineAsyncComponent(() => import('./FlagNO-4e174468.js')),
    FlagNp: defineAsyncComponent(() => import('./FlagNP-a2a52f04.js')),
    FlagNr: defineAsyncComponent(() => import('./FlagNR-3e67bf56.js')),
    FlagNu: defineAsyncComponent(() => import('./FlagNU-4383ad4c.js')),
    FlagNz: defineAsyncComponent(() => import('./FlagNZ-17f8cb23.js')),
    FlagOm: defineAsyncComponent(() => import('./FlagOM-9b6c8ea3.js')),
    FlagPa: defineAsyncComponent(() => import('./FlagPA-4e1da4d0.js')),
    FlagPe: defineAsyncComponent(() => import('./FlagPE-5eefb74d.js')),
    FlagPf: defineAsyncComponent(() => import('./FlagPF-97baf775.js')),
    FlagPg: defineAsyncComponent(() => import('./FlagPG-6165f735.js')),
    FlagPh: defineAsyncComponent(() => import('./FlagPH-807756b3.js')),
    FlagPk: defineAsyncComponent(() => import('./FlagPK-bfbb9c05.js')),
    FlagPl: defineAsyncComponent(() => import('./FlagPL-c4b71abd.js')),
    FlagPm: defineAsyncComponent(() => import('./FlagPM-61eaa2ad.js')),
    FlagPn: defineAsyncComponent(() => import('./FlagPN-cb5764ee.js')),
    FlagPr: defineAsyncComponent(() => import('./FlagPR-07132e50.js')),
    FlagPs: defineAsyncComponent(() => import('./FlagPS-4703db2b.js')),
    FlagPt: defineAsyncComponent(() => import('./FlagPT-afaafae2.js')),
    FlagPw: defineAsyncComponent(() => import('./FlagPW-ad428ffc.js')),
    FlagPy: defineAsyncComponent(() => import('./FlagPY-db555d15.js')),
    FlagQa: defineAsyncComponent(() => import('./FlagQA-d0713166.js')),
    FlagRe: defineAsyncComponent(() => import('./FlagRE-ce36cd90.js')),
    FlagRo: defineAsyncComponent(() => import('./FlagRO-7e1cc29e.js')),
    FlagRs: defineAsyncComponent(() => import('./FlagRS-68c40799.js')),
    FlagRu: defineAsyncComponent(() => import('./FlagRU-9cdd005c.js')),
    FlagRw: defineAsyncComponent(() => import('./FlagRW-629002bf.js')),
    FlagSa: defineAsyncComponent(() => import('./FlagSA-28f134e3.js')),
    FlagSb: defineAsyncComponent(() => import('./FlagSB-5a547478.js')),
    FlagSc: defineAsyncComponent(() => import('./FlagSC-359c1dc1.js')),
    FlagSd: defineAsyncComponent(() => import('./FlagSD-02524daa.js')),
    FlagSe: defineAsyncComponent(() => import('./FlagSE-98a64129.js')),
    FlagSg: defineAsyncComponent(() => import('./FlagSG-43aea1e2.js')),
    FlagSh: defineAsyncComponent(() => import('./FlagSH-36cc4a88.js')),
    FlagSi: defineAsyncComponent(() => import('./FlagSI-0773e690.js')),
    FlagSj: defineAsyncComponent(() => import('./FlagSJ-95193075.js')),
    FlagSk: defineAsyncComponent(() => import('./FlagSK-695be213.js')),
    FlagSl: defineAsyncComponent(() => import('./FlagSL-a18f8478.js')),
    FlagSm: defineAsyncComponent(() => import('./FlagSM-e7a33d8d.js')),
    FlagSn: defineAsyncComponent(() => import('./FlagSN-5693e435.js')),
    FlagSo: defineAsyncComponent(() => import('./FlagSO-a417d69e.js')),
    FlagSr: defineAsyncComponent(() => import('./FlagSR-607ce0db.js')),
    FlagSs: defineAsyncComponent(() => import('./FlagSS-583acdfd.js')),
    FlagSt: defineAsyncComponent(() => import('./FlagST-f8aa0d41.js')),
    FlagSv: defineAsyncComponent(() => import('./FlagSV-3080b5ec.js')),
    FlagSx: defineAsyncComponent(() => import('./FlagSX-738c59ab.js')),
    FlagSy: defineAsyncComponent(() => import('./FlagSY-bf2490ed.js')),
    FlagSz: defineAsyncComponent(() => import('./FlagSZ-e4008b7a.js')),
    FlagTa: defineAsyncComponent(() => import('./FlagTA-da064b91.js')),
    FlagTc: defineAsyncComponent(() => import('./FlagTC-0a2b0f4f.js')),
    FlagTd: defineAsyncComponent(() => import('./FlagTD-0efd5dce.js')),
    FlagTf: defineAsyncComponent(() => import('./FlagTF-7418e6f0.js')),
    FlagTg: defineAsyncComponent(() => import('./FlagTG-3db1754d.js')),
    FlagTh: defineAsyncComponent(() => import('./FlagTH-e3bddf9c.js')),
    FlagTj: defineAsyncComponent(() => import('./FlagTJ-9813f1ec.js')),
    FlagTk: defineAsyncComponent(() => import('./FlagTK-ad422a32.js')),
    FlagTl: defineAsyncComponent(() => import('./FlagTL-e0b6da30.js')),
    FlagTm: defineAsyncComponent(() => import('./FlagTM-804d6a76.js')),
    FlagTn: defineAsyncComponent(() => import('./FlagTN-76a7fc99.js')),
    FlagTo: defineAsyncComponent(() => import('./FlagTO-9ebf823d.js')),
    FlagTr: defineAsyncComponent(() => import('./FlagTR-5afe6c44.js')),
    FlagTt: defineAsyncComponent(() => import('./FlagTT-37c01330.js')),
    FlagTv: defineAsyncComponent(() => import('./FlagTV-44b6cb66.js')),
    FlagTw: defineAsyncComponent(() => import('./FlagTW-1c5d5a19.js')),
    FlagTz: defineAsyncComponent(() => import('./FlagTZ-c38e3da1.js')),
    FlagUa: defineAsyncComponent(() => import('./FlagUA-9d48badd.js')),
    FlagUg: defineAsyncComponent(() => import('./FlagUG-79e4a994.js')),
    FlagUm: defineAsyncComponent(() => import('./FlagUM-49478599.js')),
    FlagUs: defineAsyncComponent(() => import('./FlagUS-23044c02.js')),
    FlagUy: defineAsyncComponent(() => import('./FlagUY-bfc9882f.js')),
    FlagUz: defineAsyncComponent(() => import('./FlagUZ-7da2a080.js')),
    FlagVa: defineAsyncComponent(() => import('./FlagVA-3c05a0a4.js')),
    FlagVc: defineAsyncComponent(() => import('./FlagVC-c69239ff.js')),
    FlagVe: defineAsyncComponent(() => import('./FlagVE-0791e419.js')),
    FlagVg: defineAsyncComponent(() => import('./FlagVG-b74f0a84.js')),
    FlagVi: defineAsyncComponent(() => import('./FlagVI-891d678c.js')),
    FlagVn: defineAsyncComponent(() => import('./FlagVN-d76e33b5.js')),
    FlagVu: defineAsyncComponent(() => import('./FlagVU-d80b60ba.js')),
    FlagWf: defineAsyncComponent(() => import('./FlagWF-bd55dfbe.js')),
    FlagWs: defineAsyncComponent(() => import('./FlagWS-633ef457.js')),
    FlagXk: defineAsyncComponent(() => import('./FlagXK-4568c873.js')),
    FlagYe: defineAsyncComponent(() => import('./FlagYE-7d7d10d4.js')),
    FlagYt: defineAsyncComponent(() => import('./FlagYT-7917da21.js')),
    FlagZa: defineAsyncComponent(() => import('./FlagZA-a19a6bb8.js')),
    FlagZm: defineAsyncComponent(() => import('./FlagZM-4dc1e1d6.js')),
    FlagZw: defineAsyncComponent(() => import('./FlagZW-a028eb31.js'))
  },
  props: {
    country: {
      type: String,
      default: "en"
    }
  },
  computed: {
    componentName() {
      return `flag-${this.country.toLowerCase()}`;
    }
  }
};

const _export_sfc = (sfc, props) => {
  const target = sfc.__vccOpts || sfc;
  for (const [key, val] of props) {
    target[key] = val;
  }
  return target;
};

function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createBlock(resolveDynamicComponent($options.componentName));
}
const Flag = /* @__PURE__ */ _export_sfc(_sfc_main$P, [["render", _sfc_render]]);

const defaultVariant = {
  wrapper: "block w-full",
  // TDropdown Component
  trigger: mergeClasses(
    commonClasses.inputsBackground,
    commonClasses.inputsBorder,
    commonClasses.inputsRingBase,
    commonClasses.inputsRing,
    // commonClasses.inputsRadius,
    // Only way to get border-b-none and etc working :(
    "relative flex items-center justify-between w-full focus:z-10 cursor-pointer",
    commonClasses.inputsText,
    commonClasses.inputsTransition,
    commonClasses.inputsShadows,
    commonClasses.inputsDisabled,
    commonClasses.inputsSpacing
  ),
  dropdown: mergeClasses(
    "z-50 overflow-hidden",
    commonClasses.dropdownsBackground,
    commonClasses.dropdownsBorder,
    commonClasses.dropdownsRadius,
    commonClasses.dropdownsShadows
  ),
  // Dropdown content
  dropdownContent: "space-y-1",
  dropdownContentWithSearch: "pt-1",
  // Clear button
  clearButton: mergeClasses(
    "absolute flex items-center justify-center text-gray-600 dark:text-gray-300 dark:text rounded mr-3 hover:bg-gray-100 dark:hover:bg-gray-700 focus:ring-opacity-70 top-1/2 right-0 transform -translate-y-1/2",
    commonClasses.buttonRing,
    "focus:ring-primary-600",
    commonClasses.iconsSize,
    commonClasses.inputsTransition
  ),
  clearButtonIcon: "fill-current h-4 w-4",
  // Option list
  // We could also have here space-y-1
  optionsList: "scrollbar-thin",
  // Option wrapper
  optionWrapper: "focus:outline-none",
  // Option button
  option: mergeClasses(
    "w-full disabled:opacity-50",
    "cursor-pointer disabled:cursor-not-allowed",
    "text-sm font-normal",
    "px-3 py-2",
    "focus:outline-none"
  ),
  selectedOption: "bg-gray-50 dark:bg-gray-800 focus:outline-none",
  highlightedOption: "text-primary-900 bg-primary-100 dark:bg-primary-300 dark:text-black focus:outline-none",
  selectedHighlightedOption: "font-semibold bg-primary-50 dark:bg-primary-400 dark:text-black focus:outline-none",
  //  Option content
  optionContent: "flex items-center justify-between",
  optionLabel: "block truncate",
  optionSelectedIcon: mergeClasses(
    "",
    commonClasses.iconsSize
  ),
  // Option group
  optgroup: "space-y-2",
  optgroupContent: "",
  optgroupLabel: "block px-3 py-2 text-xs text-gray-400 uppercase truncate",
  optgroupOptionsList: "px-2 pb-2",
  // Search
  searchWrapper: "inline-block w-full px-3 py-2",
  searchInput: mergeClasses(
    "inline-block w-full shadow-inner focus:ring-opacity-70 text-sm px-4 py-2.5",
    commonClasses.inputsTextColor,
    commonClasses.inputsRingBase,
    commonClasses.inputsRing,
    commonClasses.inputsBorder,
    commonClasses.inputsRadius,
    commonClasses.inputsShadows,
    commonClasses.inputsBackgroundDarkerOrSofter
  ),
  // State texts
  searchingText: "flex items-center justify-center px-3 py-2 text-sm text-gray-500 dark:text-gray-400 text-center space-x-2",
  needsMoreCharsText: "flex items-center justify-center px-3 pt-0 pb-2 text-xs text-gray-500 dark:text-gray-400 text-center space-x-2",
  noResultsText: "flex items-center justify-center px-3 py-2 text-sm text-gray-500 dark:text-gray-400 text-center space-x-2",
  // optionsListLoadingMore: 'flex items-center justify-between text-sm text-gray-500 dark:text-gray-400 text-center',
  optionsListLoadingMore: "flex items-center justify-center px-3 py-2 text-sm text-gray-500 dark:text-gray-400 text-center space-x-2",
  // Select button
  selectButtonLabel: "block pr-4 truncate",
  selectButtonPlaceholder: "block text-gray-500/90 truncate",
  selectButtonSearchingPlaceholder: "block text-gray-400 truncate",
  selectButtonLoadingIcon: "flex-shrink-0 w-4 h-4 ml-1 text-gray-600",
  selectButtonSelectorIcon: "flex-shrink-0 w-4 h-4 ml-1 dark:text-gray-500 text-gray-400",
  // Select button tags
  tagsWrapper: "flex flex-wrap overflow-hidden -mx-2 -my-2 py-1 pr-8",
  // Single tag
  tag: mergeClasses(
    "rounded shadow-sm flex items-center cursor-pointer",
    "bg-primary-100 dark:bg-primary-500/20 dark:border dark:border-gray-700",
    "m-0.5 h-8 max-w-full",
    "text-primary-900 dark:text-white white-space-no text-sm font-semibold",
    commonClasses.buttonRing,
    "focus:ring-opacity-50 focus:ring-primary-600",
    commonClasses.inputsTransition,
    commonClasses.inputsDisabled
  ),
  tagLabel: "px-3",
  tagDeleteButton: mergeClasses(
    commonClasses.inputsTransition,
    commonClasses.buttonRing,
    "focus:ring-opacity-50 focus:ring-primary-600",
    "-ml-1.5 h-full hover:shadow-sm inline-flex items-center px-2 rounded-r",
    "text-primary-400 focus:text-white hover:text-primary-500 dark:hover:text-white",
    "hover:bg-primary-200 focus:bg-primary-500 dark:hover:bg-primary-400/20 dark:focus:bg-primary-500/20"
  ),
  tagDeleteButtonIcon: "w-3 h-3",
  // Own Configuration ( not vanilla )
  groupedBelow: "rounded-b-none border-b-0 focus:border-b focus:border-primary-500 z-10",
  groupedAbove: "rounded-t-none border-t-0 focus:border-t focus:border-primary-500 z-10",
  // State
  stateWrapper: "flex items-center justify-center space-x-1",
  stateLoadingIcon: "animate-spin w-3.5 h-3.5 -mr-2",
  // Transitions
  ...enterAndLeave
};
const richSelectConfig = {
  // Until the little bits are merged or variantjs fixes this issue or provider a clear way to override the trigger
  fixedClasses: {
    trigger: "relative appearance-none focus:outline-none",
    clearButton: "z-10"
  },
  // Default Input appearance
  classes: {
    ...defaultVariant
  },
  // Variants
  variants: {
    // Errors
    error: {
      classes: {
        ...Object.assign(defaultVariant, {
          // Trigger
          trigger: mergeClasses(
            commonClasses.inputsRingBase,
            commonClasses.inputsErrorsBackground,
            commonClasses.inputsErrorsBorder,
            commonClasses.inputsErrorsRing,
            commonClasses.inputsErrorTextColor,
            commonClasses.inputsRadius,
            // Only way to get border-b-none and etc working :(
            "flex items-center justify-between w-full",
            commonClasses.inputsText,
            commonClasses.inputsTransition,
            commonClasses.inputsShadows,
            commonClasses.inputsDisabled,
            commonClasses.inputsSpacing
          ),
          // Clear button
          clearButton: mergeClasses(
            "absolute flex items-center justify-center text-red-400 dark:text-red-300 dark:text rounded mr-3 hover:bg-gray-100 dark:hover:bg-gray-700 focus:ring-opacity-70 top-1/2 right-0 transform -translate-y-1/2",
            commonClasses.buttonErrorsRing,
            commonClasses.iconsSize,
            commonClasses.inputsTransition
          ),
          selectButtonPlaceholder: "block text-red-400 placeholder-red-400 truncate",
          // Single tag
          tag: mergeClasses(
            "rounded shadow-sm flex items-center cursor-pointer",
            "bg-red-100 dark:bg-red-500/20",
            "m-0.5 h-8 max-w-full",
            "text-red-900 dark:text-red-300 white-space-no text-sm white-space-no",
            commonClasses.buttonErrorsRing,
            commonClasses.inputsTransition,
            commonClasses.inputsDisabled
          ),
          tagDeleteButton: mergeClasses(
            commonClasses.inputsTransition,
            commonClasses.buttonErrorsRing,
            "focus:ring-opacity-50",
            "-ml-1.5 h-full hover:shadow-sm inline-flex items-center px-2 rounded-r",
            "text-red-900 dark:text-red-300 focus:text-white hover:text-red-800 dark:hover:text-red-200",
            "hover:bg-red-200 focus:bg-red-500 dark:hover:bg-red-400/20 dark:focus:bg-red-500/20"
          )
        })
      }
    }
  }
};
const richSelectClassesKeys = Object.keys(richSelectConfig.classes);

const countryInputConfig = richSelectConfig;
const countryInputOptionConfig = {
  classes: {
    wrapper: "relative",
    labelAndImageWrapper: "relative",
    labelAndImageContainer: "flex items-center space-x-2 text-sm block",
    labelAndImageContainerSelected: "font-semibold",
    labelAndImageContainerRegular: "font-normal",
    image: "flex-shrink-0 w-6 h-6",
    label: "block whitespace-nowrap truncate",
    selectedIconContainer: "absolute inset-y-0 right-0 flex items-center pl-3 pr-3 text-primary-600",
    fallbackImage: "flex-shrink-0 w-[24px] h-[16px] bg-gray-300 animate-pulse rounded-sm",
    icon: commonClasses.iconsSize
  }
};
const countryInputClassesKeys = Object.keys(countryInputConfig.classes);
const countryInputOptionClassesKeys = Object.keys(countryInputOptionConfig.classes);

const _hoisted_1$T = {
  viewBox: "0 0 24 24",
  width: "1.2em",
  height: "1.2em"
};
const _hoisted_2$J = /*#__PURE__*/createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M19.916 4.626a.75.75 0 0 1 .208 1.04l-9 13.5a.75.75 0 0 1-1.154.114l-6-6a.75.75 0 0 1 1.06-1.06l5.353 5.353l8.493-12.739a.75.75 0 0 1 1.04-.208Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3$u = [
  _hoisted_2$J
];

function render$n(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$T, _hoisted_3$u))
}

const CheckIcon$1 = { name: 'heroicons-check-solid', render: render$n };
/* vite-plugin-components disabled */

const _hoisted_1$S = ["innerHTML"];
const _hoisted_2$I = ["innerHTML"];
const __default__$E = {
  name: "VanillaCountryInputOption",
  inheritAttrs: false
};
const _sfc_main$O = /* @__PURE__ */ defineComponent({
  ...__default__$E,
  props: {
    country: {
      // TODO : move this to a exported type
      type: [Object, Array],
      required: true
    },
    selected: {
      type: Boolean,
      default: false
    },
    description: {
      type: [String],
      default: void 0
    },
    hasErrors: {
      type: Boolean,
      default: false
    },
    parentClasses: {
      type: [String, Array],
      default: ""
    },
    labelWithDialCode: {
      type: Boolean,
      required: false,
      default: false
    },
    labelWithCountryCode: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  setup(__props) {
    const props = __props;
    const { configuration } = useConfiguration(countryInputOptionConfig, "CountryInputOption");
    const nameLabel = computed(() => {
      if (props.labelWithDialCode) {
        return `${props.country.label} +${props.country.dialCode}`;
      }
      if (props.labelWithCountryCode) {
        return `${props.country.label} (${props.country.dialCode})`;
      }
      if (props.labelWithDialCode && props.labelWithCountryCode) {
        return `${props.country.label} +${props.country.dialCode} (${props.country.dialCode})`;
      }
      return props.country.label;
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass([__props.parentClasses, unref(configuration).classesList.wrapper])
      }, [
        createElementVNode("div", {
          class: normalizeClass([unref(configuration).classesList.labelAndImageWrapper])
        }, [
          createElementVNode("div", {
            class: normalizeClass([
              __props.selected ? unref(configuration).classesList.labelAndImageContainerSelected : "",
              !__props.selected ? unref(configuration).classesList.labelAndImageContainerRegular : "",
              unref(configuration).classesList.labelAndImageContainer
            ])
          }, [
            (openBlock(), createBlock(Suspense, null, {
              fallback: withCtx(() => [
                createElementVNode("div", {
                  class: normalizeClass(unref(configuration).classesList.fallbackImage)
                }, null, 2)
              ]),
              default: withCtx(() => [
                createVNode(Flag, {
                  class: normalizeClass([
                    unref(configuration).classesList.image
                  ]),
                  country: __props.country?.iso2
                }, null, 8, ["class", "country"])
              ]),
              _: 1
            })),
            createElementVNode("span", {
              class: normalizeClass([
                unref(configuration).classesList.label
              ]),
              innerHTML: unref(nameLabel)
            }, null, 10, _hoisted_1$S)
          ], 2)
        ], 2),
        __props.description ? (openBlock(), createElementBlock("div", {
          key: 0,
          class: normalizeClass([
            unref(configuration).classesList.description,
            __props.selected ? unref(configuration).classesList.descriptionSelected : "",
            !__props.selected ? unref(configuration).classesList.descriptionRegular : ""
          ]),
          innerHTML: __props.description
        }, null, 10, _hoisted_2$I)) : createCommentVNode("", true),
        __props.selected ? (openBlock(), createElementBlock("span", {
          key: 1,
          class: normalizeClass([unref(configuration).classesList.selectedIconContainer])
        }, [
          renderSlot(_ctx.$slots, "selectedIcon", {}, () => [
            createVNode(unref(CheckIcon$1), {
              "aria-hidden": "true",
              class: normalizeClass([unref(configuration).classesList.icon])
            }, null, 8, ["class"])
          ])
        ], 2)) : createCommentVNode("", true)
      ], 2);
    };
  }
});

var baseKeys = _baseKeys,
    getTag = _getTag,
    isArguments = isArguments_1,
    isArray = isArray_1,
    isArrayLike$1 = isArrayLike_1,
    isBuffer = isBufferExports,
    isPrototype$1 = _isPrototype,
    isTypedArray = isTypedArray_1;

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    setTag = '[object Set]';

/** Used for built-in method references. */
var objectProto$1 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$1 = objectProto$1.hasOwnProperty;

/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */
function isEmpty(value) {
  if (value == null) {
    return true;
  }
  if (isArrayLike$1(value) &&
      (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
        isBuffer(value) || isTypedArray(value) || isArguments(value))) {
    return !value.length;
  }
  var tag = getTag(value);
  if (tag == mapTag || tag == setTag) {
    return !value.size;
  }
  if (isPrototype$1(value)) {
    return !baseKeys(value).length;
  }
  for (var key in value) {
    if (hasOwnProperty$1.call(value, key)) {
      return false;
    }
  }
  return true;
}

var isEmpty_1 = isEmpty;

const isEmpty$1 = isEmpty_1;

/*!
* tabbable 6.0.1
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/
var candidateSelectors = ['input', 'select', 'textarea', 'a[href]', 'button', '[tabindex]:not(slot)', 'audio[controls]', 'video[controls]', '[contenteditable]:not([contenteditable="false"])', 'details>summary:first-of-type', 'details'];
var candidateSelector = /* #__PURE__ */candidateSelectors.join(',');
var NoElement = typeof Element === 'undefined';
var matches = NoElement ? function () {} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
var getRootNode = !NoElement && Element.prototype.getRootNode ? function (element) {
  return element.getRootNode();
} : function (element) {
  return element.ownerDocument;
};

/**
 * @param {Element} el container to check in
 * @param {boolean} includeContainer add container to check
 * @param {(node: Element) => boolean} filter filter candidates
 * @returns {Element[]}
 */
var getCandidates = function getCandidates(el, includeContainer, filter) {
  var candidates = Array.prototype.slice.apply(el.querySelectorAll(candidateSelector));
  if (includeContainer && matches.call(el, candidateSelector)) {
    candidates.unshift(el);
  }
  candidates = candidates.filter(filter);
  return candidates;
};

/**
 * @callback GetShadowRoot
 * @param {Element} element to check for shadow root
 * @returns {ShadowRoot|boolean} ShadowRoot if available or boolean indicating if a shadowRoot is attached but not available.
 */

/**
 * @callback ShadowRootFilter
 * @param {Element} shadowHostNode the element which contains shadow content
 * @returns {boolean} true if a shadow root could potentially contain valid candidates.
 */

/**
 * @typedef {Object} CandidateScope
 * @property {Element} scopeParent contains inner candidates
 * @property {Element[]} candidates list of candidates found in the scope parent
 */

/**
 * @typedef {Object} IterativeOptions
 * @property {GetShadowRoot|boolean} getShadowRoot true if shadow support is enabled; falsy if not;
 *  if a function, implies shadow support is enabled and either returns the shadow root of an element
 *  or a boolean stating if it has an undisclosed shadow root
 * @property {(node: Element) => boolean} filter filter candidates
 * @property {boolean} flatten if true then result will flatten any CandidateScope into the returned list
 * @property {ShadowRootFilter} shadowRootFilter filter shadow roots;
 */

/**
 * @param {Element[]} elements list of element containers to match candidates from
 * @param {boolean} includeContainer add container list to check
 * @param {IterativeOptions} options
 * @returns {Array.<Element|CandidateScope>}
 */
var getCandidatesIteratively = function getCandidatesIteratively(elements, includeContainer, options) {
  var candidates = [];
  var elementsToCheck = Array.from(elements);
  while (elementsToCheck.length) {
    var element = elementsToCheck.shift();
    if (element.tagName === 'SLOT') {
      // add shadow dom slot scope (slot itself cannot be focusable)
      var assigned = element.assignedElements();
      var content = assigned.length ? assigned : element.children;
      var nestedCandidates = getCandidatesIteratively(content, true, options);
      if (options.flatten) {
        candidates.push.apply(candidates, nestedCandidates);
      } else {
        candidates.push({
          scopeParent: element,
          candidates: nestedCandidates
        });
      }
    } else {
      // check candidate element
      var validCandidate = matches.call(element, candidateSelector);
      if (validCandidate && options.filter(element) && (includeContainer || !elements.includes(element))) {
        candidates.push(element);
      }

      // iterate over shadow content if possible
      var shadowRoot = element.shadowRoot ||
      // check for an undisclosed shadow
      typeof options.getShadowRoot === 'function' && options.getShadowRoot(element);
      var validShadowRoot = !options.shadowRootFilter || options.shadowRootFilter(element);
      if (shadowRoot && validShadowRoot) {
        // add shadow dom scope IIF a shadow root node was given; otherwise, an undisclosed
        //  shadow exists, so look at light dom children as fallback BUT create a scope for any
        //  child candidates found because they're likely slotted elements (elements that are
        //  children of the web component element (which has the shadow), in the light dom, but
        //  slotted somewhere _inside_ the undisclosed shadow) -- the scope is created below,
        //  _after_ we return from this recursive call
        var _nestedCandidates = getCandidatesIteratively(shadowRoot === true ? element.children : shadowRoot.children, true, options);
        if (options.flatten) {
          candidates.push.apply(candidates, _nestedCandidates);
        } else {
          candidates.push({
            scopeParent: element,
            candidates: _nestedCandidates
          });
        }
      } else {
        // there's not shadow so just dig into the element's (light dom) children
        //  __without__ giving the element special scope treatment
        elementsToCheck.unshift.apply(elementsToCheck, element.children);
      }
    }
  }
  return candidates;
};
var getTabindex = function getTabindex(node, isScope) {
  if (node.tabIndex < 0) {
    // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
    // `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
    // yet they are still part of the regular tab order; in FF, they get a default
    // `tabIndex` of 0; since Chrome still puts those elements in the regular tab
    // order, consider their tab index to be 0.
    // Also browsers do not return `tabIndex` correctly for contentEditable nodes;
    // so if they don't have a tabindex attribute specifically set, assume it's 0.
    //
    // isScope is positive for custom element with shadow root or slot that by default
    // have tabIndex -1, but need to be sorted by document order in order for their
    // content to be inserted in the correct position
    if ((isScope || /^(AUDIO|VIDEO|DETAILS)$/.test(node.tagName) || node.isContentEditable) && isNaN(parseInt(node.getAttribute('tabindex'), 10))) {
      return 0;
    }
  }
  return node.tabIndex;
};
var sortOrderedTabbables = function sortOrderedTabbables(a, b) {
  return a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex;
};
var isInput = function isInput(node) {
  return node.tagName === 'INPUT';
};
var isHiddenInput = function isHiddenInput(node) {
  return isInput(node) && node.type === 'hidden';
};
var isDetailsWithSummary = function isDetailsWithSummary(node) {
  var r = node.tagName === 'DETAILS' && Array.prototype.slice.apply(node.children).some(function (child) {
    return child.tagName === 'SUMMARY';
  });
  return r;
};
var getCheckedRadio = function getCheckedRadio(nodes, form) {
  for (var i = 0; i < nodes.length; i++) {
    if (nodes[i].checked && nodes[i].form === form) {
      return nodes[i];
    }
  }
};
var isTabbableRadio = function isTabbableRadio(node) {
  if (!node.name) {
    return true;
  }
  var radioScope = node.form || getRootNode(node);
  var queryRadios = function queryRadios(name) {
    return radioScope.querySelectorAll('input[type="radio"][name="' + name + '"]');
  };
  var radioSet;
  if (typeof window !== 'undefined' && typeof window.CSS !== 'undefined' && typeof window.CSS.escape === 'function') {
    radioSet = queryRadios(window.CSS.escape(node.name));
  } else {
    try {
      radioSet = queryRadios(node.name);
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error('Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s', err.message);
      return false;
    }
  }
  var checked = getCheckedRadio(radioSet, node.form);
  return !checked || checked === node;
};
var isRadio = function isRadio(node) {
  return isInput(node) && node.type === 'radio';
};
var isNonTabbableRadio = function isNonTabbableRadio(node) {
  return isRadio(node) && !isTabbableRadio(node);
};

// determines if a node is ultimately attached to the window's document
var isNodeAttached = function isNodeAttached(node) {
  var _nodeRootHost;
  // The root node is the shadow root if the node is in a shadow DOM; some document otherwise
  //  (but NOT _the_ document; see second 'If' comment below for more).
  // If rootNode is shadow root, it'll have a host, which is the element to which the shadow
  //  is attached, and the one we need to check if it's in the document or not (because the
  //  shadow, and all nodes it contains, is never considered in the document since shadows
  //  behave like self-contained DOMs; but if the shadow's HOST, which is part of the document,
  //  is hidden, or is not in the document itself but is detached, it will affect the shadow's
  //  visibility, including all the nodes it contains). The host could be any normal node,
  //  or a custom element (i.e. web component). Either way, that's the one that is considered
  //  part of the document, not the shadow root, nor any of its children (i.e. the node being
  //  tested).
  // To further complicate things, we have to look all the way up until we find a shadow HOST
  //  that is attached (or find none) because the node might be in nested shadows...
  // If rootNode is not a shadow root, it won't have a host, and so rootNode should be the
  //  document (per the docs) and while it's a Document-type object, that document does not
  //  appear to be the same as the node's `ownerDocument` for some reason, so it's safer
  //  to ignore the rootNode at this point, and use `node.ownerDocument`. Otherwise,
  //  using `rootNode.contains(node)` will _always_ be true we'll get false-positives when
  //  node is actually detached.
  var nodeRootHost = getRootNode(node).host;
  var attached = !!((_nodeRootHost = nodeRootHost) !== null && _nodeRootHost !== void 0 && _nodeRootHost.ownerDocument.contains(nodeRootHost) || node.ownerDocument.contains(node));
  while (!attached && nodeRootHost) {
    var _nodeRootHost2;
    // since it's not attached and we have a root host, the node MUST be in a nested shadow DOM,
    //  which means we need to get the host's host and check if that parent host is contained
    //  in (i.e. attached to) the document
    nodeRootHost = getRootNode(nodeRootHost).host;
    attached = !!((_nodeRootHost2 = nodeRootHost) !== null && _nodeRootHost2 !== void 0 && _nodeRootHost2.ownerDocument.contains(nodeRootHost));
  }
  return attached;
};
var isZeroArea = function isZeroArea(node) {
  var _node$getBoundingClie = node.getBoundingClientRect(),
    width = _node$getBoundingClie.width,
    height = _node$getBoundingClie.height;
  return width === 0 && height === 0;
};
var isHidden = function isHidden(node, _ref) {
  var displayCheck = _ref.displayCheck,
    getShadowRoot = _ref.getShadowRoot;
  // NOTE: visibility will be `undefined` if node is detached from the document
  //  (see notes about this further down), which means we will consider it visible
  //  (this is legacy behavior from a very long way back)
  // NOTE: we check this regardless of `displayCheck="none"` because this is a
  //  _visibility_ check, not a _display_ check
  if (getComputedStyle(node).visibility === 'hidden') {
    return true;
  }
  var isDirectSummary = matches.call(node, 'details>summary:first-of-type');
  var nodeUnderDetails = isDirectSummary ? node.parentElement : node;
  if (matches.call(nodeUnderDetails, 'details:not([open]) *')) {
    return true;
  }
  if (!displayCheck || displayCheck === 'full' || displayCheck === 'legacy-full') {
    if (typeof getShadowRoot === 'function') {
      // figure out if we should consider the node to be in an undisclosed shadow and use the
      //  'non-zero-area' fallback
      var originalNode = node;
      while (node) {
        var parentElement = node.parentElement;
        var rootNode = getRootNode(node);
        if (parentElement && !parentElement.shadowRoot && getShadowRoot(parentElement) === true // check if there's an undisclosed shadow
        ) {
          // node has an undisclosed shadow which means we can only treat it as a black box, so we
          //  fall back to a non-zero-area test
          return isZeroArea(node);
        } else if (node.assignedSlot) {
          // iterate up slot
          node = node.assignedSlot;
        } else if (!parentElement && rootNode !== node.ownerDocument) {
          // cross shadow boundary
          node = rootNode.host;
        } else {
          // iterate up normal dom
          node = parentElement;
        }
      }
      node = originalNode;
    }
    // else, `getShadowRoot` might be true, but all that does is enable shadow DOM support
    //  (i.e. it does not also presume that all nodes might have undisclosed shadows); or
    //  it might be a falsy value, which means shadow DOM support is disabled

    // Since we didn't find it sitting in an undisclosed shadow (or shadows are disabled)
    //  now we can just test to see if it would normally be visible or not, provided it's
    //  attached to the main document.
    // NOTE: We must consider case where node is inside a shadow DOM and given directly to
    //  `isTabbable()` or `isFocusable()` -- regardless of `getShadowRoot` option setting.

    if (isNodeAttached(node)) {
      // this works wherever the node is: if there's at least one client rect, it's
      //  somehow displayed; it also covers the CSS 'display: contents' case where the
      //  node itself is hidden in place of its contents; and there's no need to search
      //  up the hierarchy either
      return !node.getClientRects().length;
    }

    // Else, the node isn't attached to the document, which means the `getClientRects()`
    //  API will __always__ return zero rects (this can happen, for example, if React
    //  is used to render nodes onto a detached tree, as confirmed in this thread:
    //  https://github.com/facebook/react/issues/9117#issuecomment-284228870)
    //
    // It also means that even window.getComputedStyle(node).display will return `undefined`
    //  because styles are only computed for nodes that are in the document.
    //
    // NOTE: THIS HAS BEEN THE CASE FOR YEARS. It is not new, nor is it caused by tabbable
    //  somehow. Though it was never stated officially, anyone who has ever used tabbable
    //  APIs on nodes in detached containers has actually implicitly used tabbable in what
    //  was later (as of v5.2.0 on Apr 9, 2021) called `displayCheck="none"` mode -- essentially
    //  considering __everything__ to be visible because of the innability to determine styles.
    //
    // v6.0.0: As of this major release, the default 'full' option __no longer treats detached
    //  nodes as visible with the 'none' fallback.__
    if (displayCheck !== 'legacy-full') {
      return true; // hidden
    }
    // else, fallback to 'none' mode and consider the node visible
  } else if (displayCheck === 'non-zero-area') {
    // NOTE: Even though this tests that the node's client rect is non-zero to determine
    //  whether it's displayed, and that a detached node will __always__ have a zero-area
    //  client rect, we don't special-case for whether the node is attached or not. In
    //  this mode, we do want to consider nodes that have a zero area to be hidden at all
    //  times, and that includes attached or not.
    return isZeroArea(node);
  }

  // visible, as far as we can tell, or per current `displayCheck=none` mode, we assume
  //  it's visible
  return false;
};

// form fields (nested) inside a disabled fieldset are not focusable/tabbable
//  unless they are in the _first_ <legend> element of the top-most disabled
//  fieldset
var isDisabledFromFieldset = function isDisabledFromFieldset(node) {
  if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(node.tagName)) {
    var parentNode = node.parentElement;
    // check if `node` is contained in a disabled <fieldset>
    while (parentNode) {
      if (parentNode.tagName === 'FIELDSET' && parentNode.disabled) {
        // look for the first <legend> among the children of the disabled <fieldset>
        for (var i = 0; i < parentNode.children.length; i++) {
          var child = parentNode.children.item(i);
          // when the first <legend> (in document order) is found
          if (child.tagName === 'LEGEND') {
            // if its parent <fieldset> is not nested in another disabled <fieldset>,
            // return whether `node` is a descendant of its first <legend>
            return matches.call(parentNode, 'fieldset[disabled] *') ? true : !child.contains(node);
          }
        }
        // the disabled <fieldset> containing `node` has no <legend>
        return true;
      }
      parentNode = parentNode.parentElement;
    }
  }

  // else, node's tabbable/focusable state should not be affected by a fieldset's
  //  enabled/disabled state
  return false;
};
var isNodeMatchingSelectorFocusable = function isNodeMatchingSelectorFocusable(options, node) {
  if (node.disabled || isHiddenInput(node) || isHidden(node, options) ||
  // For a details element with a summary, the summary element gets the focus
  isDetailsWithSummary(node) || isDisabledFromFieldset(node)) {
    return false;
  }
  return true;
};
var isNodeMatchingSelectorTabbable = function isNodeMatchingSelectorTabbable(options, node) {
  if (isNonTabbableRadio(node) || getTabindex(node) < 0 || !isNodeMatchingSelectorFocusable(options, node)) {
    return false;
  }
  return true;
};
var isValidShadowRootTabbable = function isValidShadowRootTabbable(shadowHostNode) {
  var tabIndex = parseInt(shadowHostNode.getAttribute('tabindex'), 10);
  if (isNaN(tabIndex) || tabIndex >= 0) {
    return true;
  }
  // If a custom element has an explicit negative tabindex,
  // browsers will not allow tab targeting said element's children.
  return false;
};

/**
 * @param {Array.<Element|CandidateScope>} candidates
 * @returns Element[]
 */
var sortByOrder = function sortByOrder(candidates) {
  var regularTabbables = [];
  var orderedTabbables = [];
  candidates.forEach(function (item, i) {
    var isScope = !!item.scopeParent;
    var element = isScope ? item.scopeParent : item;
    var candidateTabindex = getTabindex(element, isScope);
    var elements = isScope ? sortByOrder(item.candidates) : element;
    if (candidateTabindex === 0) {
      isScope ? regularTabbables.push.apply(regularTabbables, elements) : regularTabbables.push(element);
    } else {
      orderedTabbables.push({
        documentOrder: i,
        tabIndex: candidateTabindex,
        item: item,
        isScope: isScope,
        content: elements
      });
    }
  });
  return orderedTabbables.sort(sortOrderedTabbables).reduce(function (acc, sortable) {
    sortable.isScope ? acc.push.apply(acc, sortable.content) : acc.push(sortable.content);
    return acc;
  }, []).concat(regularTabbables);
};
var tabbable = function tabbable(el, options) {
  options = options || {};
  var candidates;
  if (options.getShadowRoot) {
    candidates = getCandidatesIteratively([el], options.includeContainer, {
      filter: isNodeMatchingSelectorTabbable.bind(null, options),
      flatten: false,
      getShadowRoot: options.getShadowRoot,
      shadowRootFilter: isValidShadowRootTabbable
    });
  } else {
    candidates = getCandidates(el, options.includeContainer, isNodeMatchingSelectorTabbable.bind(null, options));
  }
  return sortByOrder(candidates);
};
var focusable = function focusable(el, options) {
  options = options || {};
  var candidates;
  if (options.getShadowRoot) {
    candidates = getCandidatesIteratively([el], options.includeContainer, {
      filter: isNodeMatchingSelectorFocusable.bind(null, options),
      flatten: true,
      getShadowRoot: options.getShadowRoot
    });
  } else {
    candidates = getCandidates(el, options.includeContainer, isNodeMatchingSelectorFocusable.bind(null, options));
  }
  return candidates;
};
var isTabbable = function isTabbable(node, options) {
  options = options || {};
  if (!node) {
    throw new Error('No node provided');
  }
  if (matches.call(node, candidateSelector) === false) {
    return false;
  }
  return isNodeMatchingSelectorTabbable(options, node);
};
var focusableCandidateSelector = /* #__PURE__ */candidateSelectors.concat('iframe').join(',');
var isFocusable = function isFocusable(node, options) {
  options = options || {};
  if (!node) {
    throw new Error('No node provided');
  }
  if (matches.call(node, focusableCandidateSelector) === false) {
    return false;
  }
  return isNodeMatchingSelectorFocusable(options, node);
};

/*!
* focus-trap 7.1.0
* @license MIT, https://github.com/focus-trap/focus-trap/blob/master/LICENSE
*/

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

var rooTrapStack = [];
var activeFocusTraps = {
  activateTrap: function activateTrap(trapStack, trap) {
    if (trapStack.length > 0) {
      var activeTrap = trapStack[trapStack.length - 1];
      if (activeTrap !== trap) {
        activeTrap.pause();
      }
    }
    var trapIndex = trapStack.indexOf(trap);
    if (trapIndex === -1) {
      trapStack.push(trap);
    } else {
      // move this existing trap to the front of the queue
      trapStack.splice(trapIndex, 1);
      trapStack.push(trap);
    }
  },
  deactivateTrap: function deactivateTrap(trapStack, trap) {
    var trapIndex = trapStack.indexOf(trap);
    if (trapIndex !== -1) {
      trapStack.splice(trapIndex, 1);
    }
    if (trapStack.length > 0) {
      trapStack[trapStack.length - 1].unpause();
    }
  }
};
var isSelectableInput = function isSelectableInput(node) {
  return node.tagName && node.tagName.toLowerCase() === 'input' && typeof node.select === 'function';
};
var isEscapeEvent = function isEscapeEvent(e) {
  return e.key === 'Escape' || e.key === 'Esc' || e.keyCode === 27;
};
var isTabEvent = function isTabEvent(e) {
  return e.key === 'Tab' || e.keyCode === 9;
};
var delay = function delay(fn) {
  return setTimeout(fn, 0);
};

// Array.find/findIndex() are not supported on IE; this replicates enough
//  of Array.findIndex() for our needs
var findIndex = function findIndex(arr, fn) {
  var idx = -1;
  arr.every(function (value, i) {
    if (fn(value)) {
      idx = i;
      return false; // break
    }

    return true; // next
  });

  return idx;
};

/**
 * Get an option's value when it could be a plain value, or a handler that provides
 *  the value.
 * @param {*} value Option's value to check.
 * @param {...*} [params] Any parameters to pass to the handler, if `value` is a function.
 * @returns {*} The `value`, or the handler's returned value.
 */
var valueOrHandler = function valueOrHandler(value) {
  for (var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    params[_key - 1] = arguments[_key];
  }
  return typeof value === 'function' ? value.apply(void 0, params) : value;
};
var getActualTarget = function getActualTarget(event) {
  // NOTE: If the trap is _inside_ a shadow DOM, event.target will always be the
  //  shadow host. However, event.target.composedPath() will be an array of
  //  nodes "clicked" from inner-most (the actual element inside the shadow) to
  //  outer-most (the host HTML document). If we have access to composedPath(),
  //  then use its first element; otherwise, fall back to event.target (and
  //  this only works for an _open_ shadow DOM; otherwise,
  //  composedPath()[0] === event.target always).
  return event.target.shadowRoot && typeof event.composedPath === 'function' ? event.composedPath()[0] : event.target;
};
var createFocusTrap = function createFocusTrap(elements, userOptions) {
  // SSR: a live trap shouldn't be created in this type of environment so this
  //  should be safe code to execute if the `document` option isn't specified
  var doc = (userOptions === null || userOptions === void 0 ? void 0 : userOptions.document) || document;
  var trapStack = (userOptions === null || userOptions === void 0 ? void 0 : userOptions.trapStack) || rooTrapStack;
  var config = _objectSpread2({
    returnFocusOnDeactivate: true,
    escapeDeactivates: true,
    delayInitialFocus: true
  }, userOptions);
  var state = {
    // containers given to createFocusTrap()
    // @type {Array<HTMLElement>}
    containers: [],
    // list of objects identifying tabbable nodes in `containers` in the trap
    // NOTE: it's possible that a group has no tabbable nodes if nodes get removed while the trap
    //  is active, but the trap should never get to a state where there isn't at least one group
    //  with at least one tabbable node in it (that would lead to an error condition that would
    //  result in an error being thrown)
    // @type {Array<{
    //   container: HTMLElement,
    //   tabbableNodes: Array<HTMLElement>, // empty if none
    //   focusableNodes: Array<HTMLElement>, // empty if none
    //   firstTabbableNode: HTMLElement|null,
    //   lastTabbableNode: HTMLElement|null,
    //   nextTabbableNode: (node: HTMLElement, forward: boolean) => HTMLElement|undefined
    // }>}
    containerGroups: [],
    // same order/length as `containers` list

    // references to objects in `containerGroups`, but only those that actually have
    //  tabbable nodes in them
    // NOTE: same order as `containers` and `containerGroups`, but __not necessarily__
    //  the same length
    tabbableGroups: [],
    nodeFocusedBeforeActivation: null,
    mostRecentlyFocusedNode: null,
    active: false,
    paused: false,
    // timer ID for when delayInitialFocus is true and initial focus in this trap
    //  has been delayed during activation
    delayInitialFocusTimer: undefined
  };
  var trap; // eslint-disable-line prefer-const -- some private functions reference it, and its methods reference private functions, so we must declare here and define later

  /**
   * Gets a configuration option value.
   * @param {Object|undefined} configOverrideOptions If true, and option is defined in this set,
   *  value will be taken from this object. Otherwise, value will be taken from base configuration.
   * @param {string} optionName Name of the option whose value is sought.
   * @param {string|undefined} [configOptionName] Name of option to use __instead of__ `optionName`
   *  IIF `configOverrideOptions` is not defined. Otherwise, `optionName` is used.
   */
  var getOption = function getOption(configOverrideOptions, optionName, configOptionName) {
    return configOverrideOptions && configOverrideOptions[optionName] !== undefined ? configOverrideOptions[optionName] : config[configOptionName || optionName];
  };

  /**
   * Finds the index of the container that contains the element.
   * @param {HTMLElement} element
   * @returns {number} Index of the container in either `state.containers` or
   *  `state.containerGroups` (the order/length of these lists are the same); -1
   *  if the element isn't found.
   */
  var findContainerIndex = function findContainerIndex(element) {
    // NOTE: search `containerGroups` because it's possible a group contains no tabbable
    //  nodes, but still contains focusable nodes (e.g. if they all have `tabindex=-1`)
    //  and we still need to find the element in there
    return state.containerGroups.findIndex(function (_ref) {
      var container = _ref.container,
        tabbableNodes = _ref.tabbableNodes;
      return container.contains(element) ||
      // fall back to explicit tabbable search which will take into consideration any
      //  web components if the `tabbableOptions.getShadowRoot` option was used for
      //  the trap, enabling shadow DOM support in tabbable (`Node.contains()` doesn't
      //  look inside web components even if open)
      tabbableNodes.find(function (node) {
        return node === element;
      });
    });
  };

  /**
   * Gets the node for the given option, which is expected to be an option that
   *  can be either a DOM node, a string that is a selector to get a node, `false`
   *  (if a node is explicitly NOT given), or a function that returns any of these
   *  values.
   * @param {string} optionName
   * @returns {undefined | false | HTMLElement | SVGElement} Returns
   *  `undefined` if the option is not specified; `false` if the option
   *  resolved to `false` (node explicitly not given); otherwise, the resolved
   *  DOM node.
   * @throws {Error} If the option is set, not `false`, and is not, or does not
   *  resolve to a node.
   */
  var getNodeForOption = function getNodeForOption(optionName) {
    var optionValue = config[optionName];
    if (typeof optionValue === 'function') {
      for (var _len2 = arguments.length, params = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        params[_key2 - 1] = arguments[_key2];
      }
      optionValue = optionValue.apply(void 0, params);
    }
    if (optionValue === true) {
      optionValue = undefined; // use default value
    }

    if (!optionValue) {
      if (optionValue === undefined || optionValue === false) {
        return optionValue;
      }
      // else, empty string (invalid), null (invalid), 0 (invalid)

      throw new Error("`".concat(optionName, "` was specified but was not a node, or did not return a node"));
    }
    var node = optionValue; // could be HTMLElement, SVGElement, or non-empty string at this point

    if (typeof optionValue === 'string') {
      node = doc.querySelector(optionValue); // resolve to node, or null if fails
      if (!node) {
        throw new Error("`".concat(optionName, "` as selector refers to no known node"));
      }
    }
    return node;
  };
  var getInitialFocusNode = function getInitialFocusNode() {
    var node = getNodeForOption('initialFocus');

    // false explicitly indicates we want no initialFocus at all
    if (node === false) {
      return false;
    }
    if (node === undefined) {
      // option not specified: use fallback options
      if (findContainerIndex(doc.activeElement) >= 0) {
        node = doc.activeElement;
      } else {
        var firstTabbableGroup = state.tabbableGroups[0];
        var firstTabbableNode = firstTabbableGroup && firstTabbableGroup.firstTabbableNode;

        // NOTE: `fallbackFocus` option function cannot return `false` (not supported)
        node = firstTabbableNode || getNodeForOption('fallbackFocus');
      }
    }
    if (!node) {
      throw new Error('Your focus-trap needs to have at least one focusable element');
    }
    return node;
  };
  var updateTabbableNodes = function updateTabbableNodes() {
    state.containerGroups = state.containers.map(function (container) {
      var tabbableNodes = tabbable(container, config.tabbableOptions);

      // NOTE: if we have tabbable nodes, we must have focusable nodes; focusable nodes
      //  are a superset of tabbable nodes
      var focusableNodes = focusable(container, config.tabbableOptions);
      return {
        container: container,
        tabbableNodes: tabbableNodes,
        focusableNodes: focusableNodes,
        firstTabbableNode: tabbableNodes.length > 0 ? tabbableNodes[0] : null,
        lastTabbableNode: tabbableNodes.length > 0 ? tabbableNodes[tabbableNodes.length - 1] : null,
        /**
         * Finds the __tabbable__ node that follows the given node in the specified direction,
         *  in this container, if any.
         * @param {HTMLElement} node
         * @param {boolean} [forward] True if going in forward tab order; false if going
         *  in reverse.
         * @returns {HTMLElement|undefined} The next tabbable node, if any.
         */
        nextTabbableNode: function nextTabbableNode(node) {
          var forward = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
          // NOTE: If tabindex is positive (in order to manipulate the tab order separate
          //  from the DOM order), this __will not work__ because the list of focusableNodes,
          //  while it contains tabbable nodes, does not sort its nodes in any order other
          //  than DOM order, because it can't: Where would you place focusable (but not
          //  tabbable) nodes in that order? They have no order, because they aren't tabbale...
          // Support for positive tabindex is already broken and hard to manage (possibly
          //  not supportable, TBD), so this isn't going to make things worse than they
          //  already are, and at least makes things better for the majority of cases where
          //  tabindex is either 0/unset or negative.
          // FYI, positive tabindex issue: https://github.com/focus-trap/focus-trap/issues/375
          var nodeIdx = focusableNodes.findIndex(function (n) {
            return n === node;
          });
          if (nodeIdx < 0) {
            return undefined;
          }
          if (forward) {
            return focusableNodes.slice(nodeIdx + 1).find(function (n) {
              return isTabbable(n, config.tabbableOptions);
            });
          }
          return focusableNodes.slice(0, nodeIdx).reverse().find(function (n) {
            return isTabbable(n, config.tabbableOptions);
          });
        }
      };
    });
    state.tabbableGroups = state.containerGroups.filter(function (group) {
      return group.tabbableNodes.length > 0;
    });

    // throw if no groups have tabbable nodes and we don't have a fallback focus node either
    if (state.tabbableGroups.length <= 0 && !getNodeForOption('fallbackFocus') // returning false not supported for this option
    ) {
      throw new Error('Your focus-trap must have at least one container with at least one tabbable node in it at all times');
    }
  };
  var tryFocus = function tryFocus(node) {
    if (node === false) {
      return;
    }
    if (node === doc.activeElement) {
      return;
    }
    if (!node || !node.focus) {
      tryFocus(getInitialFocusNode());
      return;
    }
    node.focus({
      preventScroll: !!config.preventScroll
    });
    state.mostRecentlyFocusedNode = node;
    if (isSelectableInput(node)) {
      node.select();
    }
  };
  var getReturnFocusNode = function getReturnFocusNode(previousActiveElement) {
    var node = getNodeForOption('setReturnFocus', previousActiveElement);
    return node ? node : node === false ? false : previousActiveElement;
  };

  // This needs to be done on mousedown and touchstart instead of click
  // so that it precedes the focus event.
  var checkPointerDown = function checkPointerDown(e) {
    var target = getActualTarget(e);
    if (findContainerIndex(target) >= 0) {
      // allow the click since it ocurred inside the trap
      return;
    }
    if (valueOrHandler(config.clickOutsideDeactivates, e)) {
      // immediately deactivate the trap
      trap.deactivate({
        // if, on deactivation, we should return focus to the node originally-focused
        //  when the trap was activated (or the configured `setReturnFocus` node),
        //  then assume it's also OK to return focus to the outside node that was
        //  just clicked, causing deactivation, as long as that node is focusable;
        //  if it isn't focusable, then return focus to the original node focused
        //  on activation (or the configured `setReturnFocus` node)
        // NOTE: by setting `returnFocus: false`, deactivate() will do nothing,
        //  which will result in the outside click setting focus to the node
        //  that was clicked, whether it's focusable or not; by setting
        //  `returnFocus: true`, we'll attempt to re-focus the node originally-focused
        //  on activation (or the configured `setReturnFocus` node)
        returnFocus: config.returnFocusOnDeactivate && !isFocusable(target, config.tabbableOptions)
      });
      return;
    }

    // This is needed for mobile devices.
    // (If we'll only let `click` events through,
    // then on mobile they will be blocked anyways if `touchstart` is blocked.)
    if (valueOrHandler(config.allowOutsideClick, e)) {
      // allow the click outside the trap to take place
      return;
    }

    // otherwise, prevent the click
    e.preventDefault();
  };

  // In case focus escapes the trap for some strange reason, pull it back in.
  var checkFocusIn = function checkFocusIn(e) {
    var target = getActualTarget(e);
    var targetContained = findContainerIndex(target) >= 0;

    // In Firefox when you Tab out of an iframe the Document is briefly focused.
    if (targetContained || target instanceof Document) {
      if (targetContained) {
        state.mostRecentlyFocusedNode = target;
      }
    } else {
      // escaped! pull it back in to where it just left
      e.stopImmediatePropagation();
      tryFocus(state.mostRecentlyFocusedNode || getInitialFocusNode());
    }
  };

  // Hijack Tab events on the first and last focusable nodes of the trap,
  // in order to prevent focus from escaping. If it escapes for even a
  // moment it can end up scrolling the page and causing confusion so we
  // kind of need to capture the action at the keydown phase.
  var checkTab = function checkTab(e) {
    var target = getActualTarget(e);
    updateTabbableNodes();
    var destinationNode = null;
    if (state.tabbableGroups.length > 0) {
      // make sure the target is actually contained in a group
      // NOTE: the target may also be the container itself if it's focusable
      //  with tabIndex='-1' and was given initial focus
      var containerIndex = findContainerIndex(target);
      var containerGroup = containerIndex >= 0 ? state.containerGroups[containerIndex] : undefined;
      if (containerIndex < 0) {
        // target not found in any group: quite possible focus has escaped the trap,
        //  so bring it back in to...
        if (e.shiftKey) {
          // ...the last node in the last group
          destinationNode = state.tabbableGroups[state.tabbableGroups.length - 1].lastTabbableNode;
        } else {
          // ...the first node in the first group
          destinationNode = state.tabbableGroups[0].firstTabbableNode;
        }
      } else if (e.shiftKey) {
        // REVERSE

        // is the target the first tabbable node in a group?
        var startOfGroupIndex = findIndex(state.tabbableGroups, function (_ref2) {
          var firstTabbableNode = _ref2.firstTabbableNode;
          return target === firstTabbableNode;
        });
        if (startOfGroupIndex < 0 && (containerGroup.container === target || isFocusable(target, config.tabbableOptions) && !isTabbable(target, config.tabbableOptions) && !containerGroup.nextTabbableNode(target, false))) {
          // an exception case where the target is either the container itself, or
          //  a non-tabbable node that was given focus (i.e. tabindex is negative
          //  and user clicked on it or node was programmatically given focus)
          //  and is not followed by any other tabbable node, in which
          //  case, we should handle shift+tab as if focus were on the container's
          //  first tabbable node, and go to the last tabbable node of the LAST group
          startOfGroupIndex = containerIndex;
        }
        if (startOfGroupIndex >= 0) {
          // YES: then shift+tab should go to the last tabbable node in the
          //  previous group (and wrap around to the last tabbable node of
          //  the LAST group if it's the first tabbable node of the FIRST group)
          var destinationGroupIndex = startOfGroupIndex === 0 ? state.tabbableGroups.length - 1 : startOfGroupIndex - 1;
          var destinationGroup = state.tabbableGroups[destinationGroupIndex];
          destinationNode = destinationGroup.lastTabbableNode;
        }
      } else {
        // FORWARD

        // is the target the last tabbable node in a group?
        var lastOfGroupIndex = findIndex(state.tabbableGroups, function (_ref3) {
          var lastTabbableNode = _ref3.lastTabbableNode;
          return target === lastTabbableNode;
        });
        if (lastOfGroupIndex < 0 && (containerGroup.container === target || isFocusable(target, config.tabbableOptions) && !isTabbable(target, config.tabbableOptions) && !containerGroup.nextTabbableNode(target))) {
          // an exception case where the target is the container itself, or
          //  a non-tabbable node that was given focus (i.e. tabindex is negative
          //  and user clicked on it or node was programmatically given focus)
          //  and is not followed by any other tabbable node, in which
          //  case, we should handle tab as if focus were on the container's
          //  last tabbable node, and go to the first tabbable node of the FIRST group
          lastOfGroupIndex = containerIndex;
        }
        if (lastOfGroupIndex >= 0) {
          // YES: then tab should go to the first tabbable node in the next
          //  group (and wrap around to the first tabbable node of the FIRST
          //  group if it's the last tabbable node of the LAST group)
          var _destinationGroupIndex = lastOfGroupIndex === state.tabbableGroups.length - 1 ? 0 : lastOfGroupIndex + 1;
          var _destinationGroup = state.tabbableGroups[_destinationGroupIndex];
          destinationNode = _destinationGroup.firstTabbableNode;
        }
      }
    } else {
      // NOTE: the fallbackFocus option does not support returning false to opt-out
      destinationNode = getNodeForOption('fallbackFocus');
    }
    if (destinationNode) {
      e.preventDefault();
      tryFocus(destinationNode);
    }
    // else, let the browser take care of [shift+]tab and move the focus
  };

  var checkKey = function checkKey(e) {
    if (isEscapeEvent(e) && valueOrHandler(config.escapeDeactivates, e) !== false) {
      e.preventDefault();
      trap.deactivate();
      return;
    }
    if (isTabEvent(e)) {
      checkTab(e);
      return;
    }
  };
  var checkClick = function checkClick(e) {
    var target = getActualTarget(e);
    if (findContainerIndex(target) >= 0) {
      return;
    }
    if (valueOrHandler(config.clickOutsideDeactivates, e)) {
      return;
    }
    if (valueOrHandler(config.allowOutsideClick, e)) {
      return;
    }
    e.preventDefault();
    e.stopImmediatePropagation();
  };

  //
  // EVENT LISTENERS
  //

  var addListeners = function addListeners() {
    if (!state.active) {
      return;
    }

    // There can be only one listening focus trap at a time
    activeFocusTraps.activateTrap(trapStack, trap);

    // Delay ensures that the focused element doesn't capture the event
    // that caused the focus trap activation.
    state.delayInitialFocusTimer = config.delayInitialFocus ? delay(function () {
      tryFocus(getInitialFocusNode());
    }) : tryFocus(getInitialFocusNode());
    doc.addEventListener('focusin', checkFocusIn, true);
    doc.addEventListener('mousedown', checkPointerDown, {
      capture: true,
      passive: false
    });
    doc.addEventListener('touchstart', checkPointerDown, {
      capture: true,
      passive: false
    });
    doc.addEventListener('click', checkClick, {
      capture: true,
      passive: false
    });
    doc.addEventListener('keydown', checkKey, {
      capture: true,
      passive: false
    });
    return trap;
  };
  var removeListeners = function removeListeners() {
    if (!state.active) {
      return;
    }
    doc.removeEventListener('focusin', checkFocusIn, true);
    doc.removeEventListener('mousedown', checkPointerDown, true);
    doc.removeEventListener('touchstart', checkPointerDown, true);
    doc.removeEventListener('click', checkClick, true);
    doc.removeEventListener('keydown', checkKey, true);
    return trap;
  };

  //
  // TRAP DEFINITION
  //

  trap = {
    get active() {
      return state.active;
    },
    get paused() {
      return state.paused;
    },
    activate: function activate(activateOptions) {
      if (state.active) {
        return this;
      }
      var onActivate = getOption(activateOptions, 'onActivate');
      var onPostActivate = getOption(activateOptions, 'onPostActivate');
      var checkCanFocusTrap = getOption(activateOptions, 'checkCanFocusTrap');
      if (!checkCanFocusTrap) {
        updateTabbableNodes();
      }
      state.active = true;
      state.paused = false;
      state.nodeFocusedBeforeActivation = doc.activeElement;
      if (onActivate) {
        onActivate();
      }
      var finishActivation = function finishActivation() {
        if (checkCanFocusTrap) {
          updateTabbableNodes();
        }
        addListeners();
        if (onPostActivate) {
          onPostActivate();
        }
      };
      if (checkCanFocusTrap) {
        checkCanFocusTrap(state.containers.concat()).then(finishActivation, finishActivation);
        return this;
      }
      finishActivation();
      return this;
    },
    deactivate: function deactivate(deactivateOptions) {
      if (!state.active) {
        return this;
      }
      var options = _objectSpread2({
        onDeactivate: config.onDeactivate,
        onPostDeactivate: config.onPostDeactivate,
        checkCanReturnFocus: config.checkCanReturnFocus
      }, deactivateOptions);
      clearTimeout(state.delayInitialFocusTimer); // noop if undefined
      state.delayInitialFocusTimer = undefined;
      removeListeners();
      state.active = false;
      state.paused = false;
      activeFocusTraps.deactivateTrap(trapStack, trap);
      var onDeactivate = getOption(options, 'onDeactivate');
      var onPostDeactivate = getOption(options, 'onPostDeactivate');
      var checkCanReturnFocus = getOption(options, 'checkCanReturnFocus');
      var returnFocus = getOption(options, 'returnFocus', 'returnFocusOnDeactivate');
      if (onDeactivate) {
        onDeactivate();
      }
      var finishDeactivation = function finishDeactivation() {
        delay(function () {
          if (returnFocus) {
            tryFocus(getReturnFocusNode(state.nodeFocusedBeforeActivation));
          }
          if (onPostDeactivate) {
            onPostDeactivate();
          }
        });
      };
      if (returnFocus && checkCanReturnFocus) {
        checkCanReturnFocus(getReturnFocusNode(state.nodeFocusedBeforeActivation)).then(finishDeactivation, finishDeactivation);
        return this;
      }
      finishDeactivation();
      return this;
    },
    pause: function pause() {
      if (state.paused || !state.active) {
        return this;
      }
      state.paused = true;
      removeListeners();
      return this;
    },
    unpause: function unpause() {
      if (!state.paused || !state.active) {
        return this;
      }
      state.paused = false;
      updateTabbableNodes();
      addListeners();
      return this;
    },
    updateContainerElements: function updateContainerElements(containerElements) {
      var elementsAsArray = [].concat(containerElements).filter(Boolean);
      state.containers = elementsAsArray.map(function (element) {
        return typeof element === 'string' ? doc.querySelector(element) : element;
      });
      if (state.active) {
        updateTabbableNodes();
      }
      return this;
    }
  };

  // initialize container elements
  trap.updateContainerElements(elements);
  return trap;
};

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
function useFocusTrap(target, options = {}) {
  let trap;
  const _a = options, { immediate } = _a, focusTrapOptions = __objRest(_a, ["immediate"]);
  const hasFocus = ref(false);
  const isPaused = ref(false);
  const activate = (opts) => trap && trap.activate(opts);
  const deactivate = (opts) => trap && trap.deactivate(opts);
  const pause = () => {
    if (trap) {
      trap.pause();
      isPaused.value = true;
    }
  };
  const unpause = () => {
    if (trap) {
      trap.unpause();
      isPaused.value = false;
    }
  };
  watch(
    () => unrefElement(target),
    (el) => {
      if (!el)
        return;
      trap = createFocusTrap(el, __spreadProps(__spreadValues({}, focusTrapOptions), {
        onActivate() {
          hasFocus.value = true;
          if (options.onActivate)
            options.onActivate();
        },
        onDeactivate() {
          hasFocus.value = false;
          if (options.onDeactivate)
            options.onDeactivate();
        }
      }));
      if (immediate)
        activate();
    },
    { flush: "post" }
  );
  tryOnScopeDispose(() => deactivate());
  return {
    hasFocus,
    isPaused,
    activate,
    deactivate,
    pause,
    unpause
  };
}

const dropdownConfig = {
  fixedClasses: {
    // roundedFull: commonClasses.inputsRadius,
    // roundedTop: commonClasses.inputsRadiusTop,
    // roundedBottom: commonClasses.inputsRadiusBottom,
    // roundedLeft: commonClasses.inputsRadiusLeft,
    // roundedRight: commonClasses.inputsRadiusRight,
    // roundedBottomLeft: commonClasses.inputsRadiusBottomLeft,
    // roundedBottomRight: commonClasses.inputsRadiusBottomRight,
    // roundedTopLeft: commonClasses.inputsRadiusTopLeft,
    // roundedTopRight: commonClasses.inputsRadiusTopRight,
    disabled: commonClasses.disabled
  },
  // Default appearance
  classes: {
    trigger: "",
    wrapper: "relative",
    container: "flex items-center content-center",
    // container: 'inline-flex items-center content-center',
    chevronIcon: "-mr-1 ml-2 h-3 w-3",
    overlay: "fixed top-0 right-0 left-0 bottom-0 z-[99] bg-black/50",
    menuWrapper: "absolute z-[100]",
    // Wrapper when no popper is used
    menuWrapperLeft: "absolute origin-top-left left-0",
    menuWrapperRight: "absolute origin-top-right right-0",
    menuWrapperCenter: "absolute origin-top-right right-0 left-0 sm:left-auto sm:w-sm",
    menuWrapperCenterFull: "absolute origin-top-right right-0 mx-4 left-0 sm:left-auto sm:w-sm",
    dropdown: mergeClasses(
      commonClasses.dropdownsBackground,
      commonClasses.dropdownsRing,
      commonClasses.dropdownsRadius,
      commonClasses.dropdownsShadows,
      "top-5",
      "focus:outline-none",
      "z-[99]",
      "overflow-hidden"
    ),
    roundedFull: commonClasses.inputsRadius,
    roundedTop: commonClasses.inputsRadiusTop,
    roundedBottom: commonClasses.inputsRadiusBottom,
    roundedLeft: commonClasses.inputsRadiusLeft,
    roundedRight: commonClasses.inputsRadiusRight,
    roundedBottomLeft: commonClasses.inputsRadiusBottomLeft,
    roundedBottomRight: commonClasses.inputsRadiusBottomRight,
    roundedTopLeft: commonClasses.inputsRadiusTopLeft,
    roundedTopRight: commonClasses.inputsRadiusTopRight,
    sizeNone: "",
    sizeSmall: "w-48",
    sizeDefault: "w-56",
    sizeMedium: "w-64",
    sizeLarge: "w-72",
    sizeXLarge: "w-80",
    sizeXXLarge: "w-96",
    sizeFull: "w-full",
    menuItemsWrapper: "",
    menuItemsWrapperSpaced: "space-y-1",
    menuItem: "group flex items-center w-full  text-sm leading-5 space-x-1 cursor-pointer",
    menuItemHighlighted: "text-primary-900 bg-primary-100 dark:bg-primary-300 dark:text-black z-10",
    menuItemNotHighlighted: "text-gray-700 dark:text-white",
    menuItemSpacing: "px-3 py-2",
    arrow: "top-[-5px] invisible -z-[1] before:border-b-0 before:border-r-0 before:absolute before:w-2 before:h-2 before:bg-white  before:dark:bg-gray-900 before:visible before:rotate-45 before:border before:border-1 before:border-gray-300 before:dark:border-gray-700 before:rounded-sm",
    // Transitions
    enterActiveClass: "transition duration-100 ease-out",
    enterFromClass: "transform scale-95 opacity-0",
    enterToClass: "transform scale-100 opacity-100",
    leaveActiveClass: "transition duration-75 ease-in",
    leaveFromClass: "transform scale-100 opacity-100",
    leaveToClass: "transform scale-95 opacity-0",
    disabled: ""
  }
};
const dropdownPopperDefaultOptions = popperOptions;
const dropdownClassesKeys = Object.keys(dropdownConfig.classes);
const validDropdownPlacements = [
  "auto",
  "auto-start",
  "auto-end",
  "top",
  "top-start",
  "top-end",
  "bottom",
  "bottom-start",
  "bottom-end",
  "right",
  "right-start",
  "right-end",
  "left",
  "left-start",
  "left-end"
];

const __default__$D = {
  name: "VanillaDropdown",
  inheritAttrs: false
};
const _sfc_main$N = /* @__PURE__ */ defineComponent({
  ...__default__$D,
  props: {
    ...useVariantProps$1(),
    modelValue: {
      type: [Boolean],
      default: false
    },
    text: {
      type: String,
      default: void 0
    },
    teleport: {
      type: Boolean,
      default: true
    },
    teleportTo: {
      type: [String, Object],
      default: "body"
    },
    tagName: {
      type: String,
      default: "button"
    },
    dropdownTagName: {
      type: String,
      default: "div"
    },
    dropdownAttributes: {
      type: Object,
      default: void 0
    },
    disabled: {
      type: Boolean,
      default: void 0
    },
    toggleOnFocus: {
      type: Boolean,
      default: false
    },
    toggleOnClick: {
      type: Boolean,
      default: true
    },
    toggleOnHover: {
      type: Boolean,
      default: false
    },
    closeOnClickAway: {
      type: Boolean,
      default: true
    },
    hideOnLeaveTimeout: {
      type: Number,
      default: 250
    },
    show: {
      type: Boolean,
      default: false
    },
    trapFocus: {
      type: Boolean,
      default: true
    },
    placement: {
      type: String,
      default: void 0,
      validator: (value) => validDropdownPlacements.includes(value)
    },
    popperOptions: {
      type: Object,
      default: () => dropdownPopperDefaultOptions
    }
  },
  emits: {
    "update:show": (show) => true,
    "focus": (e) => e instanceof FocusEvent,
    "blur": (e) => e instanceof FocusEvent,
    "blurOnChild": (e) => e instanceof FocusEvent,
    "click": (e) => e instanceof MouseEvent,
    "mouseover": (e) => e instanceof MouseEvent,
    "mouseleave": (e) => e instanceof MouseEvent,
    "touchstart": (e) => e instanceof TouchEvent,
    "shown": () => true,
    "hidden": () => true,
    "beforeShow": () => true,
    "beforeHide": () => true
  },
  setup(__props, { expose, emit }) {
    const props = __props;
    const localValue = useVModel(props, "modelValue");
    const { configuration, attributes } = useConfiguration(dropdownConfig, "Dropdown", localValue);
    const isTouchOnlyDevice = ref(false);
    const originalShown = ref(configuration.show);
    const shown = refThrottled(originalShown, 1e3);
    const initAsShow = ref(configuration.show);
    const hideTimeout = ref(null);
    const focusableElements = ref([]);
    const adjustingPopper = ref(false);
    const popperIsAdjusted = ref(false);
    const popperAdjusterListener = ref(null);
    const popper = ref(null);
    const dropdown = ref();
    const trigger = ref();
    const root = ref();
    const { activate, deactivate } = useFocusTrap(dropdown, {
      setReturnFocus: trigger.value,
      returnFocusOnDeactivate: false,
      delayInitialFocus: true,
      clickOutsideDeactivates: true,
      escapeDeactivates: true
    });
    const { focused } = useFocus(trigger);
    const fullPopperOptions = computed(() => {
      const popperOptions = configuration.popperOptions;
      if (configuration.placement !== void 0) {
        popperOptions.placement = configuration.placement;
      }
      return popperOptions;
    });
    const shouldShowWhenClicked = computed(() => isTouchOnlyDevice.value && (configuration.toggleOnFocus === true || configuration.toggleOnHover === true));
    const targetIsChild = (target) => {
      return elementIsTargetOrTargetChild$1(target, dropdown.value) || elementIsTargetOrTargetChild$1(target, trigger.value);
    };
    const onShown = () => {
      if (isServer()) {
        return;
      }
      emit("shown");
      emit("update:show", true);
      if (isTouchOnlyDevice.value) {
        window.addEventListener("touchstart", touchstartHandler);
      } else {
        addBlurListenersToChildElements();
      }
    };
    const onHidden = () => {
      if (isServer()) {
        return;
      }
      emit("hidden");
      emit("update:show", false);
      if (isTouchOnlyDevice.value) {
        window.removeEventListener("touchstart", touchstartHandler);
        return;
      }
      removeBlurListenersFromChildElements();
    };
    const onBeforeShown = () => {
      if (isServer()) {
        return;
      }
      emit("beforeShow");
      if (isTouchOnlyDevice.value) {
        window.addEventListener("touchstart", touchstartHandler);
      }
    };
    const onBeforeHide = () => {
      if (isServer()) {
        return;
      }
      emit("beforeHide");
      if (isTouchOnlyDevice.value) {
        window.removeEventListener("touchstart", touchstartHandler);
      }
    };
    const doShow = async () => {
      if (props.disabled) {
        return;
      }
      if (hideTimeout.value) {
        clearTimeout(hideTimeout.value);
      }
      onBeforeShown();
      await updatePopper();
      if (!shown.value) {
        shown.value = true;
      }
      await nextTick().then(() => {
        if (props.trapFocus) {
          try {
            activate();
          } catch (e) {
          }
        }
        onShown();
      });
    };
    const doHide = async () => {
      if (props.disabled) {
        return;
      }
      onBeforeHide();
      shown.value = false;
      await nextTick().then(() => {
        if (props.trapFocus) {
          try {
            deactivate();
          } catch (e) {
          }
        }
        onHidden();
        focused.value = true;
      });
    };
    const doToggle = () => {
      if (props.disabled) {
        return;
      }
      if (!shown.value) {
        doShow();
      } else {
        doHide();
      }
    };
    const blurHandler = (e) => {
      const isChild = targetIsChild(e.relatedTarget);
      if (!isChild) {
        if (props.closeOnClickAway) {
          emit("blur", e);
        }
      } else {
        emit("blurOnChild", e);
      }
      if (isTouchOnlyDevice.value) {
        return;
      }
      if (configuration.toggleOnFocus && !isChild) {
        if (props.closeOnClickAway) {
          doHide();
        }
      }
    };
    const addBlurListenersToChildElements = () => {
      focusableElements.value = getFocusableElements$1(dropdown.value);
      focusableElements.value.forEach((element) => element.addEventListener("blur", blurHandler));
    };
    const removeBlurListenersFromChildElements = () => {
      focusableElements.value.forEach((element) => element.removeEventListener("blur", blurHandler));
      focusableElements.value = [];
    };
    const focus = () => trigger.value?.focus();
    const dropdownAfterLeaveAnimation = () => trigger.value?.style.removeProperty("visibility");
    const createPopper$1 = () => {
      let popper2;
      return new Promise((resolve) => {
        const popperOptions = fullPopperOptions.value;
        const originalOnFirstUpdate = popperOptions.onFirstUpdate;
        popperOptions.onFirstUpdate = async (arg) => {
          if (originalOnFirstUpdate) {
            originalOnFirstUpdate(arg);
          }
          resolve(popper2);
        };
        popper2 = createPopper(
          trigger.value,
          dropdown.value,
          fullPopperOptions.value
        );
      });
    };
    const adjustPopper = async () => {
      return new Promise(async (resolve) => {
        if (shown.value === false && !adjustingPopper.value) {
          popperIsAdjusted.value = false;
          resolve();
          return;
        }
        if (!popper.value) {
          popper.value = await createPopper$1();
        }
        await popper.value?.update();
        resolve();
      });
    };
    const updatePopper = () => {
      return new Promise(async (resolve) => {
        if (popperIsAdjusted.value) {
          resolve();
          return;
        }
        adjustingPopper.value = true;
        await nextTick();
        await adjustPopper();
        adjustingPopper.value = false;
        await nextTick();
        popperIsAdjusted.value = true;
        await nextTick();
        resolve();
      });
    };
    const enablePopperNeedsAdjustmentListener = () => {
      if (isServer()) {
        return;
      }
      window.addEventListener("resize", popperAdjusterListener.value);
      window.addEventListener("scroll", popperAdjusterListener.value);
    };
    const disablePopperNeedsAdjustmentListener = () => {
      if (isServer()) {
        return;
      }
      window.removeEventListener("resize", popperAdjusterListener.value);
      window.removeEventListener("scroll", popperAdjusterListener.value);
      popperAdjusterListener.value?.cancel();
    };
    const clickHandler = (e) => {
      emit("click", e);
      if (configuration.toggleOnClick) {
        doToggle();
      } else if (shouldShowWhenClicked.value) {
        doShow();
      }
    };
    const focusHandler = (e) => {
      emit("focus", e);
      if (isTouchOnlyDevice.value) {
        return;
      }
      if (configuration.toggleOnFocus) {
        doToggle();
      }
    };
    const mouseoverHandler = (e) => {
      emit("mouseover", e);
      if (isTouchOnlyDevice.value) {
        return;
      }
      if (configuration.toggleOnHover) {
        doShow();
      }
    };
    const mouseleaveHandler = (e) => {
      emit("mouseleave", e);
      if (isTouchOnlyDevice.value) {
        return;
      }
      if (configuration.toggleOnHover && !targetIsChild(e.relatedTarget)) {
        hideAfterTimeout();
      }
    };
    const touchstartHandler = (e) => {
      emit("touchstart", e);
      if (Array.from(e.targetTouches).some((touch) => targetIsChild(touch.target))) {
        return;
      }
      if (configuration.toggleOnFocus || configuration.toggleOnHover) {
        doHide();
      }
    };
    const hideAfterTimeout = () => {
      if (!configuration.hideOnLeaveTimeout) {
        doHide();
        return;
      }
      hideTimeout.value = setTimeout(
        () => {
          doHide();
          hideTimeout.value = null;
        },
        configuration.hideOnLeaveTimeout
      );
    };
    watch(() => popperIsAdjusted.value, (adjustedInto) => {
      adjustedInto ? enablePopperNeedsAdjustmentListener() : disablePopperNeedsAdjustmentListener();
    });
    watch(() => configuration.show, (isShowing) => {
      isShowing ? doShow() : doHide();
    });
    onMounted(() => {
      if (isServer()) {
        return;
      }
      isTouchOnlyDevice.value = getIsTouch();
      if (isTouchOnlyDevice.value && shown.value) {
        window.addEventListener("touchstart", touchstartHandler);
      }
      if (configuration.show) {
        updatePopper().then(() => {
          initAsShow.value = false;
        });
      }
    });
    onBeforeUnmount(() => {
      if (isServer()) {
        return;
      }
      if (hideTimeout.value) {
        clearTimeout(hideTimeout.value);
      }
      disablePopperNeedsAdjustmentListener();
      if (isTouchOnlyDevice.value && shown.value) {
        window.removeEventListener("touchstart", touchstartHandler);
      }
    });
    onClickOutside(root, () => {
      if (props.closeOnClickAway && shown.value) {
        doHide();
      }
    }, {
      ignore: [
        root,
        trigger,
        dropdown
      ],
      detectIframe: true
    });
    popperAdjusterListener.value = debounce$3(() => popperIsAdjusted.value = false, 200);
    expose({
      doShow,
      doHide,
      adjustPopper,
      focus,
      shown
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        ref_key: "root",
        ref: root,
        class: "dropdown"
      }, [
        (openBlock(), createBlock(resolveDynamicComponent(__props.tagName), mergeProps({
          ref_key: "trigger",
          ref: trigger,
          type: __props.tagName === "button" ? "button" : void 0,
          "aria-expanded": unref(shown),
          class: [
            unref(configuration).classesList?.trigger,
            props.rounded === "full" ? unref(configuration).classesList.roundedFull : "",
            props.rounded === "top" ? unref(configuration).classesList.roundedTop : "",
            props.rounded === "bottom" ? unref(configuration).classesList.roundedBottom : "",
            props.rounded === "left" ? unref(configuration).classesList.roundedLeft : "",
            props.rounded === "right" ? unref(configuration).classesList.roundedRight : "",
            props.rounded === "top-left" ? unref(configuration).classesList.roundedTopLeft : "",
            props.rounded === "top-right" ? unref(configuration).classesList.roundedTopRight : "",
            props.rounded === "bottom-left" ? unref(configuration).classesList.roundedBottomLeft : "",
            props.rounded === "bottom-right" ? unref(configuration).classesList.roundedBottomRight : ""
          ],
          disabled: unref(configuration).disabled
        }, { ...unref(attributes), ..._ctx.$attrs }, {
          onClick: clickHandler,
          onFocus: focusHandler,
          onBlur: blurHandler,
          onMouseover: mouseoverHandler,
          onMouseleave: mouseleaveHandler
        }), {
          default: withCtx(() => [
            renderSlot(_ctx.$slots, "trigger", {
              configuration: unref(configuration),
              isShow: unref(shown),
              popper: popper.value
            }, () => [
              createTextVNode(toDisplayString(unref(configuration).text), 1)
            ])
          ]),
          _: 3
        }, 16, ["type", "aria-expanded", "class", "disabled"])),
        (openBlock(), createBlock(Teleport, {
          to: unref(configuration).teleportTo,
          disabled: !unref(configuration).teleport
        }, [
          createVNode(_sfc_main$$, {
            enabled: popperIsAdjusted.value || !initAsShow.value,
            "classes-list": unref(configuration).classesList,
            onAfterLeave: dropdownAfterLeaveAnimation
          }, {
            default: withCtx(() => [
              withDirectives((openBlock(), createBlock(resolveDynamicComponent(__props.dropdownTagName), mergeProps({
                ref_key: "dropdown",
                ref: dropdown,
                style: adjustingPopper.value ? "opacity:0" : void 0,
                class: unref(configuration).classesList?.dropdown,
                "aria-hidden": !unref(shown),
                tabindex: "-1"
              }, __props.dropdownAttributes, {
                onBlur: blurHandler,
                onMouseover: mouseoverHandler,
                onMouseleave: mouseleaveHandler
              }), {
                default: withCtx(() => [
                  renderSlot(_ctx.$slots, "default", {
                    show: doShow,
                    hide: doHide,
                    toggle: doToggle,
                    configuration: unref(configuration),
                    popper: popper.value
                  })
                ]),
                _: 3
              }, 16, ["style", "class", "aria-hidden"])), [
                [vShow, unref(shown) || adjustingPopper.value || initAsShow.value]
              ])
            ]),
            _: 3
          }, 8, ["enabled", "classes-list"])
        ], 8, ["to", "disabled"]))
      ], 512);
    };
  }
});

const _hoisted_1$R = ["data-value", "label", "disabled"];
const _hoisted_2$H = ["value", "disabled", "textContent"];
const __default__$C = {
  name: "VanillaSelectOption"
};
const _sfc_main$M = /* @__PURE__ */ defineComponent({
  ...__default__$C,
  props: {
    option: {
      type: [Object],
      required: true
    },
    safe: {
      type: [Boolean],
      default: false
    }
  },
  setup(__props) {
    const props = __props;
    const classesList = useInjectsClassesList();
    const hasChildren = computed(() => props.option.children !== void 0 && props.option.children.length > 0);
    return (_ctx, _cache) => {
      return unref(hasChildren) ? (openBlock(), createElementBlock("optgroup", {
        key: 0,
        "data-value": __props.option.value !== void 0 ? String(__props.option.value) : void 0,
        label: __props.option.text !== void 0 ? String(__props.option.text) : void 0,
        disabled: !!__props.option.disabled,
        class: normalizeClass(unref(classesList).optgroupLabel)
      }, [
        (openBlock(true), createElementBlock(Fragment, null, renderList(__props.option.children, (childrenOption, index) => {
          return openBlock(), createBlock(_sfc_main$M, {
            key: `${childrenOption.value}-${childrenOption.text}-${index}`,
            option: childrenOption,
            class: normalizeClass(unref(classesList).optGroup)
          }, null, 8, ["option", "class"]);
        }), 128))
      ], 10, _hoisted_1$R)) : (openBlock(), createElementBlock("option", {
        key: 1,
        value: __props.option.value === null ? void 0 : __props.option.value,
        disabled: !!__props.option.disabled,
        class: normalizeClass(unref(classesList).optGroup),
        textContent: toDisplayString(__props.option.text)
      }, null, 10, _hoisted_2$H));
    };
  }
});

const selectConfig = {
  fixedClasses: {
    wrapper: "relative",
    select: mergeClasses(
      "appearance-none block w-full focus:outline-none",
      commonClasses.inputsShadows,
      commonClasses.inputsDisabled,
      commonClasses.inputsSpacing
    ),
    selectIfMultiple: "space-y-2"
  },
  // Default Input appearance
  classes: {
    wrapper: "",
    select: mergeClasses(
      "",
      commonClasses.inputsText,
      commonClasses.inputsTextColor,
      commonClasses.inputsBackground,
      commonClasses.inputsBorder,
      commonClasses.inputsRingBase,
      commonClasses.inputsRing,
      commonClasses.inputsRadius
    ),
    selectIfMultiple: "",
    optGroup: mergeClasses(
      commonClasses.inputsSpacing,
      commonClasses.inputsDisabled,
      commonClasses.inputsText,
      commonClasses.inputsRadius,
      "checked:font-semibold",
      "checked:text-primary-900 checked:bg-primary-100 checked:dark:bg-primary-300 checked:dark:text-black",
      "select:focus:text-red-100",
      "w-full disabled:opacity-50",
      "cursor-pointer disabled:cursor-not-allowed",
      "text-sm font-normal",
      "px-3 py-2"
    )
  },
  // Variants
  variants: {
    // Used for Errors
    error: {
      classes: {
        wrapper: "",
        select: mergeClasses(
          commonClasses.inputsText,
          commonClasses.inputsRingBase,
          commonClasses.inputsErrorTextColor,
          commonClasses.inputsErrorsBackground,
          commonClasses.inputsErrorsBorder,
          commonClasses.inputsErrorsRing,
          commonClasses.inputsRadius
        ),
        selectIfMultiple: "",
        optGroup: mergeClasses(
          commonClasses.inputsSpacing,
          commonClasses.inputsDisabled,
          commonClasses.inputsText,
          commonClasses.inputsRadius,
          "checked:font-semibold",
          "checked:text-red-900 checked:bg-red-100 checked:dark:bg-red-300 checked:dark:text-black",
          "select:focus:text-red-100",
          "w-full disabled:opacity-50",
          "cursor-pointer disabled:cursor-not-allowed",
          "text-sm font-normal",
          "px-3 py-2"
        )
      }
    }
  }
};
const selectClassesKeys = Object.keys(selectConfig.classes);

const _hoisted_1$Q = { class: "vanilla-simple-select" };
const _hoisted_2$G = ["id", "name", "autocomplete", "placeholder", "multiple", "disabled"];
const __default__$B = {
  name: "VanillaSelect"
};
const _sfc_main$L = /* @__PURE__ */ defineComponent({
  ...__default__$B,
  props: {
    ...useVariantProps$1(),
    modelValue: {
      type: [
        String,
        Number,
        Boolean,
        Array,
        Object,
        Date,
        Function,
        Symbol
      ],
      default: void 0
    },
    options: {
      type: [Array, Object],
      default: void 0
    },
    normalizeOptions: {
      type: Boolean,
      default: true
    },
    valueAttribute: {
      type: String,
      default: "value"
    },
    textAttribute: {
      type: String,
      default: "text"
    },
    multiple: {
      type: [Boolean],
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    showEmpty: {
      type: Boolean,
      default: true
    },
    placeholder: {
      type: String,
      default: "Select an option"
    },
    empty: {
      type: Object,
      default: (props) => {
        return {
          value: null,
          text: props.placeholder,
          disabled: true
        };
      }
    }
  },
  setup(__props) {
    const props = __props;
    const root = ref(null);
    const { localValue } = useMultipleVModel(props, "modelValue", props.multiple);
    const { configuration, errors, hasErrors } = useConfiguration(selectConfig, "Select", localValue);
    const { normalizedOptions } = useMultipleOptions(
      computed(() => props.options),
      computed(() => props.textAttribute),
      computed(() => props.valueAttribute),
      computed(() => props.normalizeOptions)
    );
    provide("configuration_vanilla", configuration);
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$Q, [
        createElementVNode("div", {
          class: normalizeClass(unref(configuration).classesList?.wrapper)
        }, [
          withDirectives(createElementVNode("select", {
            id: _ctx.name,
            ref_key: "root",
            ref: root,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => isRef(localValue) ? localValue.value = $event : null),
            name: _ctx.name,
            autocomplete: props.autocomplete,
            class: normalizeClass([
              unref(configuration).classesList?.select,
              unref(configuration).multiple ? unref(configuration).classesList?.selectIfMultiple : ""
            ]),
            placeholder: props.placeholder,
            multiple: unref(configuration)?.multiple,
            disabled: __props.disabled
          }, [
            __props.empty && __props.showEmpty ? (openBlock(), createBlock(_sfc_main$M, {
              key: 0,
              option: __props.empty,
              selected: true
            }, null, 8, ["option"])) : createCommentVNode("", true),
            renderSlot(_ctx.$slots, "option", normalizeProps(guardReactiveProps({ normalizedOptions: unref(normalizedOptions) })), () => [
              (openBlock(true), createElementBlock(Fragment, null, renderList(unref(normalizedOptions), (option, index) => {
                return openBlock(), createBlock(_sfc_main$M, {
                  key: `${option.value}-${index}`,
                  option
                }, null, 8, ["option"]);
              }), 128))
            ])
          ], 10, _hoisted_2$G), [
            [vModelSelect, unref(localValue)]
          ])
        ], 2),
        renderSlot(_ctx.$slots, "errors", normalizeProps(guardReactiveProps({ hasErrors: unref(hasErrors), errors: unref(errors) })), () => [
          unref(hasErrors) && props.showErrors ? (openBlock(), createBlock(_sfc_main$Z, {
            key: 0,
            errors: unref(errors)
          }, null, 8, ["errors"])) : createCommentVNode("", true)
        ]),
        renderSlot(_ctx.$slots, "feedback", normalizeProps(guardReactiveProps({ hasErrors: unref(hasErrors), feedback: props.feedback })), () => [
          !unref(hasErrors) && props.feedback && props.showFeedback ? (openBlock(), createBlock(_sfc_main$Y, {
            key: 0,
            text: props.feedback
          }, null, 8, ["text"])) : createCommentVNode("", true)
        ])
      ]);
    };
  }
});

const _hoisted_1$P = ["aria-selected", "disabled", "value"];
const _sfc_main$K = /* @__PURE__ */ defineComponent({
  __name: "option",
  props: {
    option: {
      type: Object,
      required: true
    },
    deep: {
      type: Number,
      default: 0
    },
    index: {
      type: [Number, String, void 0],
      required: false,
      default: 0
    }
  },
  setup(__props) {
    const props = __props;
    const elementList = ref(null);
    const toggleOption = inject("toggleOption");
    const setActiveOption = inject("setActiveOption");
    const optionIsSelected = inject("optionIsSelected");
    const optionIsActive = inject("optionIsActive");
    const shown = inject("shown");
    const clearable = inject("clearable");
    const classesList = useInjectsClassesList();
    const isActive = computed(() => optionIsActive(props.option));
    const isSelected = computed(() => optionIsSelected(props.option));
    const isDisabled = computed(() => normalizedOptionIsDisabled$1(props.option));
    const hasChildren = computed(() => props.option.children !== void 0 && props.option.children.length > 0);
    const valueAttribute = computed(() => typeof props.option.value === "object" ? JSON.stringify(props.option.value) : String(props.option.value));
    const optionClasses = computed(() => {
      const classes = [classesList.value.option];
      if (isSelected.value) {
        if (isActive.value) {
          classes.push(classesList.value.selectedHighlightedOption);
        } else {
          classes.push(classesList.value.selectedOption);
        }
      } else if (isActive.value) {
        classes.push(classesList.value.highlightedOption);
      }
      return classes;
    });
    const scrollIntoViewIfNecessary = () => {
      if (shown?.value && isActive.value) {
        const li = elementList.value?.$el;
        if (li) {
          li.scrollIntoView({ block: "nearest", behavior: "smooth" });
        }
      }
    };
    const mouseMoveHandler = () => {
      if (isDisabled.value) {
        return;
      }
      setActiveOption(props.option);
    };
    const mouseWheelHandler = () => {
      if (isDisabled.value) {
        return;
      }
      setActiveOption(props.option);
    };
    const clickHandler = () => {
      if (isDisabled.value) {
        return;
      }
      if (!clearable && isSelected.value) {
        return;
      }
      toggleOption(props.option);
    };
    watch(() => shown, async (value) => {
      await nextTick();
      scrollIntoViewIfNecessary();
    }, { immediate: true });
    watch(() => isActive, (value) => {
      scrollIntoViewIfNecessary();
    });
    return (_ctx, _cache) => {
      return unref(hasChildren) ? (openBlock(), createElementBlock("li", {
        key: 0,
        role: "optgroup",
        class: normalizeClass(unref(classesList).optgroup)
      }, [
        createElementVNode("div", {
          class: normalizeClass(unref(classesList).optgroupContent)
        }, [
          createElementVNode("span", {
            class: normalizeClass(unref(classesList).optgroupLabel)
          }, toDisplayString(__props.option.text), 3),
          createVNode(_sfc_main$J, {
            ref: "childrenOptions",
            class: normalizeClass(unref(classesList).optgroupOptionsList),
            options: __props.option.children,
            deep: __props.deep + 1
          }, null, 8, ["class", "options", "deep"])
        ], 2)
      ], 2)) : (openBlock(), createElementBlock("li", {
        key: 1,
        class: normalizeClass(unref(classesList).optionWrapper),
        onMousemove: mouseMoveHandler,
        onMousewheel: mouseWheelHandler,
        onClick: clickHandler
      }, [
        renderSlot(_ctx.$slots, "option", {
          className: unref(optionClasses),
          option: __props.option,
          isDisabled: unref(isDisabled),
          isActive: unref(isActive),
          isSelected: unref(isSelected),
          deep: __props.deep
        }, () => [
          createElementVNode("button", {
            role: "option",
            class: normalizeClass(unref(optionClasses)),
            "aria-selected": unref(isSelected),
            tabindex: "-1",
            type: "button",
            disabled: unref(isDisabled),
            value: unref(valueAttribute)
          }, [
            createElementVNode("span", {
              class: normalizeClass(unref(classesList).optionContent)
            }, [
              renderSlot(_ctx.$slots, "optionLabel", {
                option: __props.option,
                isDisabled: unref(isDisabled),
                isActive: unref(isActive),
                isSelected: unref(isSelected),
                deep: __props.deep
              }, () => [
                createElementVNode("span", {
                  class: normalizeClass(unref(classesList).optionLabel)
                }, toDisplayString(__props.option.text), 3)
              ]),
              renderSlot(_ctx.$slots, "optionIcon", {
                className: unref(optionClasses),
                option: __props.option,
                isDisabled: unref(isDisabled),
                isActive: unref(isActive),
                isSelected: unref(isSelected),
                deep: __props.deep
              }, () => [
                unref(isSelected) ? (openBlock(), createBlock(unref(CheckIcon$1), {
                  key: 0,
                  ref: "checkIcon",
                  class: normalizeClass(unref(classesList).optionSelectedIcon)
                }, null, 8, ["class"])) : createCommentVNode("", true)
              ])
            ], 2)
          ], 10, _hoisted_1$P)
        ])
      ], 34));
    };
  }
});

const _sfc_main$J = /* @__PURE__ */ defineComponent({
  __name: "option-list",
  props: {
    options: {
      type: Array,
      required: true
    },
    deep: {
      type: Number,
      default: 0
    }
  },
  setup(__props) {
    const props = __props;
    const configuration = inject("configuration_vanilla");
    inject("shown");
    const fetchingMoreOptions = inject("fetchingMoreOptions");
    const dropdownBottomReachedHandler = inject("dropdownBottomReachedHandler");
    const classesList = useInjectsClassesList();
    const root = ref(null);
    const fetchingMoreOptionsText = ref(null);
    const maxHeight = computed(() => normalizeMeasure$1(configuration.maxHeight));
    const usesMaxHeight = computed(() => props.deep === 0 && maxHeight.value !== void 0);
    const showOptions = computed(() => props.options.length > 0);
    const bottomReachedObserver = debounce$3(([event]) => {
      const element = event.target;
      const reached = Math.ceil(element.scrollHeight - element.scrollTop) === element.clientHeight;
      if (reached) {
        dropdownBottomReachedHandler();
      }
    }, 200);
    watch(() => showOptions.value, async (shouldShow) => {
      if (shouldShow) {
        await nextTick;
        root.value.addEventListener("scroll", bottomReachedObserver);
      } else {
        root.value.removeEventListener("scroll", bottomReachedObserver);
      }
    });
    watch(() => fetchingMoreOptions.value, async (isFetching) => {
      if (isFetching) {
        await nextTick;
        const el = fetchingMoreOptionsText.value;
        if (el) {
          el.scrollIntoView({ block: "end", behavior: "smooth" });
        }
      }
    });
    onMounted(() => {
      if (showOptions.value) {
        root.value.addEventListener("scroll", bottomReachedObserver);
      }
    });
    onBeforeUnmount(() => {
      if (showOptions.value) {
        root.value.removeEventListener("scroll", bottomReachedObserver);
      }
    });
    return (_ctx, _cache) => {
      return unref(showOptions) ? (openBlock(), createElementBlock("ul", {
        key: 0,
        ref_key: "root",
        ref: root,
        class: normalizeClass(unref(classesList).optionsList),
        style: normalizeStyle(unref(usesMaxHeight) ? `max-height: ${unref(maxHeight)}; overflow-x: auto;` : void 0)
      }, [
        (openBlock(true), createElementBlock(Fragment, null, renderList(__props.options, (option, index) => {
          return openBlock(), createBlock(_sfc_main$K, {
            key: `${__props.deep > 0 ? `${__props.deep}-` : ""}${JSON.stringify(option.value)}-${index}`,
            option,
            deep: __props.deep
          }, {
            option: withCtx((props2) => [
              renderSlot(_ctx.$slots, "option", normalizeProps(guardReactiveProps(props2)))
            ]),
            optionLabel: withCtx((props2) => [
              renderSlot(_ctx.$slots, "optionLabel", normalizeProps(guardReactiveProps(props2)))
            ]),
            optionIcon: withCtx((props2) => [
              renderSlot(_ctx.$slots, "optionIcon", normalizeProps(guardReactiveProps(props2)))
            ]),
            _: 2
          }, 1032, ["option", "deep"]);
        }), 128)),
        unref(fetchingMoreOptions) ? (openBlock(), createElementBlock("li", {
          ref_key: "fetchingMoreOptionsText",
          ref: fetchingMoreOptionsText,
          key: "loading_more",
          class: normalizeClass(unref(classesList).optionsListLoadingMore)
        }, [
          createVNode(unref(LoadingIcon), {
            ref: "loadingIcon",
            class: normalizeClass(unref(classesList).selectButtonLoadingIcon)
          }, null, 8, ["class"]),
          createElementVNode("span", null, toDisplayString(unref(configuration).loadingMoreResultsText), 1)
        ], 2)) : createCommentVNode("", true)
      ], 6)) : createCommentVNode("", true);
    };
  }
});

const _hoisted_1$O = ["placeholder"];
const _sfc_main$I = /* @__PURE__ */ defineComponent({
  __name: "search",
  setup(__props) {
    const search = ref();
    const shown = inject("shown");
    const searchQuery = inject("searchQuery");
    const configuration = useInjectsConfiguration();
    const keydownDownHandler = inject("keydownDownHandler");
    const keydownUpHandler = inject("keydownUpHandler");
    const keydownEnterHandler = inject("keydownEnterHandler");
    const keydownEscHandler = inject("keydownEscHandler");
    const classesList = useInjectsClassesList();
    watch(() => shown.value, async (isShown) => {
      await nextTick(() => {
        if (shown.value) ;
      });
      if (shown.value) ;
    });
    onMounted(() => {
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(unref(classesList).searchWrapper)
      }, [
        withDirectives(createElementVNode("input", {
          ref_key: "search",
          ref: search,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => isRef(searchQuery) ? searchQuery.value = $event : null),
          type: "search",
          "data-rich-select-focusable": "",
          placeholder: unref(configuration).searchBoxPlaceholder,
          class: normalizeClass(unref(classesList).searchInput),
          tabindex: "1",
          onInput: _cache[1] || (_cache[1] = ($event) => $event.target.composing = false),
          onKeydown: [
            _cache[2] || (_cache[2] = withKeys(
              //@ts-ignore
              (...args) => unref(keydownDownHandler) && unref(keydownDownHandler)(...args),
              ["down"]
            )),
            _cache[3] || (_cache[3] = withKeys(
              //@ts-ignore
              (...args) => unref(keydownUpHandler) && unref(keydownUpHandler)(...args),
              ["up"]
            )),
            _cache[4] || (_cache[4] = withKeys(
              //@ts-ignore
              (...args) => unref(keydownEnterHandler) && unref(keydownEnterHandler)(...args),
              ["enter"]
            )),
            _cache[5] || (_cache[5] = withKeys(
              //@ts-ignore
              (...args) => unref(keydownEscHandler) && unref(keydownEscHandler)(...args),
              ["esc"]
            ))
          ]
        }, null, 42, _hoisted_1$O), [
          [vModelText, unref(searchQuery)]
        ])
      ], 2);
    };
  }
});

const _hoisted_1$N = ["textContent"];
const _hoisted_2$F = ["textContent"];
const _sfc_main$H = /* @__PURE__ */ defineComponent({
  __name: "state",
  setup(__props) {
    const options = inject("options");
    const fetchingOptions = inject("fetchingOptions");
    const needsMoreCharsToFetch = inject("needsMoreCharsToFetch");
    const needsMoreCharsMessage = inject("needsMoreCharsMessage");
    const configuration = useInjectsConfiguration();
    const noResults = computed(() => options.value.length === 0);
    const classesList = useInjectsClassesList();
    return (_ctx, _cache) => {
      return renderSlot(_ctx.$slots, "stateFeedback", {
        fetchingOptions: unref(fetchingOptions),
        needsMoreCharsToFetch: unref(needsMoreCharsToFetch),
        noResults: unref(noResults)
      }, () => [
        unref(fetchingOptions) ? (openBlock(), createElementBlock("div", {
          key: 0,
          class: normalizeClass(unref(classesList).searchingText)
        }, [
          createVNode(unref(LoadingIcon), {
            ref: "loadingIcon",
            class: normalizeClass(unref(classesList).selectButtonLoadingIcon)
          }, null, 8, ["class"]),
          createElementVNode("span", null, toDisplayString(unref(configuration).searchingText), 1)
        ], 2)) : unref(needsMoreCharsToFetch) ? (openBlock(), createElementBlock("div", {
          key: 1,
          class: normalizeClass(unref(classesList).needsMoreCharsText),
          textContent: toDisplayString(unref(needsMoreCharsMessage))
        }, null, 10, _hoisted_1$N)) : unref(noResults) ? (openBlock(), createElementBlock("div", {
          key: 2,
          class: normalizeClass(unref(classesList).noResultsText),
          textContent: toDisplayString(unref(configuration).noResultsText)
        }, null, 10, _hoisted_2$F)) : createCommentVNode("", true)
      ]);
    };
  }
});

const _sfc_main$G = /* @__PURE__ */ defineComponent({
  __name: "dropdown",
  setup(__props) {
    const root = ref();
    const searchInput = ref();
    const optionsList = ref();
    const state = ref();
    const options = inject("options");
    const showSearchInput = inject("showSearchInput");
    const className = useInjectsClassesListClass("dropdownContent");
    const classNameWithSearch = useInjectsClassesListClass("dropdownContentWithSearch");
    inject("shown");
    const configuration = useInjectsConfiguration();
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        ref_key: "root",
        ref: root,
        class: normalizeClass([
          unref(className),
          !unref(configuration).hideSearchBox ? unref(classNameWithSearch) : ""
        ])
      }, [
        unref(showSearchInput) ? (openBlock(), createBlock(_sfc_main$I, {
          key: 0,
          ref_key: "searchInput",
          ref: searchInput
        }, null, 512)) : createCommentVNode("", true),
        renderSlot(_ctx.$slots, "dropdownTop"),
        createVNode(_sfc_main$H, {
          ref_key: "state",
          ref: state
        }, {
          stateFeedback: withCtx((props) => [
            renderSlot(_ctx.$slots, "stateFeedback", normalizeProps(guardReactiveProps(props)))
          ]),
          _: 3
        }, 512),
        createVNode(_sfc_main$J, {
          ref_key: "optionsList",
          ref: optionsList,
          options: unref(options)
        }, {
          option: withCtx((props) => [
            renderSlot(_ctx.$slots, "option", normalizeProps(guardReactiveProps(props)))
          ]),
          optionLabel: withCtx((props) => [
            renderSlot(_ctx.$slots, "optionLabel", normalizeProps(guardReactiveProps(props)))
          ]),
          optionIcon: withCtx((props) => [
            renderSlot(_ctx.$slots, "optionIcon", normalizeProps(guardReactiveProps(props)))
          ]),
          _: 3
        }, 8, ["options"]),
        renderSlot(_ctx.$slots, "dropdownBottom")
      ], 2);
    };
  }
});

const __default__$A = {
  name: "VanillaTextPlaceholder",
  inheritAttrs: true
};
const _sfc_main$F = /* @__PURE__ */ defineComponent({
  ...__default__$A,
  props: {
    classProperty: {
      type: String,
      default: "placeholder"
    },
    placeholder: {
      type: String,
      default: void 0
    }
  },
  setup(__props) {
    const props = __props;
    const className = useInjectsClassesListClass(props.classProperty);
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("span", {
        class: normalizeClass(unref(className))
      }, [
        renderSlot(_ctx.$slots, "default", {}, () => [
          __props.placeholder !== void 0 ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
            createTextVNode(toDisplayString(__props.placeholder), 1)
          ], 64)) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
            createTextVNode(" ")
          ], 64))
        ])
      ], 2);
    };
  }
});

const _hoisted_1$M = ["disabled", "data-value", "onMousedown", "onKeydown"];
const _hoisted_2$E = ["onMousedown", "onKeydown"];
const _sfc_main$E = /* @__PURE__ */ defineComponent({
  __name: "trigger-tags-tag",
  props: {
    option: {
      type: Object,
      required: true
    }
  },
  setup(__props) {
    const props = __props;
    const toggleOption = inject("toggleOption");
    const classesList = useInjectsClassesList();
    const root = ref(null);
    const dataValueAttribute = computed(() => {
      if (typeof props.option.value === "object") {
        return JSON.stringify(props.option.value);
      }
      return String(props.option.value);
    });
    const isDisabled = computed(() => normalizedOptionIsDisabled$1(props.option));
    const focus = () => root.value.focus();
    const getElementIndex = () => {
      const elements = Array.from(root.value.parentElement.children);
      return Array.from(elements).findIndex((el) => el.isSameNode(root.value));
    };
    const focusNextElement = () => {
      const { parentElement } = root.value;
      const currentElementIndex = getElementIndex();
      const elements = Array.from(parentElement.children);
      if (currentElementIndex < elements.length - 1) {
        elements[currentElementIndex + 1].focus();
      }
    };
    const focusPrevElement = () => {
      const { parentElement } = root.value;
      const currentElementIndex = getElementIndex();
      const elements = Array.from(parentElement.children);
      if (currentElementIndex > 0) {
        elements[currentElementIndex - 1].focus();
      }
    };
    const unselect = async () => {
      const { parentElement } = root.value;
      const elementIndex = getElementIndex();
      toggleOption(props.option);
      await nextTick();
      const nextElement = parentElement.children[elementIndex];
      if (nextElement) {
        nextElement.focus();
      } else if (elementIndex > 0) {
        parentElement.children[elementIndex - 1].focus();
      }
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("button", {
        ref_key: "root",
        ref: root,
        type: "button",
        class: normalizeClass(unref(classesList).tag),
        disabled: unref(isDisabled),
        "data-rich-select-focusable": "",
        "data-rich-select-tag": "",
        "data-value": unref(dataValueAttribute),
        onMousedown: withModifiers(focus, ["prevent", "stop"]),
        onKeydown: [
          withKeys(withModifiers(unselect, ["prevent", "stop"]), ["backspace"]),
          withKeys(withModifiers(focusNextElement, ["prevent", "stop"]), ["right"]),
          withKeys(withModifiers(focusPrevElement, ["prevent", "stop"]), ["left"]),
          _cache[0] || (_cache[0] = withKeys(withModifiers(() => {
          }, ["prevent", "stop"]), ["enter"]))
        ]
      }, [
        createElementVNode("span", {
          class: normalizeClass(unref(classesList).tagLabel)
        }, [
          renderSlot(_ctx.$slots, "tagLabel", {
            option: __props.option,
            isDisabled: unref(isDisabled)
          }, () => [
            createTextVNode(toDisplayString(__props.option.text), 1)
          ])
        ], 2),
        !unref(isDisabled) ? (openBlock(), createElementBlock("span", {
          key: 0,
          tabindex: "0",
          class: normalizeClass(unref(classesList).tagDeleteButton),
          "data-rich-select-focusable": "",
          onMousedown: withModifiers(unselect, ["prevent", "stop"]),
          onKeydown: [
            withKeys(withModifiers(unselect, ["prevent", "stop"]), ["backspace"]),
            withKeys(withModifiers(unselect, ["prevent", "stop"]), ["enter"])
          ]
        }, [
          renderSlot(_ctx.$slots, "tagCloseIcon", { option: __props.option }, () => [
            createVNode(unref(CloseIcon), {
              ref: "closeIcon",
              class: normalizeClass(unref(classesList).tagDeleteButtonIcon)
            }, null, 8, ["class"])
          ])
        ], 42, _hoisted_2$E)) : createCommentVNode("", true)
      ], 42, _hoisted_1$M);
    };
  }
});

const _sfc_main$D = /* @__PURE__ */ defineComponent({
  __name: "trigger-tags",
  setup(__props) {
    const selectedOptions = inject("selectedOption");
    const className = useInjectsClassesListClass("tagsWrapper");
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(unref(className))
      }, [
        (openBlock(true), createElementBlock(Fragment, null, renderList(unref(selectedOptions), (option, index) => {
          return openBlock(), createBlock(_sfc_main$E, {
            key: `${option.value}-${index}`,
            option
          }, {
            tagCloseIcon: withCtx((props) => [
              renderSlot(_ctx.$slots, "tagCloseIcon", normalizeProps(guardReactiveProps(props)))
            ]),
            tagLabel: withCtx((props) => [
              renderSlot(_ctx.$slots, "tagLabel", normalizeProps(guardReactiveProps(props)))
            ]),
            _: 2
          }, 1032, ["option"]);
        }), 128))
      ], 2);
    };
  }
});

const _hoisted_1$L = {
  viewBox: "0 0 24 24",
  width: "1.2em",
  height: "1.2em"
};
const _hoisted_2$D = /*#__PURE__*/createElementVNode("path", {
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.5",
  d: "M8.25 15L12 18.75L15.75 15m-7.5-6L12 5.25L15.75 9"
}, null, -1);
const _hoisted_3$t = [
  _hoisted_2$D
];

function render$m(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$L, _hoisted_3$t))
}

const SelectorIcon = { name: 'heroicons-chevron-up-down', render: render$m };
/* vite-plugin-components disabled */

const __default__$z = {
  name: "VanillaRichSelectTrigger",
  inheritAttrs: false
};
const _sfc_main$C = /* @__PURE__ */ defineComponent({
  ...__default__$z,
  props: {},
  setup(__props) {
    const configuration = useInjectsConfiguration();
    const selectedOption = inject("selectedOption");
    const hasSelectedOption = inject("hasSelectedOption");
    const fetchingOptions = inject("fetchingOptions");
    const shown = inject("shown");
    const usesTags = inject("usesTags");
    const slots = inject("slots");
    const classesList = useInjectsClassesList();
    const fetchingPlaceholder = ref();
    const loadingIcon = ref();
    const placeholder = ref();
    const label = ref();
    const selectorIcon = ref();
    const multiple = computed(() => Array.isArray(selectedOption.value));
    const triggerLabel = computed(() => {
      if (!hasSelectedOption.value) {
        return void 0;
      }
      if (multiple.value) {
        return selectedOption.value.map((o) => o.text).join(", ");
      }
      return String(selectedOption.value.text);
    });
    const isFetchingOptionsWhileClosed = computed(() => fetchingOptions.value && !shown.value);
    const showSelectorIcon = computed(() => {
      if (slots?.right) {
        return false;
      }
      if (isFetchingOptionsWhileClosed.value) {
        return false;
      }
      if (!configuration.clearable) {
        return true;
      }
      return !hasSelectedOption || configuration.disabled === true;
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock(Fragment, null, [
        unref(isFetchingOptionsWhileClosed) || !unref(hasSelectedOption) ? renderSlot(_ctx.$slots, "placeholder", {
          key: 0,
          isFetchingOptionsWhileClosed: unref(isFetchingOptionsWhileClosed)
        }, () => [
          unref(isFetchingOptionsWhileClosed) ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
            createVNode(_sfc_main$F, {
              ref_key: "fetchingPlaceholder",
              ref: fetchingPlaceholder,
              "class-property": "selectButtonSearchingPlaceholder",
              placeholder: unref(configuration).loadingClosedPlaceholder
            }, null, 8, ["placeholder"]),
            createVNode(unref(LoadingIcon), {
              ref_key: "loadingIcon",
              ref: loadingIcon,
              class: normalizeClass(unref(classesList).selectButtonLoadingIcon)
            }, null, 8, ["class"])
          ], 64)) : (openBlock(), createBlock(_sfc_main$F, {
            key: 1,
            ref_key: "placeholder",
            ref: placeholder,
            "class-property": "selectButtonPlaceholder",
            placeholder: unref(configuration).placeholder
          }, null, 8, ["placeholder"]))
        ]) : unref(usesTags) ? (openBlock(), createBlock(_sfc_main$D, { key: 1 }, {
          tagCloseIcon: withCtx((props2) => [
            renderSlot(_ctx.$slots, "tagCloseIcon", normalizeProps(guardReactiveProps(props2)))
          ]),
          tagLabel: withCtx((props2) => [
            renderSlot(_ctx.$slots, "tagLabel", normalizeProps(guardReactiveProps(props2)))
          ]),
          _: 3
        })) : (openBlock(), createElementBlock("span", {
          key: 2,
          ref_key: "label",
          ref: label,
          class: normalizeClass(unref(classesList).selectButtonLabel)
        }, [
          renderSlot(_ctx.$slots, "label", {
            label: unref(triggerLabel),
            option: unref(selectedOption)
          }, () => [
            createTextVNode(toDisplayString(unref(triggerLabel)), 1)
          ])
        ], 2)),
        unref(showSelectorIcon) ? renderSlot(_ctx.$slots, "selectorIcon", { key: 3 }, () => [
          createVNode(unref(SelectorIcon), {
            ref_key: "selectorIcon",
            ref: selectorIcon,
            class: normalizeClass(unref(classesList).selectButtonSelectorIcon)
          }, null, 8, ["class"])
        ]) : createCommentVNode("", true)
      ], 64);
    };
  }
});

const _sfc_main$B = /* @__PURE__ */ defineComponent({
  __name: "clear-button",
  setup(__props) {
    const className = useInjectsClassesListClass("clearButton");
    const iconClassName = useInjectsClassesListClass("clearButtonIcon");
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("button", {
        type: "button",
        "data-rich-select-focusable": "",
        class: normalizeClass(unref(className))
      }, [
        renderSlot(_ctx.$slots, "clearButton", {}, () => [
          createVNode(unref(CloseIcon), {
            class: normalizeClass(unref(iconClassName))
          }, null, 8, ["class"])
        ])
      ], 2);
    };
  }
});

const _hoisted_1$K = { class: "relative" };
const __default__$y = {
  name: "VanillaRichSelect",
  inheritAttrs: false
};
const _sfc_main$A = /* @__PURE__ */ defineComponent({
  ...__default__$y,
  props: {
    ...useVariantProps$1(),
    modelValue: {
      type: [
        String,
        Number,
        Boolean,
        Array,
        Object,
        Date,
        Function,
        Symbol
      ],
      default: void 0
    },
    name: {
      type: String,
      default: void 0
    },
    options: {
      type: [Array, Object],
      default: void 0
    },
    normalizeOptions: {
      type: Boolean,
      default: true
    },
    multiple: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    tags: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: void 0
    },
    fetchEndpoint: {
      type: String,
      default: void 0
    },
    dropdownPlacement: {
      type: String,
      default: void 0,
      validator: (value) => validDropdownPlacements.includes(value)
    },
    dropdownPopperOptions: {
      type: Object,
      default: () => ({
        ...popperOptions,
        placement: "bottom",
        modifiers: [
          {
            name: "offset",
            options: {
              offset: [0, 8]
            }
          },
          sameWidthModifier
        ]
      })
    },
    closeOnSelect: {
      type: Boolean,
      default: void 0
    },
    selectOnClose: {
      type: Boolean,
      default: void 0
    },
    clearSearchOnClose: {
      type: Boolean,
      default: void 0
    },
    toggleOnFocus: {
      type: Boolean,
      default: false
    },
    toggleOnClick: {
      type: Boolean,
      default: true
    },
    toggleOnHover: {
      type: Boolean,
      default: false
    },
    closeOnClickAway: {
      type: Boolean,
      default: true
    },
    closeOnPressEscape: {
      type: Boolean,
      default: true
    },
    valueAttribute: {
      type: String,
      default: void 0
    },
    textAttribute: {
      type: String,
      default: void 0
    },
    hideSearchBox: {
      type: Boolean,
      default: false
    },
    searchBoxPlaceholder: {
      type: String,
      default: "Search..."
    },
    noResultsText: {
      type: String,
      default: "We couldn't find any options."
    },
    searchingText: {
      type: String,
      default: "Searching, please wait..."
    },
    loadingClosedPlaceholder: {
      type: String,
      default: "Loading..."
    },
    loadingMoreResultsText: {
      type: String,
      default: "Loading more options..."
    },
    clearable: {
      type: Boolean,
      default: false
    },
    maxHeight: {
      type: [Number, String],
      default: 250
    },
    fetchOptions: {
      type: Function,
      default: void 0
    },
    prefetchOptions: {
      type: [Function, Boolean],
      default: false
    },
    delay: {
      type: Number,
      default: 250
    },
    minimumInputLength: {
      type: Number,
      default: 2
    },
    minimumInputLengthText: {
      type: [Function, String],
      default: () => (minimumInputLength) => `Please enter ${minimumInputLength} or more characters`
    },
    minimumResultsForSearch: {
      type: Number,
      default: void 0
    },
    teleport: {
      type: Boolean,
      default: true
    },
    teleportTo: {
      type: [String, Object],
      default: "body"
    },
    show: {
      type: Boolean,
      default: false
    },
    trapFocus: {
      type: Boolean,
      default: true
    }
  },
  emits: {
    "change": (e) => e instanceof CustomEvent,
    "input": (e) => e instanceof CustomEvent,
    "keydown": (e) => e instanceof KeyboardEvent,
    "focus": (e) => e instanceof FocusEvent,
    "blur": (e) => e instanceof FocusEvent,
    "mousedown": (e) => e instanceof MouseEvent,
    "mouseover": (e) => e instanceof MouseEvent,
    "mouseleave": (e) => e instanceof MouseEvent,
    "touchstart": (e) => e instanceof TouchEvent,
    "shown": () => true,
    "hidden": () => true,
    "beforeShow": () => true,
    "beforeHide": () => true,
    "optionsSelected": () => true,
    "fetchOptionsSuccess": () => true,
    "fetchOptionsError": () => true,
    "update:modelValue": () => true
  },
  setup(__props, { expose: expose2, emit }) {
    const props = __props;
    const { localValue, clearValue } = useMultipleVModel(props, "modelValue", props.multiple);
    const {
      configuration,
      attributes,
      hasErrors,
      errors
    } = useConfiguration(richSelectConfig, "RichSelect", localValue);
    const fetchOptionsBaseFunction = (query, nextPage) => {
      return useFetchData$1(configuration.fetchEndpoint, {
        query,
        page: nextPage || 1
      }).then((data) => {
        return {
          results: data.data,
          hasMorePages: data.data && data.next_page_url
        };
      });
    };
    const prefetchOptionsBaseFunction = (currentValue) => {
      return useFetchData$1(configuration.fetchEndpoint, {
        values: currentValue
      }).then((data) => {
        return data.data;
      });
    };
    let fetchOptions = void 0;
    let preFetchOptions = void 0;
    if (typeof configuration.fetchOptions === "undefined" && configuration.fetchEndpoint !== void 0) {
      fetchOptions = fetchOptionsBaseFunction;
      preFetchOptions = prefetchOptionsBaseFunction;
    } else {
      fetchOptions = configuration.fetchOptions;
      preFetchOptions = configuration.prefetchOptions;
    }
    const searchQuery = ref(void 0);
    const {
      normalizedOptions,
      flattenedOptions,
      fetchsOptions,
      needsMoreCharsToFetch,
      needsMoreCharsMessage,
      fetchingOptions,
      fetchingMoreOptions,
      fetchOptions: doFetchOptions,
      prefetchOptions: doPrefetchOptions,
      fetchMoreOptions,
      optionsWereFetched,
      fetchedOptionsHaveMorePages,
      fetchOptionsCancel
    } = useFetchsOptions(
      localValue,
      computed(() => configuration.options),
      computed(() => configuration.textAttribute),
      computed(() => configuration.valueAttribute),
      computed(() => configuration.normalizeOptions),
      searchQuery,
      computed(() => fetchOptions),
      computed(() => preFetchOptions),
      computed(() => configuration.delay),
      computed(() => configuration.minimumInputLength),
      computed(() => configuration.minimumInputLengthText)
    );
    const {
      selectedOption,
      hasSelectedOption,
      selectOption,
      toggleOption,
      optionIsSelected
    } = useSelectableOption(
      flattenedOptions,
      localValue,
      computed(() => configuration.multiple),
      computed(() => configuration.clearable)
    );
    const {
      activeOption,
      optionIsActive,
      setActiveOption,
      initActiveOption,
      setNextOptionActive,
      setPrevOptionActive
    } = useActivableOption(flattenedOptions, localValue);
    const originalShown = ref(props.show);
    const shown = refThrottled(originalShown, 1e3);
    const slots = useSlots();
    const showSearchInput = computed(() => {
      if (configuration.hideSearchBox) {
        return false;
      }
      if (configuration.minimumResultsForSearch !== void 0) {
        return normalizedOptions.value.length >= configuration.minimumResultsForSearch;
      }
      return true;
    });
    const dropdownComponent = ref();
    const triggerComponent = ref();
    const dropdownContentComponent = ref();
    const clearButtonComponent = ref();
    const main = ref();
    const canFetchOptions = computed(() => fetchsOptions.value && optionsWereFetched.value && needsMoreCharsToFetch.value);
    const canPreFetchOptions = computed(() => {
      return preFetchOptions && !optionsWereFetched.value && (localValue.value !== null && !isEmpty$1(localValue.value));
    });
    const dropdownClasses = computed(() => {
      const {
        enterActiveClass,
        enterFromClass,
        enterToClass,
        leaveActiveClass,
        leaveFromClass,
        leaveToClass,
        trigger,
        dropdown
      } = configuration.classesList;
      return {
        trigger,
        dropdown,
        enterActiveClass,
        enterFromClass,
        enterToClass,
        leaveActiveClass,
        leaveFromClass,
        leaveToClass
      };
    });
    const showClearButton = computed(() => hasSelectedOption.value && configuration.clearable === true && configuration.disabled !== true);
    const focusDropdownTrigger = () => {
      if (configuration.toggleOnFocus) {
        return;
      }
      dropdownComponent.value.focus();
    };
    const usesTags = computed(() => configuration.tags === true && configuration.multiple === true);
    const hideDropdown = () => {
      shown.value = false;
      dropdownComponent.value.doHide();
    };
    const showDropdown = () => {
      shown.value = true;
      dropdownComponent.value.doShow();
    };
    const adjustDropdown = async () => await dropdownComponent.value.adjustPopper();
    const toggleDropdown = () => {
      shown.value ? hideDropdown() : showDropdown();
    };
    const toggleOptionFromActiveOption = () => {
      if (activeOption.value === null) {
        return;
      }
      toggleOption(activeOption.value);
    };
    const selectOptionFromActiveOption = () => {
      if (activeOption.value === null) {
        return;
      }
      selectOption(activeOption.value);
    };
    const keydownDownHandler = (e) => {
      emit("keydown", e);
      e.preventDefault();
      if (shown.value === false) {
        showDropdown();
        return;
      }
      setNextOptionActive();
      const lastOption = normalizedOptions.value[normalizedOptions.value.length - 1];
      if (optionIsActive(lastOption) && fetchedOptionsHaveMorePages.value && !fetchingMoreOptions.value) {
        fetchMoreOptions();
      }
    };
    const keydownUpHandler = (e) => {
      emit("keydown", e);
      e.preventDefault();
      if (shown.value === false) {
        showDropdown();
        return;
      }
      setPrevOptionActive();
    };
    const keydownEnterHandler = (e) => {
      emit("keydown", e);
      if (shown.value) {
        toggleOptionFromActiveOption();
      }
    };
    const keydownSpaceHandler = (e) => {
      emit("keydown", e);
      e.preventDefault();
      if (configuration.toggleOnClick && !shown.value) {
        showDropdown();
      } else if (shown.value) {
        toggleOptionFromActiveOption();
      }
    };
    const keydownEscHandler = (e) => {
      emit("keydown", e);
      if (shown.value === false) {
        return;
      }
      hideDropdown();
      focusDropdownTrigger();
    };
    const dropdownBottomReachedHandler = () => {
      if (fetchedOptionsHaveMorePages.value && !fetchingMoreOptions.value) {
        fetchMoreOptions();
      }
    };
    const onOptionSelected = () => {
      emit("input", new CustomEvent("input", {
        detail: localValue.value
      }));
      emit("change", new CustomEvent("change", {
        detail: localValue
      }));
      if (shown.value === false) {
        return;
      }
      adjustDropdown();
      if (configuration.closeOnSelect === true || configuration.closeOnSelect === void 0 && !configuration.multiple) {
        hideDropdown();
        if (!configuration.toggleOnFocus) {
          focusDropdownTrigger();
        }
      }
    };
    const beforeHideHandler = () => {
      emit("beforeHide");
      if (configuration.selectOnClose && !isEqual$1(localValue, activeOption?.value)) {
        selectOptionFromActiveOption();
      }
    };
    const shownHandler = () => {
      emit("shown");
      shown.value = true;
    };
    const hiddenHandler = () => {
      emit("hidden");
      shown.value = false;
      if (props.clearSearchOnClose) {
        searchQuery.value = void 0;
      }
    };
    const beforeShowHandler = () => {
      emit("beforeShow");
      initActiveOption();
      if (canFetchOptions.value && !optionsWereFetched.value) {
        doFetchOptions();
      }
    };
    const mousedownHandler = (e) => {
      emit("mousedown", e);
      if (configuration.toggleOnClick) {
        if (showSearchInput.value && shown.value === false) {
          e.preventDefault();
        }
        toggleDropdown();
      }
    };
    const focusHandler = (e) => {
      emit("focus", e);
      if (configuration.toggleOnFocus) {
        showDropdown();
      }
    };
    const rootElementFocusHandler = (e) => {
      dropdownComponent.value?.focus();
    };
    const blurOnChildHandler = (e) => {
      const target = e.target;
      const relatedTarget = e.relatedTarget;
      const relatedTargetDataset = relatedTarget instanceof HTMLElement ? relatedTarget.dataset : void 0;
      if (target.dataset.richSelectFocusable !== void 0 && relatedTargetDataset && relatedTargetDataset.richSelectFocusable === void 0) ;
    };
    const blurHandler = (e) => {
      emit("blur", e);
      if (shown.value) {
        hideDropdown();
      }
    };
    watch(() => localValue.value, () => onOptionSelected());
    watch(() => selectedOption.value, () => {
      emit("optionsSelected", {
        options: selectedOption.value
      });
    });
    onBeforeUnmount(() => fetchOptionsCancel());
    onMounted(() => {
      if (canPreFetchOptions.value) {
        doPrefetchOptions();
      }
    });
    provide("configuration_vanilla", configuration);
    provide("options", normalizedOptions);
    provide("selectedOption", selectedOption);
    provide("hasSelectedOption", hasSelectedOption);
    provide("toggleOption", toggleOption);
    provide("setActiveOption", setActiveOption);
    provide("optionIsSelected", optionIsSelected);
    provide("optionIsActive", optionIsActive);
    provide("keydownDownHandler", keydownDownHandler);
    provide("keydownUpHandler", keydownUpHandler);
    provide("keydownEscHandler", keydownEscHandler);
    provide("keydownEnterHandler", keydownEnterHandler);
    provide("shown", shown);
    provide("clearable", configuration.clearable);
    provide("showSearchInput", showSearchInput);
    provide("slots", slots);
    provide("searchQuery", searchQuery);
    provide("needsMoreCharsToFetch", needsMoreCharsToFetch);
    provide("needsMoreCharsMessage", needsMoreCharsMessage);
    provide("fetchingOptions", fetchingOptions);
    provide("fetchingMoreOptions", fetchingMoreOptions);
    provide("dropdownBottomReachedHandler", dropdownBottomReachedHandler);
    provide("usesTags", usesTags);
    expose2({
      focusDropdownTrigger
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", mergeProps({
        ref_key: "main",
        ref: main,
        class: "vanilla-rich-select"
      }, unref(attributes)), [
        createElementVNode("div", {
          class: normalizeClass(unref(configuration).classesList?.wrapper)
        }, [
          createElementVNode("div", _hoisted_1$K, [
            createVNode(_sfc_main$L, {
              modelValue: unref(localValue),
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => isRef(localValue) ? localValue.value = $event : null),
              name: unref(configuration).name,
              "fixed-classes": void 0,
              classes: void 0,
              multiple: unref(configuration).multiple,
              options: unref(flattenedOptions),
              style: { "width": "0", "opacity": "0", "height": "0", "pointer-events": "none" },
              "aria-hidden": "true",
              disabled: __props.disabled,
              onFocusin: rootElementFocusHandler
            }, null, 8, ["modelValue", "name", "multiple", "options", "disabled"]),
            createVNode(_sfc_main$N, {
              ref_key: "dropdownComponent",
              ref: dropdownComponent,
              disabled: unref(configuration).disabled,
              classes: unref(dropdownClasses),
              rounded: unref(configuration).rounded,
              "fixed-classes": void 0,
              "toggle-on-focus": false,
              "toggle-on-click": false,
              "toggle-on-hover": false,
              "close-on-click-away": props.closeOnClickAway,
              "popper-options": unref(configuration).dropdownPopperOptions,
              placement: unref(configuration).dropdownPlacement,
              "tag-name": unref(usesTags) ? "div" : "button",
              tabindex: unref(usesTags) && !unref(hasSelectedOption) ? 0 : void 0,
              teleport: unref(configuration).teleport,
              "teleport-to": unref(configuration).teleportTo,
              "trap-focus": props.trapFocus,
              "data-rich-select-focusable": "",
              onMouseover: _cache[1] || (_cache[1] = ($event) => _ctx.$emit("mouseover", $event)),
              onMouseleave: _cache[2] || (_cache[2] = ($event) => _ctx.$emit("mouseleave", $event)),
              onTouchstart: _cache[3] || (_cache[3] = ($event) => _ctx.$emit("touchstart", $event)),
              onShown: shownHandler,
              onHidden: hiddenHandler,
              onBeforeShow: beforeShowHandler,
              onBeforeHide: beforeHideHandler,
              onBlur: blurHandler,
              onFocus: focusHandler,
              onKeydown: [
                withKeys(keydownEnterHandler, ["enter"]),
                withKeys(keydownSpaceHandler, ["space"]),
                withKeys(keydownDownHandler, ["down"]),
                withKeys(keydownUpHandler, ["up"]),
                withKeys(keydownEscHandler, ["esc"])
              ],
              onMousedown: mousedownHandler,
              onBlurOnChild: blurOnChildHandler
            }, {
              trigger: withCtx((props2) => [
                createVNode(_sfc_main$C, {
                  ref_key: "triggerComponent",
                  ref: triggerComponent
                }, {
                  selectorIcon: withCtx((props3) => [
                    renderSlot(_ctx.$slots, "selectorIcon", normalizeProps(guardReactiveProps(props3)))
                  ]),
                  placeholder: withCtx((props3) => [
                    renderSlot(_ctx.$slots, "placeholder", normalizeProps(guardReactiveProps(props3)))
                  ]),
                  label: withCtx((props3) => [
                    renderSlot(_ctx.$slots, "label", normalizeProps(guardReactiveProps(props3)))
                  ]),
                  tagCloseIcon: withCtx((props3) => [
                    renderSlot(_ctx.$slots, "tagCloseIcon", normalizeProps(guardReactiveProps(props3)))
                  ]),
                  tagLabel: withCtx((props3) => [
                    renderSlot(_ctx.$slots, "tagLabel", normalizeProps(guardReactiveProps(props3)))
                  ]),
                  _: 2
                }, 1536)
              ]),
              default: withCtx(() => [
                createVNode(_sfc_main$G, {
                  ref_key: "dropdownContentComponent",
                  ref: dropdownContentComponent
                }, {
                  option: withCtx((props2) => [
                    renderSlot(_ctx.$slots, "option", normalizeProps(guardReactiveProps(props2)))
                  ]),
                  optionLabel: withCtx((props2) => [
                    renderSlot(_ctx.$slots, "optionLabel", normalizeProps(guardReactiveProps(props2)))
                  ]),
                  optionIcon: withCtx((props2) => [
                    renderSlot(_ctx.$slots, "optionIcon", normalizeProps(guardReactiveProps(props2)))
                  ]),
                  dropdownTop: withCtx((props2) => [
                    renderSlot(_ctx.$slots, "dropdownTop", normalizeProps(guardReactiveProps(props2)))
                  ]),
                  dropdownBottom: withCtx((props2) => [
                    renderSlot(_ctx.$slots, "dropdownBottom", normalizeProps(guardReactiveProps(props2)))
                  ]),
                  stateFeedback: withCtx((props2) => [
                    renderSlot(_ctx.$slots, "stateFeedback", normalizeProps(guardReactiveProps(props2)))
                  ]),
                  _: 3
                }, 512)
              ]),
              _: 3
            }, 8, ["disabled", "classes", "rounded", "close-on-click-away", "popper-options", "placement", "tag-name", "tabindex", "teleport", "teleport-to", "trap-focus", "onKeydown"]),
            renderSlot(_ctx.$slots, "right", {}, () => [
              unref(showClearButton) ? (openBlock(), createBlock(_sfc_main$B, {
                key: 0,
                ref_key: "clearButtonComponent",
                ref: clearButtonComponent,
                onClick: unref(clearValue)
              }, {
                clearButton: withCtx((props2) => [
                  renderSlot(_ctx.$slots, "clearButton", mergeProps(props2, {
                    classesList: unref(configuration).classesList
                  }))
                ]),
                _: 3
              }, 8, ["onClick"])) : createCommentVNode("", true)
            ])
          ]),
          renderSlot(_ctx.$slots, "errors", normalizeProps(guardReactiveProps({ hasErrors: unref(hasErrors), errors: unref(errors) })), () => [
            unref(hasErrors) && props.showErrors ? (openBlock(), createBlock(_sfc_main$Z, {
              key: 0,
              errors: unref(errors)
            }, null, 8, ["errors"])) : createCommentVNode("", true)
          ]),
          renderSlot(_ctx.$slots, "feedback", normalizeProps(guardReactiveProps({ hasErrors: unref(hasErrors), feedback: props.feedback })), () => [
            !unref(hasErrors) && props.feedback && props.showFeedback ? (openBlock(), createBlock(_sfc_main$Y, {
              key: 0,
              text: props.feedback
            }, null, 8, ["text"])) : createCommentVNode("", true)
          ])
        ], 2)
      ], 16);
    };
  }
});

const __default__$x = {
  name: "VanillaCountryInput",
  inheritAttrs: true
};
const _sfc_main$z = /* @__PURE__ */ defineComponent({
  ...__default__$x,
  props: {
    ...useVariantProps$1(),
    modelValue: {
      type: [String, Number],
      default: void 0
    },
    favoriteCountries: {
      type: [Array, Object, void 0],
      required: false,
      default: () => ["US", "GB", "PT", "FR", "DE"]
    },
    labelWithDialCode: {
      type: Boolean,
      required: false,
      default: false
    },
    labelWithCountryCode: {
      type: Boolean,
      required: false,
      default: false
    },
    searchBoxPlaceholder: {
      type: String,
      default: "Search for your country here..."
    },
    noResultsText: {
      type: String,
      default: "😟 Sorry but we did not find any countries to your query. Try another one query?"
    },
    searchingText: {
      type: String,
      default: "Please wait, searching for countries..."
    },
    loadingClosedPlaceholder: {
      type: String,
      default: "Loading, please wait ..."
    },
    loadingMoreResultsText: {
      type: String,
      default: "Loading more options..."
    },
    minimumInputLengthText: {
      type: [Function, String],
      default: () => (minimumInputLength) => `Search more countries by entering ${minimumInputLength} or more characters`
    }
  },
  emits: [
    "update:countryDialCode",
    "update:countryCode",
    "update:countryName",
    "update:modelValue"
  ],
  setup(__props, { emit }) {
    const props = __props;
    const localValue = useVModel(props, "modelValue");
    const preFetchOptions = filterCountriesByName(
      "",
      localValue.value?.toString(),
      countries,
      2,
      props.favoriteCountries
    );
    const fetchCountries = (query) => new Promise((resolve) => {
      resolve(filterCountriesByName(
        query,
        localValue.value?.toString(),
        countries,
        2,
        props.favoriteCountries
      ));
    }).then((response) => ({
      results: response,
      hasMorePages: false
    }));
    const selectedCountry = computed(() => {
      return find$1(
        countries,
        (country) => country.value === localValue.value
      ) || first(preFetchOptions);
    });
    watch(localValue, () => {
      emit("update:countryDialCode", selectedCountry.value.dialCode);
      emit("update:countryCode", selectedCountry.value.value);
      emit("update:countryName", selectedCountry.value.name_raw);
    }, { immediate: true });
    const { configuration, errors, hasErrors, variant } = useConfiguration(countryInputConfig, "CountryInput", localValue);
    const bindAttributes = useAttributesAndProps();
    return (_ctx, _cache) => {
      return openBlock(), createBlock(_sfc_main$A, mergeProps({
        modelValue: unref(localValue),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => isRef(localValue) ? localValue.value = $event : null)
      }, unref(bindAttributes), {
        options: unref(preFetchOptions),
        "fetch-options": fetchCountries,
        "minimum-input-length": 2,
        "value-attribute": "value",
        "text-attribute": "label",
        "clear-search-on-close": true,
        variant: unref(variant),
        classes: unref(configuration).classesList,
        "show-errors": props.showErrors,
        "search-box-placeholder": __props.searchBoxPlaceholder,
        "no-results-text": __props.noResultsText,
        "searching-text": __props.searchingText,
        "loading-closed-placeholder": __props.loadingClosedPlaceholder,
        "loading-more-results-text": __props.loadingMoreResultsText,
        "minimum-input-length-text": __props.minimumInputLengthText,
        rounded: props.rounded,
        clearable: false,
        "select-on-close": false
      }), {
        label: withCtx(({ option, className, isSelected, hasErrors: hasErrors2 }) => [
          createVNode(_sfc_main$O, {
            country: unref(selectedCountry),
            selected: isSelected,
            "parent-classes": className,
            "has-errors": hasErrors2,
            "label-with-dial-code": props.labelWithDialCode,
            "label-with-country-code": props.labelWithCountryCode
          }, null, 8, ["country", "selected", "parent-classes", "has-errors", "label-with-dial-code", "label-with-country-code"])
        ]),
        option: withCtx(({ option: { raw: country }, className, isSelected, hasErrors: hasErrors2 }) => [
          createVNode(_sfc_main$O, {
            country,
            selected: isSelected,
            "parent-classes": className,
            "has-errors": hasErrors2,
            "label-with-dial-code": props.labelWithDialCode,
            "label-with-country-code": props.labelWithCountryCode
          }, null, 8, ["country", "selected", "parent-classes", "has-errors", "label-with-dial-code", "label-with-country-code"])
        ]),
        _: 1
      }, 16, ["modelValue", "options", "variant", "classes", "show-errors", "search-box-placeholder", "no-results-text", "searching-text", "loading-closed-placeholder", "loading-more-results-text", "minimum-input-length-text", "rounded"]);
    };
  }
});

var assignValue = _assignValue,
    copyObject = _copyObject,
    createAssigner = _createAssigner,
    isArrayLike = isArrayLike_1,
    isPrototype = _isPrototype,
    keys = keys_1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns own enumerable string keyed properties of source objects to the
 * destination object. Source objects are applied from left to right.
 * Subsequent sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object` and is loosely based on
 * [`Object.assign`](https://mdn.io/Object/assign).
 *
 * @static
 * @memberOf _
 * @since 0.10.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.assignIn
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * function Bar() {
 *   this.c = 3;
 * }
 *
 * Foo.prototype.b = 2;
 * Bar.prototype.d = 4;
 *
 * _.assign({ 'a': 0 }, new Foo, new Bar);
 * // => { 'a': 1, 'c': 3 }
 */
var assign = createAssigner(function(object, source) {
  if (isPrototype(source) || isArrayLike(source)) {
    copyObject(source, keys(source), object);
    return;
  }
  for (var key in source) {
    if (hasOwnProperty.call(source, key)) {
      assignValue(object, key, source[key]);
    }
  }
});

var assign_1 = assign;

var root = _root;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now$1 = function() {
  return root.Date.now();
};

var now_1 = now$1;

var isObject = isObject_1,
    now = now_1,
    toNumber = toNumber_1;

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

var debounce_1 = debounce;

const debounce$1 = debounce_1;

const _hoisted_1$J = ["textContent"];
const __default__$w = {
  name: "VanillaDropdownOption",
  inheritAttrs: true
};
const _sfc_main$y = /* @__PURE__ */ defineComponent({
  ...__default__$w,
  props: {
    text: {
      type: [String],
      required: false,
      default: void 0
    },
    disabled: {
      type: [Boolean],
      required: false,
      default: false
    },
    as: {
      type: [String, Object],
      required: false,
      default: "template"
    },
    withDefaultPadding: {
      type: [Boolean],
      required: false,
      default: true
    }
  },
  setup(__props) {
    const classesList = useInjectsClassesList();
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(MenuItem), {
        as: __props.as,
        disabled: __props.disabled
      }, {
        default: withCtx(({ active }) => [
          createElementVNode("div", {
            class: normalizeClass([
              unref(classesList).menuItem,
              __props.withDefaultPadding ? unref(classesList).menuItemSpacing : "",
              active ? unref(classesList).menuItemHighlighted : unref(classesList).menuItemNotHighlighted
            ])
          }, [
            renderSlot(_ctx.$slots, "default", normalizeProps(guardReactiveProps({
              active,
              classes: unref(classesList).menuItemSpacing
            })), () => [
              createElementVNode("span", {
                textContent: toDisplayString(__props.text)
              }, null, 8, _hoisted_1$J)
            ])
          ], 2)
        ]),
        _: 3
      }, 8, ["as", "disabled"]);
    };
  }
});

const _hoisted_1$I = {
  viewBox: "0 0 24 24",
  width: "1.2em",
  height: "1.2em"
};
const _hoisted_2$C = /*#__PURE__*/createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M12.53 16.28a.75.75 0 0 1-1.06 0l-7.5-7.5a.75.75 0 0 1 1.06-1.06L12 14.69l6.97-6.97a.75.75 0 1 1 1.06 1.06l-7.5 7.5Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3$s = [
  _hoisted_2$C
];

function render$l(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$I, _hoisted_3$s))
}

const ChevronDownIcon = { name: 'heroicons-chevron-down-solid', render: render$l };
/* vite-plugin-components disabled */

const _hoisted_1$H = ["textContent"];
const __default__$v = {
  name: "VanillaDropdownMenu",
  inheritAttrs: true
};
const _sfc_main$x = /* @__PURE__ */ defineComponent({
  ...__default__$v,
  props: {
    ...useVariantProps$1(),
    modelValue: {
      type: [Boolean],
      default: false
    },
    text: {
      type: String,
      default: void 0
    },
    buttonVariant: {
      type: String,
      default: void 0
    },
    teleport: {
      type: Boolean,
      default: true
    },
    teleportTo: {
      type: [String, Object],
      default: "body"
    },
    tagName: {
      type: String,
      default: "div"
    },
    dropdownTagName: {
      type: String,
      default: "div"
    },
    disabled: {
      type: Boolean,
      default: void 0
    },
    toggleOnFocus: {
      type: Boolean,
      default: true
    },
    toggleOnClick: {
      type: Boolean,
      default: true
    },
    toggleOnHover: {
      type: Boolean,
      default: false
    },
    closeOnClickAway: {
      type: Boolean,
      default: true
    },
    placement: {
      type: String,
      default: void 0,
      validator: (value) => validPlacements.includes(value)
    },
    popperOptions: {
      type: Object,
      default: () => dropdownPopperDefaultOptions
    },
    usePopper: {
      type: Boolean,
      default: true
    },
    overlay: {
      type: Boolean,
      default: false
    },
    spacedItems: {
      type: Boolean,
      default: true
    },
    showArrow: {
      type: Boolean,
      default: false
    },
    size: {
      type: [String],
      default: "default",
      validator(value) {
        return ["none", "small", "default", "medium", "large", "extra-large", "super-large", "full-width"].includes(value);
      }
    },
    position: {
      type: [String],
      default: "center",
      validator(value) {
        return ["center", "left", "right", "full-width"].includes(value);
      }
    }
  },
  emits: ["update:modelValue"],
  setup(__props, { emit }) {
    const props = __props;
    const localValue = useVModel(props, "modelValue");
    const { configuration } = useConfiguration(dropdownConfig, "Dropdown", localValue);
    const menuItems = ref(void 0);
    const popperInstance = ref(null);
    const dropdown = ref();
    const trigger = ref();
    const root = ref();
    const popperComputedOptions = computed(() => {
      const popperOptions = configuration.popperOptions;
      if (configuration.placement !== void 0) {
        popperOptions.placement = configuration.placement;
        popperOptions.modifiers = [{
          name: "keepTogether",
          options: {
            enabled: true
          }
        }];
      }
      return popperOptions;
    });
    const toggleDropdown = () => {
      trigger.value?.$el.click();
    };
    const hideDropdown = () => {
      if (localValue.value === false) {
        return;
      }
      localValue.value = false;
    };
    throttle$1(() => {
      if (!props.toggleOnHover) {
        return;
      }
      toggleDropdown();
    }, 1e3);
    const closeOnClickOverlay = () => {
      if (!props.overlay) {
        return;
      }
      hideDropdown();
    };
    const createPopperInstance = () => {
      if (!props.usePopper || !dropdown.value || !trigger.value?.$el) {
        return;
      }
      if (popperInstance.value !== null) {
        return;
      }
      popperInstance.value = createPopper(trigger.value?.$el, dropdown?.value, popperComputedOptions.value);
    };
    const destroyPopperInstance = () => {
      setTimeout(() => popperInstance.value?.destroy(), 1e3);
    };
    onMounted(() => {
      if (localValue.value) {
        createPopperInstance();
        toggleDropdown();
      }
    });
    onBeforeUnmount(() => {
      destroyPopperInstance();
    });
    watch(menuItems, (newValue) => {
      localValue.value = newValue !== void 0;
      createPopperInstance();
    });
    watch(localValue, () => {
      createPopperInstance();
    }, { immediate: false });
    onClickOutside(root, () => {
      if (props.closeOnClickAway && localValue.value) {
        hideDropdown();
      }
    }, {
      ignore: [
        root,
        trigger,
        dropdown
      ],
      detectIframe: true
    });
    provide("configuration_vanilla", configuration);
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(Menu), {
        ref_key: "root",
        ref: root,
        as: "div",
        class: normalizeClass([
          __props.teleport ? unref(configuration).classesList.wrapper : ""
        ])
      }, {
        default: withCtx(({ open, close }) => [
          createVNode(unref(MenuButton), {
            ref_key: "trigger",
            ref: trigger,
            as: "div",
            class: normalizeClass([
              unref(configuration).classesList.container,
              unref(configuration).disabled ? unref(configuration).classesList.disabled : ""
            ]),
            disabled: unref(configuration).disabled
          }, {
            default: withCtx(() => [
              renderSlot(_ctx.$slots, "trigger", normalizeProps(guardReactiveProps({
                buttonVariant: __props.buttonVariant,
                text: __props.text,
                iconClasses: unref(configuration).classesList.chevronIcon,
                open,
                disabled: __props.disabled
              })), () => [
                createVNode(_sfc_main$X, {
                  variant: __props.buttonVariant,
                  disabled: unref(configuration).disabled
                }, {
                  default: withCtx(() => [
                    createElementVNode("span", {
                      textContent: toDisplayString(__props.text)
                    }, null, 8, _hoisted_1$H),
                    createVNode(unref(ChevronDownIcon), {
                      class: normalizeClass(unref(configuration).classesList.chevronIcon),
                      "aria-hidden": "true"
                    }, null, 8, ["class"])
                  ]),
                  _: 1
                }, 8, ["variant", "disabled"])
              ])
            ]),
            _: 2
          }, 1032, ["class", "disabled"]),
          (openBlock(), createBlock(Teleport, {
            to: __props.teleportTo,
            disabled: !__props.teleport
          }, [
            __props.overlay && open ? (openBlock(), createElementBlock("div", {
              key: 0,
              class: normalizeClass(unref(configuration).classesList.overlay),
              onClick: closeOnClickOverlay
            }, null, 2)) : createCommentVNode("", true),
            createElementVNode("div", {
              ref_key: "dropdown",
              ref: dropdown,
              class: normalizeClass([
                unref(configuration).classesList.menuWrapper,
                !__props.usePopper && __props.position === "left" ? unref(configuration).classesList.menuWrapperLeft : "",
                !__props.usePopper && __props.position === "right" ? unref(configuration).classesList.menuWrapperRight : "",
                !__props.usePopper && __props.position === "center" ? unref(configuration).classesList.menuWrapperCenter : "",
                !__props.usePopper && __props.position === "full-width" ? unref(configuration).classesList.menuWrapperCenterFull : ""
              ])
            }, [
              __props.showArrow && open ? (openBlock(), createElementBlock("div", {
                key: 0,
                class: normalizeClass(unref(configuration).classesList.arrow),
                "data-popper-arrow": ""
              }, null, 2)) : createCommentVNode("", true),
              createVNode(_sfc_main$$, {
                "classes-list": unref(configuration).classesList
              }, {
                default: withCtx(() => [
                  createVNode(unref(MenuItems), {
                    class: normalizeClass([
                      unref(configuration).classesList.dropdown,
                      __props.size === "none" ? unref(configuration).classesList.sizeNone : "",
                      __props.size === "small" ? unref(configuration).classesList.sizeSmall : "",
                      __props.size === "default" ? unref(configuration).classesList.sizeDefault : "",
                      __props.size === "medium" ? unref(configuration).classesList.sizeMedium : "",
                      __props.size === "large" ? unref(configuration).classesList.sizeLarge : "",
                      __props.size === "extra-large" ? unref(configuration).classesList.sizeXLarge : "",
                      __props.size === "super-large" ? unref(configuration).classesList.sizeXXLarge : "",
                      __props.size === "full-width" ? unref(configuration).classesList.sizeFull : ""
                    ])
                  }, {
                    default: withCtx(() => [
                      createElementVNode("div", {
                        ref_key: "menuItems",
                        ref: menuItems,
                        class: normalizeClass([
                          unref(configuration).classesList.menuItemsWrapper,
                          __props.spacedItems ? unref(configuration).classesList.menuItemsWrapperSpaced : ""
                        ])
                      }, [
                        renderSlot(_ctx.$slots, "default", normalizeProps(guardReactiveProps({ close })))
                      ], 2)
                    ]),
                    _: 2
                  }, 1032, ["class"])
                ]),
                _: 2
              }, 1032, ["classes-list"])
            ], 2)
          ], 8, ["to", "disabled"]))
        ]),
        _: 3
      }, 8, ["class"]);
    };
  }
});

const _hoisted_1$G = {
  viewBox: "0 0 24 24",
  width: "1.2em",
  height: "1.2em"
};
const _hoisted_2$B = /*#__PURE__*/createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M11.47 7.72a.75.75 0 0 1 1.06 0l7.5 7.5a.75.75 0 1 1-1.06 1.06L12 9.31l-6.97 6.97a.75.75 0 0 1-1.06-1.06l7.5-7.5Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3$r = [
  _hoisted_2$B
];

function render$k(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$G, _hoisted_3$r))
}

const ChevronUpIcon = { name: 'heroicons-chevron-up-solid', render: render$k };
/* vite-plugin-components disabled */

const _hoisted_1$F = ["checked", "disabled", "indeterminate"];
const _hoisted_2$A = ["onClick"];
const __default__$u = {
  name: "VanillaDatatableTableHead"
};
const _sfc_main$w = /* @__PURE__ */ defineComponent({
  ...__default__$u,
  props: {
    columns: {
      type: [Array],
      required: true
    },
    columnsWithHiddenState: {
      type: [Array],
      required: false,
      default() {
        return [];
      }
    },
    columnsWithSorting: {
      type: [Array],
      required: false,
      default() {
        return [];
      }
    },
    isFetching: {
      type: Boolean,
      default: false
    },
    selectable: {
      type: Boolean,
      default: false
    },
    allItemsChecked: {
      type: Boolean,
      default: false
    },
    someItemsChecked: {
      type: Boolean,
      default: false
    }
  },
  emits: ["checked", "sorted"],
  setup(__props, { emit }) {
    const props = __props;
    const onCheckAllToggled = (event) => {
      emit("checked", event.target?.checked);
    };
    const defaultSorting = "desc";
    const localSorting = ref(props.columnsWithSorting.map((column) => {
      return {
        ...column,
        sortedTimes: 1
      };
    }));
    watch(
      () => props.columnsWithSorting,
      (newValue) => {
        localSorting.value = [...newValue];
      }
    );
    const toggleSorting = (columnToSort) => {
      const finalSorting = localSorting.value;
      const index = findIndex_1(localSorting.value, { column: columnToSort });
      if (index === -1) {
        finalSorting.push({
          column: columnToSort,
          direction: defaultSorting,
          sortedTimes: 1
        });
      } else {
        const columnSort = find$1(localSorting.value, { column: columnToSort });
        const timesSorted = columnSort?.sortedTimes ?? 0;
        if (timesSorted >= 2) {
          finalSorting.splice(index, 1);
        } else {
          finalSorting.splice(index, 1, {
            column: columnToSort,
            direction: columnSort?.direction === "asc" ? "desc" : "asc",
            sortedTimes: timesSorted + 1
          });
        }
      }
      localSorting.value = finalSorting;
      emit("sorted", [...localSorting.value]);
    };
    const classesList = useInjectsClassesList("configuration_vanilla_datatable");
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("thead", null, [
        createElementVNode("tr", null, [
          __props.selectable ? (openBlock(), createElementBlock("th", {
            key: 0,
            class: normalizeClass([unref(classesList).tableHeadColumnCheckbox])
          }, [
            createElementVNode("input", {
              checked: __props.allItemsChecked,
              disabled: __props.isFetching,
              indeterminate: __props.someItemsChecked,
              class: normalizeClass([
                unref(classesList).tableCheckbox,
                unref(classesList).tableHeadCheckbox
              ]),
              type: "checkbox",
              onChange: onCheckAllToggled
            }, null, 42, _hoisted_1$F)
          ], 2)) : createCommentVNode("", true),
          (openBlock(true), createElementBlock(Fragment, null, renderList(__props.columns, (column) => {
            return withDirectives((openBlock(), createElementBlock("th", {
              key: column.name,
              class: normalizeClass([unref(classesList).tableHeadColumn]),
              scope: "col"
            }, [
              renderSlot(_ctx.$slots, "column", normalizeProps(guardReactiveProps({ column })), () => [
                createElementVNode("div", {
                  class: normalizeClass([unref(classesList).tableHeadColumnContainer])
                }, [
                  createElementVNode("span", {
                    class: normalizeClass([unref(classesList).tableHeadColumnLabel])
                  }, toDisplayString(column.label), 3),
                  column.sortable ? (openBlock(), createElementBlock("span", {
                    key: 0,
                    class: normalizeClass([
                      unref(classesList).tableHeadColumnSortContainer,
                      column.isSorted ? unref(classesList).tableHeadColumnSorted : unref(classesList).tableHeadColumnNotSorted
                    ]),
                    onClick: ($event) => toggleSorting(column.name)
                  }, [
                    column.isSorted && !column.isSortedDesc ? (openBlock(), createBlock(unref(ChevronUpIcon), {
                      key: 0,
                      class: normalizeClass([
                        unref(classesList).tableHeadColumnSortedIconClasses,
                        column.isSortedAsc ? "" : unref(classesList).tableHeadColumnSortedIcon
                      ]),
                      "aria-hidden": "true"
                    }, null, 8, ["class"])) : createCommentVNode("", true),
                    column.isSorted && !column.isSortedAsc || !column.isSorted ? (openBlock(), createBlock(unref(ChevronDownIcon), {
                      key: 1,
                      class: normalizeClass([
                        unref(classesList).tableHeadColumnSortedIconClasses,
                        column.isSortedDesc ? "" : unref(classesList).tableHeadColumnSortedIcon
                      ]),
                      "aria-hidden": "true"
                    }, null, 8, ["class"])) : createCommentVNode("", true)
                  ], 10, _hoisted_2$A)) : createCommentVNode("", true)
                ], 2)
              ])
            ], 2)), [
              [vShow, column.visible]
            ]);
          }), 128))
        ])
      ]);
    };
  }
});

const skeletonConfig = {
  fixedClasses: {
    wrapper: "animate-pulse space-y-1",
    class: ""
  },
  classes: {
    wrapper: "",
    class: "h-5 rounded w-full bg-gradient-to-r from-gray-100 to-gray-200 dark:from-gray-500 dark:to-gray-700"
  },
  variants: {
    vanilla: {
      classes: {
        class: "bg-gradient-to-r from-gray-100 to-gray-200 dark:from-gray-500 dark:to-gray-700"
      }
    },
    bar: {
      classes: {
        class: "h-5 rounded w-full bg-gradient-to-r from-gray-100 to-gray-200 dark:from-gray-500 dark:to-gray-700"
      }
    },
    circle: {
      classes: {
        wrapper: "",
        class: "h-5 w-5 rounded-full bg-gradient-to-r from-gray-100 to-gray-200 dark:from-gray-500 dark:to-gray-700"
      }
    }
  }
};
const skeletonClassesKeys = Object.keys(skeletonConfig.classes);

const __default__$t = {
  name: "VanillaSkeleton",
  inheritAttrs: false
};
const _sfc_main$v = /* @__PURE__ */ defineComponent({
  ...__default__$t,
  props: {
    ...useVariantProps$1(),
    count: {
      type: [Number],
      required: false,
      default: 1
    },
    as: {
      type: [String, void 0],
      default: "div",
      required: false
    },
    width: {
      type: [String, void 0],
      default: "100%",
      required: false
    }
  },
  setup(__props) {
    const props = __props;
    const { configuration } = useConfiguration(skeletonConfig, "SkeletonBar");
    return (_ctx, _cache) => {
      return openBlock(), createBlock(resolveDynamicComponent(__props.as), {
        class: normalizeClass(unref(configuration).classesList.wrapper)
      }, {
        default: withCtx(() => [
          (openBlock(true), createElementBlock(Fragment, null, renderList(__props.count, (index) => {
            return openBlock(), createElementBlock("div", mergeProps({
              key: unref(uniqueId)(`skeleton_${index}`),
              class: unref(configuration).classesList.class
            }, _ctx.$attrs, {
              style: { width: props.width }
            }), [
              renderSlot(_ctx.$slots, "default")
            ], 16);
          }), 128))
        ]),
        _: 3
      }, 8, ["class"]);
    };
  }
});

const __default__$s = {
  name: "VanillaDatatableRowSkeleton"
};
const _sfc_main$u = /* @__PURE__ */ defineComponent({
  ...__default__$s,
  props: {
    numberOfRows: {
      type: [Number, String],
      required: true
    },
    columns: {
      type: [Array],
      required: true
    },
    isSelectable: {
      type: [Boolean],
      required: true
    }
  },
  setup(__props) {
    const classesList = useInjectsClassesList("configuration_vanilla_datatable");
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("tbody", {
        class: normalizeClass([unref(classesList).skeletonTableBody])
      }, [
        (openBlock(true), createElementBlock(Fragment, null, renderList(__props.numberOfRows, (row, rowIndex) => {
          return openBlock(), createElementBlock("tr", { key: rowIndex }, [
            __props.isSelectable ? (openBlock(), createElementBlock("td", {
              key: `checkbox-${rowIndex}`,
              class: normalizeClass([unref(classesList).tableColumnCheckbox])
            }, [
              createElementVNode("input", {
                class: normalizeClass([
                  unref(classesList).tableCheckbox
                ]),
                type: "checkbox"
              }, null, 2)
            ], 2)) : createCommentVNode("", true),
            (openBlock(true), createElementBlock(Fragment, null, renderList(__props.columns, (column, columnIndex) => {
              return openBlock(), createElementBlock("td", {
                key: columnIndex,
                class: normalizeClass([
                  unref(classesList).skeletonTableColumn,
                  column.name.toLocaleLowerCase() === "id" ? unref(classesList).tableIdColumn : ""
                ])
              }, [
                createVNode(_sfc_main$v, {
                  width: column.name.toLocaleLowerCase() === "id" ? `${Math.floor(Math.random() * (3 - 1 + 1) + 1)}rem` : `${Math.floor(Math.random() * (12 - 7 + 1) + 7)}rem`
                }, null, 8, ["width"])
              ], 2);
            }), 128))
          ]);
        }), 128))
      ], 2);
    };
  }
});

const defaultInput = {
  input: mergeClasses(
    "",
    commonClasses.inputsBorder,
    commonClasses.inputsTextColor,
    commonClasses.inputsBackground,
    commonClasses.inputsRingBase,
    commonClasses.inputsRing,
    commonClasses.inputsSpacing,
    commonClasses.inputsAutofill
  ),
  roundedFull: "",
  roundedTop: "",
  roundedBottom: "",
  roundedLeft: "",
  roundedRight: "",
  roundedBottomLeft: "",
  roundedBottomRight: "",
  roundedTopLeft: "",
  roundedTopRight: "",
  inputBorder: commonClasses.inputsBorder,
  wrapper: "",
  addonBefore: "",
  addonAfter: "",
  addonBeforeInputClasses: "",
  addonAfterInputClasses: "",
  addonClasses: "text-gray-300 dark:text-gray-600",
  disabled: ""
};
const inputConfig = {
  fixedClasses: {
    input: mergeClasses(
      commonClasses.inputsText,
      "appearance-none w-full focus:outline-none",
      commonClasses.inputsShadows,
      commonClasses.inputsDisabled,
      commonClasses.inputsBorder
    ),
    wrapper: "relative",
    addonBefore: "absolute inset-y-0 left-0 pl-3 flex items-center cursor-pointer",
    addonAfter: "absolute inset-y-0 right-0 pr-3 flex items-center cursor-pointer",
    addonBeforeInputClasses: "pl-10",
    addonAfterInputClasses: "pr-10",
    addonClasses: commonClasses.iconsSize,
    roundedFull: commonClasses.inputsRadius,
    roundedTop: commonClasses.inputsRadiusTop,
    roundedBottom: commonClasses.inputsRadiusBottom,
    roundedLeft: commonClasses.inputsRadiusLeft,
    roundedRight: commonClasses.inputsRadiusRight,
    roundedBottomLeft: commonClasses.inputsRadiusBottomLeft,
    roundedBottomRight: commonClasses.inputsRadiusBottomRight,
    roundedTopLeft: commonClasses.inputsRadiusTopLeft,
    roundedTopRight: commonClasses.inputsRadiusTopRight,
    inputBorder: "",
    disabled: commonClasses.disabled
  },
  // Default Input appearance
  classes: {
    ...defaultInput
  },
  // Variants
  variants: {
    // Used for Errors
    error: {
      classes: {
        input: mergeClasses(
          commonClasses.inputsErrorTextColor,
          commonClasses.inputsErrorsBackground,
          commonClasses.inputsRingBase,
          commonClasses.inputsErrorsRing,
          commonClasses.inputsSpacing,
          commonClasses.inputsAutofill
        ),
        inputBorder: commonClasses.inputsErrorsBorder,
        wrapper: "",
        addonBefore: "",
        addonAfter: "",
        addonBeforeInputClasses: "",
        addonAfterInputClasses: "",
        addonClasses: "text-red-300 dark:text-red-300/70"
      }
    },
    compact: {
      classes: {
        ...defaultInput,
        input: mergeClasses(
          "",
          commonClasses.inputsText,
          commonClasses.inputsTextColor,
          commonClasses.inputsBackground,
          commonClasses.inputsBorder,
          commonClasses.inputsRingBase,
          commonClasses.inputsRing,
          commonClasses.inputsRadius,
          "px-4 py-2"
        ),
        inputBorder: commonClasses.inputsBorder
      }
    }
  }
};
const inputClassesKeys = Object.keys(inputConfig.classes);

const _hoisted_1$E = {
  viewBox: "0 0 24 24",
  width: "1.2em",
  height: "1.2em"
};
const _hoisted_2$z = /*#__PURE__*/createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75s-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12ZM12 8.25a.75.75 0 0 1 .75.75v3.75a.75.75 0 0 1-1.5 0V9a.75.75 0 0 1 .75-.75Zm0 8.25a.75.75 0 1 0 0-1.5a.75.75 0 0 0 0 1.5Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3$q = [
  _hoisted_2$z
];

function render$j(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$E, _hoisted_3$q))
}

const ExclamationCircleIcon = { name: 'heroicons-exclamation-circle-solid', render: render$j };
/* vite-plugin-components disabled */

const _hoisted_1$D = {
  viewBox: "0 0 24 24",
  width: "1.2em",
  height: "1.2em"
};
const _hoisted_2$y = /*#__PURE__*/createElementVNode("g", { fill: "currentColor" }, [
  /*#__PURE__*/createElementVNode("path", { d: "M12 15a3 3 0 1 0 0-6a3 3 0 0 0 0 6Z" }),
  /*#__PURE__*/createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M1.323 11.447C2.811 6.976 7.028 3.75 12.001 3.75c4.97 0 9.185 3.223 10.675 7.69c.12.362.12.752 0 1.113c-1.487 4.471-5.705 7.697-10.677 7.697c-4.97 0-9.186-3.223-10.675-7.69a1.762 1.762 0 0 1 0-1.113ZM17.25 12a5.25 5.25 0 1 1-10.5 0a5.25 5.25 0 0 1 10.5 0Z",
    "clip-rule": "evenodd"
  })
], -1);
const _hoisted_3$p = [
  _hoisted_2$y
];

function render$i(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$D, _hoisted_3$p))
}

const EyeIcon = { name: 'heroicons-eye-solid', render: render$i };
/* vite-plugin-components disabled */

const _hoisted_1$C = {
  viewBox: "0 0 24 24",
  width: "1.2em",
  height: "1.2em"
};
const _hoisted_2$x = /*#__PURE__*/createElementVNode("g", { fill: "currentColor" }, [
  /*#__PURE__*/createElementVNode("path", { d: "M3.53 2.47a.75.75 0 0 0-1.06 1.06l18 18a.75.75 0 1 0 1.06-1.06l-18-18Zm19.146 10.083a11.249 11.249 0 0 1-2.631 4.31l-3.099-3.099a5.25 5.25 0 0 0-6.71-6.71L7.759 4.577a11.217 11.217 0 0 1 4.242-.827c4.97 0 9.185 3.223 10.675 7.69c.12.362.12.752 0 1.113Z" }),
  /*#__PURE__*/createElementVNode("path", { d: "M15.75 12c0 .18-.013.357-.037.53l-4.244-4.243A3.75 3.75 0 0 1 15.75 12Zm-3.22 3.713l-4.243-4.244a3.75 3.75 0 0 0 4.243 4.243Z" }),
  /*#__PURE__*/createElementVNode("path", { d: "M6.75 12c0-.619.107-1.213.304-1.764l-3.1-3.1a11.25 11.25 0 0 0-2.63 4.31c-.12.362-.12.752 0 1.114c1.489 4.467 5.704 7.69 10.675 7.69c1.5 0 2.933-.294 4.242-.827l-2.477-2.477A5.25 5.25 0 0 1 6.75 12Z" })
], -1);
const _hoisted_3$o = [
  _hoisted_2$x
];

function render$h(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$C, _hoisted_3$o))
}

const EyeSlashIcon = { name: 'heroicons-eye-slash-solid', render: render$h };
/* vite-plugin-components disabled */

const _hoisted_1$B = {
  viewBox: "0 0 24 24",
  width: "1.2em",
  height: "1.2em"
};
const _hoisted_2$w = /*#__PURE__*/createElementVNode("path", {
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.5",
  d: "M15.666 3.888A2.25 2.25 0 0 0 13.5 2.25h-3c-1.03 0-1.9.693-2.166 1.638m7.332 0c.055.194.084.4.084.612v0a.75.75 0 0 1-.75.75H9a.75.75 0 0 1-.75-.75v0c0-.212.03-.418.084-.612m7.332 0c.646.049 1.288.11 1.927.184c1.1.128 1.907 1.077 1.907 2.185V19.5a2.25 2.25 0 0 1-2.25 2.25H6.75A2.25 2.25 0 0 1 4.5 19.5V6.257c0-1.108.806-2.057 1.907-2.185a48.208 48.208 0 0 1 1.927-.184"
}, null, -1);
const _hoisted_3$n = [
  _hoisted_2$w
];

function render$g(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$B, _hoisted_3$n))
}

const ClipboardIcon = { name: 'heroicons-clipboard', render: render$g };
/* vite-plugin-components disabled */

const _hoisted_1$A = { class: "vc-input" };
const _hoisted_2$v = ["id", "name", "autocomplete", "placeholder", "disabled", "type"];
const __default__$r = {
  name: "VanillaInput",
  inheritAttrs: false
};
const _sfc_main$t = /* @__PURE__ */ defineComponent({
  ...__default__$r,
  props: {
    ...useVariantProps$1(),
    modelValue: {
      type: [String, Number],
      default: void 0
    },
    type: {
      type: [String],
      default: "text"
    },
    placeholder: {
      type: [String],
      default: ""
    },
    copiable: {
      type: [Boolean],
      default: false
    }
  },
  emits: ["click", "update:modelValue", "focus", "focusout"],
  setup(__props, { emit }) {
    const props = __props;
    const root = ref(null);
    const localValue = useVModel(props, "modelValue");
    const localType = ref(props.type);
    const { configuration, errors, hasErrors } = useConfiguration(inputConfig, "Input", localValue);
    const showingPassword = ref(false);
    const togglePassword = () => {
      showingPassword.value = !showingPassword.value;
      localType.value = showingPassword.value ? "text" : "password";
    };
    const { text, copy, copied, isSupported } = useClipboard();
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$A, [
        createElementVNode("div", {
          class: normalizeClass(unref(configuration).classesList.wrapper)
        }, [
          unref(hasSlot)(_ctx.$slots.before) ? (openBlock(), createElementBlock("div", {
            key: 0,
            class: normalizeClass(unref(configuration).classesList.addonBefore)
          }, [
            renderSlot(_ctx.$slots, "before", normalizeProps(guardReactiveProps({ className: unref(configuration).classesList.addonClasses })))
          ], 2)) : createCommentVNode("", true),
          withDirectives(createElementVNode("input", mergeProps({
            id: _ctx.name,
            ref_key: "root",
            ref: root,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => isRef(localValue) ? localValue.value = $event : null),
            name: _ctx.name,
            autocomplete: props.autocomplete,
            placeholder: __props.placeholder,
            class: [
              unref(hasSlot)(_ctx.$slots.before) ? unref(configuration).classesList.addonBeforeInputClasses : "",
              unref(hasSlot)(_ctx.$slots.after) || unref(hasErrors) ? unref(configuration).classesList.addonAfterInputClasses : "",
              unref(configuration).classesList.input,
              props.rounded === "full" ? unref(configuration).classesList.roundedFull : "",
              props.rounded === "top" ? unref(configuration).classesList.roundedTop : "",
              props.rounded === "bottom" ? unref(configuration).classesList.roundedBottom : "",
              props.rounded === "left" ? unref(configuration).classesList.roundedLeft : "",
              props.rounded === "right" ? unref(configuration).classesList.roundedRight : "",
              props.rounded === "top-left" ? unref(configuration).classesList.roundedTopLeft : "",
              props.rounded === "top-right" ? unref(configuration).classesList.roundedTopRight : "",
              props.rounded === "bottom-left" ? unref(configuration).classesList.roundedBottomLeft : "",
              props.rounded === "bottom-right" ? unref(configuration).classesList.roundedBottomRight : "",
              props.disabled ? unref(configuration).classesList.disabled : ""
            ],
            disabled: _ctx.disabled,
            type: localType.value
          }, _ctx.$attrs, {
            onClick: _cache[1] || (_cache[1] = ($event) => _ctx.$emit("click", $event)),
            onFocus: _cache[2] || (_cache[2] = ($event) => _ctx.$emit("focus", $event)),
            onFocusout: _cache[3] || (_cache[3] = ($event) => _ctx.$emit("focusout", $event))
          }), null, 16, _hoisted_2$v), [
            [vModelDynamic, unref(localValue)]
          ]),
          unref(hasSlot)(_ctx.$slots.after) || unref(hasErrors) || (__props.type === "password" || props.copiable) ? (openBlock(), createElementBlock("div", {
            key: 1,
            class: normalizeClass(unref(configuration).classesList.addonAfter)
          }, [
            renderSlot(_ctx.$slots, "after", normalizeProps(guardReactiveProps({ hasErrors: unref(hasErrors), type: __props.type, showingPassword: showingPassword.value, className: unref(configuration).classesList.addonClasses })), () => [
              unref(hasErrors) && (__props.type !== "password" && !props.copiable) ? (openBlock(), createBlock(unref(ExclamationCircleIcon), {
                key: 0,
                class: normalizeClass(unref(configuration).classesList.addonClasses)
              }, null, 8, ["class"])) : createCommentVNode("", true),
              __props.type === "password" && !showingPassword.value ? (openBlock(), createBlock(unref(EyeIcon), {
                key: 1,
                class: normalizeClass(unref(configuration).classesList.addonClasses),
                onClick: togglePassword
              }, null, 8, ["class"])) : createCommentVNode("", true),
              showingPassword.value ? (openBlock(), createBlock(unref(EyeSlashIcon), {
                key: 2,
                class: normalizeClass(unref(configuration).classesList.addonClasses),
                onClick: togglePassword
              }, null, 8, ["class"])) : createCommentVNode("", true),
              withDirectives(createVNode(unref(ClipboardIcon), {
                class: normalizeClass(unref(configuration).classesList.addonClasses),
                onClick: _cache[4] || (_cache[4] = ($event) => unref(copy)(unref(localValue)))
              }, null, 8, ["class"]), [
                [vShow, props.copiable && !unref(copied)]
              ]),
              withDirectives(createVNode(unref(CheckIcon$1), {
                class: normalizeClass(unref(configuration).classesList.addonClasses)
              }, null, 8, ["class"]), [
                [vShow, props.copiable && unref(copied)]
              ])
            ])
          ], 2)) : createCommentVNode("", true)
        ], 2),
        renderSlot(_ctx.$slots, "errors", normalizeProps(guardReactiveProps({ hasErrors: unref(hasErrors), errors: unref(errors) })), () => [
          unref(hasErrors) && props.showErrors ? (openBlock(), createBlock(_sfc_main$Z, {
            key: 0,
            errors: unref(errors)
          }, null, 8, ["errors"])) : createCommentVNode("", true)
        ]),
        renderSlot(_ctx.$slots, "feedback", normalizeProps(guardReactiveProps({ hasErrors: unref(hasErrors), feedback: props.feedback })), () => [
          !unref(hasErrors) && props?.feedback && props.showFeedback ? (openBlock(), createBlock(_sfc_main$Y, {
            key: 0,
            text: props.feedback
          }, null, 8, ["text"])) : createCommentVNode("", true)
        ])
      ]);
    };
  }
});

const _hoisted_1$z = {
  viewBox: "0 0 24 24",
  width: "1.2em",
  height: "1.2em"
};
const _hoisted_2$u = /*#__PURE__*/createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M10.5 3.75a6.75 6.75 0 1 0 0 13.5a6.75 6.75 0 0 0 0-13.5ZM2.25 10.5a8.25 8.25 0 1 1 14.59 5.28l4.69 4.69a.75.75 0 1 1-1.06 1.06l-4.69-4.69A8.25 8.25 0 0 1 2.25 10.5Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3$m = [
  _hoisted_2$u
];

function render$f(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$z, _hoisted_3$m))
}

const SearchIcon = { name: 'heroicons-magnifying-glass-solid', render: render$f };
/* vite-plugin-components disabled */

const __default__$q = {
  name: "VanillaDatatableSearchbar"
};
const _sfc_main$s = /* @__PURE__ */ defineComponent({
  ...__default__$q,
  props: {
    modelValue: {
      type: [String, null, void 0],
      required: true
    },
    placeholder: {
      type: [String],
      required: true
    },
    searchable: {
      type: Boolean,
      required: true
    }
  },
  emits: ["update:modelValue"],
  setup(__props, { emit }) {
    const props = __props;
    const search = ref();
    const localValue = useVModel(props, "modelValue");
    const classesList = useInjectsClassesList("configuration_vanilla_datatable");
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass([unref(classesList).searchContainer])
      }, [
        createVNode(_sfc_main$t, {
          ref_key: "search",
          ref: search,
          modelValue: unref(localValue),
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => isRef(localValue) ? localValue.value = $event : null),
          modelModifiers: { lazy: true },
          name: "search",
          class: normalizeClass([
            unref(classesList).searchInputClasses,
            !__props.searchable ? unref(classesList).genericForbidden : ""
          ]),
          placeholder: __props.placeholder,
          variant: unref(classesList).searchInputVariant,
          type: "search"
        }, {
          before: withCtx(() => [
            createVNode(unref(SearchIcon), {
              class: normalizeClass([unref(classesList).searchIcon])
            }, null, 8, ["class"])
          ]),
          _: 1
        }, 8, ["modelValue", "class", "placeholder", "variant"])
      ], 2);
    };
  }
});

const fetchData = (config, data, options) => {
  const isAction = data.action !== null;
  const method = isAction ? config?.actionsMethod : config?.fetchMethod;
  const url = isAction ? config?.actionsEndpoint : config?.fetchEndpoint;
  const postParams = method === "POST" ? data : {};
  const queryParams = method === "GET" ? data : {};
  const finalOptions = {
    method,
    body: JSON.stringify(postParams),
    ...options
  };
  return useFetchData$1(url, queryParams, finalOptions);
};
const useFetchData = fetchData;

function configurationBuilder(props) {
  if (props?.config == null) {
    throw new Error("Datatable configuration is not defined. Pleaes pass a config prop to the Datatable component.");
  }
  const defaultPooling = {
    enable: false,
    interval: 5,
    during: 60,
    stopWhenDataChanges: true
  };
  const defaultOptions = {
    selectable: true,
    allSelectable: true,
    searchable: true,
    isSearchHidden: false,
    showSettings: true,
    showNumberOfItems: true,
    showPages: false,
    striped: false,
    compact: true,
    refreshable: true,
    filtersHashingMethod: "query"
  };
  const defaultTranslations = {
    title: "Items",
    subtitle: "Here you can check your latest items",
    resource: "Item",
    resources: "Items",
    actionsButton: "Actions",
    actionsSelectedRows: "With :rows selected",
    actionConfirmTitle: "Confirm your action",
    actionConfirmText: "Are you sure you want to :action on the :itemsSelected item(s) selected? Please confirm",
    actionConfirmButton: "Yes, I'v Confirmed",
    actionCancelButton: "Nah, Cancel",
    search: "Search",
    searchPlaceholder: "Search your latest Payments",
    selectRows: "You currently have :rows payments selected",
    selectedUndo: "Deselect all",
    selectAllOr: "Select current page or",
    selectAllMatching: "Select all records matching filter",
    selectAllMatchingUndo: "Select only current page",
    filters: "Filters",
    filtersBarLabel: "Filters",
    filtersWithEmptyData: "Oops, seems like there is no records after filtering",
    filtersReset: "Reset Filters",
    filtersResetOr: "or",
    filtersCopy: "Copy Filters Link",
    filtersCopied: "Copied to Clipboard",
    filtersSaveAndClose: "Save & Close",
    filtersRemove: "Remove",
    settings: "Settings",
    settingsItemsPerPage: "Items p/ Page",
    settingsVisibility: "Hidden Columns",
    settingsPersist: "Persist Settings",
    settingsPersistSelection: "Save Selected",
    settingsReset: "Reset to Default Settings",
    settingsSaveAndClose: "Save & Close",
    refresh: "Refresh",
    recordsEmpty: "Seems like there is no records to show you. Please come back later or try inserting some records.",
    recordsEmptyWithFiltersOrSearch: "Sorry but there is no records matching your search or filters.",
    recordsEmptyWithFiltersOrSearchAction: "Reset Query",
    settingsPerPage: ":count Items per page",
    selectOption: "Select an option",
    showingFrom: "Showing :from to :to of :total results",
    nextPage: "Next",
    previousPage: "Previous"
  };
  const defaultPerPageOptions = [
    { value: 5, text: "5 Items per page" },
    { value: 10, text: "10 Items per page" },
    { value: 50, text: "50 Items per page" },
    { value: 100, text: "100 Items per page" },
    { value: 300, text: "300 Items per page" }
  ];
  return {
    name: props.config?.name,
    primaryKey: props.config?.primaryKey || "id",
    filtersKey: props.config?.primaryKey || props.config?.primaryKey,
    columns: props.config?.columns,
    actions: props.config?.actions,
    filters: props.config?.filters,
    options: Object.assign(
      defaultOptions,
      props.config?.options
    ),
    translations: Object.assign(
      defaultTranslations,
      props.config?.translations
    ),
    perPageOptions: props.config?.perPageOptions || defaultPerPageOptions,
    pooling: Object.assign(
      defaultPooling,
      props.config?.pooling
    ),
    fetchData: props?.fetchData || props.config?.fetchData || useFetchData,
    fetchEndpoint: props?.config?.fetchEndpoint || void 0,
    fetchMethod: props?.config?.fetchMethod || "POST",
    originUrl: props.config?.originUrl || void 0,
    actionsEndpoint: props?.config?.fetchEndpoint || void 0,
    actionsMethod: props.config?.actionsMethod?.method || "POST",
    onActionExecutedCallback: props?.onActionExecutedCallback || props.config?.onActionExecutedCallback || void 0,
    onExceptionCallback: props?.onExceptionCallback || props.config?.onExceptionCallback || void 0
  };
}

const validator = (config) => {
  if (typeof config?.columns === "undefined" || config?.columns === null || config?.columns.length <= 0) {
    throw new Error("You must define the columns for this table");
  }
  config?.columns.forEach((column) => {
    if (!column.name) {
      throw new Error(`You must define a name for this column ${column.name}`);
    }
  });
  if (config?.fetchData === void 0 && (config?.fetchEndpoint === void 0 || config?.actionsEndpoint === void 0)) {
    throw new Error("You must define fetchData function to fetch the data or fetchEndpoint & actionsEndpoint to allow the default function to take care of it.");
  }
};
const useValidator = validator;

function injectDatatableConfiguration() {
  const configuration = inject("datatable_configuration");
  return computed(() => configuration);
}

function injectTranslations() {
  const configuration = inject("datatable_configuration");
  return computed(() => configuration.translations || {});
}

const _hoisted_1$y = ["innerHTML"];
const _hoisted_2$t = ["innerHTML"];
const _hoisted_3$l = ["innerHTML"];
const _hoisted_4$5 = ["innerHTML"];
const _hoisted_5$3 = ["innerHTML"];
const __default__$p = {
  name: "VanillaDatatableSelectionBar"
};
const _sfc_main$r = /* @__PURE__ */ defineComponent({
  ...__default__$p,
  props: {
    isAllSelected: {
      type: Boolean,
      required: true
    },
    countSelected: {
      type: [String, Number],
      required: true
    },
    countTotal: {
      type: [String, Number],
      required: true
    }
  },
  emits: [
    "deselectAll",
    "selectMatching",
    "deselectMatching"
  ],
  setup(__props, { emit }) {
    const deselectAll = () => {
      emit("deselectAll", true);
    };
    const selectMatching = () => {
      emit("selectMatching", true);
    };
    const deselectMatching = () => {
      emit("deselectMatching", true);
    };
    const translations = injectTranslations();
    const configuration = injectDatatableConfiguration();
    const classesList = useInjectsClassesList("configuration_vanilla_datatable");
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass([unref(classesList).selectionBarContainer])
      }, [
        createElementVNode("span", {
          innerHTML: unref(useReplacePlaceholders)(unref(translations).selectRows, { rows: __props.countSelected })
        }, null, 8, _hoisted_1$y),
        createElementVNode("a", {
          class: normalizeClass([unref(classesList).selectionBarButton]),
          tabindex: "0",
          onClick: deselectAll,
          innerHTML: unref(useReplacePlaceholders)(unref(translations).selectedUndo)
        }, null, 10, _hoisted_2$t),
        unref(configuration).options.allSelectable ? (openBlock(), createElementBlock("span", {
          key: 0,
          class: normalizeClass([unref(classesList).selectionBarOrText]),
          innerHTML: unref(useReplacePlaceholders)(unref(translations).selectAllOr)
        }, null, 10, _hoisted_3$l)) : createCommentVNode("", true),
        unref(configuration).options.allSelectable && !__props.isAllSelected ? (openBlock(), createElementBlock("a", {
          key: 1,
          class: normalizeClass([unref(classesList).selectionBarButton]),
          tabindex: "0",
          onClick: selectMatching,
          innerHTML: unref(useReplacePlaceholders)(unref(translations).selectAllMatching, { rows: __props.countTotal })
        }, null, 10, _hoisted_4$5)) : createCommentVNode("", true),
        unref(configuration).options.allSelectable && __props.isAllSelected ? (openBlock(), createElementBlock("a", {
          key: 2,
          class: normalizeClass([unref(classesList).selectionBarButton]),
          tabindex: "0",
          onClick: deselectMatching,
          innerHTML: unref(useReplacePlaceholders)(unref(translations).selectAllMatchingUndo, { rows: __props.countTotal })
        }, null, 10, _hoisted_5$3)) : createCommentVNode("", true)
      ], 2);
    };
  }
});

const _hoisted_1$x = {
  viewBox: "0 0 24 24",
  width: "1.2em",
  height: "1.2em"
};
const _hoisted_2$s = /*#__PURE__*/createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M7.72 12.53a.75.75 0 0 1 0-1.06l7.5-7.5a.75.75 0 1 1 1.06 1.06L9.31 12l6.97 6.97a.75.75 0 1 1-1.06 1.06l-7.5-7.5Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3$k = [
  _hoisted_2$s
];

function render$e(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$x, _hoisted_3$k))
}

const ChevronLeftIcon = { name: 'heroicons-chevron-left-solid', render: render$e };
/* vite-plugin-components disabled */

const _hoisted_1$w = {
  viewBox: "0 0 24 24",
  width: "1.2em",
  height: "1.2em"
};
const _hoisted_2$r = /*#__PURE__*/createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M16.28 11.47a.75.75 0 0 1 0 1.06l-7.5 7.5a.75.75 0 0 1-1.06-1.06L14.69 12L7.72 5.03a.75.75 0 0 1 1.06-1.06l7.5 7.5Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3$j = [
  _hoisted_2$r
];

function render$d(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$w, _hoisted_3$j))
}

const ChevronRightIcon = { name: 'heroicons-chevron-right-solid', render: render$d };
/* vite-plugin-components disabled */

const _hoisted_1$v = ["innerHTML"];
const _hoisted_2$q = ["innerHTML"];
const _hoisted_3$i = ["innerHTML"];
const __default__$o = {
  name: "VanillaDatatablePagination"
};
const _sfc_main$q = /* @__PURE__ */ defineComponent({
  ...__default__$o,
  props: {
    isFetching: {
      type: Boolean,
      default: false
    },
    pages: {
      type: [Array],
      required: false,
      default() {
        return [];
      }
    },
    nextPage: {
      type: [String, Number],
      default: null
    },
    previousPage: {
      type: [String, Number],
      default: null
    },
    currentPage: {
      type: [String, Number],
      default: null
    },
    showingFrom: {
      type: [String, Number],
      required: false,
      default: 0
    },
    showingTo: {
      type: [String, Number],
      required: false,
      default: 0
    },
    total: {
      type: [String, Number],
      required: false,
      default: 0
    },
    showPages: {
      type: Boolean,
      required: false,
      default: false
    },
    showPagesMaximum: {
      type: [String, Number],
      required: false,
      default: 5
    },
    limitPages: {
      type: [Boolean],
      default: false
    },
    showNumberOfItems: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  emits: ["navigate"],
  setup(__props, { emit }) {
    const props = __props;
    const goToPage = (page) => emit("navigate", page);
    const translations = injectTranslations();
    const classesList = useInjectsClassesList("configuration_vanilla_datatable");
    const pagesLimited = computed(() => {
      if (props.limitPages === false) {
        return props.pages;
      }
      const pages = props.pages;
      const currentPage = Number(props.currentPage) - 1;
      const showPagesMaximum = Number(props.showPagesMaximum);
      const pagesLength = pages.length;
      const pagesSliced = pages.slice(currentPage, currentPage + showPagesMaximum);
      if (pagesSliced.length < showPagesMaximum) {
        const pagesToAdd = showPagesMaximum - pagesSliced.length;
        const pagesToAddStart = pagesSliced.length;
        const pagesToAddEnd = pagesSliced.length + pagesToAdd;
        const pagesToAddStartLimited = pages.slice(0, pagesToAddStart);
        const pagesToAddEndLimited = pages.slice(pagesLength - pagesToAddEnd, pagesLength);
        return [...pagesToAddStartLimited, ...pagesSliced, ...pagesToAddEndLimited];
      }
      return pagesSliced;
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass([unref(classesList).paginationContainer])
      }, [
        createElementVNode("div", {
          class: normalizeClass([unref(classesList).paginationShortContainer])
        }, [
          createVNode(_sfc_main$X, {
            variant: "paginationButton",
            class: normalizeClass([
              __props.isFetching || __props.previousPage === null ? unref(classesList).genericForbidden : unref(classesList).genericPointer
            ]),
            "aria-label": "Previous",
            onClick: _cache[0] || (_cache[0] = withModifiers(($event) => goToPage(__props.previousPage), ["prevent"]))
          }, {
            default: withCtx(() => [
              createVNode(unref(ChevronLeftIcon), {
                class: normalizeClass([unref(classesList).paginationShortIcon])
              }, null, 8, ["class"]),
              createElementVNode("span", {
                class: normalizeClass(unref(classesList).paginationShortLeft),
                innerHTML: unref(translations).previousPage
              }, null, 10, _hoisted_1$v)
            ]),
            _: 1
          }, 8, ["class"]),
          createVNode(_sfc_main$X, {
            variant: "paginationButton",
            class: normalizeClass([
              __props.isFetching || __props.nextPage === null ? unref(classesList).genericForbidden : unref(classesList).genericPointer
            ]),
            "aria-label": "Next",
            onClick: _cache[1] || (_cache[1] = withModifiers(($event) => goToPage(__props.nextPage), ["prevent"]))
          }, {
            default: withCtx(() => [
              createElementVNode("span", {
                class: normalizeClass(unref(classesList).paginationShortRight),
                innerHTML: unref(translations).nextPage
              }, null, 10, _hoisted_2$q),
              createVNode(unref(ChevronRightIcon), {
                class: normalizeClass([unref(classesList).paginationShortIcon])
              }, null, 8, ["class"])
            ]),
            _: 1
          }, 8, ["class"])
        ], 2),
        createElementVNode("div", {
          class: normalizeClass([unref(classesList).paginationFullContainer])
        }, [
          createElementVNode("div", null, [
            __props.showNumberOfItems && __props.total > 0 ? (openBlock(), createElementBlock("p", {
              key: 0,
              class: normalizeClass([unref(classesList).paginationFullNumberOfRecords])
            }, [
              createElementVNode("span", {
                innerHTML: unref(useReplacePlaceholders)(unref(translations).showingFrom, {
                  from: __props.showingFrom,
                  to: __props.showingTo,
                  total: __props.total
                })
              }, null, 8, _hoisted_3$i)
            ], 2)) : createCommentVNode("", true)
          ]),
          createElementVNode("div", null, [
            createElementVNode("nav", {
              class: normalizeClass([unref(classesList).paginationFullButtonsContainer])
            }, [
              createVNode(_sfc_main$X, {
                variant: "paginationButton",
                class: normalizeClass([
                  unref(classesList).paginationFullLeft,
                  __props.isFetching || __props.previousPage === null ? unref(classesList).genericForbidden : unref(classesList).genericPointer
                ]),
                "aria-label": "Previous",
                onClick: _cache[2] || (_cache[2] = withModifiers(($event) => goToPage(__props.previousPage), ["prevent"]))
              }, {
                default: withCtx(() => [
                  createVNode(unref(ChevronLeftIcon), {
                    class: normalizeClass([unref(classesList).paginationFullIcon])
                  }, null, 8, ["class"])
                ]),
                _: 1
              }, 8, ["class"]),
              __props.showPages && __props.pages.length > 0 ? (openBlock(true), createElementBlock(Fragment, { key: 0 }, renderList(unref(pagesLimited), (page, key) => {
                return openBlock(), createBlock(_sfc_main$X, {
                  key,
                  variant: "paginationButtonPage",
                  class: normalizeClass([
                    page.active ? unref(classesList).paginationFullPageActive : unref(classesList).paginationFullPage
                  ]),
                  onClick: withModifiers(($event) => goToPage(page.url), ["prevent"])
                }, {
                  default: withCtx(() => [
                    createTextVNode(toDisplayString(page.label), 1)
                  ]),
                  _: 2
                }, 1032, ["class", "onClick"]);
              }), 128)) : createCommentVNode("", true),
              createVNode(_sfc_main$X, {
                variant: "paginationButton",
                class: normalizeClass([
                  unref(classesList).paginationFullRight,
                  __props.isFetching || __props.nextPage === null ? unref(classesList).genericForbidden : unref(classesList).genericPointer
                ]),
                "aria-label": "Previous",
                onClick: _cache[3] || (_cache[3] = withModifiers(($event) => goToPage(__props.nextPage), ["prevent"]))
              }, {
                default: withCtx(() => [
                  createVNode(unref(ChevronRightIcon), {
                    class: normalizeClass([unref(classesList).paginationFullIcon])
                  }, null, 8, ["class"])
                ]),
                _: 1
              }, 8, ["class"])
            ], 2)
          ])
        ], 2)
      ], 2);
    };
  }
});

const _hoisted_1$u = ["textContent"];
const __default__$n = {
  name: "VanillaDatatableActions"
};
const _sfc_main$p = /* @__PURE__ */ defineComponent({
  ...__default__$n,
  props: {
    actions: {
      type: [Array, Object],
      required: true
    },
    countSelected: {
      type: [String, Number, void 0],
      default: void 0
    },
    textActions: {
      type: [String],
      default: "Actions"
    }
  },
  emits: ["actionSelected"],
  setup(__props, { emit }) {
    const isDropdownOpen = ref(false);
    const selectAction = (action) => {
      emit("actionSelected", action);
    };
    const translations = injectTranslations();
    const classesList = useInjectsClassesList("configuration_vanilla_datatable");
    return (_ctx, _cache) => {
      return openBlock(), createBlock(_sfc_main$x, {
        modelValue: isDropdownOpen.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => isDropdownOpen.value = $event),
        class: normalizeClass([unref(classesList).actionsContainer])
      }, {
        trigger: withCtx(({ iconClasses }) => [
          createVNode(_sfc_main$X, {
            variant: unref(classesList).actionsButtonVariant
          }, {
            default: withCtx(() => [
              createElementVNode("span", {
                textContent: toDisplayString(unref(translations).actionsButton)
              }, null, 8, _hoisted_1$u),
              __props.countSelected !== void 0 ? (openBlock(), createElementBlock("span", {
                key: 0,
                class: normalizeClass([unref(classesList).actionsButtonCount])
              }, "( " + toDisplayString(__props.countSelected) + " )", 3)) : createCommentVNode("", true),
              createVNode(unref(ChevronDownIcon), {
                class: normalizeClass(iconClasses),
                "aria-hidden": "true"
              }, null, 8, ["class"])
            ]),
            _: 2
          }, 1032, ["variant"])
        ]),
        default: withCtx(() => [
          (openBlock(true), createElementBlock(Fragment, null, renderList(__props.actions, (action) => {
            return openBlock(), createBlock(_sfc_main$y, {
              key: action.name,
              onClick: ($event) => selectAction(action)
            }, {
              default: withCtx(() => [
                renderSlot(_ctx.$slots, action.slotName, normalizeProps(guardReactiveProps({ selectAction })), () => [
                  createElementVNode("span", null, toDisplayString(action.label), 1)
                ])
              ]),
              _: 2
            }, 1032, ["onClick"]);
          }), 128))
        ]),
        _: 3
      }, 8, ["modelValue", "class"]);
    };
  }
});

const __default__$m = {
  name: "VanillaDialogFooter"
};
const _sfc_main$o = /* @__PURE__ */ defineComponent({
  ...__default__$m,
  props: {
    divided: {
      type: Boolean,
      default: true
    }
  },
  setup(__props) {
    const classesList = useInjectsClassesList();
    const footer = ref(null);
    const children = ref(0);
    const footerClasses = ref("");
    onMounted(() => {
      children.value = footer.value?.children?.length ?? 0;
      if (children.value === 1) {
        footerClasses.value = classesList.value.footerWithOneButton;
      }
      if (children.value === 2) {
        footerClasses.value = classesList.value.footerWithTwoButtons;
      }
      if (children.value === 3) {
        footerClasses.value = classesList.value.footerWithThreeButtons;
      }
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        ref_key: "footer",
        ref: footer,
        class: normalizeClass([
          unref(footerClasses),
          unref(classesList)?.footer,
          __props.divided ? unref(classesList)?.footerDivided : ""
        ])
      }, [
        renderSlot(_ctx.$slots, "default")
      ], 2);
    };
  }
});

const dialogConfig = {
  fixedClasses: {},
  // Default appearance
  classes: {
    wrapper: "fixed inset-0 overflow-y-auto",
    inner: "flex min-h-full p-4 justify-center text-center sm:p-0",
    positionCentered: "items-center",
    positionCenterBottom: "items-end sm:items-center",
    positionCenterTop: "items-start sm:items-center",
    positionBottom: "items-end",
    positionTop: "items-start",
    overlay: "fixed inset-0 transition-opacity  backdrop-blur-sm",
    overlayColor: "bg-gray-600/50 dark:bg-gray-900/80",
    modalBackground: "bg-white dark:bg-gray-800",
    modalRing: "ring-1 ring-gray-500/20 dark:ring-gray-200/20",
    modal: mergeClasses(
      "sm:my-8",
      "relative inline-block align-middle overflow-hidden",
      "shadow-xl",
      "rounded-lg",
      "transform transition-all"
    ),
    modalPaddingX: "px-5",
    modalPaddingTop: "pt-5",
    modalPaddingBottom: "pb-4",
    zIndexWrapper: "z-[40]",
    zIndexOverlay: "z-[30]",
    sizeDefault: "max-w-sm w-full sm:max-w-sm sm:w-full",
    sizeSmall: "max-w-xs w-full sm:max-w-xs sm:w-full",
    sizeMedium: "max-w-md w-full sm:max-w-md sm:w-full",
    sizeLarge: "max-w-lg w-full sm:max-w-lg sm:w-full",
    sizeFull: " w-full",
    // Body
    // body: 'text-sm leading-5 text-gray-600 dark:text-gray-300',
    body: "",
    // bodyWithPadding: 'px-4 sm:px-8 py-4 sm:py-8',
    bodyPaddingX: "px-4",
    bodyPaddingBottom: "pb-4",
    bodyPaddingTop: "pt-5",
    // Header / Title
    title: "px-4 py-4 sm:px-6 text-gray-700",
    titleDivided: "border-b dark:border-gray-700",
    titleText: "text-lg leading-6 font-medium text-gray-900 dark:text-white",
    // Footer
    footer: "px-4 py-4",
    footerDivided: "border-t border-gray-200 dark:border-gray-700",
    footerWithOneButton: "grid grid-cols-1",
    footerWithTwoButtons: "grid gap-y-2 grid-cols-1 sm:grid-cols-2 sm:gap-x-2 sm:gap-y-0 xs:grid-cols-2 xs:grid-flow-row-dense xs:gap-x-2 xs:gap-y-0",
    footerWithThreeButtons: "sm:grid sm:grid-cols-3 sm:gap-2 sm:grid-flow-row-dense",
    // Transition backdrop
    overlayEnter: "duration-300 ease-out",
    overlayEnterFrom: "opacity-0",
    overlayEnterTo: "opacity-100",
    overlayLeave: "duration-200 ease-in",
    overlayLeaveFrom: "opacity-100",
    overlayLeaveTo: "opacity-0",
    // Transition for Modal
    dialogEnter: "duration-300 ease-out",
    dialogEnterFrom: "opacity-0 scale-95",
    dialogEnterTo: "opacity-100 scale-100",
    dialogLeave: "duration-200 ease-in",
    dialogLeaveFrom: "opacity-100 scale-100",
    dialogLeaveTo: "opacity-0 scale-95"
  }
};
const dialogClassesKeys = Object.keys(dialogConfig.classes);

const _hoisted_1$t = /* @__PURE__ */ createElementVNode("div", {
  style: { "width": "0", "height": "0", "visibility": "hidden" },
  tabindex: "99"
}, null, -1);
const _hoisted_2$p = ["innerHTML"];
const __default__$l = {
  name: "VanillaDialog"
};
const _sfc_main$n = /* @__PURE__ */ defineComponent({
  ...__default__$l,
  props: {
    ...useVariantProps$1(),
    modelValue: {
      type: [Boolean],
      default: false
    },
    title: {
      type: [String],
      default: void 0
    },
    teleport: {
      type: Boolean,
      default: false
    },
    teleportTo: {
      type: [String, Object],
      default: "body"
    },
    overlay: {
      type: Boolean,
      default: false
    },
    closeable: {
      type: Boolean,
      default: true
    },
    closeableOnClickOutside: {
      type: Boolean,
      default: true
    },
    closeableOnPressEscape: {
      type: Boolean,
      default: true
    },
    padding: {
      type: Boolean,
      default: false
    },
    paddingBody: {
      type: [Boolean],
      default: true
    },
    divided: {
      type: Boolean,
      default: false
    },
    as: {
      type: [String],
      default: "div"
    },
    size: {
      type: [String],
      required: false,
      default: "default",
      validator(align) {
        return ["default", "small", "medium", "large", "full"].includes(align);
      }
    },
    position: {
      type: [String],
      required: false,
      default: "center",
      validator(align) {
        return ["center-bottom", "center-top", "center", "top", "bottom"].includes(align);
      }
    }
  },
  emits: [
    "update:modelValue",
    "close",
    "open",
    "opening",
    "opened",
    "closing",
    "closed"
  ],
  setup(__props, { emit }) {
    const props = __props;
    const slots = useSlots();
    const localValue = useVModel(props, "modelValue");
    const { configuration, errors, hasErrors } = useConfiguration(dialogConfig, "Dialog", localValue);
    const close = () => {
      if (!props.closeable) {
        return;
      }
      if (!props.closeableOnClickOutside) {
        localValue.value = true;
        return;
      }
      setTimeout(() => {
        localValue.value = false;
        emit("close");
      }, 50);
    };
    const hasHeaderSlot = computed(() => hasSlot(slots.header) || props.title !== void 0);
    const hasFooterSlot = computed(() => hasSlot(slots.footer));
    const shouldApplyModalPaddingX = computed(() => props.padding && !hasHeaderSlot.value);
    const shouldApplyModalPaddingTop = computed(() => props.padding && !hasHeaderSlot.value);
    const shouldApplyModalPaddingBottom = computed(() => props.padding && !hasFooterSlot.value);
    const shouldApplyBodyPaddingTop = computed(() => props.paddingBody && !hasHeaderSlot.value || hasHeaderSlot.value && props.divided);
    const shouldApplyBodyPaddingBottom = computed(() => props.paddingBody && !hasFooterSlot.value || hasFooterSlot.value && props.divided);
    const shouldApplyBodyXPadding = computed(() => props.paddingBody);
    const emitTransitionEvent = (event) => emit(event);
    provide("configuration_vanilla", configuration);
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(TransitionRoot), {
        appear: "",
        show: unref(localValue),
        as: "template",
        onBeforeEnter: _cache[0] || (_cache[0] = ($event) => emitTransitionEvent("opening")),
        onAfterEnter: _cache[1] || (_cache[1] = ($event) => emitTransitionEvent("opened")),
        onBeforeLeave: _cache[2] || (_cache[2] = ($event) => emitTransitionEvent("closing")),
        onAfterLeave: _cache[3] || (_cache[3] = ($event) => emitTransitionEvent("closed"))
      }, {
        default: withCtx(() => [
          createVNode(unref(Dialog), {
            as: __props.as,
            "initial-focus": null,
            onClose: close
          }, {
            default: withCtx(() => [
              createVNode(unref(TransitionChild), {
                as: "template",
                enter: unref(configuration).classesList.overlayEnter,
                "enter-from": unref(configuration).classesList.overlayEnterFrom,
                "enter-to": unref(configuration).classesList.overlayEnterTo,
                leave: unref(configuration).classesList.overlayLeave,
                "leave-from": unref(configuration).classesList.overlayLeaveFrom,
                "leave-to": unref(configuration).classesList.overlayLeaveTo
              }, {
                default: withCtx(() => [
                  createVNode(unref(DialogOverlay), {
                    class: normalizeClass([
                      unref(configuration).classesList.overlay,
                      unref(configuration).classesList.overlayColor,
                      unref(configuration).classesList.zIndexOverlay
                    ])
                  }, null, 8, ["class"])
                ]),
                _: 1
              }, 8, ["enter", "enter-from", "enter-to", "leave", "leave-from", "leave-to"]),
              createElementVNode("div", {
                class: normalizeClass([
                  unref(configuration).classesList.wrapper,
                  unref(configuration).classesList.zIndexWrapper
                ])
              }, [
                createElementVNode("div", {
                  class: normalizeClass([
                    unref(configuration).classesList.inner,
                    __props.position === "center" ? unref(configuration).classesList.positionCentered : "",
                    __props.position === "center-bottom" ? unref(configuration).classesList.positionCenterBottom : "",
                    __props.position === "center-top" ? unref(configuration).classesList.positionCenterTop : "",
                    __props.position === "bottom" ? unref(configuration).classesList.positionBottom : "",
                    __props.position === "top" ? unref(configuration).classesList.positionTop : ""
                  ])
                }, [
                  createVNode(unref(TransitionChild), {
                    as: "template",
                    enter: unref(configuration).classesList.dialogEnter,
                    "enter-from": unref(configuration).classesList.dialogEnterFrom,
                    "enter-to": unref(configuration).classesList.dialogEnterTo,
                    leave: unref(configuration).classesList.dialogLeave,
                    "leave-from": unref(configuration).classesList.dialogLeaveFrom,
                    "leave-to": unref(configuration).classesList.dialogLeaveTo
                  }, {
                    default: withCtx(() => [
                      createVNode(unref(DialogPanel), {
                        class: normalizeClass([
                          unref(configuration).classesList.modal,
                          unref(configuration).classesList.modalBackground,
                          unref(configuration).classesList.modalRing,
                          unref(shouldApplyModalPaddingX) ? unref(configuration).classesList.modalPaddingX : "",
                          unref(shouldApplyModalPaddingTop) ? unref(configuration).classesList.modalPaddingTop : "",
                          unref(shouldApplyModalPaddingBottom) ? unref(configuration).classesList.modalPaddingBottom : "",
                          __props.size === "default" ? unref(configuration).classesList.sizeDefault : "",
                          __props.size === "small" ? unref(configuration).classesList.sizeSmall : "",
                          __props.size === "medium" ? unref(configuration).classesList.sizeMedium : "",
                          __props.size === "large" ? unref(configuration).classesList.sizeLarge : "",
                          __props.size === "full" ? unref(configuration).classesList.sizeFull : ""
                        ])
                      }, {
                        default: withCtx(() => [
                          _hoisted_1$t,
                          unref(hasHeaderSlot) ? (openBlock(), createBlock(unref(DialogTitle), {
                            key: 0,
                            as: "div",
                            class: normalizeClass([
                              unref(configuration).classesList.title,
                              __props.divided ? unref(configuration).classesList.titleDivided : ""
                            ])
                          }, {
                            default: withCtx(() => [
                              renderSlot(_ctx.$slots, "header", { close }, () => [
                                createElementVNode("h3", {
                                  class: normalizeClass(unref(configuration).classesList.titleText),
                                  innerHTML: __props.title
                                }, null, 10, _hoisted_2$p)
                              ])
                            ]),
                            _: 3
                          }, 8, ["class"])) : createCommentVNode("", true),
                          createVNode(unref(DialogDescription), mergeProps({ as: "div" }, _ctx.$attrs, {
                            class: [
                              unref(shouldApplyBodyXPadding) ? unref(configuration).classesList.bodyPaddingX : "",
                              unref(shouldApplyBodyPaddingTop) ? unref(configuration).classesList.bodyPaddingTop : "",
                              unref(shouldApplyBodyPaddingBottom) ? unref(configuration).classesList.bodyPaddingBottom : "",
                              unref(configuration).classesList.body
                            ]
                          }), {
                            default: withCtx(() => [
                              renderSlot(_ctx.$slots, "default", normalizeProps(guardReactiveProps({ close })))
                            ]),
                            _: 3
                          }, 16, ["class"]),
                          unref(hasFooterSlot) ? (openBlock(), createBlock(_sfc_main$o, {
                            key: 1,
                            ref: "footer",
                            divided: __props.divided
                          }, {
                            default: withCtx(() => [
                              renderSlot(_ctx.$slots, "footer", { close })
                            ]),
                            _: 3
                          }, 8, ["divided"])) : createCommentVNode("", true)
                        ]),
                        _: 3
                      }, 8, ["class"])
                    ]),
                    _: 3
                  }, 8, ["enter", "enter-from", "enter-to", "leave", "leave-from", "leave-to"])
                ], 2)
              ], 2)
            ]),
            _: 3
          }, 8, ["as"])
        ]),
        _: 3
      }, 8, ["show"]);
    };
  }
});

const _hoisted_1$s = {
  viewBox: "0 0 24 24",
  width: "1.2em",
  height: "1.2em"
};
const _hoisted_2$o = /*#__PURE__*/createElementVNode("path", {
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.5",
  d: "M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z"
}, null, -1);
const _hoisted_3$h = [
  _hoisted_2$o
];

function render$c(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$s, _hoisted_3$h))
}

const ExclamationTriangleIcon = { name: 'heroicons-exclamation-triangle', render: render$c };
/* vite-plugin-components disabled */

const _hoisted_1$r = {
  viewBox: "0 0 24 24",
  width: "1.2em",
  height: "1.2em"
};
const _hoisted_2$n = /*#__PURE__*/createElementVNode("path", {
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.5",
  d: "m4.5 12.75l6 6l9-13.5"
}, null, -1);
const _hoisted_3$g = [
  _hoisted_2$n
];

function render$b(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$r, _hoisted_3$g))
}

const CheckIcon = { name: 'heroicons-check', render: render$b };
/* vite-plugin-components disabled */

const _hoisted_1$q = {
  viewBox: "0 0 24 24",
  width: "1.2em",
  height: "1.2em"
};
const _hoisted_2$m = /*#__PURE__*/createElementVNode("path", {
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.5",
  d: "M9.348 14.651a3.75 3.75 0 0 1 0-5.303m5.304 0a3.75 3.75 0 0 1 0 5.303m-7.425 2.122a6.75 6.75 0 0 1 0-9.546m9.546 0a6.75 6.75 0 0 1 0 9.546M5.106 18.894c-3.808-3.808-3.808-9.98 0-13.789m13.788 0c3.808 3.808 3.808 9.981 0 13.79M12 12h.008v.007H12V12Zm.375 0a.375.375 0 1 1-.75 0a.375.375 0 0 1 .75 0Z"
}, null, -1);
const _hoisted_3$f = [
  _hoisted_2$m
];

function render$a(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$q, _hoisted_3$f))
}

const SignalIcon = { name: 'heroicons-signal', render: render$a };
/* vite-plugin-components disabled */

const _hoisted_1$p = {
  viewBox: "0 0 24 24",
  width: "1.2em",
  height: "1.2em"
};
const _hoisted_2$l = /*#__PURE__*/createElementVNode("path", {
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.5",
  d: "m11.25 11.25l.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0a9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z"
}, null, -1);
const _hoisted_3$e = [
  _hoisted_2$l
];

function render$9(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$p, _hoisted_3$e))
}

const InformationCircleIcon = { name: 'heroicons-information-circle', render: render$9 };
/* vite-plugin-components disabled */

const _hoisted_1$o = ["innerHTML"];
const _hoisted_2$k = { key: 1 };
const _hoisted_3$d = ["innerHTML"];
const _hoisted_4$4 = { key: 1 };
const __default__$k = {
  name: "VanillaDatatableConfirmActionDialog"
};
const _sfc_main$m = /* @__PURE__ */ defineComponent({
  ...__default__$k,
  props: {
    action: {
      type: [Object, void 0],
      required: false,
      default: void 0
    },
    countSelected: {
      type: [Number, String],
      required: true
    }
  },
  emits: [
    "update:modelValue",
    "actionCanceled",
    "actionConfirmed"
  ],
  setup(__props, { emit }) {
    const props = __props;
    const isOpen = ref(false);
    const cancelAction = () => {
      isOpen.value = false;
      emit("actionCanceled", props.action);
    };
    const confirmAction = () => {
      isOpen.value = false;
      emit("actionConfirmed", props.action);
    };
    const translations = injectTranslations();
    const classesList = useInjectsClassesList("configuration_vanilla_datatable");
    const title = computed(() => {
      const value = props.action?.before?.confirm?.title || translations.value.actionConfirmTitle;
      return useReplacePlaceholders(value, { name: props.action?.label });
    });
    const text = computed(() => {
      const value = props.action?.before?.confirm?.text || translations.value.actionConfirmText;
      return useReplacePlaceholders(value, { name: `<b>${props.action?.label}</b>`, itemsSelected: `<b>${props.countSelected}</b>` });
    });
    const confirmText = computed(() => {
      const value = props.action?.before?.confirm?.confirmButton || translations.value.actionConfirmButton;
      return useReplacePlaceholders(value, { name: props.action?.label, itemsSelected: props.countSelected });
    });
    const cancelText = computed(() => {
      const value = props.action?.before?.confirm?.cancelButton || translations.value.actionCancelButton;
      return useReplacePlaceholders(value, { name: props.action?.label, itemsSelected: props.countSelected });
    });
    watch(isOpen, (val) => {
      emit("update:modelValue", val);
    });
    return (_ctx, _cache) => {
      return openBlock(), createBlock(_sfc_main$n, {
        modelValue: isOpen.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => isOpen.value = $event),
        "body-with-padding": true,
        "body-darker": false
      }, {
        footer: withCtx(() => [
          createVNode(_sfc_main$X, {
            label: unref(cancelText),
            tabindex: "1",
            "focus-on-mount": "",
            onClick: cancelAction
          }, null, 8, ["label"]),
          createVNode(_sfc_main$X, {
            tabindex: "2",
            variant: "primary",
            label: unref(confirmText),
            onClick: confirmAction
          }, null, 8, ["label"])
        ]),
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "icon", normalizeProps(guardReactiveProps({
            action: __props.action,
            title: unref(title),
            text: unref(text),
            confirmText: unref(confirmText),
            cancelText: unref(cancelText)
          })), () => [
            createElementVNode("div", {
              class: normalizeClass([
                unref(classesList).actionIconContainer,
                __props.action?.icon === "success" ? unref(classesList).actionIconContainerSuccess : "",
                __props.action?.icon === "danger" || __props.action?.icon === void 0 ? unref(classesList).actionIconContainerDanger : "",
                __props.action?.icon === "warning" ? unref(classesList).actionIconContainerWarning : "",
                __props.action?.icon === "info" ? unref(classesList).actionIconContainerInfo : ""
              ])
            }, [
              __props.action?.icon === void 0 || __props.action?.icon === "danger" ? (openBlock(), createBlock(unref(ExclamationTriangleIcon), {
                key: 0,
                class: normalizeClass([
                  unref(classesList).actionIcon,
                  unref(classesList).actionIconDanger
                ])
              }, null, 8, ["class"])) : createCommentVNode("", true),
              __props.action?.icon === "success" ? (openBlock(), createBlock(unref(CheckIcon), {
                key: 1,
                class: normalizeClass([
                  unref(classesList).actionIcon,
                  unref(classesList).actionIconSuccess
                ])
              }, null, 8, ["class"])) : createCommentVNode("", true),
              __props.action?.icon === "warning" ? (openBlock(), createBlock(unref(SignalIcon), {
                key: 2,
                class: normalizeClass([
                  unref(classesList).actionIcon,
                  unref(classesList).actionIconWarning
                ])
              }, null, 8, ["class"])) : createCommentVNode("", true),
              __props.action?.icon === "info" ? (openBlock(), createBlock(unref(InformationCircleIcon), {
                key: 3,
                class: normalizeClass([
                  unref(classesList).actionIcon,
                  unref(classesList).actionIconInfo
                ])
              }, null, 8, ["class"])) : createCommentVNode("", true)
            ], 2)
          ]),
          renderSlot(_ctx.$slots, "default", normalizeProps(guardReactiveProps({
            action: __props.action,
            title: unref(title),
            text: unref(text),
            confirmText: unref(confirmText),
            cancelText: unref(cancelText)
          })), () => [
            createElementVNode("div", {
              class: normalizeClass(unref(classesList).actionsContentContainer)
            }, [
              unref(title) !== null && unref(title) !== "" ? (openBlock(), createElementBlock("h3", {
                key: 0,
                class: normalizeClass([
                  unref(classesList).actionsTitle,
                  __props.action?.before?.confirm?.classes?.title
                ])
              }, [
                __props.action?.before?.confirm?.safe ? (openBlock(), createElementBlock("span", {
                  key: 0,
                  innerHTML: unref(title)
                }, null, 8, _hoisted_1$o)) : (openBlock(), createElementBlock("span", _hoisted_2$k, toDisplayString(unref(title)), 1))
              ], 2)) : createCommentVNode("", true),
              createElementVNode("div", {
                class: normalizeClass([
                  unref(classesList).actionsText,
                  __props.action?.before?.confirm?.classes?.text
                ])
              }, [
                __props.action?.before?.confirm?.safe ? (openBlock(), createElementBlock("p", {
                  key: 0,
                  innerHTML: unref(text)
                }, null, 8, _hoisted_3$d)) : (openBlock(), createElementBlock("p", _hoisted_4$4, toDisplayString(unref(text)), 1))
              ], 2)
            ], 2)
          ])
        ]),
        _: 3
      }, 8, ["modelValue"]);
    };
  }
});

const toggleConfig = {
  fixedClasses: {
    wrapper: "",
    wrapperLeftTop: "justify-start items-start",
    wrapperLeftCenter: "justify-start items-center",
    wrapperLeftBottom: "justify-start items-end",
    wrapperRightTop: "justify-end items-start",
    wrapperRightCenter: "justify-end items-center",
    wrapperRightBottom: "justify-end items-end",
    wrapperCenterTop: "justify-center items-start",
    wrapperCenterCenter: "justify-center items-center",
    wrapperCenterBottom: "justify-center items-end",
    container: "",
    toggle: mergeClasses(
      "relative inline-flex flex-shrink-0  cursor-pointer",
      "border-2 border-transparent",
      "h-6 w-11",
      "rounded-full",
      "transition-colors ease-in-out duration-200",
      commonClasses.buttonRing
    ),
    checked: "",
    unchecked: "",
    iconChecked: "h-3 w-3",
    iconUnchecked: "h-3 w-3",
    groupContainer: "space-y-3",
    groupToggleWrapper: "relative flex items-start",
    groupToggle: "flex items-center h-5",
    groupLabelWrapper: "ml-3 text-sm leading-5",
    groupLabelFeedback: "text-gray-500",
    label: {
      label: ""
    },
    disabled: commonClasses.disabled
  },
  // Default Input appearance
  classes: {
    wrapper: "",
    wrapperLeftTop: "",
    wrapperLeftCenter: "",
    wrapperLeftBottom: "",
    wrapperRightTop: "",
    wrapperRightCenter: "",
    wrapperRightBottom: "",
    wrapperCenterTop: "",
    wrapperCenterCenter: "",
    wrapperCenterBottom: "",
    container: "",
    toggle: "focus:ring-offset-2 focus:ring-primary-600",
    checked: "bg-primary-600",
    unchecked: "bg-gray-200 dark:bg-gray-900 dark:border-gray-700",
    iconChecked: "text-primary-600",
    iconUnchecked: "text-gray-400 dark:text-gray-900",
    iconWrapper: "pointer-events-none inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200 flex items-center justify-center",
    transitionChecked: "translate-x-5",
    transitionUnchecked: "translate-x-0",
    label: {
      label: "block font-medium text-sm text-gray-700 dark:text-white cursor-pointer"
    },
    groupContainer: "",
    groupToggleWrapper: "",
    groupToggle: "",
    groupLabelWrapper: "",
    groupLabelFeedback: "",
    disabled: ""
  },
  // Variants
  variants: {
    // Used for Errors
    error: {
      classes: {
        wrapper: "",
        toggle: "focus:ring-offset-2 focus:ring-red-600",
        checked: "bg-red-600",
        unchecked: "bg-red-600/50 dark:bg-red-500/70",
        iconChecked: "text-red-600",
        iconUnchecked: "text-red-400",
        label: {
          label: "block font-medium text-sm text-gray-700 dark:text-white cursor-pointer"
        }
      }
    }
  }
};
const toggleClassesKeys = Object.keys(toggleConfig.classes);

const _hoisted_1$n = {
  viewBox: "0 0 256 256",
  width: "1.2em",
  height: "1.2em"
};
const _hoisted_2$j = /*#__PURE__*/createElementVNode("path", {
  fill: "currentColor",
  d: "m232.49 80.49l-128 128a12 12 0 0 1-17 0l-56-56a12 12 0 1 1 17-17L96 183L215.51 63.51a12 12 0 0 1 17 17Z"
}, null, -1);
const _hoisted_3$c = [
  _hoisted_2$j
];

function render$8(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$n, _hoisted_3$c))
}

const VanillaCheckedIcon = { name: 'ph-check-bold', render: render$8 };
/* vite-plugin-components disabled */

const _hoisted_1$m = ["id", "checked", "value", "disabled"];
const _hoisted_2$i = ["disabled"];
const __default__$j = {
  name: "VanillaToggle",
  inheritAttrs: false
};
const _sfc_main$l = /* @__PURE__ */ defineComponent({
  ...__default__$j,
  props: {
    ...useVariantProps$1(),
    modelValue: {
      type: [String, Number, Boolean, Array, Object, Date, Function, Symbol],
      default: void 0
    },
    checked: {
      type: [Boolean],
      default: false
    },
    value: {
      type: [String, Number, Boolean, Array, Object, Date, Function, Symbol, void 0],
      default: false
    },
    checkedValue: {
      type: [String, Number, Boolean, Array, Object, Date, Function, Symbol],
      default: true
    },
    uncheckedValue: {
      type: [String, Number, Boolean, Array, Object, Date, Function, Symbol],
      default: false
    },
    align: {
      type: [String],
      required: false,
      default: "left-top",
      validator(align) {
        return [
          "left-top",
          "left-center",
          "left-bottom",
          "right-top",
          "right-center",
          "right-bottom",
          "center-top",
          "center-center",
          "center-bottom"
        ].includes(align);
      }
    },
    icon: {
      type: [Boolean],
      default: true
    }
  },
  emits: ["update:modelValue", "updated:checked", "focus", "focusout", "click"],
  setup(__props, { emit }) {
    const props = __props;
    const root = ref(null);
    const localValue = useVModel(props, "modelValue");
    const emitUpdate = (event) => {
      const isChecked2 = event.target?.checked;
      if (Array.isArray(localValue.value)) {
        const newValue = [...localValue.value];
        if (isChecked2) {
          newValue.push(props.value);
        } else {
          newValue.splice(newValue.indexOf(props.value), 1);
        }
        localValue.value = newValue;
        return;
      }
      if (typeof localValue.value === "object" && localValue.value !== null) {
        const temporaryValue = props.value;
        const temporaryObject = localValue.value;
        if (isChecked2) {
          temporaryObject[temporaryValue] = true;
        } else {
          delete temporaryObject[temporaryValue];
        }
        localValue.value = temporaryObject;
        return;
      }
      const toggleValue = isChecked2 ? props.checkedValue : props.uncheckedValue;
      localValue.value = toggleValue;
    };
    const isChecked = computed(() => {
      if (Array.isArray(localValue.value) && typeof props.value === "string") {
        return localValue.value.includes(props.value);
      }
      return localValue.value === props.checkedValue;
    });
    const toggle = (event) => {
      if (props.disabled) {
        return;
      }
      root.value.click();
      emit("click", event);
    };
    const { configuration, errors, hasErrors } = useConfiguration(toggleConfig, "Toggle", localValue);
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass([
          unref(configuration).classesList.wrapper,
          __props.align === "left-top" ? unref(configuration).classesList.wrapperLeftTop : "",
          __props.align === "left-center" ? unref(configuration).classesList.wrapperLeftCenter : "",
          __props.align === "left-bottom" ? unref(configuration).classesList.wrapperLeftBottom : "",
          __props.align === "right-top" ? unref(configuration).classesList.wrapperRightTop : "",
          __props.align === "right-center" ? unref(configuration).classesList.wrapperRightCenter : "",
          __props.align === "right-bottom" ? unref(configuration).classesList.wrapperRightBottom : "",
          __props.align === "center-top" ? unref(configuration).classesList.wrapperCenterTop : "",
          __props.align === "center-center" ? unref(configuration).classesList.wrapperCenterCenter : "",
          __props.align === "center-bottom" ? unref(configuration).classesList.wrapperCenterBottom : ""
        ])
      }, [
        createElementVNode("input", {
          id: _ctx.name,
          ref_key: "root",
          ref: root,
          checked: unref(isChecked),
          value: __props.value,
          style: { "display": "none" },
          type: "checkbox",
          disabled: _ctx.disabled,
          onChange: emitUpdate
        }, null, 40, _hoisted_1$m),
        createElementVNode("button", mergeProps({
          ref: "input",
          "aria-pressed": "false",
          class: [
            unref(configuration).classesList.toggle,
            unref(isChecked) ? unref(configuration).classesList.checked : unref(configuration).classesList.unchecked,
            _ctx.disabled ? unref(configuration).classesList.disabled : ""
          ],
          disabled: _ctx.disabled,
          type: "button"
        }, _ctx.$attrs, {
          onFocus: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("focus", $event)),
          onFocusout: _cache[1] || (_cache[1] = ($event) => _ctx.$emit("focusout", $event)),
          onClick: toggle
        }), [
          createElementVNode("span", {
            class: normalizeClass([
              unref(configuration).classesList.iconWrapper,
              unref(isChecked) ? unref(configuration).classesList.transitionChecked : unref(configuration).classesList.transitionUnchecked
            ]),
            "aria-hidden": "true"
          }, [
            unref(isChecked) ? renderSlot(_ctx.$slots, "unchecked", {
              key: 0,
              isChecked: unref(isChecked)
            }, () => [
              __props.icon ? (openBlock(), createBlock(unref(VanillaCheckedIcon), {
                key: 0,
                class: normalizeClass(unref(configuration).classesList.iconChecked)
              }, null, 8, ["class"])) : createCommentVNode("", true)
            ]) : renderSlot(_ctx.$slots, "checked", {
              key: 1,
              isChecked: unref(isChecked)
            }, () => [
              __props.icon ? (openBlock(), createBlock(unref(CloseIcon), {
                key: 0,
                class: normalizeClass(unref(configuration).classesList.iconUnchecked)
              }, null, 8, ["class"])) : createCommentVNode("", true)
            ])
          ], 2)
        ], 16, _hoisted_2$i)
      ], 2);
    };
  }
});

const inputGroupConfig = {
  fixedClasses: {
    wrapper: "",
    container: "",
    containerWithPadding: "px-6 py-3.5",
    label: "",
    labelWrapperLeftTop: commonClasses.leftTop,
    labelWrapperLeftCenter: commonClasses.leftCenter,
    labelWrapperLeftBottom: commonClasses.leftBottom,
    labelWrapperRightTop: commonClasses.rightTop,
    labelWrapperRightCenter: commonClasses.rightCenter,
    labelWrapperRightBottom: commonClasses.rightBottom,
    labelWrapperCenterTop: commonClasses.centerTop,
    labelWrapperCenterCenter: commonClasses.centerCenter,
    labelWrapperCenterBottom: commonClasses.centerBottom,
    inputWrapper: ""
  },
  classes: {
    wrapper: "grid grid-col-1 gap-y-2",
    container: "block sm:grid gap-y-2",
    containerWithPadding: "",
    label: "",
    labelWrapper: "sm:mt-px sm:pt-0 flex items-center",
    labelWrapperLeftTop: "",
    labelWrapperLeftCenter: "",
    labelWrapperLeftBottom: "",
    labelWrapperRightTop: "",
    labelWrapperRightCenter: "",
    labelWrapperRightBottom: "",
    labelWrapperCenterTop: "",
    labelWrapperCenterCenter: "",
    labelWrapperCenterBottom: "",
    inputWrapper: "mt-0 grid grid-cols-1 gap-y-2"
  },
  variants: {
    inline: {
      classes: {
        wrapper: "sm:grid sm:grid-cols-3 sm:items-start sm:gap-4 content-center",
        labelWrapper: "flex items-center justify-start h-full",
        inputWrapper: "mt-1 sm:col-span-2 sm:mt-0 flex flex-col gap-y-2",
        label: ""
      }
    },
    content: {
      classes: {
        wrapper: "sm:grid",
        label: ""
      }
    }
  }
};
const inputGroupClassesKeys = Object.keys(inputGroupConfig.classes);

const _hoisted_1$l = {
  key: 0,
  class: "vc-errors-and-feedback"
};
const __default__$i = {
  name: "VanillaInputGroup",
  inheritAttrs: true
};
const _sfc_main$k = /* @__PURE__ */ defineComponent({
  ...__default__$i,
  props: {
    ...useVariantProps$1(),
    errors: {
      type: [String, Array, Object],
      default: void 0
    },
    feedback: {
      type: [String],
      default: void 0
    },
    label: {
      type: [String],
      default: void 0,
      required: false
    },
    name: {
      type: [String, void 0],
      default: void 0,
      required: false
    },
    for: {
      type: [String, void 0],
      default: void 0,
      required: false
    },
    showErrors: {
      type: Boolean,
      default: true,
      required: false
    },
    showFeedback: {
      type: Boolean,
      default: true,
      required: false
    },
    padding: {
      type: [Boolean],
      default: true,
      required: false
    },
    alignLabel: {
      type: [String],
      required: false,
      default: "left-center",
      validator(align) {
        return [
          "left-top",
          "left-center",
          "left-bottom",
          "right-top",
          "right-center",
          "right-bottom",
          "center-top",
          "center-center",
          "center-bottom"
        ].includes(align);
      }
    }
  },
  setup(__props) {
    const props = __props;
    const { configuration, errors, hasErrors, variant } = useConfiguration(inputGroupConfig, "InputGroup");
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass([
          unref(configuration).classesList.container,
          unref(configuration).padding ? unref(configuration).classesList.containerWithPadding : ""
        ])
      }, [
        createElementVNode("div", {
          class: normalizeClass(unref(configuration).classesList.wrapper)
        }, [
          __props.label || unref(hasSlot)(_ctx.$slots.label) ? (openBlock(), createElementBlock("div", {
            key: 0,
            class: normalizeClass([
              unref(configuration).classesList.labelWrapper,
              __props.alignLabel === "left-top" ? unref(configuration).classesList.labelWrapperLeftTop : "",
              __props.alignLabel === "left-center" ? unref(configuration).classesList.labelWrapperLeftCenter : "",
              __props.alignLabel === "left-bottom" ? unref(configuration).classesList.labelWrapperLeftBottom : "",
              __props.alignLabel === "right-top" ? unref(configuration).classesList.labelWrapperRightTop : "",
              __props.alignLabel === "right-center" ? unref(configuration).classesList.labelWrapperRightCenter : "",
              __props.alignLabel === "right-bottom" ? unref(configuration).classesList.labelWrapperRightBottom : "",
              __props.alignLabel === "center-top" ? unref(configuration).classesList.labelWrapperCenterTop : "",
              __props.alignLabel === "center-center" ? unref(configuration).classesList.labelWrapperCenterCenter : "",
              __props.alignLabel === "center-bottom" ? unref(configuration).classesList.labelWrapperCenterBottom : ""
            ])
          }, [
            renderSlot(_ctx.$slots, "label", {}, () => [
              __props.label !== void 0 ? (openBlock(), createBlock(_sfc_main$R, {
                key: 0,
                label: __props.label,
                for: props.for || __props.name
              }, {
                before: withCtx(() => [
                  renderSlot(_ctx.$slots, "label-before")
                ]),
                after: withCtx(() => [
                  renderSlot(_ctx.$slots, "label-after")
                ]),
                _: 3
              }, 8, ["label", "for"])) : createCommentVNode("", true)
            ])
          ], 2)) : createCommentVNode("", true),
          createElementVNode("div", {
            class: normalizeClass([
              unref(configuration).classesList.inputWrapper
            ])
          }, [
            unref(hasSlot)(_ctx.$slots.before) ? (openBlock(), createElementBlock("div", {
              key: 0,
              class: normalizeClass(unref(configuration).classesList.addonBefore)
            }, [
              renderSlot(_ctx.$slots, "before", normalizeProps(guardReactiveProps({ className: unref(configuration).classesList.addonClasses })))
            ], 2)) : createCommentVNode("", true),
            renderSlot(_ctx.$slots, "default", normalizeProps(guardReactiveProps({ label: __props.label, name: __props.name }))),
            unref(hasSlot)(_ctx.$slots.after) ? (openBlock(), createElementBlock("div", {
              key: 1,
              class: normalizeClass(unref(configuration).classesList.addonAfter)
            }, [
              renderSlot(_ctx.$slots, "after", normalizeProps(guardReactiveProps({ hasErrors: unref(hasErrors) })))
            ], 2)) : createCommentVNode("", true)
          ], 2)
        ], 2),
        unref(hasErrors) && __props.showErrors || __props.feedback !== void 0 && __props.showFeedback ? (openBlock(), createElementBlock("div", _hoisted_1$l, [
          renderSlot(_ctx.$slots, "errors", normalizeProps(guardReactiveProps({ hasErrors: unref(hasErrors), errors: unref(errors) })), () => [
            unref(hasErrors) && __props.showErrors ? (openBlock(), createBlock(_sfc_main$Z, {
              key: 0,
              errors: unref(errors)
            }, null, 8, ["errors"])) : createCommentVNode("", true)
          ]),
          renderSlot(_ctx.$slots, "feedback", normalizeProps(guardReactiveProps({ hasErrors: unref(hasErrors), feedback: __props.feedback })), () => [
            !unref(hasErrors) && __props.feedback !== void 0 && __props.showFeedback ? (openBlock(), createBlock(_sfc_main$Y, {
              key: 0,
              text: __props.feedback
            }, null, 8, ["text"])) : createCommentVNode("", true)
          ])
        ])) : createCommentVNode("", true)
      ], 2);
    };
  }
});

const __default__$h = {
  name: "VanillaFormSection",
  inheritAttrs: true
};
const _sfc_main$j = /* @__PURE__ */ defineComponent({
  ...__default__$h,
  props: {
    ...useVariantProps$1(),
    divided: {
      type: [Boolean],
      default: false,
      required: false
    },
    as: {
      type: [String],
      default: "div",
      required: false
    },
    spaced: {
      type: [Boolean],
      default: false,
      required: false
    },
    filled: {
      type: [Boolean],
      default: false,
      required: false
    }
  },
  setup(__props) {
    const props = __props;
    const { configuration } = useConfiguration(formsConfig, "FormSection");
    return (_ctx, _cache) => {
      return openBlock(), createBlock(resolveDynamicComponent(props.as), {
        class: normalizeClass(["form-section", [
          props.filled ? unref(configuration).classesList.sectionFilled : "",
          props.divided ? unref(configuration).classesList.sectionDivided : "",
          props.spaced ? unref(configuration).classesList.sectionSpaced : ""
        ]])
      }, {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 8, ["class"]);
    };
  }
});

const _hoisted_1$k = {
  viewBox: "0 0 24 24",
  width: "1.2em",
  height: "1.2em"
};
const _hoisted_2$h = /*#__PURE__*/createElementVNode("path", {
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.5",
  d: "m14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0"
}, null, -1);
const _hoisted_3$b = [
  _hoisted_2$h
];

function render$7(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$k, _hoisted_3$b))
}

const TrashIcon = { name: 'heroicons-trash', render: render$7 };
/* vite-plugin-components disabled */

const _hoisted_1$j = ["textContent"];
const __default__$g = {
  name: "VanillaDatatableSettingsDialog"
};
const _sfc_main$i = /* @__PURE__ */ defineComponent({
  ...__default__$g,
  props: {
    userSettings: {
      type: [Object],
      required: true
    },
    defaultSettings: {
      type: [Object],
      required: true
    },
    perPageOptions: {
      type: [Object, Array],
      required: true
    },
    columns: {
      type: [Array],
      required: true
    }
  },
  emits: [
    "update:modelValue",
    "update:settings",
    "settingsReset"
  ],
  setup(__props, { emit }) {
    const props = __props;
    const isOpen = ref(false);
    const localSettings = ref(props.userSettings);
    const columnsNormalized = computed(() => {
      const columns = [];
      props.columns.forEach((column) => {
        columns.push({
          text: column.label,
          value: column.name
        });
      });
      return columns;
    });
    const saveSettings = () => {
      isOpen.value = false;
      emit("update:settings", localSettings.value);
    };
    const resetSettings = () => {
      isOpen.value = false;
      emit("settingsReset", true);
    };
    watch(isOpen, (val) => {
      emit("update:modelValue", val);
    });
    const translations = injectTranslations();
    const classesList = useInjectsClassesList("configuration_vanilla_datatable");
    return (_ctx, _cache) => {
      return openBlock(), createBlock(_sfc_main$n, {
        modelValue: isOpen.value,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => isOpen.value = $event),
        title: unref(translations).settings,
        as: "form",
        size: "medium",
        "body-darker": true,
        onSubmit: withModifiers(saveSettings, ["prevent"])
      }, {
        footer: withCtx(() => [
          createVNode(_sfc_main$X, {
            tabindex: "2",
            type: "submit",
            label: unref(translations).settingsSaveAndClose
          }, null, 8, ["label"])
        ]),
        default: withCtx(() => [
          createVNode(_sfc_main$j, { divided: "" }, {
            default: withCtx(() => [
              createVNode(_sfc_main$k, {
                label: unref(translations).settingsItemsPerPage,
                name: "perPage",
                variant: "inline"
              }, {
                default: withCtx(() => [
                  createVNode(_sfc_main$L, {
                    modelValue: unref(localSettings).perPage,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => unref(localSettings).perPage = $event),
                    options: __props.perPageOptions,
                    placeholder: unref(translations).selectOption
                  }, null, 8, ["modelValue", "options", "placeholder"])
                ]),
                _: 1
              }, 8, ["label"]),
              createVNode(_sfc_main$k, {
                label: unref(translations).settingsVisibility,
                name: "hiddenColumns"
              }, {
                default: withCtx(() => [
                  createVNode(_sfc_main$Q, {
                    modelValue: unref(localSettings).hiddenColumns,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => unref(localSettings).hiddenColumns = $event),
                    options: unref(columnsNormalized)
                  }, null, 8, ["modelValue", "options"])
                ]),
                _: 1
              }, 8, ["label"]),
              createVNode(_sfc_main$k, {
                label: unref(translations).settingsItemsPerPage,
                name: "useStorage",
                variant: "inline"
              }, {
                default: withCtx(() => [
                  createVNode(_sfc_main$l, {
                    modelValue: unref(localSettings).useStorage,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => unref(localSettings).useStorage = $event)
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"]),
              createVNode(_sfc_main$k, {
                label: unref(translations).settingsPersistSelection,
                name: "saveSelection",
                variant: "inline"
              }, {
                default: withCtx(() => [
                  createVNode(_sfc_main$l, {
                    modelValue: unref(localSettings).saveSelection,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => unref(localSettings).saveSelection = $event)
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"]),
              createVNode(_sfc_main$k, {
                variant: "content",
                "with-padding": ""
              }, {
                default: withCtx(() => [
                  createElementVNode("span", {
                    class: normalizeClass([unref(classesList).genericFormsContentContainer]),
                    onClick: resetSettings
                  }, [
                    createVNode(unref(TrashIcon), {
                      class: normalizeClass([unref(classesList).genericFormsContentIcons])
                    }, null, 8, ["class"]),
                    createElementVNode("span", {
                      textContent: toDisplayString(unref(translations).settingsReset)
                    }, null, 8, _hoisted_1$j)
                  ], 2)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue", "title", "onSubmit"]);
    };
  }
});

const _hoisted_1$i = ["textContent"];
const _hoisted_2$g = ["textContent"];
const _hoisted_3$a = ["textContent"];
const _hoisted_4$3 = ["textContent"];
const __default__$f = {
  name: "VanillaDatatableFiltersDialog"
};
const _sfc_main$h = /* @__PURE__ */ defineComponent({
  ...__default__$f,
  props: {
    filters: {
      type: [Array],
      required: true
    },
    userSettings: {
      type: [Object],
      required: true
    },
    configuration: {
      type: [Object],
      required: true
    }
  },
  emits: [
    "update:modelValue",
    "filtersSaved",
    "filtersReset"
  ],
  setup(__props, { emit }) {
    const props = __props;
    const Select = defineAsyncComponent(() => import('./select-5f34b781.js'));
    const RichSelect = defineAsyncComponent(() => import('./rich-select-36c03496.js'));
    const Checkbox = defineAsyncComponent(() => import('./checkbox-17850485.js'));
    const Toggle = defineAsyncComponent(() => import('./toggle-db86e4f5.js'));
    const VanillaInput = defineAsyncComponent(() => import('./input-a2226485.js'));
    const Textarea = defineAsyncComponent(() => import('./textarea-245453cf.js'));
    const DateTimeInput = defineAsyncComponent(() => import('./datetime-input-41121008.js'));
    const isOpen = ref(false);
    const localFilters = ref({});
    const resetUrl = inject("datatable_reset_url_function");
    watch(
      () => props.userSettings.filters,
      (newValue) => {
        localFilters.value = { ...newValue };
      },
      { deep: true }
    );
    const getFilterDefaultValue = (name) => {
      return find$1(props.filters, { name })?.defaultValue || null;
    };
    const cleanupEmptyFilters = (filters) => {
      return Object.fromEntries(Object.entries(filters).filter(([key, v]) => {
        if (v === null && v === "") {
          return false;
        }
        if (Array.isArray(v) && v.length <= 0) {
          return false;
        }
        if (typeof v === "object" && Object.keys(v).length <= 0) {
          return false;
        }
        return v !== getFilterDefaultValue(key);
      }));
    };
    const saveSettings = () => {
      isOpen.value = false;
      if (Object.keys(localFilters).length > 0 && !isEqual$1(localFilters.value, props.userSettings.filters)) {
        localFilters.value = cleanupEmptyFilters(localFilters.value);
        emit("filtersSaved", { ...localFilters.value });
      }
    };
    const resetFilters = () => {
      isOpen.value = false;
      localFilters.value = {};
      resetUrl();
      emit("filtersReset", true);
    };
    const { text, copy, copied, isSupported } = useClipboard();
    const copyFiltersLink = () => {
      if (isServer()) {
        return;
      }
      const filtersKey = camelize(`${props.configuration.name}`);
      const query = {
        [filtersKey]: props.configuration.options.filtersHashingMethod === "query" ? localFilters.value : Base64$1.encode(JSON.stringify(localFilters.value))
      };
      const finalUrl = urlHelper(window.location.href, query);
      copy(finalUrl);
    };
    watch(isOpen, (val) => {
      emit("update:modelValue", val);
    });
    const translations = injectTranslations();
    const classesList = useInjectsClassesList("configuration_vanilla_datatable");
    return (_ctx, _cache) => {
      return openBlock(), createBlock(_sfc_main$n, {
        modelValue: unref(isOpen),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => isRef(isOpen) ? isOpen.value = $event : null),
        title: unref(translations).filters,
        "body-darker": true,
        as: "form",
        size: "medium",
        onSubmit: withModifiers(saveSettings, ["prevent"])
      }, {
        footer: withCtx(() => [
          createVNode(_sfc_main$X, {
            tabindex: "2",
            type: "submit",
            label: unref(translations).filtersSaveAndClose
          }, null, 8, ["label"])
        ]),
        default: withCtx(() => [
          createVNode(_sfc_main$j, { divided: "" }, {
            default: withCtx(() => [
              (openBlock(true), createElementBlock(Fragment, null, renderList(__props.filters, (filter) => {
                return openBlock(), createBlock(_sfc_main$k, {
                  key: filter.name,
                  label: filter.label,
                  name: filter.name,
                  variant: filter.layout || "inline"
                }, {
                  default: withCtx(() => [
                    filter.component === "VanillaSelect" ? (openBlock(), createBlock(unref(Select), mergeProps({
                      key: 0,
                      modelValue: unref(localFilters)[filter.name],
                      "onUpdate:modelValue": ($event) => unref(localFilters)[filter.name] = $event,
                      options: filter.options
                    }, filter?.props, {
                      "show-empty": true,
                      feedback: filter?.feedback,
                      errors: filter?.errors
                    }), null, 16, ["modelValue", "onUpdate:modelValue", "options", "feedback", "errors"])) : createCommentVNode("", true),
                    filter.component === "VanillaRichSelect" ? (openBlock(), createBlock(unref(RichSelect), mergeProps({
                      key: 1,
                      modelValue: unref(localFilters)[filter.name],
                      "onUpdate:modelValue": ($event) => unref(localFilters)[filter.name] = $event,
                      placeholder: filter?.placeholder,
                      "fetch-endpoint": filter?.fetchEndpoint,
                      "value-attribute": filter?.valueAttribute,
                      "text-attribute": filter?.textAttribute,
                      options: filter.options,
                      feedback: filter?.feedback,
                      errors: filter?.errors
                    }, filter?.props, {
                      teleport: true,
                      multiple: filter?.multiple
                    }), null, 16, ["modelValue", "onUpdate:modelValue", "placeholder", "fetch-endpoint", "value-attribute", "text-attribute", "options", "feedback", "errors", "multiple"])) : createCommentVNode("", true),
                    filter.component === "VanillaInput" ? (openBlock(), createBlock(unref(VanillaInput), mergeProps({
                      key: 2,
                      modelValue: unref(localFilters)[filter.name],
                      "onUpdate:modelValue": ($event) => unref(localFilters)[filter.name] = $event,
                      placeholder: filter?.placeholder
                    }, filter?.props, {
                      feedback: filter?.feedback,
                      errors: filter?.errors
                    }), null, 16, ["modelValue", "onUpdate:modelValue", "placeholder", "feedback", "errors"])) : createCommentVNode("", true),
                    filter.component === "VanillaCheckbox" ? (openBlock(), createBlock(unref(Checkbox), mergeProps({
                      key: 3,
                      modelValue: unref(localFilters)[filter.name],
                      "onUpdate:modelValue": ($event) => unref(localFilters)[filter.name] = $event,
                      placeholder: filter?.placeholder
                    }, filter?.props, {
                      feedback: filter?.feedback,
                      errors: filter?.errors
                    }), null, 16, ["modelValue", "onUpdate:modelValue", "placeholder", "feedback", "errors"])) : createCommentVNode("", true),
                    filter.component === "VanillaToggle" ? (openBlock(), createBlock(unref(Toggle), mergeProps({
                      key: 4,
                      modelValue: unref(localFilters)[filter.name],
                      "onUpdate:modelValue": ($event) => unref(localFilters)[filter.name] = $event,
                      placeholder: filter?.placeholder
                    }, filter?.props, {
                      feedback: filter?.feedback,
                      errors: filter?.errors
                    }), null, 16, ["modelValue", "onUpdate:modelValue", "placeholder", "feedback", "errors"])) : createCommentVNode("", true),
                    filter.component === "VanillaTextarea" ? (openBlock(), createBlock(unref(Textarea), mergeProps({
                      key: 5,
                      modelValue: unref(localFilters)[filter.name],
                      "onUpdate:modelValue": ($event) => unref(localFilters)[filter.name] = $event,
                      placeholder: filter?.placeholder
                    }, filter?.props, {
                      feedback: filter?.feedback,
                      errors: filter?.errors
                    }), null, 16, ["modelValue", "onUpdate:modelValue", "placeholder", "feedback", "errors"])) : createCommentVNode("", true),
                    filter.component === "VanillaDatetimePicker" ? (openBlock(), createBlock(unref(DateTimeInput), mergeProps({
                      key: 6,
                      modelValue: unref(localFilters)[filter.name],
                      "onUpdate:modelValue": ($event) => unref(localFilters)[filter.name] = $event,
                      placeholder: filter?.placeholder
                    }, filter?.props, {
                      feedback: filter?.feedback,
                      errors: filter?.errors
                    }), null, 16, ["modelValue", "onUpdate:modelValue", "placeholder", "feedback", "errors"])) : createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1032, ["label", "name", "variant"]);
              }), 128)),
              createVNode(_sfc_main$k, { variant: "content" }, {
                default: withCtx(() => [
                  createElementVNode("div", {
                    class: normalizeClass([unref(classesList).genericFormsContentContainer])
                  }, [
                    createElementVNode("span", {
                      class: normalizeClass([unref(classesList).genericFormsContentLink]),
                      onClick: resetFilters
                    }, [
                      createVNode(unref(TrashIcon), {
                        class: normalizeClass([unref(classesList).genericFormsContentIcons])
                      }, null, 8, ["class"]),
                      createElementVNode("span", {
                        textContent: toDisplayString(unref(translations).filtersReset)
                      }, null, 8, _hoisted_1$i)
                    ], 2),
                    createElementVNode("span", {
                      textContent: toDisplayString(unref(translations).filtersResetOr)
                    }, null, 8, _hoisted_2$g),
                    !unref(copied) ? (openBlock(), createBlock(unref(ClipboardIcon), {
                      key: 0,
                      class: normalizeClass([unref(classesList).genericFormsContentIcons])
                    }, null, 8, ["class"])) : createCommentVNode("", true),
                    unref(copied) ? (openBlock(), createBlock(unref(CheckIcon), {
                      key: 1,
                      class: normalizeClass([unref(classesList).genericFormsContentIcons])
                    }, null, 8, ["class"])) : createCommentVNode("", true),
                    !unref(copied) ? (openBlock(), createElementBlock("span", {
                      key: 2,
                      class: normalizeClass([unref(classesList).genericFormsContentLink]),
                      onClick: copyFiltersLink,
                      textContent: toDisplayString(unref(translations).filtersCopy)
                    }, null, 10, _hoisted_3$a)) : createCommentVNode("", true),
                    unref(copied) ? (openBlock(), createElementBlock("span", {
                      key: 3,
                      class: normalizeClass([unref(classesList).genericFormsContentLink]),
                      onClick: copyFiltersLink,
                      textContent: toDisplayString(unref(translations).filtersCopied)
                    }, null, 10, _hoisted_4$3)) : createCommentVNode("", true)
                  ], 2)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue", "title", "onSubmit"]);
    };
  }
});

const _hoisted_1$h = ["innerHTML"];
const _hoisted_2$f = ["textContent"];
const _hoisted_3$9 = ["textContent"];
const _hoisted_4$2 = /* @__PURE__ */ createElementVNode("path", {
  "stroke-linecap": "round",
  "stroke-width": "1.5",
  d: "M1 1l6 6m0-6L1 7"
}, null, -1);
const _hoisted_5$2 = [
  _hoisted_4$2
];
const __default__$e = {
  name: "VanillaDatatableFilterBadge"
};
const _sfc_main$g = /* @__PURE__ */ defineComponent({
  ...__default__$e,
  props: {
    filter: {
      type: [Object, Array],
      required: true
    },
    value: {
      type: [Number, String, Array, Object],
      required: true
    },
    withLabel: {
      type: [Boolean],
      default: true,
      required: false
    }
  },
  emits: ["filterRemove"],
  setup(__props, { emit }) {
    const classesList = useInjectsClassesList("configuration_vanilla_datatable");
    const translations = injectTranslations();
    const translateFilterValue = (filter) => {
      if (filter?.options !== void 0 && !(typeof filter.value == "object" && Object.keys(filter.value).length > 0)) {
        let value = filter.value;
        if (value === "true" || value === "false") {
          value = value === "true";
        }
        const selectedOption = find$1(filter.options, { value });
        return selectedOption?.text || filter.value;
      }
      if (Array.isArray(filter?.value) && filter?.value.length > 0) {
        return filter.value.join(",");
      }
      return filter.value;
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass([unref(classesList).filtersBadge])
      }, [
        renderSlot(_ctx.$slots, "default", {}, () => [
          createElementVNode("div", {
            class: normalizeClass([unref(classesList).filtersBadgeLabel])
          }, [
            __props.withLabel && __props.filter?.label ? (openBlock(), createElementBlock("span", {
              key: 0,
              innerHTML: `${__props.filter.label}: `
            }, null, 8, _hoisted_1$h)) : createCommentVNode("", true),
            createElementVNode("span", {
              textContent: toDisplayString(translateFilterValue(__props.filter))
            }, null, 8, _hoisted_2$f)
          ], 2)
        ]),
        createElementVNode("button", {
          type: "button",
          class: normalizeClass([unref(classesList).filtersBadgeRemoveButton]),
          onClick: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("filterRemove"))
        }, [
          createElementVNode("span", {
            class: "sr-only",
            textContent: toDisplayString(unref(translations).filtersRemove)
          }, null, 8, _hoisted_3$9),
          (openBlock(), createElementBlock("svg", {
            class: normalizeClass([unref(classesList).filtersBadgeRemoveIcon]),
            stroke: "currentColor",
            fill: "none",
            viewBox: "0 0 8 8"
          }, _hoisted_5$2, 2))
        ], 2)
      ], 2);
    };
  }
});

const _hoisted_1$g = {
  viewBox: "0 0 48 48",
  width: "1.2em",
  height: "1.2em"
};
const _hoisted_2$e = /*#__PURE__*/createStaticVNode("<circle cx=\"24\" cy=\"24\" r=\"21.5\" fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></circle><path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M11.07 14.58a16 16 0 1 0 3.51-3.51\"></path><path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M15.42 29a9.93 9.93 0 1 1 16.56.89M29.85 32a9.93 9.93 0 0 1-10.87.58\"></path><circle cx=\"23.979\" cy=\"24\" r=\"4.43\" fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></circle><circle cx=\"12.69\" cy=\"12.69\" r=\"2.5\" fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></circle><circle cx=\"17.049\" cy=\"30.93\" r=\"2.5\" fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></circle><circle cx=\"30.909\" cy=\"30.94\" r=\"1.5\" fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></circle>", 7);
const _hoisted_9$1 = [
  _hoisted_2$e
];

function render$6(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$g, _hoisted_9$1))
}

const RadarIcon = { name: 'arcticons-canadaradar', render: render$6 };
/* vite-plugin-components disabled */

const _hoisted_1$f = {
  viewBox: "0 0 24 24",
  width: "1.2em",
  height: "1.2em"
};
const _hoisted_2$d = /*#__PURE__*/createElementVNode("g", {
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2"
}, [
  /*#__PURE__*/createElementVNode("path", { d: "M16.95 9.01c3.02.739 5.05 2.123 5.05 3.714C22 15.091 17.52 17 12 17S2 15.091 2 12.724C2 11.134 4.04 9.739 7.07 9" }),
  /*#__PURE__*/createElementVNode("path", { d: "M7 9c0 1.105 2.239 2 5 2s5-.895 5-2v-.035C17 6.223 14.761 4 12 4S7 6.223 7 8.965V9m8 8l2 3m-8.5-3L7 20m5-6h.01M7 13h.01M17 13h.01" })
], -1);
const _hoisted_3$8 = [
  _hoisted_2$d
];

function render$5(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$f, _hoisted_3$8))
}

const UFOIcon = { name: 'tabler-ufo', render: render$5 };
/* vite-plugin-components disabled */

const _hoisted_1$e = {
  viewBox: "0 0 24 24",
  width: "1.2em",
  height: "1.2em"
};
const _hoisted_2$c = /*#__PURE__*/createElementVNode("path", {
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.5",
  d: "M12 3c2.755 0 5.455.232 8.083.678c.533.09.917.556.917 1.096v1.044a2.25 2.25 0 0 1-.659 1.591l-5.432 5.432a2.25 2.25 0 0 0-.659 1.591v2.927a2.25 2.25 0 0 1-1.244 2.013L9.75 21v-6.568a2.25 2.25 0 0 0-.659-1.591L3.659 7.409A2.25 2.25 0 0 1 3 5.818V4.774c0-.54.384-1.006.917-1.096A48.32 48.32 0 0 1 12 3Z"
}, null, -1);
const _hoisted_3$7 = [
  _hoisted_2$c
];

function render$4(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$e, _hoisted_3$7))
}

const FunnelIcon = { name: 'heroicons-funnel', render: render$4 };
/* vite-plugin-components disabled */

const _hoisted_1$d = ["textContent"];
const _hoisted_2$b = ["textContent"];
const _hoisted_3$6 = ["textContent"];
const __default__$d = {
  name: "VanillaDatatableEmptyState"
};
const _sfc_main$f = /* @__PURE__ */ defineComponent({
  ...__default__$d,
  props: {
    hasFiltersOrSearch: {
      type: Boolean,
      default: false
    },
    isFetching: {
      type: Boolean,
      default: false
    }
  },
  emits: [
    "resetFilters",
    "actionWithoutRecords"
  ],
  setup(__props, { emit }) {
    const translations = injectTranslations();
    const classesList = useInjectsClassesList("configuration_vanilla_datatable");
    const isLocallyLoading = ref(false);
    const resetFilters = () => {
      isLocallyLoading.value = true;
      emit("resetFilters");
      nextTick(() => {
        isLocallyLoading.value = false;
      });
    };
    const actionWithoutRecords = () => emit("actionWithoutRecords");
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass([unref(classesList).emptyStateContainer])
      }, [
        __props.hasFiltersOrSearch ? renderSlot(_ctx.$slots, "emptyWithFilters", { key: 0 }, () => [
          createElementVNode("div", {
            class: normalizeClass([unref(classesList).emptyStateInner])
          }, [
            createElementVNode("div", {
              class: normalizeClass([unref(classesList).emptyStateRow])
            }, [
              renderSlot(_ctx.$slots, "emptyWithFiltersIcon", {}, () => [
                createVNode(unref(UFOIcon), {
                  class: normalizeClass([unref(classesList).emptyStateIcon])
                }, null, 8, ["class"])
              ])
            ], 2),
            createElementVNode("div", {
              class: normalizeClass([unref(classesList).emptyStateRow])
            }, [
              renderSlot(_ctx.$slots, "emptyWithFiltersTitle", {}, () => [
                createElementVNode("h3", {
                  class: normalizeClass([unref(classesList).emptyStateTitle]),
                  textContent: toDisplayString(unref(translations).recordsEmptyWithFiltersOrSearch)
                }, null, 10, _hoisted_1$d)
              ])
            ], 2),
            createElementVNode("div", {
              class: normalizeClass([unref(classesList).emptyStateRow]),
              onClick: resetFilters
            }, [
              renderSlot(_ctx.$slots, "emptyWithFiltersButton", {}, () => [
                createVNode(_sfc_main$X, {
                  variant: unref(classesList).emptyStateResetFiltersButtonVariant,
                  loading: __props.isFetching || isLocallyLoading.value
                }, {
                  icon: withCtx(() => [
                    createVNode(unref(FunnelIcon), {
                      class: normalizeClass(unref(classesList).emptyStateResetFiltersButtonIcon)
                    }, null, 8, ["class"])
                  ]),
                  label: withCtx(() => [
                    createElementVNode("span", {
                      textContent: toDisplayString(unref(translations).recordsEmptyWithFiltersOrSearchAction)
                    }, null, 8, _hoisted_2$b)
                  ]),
                  _: 1
                }, 8, ["variant", "loading"])
              ])
            ], 2)
          ], 2)
        ]) : renderSlot(_ctx.$slots, "emptyWithoutRecords", { key: 1 }, () => [
          createElementVNode("div", {
            class: normalizeClass([unref(classesList).emptyStateInner])
          }, [
            createElementVNode("div", {
              class: normalizeClass([unref(classesList).emptyStateRow])
            }, [
              renderSlot(_ctx.$slots, "emptyWithoutRecordsIcon", {}, () => [
                createVNode(unref(RadarIcon), {
                  class: normalizeClass([unref(classesList).emptyStateIcon])
                }, null, 8, ["class"])
              ])
            ], 2),
            createElementVNode("div", {
              class: normalizeClass([unref(classesList).emptyStateRow])
            }, [
              renderSlot(_ctx.$slots, "emptyWithoutRecordsTitle", {}, () => [
                createElementVNode("h3", {
                  class: normalizeClass([unref(classesList).emptyStateTitle]),
                  textContent: toDisplayString(unref(translations).recordsEmpty)
                }, null, 10, _hoisted_3$6)
              ])
            ], 2),
            createElementVNode("div", {
              class: normalizeClass([unref(classesList).emptyStateRow]),
              onClick: actionWithoutRecords
            }, [
              renderSlot(_ctx.$slots, "emptyWithoutRecordsButton")
            ], 2)
          ], 2)
        ])
      ], 2);
    };
  }
});

const datatableConfig = {
  fixedClasses: {},
  // Default appearance
  classes: {
    cardVariant: "",
    genericForbidden: "cursor-not-allowed",
    genericPointer: "cursor-pointer",
    genericFormsContentContainer: "flex items-center justify-center space-x-1 text-xs select-none cursor-pointer dark:text-white",
    genericFormsContentLink: "underline flex items-center justify-center space-x-1",
    genericFormsContentIcons: "h-4 w-4",
    actionsContainer: "inline-flex",
    actionsButtonVariant: "primary",
    actionsButtonCount: "ml-1 text-xxs text-white xxs:hidden",
    headerFiltersContainer: "inline-flex",
    headerFiltersIcon: "h-4 h-4 sm:mr-1",
    headerFiltersLabel: "hidden sm:block",
    headerFiltersCount: "ml-1 text-xxs",
    headerSettingsContainer: "inline-flex",
    headerSettingsIcon: "h-4 w-4",
    headerSettingsRefreshIcon: "h-4 h-4",
    headerSettingsRefreshIconAnimation: "animate-spin",
    headerSettingsEditIcon: "h-4 h-4",
    headerSettingsSearchIcon: "h-4 h-4",
    searchContainer: "px-5 mt-3 mb-3",
    searchInputVariant: "compact",
    searchInputClasses: "",
    searchIcon: "-mr-2 h-4 w-4 text-gray-400",
    filtersBarContainer: "px-5 mt-2 my-3",
    filtersBarInner: "flex items-center space-x-1 text-xs",
    filtersBarBadgesContainer: "flex flex-wrap items-center gap-1",
    filtersBadge: "flex-shrink-0 inline-flex items-center py-0.5 pl-2 pr-0.5 rounded-full text-xs font-medium bg-primary-100 text-primary-700",
    filtersBadgeLabel: "flex space-x-1",
    filtersBadgeRemoveButton: "flex-shrink-0 ml-0.5 h-4 w-4 rounded-full inline-flex items-center justify-center text-primary-400 hover:bg-primary-200 hover:text-primary-500 focus:outline-none focus:bg-primary-500 focus:text-white",
    filtersBadgeRemoveIcon: "h-2 w-2",
    selectionBarContainer: "px-6 sm:px-8 py-3 bg-primary-100/50 dark:bg-primary-500 items-center text-left text-xs text-primary-900 dark:text-white space-x-1 space-y-1 sm:space-y-0 flex flex-col sm:flex-row",
    selectionBarButton: "cursor-pointer inline-flex items-center rounded-md bg-transparent text-xs font-semibold focus:outline-none focus:underline",
    selectionBarOrText: "hidden sm:inline mx-1",
    emptyStateContainer: "flex items-center justify-center text-center bg-gray-50 px-6 py-8 dark:bg-gray-800",
    emptyStateRow: "flex items-center justify-center",
    emptyStateIcon: "text-gray-200 w-28 h-28",
    emptyStateInner: "text-sm w-full space-y-2",
    emptyStateTitle: "text-small text-gray-500 mb-3 mt-3",
    emptyStateText: "",
    emptyStateResetFiltersButtonVariant: "primary",
    emptyStateResetFiltersButtonIcon: "h-4 w-4",
    tableContainer: "datatable overflow-x-auto dark:border-gray-700",
    tableContainerBorder: "border-t",
    tableClass: "min-w-full m-0 table-fixed",
    tableBody: "divide-y bg-gray-50 dark:bg-gray-800 divide-gray-200 dark:divide-gray-700/90",
    tableRow: "",
    tableColumn: "whitespace-nowrap py-2 pr-2 text-sm text-gray-500 dark:text-white",
    tableColumnCheckbox: "px-6 py-3 text-sm w-[10px]",
    tableCheckbox: "rounded border-gray-300 text-primary-600 focus:ring-indigo-500 block transition duration-150 ease-in-out dark:focus:ring-offset-gray-900 dark:border-gray-600 dark:bg-gray-900 dark:checked:bg-primary-600 h-4 w-4",
    tableIdColumn: "w-[60px]",
    tableHeadColumnCheckbox: "bg-gray-100 text-left text-xs px-6 py-3 leading-4 font-medium text-gray-500 uppercase tracking-wider whitespace-nowrap dark:bg-gray-700",
    tableHeadCheckbox: "",
    // Inherits main checkbox.
    tableHeadColumn: "py-3 bg-gray-100 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider whitespace-nowrap dark:bg-gray-700 dark:text-white",
    tableHeadColumnContainer: "group inline-flex",
    tableHeadColumnSortContainer: "ml-2 flex-none rounded",
    tableHeadColumnLabel: "",
    tableHeadColumnSorted: "bg-gray-200 dark:bg-gray-800 text-gray-900 dark:text-gray-200 group-hover:bg-gray-300 dark:group-hover:bg-gray-600",
    tableHeadColumnNotSorted: "invisible group-focus:visible text-gray-400 group-hover:visible",
    tableHeadColumnSortedIcon: "text-gray-400 group-hover:visible group-focus:visible invisible",
    tableHeadColumnSortedIconClasses: "h-4 w-4 flex-none rounded",
    actionIconContainer: "mx-auto flex flex-shrink-0  items-center justify-center h-12 w-12 rounded-full",
    actionIcon: "h-6 w-6",
    actionIconContainerDanger: "bg-red-100",
    actionIconContainerSuccess: "bg-green-100",
    actionIconContainerWarning: "bg-yellow-100",
    actionIconContainerInfo: "bg-blue-100",
    actionIconDanger: "text-red-600",
    actionIconSuccess: "text-green-600",
    actionIconWarning: "text-yellow-600",
    actionIconInfo: "text-blue-600",
    actionsContentContainer: "mt-3 text-center sm:mt-5",
    actionsTitle: "text-lg leading-6 font-medium text-gray-900 dark:text-white",
    actionsText: "mt-2 text-sm leading-5 text-gray-600 dark:text-gray-300",
    paginationContainer: "px-4 py-3 flex items-center justify-between border-gray-200 border-t sm:px-6 dark:border-gray-700",
    paginationShortContainer: "flex-1 flex justify-between sm:hidden",
    paginationShortIcon: "h-5 w-5",
    paginationShortLeft: "mr-2",
    paginationShortRight: "ml-2",
    paginationFullContainer: "hidden sm:flex-1 sm:flex sm:items-center sm:justify-between",
    paginationFullNumberOfRecords: "text-sm leading-5 text-gray-700 dark:text-gray-400",
    paginationFullButtonsContainer: "relative z-0 inline-flex shadow-sm cursor-pointer",
    paginationFullIcon: "h-6 w-5",
    paginationFullLeft: "rounded-l-md rounded-r-none focus:ring-0",
    paginationFullRight: "-ml-px rounded-r-md rounded-l-none focus:ring-0",
    paginationFullPage: "focus:bg-gray-300/10",
    paginationFullPageActive: "bg-primary-50 text-primary-600",
    skeletonTableBody: "bg-white dark:bg-gray-800 divide-y divide-gray-200 dark:divide-gray-700",
    skeletonTableColumn: "py-2 pr-3 whitespace-nowrap leading-5",
    skeletonPlaceholder: mergeClasses(
      "inline relative after:content-[''] after:absolute after:-inset-0.5 after:animate-pulse after:h-5 after:w-full after:min-w-[2rem] after:rounded after:transition-all after:duration-500 after:inline-block",
      "after:bg-gradient-to-r",
      "after:from-gray-100 after:to-gray-200",
      "dark:after:from-gray-500 dark:after:to-gray-700"
    )
  }
};
const datatableClassesKeys = Object.keys(datatableConfig.classes);

const _hoisted_1$c = {
  viewBox: "0 0 24 24",
  width: "1.2em",
  height: "1.2em"
};
const _hoisted_2$a = /*#__PURE__*/createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M4.755 10.059a7.5 7.5 0 0 1 12.548-3.364l1.903 1.903h-3.183a.75.75 0 1 0 0 1.5h4.992a.75.75 0 0 0 .75-.75V4.356a.75.75 0 0 0-1.5 0v3.18l-1.9-1.9A9 9 0 0 0 3.306 9.67a.75.75 0 1 0 1.45.388Zm15.408 3.352a.75.75 0 0 0-.919.53a7.5 7.5 0 0 1-12.548 3.364l-1.902-1.903h3.183a.75.75 0 0 0 0-1.5H2.984a.75.75 0 0 0-.75.75v4.992a.75.75 0 0 0 1.5 0v-3.18l1.9 1.9a9 9 0 0 0 15.059-4.035a.75.75 0 0 0-.53-.918Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3$5 = [
  _hoisted_2$a
];

function render$3(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$c, _hoisted_3$5))
}

const ArrowPathIcon = { name: 'heroicons-arrow-path-solid', render: render$3 };
/* vite-plugin-components disabled */

const _hoisted_1$b = {
  viewBox: "0 0 24 24",
  width: "1.2em",
  height: "1.2em"
};
const _hoisted_2$9 = /*#__PURE__*/createElementVNode("g", {
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.5"
}, [
  /*#__PURE__*/createElementVNode("path", { d: "M10.343 3.94c.09-.542.56-.94 1.11-.94h1.093c.55 0 1.02.398 1.11.94l.149.894c.07.424.384.764.78.93c.398.164.855.142 1.205-.108l.737-.527a1.125 1.125 0 0 1 1.45.12l.773.774c.39.389.44 1.002.12 1.45l-.527.737c-.25.35-.272.806-.107 1.204c.165.397.505.71.93.78l.893.15c.543.09.94.56.94 1.109v1.094c0 .55-.397 1.02-.94 1.11l-.893.149c-.425.07-.765.383-.93.78c-.165.398-.143.854.107 1.204l.527.738c.32.447.269 1.06-.12 1.45l-.774.773a1.125 1.125 0 0 1-1.449.12l-.738-.527c-.35-.25-.806-.272-1.203-.107c-.397.165-.71.505-.781.929l-.149.894c-.09.542-.56.94-1.11.94h-1.094c-.55 0-1.019-.398-1.11-.94l-.148-.894c-.071-.424-.384-.764-.781-.93c-.398-.164-.854-.142-1.204.108l-.738.527c-.447.32-1.06.269-1.45-.12l-.773-.774a1.125 1.125 0 0 1-.12-1.45l.527-.737c.25-.35.273-.806.108-1.204c-.165-.397-.505-.71-.93-.78l-.894-.15c-.542-.09-.94-.56-.94-1.109v-1.094c0-.55.398-1.02.94-1.11l.894-.149c.424-.07.765-.383.93-.78c.165-.398.143-.854-.107-1.204l-.527-.738a1.125 1.125 0 0 1 .12-1.45l.773-.773a1.125 1.125 0 0 1 1.45-.12l.737.527c.35.25.807.272 1.204.107c.397-.165.71-.505.78-.929l.15-.894Z" }),
  /*#__PURE__*/createElementVNode("path", { d: "M15 12a3 3 0 1 1-6 0a3 3 0 0 1 6 0Z" })
], -1);
const _hoisted_3$4 = [
  _hoisted_2$9
];

function render$2(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$b, _hoisted_3$4))
}

const CogIcon = { name: 'heroicons-cog-8-tooth', render: render$2 };
/* vite-plugin-components disabled */

const _hoisted_1$a = {
  viewBox: "0 0 24 24",
  width: "1.2em",
  height: "1.2em"
};
const _hoisted_2$8 = /*#__PURE__*/createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M10.5 6a1.5 1.5 0 1 1 3 0a1.5 1.5 0 0 1-3 0Zm0 6a1.5 1.5 0 1 1 3 0a1.5 1.5 0 0 1-3 0Zm0 6a1.5 1.5 0 1 1 3 0a1.5 1.5 0 0 1-3 0Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3$3 = [
  _hoisted_2$8
];

function render$1(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$a, _hoisted_3$3))
}

const EllipsisVerticalIcon = { name: 'heroicons-ellipsis-vertical-solid', render: render$1 };
/* vite-plugin-components disabled */

const _hoisted_1$9 = ["textContent"];
const _hoisted_2$7 = ["textContent"];
const _hoisted_3$2 = ["textContent"];
const _hoisted_4$1 = ["textContent"];
const _hoisted_5$1 = ["textContent"];
const _hoisted_6$1 = /* @__PURE__ */ createElementVNode("span", null, ":", -1);
const _hoisted_7 = ["checked", "onChange"];
const _hoisted_8 = { class: "opacity-0" };
const _hoisted_9 = ["innerHTML"];
const _hoisted_10 = { key: 1 };
const _hoisted_11 = { key: 2 };
const __default__$c = {
  name: "VanillaDatatable",
  inheritAttrs: false
};
const _sfc_main$e = /* @__PURE__ */ defineComponent({
  ...__default__$c,
  props: {
    ...useVariantProps$1(),
    config: {
      type: [Object],
      required: false,
      default() {
        return {};
      }
    },
    fetchData: {
      type: [Function, void 0],
      required: false,
      default: void 0
    },
    onActionExecutedCallback: {
      type: [Function, void 0],
      required: false,
      default: void 0
    },
    onExceptionCallback: {
      type: [Function, void 0],
      required: false,
      default: void 0
    }
  },
  emits: [
    "fetchedSuccess",
    "fetchError",
    "actionExecuted",
    "sortingUpdated",
    "navigateToPage",
    "filtersSaved",
    "mounted",
    "unmounted",
    "search",
    "openedFilters",
    "openedSettings"
  ],
  setup(__props, { expose, emit }) {
    const props = __props;
    const { configuration } = useConfiguration(datatableConfig, "Datatable");
    const datatable = reactive(configurationBuilder(props));
    useValidator(datatable);
    const isFetching = ref(false);
    const isShowingFilters = ref(false);
    const isShowingActionConfirmation = ref(false);
    const isShowingSettings = ref(false);
    const showLoadingAnimation = ref(false);
    const results = reactive({
      data: [],
      links: {
        next: null,
        previous: null,
        pages: []
      },
      meta: {
        current_page: 0,
        from: 0,
        to: 0,
        total: 0
      }
    });
    const currentAction = ref(void 0);
    const poolingInterval = ref(void 0);
    const isShowingSearchbar = ref(!datatable.options.isSearchHidden);
    const userSettingsDefault = {
      hiddenColumns: filter$1(datatable.columns, { hidden: true }).map((c) => c.name),
      perPage: datatable.perPageOptions[0]?.value,
      useStorage: true,
      saveSelection: true,
      selectedIds: [],
      filters: {}
    };
    const userSettings = reactive({ ...userSettingsDefault });
    const userStorage = useLocalStorage(camelize(datatable.name.toString()), userSettings, {});
    const queryData = reactive({
      search: "",
      perPage: userSettings.perPage,
      selected: [],
      selectedAll: false,
      filters: {},
      sorting: [],
      action: null
    });
    const fetchData = datatable?.fetchData || useFetchData;
    const currentPageIds = computed(() => results.data?.map((item) => item.id) || []);
    const resultsHash = computed(() => JSON.stringify(results.data));
    const hasResults = computed(() => typeof results.data !== "undefined" && results.data.length > 0);
    const hasAnyItemsSelected = computed(() => queryData.selectedAll || queryData.selected.length > 0);
    const hasFilters = computed(() => datatable.filters.length > 0);
    const hasActions = computed(() => datatable.actions.length > 0);
    const visibleColumnsCount = computed(() => userSettings.hiddenColumns?.length - (datatable.options.selectable ? 1 : 0));
    const selectedItemsCount = computed(() => queryData.selectedAll ? results?.meta?.total : queryData.selected.length);
    const canSearch = computed(() => datatable.options.searchable && !isFetching.value && !hasAnyItemsSelected.value);
    const isAllItemsInPageSelected = computed(() => queryData.selectedAll || currentPageIds.value.every((id) => queryData.selected.includes(id)));
    const hasAnyItemsSelectedForCurrentPage = computed(() => queryData.selected.some((id) => currentPageIds.value.includes(id)));
    const filtersActiveCount = computed(() => Object.keys(userSettings.filters).length || Object.keys(queryData.filters).length);
    const hasFiltersOrSearchApplied = computed(() => filtersActiveCount.value > 0 || queryData.search !== "");
    const showBeInLoadingState = computed(() => isFetching.value || showLoadingAnimation.value);
    const showSettingsDropdown = computed(() => [datatable.options.isSearchHidden, datatable.options.refreshable, datatable.options.manageSettings].includes(true));
    const columnsComputed = computed(() => {
      return datatable.columns.map((column) => {
        return {
          ...column,
          visible: !userSettings.hiddenColumns.includes(column.name),
          isSorted: queryData.sorting.some((c) => c.column === column.name),
          isSortedAsc: queryData.sorting.some((c) => c.column === column.name && c.direction === "asc"),
          isSortedDesc: queryData.sorting.some((c) => c.column === column.name && c.direction === "desc"),
          slotName: useDynamicSlots("row", column.name)
        };
      });
    });
    const actionsComputed = computed(() => {
      return datatable.actions.map((action) => {
        return {
          ...action,
          slotName: useDynamicSlots("action", action.name)
        };
      });
    });
    const filtersComputed = computed(() => {
      const finalFilters = [];
      Object.entries(userSettings.filters).forEach(([key, value]) => {
        const filterObject = find$1(datatable.filters, { name: key });
        if (void 0 === filterObject) {
          return;
        }
        let finalFilterValue = value;
        if (filterObject?.options?.length) {
          const option = find$1(filterObject?.options, { value });
          if (option !== void 0) {
            finalFilterValue = option.text;
          }
        }
        finalFilters.push({
          ...filterObject,
          value: finalFilterValue
        });
      });
      return finalFilters;
    });
    const fetchFromServer = (then = () => {
    }, link = null) => {
      isFetching.value = true;
      return fetchData({ ...datatable }, queryData, link).then((response) => {
        results.data = response.data;
        results.links = response?.links;
        results.meta = response?.meta;
        results.responses = response?.meta;
        emit("fetchedSuccess", {
          results,
          success: true
        });
      }).catch((error) => {
        if (datatable?.onExceptionCallback !== void 0) {
          datatable.onExceptionCallback(error);
        }
        console.log("[REST] 🚀 Got error", error);
        emit("fetchError", {
          error,
          success: false
        });
      }).then(() => {
        setTimeout(() => {
          isFetching.value = false;
        }, 300);
      }).then(then);
    };
    const refresh = (then = () => {
    }, link = null) => {
      if (!isFetching.value) {
        fetchFromServer(then, link);
      }
    };
    const selectItem = (item, uncheckIfChecked = true) => {
      const itemKey = item[datatable.primaryKey] || null;
      if (itemKey === null) {
        throw new Error('Please make sure the config "primaryKey" exists on your resource data.');
      }
      queryData.selectedAll = false;
      if (!queryData.selected.includes(itemKey)) {
        return queryData.selected.push(itemKey);
      }
      if (uncheckIfChecked) {
        const index = queryData.selected.indexOf(itemKey);
        if (index > -1) {
          return queryData.selected.splice(index, 1);
        }
      }
    };
    const isItemSelected = (item) => {
      return queryData.selectedAll || queryData.selected.includes(item[datatable.primaryKey]);
    };
    const deselectAllItemsInPage = () => {
      each(currentPageIds.value, (item) => {
        const index = queryData.selected.indexOf(item);
        if (index > -1) {
          return queryData.selected.splice(index, 1);
        }
      });
    };
    const deselectAllItems = () => {
      queryData.selected = [];
      queryData.selectedAll = false;
    };
    const selectAllItemsInPage = () => {
      queryData.selectedAll = false;
      if (isAllItemsInPageSelected.value) {
        deselectAllItemsInPage();
        return;
      }
      each(results.data, (item) => {
        selectItem(item, false);
      });
    };
    const toggleSelectAll = () => {
      queryData.selectedAll = !queryData.selectedAll;
    };
    const poolUntil = (enable = false, every = 20, during = 120, stopWhenChanged = true) => {
      if (!enable) {
        return;
      }
      const started = Date.now();
      const initialItemsHash = resultsHash.value;
      poolingInterval.value = setInterval(() => {
        const timeExpired = Date.now() - started > during * 1e3;
        const hashChanged = initialItemsHash !== resultsHash.value;
        if (timeExpired || hashChanged && stopWhenChanged) {
          clearInterval(poolingInterval.value);
        } else {
          refresh();
        }
      }, every * 1e3);
    };
    const poolForever = (enable = false, every = 20) => {
      if (!enable) {
        return;
      }
      poolingInterval.value = setInterval(() => refresh(), every * 1e3);
    };
    const resetSorting = () => {
      queryData.sorting = [];
    };
    const resetSearchQuery = (shouldRefresh = false) => {
      queryData.search = "";
      if (!shouldRefresh) {
        return;
      }
      refresh();
    };
    const resetFilter = (filterToClear, shouldRefresh = true) => {
      if (!(filterToClear.name in userSettings.filters)) {
        return;
      }
      deselectAllItems();
      userSettings.filters = { ...omit$1(userSettings.filters, filterToClear.name) };
      queryData.filters = { ...omit$1(queryData.filters, filterToClear.name) };
      if (!shouldRefresh) {
        return;
      }
      refresh();
    };
    const resetAllFilters = (shouldRefresh = false) => {
      if (!Object.keys(queryData.filters).length) {
        return;
      }
      queryData.filters = {};
      userSettings.filters = {};
      if (!shouldRefresh) {
        return;
      }
      refresh();
    };
    const resetFiltersAndSearch = (shouldRefresh = true) => {
      showLoadingAnimation.value = true;
      resetAllFilters(false);
      resetSearchQuery(false);
      resetUrl();
      if (!shouldRefresh) {
        return;
      }
      refresh();
      showLoadingAnimation.value = false;
    };
    const resetUrl = () => {
      if (isServer()) {
        return;
      }
      if (datatable.originUrl !== void 0) {
        window.history.pushState({}, document.title, datatable.originUrl);
      } else {
        const url = new URL(window.location.href);
        const params = new URLSearchParams(url.search);
        for (const [key, value] of params) {
          if (key.startsWith(datatable.name)) {
            params.delete(key);
          }
        }
        url.search = params.toString();
        window.history.replaceState({}, "", url.toString());
      }
    };
    const resetAllSettings = () => {
      resetAllFilters();
      resetSorting();
      deselectAllItems();
      Object.assign(userSettings, userSettingsDefault);
    };
    const resetAction = () => {
      isShowingActionConfirmation.value = false;
      currentAction.value = void 0;
    };
    const executeAction = (action) => {
      if (!action?.permissions?.execute) {
        return;
      }
      const queryDataImmutable = { ...queryData };
      if (action?.before?.callback !== void 0) {
        action.before.callback(action, queryDataImmutable, datatable);
      }
      queryData.action = action.name;
      const afterActionCallback = () => {
        if (action?.after?.clearSelected) {
          deselectAllItems();
        }
        if (action?.after?.resetFilters) {
          resetAllFilters();
        }
        if (action?.after?.callback !== void 0) {
          action.after.callback(action, queryDataImmutable, datatable);
        }
        if (action?.after?.redirect && action?.after?.redirect?.url !== void 0) {
          if (action?.after?.redirect.newTab && !isServer()) {
            window.open(action?.after?.redirect.url, "_blank");
          }
          if (!action?.after?.redirect.newTab && !isServer()) {
            window.location.href = action?.after?.redirect.url;
          }
        }
        if (action?.after?.pooling && action?.after?.pooling?.enable && action?.after?.pooling?.during !== void 0 && action?.after?.pooling?.during > 0) {
          poolUntil(
            action?.after?.pooling?.enable,
            action?.after?.pooling?.interval,
            action?.after?.pooling?.during,
            action?.after?.pooling?.stopWhenDataChanges
          );
        }
        if (datatable?.onActionExecutedCallback !== void 0) {
          datatable.onActionExecutedCallback(action, queryDataImmutable);
        }
        resetAction();
        if (action?.after?.refresh || true) {
          refresh();
        }
      };
      emit("actionExecuted", {
        action
      });
      refresh(afterActionCallback);
    };
    const onSortingUpdated = (sorting) => {
      queryData.sorting = sorting;
      emit("sortingUpdated", {
        sorting
      });
      refresh();
    };
    const onActionSelected = (action) => {
      if (action.before?.confirm?.enable) {
        isShowingActionConfirmation.value = true;
        currentAction.value = action;
        return;
      }
      return executeAction(action);
    };
    const onActionConfirmed = (action) => {
      return executeAction(action);
    };
    const onPageNavigated = (link) => {
      if (link == null) {
        return;
      }
      emit("navigateToPage", {
        link
      });
      const fetchEndpoint = datatable.fetchEndpoint;
      const actionsEndpoint = datatable.actionsEndpoint;
      datatable.fetchEndpoint = link;
      datatable.actionsEndpoint = link;
      refresh(() => {
        datatable.fetchEndpoint = fetchEndpoint;
        datatable.actionsEndpoint = actionsEndpoint;
      }, link);
    };
    const onFiltersSaved = (filters) => {
      isShowingFilters.value = false;
      userSettings.filters = filters;
      queryData.filters = filters;
      resetAction();
      deselectAllItems();
      resetSearchQuery();
      emit("filtersSaved", { filters });
      refresh();
    };
    const onFiltersReset = () => {
      isShowingFilters.value = false;
      userSettings.filters = {};
      queryData.filters = {};
      resetAction();
      deselectAllItems();
      resetSearchQuery();
      refresh();
    };
    const onSearch = debounce$1((newQuery) => {
      if (newQuery === void 0) {
        newQuery = "";
      }
      if (canSearch.value) {
        deselectAllItems();
        refresh();
        emit("search", newQuery || "");
      }
    }, 700);
    const onSettingsVisit = () => {
      isShowingSettings.value = true;
      emit("openedSettings", true);
    };
    const onFiltersVisit = () => {
      isShowingFilters.value = true;
      emit("openedFilters", true);
    };
    const onSearchToggle = () => {
      isShowingSearchbar.value = !isShowingSearchbar.value;
      if (hasAnyItemsSelected.value && isShowingSearchbar.value) {
        deselectAllItems();
      }
    };
    const fromUserStorageToUserSettings = () => {
      if (userStorage.value?.useStorage === false) {
        return;
      }
      if (userStorage.value.hiddenColumns.length) {
        userStorage.value.hiddenColumns = userStorage.value.hiddenColumns.filter((column) => {
          return find$1(columnsComputed.value, { name: column });
        });
      }
      Object.assign(userSettings, assign_1(userSettingsDefault, userStorage.value));
      if (userSettings.selectedIds.length) {
        queryData.selected = userSettings.selectedIds;
      }
      if (Object.keys(userSettings.filters).length > 0) {
        queryData.filters = userSettings.filters;
      }
      if (userSettings.perPage) {
        queryData.perPage = userSettings.perPage;
      }
    };
    const fromCurrentFiltersStateToLocalStorage = () => {
      if (Object.keys(datatable.filters).length > 0) {
        Object.keys(datatable.filters).forEach((key) => {
          const filterObject = datatable.filters[key];
          if (filterObject.value !== void 0 && filterObject.value !== filterObject.defaultValue) {
            userStorage.value.filters[filterObject.name] = filterObject.value;
          }
        });
      }
    };
    onMounted(() => {
      fromCurrentFiltersStateToLocalStorage();
      fromUserStorageToUserSettings();
      if (datatable?.pooling?.enable && datatable?.pooling?.interval !== void 0) {
        refresh(() => {
          poolForever(
            datatable?.pooling?.enable,
            datatable?.pooling?.interval
          );
        });
      } else {
        refresh();
      }
      emit("mounted");
    });
    onMounted(() => {
      watch(
        () => {
          return queryData.perPage;
        },
        () => {
          refresh();
        },
        {
          deep: true
        }
      );
    });
    onUnmounted(() => {
      clearInterval(poolingInterval.value);
      emit("unmounted");
    });
    watch(() => queryData.selected, () => {
      userSettings.selectedIds = queryData.selected;
    }, { deep: true });
    watch(() => queryData.search, (searchQuery) => {
      if (!isFetching.value) {
        onSearch(searchQuery);
      }
    }, { deep: true });
    watch(() => userSettings.perPage, () => {
      queryData.perPage = userSettings.perPage;
    }, { deep: false });
    watch(userSettings, (value) => {
      userStorage.value = value;
    }, { deep: true });
    const translations = datatable.translations;
    const classesList = configuration.classesList;
    provide("configuration_vanilla_datatable", configuration);
    provide("datatable_configuration", datatable);
    provide("datatable_reset_url_function", resetUrl);
    expose({
      fetchData,
      resetUrl,
      resetAllSettings,
      resetSorting,
      resetAction,
      resetSearchQuery,
      resetFiltersAndSearch,
      poolForever,
      refresh,
      poolUntil,
      deselectAllItemsInPage,
      selectItem,
      deselectAllItems,
      toggleSelectAll,
      isItemSelected,
      executeAction,
      currentAction,
      isFetching,
      datatable
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", null, [
        createVNode(_sfc_main$U, {
          title: unref(datatable).translations.title,
          subtitle: unref(datatable).translations.subtitle,
          variant: unref(classesList).cardVariant
        }, {
          actions: withCtx(() => [
            renderSlot(_ctx.$slots, "headerActions", normalizeProps(guardReactiveProps({
              actions: unref(datatable).actions,
              hasActions: unref(hasActions),
              hasAnyItemsSelected: unref(hasAnyItemsSelected),
              onActionSelected
            })), () => [
              unref(hasActions) && unref(hasAnyItemsSelected) ? (openBlock(), createBlock(_sfc_main$p, {
                key: 0,
                actions: unref(actionsComputed),
                "count-selected": unref(selectedItemsCount),
                onActionSelected
              }, createSlots({ _: 2 }, [
                renderList(unref(actionsComputed), (action) => {
                  return {
                    name: action.slotName,
                    fn: withCtx(({ selectAction }) => [
                      renderSlot(_ctx.$slots, action.slotName, mergeProps({ action }, { action, selectAction }))
                    ])
                  };
                })
              ]), 1032, ["actions", "count-selected"])) : createCommentVNode("", true)
            ]),
            renderSlot(_ctx.$slots, "headerFilters", normalizeProps(guardReactiveProps({
              filters: unref(filtersComputed),
              hasFilters: unref(hasFilters),
              isShowingFilters: unref(isShowingFilters),
              filtersActiveCount: unref(filtersActiveCount)
            })), () => [
              unref(hasFilters) ? (openBlock(), createElementBlock("div", {
                key: 0,
                class: normalizeClass([unref(classesList).headerFiltersContainer])
              }, [
                createVNode(_sfc_main$X, { onClick: onFiltersVisit }, {
                  default: withCtx(() => [
                    createVNode(unref(FunnelIcon), {
                      class: normalizeClass([unref(classesList).headerFiltersIcon])
                    }, null, 8, ["class"]),
                    createElementVNode("span", {
                      class: normalizeClass([unref(classesList).headerFiltersLabel]),
                      textContent: toDisplayString(unref(translations).filters)
                    }, null, 10, _hoisted_1$9),
                    unref(filtersActiveCount) > 0 ? (openBlock(), createElementBlock("span", {
                      key: 0,
                      class: normalizeClass([unref(classesList).headerFiltersCount])
                    }, "( " + toDisplayString(unref(filtersActiveCount)) + " )", 3)) : createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ], 2)) : createCommentVNode("", true)
            ]),
            renderSlot(_ctx.$slots, "headerSettings", normalizeProps(guardReactiveProps({
              refreshable: unref(datatable).options.refreshable,
              isFetching: unref(isFetching),
              isShowingSettings: unref(isShowingSettings),
              userSettings: unref(userSettings),
              refresh
            })), () => [
              unref(showSettingsDropdown) ? (openBlock(), createBlock(_sfc_main$x, {
                key: 0,
                class: normalizeClass([unref(classesList).headerSettingsContainer])
              }, {
                trigger: withCtx(() => [
                  createVNode(_sfc_main$X, null, {
                    default: withCtx(() => [
                      createVNode(unref(EllipsisVerticalIcon), {
                        class: normalizeClass([unref(classesList).headerSettingsIcon])
                      }, null, 8, ["class"])
                    ]),
                    _: 1
                  })
                ]),
                default: withCtx(() => [
                  unref(datatable).options.isSearchHidden ? (openBlock(), createBlock(_sfc_main$y, {
                    key: 0,
                    onClick: onSearchToggle
                  }, {
                    default: withCtx(() => [
                      createVNode(unref(SearchIcon), {
                        class: normalizeClass([unref(classesList).headerSettingsSearchIcon])
                      }, null, 8, ["class"]),
                      createElementVNode("span", {
                        textContent: toDisplayString(unref(translations).search)
                      }, null, 8, _hoisted_2$7)
                    ]),
                    _: 1
                  })) : createCommentVNode("", true),
                  unref(datatable).options.refreshable ? (openBlock(), createBlock(_sfc_main$y, {
                    key: 1,
                    onClick: refresh
                  }, {
                    default: withCtx(() => [
                      createVNode(unref(ArrowPathIcon), {
                        class: normalizeClass([
                          unref(classesList).headerSettingsRefreshIcon,
                          unref(isFetching) ? unref(classesList).headerSettingsRefreshIconAnimation : ""
                        ])
                      }, null, 8, ["class"]),
                      createElementVNode("span", {
                        textContent: toDisplayString(unref(translations).refresh)
                      }, null, 8, _hoisted_3$2)
                    ]),
                    _: 1
                  })) : createCommentVNode("", true),
                  unref(datatable).options.manageSettings ? (openBlock(), createBlock(_sfc_main$y, {
                    key: 2,
                    onClick: onSettingsVisit
                  }, {
                    default: withCtx(() => [
                      createVNode(unref(CogIcon), {
                        class: normalizeClass([unref(classesList).headerSettingsEditIcon])
                      }, null, 8, ["class"]),
                      createElementVNode("span", {
                        textContent: toDisplayString(unref(translations).settings)
                      }, null, 8, _hoisted_4$1)
                    ]),
                    _: 1
                  })) : createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["class"])) : createCommentVNode("", true)
            ])
          ]),
          default: withCtx(() => [
            unref(datatable).options.searchable && isShowingSearchbar.value && !unref(hasAnyItemsSelected) ? renderSlot(_ctx.$slots, "headerSearch", normalizeProps(mergeProps({ key: 0 }, {
              searchable: unref(datatable).options.searchable,
              hasAnyItemsSelected: unref(hasAnyItemsSelected),
              query: unref(queryData).search,
              placeholder: unref(translations).searchPlaceholder,
              onSearch: unref(onSearch)
            })), () => [
              createVNode(_sfc_main$s, {
                modelValue: unref(queryData).search,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => unref(queryData).search = $event),
                searchable: unref(canSearch),
                placeholder: unref(translations).searchPlaceholder
              }, null, 8, ["modelValue", "searchable", "placeholder"])
            ]) : createCommentVNode("", true),
            unref(hasFilters) && unref(filtersActiveCount) > 0 ? renderSlot(_ctx.$slots, "headerFiltersActive", normalizeProps(mergeProps({ key: 1 }, {
              hasFilters: unref(hasFilters),
              filtersActiveCount: unref(filtersActiveCount),
              resetFilter,
              filters: unref(filtersComputed)
            })), () => [
              createElementVNode("div", {
                class: normalizeClass(unref(classesList).filtersBarContainer)
              }, [
                createElementVNode("div", {
                  class: normalizeClass(unref(classesList).filtersBarInner)
                }, [
                  createElementVNode("span", {
                    textContent: toDisplayString(unref(translations).filtersBarLabel)
                  }, null, 8, _hoisted_5$1),
                  _hoisted_6$1,
                  createElementVNode("div", {
                    class: normalizeClass(unref(classesList).filtersBarBadgesContainer)
                  }, [
                    (openBlock(true), createElementBlock(Fragment, null, renderList(unref(filtersComputed), (aFilter) => {
                      return openBlock(), createBlock(_sfc_main$g, {
                        key: `${aFilter.name}${aFilter.value}`,
                        filter: aFilter,
                        value: aFilter.value,
                        onFilterRemove: ($event) => resetFilter(aFilter)
                      }, null, 8, ["filter", "value", "onFilterRemove"]);
                    }), 128))
                  ], 2)
                ], 2)
              ], 2)
            ]) : createCommentVNode("", true),
            unref(hasAnyItemsSelected) && unref(hasActions) ? renderSlot(_ctx.$slots, "selection", normalizeProps(mergeProps({ key: 2 }, {
              isAllSelected: unref(queryData).selectedAll,
              countSelected: unref(selectedItemsCount),
              countTotal: unref(results)?.meta.total,
              deselectAll: deselectAllItems,
              selectMatching: toggleSelectAll,
              deselectMatching: toggleSelectAll
            })), () => [
              createVNode(_sfc_main$r, {
                "is-all-selected": unref(queryData).selectedAll,
                "count-selected": unref(selectedItemsCount),
                "count-total": unref(results)?.meta.total,
                onDeselectAll: deselectAllItems,
                onSelectMatching: toggleSelectAll,
                onDeselectMatching: toggleSelectAll
              }, null, 8, ["is-all-selected", "count-selected", "count-total"])
            ]) : createCommentVNode("", true),
            createElementVNode("div", {
              class: normalizeClass([
                unref(classesList).tableContainer,
                unref(hasAnyItemsSelected) && unref(hasActions) || unref(filtersActiveCount) > 0 ? unref(classesList).tableContainerBorder : ""
              ])
            }, [
              !unref(showBeInLoadingState) && !unref(hasResults) ? (openBlock(), createBlock(_sfc_main$f, {
                key: 0,
                "has-filters-or-search": unref(hasFiltersOrSearchApplied),
                "is-fetching": unref(isFetching),
                onResetFilters: resetFiltersAndSearch
              }, {
                emptyWithFilters: withCtx(() => [
                  renderSlot(_ctx.$slots, "emptyWithFilters", normalizeProps(guardReactiveProps({
                    resetFiltersAndSearch,
                    filters: unref(filtersComputed),
                    filtersActiveCount: unref(filtersActiveCount)
                  })))
                ]),
                emptyWithFiltersIcon: withCtx(() => [
                  renderSlot(_ctx.$slots, "emptyWithFiltersIcon", normalizeProps(guardReactiveProps({
                    resetFiltersAndSearch,
                    filters: unref(filtersComputed),
                    filtersActiveCount: unref(filtersActiveCount)
                  })))
                ]),
                emptyWithFiltersTitle: withCtx(() => [
                  renderSlot(_ctx.$slots, "emptyWithFiltersTitle", normalizeProps(guardReactiveProps({
                    resetFiltersAndSearch,
                    filters: unref(filtersComputed),
                    filtersActiveCount: unref(filtersActiveCount)
                  })))
                ]),
                emptyWithFiltersButton: withCtx(() => [
                  renderSlot(_ctx.$slots, "emptyWithFiltersButton", normalizeProps(guardReactiveProps({
                    resetFiltersAndSearch,
                    filters: unref(filtersComputed),
                    filtersActiveCount: unref(filtersActiveCount)
                  })))
                ]),
                emptyWithoutRecords: withCtx(() => [
                  renderSlot(_ctx.$slots, "emptyWithoutRecords")
                ]),
                emptyWithoutRecordsIcon: withCtx(() => [
                  renderSlot(_ctx.$slots, "emptyWithoutRecordsIcon")
                ]),
                emptyWithoutRecordsTitle: withCtx(() => [
                  renderSlot(_ctx.$slots, "emptyWithoutRecordsTitle")
                ]),
                emptyWithoutRecordsButton: withCtx(() => [
                  renderSlot(_ctx.$slots, "emptyWithoutRecordsButton")
                ]),
                _: 3
              }, 8, ["has-filters-or-search", "is-fetching"])) : (openBlock(), createElementBlock("table", {
                key: 1,
                class: normalizeClass([unref(classesList).tableClass])
              }, [
                renderSlot(_ctx.$slots, "header", normalizeProps(guardReactiveProps({
                  datatable: unref(datatable),
                  isFetching: unref(isFetching),
                  isAllItemsInPageSelected: unref(isAllItemsInPageSelected),
                  hasAnyItemsSelectedForCurrentPage: unref(hasAnyItemsSelectedForCurrentPage),
                  columns: unref(columnsComputed),
                  selectAllItemsInPage
                })), () => [
                  createVNode(_sfc_main$w, {
                    columns: unref(columnsComputed),
                    "columns-with-sorting": unref(queryData).sorting,
                    "columns-with-hidden-state": [],
                    "is-fetching": unref(isFetching),
                    selectable: unref(datatable).options.selectable,
                    "all-items-checked": unref(isAllItemsInPageSelected) && !unref(isFetching),
                    "some-items-checked": !unref(isAllItemsInPageSelected) && unref(hasAnyItemsSelectedForCurrentPage) && !unref(isFetching),
                    onChecked: selectAllItemsInPage,
                    onSorted: onSortingUpdated
                  }, null, 8, ["columns", "columns-with-sorting", "is-fetching", "selectable", "all-items-checked", "some-items-checked"])
                ]),
                unref(showBeInLoadingState) && !unref(hasResults) ? renderSlot(_ctx.$slots, "skeleton", normalizeProps(mergeProps({ key: 0 }, {
                  isFetching: unref(isFetching),
                  showBeInLoadingState: unref(showBeInLoadingState),
                  columnsCount: unref(visibleColumnsCount),
                  rowsCount: unref(results).data?.length || unref(queryData).perPage
                })), () => [
                  createVNode(_sfc_main$u, {
                    columns: unref(columnsComputed),
                    "number-of-rows": unref(results).data?.length || unref(queryData).perPage,
                    "is-selectable": unref(datatable).options.selectable
                  }, null, 8, ["columns", "number-of-rows", "is-selectable"])
                ]) : (openBlock(), createElementBlock("tbody", {
                  key: 1,
                  class: normalizeClass([unref(classesList).tableBody])
                }, [
                  (openBlock(true), createElementBlock(Fragment, null, renderList(unref(results).data, (result) => {
                    return openBlock(), createElementBlock("tr", {
                      key: result.id,
                      class: normalizeClass([unref(classesList).tableRow])
                    }, [
                      unref(datatable).options.selectable ? (openBlock(), createElementBlock("td", {
                        key: 0,
                        class: normalizeClass([
                          unref(classesList).tableColumnCheckbox
                        ])
                      }, [
                        createElementVNode("input", {
                          checked: isItemSelected(result),
                          class: normalizeClass([
                            unref(classesList).tableCheckbox
                          ]),
                          type: "checkbox",
                          onChange: ($event) => selectItem(result)
                        }, null, 42, _hoisted_7)
                      ], 2)) : createCommentVNode("", true),
                      renderSlot(_ctx.$slots, "default", normalizeProps(guardReactiveProps({
                        result,
                        columns: unref(columnsComputed),
                        selectable: unref(datatable).options.selectable,
                        selected: isItemSelected(result)
                      })), () => [
                        (openBlock(true), createElementBlock(Fragment, null, renderList(unref(columnsComputed), (column) => {
                          return withDirectives((openBlock(), createElementBlock("td", {
                            key: column.name,
                            class: normalizeClass([
                              unref(classesList).tableColumn,
                              column.name.toLocaleLowerCase() === "id" ? unref(classesList).tableIdColumn : ""
                            ])
                          }, [
                            unref(showBeInLoadingState) ? renderSlot(_ctx.$slots, "rowSkeleton", normalizeProps(mergeProps({ key: 0 }, {
                              column,
                              result: unref(get$4)(result, column.name),
                              resultRaw: result,
                              isLoading: unref(showBeInLoadingState)
                            })), () => [
                              createElementVNode("div", {
                                class: normalizeClass(unref(classesList).skeletonPlaceholder)
                              }, [
                                createElementVNode("span", _hoisted_8, toDisplayString(unref(get$4)(result, column.name)), 1)
                              ], 2)
                            ]) : createCommentVNode("", true),
                            !unref(showBeInLoadingState) ? renderSlot(_ctx.$slots, column.slotName, normalizeProps(mergeProps({ key: 1 }, {
                              column,
                              result: unref(get$4)(result, column.name),
                              resultRaw: result,
                              isLoading: unref(showBeInLoadingState)
                            })), () => [
                              column?.raw && !column.component ? (openBlock(), createElementBlock("div", {
                                key: 0,
                                innerHTML: unref(get$4)(result, column.name)
                              }, null, 8, _hoisted_9)) : !column?.raw ? (openBlock(), createElementBlock("div", _hoisted_10, toDisplayString(unref(get$4)(result, column.name)), 1)) : column.component && column.component !== "" ? (openBlock(), createElementBlock("div", _hoisted_11)) : createCommentVNode("", true)
                            ]) : createCommentVNode("", true)
                          ], 2)), [
                            [vShow, column.visible]
                          ]);
                        }), 128))
                      ])
                    ], 2);
                  }), 128))
                ], 2))
              ], 2))
            ], 2),
            renderSlot(_ctx.$slots, "pagination", normalizeProps(guardReactiveProps({
              isFetching: unref(isFetching),
              pages: unref(results).links?.pages,
              previousPage: unref(results).links?.previous,
              nextPage: unref(results).links?.next,
              currentPage: unref(results).meta?.current_page,
              showingFrom: unref(results).meta?.from,
              showingTo: unref(results).meta?.to,
              total: unref(results).meta?.total
            })), () => [
              createVNode(_sfc_main$q, {
                "is-fetching": unref(isFetching),
                pages: unref(results).links?.pages,
                "next-page": unref(results).links?.next,
                "previous-page": unref(results).links?.previous,
                "current-page": unref(results).meta?.current_page,
                "showing-from": unref(results).meta?.from,
                "showing-to": unref(results).meta?.to,
                total: unref(results).meta?.total,
                "show-pages": unref(datatable).options.showPages,
                "show-number-of-items": unref(datatable).options.showTotalItems,
                onNavigate: onPageNavigated
              }, null, 8, ["is-fetching", "pages", "next-page", "previous-page", "current-page", "showing-from", "showing-to", "total", "show-pages", "show-number-of-items"])
            ])
          ]),
          _: 3
        }, 8, ["title", "subtitle", "variant"]),
        renderSlot(_ctx.$slots, "actionsDialog", normalizeProps(guardReactiveProps({
          isShowingActionConfirmation: unref(isShowingActionConfirmation),
          currentAction: unref(currentAction),
          selectedItemsCount: unref(selectedItemsCount),
          onActionConfirmed
        })), () => [
          createVNode(_sfc_main$m, {
            modelValue: unref(isShowingActionConfirmation),
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => isRef(isShowingActionConfirmation) ? isShowingActionConfirmation.value = $event : null),
            action: unref(currentAction),
            "count-selected": unref(selectedItemsCount),
            onActionConfirmed
          }, {
            icon: withCtx(({
              action,
              title,
              text,
              confirmText,
              cancelText
            }) => [
              renderSlot(_ctx.$slots, "actionsIcon", normalizeProps(guardReactiveProps({
                action,
                title,
                text,
                confirmText,
                cancelText
              })))
            ]),
            default: withCtx(({
              action,
              title,
              text,
              confirmText,
              cancelText
            }) => [
              renderSlot(_ctx.$slots, "actionBody", normalizeProps(guardReactiveProps({
                action,
                title,
                text,
                confirmText,
                cancelText
              })))
            ]),
            _: 3
          }, 8, ["modelValue", "action", "count-selected"])
        ]),
        renderSlot(_ctx.$slots, "settingsDialog", normalizeProps(guardReactiveProps({
          isShowingSettings: unref(isShowingSettings),
          userSettings: unref(userSettings),
          perPageOptions: unref(datatable).perPageOptions,
          columns: unref(columnsComputed)
        })), () => [
          createVNode(_sfc_main$i, {
            modelValue: unref(isShowingSettings),
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => isRef(isShowingSettings) ? isShowingSettings.value = $event : null),
            "user-settings": unref(userSettings),
            "default-settings": unref(userSettingsDefault),
            "per-page-options": unref(datatable).perPageOptions,
            columns: unref(columnsComputed),
            onSettingsReset: resetAllSettings
          }, null, 8, ["modelValue", "user-settings", "default-settings", "per-page-options", "columns"])
        ]),
        renderSlot(_ctx.$slots, "filtersDialog", normalizeProps(guardReactiveProps({
          isShowingFilters: unref(isShowingFilters),
          userSettings: unref(userSettings),
          filters: unref(datatable).filters
        })), () => [
          createVNode(_sfc_main$h, {
            modelValue: unref(isShowingFilters),
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => isRef(isShowingFilters) ? isShowingFilters.value = $event : null),
            "user-settings": unref(userSettings),
            filters: unref(datatable).filters,
            configuration: unref(datatable),
            onFiltersReset,
            onFiltersSaved
          }, null, 8, ["modelValue", "user-settings", "filters", "configuration"])
        ])
      ]);
    };
  }
});

const _sfc_main$d = defineComponent({
  setup(_, { slots }) {
    const show = ref(false);
    onMounted(() => show.value = true);
    return () => show.value && slots.default ? slots.default() : null;
  }
});

const baseProps = {
  ...useVariantProps$1(),
  modelValue: {
    type: [String, Object, Number, Array, void 0]
  },
  color: {
    type: String,
    default: "indigo"
  },
  placeholder: {
    type: String,
    default: ""
  },
  inline: {
    type: Boolean,
    default: false
  },
  inputProps: {
    type: Object,
    default: () => {
    }
  }
};

const dateTimeInputConfig = {
  fixedClasses: {
    wrapper: "relative items-center justify-between focus:z-10",
    clearButton: mergeClasses(
      "absolute flex items-center justify-center dark:text-gray-700 text-gray-300 rounded mr-3 hover:bg-gray-100 hover:text-gray-400 dark:hover:bg-gray-700 focus:ring-opacity-70 top-1/2 right-0 transform -translate-y-1/2",
      commonClasses.buttonRing,
      "focus:ring-primary-600",
      commonClasses.iconsSize,
      commonClasses.inputsTransition
    )
  },
  classes: {
    wrapper: "",
    clearButton: ""
  }
};
const dateTimeInputClassesKeys = Object.keys(dateTimeInputConfig.classes);

const __default__$b = {
  name: "VanillaDateTimeInput",
  inheritAttrs: false
};
const _sfc_main$c = /* @__PURE__ */ defineComponent({
  ...__default__$b,
  props: baseProps,
  setup(__props) {
    const props = __props;
    const localValue = useVModel(props, "modelValue");
    const { configuration, errors, variant } = useConfiguration(dateTimeInputConfig, "DateTimeInput", localValue);
    ({ ...DatePicker.props, ...baseProps });
    const formatRange = (start, end) => {
      if (!start || !end) {
        return "";
      }
      return `${start || ""} - ${start || ""}`;
    };
    watch(localValue, () => {
      if (localValue.value == "Invalid Date") {
        nextTick(() => {
          localValue.value = null;
        });
      }
    }, { immediate: false });
    return (_ctx, _cache) => {
      return openBlock(), createBlock(_sfc_main$d, null, {
        default: withCtx(() => [
          createVNode(unref(DatePicker), mergeProps({
            modelValue: unref(localValue),
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => isRef(localValue) ? localValue.value = $event : null),
            color: "indigo",
            "is-dark": { selector: ":root", darkClass: "dark" },
            "input-debounce": 1200,
            "update-on-input": true,
            popover: { visibility: "focus" }
          }, _ctx.$attrs), createSlots({ _: 2 }, [
            props.inline === false ? {
              name: "default",
              fn: withCtx(({ inputValue, inputEvents }) => [
                renderSlot(_ctx.$slots, "default", normalizeProps(guardReactiveProps({ inputValue, inputEvents })), () => [
                  createElementVNode("div", {
                    class: normalizeClass(unref(configuration).classesList.wrapper)
                  }, [
                    unref(get$4)(_ctx.$attrs, "is-range", false) === false ? (openBlock(), createBlock(_sfc_main$t, mergeProps({
                      key: 0,
                      "model-value": inputValue,
                      placeholder: props.placeholder,
                      errors: unref(errors),
                      variant: unref(variant),
                      disabled: _ctx.disabled,
                      feedback: props.feedback
                    }, toHandlers(inputEvents)), {
                      before: withCtx(() => [
                        renderSlot(_ctx.$slots, "before")
                      ]),
                      after: withCtx(() => [
                        unref(get$4)(_ctx.$attrs, "is-required", false) === false ? (openBlock(), createBlock(_sfc_main$B, {
                          key: 0,
                          class: normalizeClass(unref(configuration).classesList?.clearButton),
                          onClick: _cache[0] || (_cache[0] = ($event) => localValue.value = null)
                        }, null, 8, ["class"])) : createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1040, ["model-value", "placeholder", "errors", "variant", "disabled", "feedback"])) : createCommentVNode("", true),
                    unref(get$4)(_ctx.$attrs, "is-range", false) === true ? (openBlock(), createBlock(_sfc_main$t, mergeProps({
                      key: 1,
                      "model-value": formatRange(inputValue.start, inputValue.end),
                      placeholder: props.placeholder,
                      errors: unref(errors),
                      variant: unref(variant),
                      feedback: props.feedback
                    }, toHandlers({ ...inputEvents.start, ...inputEvents.end })), {
                      before: withCtx(() => [
                        renderSlot(_ctx.$slots, "before")
                      ]),
                      after: withCtx(() => [
                        unref(get$4)(_ctx.$attrs, "is-required", false) === false ? (openBlock(), createBlock(_sfc_main$B, {
                          key: 0,
                          class: normalizeClass(unref(configuration).classesList?.clearButton),
                          onClick: _cache[1] || (_cache[1] = ($event) => localValue.value = null)
                        }, null, 8, ["class"])) : createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1040, ["model-value", "placeholder", "errors", "variant", "feedback"])) : createCommentVNode("", true)
                  ], 2)
                ])
              ]),
              key: "0"
            } : void 0
          ]), 1040, ["modelValue"])
        ]),
        _: 3
      });
    };
  }
});

const _sfc_main$b = {
  name: "Fragment",
  render() {
    return createVNode(Fragment, null, this.$slots.default?.());
  }
};

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

var awesomePhonenumber = {exports: {}};

var lib = {exports: {}};

(function (module) {
(function(){/*

 Copyright The Closure Library Authors.
 SPDX-License-Identifier: Apache-2.0
*/
var aa=this||self;function h(a,b){function c(){}c.prototype=b.prototype;a.Ba=b.prototype;a.prototype=new c;a.prototype.constructor=a;a.Ha=function(d,e,f){for(var g=Array(arguments.length-2),l=2;l<arguments.length;l++)g[l-2]=arguments[l];return b.prototype[e].apply(d,g)};}function ba(a){var b=[];let c=0;for(var d in a)b[c++]=a[d];return b}function ca(a,b){this.h=a;this.g={};for(a=0;a<b.length;a++){var c=b[a];this.g[c.g]=c;}}function da(a){a=ba(a.g);a.sort(function(b,c){return b.g-c.g});return a}function ea(a,b){this.g=a;this.m=!!b.ga;this.h=b.i;this.u=b.type;this.s=!1;switch(this.h){case fa:case ha:case ia:case ja:case ka:case la:case ma:this.s=!0;}this.j=b.defaultValue;}var ma=1,la=2,fa=3,ha=4,ia=6,ja=16,ka=18;function k(){this.h={};this.j=this.o().g;this.g=this.m=null;}k.prototype.has=function(a){return m(this,a.g)};k.prototype.get=function(a,b){return n(this,a.g,b)};k.prototype.set=function(a,b){p(this,a.g,b);};k.prototype.add=function(a,b){na(this,a.g,b);};
function oa(a,b){for(var c=da(a.o()),d=0;d<c.length;d++){var e=c[d],f=e.g;if(m(b,f)){a.g&&delete a.g[e.g];var g=11==e.h||10==e.h;if(e.m){e=r(b,f);for(var l=0;l<e.length;l++)na(a,f,g?e[l].clone():e[l]);}else e=t(b,f),g?(g=t(a,f))?oa(g,e):p(a,f,e.clone()):p(a,f,e);}}}k.prototype.clone=function(){var a=new this.constructor;a!=this&&(a.h={},a.g&&(a.g={}),oa(a,this));return a};function m(a,b){return null!=a.h[b]}
function t(a,b){var c=a.h[b];if(null==c)return null;if(a.m){if(!(b in a.g)){var d=a.m,e=a.j[b];if(null!=c)if(e.m){for(var f=[],g=0;g<c.length;g++)f[g]=d.h(e,c[g]);c=f;}else c=d.h(e,c);return a.g[b]=c}return a.g[b]}return c}function n(a,b,c){var d=t(a,b);return a.j[b].m?d[c||0]:d}function u(a,b){if(m(a,b))a=n(a,b);else a:{a=a.j[b];if(void 0===a.j)if(b=a.u,b===Boolean)a.j=!1;else if(b===Number)a.j=0;else if(b===String)a.j=a.s?"0":"";else {a=new b;break a}a=a.j;}return a}
function r(a,b){return t(a,b)||[]}function v(a,b){return a.j[b].m?m(a,b)?a.h[b].length:0:m(a,b)?1:0}function p(a,b,c){a.h[b]=c;a.g&&(a.g[b]=c);}function na(a,b,c){a.h[b]||(a.h[b]=[]);a.h[b].push(c);a.g&&delete a.g[b];}function w(a,b){var c=[],d;for(d in b)0!=d&&c.push(new ea(d,b[d]));return new ca(a,c)}function x(){}x.prototype.g=function(a){new a.h;throw Error("Unimplemented");};x.prototype.h=function(a,b){if(11==a.h||10==a.h)return b instanceof k?b:this.g(a.u.prototype.o(),b);if(14==a.h)return "string"===typeof b&&pa.test(b)&&(a=Number(b),0<a)?a:b;if(!a.s)return b;a=a.u;if(a===String){if("number"===typeof b)return String(b)}else if(a===Number&&"string"===typeof b&&("Infinity"===b||"-Infinity"===b||"NaN"===b||pa.test(b)))return Number(b);return b};var pa=/^-?[0-9]+$/;function qa(){}h(qa,x);qa.prototype.g=function(a,b){a=new a.h;a.m=this;a.h=b;a.g={};return a};function y(){}h(y,qa);y.prototype.h=function(a,b){return 8==a.h?!!b:x.prototype.h.apply(this,arguments)};y.prototype.g=function(a,b){return y.Ba.g.call(this,a,b)};function z(a,b){null!=a&&this.g.apply(this,arguments);}z.prototype.h="";z.prototype.set=function(a){this.h=""+a;};z.prototype.g=function(a,b,c){this.h+=String(a);if(null!=b)for(let d=1;d<arguments.length;d++)this.h+=arguments[d];return this};function A(a){a.h="";}z.prototype.toString=function(){return this.h};/*

 Protocol Buffer 2 Copyright 2008 Google Inc.
 All other code copyright its respective owners.
 Copyright (C) 2010 The Libphonenumber Authors

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

 http://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
*/
function B(){k.call(this);}h(B,k);var ra=null;function C(){k.call(this);}h(C,k);var sa=null;function D(){k.call(this);}h(D,k);var ta=null;D.prototype.ia=function(){return n(this,10)};
B.prototype.o=function(){var a=ra;a||(ra=a=w(B,{0:{name:"NumberFormat",na:"i18n.phonenumbers.NumberFormat"},1:{name:"pattern",required:!0,i:9,type:String},2:{name:"format",required:!0,i:9,type:String},3:{name:"leading_digits_pattern",ga:!0,i:9,type:String},4:{name:"national_prefix_formatting_rule",i:9,type:String},6:{name:"national_prefix_optional_when_formatting",i:8,defaultValue:!1,type:Boolean},5:{name:"domestic_carrier_code_formatting_rule",i:9,type:String}}));return a};B.o=B.prototype.o;
C.prototype.o=function(){var a=sa;a||(sa=a=w(C,{0:{name:"PhoneNumberDesc",na:"i18n.phonenumbers.PhoneNumberDesc"},2:{name:"national_number_pattern",i:9,type:String},9:{name:"possible_length",ga:!0,i:5,type:Number},10:{name:"possible_length_local_only",ga:!0,i:5,type:Number},6:{name:"example_number",i:9,type:String}}));return a};C.o=C.prototype.o;
D.prototype.o=function(){var a=ta;a||(ta=a=w(D,{0:{name:"PhoneMetadata",na:"i18n.phonenumbers.PhoneMetadata"},1:{name:"general_desc",i:11,type:C},2:{name:"fixed_line",i:11,type:C},3:{name:"mobile",i:11,type:C},4:{name:"toll_free",i:11,type:C},5:{name:"premium_rate",i:11,type:C},6:{name:"shared_cost",i:11,type:C},7:{name:"personal_number",i:11,type:C},8:{name:"voip",i:11,type:C},21:{name:"pager",i:11,type:C},25:{name:"uan",i:11,type:C},27:{name:"emergency",i:11,type:C},28:{name:"voicemail",i:11,type:C},
29:{name:"short_code",i:11,type:C},30:{name:"standard_rate",i:11,type:C},31:{name:"carrier_specific",i:11,type:C},33:{name:"sms_services",i:11,type:C},24:{name:"no_international_dialling",i:11,type:C},9:{name:"id",required:!0,i:9,type:String},10:{name:"country_code",i:5,type:Number},11:{name:"international_prefix",i:9,type:String},17:{name:"preferred_international_prefix",i:9,type:String},12:{name:"national_prefix",i:9,type:String},13:{name:"preferred_extn_prefix",i:9,type:String},15:{name:"national_prefix_for_parsing",
i:9,type:String},16:{name:"national_prefix_transform_rule",i:9,type:String},18:{name:"same_mobile_and_fixed_line_pattern",i:8,defaultValue:!1,type:Boolean},19:{name:"number_format",ga:!0,i:11,type:B},20:{name:"intl_number_format",ga:!0,i:11,type:B},22:{name:"main_country_for_code",i:8,defaultValue:!1,type:Boolean},23:{name:"leading_digits",i:9,type:String}}));return a};D.o=D.prototype.o;function E(){k.call(this);}h(E,k);var ua=null;E.prototype.ia=function(){return n(this,1)};var va={Ga:0,Fa:1,Ea:5,Da:10,Ca:20};
E.prototype.o=function(){var a=ua;a||(ua=a=w(E,{0:{name:"PhoneNumber",na:"i18n.phonenumbers.PhoneNumber"},1:{name:"country_code",required:!0,i:5,type:Number},2:{name:"national_number",required:!0,i:4,type:Number},3:{name:"extension",i:9,type:String},4:{name:"italian_leading_zero",i:8,type:Boolean},8:{name:"number_of_leading_zeros",i:5,defaultValue:1,type:Number},5:{name:"raw_input",i:9,type:String},6:{name:"country_code_source",i:14,defaultValue:0,type:va},7:{name:"preferred_domestic_carrier_code",
i:9,type:String}}));return a};E.ctor=E;E.ctor.o=E.prototype.o;/*

 Copyright (C) 2010 The Libphonenumber Authors

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

 http://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
*/
var F={1:"US AG AI AS BB BM BS CA DM DO GD GU JM KN KY LC MP MS PR SX TC TT VC VG VI".split(" "),7:["RU","KZ"],20:["EG"],27:["ZA"],30:["GR"],31:["NL"],32:["BE"],33:["FR"],34:["ES"],36:["HU"],39:["IT","VA"],40:["RO"],41:["CH"],43:["AT"],44:["GB","GG","IM","JE"],45:["DK"],46:["SE"],47:["NO","SJ"],48:["PL"],49:["DE"],51:["PE"],52:["MX"],53:["CU"],54:["AR"],55:["BR"],56:["CL"],57:["CO"],58:["VE"],60:["MY"],61:["AU","CC","CX"],62:["ID"],63:["PH"],64:["NZ"],65:["SG"],66:["TH"],81:["JP"],82:["KR"],84:["VN"],
86:["CN"],90:["TR"],91:["IN"],92:["PK"],93:["AF"],94:["LK"],95:["MM"],98:["IR"],211:["SS"],212:["MA","EH"],213:["DZ"],216:["TN"],218:["LY"],220:["GM"],221:["SN"],222:["MR"],223:["ML"],224:["GN"],225:["CI"],226:["BF"],227:["NE"],228:["TG"],229:["BJ"],230:["MU"],231:["LR"],232:["SL"],233:["GH"],234:["NG"],235:["TD"],236:["CF"],237:["CM"],238:["CV"],239:["ST"],240:["GQ"],241:["GA"],242:["CG"],243:["CD"],244:["AO"],245:["GW"],246:["IO"],247:["AC"],248:["SC"],249:["SD"],250:["RW"],251:["ET"],252:["SO"],
253:["DJ"],254:["KE"],255:["TZ"],256:["UG"],257:["BI"],258:["MZ"],260:["ZM"],261:["MG"],262:["RE","YT"],263:["ZW"],264:["NA"],265:["MW"],266:["LS"],267:["BW"],268:["SZ"],269:["KM"],290:["SH","TA"],291:["ER"],297:["AW"],298:["FO"],299:["GL"],350:["GI"],351:["PT"],352:["LU"],353:["IE"],354:["IS"],355:["AL"],356:["MT"],357:["CY"],358:["FI","AX"],359:["BG"],370:["LT"],371:["LV"],372:["EE"],373:["MD"],374:["AM"],375:["BY"],376:["AD"],377:["MC"],378:["SM"],380:["UA"],381:["RS"],382:["ME"],383:["XK"],385:["HR"],
386:["SI"],387:["BA"],389:["MK"],420:["CZ"],421:["SK"],423:["LI"],500:["FK"],501:["BZ"],502:["GT"],503:["SV"],504:["HN"],505:["NI"],506:["CR"],507:["PA"],508:["PM"],509:["HT"],590:["GP","BL","MF"],591:["BO"],592:["GY"],593:["EC"],594:["GF"],595:["PY"],596:["MQ"],597:["SR"],598:["UY"],599:["CW","BQ"],670:["TL"],672:["NF"],673:["BN"],674:["NR"],675:["PG"],676:["TO"],677:["SB"],678:["VU"],679:["FJ"],680:["PW"],681:["WF"],682:["CK"],683:["NU"],685:["WS"],686:["KI"],687:["NC"],688:["TV"],689:["PF"],690:["TK"],
691:["FM"],692:["MH"],800:["001"],808:["001"],850:["KP"],852:["HK"],853:["MO"],855:["KH"],856:["LA"],870:["001"],878:["001"],880:["BD"],881:["001"],882:["001"],883:["001"],886:["TW"],888:["001"],960:["MV"],961:["LB"],962:["JO"],963:["SY"],964:["IQ"],965:["KW"],966:["SA"],967:["YE"],968:["OM"],970:["PS"],971:["AE"],972:["IL"],973:["BH"],974:["QA"],975:["BT"],976:["MN"],977:["NP"],979:["001"],992:["TJ"],993:["TM"],994:["AZ"],995:["GE"],996:["KG"],998:["UZ"]},G={AC:[,[,,"(?:[01589]\\d|[46])\\d{4}",,
,,,,,[5,6]],[,,"6[2-467]\\d{3}",,,,"62889",,,[5]],[,,"4\\d{4}",,,,"40123",,,[5]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"AC",247,"00",,,,,,,,,,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"(?:0[1-9]|[1589]\\d)\\d{4}",,,,"542011",,,[6]],,,[,,,,,,,,,[-1]]],AD:[,[,,"(?:1|6\\d)\\d{7}|[135-9]\\d{5}",,,,,,,[6,8,9]],[,,"[78]\\d{5}",,,,"712345",,,[6]],[,,"690\\d{6}|[356]\\d{5}",,,,"312345",,,[6,9]],[,,"180[02]\\d{4}",,,,"18001234",,,[8]],[,,"[19]\\d{5}",,,,"912345",,,[6]],
[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"AD",376,"00",,,,,,,,[[,"(\\d{3})(\\d{3})","$1 $2",["[135-9]"]],[,"(\\d{4})(\\d{4})","$1 $2",["1"]],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["6"]]],,[,,,,,,,,,[-1]],,,[,,"1800\\d{4}",,,,,,,[8]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],AE:[,[,,"(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}",,,,,,,[5,6,7,8,9,10,11,12]],[,,"[2-4679][2-8]\\d{6}",,,,"22345678",,,[8],[7]],[,,"5[024-68]\\d{7}",,,,"501234567",,,[9]],[,,"400\\d{6}|800\\d{2,9}",,,,"800123456"],
[,,"900[02]\\d{5}",,,,"900234567",,,[9]],[,,"700[05]\\d{5}",,,,"700012345",,,[9]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"AE",971,"00","0",,,"0",,,,[[,"(\\d{3})(\\d{2,9})","$1 $2",["60|8"]],[,"(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["[236]|[479][2-8]"],"0$1"],[,"(\\d{3})(\\d)(\\d{5})","$1 $2 $3",["[479]"]],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["5"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"600[25]\\d{5}",,,,"600212345",,,[9]],,,[,,,,,,,,,[-1]]],AF:[,[,,"[2-7]\\d{8}",,,,,,,[9],[7]],[,,"(?:[25][0-8]|[34][0-4]|6[0-5])[2-9]\\d{6}",
,,,"234567890",,,,[7]],[,,"7\\d{8}",,,,"701234567",,,,[7]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"AF",93,"00","0",,,"0",,,,[[,"(\\d{3})(\\d{4})","$1 $2",["[1-9]"]],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[2-7]"],"0$1"]],[[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[2-7]"],"0$1"]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],AG:[,[,,"(?:268|[58]\\d\\d|900)\\d{7}",,,,,,,[10],[7]],[,,"268(?:4(?:6[0-38]|84)|56[0-2])\\d{4}",,,,"2684601234",
,,,[7]],[,,"268(?:464|7(?:1[3-9]|[28]\\d|3[0246]|64|7[0-689]))\\d{4}",,,,"2684641234",,,,[7]],[,,"8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",,,,"8002123456"],[,,"900[2-9]\\d{6}",,,,"9002123456"],[,,,,,,,,,[-1]],[,,"52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",,,,"5002345678"],[,,"26848[01]\\d{4}",,,,"2684801234",,,,[7]],
"AG",1,"011","1",,,"([457]\\d{6})$|1","268$1",,,,,[,,"26840[69]\\d{4}",,,,"2684061234",,,,[7]],,"268",[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],AI:[,[,,"(?:264|[58]\\d\\d|900)\\d{7}",,,,,,,[10],[7]],[,,"264(?:292|4(?:6[12]|9[78]))\\d{4}",,,,"2644612345",,,,[7]],[,,"264(?:235|4(?:69|76)|5(?:3[6-9]|8[1-4])|7(?:29|72))\\d{4}",,,,"2642351234",,,,[7]],[,,"8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",,,,"8002123456"],[,,"900[2-9]\\d{6}",,,,"9002123456"],[,,,,,,,,,[-1]],[,,"52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
,,,"5002345678"],[,,,,,,,,,[-1]],"AI",1,"011","1",,,"([2457]\\d{6})$|1","264$1",,,,,[,,"264724\\d{4}",,,,"2647241234",,,,[7]],,"264",[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],AL:[,[,,"(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}",,,,,,,[6,7,8,9],[5]],[,,"4505[0-2]\\d{3}|(?:[2358][16-9]\\d[2-9]|4410)\\d{4}|(?:[2358][2-5][2-9]|4(?:[2-57-9][2-9]|6\\d))\\d{5}",,,,"22345678",,,[8],[5,6,7]],[,,"6(?:[78][2-9]|9\\d)\\d{6}",,,,"672123456",,,[9]],[,,"800\\d{4}",,,,"8001234",,,[7]],[,,"900[1-9]\\d\\d",
,,,"900123",,,[6]],[,,"808[1-9]\\d\\d",,,,"808123",,,[6]],[,,"700[2-9]\\d{4}",,,,"70021234",,,[8]],[,,,,,,,,,[-1]],"AL",355,"00","0",,,"0",,,,[[,"(\\d{3})(\\d{3,4})","$1 $2",["80|9"],"0$1"],[,"(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["4[2-6]"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[2358][2-5]|4"],"0$1"],[,"(\\d{3})(\\d{5})","$1 $2",["[23578]"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["6"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],AM:[,[,,"(?:[1-489]\\d|55|60|77)\\d{6}",
,,,,,,[8],[5,6]],[,,"(?:(?:1[0-25]|47)\\d|2(?:2[2-46]|3[1-8]|4[2-69]|5[2-7]|6[1-9]|8[1-7])|3[12]2)\\d{5}",,,,"10123456",,,,[5,6]],[,,"(?:33|4[1349]|55|77|88|9[13-9])\\d{6}",,,,"77123456"],[,,"800\\d{5}",,,,"80012345"],[,,"90[016]\\d{5}",,,,"90012345"],[,,"80[1-4]\\d{5}",,,,"80112345"],[,,,,,,,,,[-1]],[,,"60(?:2[78]|3[5-9]|4[02-9]|5[0-46-9]|[6-8]\\d|9[01])\\d{4}",,,,"60271234"],"AM",374,"00","0",,,"0",,,,[[,"(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["[89]0"],"0 $1"],[,"(\\d{3})(\\d{5})","$1 $2",["2|3[12]"],
"(0$1)"],[,"(\\d{2})(\\d{6})","$1 $2",["1|47"],"(0$1)"],[,"(\\d{2})(\\d{6})","$1 $2",["[3-9]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],AO:[,[,,"[29]\\d{8}",,,,,,,[9]],[,,"2\\d(?:[0134][25-9]|[25-9]\\d)\\d{5}",,,,"222123456"],[,,"9[1-59]\\d{7}",,,,"923123456"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"AO",244,"00",,,,,,,,[[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[29]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],
,,[,,,,,,,,,[-1]]],AR:[,[,,"(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}",,,,,,,[10,11],[6,7,8]],[,,"3888[013-9]\\d{5}|3(?:7(?:1[15]|81)|8(?:21|4[16]|69|9[12]))[46]\\d{5}|(?:29(?:54|66)|3(?:7(?:55|77)|865))[2-8]\\d{5}|(?:2(?:2(?:2[59]|44|52)|3(?:26|44)|473|9(?:[07]2|2[26]|34|46))|3327)[45]\\d{5}|(?:2(?:284|3(?:02|23)|657|920)|3(?:4(?:8[27]|92)|541|878))[2-7]\\d{5}|(?:2(?:(?:26|62)2|320|477|9(?:42|83))|3(?:329|4(?:[47]6|62|89)|564))[2-6]\\d{5}|(?:(?:11[1-8]|670)\\d|2(?:2(?:0[45]|1[2-6]|3[3-6])|3(?:[06]4|7[45])|494|6(?:04|1[2-8]|[36][45]|4[3-6])|80[45]|9(?:[17][4-6]|[48][45]|9[3-6]))|3(?:364|4(?:1[2-7]|[235][4-6]|84)|5(?:1[2-9]|[38][4-6])|6(?:2[45]|44)|7[069][45]|8(?:0[45]|[17][2-6]|3[4-6]|[58][3-6])))\\d{6}|2(?:2(?:21|4[23]|6[145]|7[1-4]|8[356]|9[267])|3(?:16|3[13-8]|43|5[346-8]|9[3-5])|475|6(?:2[46]|4[78]|5[1568])|9(?:03|2[1457-9]|3[1356]|4[08]|[56][23]|82))4\\d{5}|(?:2(?:2(?:57|81)|3(?:24|46|92)|9(?:01|23|64))|3(?:4(?:42|71)|5(?:25|37|4[347]|71)|7(?:18|5[17])))[3-6]\\d{5}|(?:2(?:2(?:02|2[3467]|4[156]|5[45]|6[6-8]|91)|3(?:1[47]|25|[45][25]|96)|47[48]|625|932)|3(?:38[2578]|4(?:0[0-24-9]|3[78]|4[457]|58|6[03-9]|72|83|9[136-8])|5(?:2[124]|[368][23]|4[2689]|7[2-6])|7(?:16|2[15]|3[145]|4[13]|5[468]|7[2-5]|8[26])|8(?:2[5-7]|3[278]|4[3-5]|5[78]|6[1-378]|[78]7|94)))[4-6]\\d{5}",
,,,"1123456789",,,[10],[6,7,8]],[,,"93(?:7(?:1[15]|81)[46]|8(?:(?:21|4[16]|69|9[12])[46]|88[013-9]))\\d{5}|9(?:29(?:54|66)|3(?:7(?:55|77)|865))[2-8]\\d{5}|9(?:2(?:2(?:2[59]|44|52)|3(?:26|44)|473|9(?:[07]2|2[26]|34|46))|3327)[45]\\d{5}|9(?:2(?:284|3(?:02|23)|657|920)|3(?:4(?:8[27]|92)|541|878))[2-7]\\d{5}|9(?:2(?:(?:26|62)2|320|477|9(?:42|83))|3(?:329|4(?:[47]6|62|89)|564))[2-6]\\d{5}|(?:675\\d|9(?:11[1-8]\\d|2(?:2(?:0[45]|1[2-6]|3[3-6])|3(?:[06]4|7[45])|494|6(?:04|1[2-8]|[36][45]|4[3-6])|80[45]|9(?:[17][4-6]|[48][45]|9[3-6]))|3(?:364|4(?:1[2-7]|[235][4-6]|84)|5(?:1[2-9]|[38][4-6])|6(?:2[45]|44)|7[069][45]|8(?:0[45]|[17][2-6]|3[4-6]|[58][3-6]))))\\d{6}|92(?:2(?:21|4[23]|6[145]|7[1-4]|8[356]|9[267])|3(?:16|3[13-8]|43|5[346-8]|9[3-5])|475|6(?:2[46]|4[78]|5[1568])|9(?:03|2[1457-9]|3[1356]|4[08]|[56][23]|82))4\\d{5}|9(?:2(?:2(?:57|81)|3(?:24|46|92)|9(?:01|23|64))|3(?:4(?:42|71)|5(?:25|37|4[347]|71)|7(?:18|5[17])))[3-6]\\d{5}|9(?:2(?:2(?:02|2[3467]|4[156]|5[45]|6[6-8]|91)|3(?:1[47]|25|[45][25]|96)|47[48]|625|932)|3(?:38[2578]|4(?:0[0-24-9]|3[78]|4[457]|58|6[03-9]|72|83|9[136-8])|5(?:2[124]|[368][23]|4[2689]|7[2-6])|7(?:16|2[15]|3[145]|4[13]|5[468]|7[2-5]|8[26])|8(?:2[5-7]|3[278]|4[3-5]|5[78]|6[1-378]|[78]7|94)))[4-6]\\d{5}",
,,,"91123456789",,,,[6,7,8]],[,,"800\\d{7,8}",,,,"8001234567"],[,,"60[04579]\\d{7}",,,,"6001234567",,,[10]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"AR",54,"00","0",,,"0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?",
"9$1",,,[[,"(\\d{3})","$1",["0|1(?:0[0-35-7]|1[02-5]|2[015]|3[47]|4[478])|911"]],[,"(\\d{2})(\\d{4})","$1-$2",["[1-9]"]],[,"(\\d{3})(\\d{4})","$1-$2",["[2-9]"]],[,"(\\d{4})(\\d{4})","$1-$2",["[1-8]"]],[,"(\\d{4})(\\d{2})(\\d{4})","$1 $2-$3",["2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])","2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)",
"2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]","2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"],
"0$1",,1],[,"(\\d{2})(\\d{4})(\\d{4})","$1 $2-$3",["1"],"0$1",,1],[,"(\\d{3})(\\d{3})(\\d{4})","$1-$2-$3",["[68]"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2-$3",["[23]"],"0$1",,1],[,"(\\d)(\\d{4})(\\d{2})(\\d{4})","$2 15-$3-$4",["9(?:2[2-469]|3[3-578])","9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))","9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)",
"9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]","9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"],
"0$1"],[,"(\\d)(\\d{2})(\\d{4})(\\d{4})","$2 15-$3-$4",["91"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{5})","$1-$2-$3",["8"],"0$1"],[,"(\\d)(\\d{3})(\\d{3})(\\d{4})","$2 15-$3-$4",["9"],"0$1"]],[[,"(\\d{4})(\\d{2})(\\d{4})","$1 $2-$3",["2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])","2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)",
"2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]","2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"],
"0$1",,1],[,"(\\d{2})(\\d{4})(\\d{4})","$1 $2-$3",["1"],"0$1",,1],[,"(\\d{3})(\\d{3})(\\d{4})","$1-$2-$3",["[68]"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2-$3",["[23]"],"0$1",,1],[,"(\\d)(\\d{4})(\\d{2})(\\d{4})","$1 $2 $3-$4",["9(?:2[2-469]|3[3-578])","9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))","9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)",
"9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]","9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"]],
[,"(\\d)(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3-$4",["91"]],[,"(\\d{3})(\\d{3})(\\d{5})","$1-$2-$3",["8"],"0$1"],[,"(\\d)(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3-$4",["9"]]],[,,,,,,,,,[-1]],,,[,,"810\\d{7}",,,,,,,[10]],[,,"810\\d{7}",,,,"8101234567",,,[10]],,,[,,,,,,,,,[-1]]],AS:[,[,,"(?:[58]\\d\\d|684|900)\\d{7}",,,,,,,[10],[7]],[,,"6846(?:22|33|44|55|77|88|9[19])\\d{4}",,,,"6846221234",,,,[7]],[,,"684(?:2(?:48|5[2468]|7[26])|7(?:3[13]|70|82))\\d{4}",,,,"6847331234",,,,[7]],[,,"8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
,,,"8002123456"],[,,"900[2-9]\\d{6}",,,,"9002123456"],[,,,,,,,,,[-1]],[,,"52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",,,,"5002345678"],[,,,,,,,,,[-1]],"AS",1,"011","1",,,"([267]\\d{6})$|1","684$1",,,,,[,,,,,,,,,[-1]],,"684",[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],AT:[,[,,"1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}",
,,,,,,[4,5,6,7,8,9,10,11,12,13],[3]],[,,"1(?:11\\d|[2-9]\\d{3,11})|(?:316|463|(?:51|66|73)2)\\d{3,10}|(?:2(?:1[467]|2[13-8]|5[2357]|6[1-46-8]|7[1-8]|8[124-7]|9[1458])|3(?:1[1-578]|3[23568]|4[5-7]|5[1378]|6[1-38]|8[3-68])|4(?:2[1-8]|35|7[1368]|8[2457])|5(?:2[1-8]|3[357]|4[147]|5[12578]|6[37])|6(?:13|2[1-47]|4[135-8]|5[468])|7(?:2[1-8]|35|4[13478]|5[68]|6[16-8]|7[1-6]|9[45]))\\d{4,10}",,,,"1234567890",,,,[3]],[,,"6(?:5[0-3579]|6[013-9]|[7-9]\\d)\\d{4,10}",,,,"664123456",,,[7,8,9,10,11,12,13]],[,,"800\\d{6,10}",
,,,"800123456",,,[9,10,11,12,13]],[,,"(?:8[69][2-68]|9(?:0[01]|3[019]))\\d{6,10}",,,,"900123456",,,[9,10,11,12,13]],[,,"8(?:10|2[018])\\d{6,10}|828\\d{5}",,,,"810123456",,,[8,9,10,11,12,13]],[,,,,,,,,,[-1]],[,,"5(?:0[1-9]|17|[79]\\d)\\d{2,10}|7[28]0\\d{6,10}",,,,"780123456",,,[5,6,7,8,9,10,11,12,13]],"AT",43,"00","0",,,"0",,,,[[,"(\\d{4})","$1",["14"]],[,"(\\d)(\\d{3,12})","$1 $2",["1(?:11|[2-9])"],"0$1"],[,"(\\d{3})(\\d{2})","$1 $2",["517"],"0$1"],[,"(\\d{2})(\\d{3,5})","$1 $2",["5[079]"],"0$1"],
[,"(\\d{6})","$1",["[18]"]],[,"(\\d{3})(\\d{3,10})","$1 $2",["(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]"],"0$1"],[,"(\\d{4})(\\d{3,9})","$1 $2",["[2-467]|5[2-6]"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["5"],"0$1"],[,"(\\d{2})(\\d{4})(\\d{4,7})","$1 $2 $3",["5"],"0$1"]],[[,"(\\d)(\\d{3,12})","$1 $2",["1(?:11|[2-9])"],"0$1"],[,"(\\d{3})(\\d{2})","$1 $2",["517"],"0$1"],[,"(\\d{2})(\\d{3,5})","$1 $2",["5[079]"],"0$1"],[,"(\\d{3})(\\d{3,10})","$1 $2",["(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]"],
"0$1"],[,"(\\d{4})(\\d{3,9})","$1 $2",["[2-467]|5[2-6]"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["5"],"0$1"],[,"(\\d{2})(\\d{4})(\\d{4,7})","$1 $2 $3",["5"],"0$1"]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],AU:[,[,,"1(?:[0-79]\\d{7}(?:\\d(?:\\d{2})?)?|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}",,,,,,,[5,6,7,8,9,10,12]],[,,"(?:(?:2(?:[0-26-9]\\d|3[0-8]|4[02-9]|5[0135-9])|3(?:[0-3589]\\d|4[0-578]|6[1-9]|7[0-35-9])|7(?:[013-57-9]\\d|2[0-8]))\\d{3}|8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-79]|[18][13579]|2[14-9]|3[0-46-9]|[4-6]\\d|7[89]|9[0-4]))|(?:6[0-8]|[78]\\d)\\d{3}|9(?:[02-9]\\d{3}|1(?:(?:[0-58]\\d|6[0135-9])\\d|7(?:0[0-24-9]|[1-9]\\d)|9(?:[0-46-9]\\d|5[0-79])))))\\d{3}",
,,,"212345678",,,[9],[8]],[,,"4(?:79[01]|83[0-389]|93[0-6])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[016-9]|7[02-8]|8[0-24-9]|9[0-27-9])\\d{6}",,,,"412345678",,,[9]],[,,"180(?:0\\d{3}|2)\\d{3}",,,,"1800123456",,,[7,10]],[,,"190[0-26]\\d{6}",,,,"1900123456",,,[10]],[,,"13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",,,,"1300123456",,,[6,8,10,12]],[,,,,,,,,,[-1]],[,,"14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",,,,"147101234",,,[9]],"AU",61,"001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011","0",,,
"(183[12])|0",,"0011",,[[,"(\\d{2})(\\d{3,4})","$1 $2",["16"],"0$1"],[,"(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["13"]],[,"(\\d{3})(\\d{3})","$1 $2",["19"]],[,"(\\d{3})(\\d{4})","$1 $2",["180","1802"]],[,"(\\d{4})(\\d{3,4})","$1 $2",["19"]],[,"(\\d{2})(\\d{3})(\\d{2,4})","$1 $2 $3",["16"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["14|4"],"0$1"],[,"(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["[2378]"],"(0$1)","$CC ($1)"],[,"(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1(?:30|[89])"]],[,"(\\d{4})(\\d{4})(\\d{4})",
"$1 $2 $3",["130"]]],[[,"(\\d{2})(\\d{3,4})","$1 $2",["16"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{2,4})","$1 $2 $3",["16"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["14|4"],"0$1"],[,"(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["[2378]"],"(0$1)","$CC ($1)"],[,"(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1(?:30|[89])"]]],[,,"163\\d{2,6}",,,,"1631234",,,[5,6,7,8,9]],1,,[,,"1(?:3(?:00\\d{5}|45[0-4])|802)\\d{3}|1[38]00\\d{6}|13\\d{4}",,,,,,,[6,7,8,10,12]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],AW:[,[,,"(?:[25-79]\\d\\d|800)\\d{4}",
,,,,,,[7]],[,,"5(?:2\\d|8[1-9])\\d{4}",,,,"5212345"],[,,"(?:290|5[69]\\d|6(?:[03]0|22|4[0-2]|[69]\\d)|7(?:[34]\\d|7[07])|9(?:6[45]|9[4-8]))\\d{4}",,,,"5601234"],[,,"800\\d{4}",,,,"8001234"],[,,"900\\d{4}",,,,"9001234"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"(?:28\\d|501)\\d{4}",,,,"5011234"],"AW",297,"00",,,,,,,,[[,"(\\d{3})(\\d{4})","$1 $2",["[25-9]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],AX:[,[,,"2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}",
,,,,,,[5,6,7,8,9,10,11,12]],[,,"18[1-8]\\d{3,6}",,,,"181234567",,,[6,7,8,9]],[,,"4946\\d{2,6}|(?:4[0-8]|50)\\d{4,8}",,,,"412345678",,,[6,7,8,9,10]],[,,"800\\d{4,6}",,,,"800123456",,,[7,8,9]],[,,"[67]00\\d{5,6}",,,,"600123456",,,[8,9]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"AX",358,"00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))","0",,,"0",,"00",,,,[,,,,,,,,,[-1]],,"18",[,,,,,,,,,[-1]],[,,"20\\d{4,8}|60[12]\\d{5,6}|7(?:099\\d{4,5}|5[03-9]\\d{3,7})|20[2-59]\\d\\d|(?:606|7(?:0[78]|1|3\\d))\\d{7}|(?:10|29|3[09]|70[1-5]\\d)\\d{4,8}",
,,,"10112345"],,,[,,,,,,,,,[-1]]],AZ:[,[,,"365\\d{6}|(?:[124579]\\d|60|88)\\d{7}",,,,,,,[9],[7]],[,,"(?:2[12]428|3655[02])\\d{4}|(?:2(?:22[0-79]|63[0-28])|3654)\\d{5}|(?:(?:1[28]|46)\\d|2(?:[014-6]2|[23]3))\\d{6}",,,,"123123456",,,,[7]],[,,"36554\\d{4}|(?:[16]0|4[04]|5[015]|7[07]|99)\\d{7}",,,,"401234567"],[,,"88\\d{7}",,,,"881234567"],[,,"900200\\d{3}",,,,"900200123"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"AZ",994,"00","0",,,"0",,,,[[,"(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3",["[1-9]"]],[,
"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["90"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["1[28]|2|365|46","1[28]|2|365[45]|46","1[28]|2|365(?:4|5[02])|46"],"(0$1)"],[,"(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[13-9]"],"0$1"]],[[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["90"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["1[28]|2|365|46","1[28]|2|365[45]|46","1[28]|2|365(?:4|5[02])|46"],"(0$1)"],[,"(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",
["[13-9]"],"0$1"]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],BA:[,[,,"6\\d{8}|(?:[35689]\\d|49|70)\\d{6}",,,,,,,[8,9],[6]],[,,"(?:3(?:[05-79][2-9]|1[4579]|[23][24-9]|4[2-4689]|8[2457-9])|49[2-579]|5(?:0[2-49]|[13][2-9]|[268][2-4679]|4[4689]|5[2-79]|7[2-69]|9[2-4689]))\\d{5}",,,,"30212345",,,[8],[6]],[,,"6040\\d{5}|6(?:03|[1-356]|44|7\\d)\\d{6}",,,,"61123456"],[,,"8[08]\\d{6}",,,,"80123456",,,[8]],[,,"9[0246]\\d{6}",,,,"90123456",,,[8]],[,,"8[12]\\d{6}",,,,"82123456",,,[8]],
[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"BA",387,"00","0",,,"0",,,,[[,"(\\d{3})(\\d{3})","$1-$2",["[2-9]"]],[,"(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["6[1-3]|[7-9]"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{3})","$1 $2-$3",["[3-5]|6[56]"],"0$1"],[,"(\\d{2})(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3 $4",["6"],"0$1"]],[[,"(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["6[1-3]|[7-9]"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{3})","$1 $2-$3",["[3-5]|6[56]"],"0$1"],[,"(\\d{2})(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3 $4",["6"],"0$1"]],[,,,,,,,,,[-1]],
,,[,,,,,,,,,[-1]],[,,"703[235]0\\d{3}|70(?:2[0-5]|3[0146]|[56]0)\\d{4}",,,,"70341234",,,[8]],,,[,,,,,,,,,[-1]]],BB:[,[,,"(?:246|[58]\\d\\d|900)\\d{7}",,,,,,,[10],[7]],[,,"246521[0369]\\d{3}|246(?:2(?:2[78]|7[0-4])|4(?:1[024-6]|2\\d|3[2-9])|5(?:20|[34]\\d|54|7[1-3])|6(?:2\\d|38)|7[35]7|9(?:1[89]|63))\\d{4}",,,,"2464123456",,,,[7]],[,,"246(?:(?:2(?:[3568]\\d|4[0-57-9])|3(?:5[2-9]|6[0-6])|4(?:46|5\\d)|69[5-7]|8(?:[2-5]\\d|83))\\d|52(?:1[147]|20))\\d{3}",,,,"2462501234",,,,[7]],[,,"8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
,,,"8002123456"],[,,"(?:246976|900[2-9]\\d\\d)\\d{4}",,,,"9002123456",,,,[7]],[,,,,,,,,,[-1]],[,,"52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",,,,"5002345678"],[,,"24631\\d{5}",,,,"2463101234",,,,[7]],"BB",1,"011","1",,,"([2-9]\\d{6})$|1","246$1",,,,,[,,,,,,,,,[-1]],,"246",[,,,,,,,,,[-1]],[,,"246(?:292|367|4(?:1[7-9]|3[01]|4[47-9]|67)|7(?:1[2-9]|2\\d|3[016]|53))\\d{4}",
,,,"2464301234",,,,[7]],,,[,,,,,,,,,[-1]]],BD:[,[,,"[1-469]\\d{9}|8[0-79]\\d{7,8}|[2-79]\\d{8}|[2-9]\\d{7}|[3-9]\\d{6}|[57-9]\\d{5}",,,,,,,[6,7,8,9,10]],[,,"(?:4(?:31\\d\\d|423)|5222)\\d{3}(?:\\d{2})?|8332[6-9]\\d\\d|(?:3(?:03[56]|224)|4(?:22[25]|653))\\d{3,4}|(?:3(?:42[47]|529|823)|4(?:027|525|65(?:28|8))|562|6257|7(?:1(?:5[3-5]|6[12]|7[156]|89)|22[589]56|32|42675|52(?:[25689](?:56|8)|[347]8)|71(?:6[1267]|75|89)|92374)|82(?:2[59]|32)56|9(?:03[23]56|23(?:256|373)|31|5(?:1|2[4589]56)))\\d{3}|(?:3(?:02[348]|22[35]|324|422)|4(?:22[67]|32[236-9]|6(?:2[46]|5[57])|953)|5526|6(?:024|6655)|81)\\d{4,5}|(?:2(?:7(?:1[0-267]|2[0-289]|3[0-29]|4[01]|5[1-3]|6[013]|7[0178]|91)|8(?:0[125]|1[1-6]|2[0157-9]|3[1-69]|41|6[1-35]|7[1-5]|8[1-8]|9[0-6])|9(?:0[0-2]|1[0-4]|2[568]|3[3-6]|5[5-7]|6[0136-9]|7[0-7]|8[014-9]))|3(?:0(?:2[025-79]|3[2-4])|181|22[12]|32[2356]|824)|4(?:02[09]|22[348]|32[045]|523|6(?:27|54))|666(?:22|53)|7(?:22[57-9]|42[56]|82[35])8|8(?:0[124-9]|2(?:181|2[02-4679]8)|4[12]|[5-7]2)|9(?:[04]2|2(?:2|328)|81))\\d{4}|(?:2(?:222|[45]\\d)\\d|3(?:1(?:2[5-7]|[5-7])|425|822)|4(?:033|1\\d|[257]1|332|4(?:2[246]|5[25])|6(?:2[35]|56|62)|8(?:23|54)|92[2-5])|5(?:02[03489]|22[457]|32[35-79]|42[46]|6(?:[18]|53)|724|826)|6(?:023|2(?:2[2-5]|5[3-5]|8)|32[3478]|42[34]|52[47]|6(?:[18]|6(?:2[34]|5[24]))|[78]2[2-5]|92[2-6])|7(?:02|21\\d|[3-589]1|6[12]|72[24])|8(?:217|3[12]|[5-7]1)|9[24]1)\\d{5}|(?:(?:3[2-8]|5[2-57-9]|6[03-589])1|4[4689][18])\\d{5}|[59]1\\d{5}",
,,,"27111234"],[,,"(?:1[13-9]\\d|644)\\d{7}|(?:3[78]|44|66)[02-9]\\d{7}",,,,"1812345678",,,[10]],[,,"80[03]\\d{7}",,,,"8001234567",,,[10]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"96(?:0[469]|1[0-47]|3[389]|6[69]|7[78])\\d{6}",,,,"9604123456",,,[10]],"BD",880,"00","0",,,"0",,,,[[,"(\\d{2})(\\d{4,6})","$1-$2",["31[5-8]|[459]1"],"0$1"],[,"(\\d{3})(\\d{3,7})","$1-$2",["3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:28|4[14]|5)|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"],
"0$1"],[,"(\\d{4})(\\d{3,6})","$1-$2",["[13-9]|22"],"0$1"],[,"(\\d)(\\d{7,8})","$1-$2",["2"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],BE:[,[,,"4\\d{8}|[1-9]\\d{7}",,,,,,,[8,9]],[,,"80[2-8]\\d{5}|(?:1[0-69]|[23][2-8]|4[23]|5\\d|6[013-57-9]|71|8[1-79]|9[2-4])\\d{6}",,,,"12345678",,,[8]],[,,"4[5-9]\\d{7}",,,,"470123456",,,[9]],[,,"800[1-9]\\d{4}",,,,"80012345",,,[8]],[,,"(?:70(?:2[0-57]|3[04-7]|44|6[569]|7[0579])|90(?:0[0-8]|1[36]|2[0-3568]|3[0-689]|[47][2-68]|5[1-68]|6[0-378]|9[34679]))\\d{4}",
,,,"90012345",,,[8]],[,,"7879\\d{4}",,,,"78791234",,,[8]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"BE",32,"00","0",,,"0",,,,[[,"(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["(?:80|9)0"],"0$1"],[,"(\\d)(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[239]|4[23]"],"0$1"],[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[15-8]"],"0$1"],[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["4"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"78(?:0[57]|1[014-8]|2[25]|3[15-8]|48|[56]0|7[06-8]|9\\d)\\d{4}",,,,"78102345",,
,[8]],,,[,,,,,,,,,[-1]]],BF:[,[,,"[025-7]\\d{7}",,,,,,,[8]],[,,"2(?:0(?:49|5[23]|6[5-7]|9[016-9])|4(?:4[569]|5[4-6]|6[5-7]|7[0179])|5(?:[34]\\d|50|6[5-7]))\\d{4}",,,,"20491234"],[,,"(?:0[1-35-7]|5[1-8]|[67]\\d)\\d{6}",,,,"70123456"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"BF",226,"00",,,,,,,,[[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[025-7]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],BG:[,[,,"00800\\d{7}|[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}",
,,,,,,[6,7,8,9,12],[4,5]],[,,"2\\d{5,7}|(?:43[1-6]|70[1-9])\\d{4,5}|(?:[36]\\d|4[124-7]|[57][1-9]|8[1-6]|9[1-7])\\d{5,6}",,,,"2123456",,,[6,7,8],[4,5]],[,,"(?:43[07-9]|99[69]\\d)\\d{5}|(?:8[7-9]|98)\\d{7}",,,,"43012345",,,[8,9]],[,,"(?:00800\\d\\d|800)\\d{5}",,,,"80012345",,,[8,12]],[,,"90\\d{6}",,,,"90123456",,,[8]],[,,"700\\d{5}",,,,"70012345",,,[8]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"BG",359,"00","0",,,"0",,,,[[,"(\\d{6})","$1",["1"]],[,"(\\d)(\\d)(\\d{2})(\\d{2})","$1 $2 $3 $4",["2"],"0$1"],[,"(\\d{3})(\\d{4})",
"$1 $2",["43[1-6]|70[1-9]"],"0$1"],[,"(\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["2"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{2,3})","$1 $2 $3",["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"],"0$1"],[,"(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["(?:70|8)0"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{2})","$1 $2 $3",["43[1-7]|7"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[48]|9[08]"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["9"],"0$1"]],[[,"(\\d)(\\d)(\\d{2})(\\d{2})","$1 $2 $3 $4",["2"],"0$1"],[,"(\\d{3})(\\d{4})","$1 $2",
["43[1-6]|70[1-9]"],"0$1"],[,"(\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["2"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{2,3})","$1 $2 $3",["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"],"0$1"],[,"(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["(?:70|8)0"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{2})","$1 $2 $3",["43[1-7]|7"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[48]|9[08]"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["9"],"0$1"]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],BH:[,[,,"[136-9]\\d{7}",
,,,,,,[8]],[,,"(?:1(?:3[1356]|6[0156]|7\\d)\\d|6(?:1[16]\\d|500|6(?:0\\d|3[12]|44|7[7-9]|88)|9[69][69])|7(?:1(?:11|78)|7\\d\\d))\\d{4}",,,,"17001234"],[,,"(?:3(?:[1-79]\\d|8[0-47-9])\\d|6(?:3(?:00|33|6[16])|6(?:3[03-9]|[69]\\d|7[0-6])))\\d{4}",,,,"36001234"],[,,"80\\d{6}",,,,"80123456"],[,,"(?:87|9[014578])\\d{6}",,,,"90123456"],[,,"84\\d{6}",,,,"84123456"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"BH",973,"00",,,,,,,,[[,"(\\d{4})(\\d{4})","$1 $2",["[13679]|8[047]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,
,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],BI:[,[,,"(?:[267]\\d|31)\\d{6}",,,,,,,[8]],[,,"(?:22|31)\\d{6}",,,,"22201234"],[,,"(?:29|[67][125-9])\\d{6}",,,,"79561234"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"BI",257,"00",,,,,,,,[[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2367]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],BJ:[,[,,"[24-689]\\d{7}",,,,,,,[8]],[,,"2(?:02|1[037]|2[45]|3[68]|4\\d)\\d{5}",,,,"20211234"],[,,"(?:4[0-2]|[56]\\d|9[013-9])\\d{6}",
,,,"90011234"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"857[58]\\d{4}",,,,"85751234"],"BJ",229,"00",,,,,,,,[[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[24-689]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"81\\d{6}",,,,"81123456"],,,[,,,,,,,,,[-1]]],BL:[,[,,"(?:590|(?:69|80)\\d|976)\\d{6}",,,,,,,[9]],[,,"590(?:2[7-9]|5[12]|87)\\d{4}",,,,"590271234"],[,,"69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}",,,,"690001234"],[,,"80[0-5]\\d{6}",,,,"800012345"],[,,,,,,,,,[-1]],[,,,
,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"976[01]\\d{5}",,,,"976012345"],"BL",590,"00","0",,,"0",,,,,,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],BM:[,[,,"(?:441|[58]\\d\\d|900)\\d{7}",,,,,,,[10],[7]],[,,"441(?:[46]\\d\\d|5(?:4\\d|60|89))\\d{4}",,,,"4414123456",,,,[7]],[,,"441(?:[2378]\\d|5[0-39]|92)\\d{5}",,,,"4413701234",,,,[7]],[,,"8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",,,,"8002123456"],[,,"900[2-9]\\d{6}",,,,"9002123456"],[,,,,,,,,,[-1]],[,,"52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
,,,"5002345678"],[,,,,,,,,,[-1]],"BM",1,"011","1",,,"([2-9]\\d{6})$|1","441$1",,,,,[,,,,,,,,,[-1]],,"441",[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],BN:[,[,,"[2-578]\\d{6}",,,,,,,[7]],[,,"22[0-7]\\d{4}|(?:2[013-9]|[34]\\d|5[0-25-9])\\d{5}",,,,"2345678"],[,,"(?:22[89]|[78]\\d\\d)\\d{4}",,,,"7123456"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"5[34]\\d{5}",,,,"5345678"],"BN",673,"00",,,,,,,,[[,"(\\d{3})(\\d{4})","$1 $2",["[2-578]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],
[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],BO:[,[,,"(?:[2-467]\\d\\d|8001)\\d{5}",,,,,,,[8,9],[7]],[,,"(?:2(?:2\\d\\d|5(?:11|[258]\\d|9[67])|6(?:12|2\\d|9[34])|8(?:2[34]|39|62))|3(?:3\\d\\d|4(?:6\\d|8[24])|8(?:25|42|5[257]|86|9[25])|9(?:[27]\\d|3[2-4]|4[248]|5[24]|6[2-6]))|4(?:4\\d\\d|6(?:11|[24689]\\d|72)))\\d{4}",,,,"22123456",,,[8],[7]],[,,"[67]\\d{7}",,,,"71234567",,,[8]],[,,"8001[07]\\d{4}",,,,"800171234",,,[9]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"BO",591,"00(?:1\\d)?","0",
,,"0(1\\d)?",,,,[[,"(\\d)(\\d{7})","$1 $2",["[23]|4[46]"],,"0$CC $1"],[,"(\\d{8})","$1",["[67]"],,"0$CC $1"],[,"(\\d{3})(\\d{2})(\\d{4})","$1 $2 $3",["8"],,"0$CC $1"]],,[,,,,,,,,,[-1]],,,[,,"8001[07]\\d{4}",,,,,,,[9]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],BQ:[,[,,"(?:[34]1|7\\d)\\d{5}",,,,,,,[7]],[,,"(?:318[023]|41(?:6[023]|70)|7(?:1[578]|2[05]|50)\\d)\\d{3}",,,,"7151234"],[,,"(?:31(?:8[14-8]|9[14578])|416[14-9]|7(?:0[01]|7[07]|8\\d|9[056])\\d)\\d{3}",,,,"3181234"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,
,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"BQ",599,"00",,,,,,,,,,[,,,,,,,,,[-1]],,"[347]",[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],BR:[,[,,"(?:[1-46-9]\\d\\d|5(?:[0-46-9]\\d|5[0-46-9]))\\d{8}|[1-9]\\d{9}|[3589]\\d{8}|[34]\\d{7}",,,,,,,[8,9,10,11]],[,,"(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-5]\\d{7}",,,,"1123456789",,,[10],[8]],[,,"(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])(?:7|9\\d)\\d{7}",,,,"11961234567",,,[10,11],[8,9]],[,,"800\\d{6,7}",,,,"800123456",,,
[9,10]],[,,"300\\d{6}|[59]00\\d{6,7}",,,,"300123456",,,[9,10]],[,,"(?:30[03]\\d{3}|4(?:0(?:0\\d|20)|370))\\d{4}|300\\d{5}",,,,"40041234",,,[8,10]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"BR",55,"00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)","0",,,"(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?","$2",,,[[,"(\\d{3,6})","$1",["1(?:1[25-8]|2[357-9]|3[02-68]|4[12568]|5|6[0-8]|8[015]|9[0-47-9])|321|610"]],[,"(\\d{4})(\\d{4})","$1-$2",["300|4(?:0[02]|37)","4(?:02|37)0|[34]00"]],[,"(\\d{4})(\\d{4})","$1-$2",
["[2-57]","[2357]|4(?:[0-24-9]|3(?:[0-689]|7[1-9]))"]],[,"(\\d{3})(\\d{2,3})(\\d{4})","$1 $2 $3",["(?:[358]|90)0"],"0$1"],[,"(\\d{5})(\\d{4})","$1-$2",["9"]],[,"(\\d{2})(\\d{4})(\\d{4})","$1 $2-$3",["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"],"($1)","0 $CC ($1)"],[,"(\\d{2})(\\d{5})(\\d{4})","$1 $2-$3",["[16][1-9]|[2-57-9]"],"($1)","0 $CC ($1)"]],[[,"(\\d{4})(\\d{4})","$1-$2",["300|4(?:0[02]|37)","4(?:02|37)0|[34]00"]],[,"(\\d{3})(\\d{2,3})(\\d{4})","$1 $2 $3",["(?:[358]|90)0"],
"0$1"],[,"(\\d{2})(\\d{4})(\\d{4})","$1 $2-$3",["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"],"($1)","0 $CC ($1)"],[,"(\\d{2})(\\d{5})(\\d{4})","$1 $2-$3",["[16][1-9]|[2-57-9]"],"($1)","0 $CC ($1)"]],[,,,,,,,,,[-1]],,,[,,"30(?:0\\d{5,7}|3\\d{7})|40(?:0\\d|20)\\d{4}|800\\d{6,7}",,,,,,,[8,9,10]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],BS:[,[,,"(?:242|[58]\\d\\d|900)\\d{7}",,,,,,,[10],[7]],[,,"242(?:3(?:02|[236][1-9]|4[0-24-9]|5[0-68]|7[347]|8[0-4]|9[2-467])|461|502|6(?:0[1-5]|12|2[013]|[45]0|7[67]|8[78]|9[89])|7(?:02|88))\\d{4}",
,,,"2423456789",,,,[7]],[,,"242(?:3(?:5[79]|7[56]|95)|4(?:[23][1-9]|4[1-35-9]|5[1-8]|6[2-8]|7\\d|81)|5(?:2[45]|3[35]|44|5[1-46-9]|65|77)|6[34]6|7(?:27|38)|8(?:0[1-9]|1[02-9]|2\\d|[89]9))\\d{4}",,,,"2423591234",,,,[7]],[,,"242300\\d{4}|8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",,,,"8002123456",,,,[7]],[,,"900[2-9]\\d{6}",,,,"9002123456"],[,,,,,,,,,[-1]],[,,"52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
,,,"5002345678"],[,,,,,,,,,[-1]],"BS",1,"011","1",,,"([3-8]\\d{6})$|1","242$1",,,,,[,,,,,,,,,[-1]],,"242",[,,,,,,,,,[-1]],[,,"242225\\d{4}",,,,"2422250123"],,,[,,,,,,,,,[-1]]],BT:[,[,,"[17]\\d{7}|[2-8]\\d{6}",,,,,,,[7,8],[6]],[,,"(?:2[3-6]|[34][5-7]|5[236]|6[2-46]|7[246]|8[2-4])\\d{5}",,,,"2345678",,,[7],[6]],[,,"(?:1[67]|77)\\d{6}",,,,"17123456",,,[8]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"BT",975,"00",,,,,,,,[[,"(\\d{3})(\\d{3})","$1 $2",["[2-7]"]],[,"(\\d)(\\d{3})(\\d{3})",
"$1 $2 $3",["[2-68]|7[246]"]],[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["1[67]|7"]]],[[,"(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[2-68]|7[246]"]],[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["1[67]|7"]]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],BW:[,[,,"(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}",,,,,,,[7,8,10]],[,,"(?:2(?:4[0-48]|6[0-24]|9[0578])|3(?:1[0-35-9]|55|[69]\\d|7[013])|4(?:6[03]|7[1267]|9[0-5])|5(?:3[03489]|4[0489]|7[1-47]|88|9[0-49])|6(?:2[1-35]|5[149]|8[067]))\\d{4}",
,,,"2401234",,,[7]],[,,"(?:321|7(?:[1-7]\\d|8[0-4]))\\d{5}",,,,"71123456",,,[8]],[,,"(?:0800|800\\d)\\d{6}",,,,"0800012345",,,[10]],[,,"90\\d{5}",,,,"9012345",,,[7]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"79(?:1(?:[01]\\d|2[0-7])|2[0-7]\\d)\\d{3}",,,,"79101234",,,[8]],"BW",267,"00",,,,,,,,[[,"(\\d{2})(\\d{5})","$1 $2",["90"]],[,"(\\d{3})(\\d{4})","$1 $2",["[24-6]|3[15-79]"]],[,"(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[37]"]],[,"(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["0"]],[,"(\\d{3})(\\d{4})(\\d{3})",
"$1 $2 $3",["8"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],BY:[,[,,"(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}",,,,,,,[6,7,8,9,10,11],[5]],[,,"(?:1(?:5(?:1[1-5]|[24]\\d|6[2-4]|9[1-7])|6(?:[235]\\d|4[1-7])|7\\d\\d)|2(?:1(?:[246]\\d|3[0-35-9]|5[1-9])|2(?:[235]\\d|4[0-8])|3(?:[26]\\d|3[02-79]|4[024-7]|5[03-7])))\\d{5}",,,,"152450911",,,[9],[5,6,7]],[,,"(?:2(?:5[5-79]|9[1-9])|(?:33|44)\\d)\\d{6}",
,,,"294911911",,,[9]],[,,"800\\d{3,7}|8(?:0[13]|20\\d)\\d{7}",,,,"8011234567"],[,,"(?:810|902)\\d{7}",,,,"9021234567",,,[10]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"249\\d{6}",,,,"249123456",,,[9]],"BY",375,"810","8",,,"0|80?",,"8~10",,[[,"(\\d{3})(\\d{3})","$1 $2",["800"],"8 $1"],[,"(\\d{3})(\\d{2})(\\d{2,4})","$1 $2 $3",["800"],"8 $1"],[,"(\\d{4})(\\d{2})(\\d{3})","$1 $2-$3",["1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])","1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"],
"8 0$1"],[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2-$3-$4",["1(?:[56]|7[467])|2[1-3]"],"8 0$1"],[,"(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2-$3-$4",["[1-4]"],"8 0$1"],[,"(\\d{3})(\\d{3,4})(\\d{4})","$1 $2 $3",["[89]"],"8 $1"]],,[,,,,,,,,,[-1]],,,[,,"800\\d{3,7}|(?:8(?:0[13]|10|20\\d)|902)\\d{7}"],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],BZ:[,[,,"(?:0800\\d|[2-8])\\d{6}",,,,,,,[7,11]],[,,"(?:2(?:[02]\\d|36|[68]0)|[3-58](?:[02]\\d|[68]0)|7(?:[02]\\d|32|[68]0))\\d{4}",,,,"2221234",,,[7]],[,,"6[0-35-7]\\d{5}",
,,,"6221234",,,[7]],[,,"0800\\d{7}",,,,"08001234123",,,[11]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"BZ",501,"00",,,,,,,,[[,"(\\d{3})(\\d{4})","$1-$2",["[2-8]"]],[,"(\\d)(\\d{3})(\\d{4})(\\d{3})","$1-$2-$3-$4",["0"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],CA:[,[,,"(?:[2-8]\\d|90)\\d{8}|3\\d{6}",,,,,,,[7,10]],[,,"(?:2(?:04|[23]6|[48]9|50|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|3[178]|50|68|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|73)|90[25])[2-9]\\d{6}",
,,,"5062345678",,,[10],[7]],[,,"(?:2(?:04|[23]6|[48]9|50|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|3[178]|50|68|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|73)|90[25])[2-9]\\d{6}",,,,"5062345678",,,[10],[7]],[,,"8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",,,,"8002123456",,,[10]],[,,"900[2-9]\\d{6}",,,,"9002123456",,,[10]],[,,,,,,,,,[-1]],[,,"52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:00|2[125-9]|33|44|66|77|88)|622)[2-9]\\d{6}",
,,,"5002345678",,,[10]],[,,"600[2-9]\\d{6}",,,,"6002012345",,,[10]],"CA",1,"011","1",,,"1",,,1,,,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"310\\d{4}",,,,"3101234",,,[7]],,,[,,,,,,,,,[-1]]],CC:[,[,,"1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}",,,,,,,[6,7,8,9,10,12]],[,,"8(?:51(?:0(?:02|31|60|89)|1(?:18|76)|223)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}",,,,"891621234",,,[9],[8]],[,,"4(?:79[01]|83[0-389]|93[0-6])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[016-9]|7[02-8]|8[0-24-9]|9[0-27-9])\\d{6}",
,,,"412345678",,,[9]],[,,"180(?:0\\d{3}|2)\\d{3}",,,,"1800123456",,,[7,10]],[,,"190[0-26]\\d{6}",,,,"1900123456",,,[10]],[,,"13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",,,,"1300123456",,,[6,8,10,12]],[,,,,,,,,,[-1]],[,,"14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",,,,"147101234",,,[9]],"CC",61,"001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011","0",,,"([59]\\d{7})$|0","8$1","0011",,,,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],CD:[,[,,"[189]\\d{8}|[1-68]\\d{6}",,,,,,
,[7,9]],[,,"12\\d{7}|[1-6]\\d{6}",,,,"1234567"],[,,"88\\d{5}|(?:8[0-59]|9[017-9])\\d{7}",,,,"991234567"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"CD",243,"00","0",,,"0",,,,[[,"(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["88"],"0$1"],[,"(\\d{2})(\\d{5})","$1 $2",["[1-6]"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["1"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[89]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],CF:[,[,,
"(?:[27]\\d{3}|8776)\\d{4}",,,,,,,[8]],[,,"2[12]\\d{6}",,,,"21612345"],[,,"7[024-7]\\d{6}",,,,"70012345"],[,,,,,,,,,[-1]],[,,"8776\\d{4}",,,,"87761234"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"CF",236,"00",,,,,,,,[[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[278]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],CG:[,[,,"222\\d{6}|(?:0\\d|80)\\d{7}",,,,,,,[9]],[,,"222[1-589]\\d{5}",,,,"222123456"],[,,"026(?:1[0-5]|6[6-9])\\d{4}|0(?:[14-6]\\d\\d|2(?:40|5[5-8]|6[07-9]))\\d{5}",
,,,"061234567"],[,,,,,,,,,[-1]],[,,"80(?:0\\d\\d|120)\\d{4}",,,,"800123456"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"CG",242,"00",,,,,,,,[[,"(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["8"]],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[02]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],CH:[,[,,"8\\d{11}|[2-9]\\d{8}",,,,,,,[9,12]],[,,"(?:2[12467]|3[1-4]|4[134]|5[256]|6[12]|[7-9]1)\\d{7}",,,,"212345678",,,[9]],[,,"7[35-9]\\d{7}",,,,"781234567",,,[9]],[,,"800\\d{6}",,,,"800123456",
,,[9]],[,,"90[016]\\d{6}",,,,"900123456",,,[9]],[,,"84[0248]\\d{6}",,,,"840123456",,,[9]],[,,"878\\d{6}",,,,"878123456",,,[9]],[,,,,,,,,,[-1]],"CH",41,"00","0",,,"0",,,,[[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["8[047]|90"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2-79]|81"],"0$1"],[,"(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["8"],"0$1"]],,[,,"74[0248]\\d{6}",,,,"740123456",,,[9]],,,[,,,,,,,,,[-1]],[,,"5[18]\\d{7}",,,,"581234567",,,[9]],,,[,,"860\\d{9}",,,,"860123456789",
,,[12]]],CI:[,[,,"[02]\\d{9}",,,,,,,[10]],[,,"2(?:[15]\\d{3}|7(?:2(?:0[23]|1[2357]|2[245]|3[45]|4[3-5])|3(?:06|1[69]|[2-6]7)))\\d{5}",,,,"2123456789"],[,,"0[157]\\d{8}",,,,"0123456789"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"CI",225,"00",,,,,,,,[[,"(\\d{2})(\\d{2})(\\d)(\\d{5})","$1 $2 $3 $4",["2"]],[,"(\\d{2})(\\d{2})(\\d{2})(\\d{4})","$1 $2 $3 $4",["0"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],CK:[,[,,"[2-578]\\d{4}",,,,,,
,[5]],[,,"(?:2\\d|3[13-7]|4[1-5])\\d{3}",,,,"21234"],[,,"[578]\\d{4}",,,,"71234"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"CK",682,"00",,,,,,,,[[,"(\\d{2})(\\d{3})","$1 $2",["[2-578]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],CL:[,[,,"12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}",,,,,,,[9,10,11]],[,,"2(?:1982[0-6]|3314[05-9])\\d{3}|(?:2(?:1(?:160|962)|3(?:2\\d\\d|3(?:[0346]\\d|1[0-35-9]|2[1-9]|5[0-24-9]|7[0-3])|600)|646[59])|80[1-9]\\d\\d|9(?:3(?:[0-57-9]\\d\\d|6(?:0[02-9]|[1-9]\\d))|6(?:[0-8]\\d\\d|9(?:[02-79]\\d|1[05-9]))|7[1-9]\\d\\d|9(?:[03-9]\\d\\d|1(?:[0235-9]\\d|4[0-24-9])|2(?:[0-79]\\d|8[0-46-9]))))\\d{4}|(?:22|3[2-5]|[47][1-35]|5[1-3578]|6[13-57]|8[1-9]|9[2458])\\d{7}",
,,,"221234567",,,[9]],[,,"2(?:1982[0-6]|3314[05-9])\\d{3}|(?:2(?:1(?:160|962)|3(?:2\\d\\d|3(?:[0346]\\d|1[0-35-9]|2[1-9]|5[0-24-9]|7[0-3])|600)|646[59])|80[1-9]\\d\\d|9(?:3(?:[0-57-9]\\d\\d|6(?:0[02-9]|[1-9]\\d))|6(?:[0-8]\\d\\d|9(?:[02-79]\\d|1[05-9]))|7[1-9]\\d\\d|9(?:[03-9]\\d\\d|1(?:[0235-9]\\d|4[0-24-9])|2(?:[0-79]\\d|8[0-46-9]))))\\d{4}|(?:22|3[2-5]|[47][1-35]|5[1-3578]|6[13-57]|8[1-9]|9[2458])\\d{7}",,,,"221234567",,,[9]],[,,"(?:123|8)00\\d{6}",,,,"800123456",,,[9,11]],[,,,,,,,,,[-1]],[,,"600\\d{7,8}",
,,,"6001234567",,,[10,11]],[,,,,,,,,,[-1]],[,,"44\\d{7}",,,,"441234567",,,[9]],"CL",56,"(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0",,,,,,,1,[[,"(\\d{4})","$1",["1(?:[03-589]|21)|[29]0|78"]],[,"(\\d{5})(\\d{4})","$1 $2",["219","2196"],"($1)"],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["44"]],[,"(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["2[1-36]"],"($1)"],[,"(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["9[2-9]"]],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"],
"($1)"],[,"(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["60|8"]],[,"(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["1"]],[,"(\\d{3})(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3 $4",["60"]]],[[,"(\\d{5})(\\d{4})","$1 $2",["219","2196"],"($1)"],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["44"]],[,"(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["2[1-36]"],"($1)"],[,"(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["9[2-9]"]],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"],"($1)"],[,"(\\d{3})(\\d{3})(\\d{3,4})",
"$1 $2 $3",["60|8"]],[,"(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["1"]],[,"(\\d{3})(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3 $4",["60"]]],[,,,,,,,,,[-1]],,,[,,"600\\d{7,8}",,,,,,,[10,11]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],CM:[,[,,"[26]\\d{8}|88\\d{6,7}",,,,,,,[8,9]],[,,"2(?:22|33)\\d{6}",,,,"222123456",,,[9]],[,,"(?:24[23]|6[25-9]\\d)\\d{6}",,,,"671234567",,,[9]],[,,"88\\d{6,7}",,,,"88012345"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"CM",237,"00",,,,,,,,[[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
"$1 $2 $3 $4",["88"]],[,"(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["[26]|88"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],CN:[,[,,"1[127]\\d{8,9}|2\\d{9}(?:\\d{2})?|[12]\\d{6,7}|86\\d{6}|(?:1[03-689]\\d|6)\\d{7,9}|(?:[3-579]\\d|8[0-57-9])\\d{6,9}",,,,,,,[7,8,9,10,11,12],[5,6]],[,,"(?:10(?:[02-79]\\d\\d|[18](?:0[1-9]|[1-9]\\d))|21(?:[18](?:0[1-9]|[1-9]\\d)|[2-79]\\d\\d))\\d{5}|(?:43[35]|754)\\d{7,8}|8(?:078\\d{7}|51\\d{7,8})|(?:10|(?:2|85)1|43[35]|754)(?:100\\d\\d|95\\d{3,4})|(?:2[02-57-9]|3(?:11|7[179])|4(?:[15]1|3[12])|5(?:1\\d|2[37]|3[12]|51|7[13-79]|9[15])|7(?:[39]1|5[57]|6[09])|8(?:71|98))(?:[02-8]\\d{7}|1(?:0(?:0\\d\\d(?:\\d{3})?|[1-9]\\d{5})|[1-9]\\d{6})|9(?:[0-46-9]\\d{6}|5\\d{3}(?:\\d(?:\\d{2})?)?))|(?:3(?:1[02-9]|35|49|5\\d|7[02-68]|9[1-68])|4(?:1[02-9]|2[179]|3[46-9]|5[2-9]|6[47-9]|7\\d|8[23])|5(?:3[03-9]|4[36]|5[02-9]|6[1-46]|7[028]|80|9[2-46-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[17]\\d|2[248]|3[04-9]|4[3-6]|5[0-3689]|6[2368]|9[02-9])|8(?:1[236-8]|2[5-7]|3\\d|5[2-9]|7[02-9]|8[36-8]|9[1-7])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:[02-8]\\d{6}|1(?:0(?:0\\d\\d(?:\\d{2})?|[1-9]\\d{4})|[1-9]\\d{5})|9(?:[0-46-9]\\d{5}|5\\d{3,5}))",
,,,"1012345678",,,[7,8,9,10,11],[5,6]],[,,"1740[0-5]\\d{6}|1(?:[38]\\d|4[57]|[59][0-35-9]|6[25-7]|7[0-35-8])\\d{8}",,,,"13123456789",,,[11]],[,,"(?:(?:10|21)8|8)00\\d{7}",,,,"8001234567",,,[10,12]],[,,"16[08]\\d{5}",,,,"16812345",,,[8]],[,,"10(?:10\\d{4}|96\\d{3,4})|400\\d{7}|950\\d{7,8}|(?:2[0-57-9]|3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))96\\d{3,4}",
,,,"4001234567",,,[7,8,9,10,11],[5,6]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"CN",86,"00|1(?:[12]\\d|79)\\d\\d00","0",,,"(1(?:[12]\\d|79)\\d\\d)|0",,"00",,[[,"(\\d{5,6})","$1",["10|96"]],[,"(\\d{2})(\\d{5,6})","$1 $2",["(?:10|2[0-57-9])[19]","(?:10|2[0-57-9])(?:10|9[56])","10(?:10|9[56])|2[0-57-9](?:100|9[56])"],"0$1","$CC $1"],[,"(\\d{3})(\\d{4})","$1 $2",["[1-9]","1[1-9]|26|[3-9]|(?:10|2[0-57-9])(?:[0-8]|9[0-47-9])","1(?:0(?:[0-8]|9[0-47-9])|[1-9])|2(?:[0-57-9](?:[02-8]|1(?:0[1-9]|[1-9])|9[0-47-9])|6)|[3-9]"]],
[,"(\\d{4})(\\d{4})","$1 $2",["16[08]"]],[,"(\\d{3})(\\d{5,6})","$1 $2",["3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]","(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]",
"85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])","85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"],
"0$1","$CC $1"],[,"(\\d{4})(\\d{4})","$1 $2",["[1-9]","1(?:0(?:[02-8]|1[1-9]|9[0-47-9])|[1-9])|2(?:[0-57-9](?:[0-8]|9[0-47-9])|6)|[3-9]","1(?:0(?:[02-8]|1[1-9]|9[0-47-9])|[1-9])|26|3(?:[0268]|4[0-8]|9[079])|4(?:[049]|2[02-68]|[35]0|6[0-356]|8[014-9])|5(?:0|2[0-24-689]|4[0-2457-9]|6[057-9]|8[1-9]|90)|6(?:[0-24578]|3[06-9]|6[14-79]|9[03-9])|7(?:0[02-9]|2[0135-79]|3[23]|4[0-27-9]|6[1457]|8)|8(?:[046]|1[01459]|2[0-489]|5(?:0|[23][0-8])|8[0-2459]|9[09])|9(?:0[0457]|1[08]|[268]|4[024-9]|5[06-9])|(?:33|85[23]9)[0-46-9]|(?:2[0-57-9]|3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:[0-8]|9[0-47-9])",
"1(?:0[02-8]|[1-9])|2(?:[0-57-9][0-8]|6)|3(?:[0268]|3[0-46-9]|4[0-8]|9[079])|4(?:[049]|2[02-68]|[35]0|6[0-356]|8[014-9])|5(?:0|2[0-24-689]|4[0-2457-9]|6[057-9]|90)|6(?:[0-24578]|3[06-9]|6[14-79]|9[03-9])|7(?:0[02-9]|2[0135-79]|3[23]|4[0-27-9]|6[1457]|8)|8(?:[046]|1[01459]|2[0-489]|5(?:0|[23](?:[02-8]|1[1-9]|9[0-46-9]))|8[0-2459]|9[09])|9(?:0[0457]|1[08]|[268]|4[024-9]|5[06-9])|(?:10|2[0-57-9])9[0-47-9]|(?:101|58|85[23]10)[1-9]|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:[02-8]|1(?:0[1-9]|[1-9])|9[0-47-9])"]],
[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["(?:4|80)0"]],[,"(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["10|2(?:[02-57-9]|1[1-9])","10|2(?:[02-57-9]|1[1-9])","10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"],"0$1","$CC $1",1],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"],"0$1","$CC $1",1],[,"(\\d{3})(\\d{7,8})",
"$1 $2",["9"]],[,"(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["80"],"0$1","$CC $1",1],[,"(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["[3-578]"],"0$1","$CC $1",1],[,"(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["1[3-9]"],,"$CC $1"],[,"(\\d{2})(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3 $4",["[12]"],"0$1",,1]],[[,"(\\d{2})(\\d{5,6})","$1 $2",["(?:10|2[0-57-9])[19]","(?:10|2[0-57-9])(?:10|9[56])","10(?:10|9[56])|2[0-57-9](?:100|9[56])"],"0$1","$CC $1"],[,"(\\d{3})(\\d{5,6})","$1 $2",["3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]",
"(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]","85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])",
"85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"],"0$1","$CC $1"],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["(?:4|80)0"]],[,"(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["10|2(?:[02-57-9]|1[1-9])","10|2(?:[02-57-9]|1[1-9])","10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"],
"0$1","$CC $1",1],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"],"0$1","$CC $1",1],[,"(\\d{3})(\\d{7,8})","$1 $2",["9"]],[,"(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["80"],"0$1","$CC $1",1],[,"(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["[3-578]"],"0$1","$CC $1",1],[,"(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["1[3-9]"],,"$CC $1"],
[,"(\\d{2})(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3 $4",["[12]"],"0$1",,1]],[,,,,,,,,,[-1]],,,[,,"(?:(?:10|21)8|[48])00\\d{7}|950\\d{7,8}",,,,,,,[10,11,12]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],CO:[,[,,"(?:60\\d\\d|9101)\\d{6}|(?:1\\d|3)\\d{9}",,,,,,,[10,11],[7]],[,,"601055(?:[0-4]\\d|50)\\d\\d|6010(?:[0-4]\\d|5[0-4])\\d{4}|60[124-8][2-9]\\d{6}",,,,"6012345678",,,[10],[7]],[,,"3333(?:0(?:0\\d|1[0-5])|[4-9]\\d\\d)\\d{3}|(?:3(?:24[1-9]|3(?:00|3[0-24-9]))|9101)\\d{6}|3(?:0[0-5]|1\\d|2[0-3]|5[01]|70)\\d{7}",
,,,"3211234567",,,[10]],[,,"1800\\d{7}",,,,"18001234567",,,[11]],[,,"19(?:0[01]|4[78])\\d{7}",,,,"19001234567",,,[11]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"CO",57,"00(?:4(?:[14]4|56)|[579])","0",,,"0(4(?:[14]4|56)|[579])?",,,,[[,"(\\d{3})(\\d{7})","$1 $2",["6"],"($1)","0$CC $1"],[,"(\\d{3})(\\d{7})","$1 $2",["3[0-357]|91"],,"0$CC $1"],[,"(\\d)(\\d{3})(\\d{7})","$1-$2-$3",["1"],"0$1"]],[[,"(\\d{3})(\\d{7})","$1 $2",["6"],"($1)","0$CC $1"],[,"(\\d{3})(\\d{7})","$1 $2",["3[0-357]|91"],,"0$CC $1"],
[,"(\\d)(\\d{3})(\\d{7})","$1 $2 $3",["1"]]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],CR:[,[,,"(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}",,,,,,,[8,10]],[,,"210[7-9]\\d{4}|2(?:[024-7]\\d|1[1-9])\\d{5}",,,,"22123456",,,[8]],[,,"(?:3005\\d|6500[01])\\d{3}|(?:5[07]|6[0-4]|7[0-3]|8[3-9])\\d{6}",,,,"83123456",,,[8]],[,,"800\\d{7}",,,,"8001234567",,,[10]],[,,"90[059]\\d{7}",,,,"9001234567",,,[10]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"(?:210[0-6]|4\\d{3}|5100)\\d{4}",,,,"40001234",
,,[8]],"CR",506,"00",,,,"(19(?:0[0-2468]|1[09]|20|66|77|99))",,,,[[,"(\\d{4})(\\d{4})","$1 $2",["[2-7]|8[3-9]"],,"$CC $1"],[,"(\\d{3})(\\d{3})(\\d{4})","$1-$2-$3",["[89]"],,"$CC $1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],CU:[,[,,"[27]\\d{6,7}|[34]\\d{5,7}|(?:5|8\\d\\d)\\d{7}",,,,,,,[6,7,8,10],[4,5]],[,,"(?:3[23]|48)\\d{4,6}|(?:31|4[36]|8(?:0[25]|78)\\d)\\d{6}|(?:2[1-4]|4[1257]|7\\d)\\d{5,6}",,,,"71234567",,,,[4,5]],[,,"5\\d{7}",,,,"51234567",,,[8]],[,,"800\\d{7}",
,,,"8001234567",,,[10]],[,,,,,,,,,[-1]],[,,"807\\d{7}",,,,"8071234567",,,[10]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"CU",53,"119","0",,,"0",,,,[[,"(\\d{2})(\\d{4,6})","$1 $2",["2[1-4]|[34]"],"(0$1)"],[,"(\\d)(\\d{6,7})","$1 $2",["7"],"(0$1)"],[,"(\\d)(\\d{7})","$1 $2",["5"],"0$1"],[,"(\\d{3})(\\d{7})","$1 $2",["8"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],CV:[,[,,"(?:[2-59]\\d\\d|800)\\d{4}",,,,,,,[7]],[,,"2(?:2[1-7]|3[0-8]|4[12]|5[1256]|6\\d|7[1-3]|8[1-5])\\d{4}",
,,,"2211234"],[,,"(?:36|5[1-389]|9\\d)\\d{5}",,,,"9911234"],[,,"800\\d{4}",,,,"8001234"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"(?:3[3-5]|4[356])\\d{5}",,,,"3401234"],"CV",238,"0",,,,,,,,[[,"(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3",["[2-589]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],CW:[,[,,"(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}",,,,,,,[7,8]],[,,"9(?:4(?:3[0-5]|4[14]|6\\d)|50\\d|7(?:2[014]|3[02-9]|4[4-9]|6[357]|77|8[7-9])|8(?:3[39]|[46]\\d|7[01]|8[57-9]))\\d{4}",
,,,"94351234"],[,,"953[01]\\d{4}|9(?:5[12467]|6[5-9])\\d{5}",,,,"95181234"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"60[0-2]\\d{4}",,,,"6001234",,,[7]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"CW",599,"00",,,,,,,,[[,"(\\d{3})(\\d{4})","$1 $2",["[3467]"]],[,"(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["9[4-8]"]]],,[,,"955\\d{5}",,,,"95581234",,,[8]],1,"[69]",[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],CX:[,[,,"1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}",,,,,,,[6,7,8,9,10,12]],[,,"8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|2(?:22|35))|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}",
,,,"891641234",,,[9],[8]],[,,"4(?:79[01]|83[0-389]|93[0-6])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[016-9]|7[02-8]|8[0-24-9]|9[0-27-9])\\d{6}",,,,"412345678",,,[9]],[,,"180(?:0\\d{3}|2)\\d{3}",,,,"1800123456",,,[7,10]],[,,"190[0-26]\\d{6}",,,,"1900123456",,,[10]],[,,"13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",,,,"1300123456",,,[6,8,10,12]],[,,,,,,,,,[-1]],[,,"14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",,,,"147101234",,,[9]],"CX",61,"001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011","0",,,
"([59]\\d{7})$|0","8$1","0011",,,,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],CY:[,[,,"(?:[279]\\d|[58]0)\\d{6}",,,,,,,[8]],[,,"2[2-6]\\d{6}",,,,"22345678"],[,,"9(?:10|[4-79]\\d)\\d{5}",,,,"96123456"],[,,"800\\d{5}",,,,"80001234"],[,,"90[09]\\d{5}",,,,"90012345"],[,,"80[1-9]\\d{5}",,,,"80112345"],[,,"700\\d{5}",,,,"70012345"],[,,,,,,,,,[-1]],"CY",357,"00",,,,,,,,[[,"(\\d{2})(\\d{6})","$1 $2",["[257-9]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"(?:50|77)\\d{6}",,,,"77123456"],
,,[,,,,,,,,,[-1]]],CZ:[,[,,"(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}",,,,,,,[9,10,11,12]],[,,"(?:2\\d|3[1257-9]|4[16-9]|5[13-9])\\d{7}",,,,"212345678",,,[9]],[,,"(?:60[1-8]|7(?:0[2-5]|[2379]\\d))\\d{6}",,,,"601123456",,,[9]],[,,"800\\d{6}",,,,"800123456",,,[9]],[,,"9(?:0[05689]|76)\\d{6}",,,,"900123456",,,[9]],[,,"8[134]\\d{7}",,,,"811234567",,,[9]],[,,"70[01]\\d{6}",,,,"700123456",,,[9]],[,,"9[17]0\\d{6}",,,,"910123456",,,[9]],"CZ",420,"00",,,,,,,,[[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[2-8]|9[015-7]"]],
[,"(\\d{2})(\\d{3})(\\d{3})(\\d{2})","$1 $2 $3 $4",["96"]],[,"(\\d{2})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["9"]],[,"(\\d{3})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["9"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"9(?:5\\d|7[2-4])\\d{6}",,,,"972123456",,,[9]],,,[,,"9(?:3\\d{9}|6\\d{7,10})",,,,"93123456789"]],DE:[,[,,"[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:2[024-9]|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[015]\\d|2[13]|31|[46][1-8])\\d{1,9}",
,,,,,,[4,5,6,7,8,9,10,11,12,13,14,15],[2,3]],[,,"32\\d{9,11}|49[1-6]\\d{10}|322\\d{6}|49[0-7]\\d{3,9}|(?:[34]0|[68]9)\\d{3,13}|(?:2(?:0[1-689]|[1-3569]\\d|4[0-8]|7[1-7]|8[0-7])|3(?:[3569]\\d|4[0-79]|7[1-7]|8[1-8])|4(?:1[02-9]|[2-48]\\d|5[0-6]|6[0-8]|7[0-79])|5(?:0[2-8]|[124-6]\\d|[38][0-8]|[79][0-7])|6(?:0[02-9]|[1-358]\\d|[47][0-8]|6[1-9])|7(?:0[2-8]|1[1-9]|[27][0-7]|3\\d|[4-6][0-8]|8[0-5]|9[013-7])|8(?:0[2-9]|1[0-79]|2\\d|3[0-46-9]|4[0-6]|5[013-9]|6[1-8]|7[0-8]|8[0-24-6])|9(?:0[6-9]|[1-4]\\d|[589][0-7]|6[0-8]|7[0-467]))\\d{3,12}",
,,,"30123456",,,[5,6,7,8,9,10,11,12,13,14,15],[2,3,4]],[,,"15[0-25-9]\\d{8}|1(?:6[023]|7\\d)\\d{7,8}",,,,"15123456789",,,[10,11]],[,,"800\\d{7,12}",,,,"8001234567890",,,[10,11,12,13,14,15]],[,,"(?:137[7-9]|900(?:[135]|9\\d))\\d{6}",,,,"9001234567",,,[10,11]],[,,"180\\d{5,11}|13(?:7[1-6]\\d\\d|8)\\d{4}",,,,"18012345",,,[7,8,9,10,11,12,13,14]],[,,"700\\d{8}",,,,"70012345678",,,[11]],[,,,,,,,,,[-1]],"DE",49,"00","0",,,"0",,,,[[,"(\\d{2})(\\d{3,13})","$1 $2",["3[02]|40|[68]9"],"0$1"],[,"(\\d{3})(\\d{3,12})",
"$1 $2",["2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1","2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"],"0$1"],[,"(\\d{4})(\\d{2,11})","$1 $2",["[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]","[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"],
"0$1"],[,"(\\d{3})(\\d{4})","$1 $2",["138"],"0$1"],[,"(\\d{5})(\\d{2,10})","$1 $2",["3"],"0$1"],[,"(\\d{3})(\\d{5,11})","$1 $2",["181"],"0$1"],[,"(\\d{3})(\\d)(\\d{4,10})","$1 $2 $3",["1(?:3|80)|9"],"0$1"],[,"(\\d{3})(\\d{7,8})","$1 $2",["1[67]"],"0$1"],[,"(\\d{3})(\\d{7,12})","$1 $2",["8"],"0$1"],[,"(\\d{5})(\\d{6})","$1 $2",["185","1850","18500"],"0$1"],[,"(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["7"],"0$1"],[,"(\\d{4})(\\d{7})","$1 $2",["18[68]"],"0$1"],[,"(\\d{5})(\\d{6})","$1 $2",["15[0568]"],"0$1"],
[,"(\\d{4})(\\d{7})","$1 $2",["15[1279]"],"0$1"],[,"(\\d{3})(\\d{8})","$1 $2",["18"],"0$1"],[,"(\\d{3})(\\d{2})(\\d{7,8})","$1 $2 $3",["1(?:6[023]|7)"],"0$1"],[,"(\\d{4})(\\d{2})(\\d{7})","$1 $2 $3",["15[279]"],"0$1"],[,"(\\d{3})(\\d{2})(\\d{8})","$1 $2 $3",["15"],"0$1"]],,[,,"16(?:4\\d{1,10}|[89]\\d{1,11})",,,,"16412345",,,[4,5,6,7,8,9,10,11,12,13,14]],,,[,,,,,,,,,[-1]],[,,"18(?:1\\d{5,11}|[2-9]\\d{8})",,,,"18500123456",,,[8,9,10,11,12,13,14]],,,[,,"1(?:6(?:013|255|399)|7(?:(?:[015]1|[69]3)3|[2-4]55|[78]99))\\d{7,8}|15(?:(?:[03-68]00|113)\\d|2\\d55|7\\d99|9\\d33)\\d{7}",
,,,"177991234567",,,[12,13]]],DJ:[,[,,"(?:2\\d|77)\\d{6}",,,,,,,[8]],[,,"2(?:1[2-5]|7[45])\\d{5}",,,,"21360003"],[,,"77\\d{6}",,,,"77831001"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"DJ",253,"00",,,,,,,,[[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[27]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],DK:[,[,,"[2-9]\\d{7}",,,,,,,[8]],[,,"(?:[2-7]\\d|8[126-9]|9[1-46-9])\\d{6}",,,,"32123456"],[,,"(?:[2-7]\\d|8[126-9]|9[1-46-9])\\d{6}",
,,,"32123456"],[,,"80\\d{6}",,,,"80123456"],[,,"90\\d{6}",,,,"90123456"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"DK",45,"00",,,,,,,1,[[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2-9]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],DM:[,[,,"(?:[58]\\d\\d|767|900)\\d{7}",,,,,,,[10],[7]],[,,"767(?:2(?:55|66)|4(?:2[01]|4[0-25-9])|50[0-4])\\d{4}",,,,"7674201234",,,,[7]],[,,"767(?:2(?:[2-4689]5|7[5-7])|31[5-7]|61[1-8]|70[1-6])\\d{4}",,,,"7672251234",,,,[7]],
[,,"8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",,,,"8002123456"],[,,"900[2-9]\\d{6}",,,,"9002123456"],[,,,,,,,,,[-1]],[,,"52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",,,,"5002345678"],[,,,,,,,,,[-1]],"DM",1,"011","1",,,"([2-7]\\d{6})$|1","767$1",,,,,[,,,,,,,,,[-1]],,"767",[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],
DO:[,[,,"(?:[58]\\d\\d|900)\\d{7}",,,,,,,[10],[7]],[,,"8(?:[04]9[2-9]\\d\\d|29(?:2(?:[0-59]\\d|6[04-9]|7[0-27]|8[0237-9])|3(?:[0-35-9]\\d|4[7-9])|[45]\\d\\d|6(?:[0-27-9]\\d|[3-5][1-9]|6[0135-8])|7(?:0[013-9]|[1-37]\\d|4[1-35689]|5[1-4689]|6[1-57-9]|8[1-79]|9[1-8])|8(?:0[146-9]|1[0-48]|[248]\\d|3[1-79]|5[01589]|6[013-68]|7[124-8]|9[0-8])|9(?:[0-24]\\d|3[02-46-9]|5[0-79]|60|7[0169]|8[57-9]|9[02-9])))\\d{4}",,,,"8092345678",,,,[7]],[,,"8[024]9[2-9]\\d{6}",,,,"8092345678",,,,[7]],[,,"8(?:00(?:14|[2-9]\\d)|(?:33|44|55|66|77|88)[2-9]\\d)\\d{5}",
,,,"8002123456"],[,,"900[2-9]\\d{6}",,,,"9002123456"],[,,,,,,,,,[-1]],[,,"52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",,,,"5002345678"],[,,,,,,,,,[-1]],"DO",1,"011","1",,,"1",,,,,,[,,,,,,,,,[-1]],,"8001|8[024]9",[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],DZ:[,[,,"(?:[1-4]|[5-79]\\d|80)\\d{7}",,,,,,,[8,9]],
[,,"9619\\d{5}|(?:1\\d|2[013-79]|3[0-8]|4[013-689])\\d{6}",,,,"12345678"],[,,"(?:5(?:4[0-29]|5\\d|6[0-2])|6(?:[569]\\d|7[0-6])|7[7-9]\\d)\\d{6}",,,,"551234567",,,[9]],[,,"800\\d{6}",,,,"800123456",,,[9]],[,,"80[3-689]1\\d{5}",,,,"808123456",,,[9]],[,,"80[12]1\\d{5}",,,,"801123456",,,[9]],[,,,,,,,,,[-1]],[,,"98[23]\\d{6}",,,,"983123456",,,[9]],"DZ",213,"00","0",,,"0",,,,[[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[1-4]"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["9"],"0$1"],
[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[5-8]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],EC:[,[,,"1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}",,,,,,,[8,9,10,11],[7]],[,,"[2-7][2-7]\\d{6}",,,,"22123456",,,[8],[7]],[,,"964[0-2]\\d{5}|9(?:39|[57][89]|6[0-36-9]|[89]\\d)\\d{6}",,,,"991234567",,,[9]],[,,"1800\\d{7}|1[78]00\\d{6}",,,,"18001234567",,,[10,11]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"[2-7]890\\d{4}",,,,"28901234",,,[8]],"EC",593,"00","0",,,
"0",,,,[[,"(\\d{3})(\\d{4})","$1-$2",["[2-7]"]],[,"(\\d)(\\d{3})(\\d{4})","$1 $2-$3",["[2-7]"],"(0$1)"],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["9"],"0$1"],[,"(\\d{4})(\\d{3})(\\d{3,4})","$1 $2 $3",["1"]]],[[,"(\\d)(\\d{3})(\\d{4})","$1-$2-$3",["[2-7]"]],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["9"],"0$1"],[,"(\\d{4})(\\d{3})(\\d{3,4})","$1 $2 $3",["1"]]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],EE:[,[,,"8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}",,,,,,,[7,8,10]],[,,"(?:3[23589]|4[3-8]|6\\d|7[1-9]|88)\\d{5}",
,,,"3212345",,,[7]],[,,"(?:5\\d{5}|8(?:1(?:0(?:000|[3-9]\\d\\d)|(?:1(?:0[236]|1\\d)|(?:2[0-59]|[3-79]\\d)\\d)\\d)|2(?:0(?:000|(?:19|[2-7]\\d)\\d)|(?:(?:[124-6]\\d|3[5-9])\\d|7(?:[3679]\\d|8[13-9])|8(?:[2-6]\\d|7[01]))\\d)|[349]\\d{4}))\\d\\d|5(?:(?:[02]\\d|5[0-478])\\d|1(?:[0-8]\\d|95)|6(?:4[0-4]|5[1-589]))\\d{3}",,,,"51234567",,,[7,8]],[,,"800(?:(?:0\\d\\d|1)\\d|[2-9])\\d{3}",,,,"80012345"],[,,"(?:40\\d\\d|900)\\d{4}",,,,"9001234",,,[7,8]],[,,,,,,,,,[-1]],[,,"70[0-2]\\d{5}",,,,"70012345",,,[8]],
[,,,,,,,,,[-1]],"EE",372,"00",,,,,,,,[[,"(\\d{3})(\\d{4})","$1 $2",["[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88","[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"]],[,"(\\d{4})(\\d{3,4})","$1 $2",["[45]|8(?:00|[1-49])","[45]|8(?:00[1-9]|[1-49])"]],[,"(\\d{2})(\\d{2})(\\d{4})","$1 $2 $3",["7"]],[,"(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["8"]]],,[,,,,,,,,,[-1]],,,[,,"800[2-9]\\d{3}",,,,,,,[7]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],EG:[,[,,"[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}",
,,,,,,[8,9,10],[6,7]],[,,"13[23]\\d{6}|(?:15|57)\\d{6,7}|(?:2[2-4]|3|4[05-8]|5[05]|6[24-689]|8[2468]|9[235-7])\\d{7}",,,,"234567890",,,[8,9],[6,7]],[,,"1[0-25]\\d{8}",,,,"1001234567",,,[10]],[,,"800\\d{7}",,,,"8001234567",,,[10]],[,,"900\\d{7}",,,,"9001234567",,,[10]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"EG",20,"00","0",,,"0",,,,[[,"(\\d)(\\d{7,8})","$1 $2",["[23]"],"0$1"],[,"(\\d{2})(\\d{6,7})","$1 $2",["1[35]|[4-6]|8[2468]|9[235-7]"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[189]"],
"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],EH:[,[,,"[5-8]\\d{8}",,,,,,,[9]],[,,"528[89]\\d{5}",,,,"528812345"],[,,"(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[017]\\d|2[0-2]|6[0-8]|8[0-3]))\\d{6}",,,,"650123456"],[,,"80\\d{7}",,,,"801234567"],[,,"89\\d{7}",,,,"891234567"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"592(?:4[0-2]|93)\\d{4}",,,,"592401234"],"EH",212,"00","0",,,"0",,,,,,[,,,,,,,,,[-1]],,"528[89]",[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],ER:[,[,,"[178]\\d{6}",
,,,,,,[7],[6]],[,,"(?:1(?:1[12568]|[24]0|55|6[146])|8\\d\\d)\\d{4}",,,,"8370362",,,,[6]],[,,"(?:17[1-3]|7\\d\\d)\\d{4}",,,,"7123456"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"ER",291,"00","0",,,"0",,,,[[,"(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[178]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],ES:[,[,,"[5-9]\\d{8}",,,,,,,[9]],[,,"96906(?:0[0-8]|1[1-9]|[2-9]\\d)\\d\\d|9(?:69(?:0[0-57-9]|[1-9]\\d)|73(?:[0-8]\\d|9[1-9]))\\d{4}|(?:8(?:[1356]\\d|[28][0-8]|[47][1-9])|9(?:[135]\\d|[268][0-8]|4[1-9]|7[124-9]))\\d{6}",
,,,"810123456"],[,,"(?:590[16]00\\d|9(?:6906(?:09|10)|7390\\d\\d))\\d\\d|(?:6\\d|7[1-48])\\d{7}",,,,"612345678"],[,,"[89]00\\d{6}",,,,"800123456"],[,,"80[367]\\d{6}",,,,"803123456"],[,,"90[12]\\d{6}",,,,"901123456"],[,,"70\\d{7}",,,,"701234567"],[,,,,,,,,,[-1]],"ES",34,"00",,,,,,,,[[,"(\\d{4})","$1",["905"]],[,"(\\d{6})","$1",["[79]9"]],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[89]00"]],[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[5-9]"]]],[[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[89]00"]],
[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[5-9]"]]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"51\\d{7}",,,,"511234567"],,,[,,,,,,,,,[-1]]],ET:[,[,,"(?:11|[2-579]\\d)\\d{7}",,,,,,,[9],[7]],[,,"11667[01]\\d{3}|(?:11(?:1(?:1[124]|2[2-7]|3[1-5]|5[5-8]|8[6-8])|2(?:13|3[6-8]|5[89]|7[05-9]|8[2-6])|3(?:2[01]|3[0-289]|4[1289]|7[1-4]|87)|4(?:1[69]|3[2-49]|4[0-3]|6[5-8])|5(?:1[578]|44|5[0-4])|6(?:1[578]|2[69]|39|4[5-7]|5[0-5]|6[0-59]|8[015-8]))|2(?:2(?:11[1-9]|22[0-7]|33\\d|44[1467]|66[1-68])|5(?:11[124-6]|33[2-8]|44[1467]|55[14]|66[1-3679]|77[124-79]|880))|3(?:3(?:11[0-46-8]|(?:22|55)[0-6]|33[0134689]|44[04]|66[01467])|4(?:44[0-8]|55[0-69]|66[0-3]|77[1-5]))|4(?:6(?:119|22[0-24-7]|33[1-5]|44[13-69]|55[14-689]|660|88[1-4])|7(?:(?:11|22)[1-9]|33[13-7]|44[13-6]|55[1-689]))|5(?:7(?:227|55[05]|(?:66|77)[14-8])|8(?:11[149]|22[013-79]|33[0-68]|44[013-8]|550|66[1-5]|77\\d)))\\d{4}",
,,,"111112345",,,,[7]],[,,"7001\\d{5}|(?:7(?:0[1-9]|1[01]|77|86|99)|9\\d\\d)\\d{6}",,,,"911234567"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"ET",251,"00","0",,,"0",,,,[[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[1-579]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],FI:[,[,,"[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}",,,,,,,[5,6,7,8,9,10,11,12]],[,,"(?:1[3-79][1-8]|[235689][1-8]\\d)\\d{2,6}",,,,"131234567",
,,[5,6,7,8,9]],[,,"4946\\d{2,6}|(?:4[0-8]|50)\\d{4,8}",,,,"412345678",,,[6,7,8,9,10]],[,,"800\\d{4,6}",,,,"800123456",,,[7,8,9]],[,,"[67]00\\d{5,6}",,,,"600123456",,,[8,9]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"FI",358,"00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))","0",,,"0",,"00",,[[,"(\\d{5})","$1",["75[12]"],"0$1"],[,"(\\d)(\\d{4,9})","$1 $2",["[2568][1-8]|3(?:0[1-9]|[1-9])|9"],"0$1"],[,"(\\d{6})","$1",["11"]],[,"(\\d{3})(\\d{3,7})","$1 $2",["[12]00|[368]|70[07-9]"],"0$1"],[,
"(\\d{2})(\\d{4,8})","$1 $2",["[1245]|7[135]"],"0$1"],[,"(\\d{2})(\\d{6,10})","$1 $2",["7"],"0$1"]],[[,"(\\d)(\\d{4,9})","$1 $2",["[2568][1-8]|3(?:0[1-9]|[1-9])|9"],"0$1"],[,"(\\d{3})(\\d{3,7})","$1 $2",["[12]00|[368]|70[07-9]"],"0$1"],[,"(\\d{2})(\\d{4,8})","$1 $2",["[1245]|7[135]"],"0$1"],[,"(\\d{2})(\\d{6,10})","$1 $2",["7"],"0$1"]],[,,,,,,,,,[-1]],1,"1[03-79]|[2-9]",[,,"20(?:2[023]|9[89])\\d{1,6}|(?:60[12]\\d|7099)\\d{4,5}|(?:606|7(?:0[78]|1|3\\d))\\d{7}|(?:[1-3]00|7(?:0[1-5]\\d\\d|5[03-9]))\\d{3,7}"],
[,,"20\\d{4,8}|60[12]\\d{5,6}|7(?:099\\d{4,5}|5[03-9]\\d{3,7})|20[2-59]\\d\\d|(?:606|7(?:0[78]|1|3\\d))\\d{7}|(?:10|29|3[09]|70[1-5]\\d)\\d{4,8}",,,,"10112345"],,,[,,,,,,,,,[-1]]],FJ:[,[,,"45\\d{5}|(?:0800\\d|[235-9])\\d{6}",,,,,,,[7,11]],[,,"603\\d{4}|(?:3[0-5]|6[25-7]|8[58])\\d{5}",,,,"3212345",,,[7]],[,,"(?:[279]\\d|45|5[01568]|8[034679])\\d{5}",,,,"7012345",,,[7]],[,,"0800\\d{7}",,,,"08001234567",,,[11]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"FJ",679,"0(?:0|52)",,,,,
,"00",,[[,"(\\d{3})(\\d{4})","$1 $2",["[235-9]|45"]],[,"(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["0"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],FK:[,[,,"[2-7]\\d{4}",,,,,,,[5]],[,,"[2-47]\\d{4}",,,,"31234"],[,,"[56]\\d{4}",,,,"51234"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"FK",500,"00",,,,,,,,,,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],FM:[,[,,"(?:[39]\\d\\d|820)\\d{4}",,,,,,,[7]],[,,"31(?:00[67]|208|309)\\d\\d|(?:3(?:[2357]0[1-9]|602|804|905)|(?:820|9[2-6]\\d)\\d)\\d{3}",
,,,"3201234"],[,,"31(?:00[67]|208|309)\\d\\d|(?:3(?:[2357]0[1-9]|602|804|905)|(?:820|9[2-7]\\d)\\d)\\d{3}",,,,"3501234"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"FM",691,"00",,,,,,,,[[,"(\\d{3})(\\d{4})","$1 $2",["[389]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],FO:[,[,,"[2-9]\\d{5}",,,,,,,[6]],[,,"(?:20|[34]\\d|8[19])\\d{4}",,,,"201234"],[,,"(?:[27][1-9]|5\\d|9[16])\\d{4}",,,,"211234"],[,,"80[257-9]\\d{3}",,,,"802123"],[,,"90(?:[13-5][15-7]|2[125-7]|9\\d)\\d\\d",
,,,"901123"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"(?:6[0-36]|88)\\d{4}",,,,"601234"],"FO",298,"00",,,,"(10(?:01|[12]0|88))",,,,[[,"(\\d{6})","$1",["[2-9]"],,"$CC $1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],FR:[,[,,"[1-9]\\d{8}",,,,,,,[9]],[,,"(?:[1-35]\\d|4[1-9])\\d{7}",,,,"123456789"],[,,"(?:6(?:[0-24-8]\\d|3[0-8]|9[589])|7[3-9]\\d)\\d{6}",,,,"612345678"],[,,"80[0-5]\\d{6}",,,,"801234567"],[,,"836(?:0[0-36-9]|[1-9]\\d)\\d{4}|8(?:1[2-9]|2[2-47-9]|3[0-57-9]|[569]\\d|8[0-35-9])\\d{6}",
,,,"891123456"],[,,"8(?:1[01]|2[0156]|4[02]|84)\\d{6}",,,,"884012345"],[,,,,,,,,,[-1]],[,,"9\\d{8}",,,,"912345678"],"FR",33,"00","0",,,"0",,,,[[,"(\\d{4})","$1",["10"]],[,"(\\d{3})(\\d{3})","$1 $2",["1"]],[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"],"0 $1"],[,"(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["[1-79]"],"0$1"]],[[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"],"0 $1"],[,"(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["[1-79]"],"0$1"]],[,,,,,,,,
,[-1]],,,[,,,,,,,,,[-1]],[,,"80[6-9]\\d{6}",,,,"806123456"],,,[,,,,,,,,,[-1]]],GA:[,[,,"(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}",,,,,,,[7,8]],[,,"[01]1\\d{6}",,,,"01441234",,,[8]],[,,"(?:(?:0[2-7]|7[467])\\d|6(?:0[0-4]|10|[256]\\d))\\d{5}|[2-7]\\d{6}",,,,"06031234"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"GA",241,"00",,,,"0(11\\d{6}|60\\d{6}|61\\d{6}|6[256]\\d{6}|7[467]\\d{6})","$1",,,[[,"(\\d)(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2-7]"],"0$1"],[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
"$1 $2 $3 $4",["0"]],[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["11|[67]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],GB:[,[,,"[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}",,,,,,,[7,9,10],[4,5,6,8]],[,,"(?:1(?:1(?:3(?:[0-58]\\d\\d|73[0235])|4(?:[0-5]\\d\\d|69[7-9]|70[0-579])|(?:(?:5[0-26-9]|[78][0-49])\\d|6(?:[0-4]\\d|50))\\d)|2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d\\d|1(?:[0-7]\\d\\d|8(?:[02]\\d|1[0-246-9])))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}",
,,,"1212345678",,,[9,10],[4,5,6,7,8]],[,,"7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}",,,,"7400123456",,,[10]],[,,"80[08]\\d{7}|800\\d{6}|8001111",,,,"8001234567"],[,,"(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d",,,,"9012345678",,,[7,10]],[,,,,,,,,,[-1]],[,,"70\\d{8}",,,,"7012345678",,,[10]],[,,"56\\d{8}",,,,"5612345678",
,,[10]],"GB",44,"00","0"," x",,"0",,,,[[,"(\\d{3})(\\d{4})","$1 $2",["800","8001","80011","800111","8001111"],"0$1"],[,"(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3",["845","8454","84546","845464"],"0$1"],[,"(\\d{3})(\\d{6})","$1 $2",["800"],"0$1"],[,"(\\d{5})(\\d{4,5})","$1 $2",["1(?:38|5[23]|69|76|94)","1(?:(?:38|69)7|5(?:24|39)|768|946)","1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"],"0$1"],[,"(\\d{4})(\\d{5,6})","$1 $2",["1(?:[2-69][02-9]|[78])"],"0$1"],[,"(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["[25]|7(?:0|6[02-9])",
"[25]|7(?:0|6(?:[03-9]|2[356]))"],"0$1"],[,"(\\d{4})(\\d{6})","$1 $2",["7"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[1389]"],"0$1"]],,[,,"76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}",,,,"7640123456",,,[10]],1,,[,,,,,,,,,[-1]],[,,"(?:3[0347]|55)\\d{8}",,,,"5512345678",,,[10]],,,[,,,,,,,,,[-1]]],GD:[,[,,"(?:473|[58]\\d\\d|900)\\d{7}",,,,,,,[10],[7]],[,,"473(?:2(?:3[0-2]|69)|3(?:2[89]|86)|4(?:[06]8|3[5-9]|4[0-49]|5[5-79]|73|90)|63[68]|7(?:58|84)|800|938)\\d{4}",
,,,"4732691234",,,,[7]],[,,"473(?:4(?:0[2-79]|1[04-9]|2[0-5]|58)|5(?:2[01]|3[3-8])|901)\\d{4}",,,,"4734031234",,,,[7]],[,,"8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",,,,"8002123456"],[,,"900[2-9]\\d{6}",,,,"9002123456"],[,,,,,,,,,[-1]],[,,"52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",,,,"5002345678"],[,,,,,,,,,[-1]],
"GD",1,"011","1",,,"([2-9]\\d{6})$|1","473$1",,,,,[,,,,,,,,,[-1]],,"473",[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],GE:[,[,,"(?:[3-57]\\d\\d|800)\\d{6}",,,,,,,[9],[6,7]],[,,"(?:3(?:[256]\\d|4[124-9]|7[0-4])|4(?:1\\d|2[2-7]|3[1-79]|4[2-8]|7[239]|9[1-7]))\\d{6}",,,,"322123456",,,,[6,7]],[,,"5(?:(?:(?:0555|1(?:[17]77|555))[5-9]|757(?:7[7-9]|8[01]))\\d|22252[0-4])\\d\\d|5(?:00(?:0\\d|5[05])|11(?:00|[124]\\d|3[01])|(?:520|909)0|75(?:00|[57]5)|8(?:0(?:[01]\\d|2[0-4])|58[89]|8(?:55|88)))\\d{4}|(?:5(?:[14]4|5[0157-9]|68|7[0147-9]|9[1-35-9])|790)\\d{6}|5(?:0(?:070|505)|1(?:0[01]0|1(?:07|33|51))|2(?:0[02]0|2[25]2)|3(?:0[03]0|3[35]3)|(?:40[04]|900)0|5222)[0-4]\\d{3}",
,,,"555123456"],[,,"800\\d{6}",,,,"800123456"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"70[67]\\d{6}",,,,"706123456"],"GE",995,"00","0",,,"0",,,,[[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["70"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["32"],"0$1"],[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[57]"]],[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[348]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,"70[67]\\d{6}"],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],GF:[,[,,"(?:[56]94|80\\d|976)\\d{6}",
,,,,,,[9]],[,,"594(?:[0239]\\d|1[0-2]|4[03-9]|5[6-9]|6[0-3]|80)\\d{4}",,,,"594101234"],[,,"694(?:[0-249]\\d|3[0-8])\\d{4}",,,,"694201234"],[,,"80[0-5]\\d{6}",,,,"800012345"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"976\\d{6}",,,,"976012345"],"GF",594,"00","0",,,"0",,,,[[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[569]"],"0$1"],[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],GG:[,[,,"(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?",
,,,,,,[7,9,10],[6]],[,,"1481[25-9]\\d{5}",,,,"1481256789",,,[10],[6]],[,,"7(?:(?:781|839)\\d|911[17])\\d{5}",,,,"7781123456",,,[10]],[,,"80[08]\\d{7}|800\\d{6}|8001111",,,,"8001234567"],[,,"(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d",,,,"9012345678",,,[7,10]],[,,,,,,,,,[-1]],[,,"70\\d{8}",,,,"7012345678",,,[10]],[,,"56\\d{8}",,,,"5612345678",,,[10]],"GG",44,"00","0",,,"([25-9]\\d{5})$|0","1481$1",,,,,[,,"76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}",
,,,"7640123456",,,[10]],,,[,,,,,,,,,[-1]],[,,"(?:3[0347]|55)\\d{8}",,,,"5512345678",,,[10]],,,[,,,,,,,,,[-1]]],GH:[,[,,"(?:[235]\\d{3}|800)\\d{5}",,,,,,,[8,9],[7]],[,,"3082[0-5]\\d{4}|3(?:0(?:[237]\\d|8[01])|[167](?:2[0-6]|7\\d|80)|2(?:2[0-5]|7\\d|80)|3(?:2[0-3]|7\\d|80)|4(?:2[013-9]|3[01]|7\\d|80)|5(?:2[0-7]|7\\d|80)|8(?:2[0-2]|7\\d|80)|9(?:[28]0|7\\d))\\d{5}",,,,"302345678",,,[9],[7]],[,,"(?:2(?:[0346-9]\\d|5[67])|5(?:[03-7]\\d|9[1-9]))\\d{6}",,,,"231234567",,,[9]],[,,"800\\d{5}",,,,"80012345",
,,[8]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"GH",233,"00","0",,,"0",,,,[[,"(\\d{3})(\\d{4})","$1 $2",["[237]|8[0-2]"]],[,"(\\d{3})(\\d{5})","$1 $2",["8"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[235]"],"0$1"]],[[,"(\\d{3})(\\d{5})","$1 $2",["8"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[235]"],"0$1"]],[,,,,,,,,,[-1]],,,[,,"800\\d{5}",,,,,,,[8]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],GI:[,[,,"(?:[25]\\d\\d|606)\\d{5}",,,,,,,[8]],[,,"2190[0-2]\\d{3}|2(?:0(?:0\\d|20)|16[24-9]|2[2-5]\\d)\\d{4}",
,,,"20012345"],[,,"525(?:0\\d|1[0-4])\\d{3}|(?:5[146-8]\\d|606)\\d{5}",,,,"57123456"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"GI",350,"00",,,,,,,,[[,"(\\d{3})(\\d{5})","$1 $2",["2"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],GL:[,[,,"(?:19|[2-689]\\d|70)\\d{4}",,,,,,,[6]],[,,"(?:19|3[1-7]|6[14689]|70|8[14-79]|9\\d)\\d{4}",,,,"321000"],[,,"[245]\\d{5}",,,,"221234"],[,,"80\\d{4}",,,,"801234"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,
,,,,,[-1]],[,,"3[89]\\d{4}",,,,"381234"],"GL",299,"00",,,,,,,,[[,"(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["19|[2-9]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],GM:[,[,,"[2-9]\\d{6}",,,,,,,[7]],[,,"(?:4(?:[23]\\d\\d|4(?:1[024679]|[6-9]\\d))|5(?:5(?:3\\d|4[0-7])|6[67]\\d|7(?:1[04]|2[035]|3[58]|48))|8\\d{3})\\d{3}",,,,"5661234"],[,,"(?:[23679]\\d|5[0-389])\\d{5}",,,,"3012345"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"GM",220,"00",,,
,,,,,[[,"(\\d{3})(\\d{4})","$1 $2",["[2-9]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],GN:[,[,,"722\\d{6}|(?:3|6\\d)\\d{7}",,,,,,,[8,9]],[,,"3(?:0(?:24|3[12]|4[1-35-7]|5[13]|6[189]|[78]1|9[1478])|1\\d\\d)\\d{4}",,,,"30241234",,,[8]],[,,"6[0-356]\\d{7}",,,,"601123456",,,[9]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"722\\d{6}",,,,"722123456",,,[9]],"GN",224,"00",,,,,,,,[[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["3"]],[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
"$1 $2 $3 $4",["[67]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],GP:[,[,,"(?:590|(?:69|80)\\d|976)\\d{6}",,,,,,,[9]],[,,"590(?:0[1-68]|[14][0-24-9]|2[0-68]|3[1289]|5[3-579]|6[0-489]|7[08]|8[0-689]|9\\d)\\d{4}",,,,"590201234"],[,,"69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}",,,,"690001234"],[,,"80[0-5]\\d{6}",,,,"800012345"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"976[01]\\d{5}",,,,"976012345"],"GP",590,"00","0",,,"0",,,,[[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",
["[569]"],"0$1"],[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"],"0$1"]],,[,,,,,,,,,[-1]],1,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],GQ:[,[,,"222\\d{6}|(?:3\\d|55|[89]0)\\d{7}",,,,,,,[9]],[,,"33[0-24-9]\\d[46]\\d{4}|3(?:33|5\\d)\\d[7-9]\\d{4}",,,,"333091234"],[,,"(?:222|55\\d)\\d{6}",,,,"222123456"],[,,"80\\d[1-9]\\d{5}",,,,"800123456"],[,,"90\\d[1-9]\\d{5}",,,,"900123456"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"GQ",240,"00",,,,,,,,[[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",
["[235]"]],[,"(\\d{3})(\\d{6})","$1 $2",["[89]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],GR:[,[,,"5005000\\d{3}|8\\d{9,11}|(?:[269]\\d|70)\\d{8}",,,,,,,[10,11,12]],[,,"2(?:1\\d\\d|2(?:2[1-46-9]|[36][1-8]|4[1-7]|5[1-4]|7[1-5]|[89][1-9])|3(?:1\\d|2[1-57]|[35][1-3]|4[13]|7[1-7]|8[124-6]|9[1-79])|4(?:1\\d|2[1-8]|3[1-4]|4[13-5]|6[1-578]|9[1-5])|5(?:1\\d|[29][1-4]|3[1-5]|4[124]|5[1-6])|6(?:1\\d|[269][1-6]|3[1245]|4[1-7]|5[13-9]|7[14]|8[1-5])|7(?:1\\d|2[1-5]|3[1-6]|4[1-7]|5[1-57]|6[135]|9[125-7])|8(?:1\\d|2[1-5]|[34][1-4]|9[1-57]))\\d{6}",
,,,"2123456789",,,[10]],[,,"68[57-9]\\d{7}|(?:69|94)\\d{8}",,,,"6912345678",,,[10]],[,,"800\\d{7,9}",,,,"8001234567"],[,,"90[19]\\d{7}",,,,"9091234567",,,[10]],[,,"8(?:0[16]|12|[27]5|50)\\d{7}",,,,"8011234567",,,[10]],[,,"70\\d{8}",,,,"7012345678",,,[10]],[,,,,,,,,,[-1]],"GR",30,"00",,,,,,,,[[,"(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["21|7"]],[,"(\\d{4})(\\d{6})","$1 $2",["2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"]],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[2689]"]],[,"(\\d{3})(\\d{3,4})(\\d{5})",
"$1 $2 $3",["8"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"5005000\\d{3}",,,,"5005000123",,,[10]],,,[,,,,,,,,,[-1]]],GT:[,[,,"(?:1\\d{3}|[2-7])\\d{7}",,,,,,,[8,11]],[,,"[267][2-9]\\d{6}",,,,"22456789",,,[8]],[,,"[3-5]\\d{7}",,,,"51234567",,,[8]],[,,"18[01]\\d{8}",,,,"18001112222",,,[11]],[,,"19\\d{9}",,,,"19001112222",,,[11]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"GT",502,"00",,,,,,,,[[,"(\\d{4})(\\d{4})","$1 $2",["[2-7]"]],[,"(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["1"]]],,[,,,,,,,,,[-1]],
,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],GU:[,[,,"(?:[58]\\d\\d|671|900)\\d{7}",,,,,,,[10],[7]],[,,"671(?:3(?:00|3[39]|4[349]|55|6[26])|4(?:00|56|7[1-9]|8[02-46-9])|5(?:55|6[2-5]|88)|6(?:3[2-578]|4[24-9]|5[34]|78|8[235-9])|7(?:[0479]7|2[0167]|3[45]|8[7-9])|8(?:[2-57-9]8|6[48])|9(?:2[29]|6[79]|7[1279]|8[7-9]|9[78]))\\d{4}",,,,"6713001234",,,,[7]],[,,"671(?:3(?:00|3[39]|4[349]|55|6[26])|4(?:00|56|7[1-9]|8[02-46-9])|5(?:55|6[2-5]|88)|6(?:3[2-578]|4[24-9]|5[34]|78|8[235-9])|7(?:[0479]7|2[0167]|3[45]|8[7-9])|8(?:[2-57-9]8|6[48])|9(?:2[29]|6[79]|7[1279]|8[7-9]|9[78]))\\d{4}",
,,,"6713001234",,,,[7]],[,,"8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",,,,"8002123456"],[,,"900[2-9]\\d{6}",,,,"9002123456"],[,,,,,,,,,[-1]],[,,"52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",,,,"5002345678"],[,,,,,,,,,[-1]],"GU",1,"011","1",,,"([3-9]\\d{6})$|1","671$1",,1,,,[,,,,,,,,,[-1]],,"671",[,,,,,,,,,[-1]],[,,,,
,,,,,[-1]],,,[,,,,,,,,,[-1]]],GW:[,[,,"[49]\\d{8}|4\\d{6}",,,,,,,[7,9]],[,,"443\\d{6}",,,,"443201234",,,[9]],[,,"9(?:5\\d|6[569]|77)\\d{6}",,,,"955012345",,,[9]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"40\\d{5}",,,,"4012345",,,[7]],"GW",245,"00",,,,,,,,[[,"(\\d{3})(\\d{4})","$1 $2",["40"]],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[49]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],GY:[,[,,"9008\\d{3}|(?:[2-467]\\d\\d|862)\\d{4}",,,,,,,[7]],[,
,"(?:2(?:1[6-9]|2[0-35-9]|3[1-4]|5[3-9]|6\\d|7[0-24-79])|3(?:2[25-9]|3\\d)|4(?:4[0-24]|5[56])|77[1-57])\\d{4}",,,,"2201234"],[,,"(?:6\\d\\d|70[0-35-7])\\d{4}",,,,"6091234"],[,,"(?:289|862)\\d{4}",,,,"2891234"],[,,"9008\\d{3}",,,,"9008123"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"GY",592,"001",,,,,,,,[[,"(\\d{3})(\\d{4})","$1 $2",["[2-46-9]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],HK:[,[,,"8[0-46-9]\\d{6,7}|9\\d{4,7}|(?:[2-7]|9\\d{3})\\d{7}",,,,,,,[5,6,7,8,
9,11]],[,,"(?:2(?:[13-9]\\d|2[013-9])\\d|3(?:(?:[1569][0-24-9]|4[0-246-9]|7[0-24-69])\\d|8(?:[45][0-8]|6[01]|9\\d))|58(?:0[1-8]|1[2-9]))\\d{4}",,,,"21234567",,,[8]],[,,"(?:4(?:44[5-9]|6(?:0[0-7]|1[0-6]|4[0-57-9]|6[0-4]|7[0-8]))|573[0-6]|6(?:26[013-8]|66[0-3])|70(?:7[1-5]|8[0-4])|848[015-9]|9(?:29[013-9]|59[0-4]))\\d{4}|(?:4(?:4[01]|6[2358])|5(?:[1-59][0-46-9]|6[0-4689]|7[0-246-9])|6(?:0[1-9]|[13-59]\\d|[268][0-57-9]|7[0-79])|84[09]|9(?:0[1-9]|1[02-9]|[2358][0-8]|[467]\\d))\\d{5}",,,,"51234567",,,
[8]],[,,"800\\d{6}",,,,"800123456",,,[9]],[,,"900(?:[0-24-9]\\d{7}|3\\d{1,4})",,,,"90012345678",,,[5,6,7,8,11]],[,,,,,,,,,[-1]],[,,"8(?:1[0-4679]\\d|2(?:[0-36]\\d|7[0-4])|3(?:[034]\\d|2[09]|70))\\d{4}",,,,"81123456",,,[8]],[,,,,,,,,,[-1]],"HK",852,"00(?:30|5[09]|[126-9]?)",,,,,,"00",,[[,"(\\d{3})(\\d{2,5})","$1 $2",["900","9003"]],[,"(\\d{4})(\\d{4})","$1 $2",["[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"]],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["8"]],[,"(\\d{3})(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3 $4",["9"]]],
,[,,"7(?:1(?:0[0-38]|1[0-3679]|3[013]|69|9[0136])|2(?:[02389]\\d|1[18]|7[27-9])|3(?:[0-38]\\d|7[0-369]|9[2357-9])|47\\d|5(?:[178]\\d|5[0-5])|6(?:0[0-7]|2[236-9]|[35]\\d)|7(?:[27]\\d|8[7-9])|8(?:[23689]\\d|7[1-9])|9(?:[025]\\d|6[0-246-8]|7[0-36-9]|8[238]))\\d{4}",,,,"71123456",,,[8]],,,[,,,,,,,,,[-1]],[,,"30(?:0[1-9]|[15-7]\\d|2[047]|89)\\d{4}",,,,"30161234",,,[8]],,,[,,,,,,,,,[-1]]],HN:[,[,,"8\\d{10}|[237-9]\\d{7}",,,,,,,[8,11]],[,,"2(?:2(?:0[0-59]|1[1-9]|[23]\\d|4[02-6]|5[57]|6[245]|7[0135689]|8[01346-9]|9[0-2])|4(?:0[578]|2[3-59]|3[13-9]|4[0-68]|5[1-3589])|5(?:0[2357-9]|1[1-356]|4[03-5]|5\\d|6[014-69]|7[04]|80)|6(?:[056]\\d|17|2[067]|3[047]|4[0-378]|[78][0-8]|9[01])|7(?:0[5-79]|6[46-9]|7[02-9]|8[034]|91)|8(?:79|8[0-357-9]|9[1-57-9]))\\d{4}",
,,,"22123456",,,[8]],[,,"[37-9]\\d{7}",,,,"91234567",,,[8]],[,,"8002\\d{7}",,,,"80021234567",,,[11]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"HN",504,"00",,,,,,,,[[,"(\\d{4})(\\d{4})","$1-$2",["[237-9]"]],[,"(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["8"]]],[[,"(\\d{4})(\\d{4})","$1-$2",["[237-9]"]]],[,,,,,,,,,[-1]],,,[,,"8002\\d{7}",,,,,,,[11]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],HR:[,[,,"(?:[24-69]\\d|3[0-79])\\d{7}|80\\d{5,7}|[1-79]\\d{7}|6\\d{5,6}",,,,,,,[6,7,8,9]],[,,"1\\d{7}|(?:2[0-3]|3[1-5]|4[02-47-9]|5[1-3])\\d{6,7}",
,,,"12345678",,,[8,9],[6,7]],[,,"98\\d{6,7}|975(?:1\\d|77|9[67])\\d{4}|9(?:0[1-9]|[1259]\\d|7[0679])\\d{6}",,,,"921234567",,,[8,9]],[,,"80[01]\\d{4,6}",,,,"800123456",,,[7,8,9]],[,,"6[01459]\\d{6}|6[01]\\d{4,5}",,,,"611234",,,[6,7,8]],[,,,,,,,,,[-1]],[,,"7[45]\\d{6}",,,,"74123456",,,[8]],[,,,,,,,,,[-1]],"HR",385,"00","0",,,"0",,,,[[,"(\\d{2})(\\d{2})(\\d{2,3})","$1 $2 $3",["6[01]"],"0$1"],[,"(\\d{3})(\\d{2})(\\d{2,3})","$1 $2 $3",["8"],"0$1"],[,"(\\d)(\\d{4})(\\d{3})","$1 $2 $3",["1"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{3,4})",
"$1 $2 $3",["[67]"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["9"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[2-5]"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["8"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"62\\d{6,7}|72\\d{6}",,,,"62123456",,,[8,9]],,,[,,,,,,,,,[-1]]],HT:[,[,,"(?:[2-489]\\d|55)\\d{6}",,,,,,,[8]],[,,"2(?:2\\d|5[1-5]|81|9[149])\\d{5}",,,,"22453300"],[,,"(?:[34]\\d|55)\\d{6}",,,,"34101234"],[,,"8\\d{7}",,,,"80012345"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,
,,,,,[-1]],[,,"9(?:[67][0-4]|8[0-3589]|9\\d)\\d{5}",,,,"98901234"],"HT",509,"00",,,,,,,,[[,"(\\d{2})(\\d{2})(\\d{4})","$1 $2 $3",["[2-589]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],HU:[,[,,"[235-7]\\d{8}|[1-9]\\d{7}",,,,,,,[8,9],[6,7]],[,,"(?:1\\d|[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6[23689]|8[2-57-9]|9[2-69])\\d{6}",,,,"12345678",,,[8],[6,7]],[,,"(?:[257]0|3[01])\\d{7}",,,,"201234567",,,[9]],[,,"(?:[48]0\\d|680[29])\\d{5}",,,,"80123456"],[,,"9[01]\\d{6}",,,,"90123456",
,,[8]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"21\\d{7}",,,,"211234567",,,[9]],"HU",36,"00","06",,,"06",,,,[[,"(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["1"],"(06 $1)"],[,"(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"],"(06 $1)"],[,"(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[2-9]"],"06 $1"]],,[,,,,,,,,,[-1]],,,[,,"(?:[48]0\\d|680[29])\\d{5}"],[,,"38\\d{7}",,,,"381234567",,,[9]],,,[,,,,,,,,,[-1]]],ID:[,[,,"(?:(?:00[1-9]|8\\d)\\d{4}|[1-36])\\d{6}|00\\d{10}|[1-9]\\d{8,10}|[2-9]\\d{7}",
,,,,,,[7,8,9,10,11,12,13],[5,6]],[,,"2[124]\\d{7,8}|619\\d{8}|2(?:1(?:14|500)|2\\d{3})\\d{3}|61\\d{5,8}|(?:2(?:[35][1-4]|6[0-8]|7[1-6]|8\\d|9[1-8])|3(?:1|[25][1-8]|3[1-68]|4[1-3]|6[1-3568]|7[0-469]|8\\d)|4(?:0[1-589]|1[01347-9]|2[0-36-8]|3[0-24-68]|43|5[1-378]|6[1-5]|7[134]|8[1245])|5(?:1[1-35-9]|2[25-8]|3[124-9]|4[1-3589]|5[1-46]|6[1-8])|6(?:[25]\\d|3[1-69]|4[1-6])|7(?:02|[125][1-9]|[36]\\d|4[1-8]|7[0-36-9])|9(?:0[12]|1[013-8]|2[0-479]|5[125-8]|6[23679]|7[159]|8[01346]))\\d{5,8}",,,,"218350123",
,,[7,8,9,10,11],[5,6]],[,,"8[1-35-9]\\d{7,10}",,,,"812345678",,,[9,10,11,12]],[,,"00[17]803\\d{7}|(?:177\\d|800)\\d{5,7}|001803\\d{6}",,,,"8001234567",,,[8,9,10,11,12,13]],[,,"809\\d{7}",,,,"8091234567",,,[10]],[,,"804\\d{7}",,,,"8041234567",,,[10]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"ID",62,"00[89]","0",,,"0",,,,[[,"(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["15"]],[,"(\\d{2})(\\d{5,9})","$1 $2",["2[124]|[36]1"],"(0$1)"],[,"(\\d{3})(\\d{5,7})","$1 $2",["800"],"0$1"],[,"(\\d{3})(\\d{5,8})","$1 $2",["[2-79]"],
"(0$1)"],[,"(\\d{3})(\\d{3,4})(\\d{3})","$1-$2-$3",["8[1-35-9]"],"0$1"],[,"(\\d{3})(\\d{6,8})","$1 $2",["1"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["804"],"0$1"],[,"(\\d{3})(\\d)(\\d{3})(\\d{3})","$1 $2 $3 $4",["80"],"0$1"],[,"(\\d{3})(\\d{4})(\\d{4,5})","$1-$2-$3",["8"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["001"]],[,"(\\d{2})(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3 $4",["0"]]],[[,"(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["15"]],[,"(\\d{2})(\\d{5,9})","$1 $2",["2[124]|[36]1"],
"(0$1)"],[,"(\\d{3})(\\d{5,7})","$1 $2",["800"],"0$1"],[,"(\\d{3})(\\d{5,8})","$1 $2",["[2-79]"],"(0$1)"],[,"(\\d{3})(\\d{3,4})(\\d{3})","$1-$2-$3",["8[1-35-9]"],"0$1"],[,"(\\d{3})(\\d{6,8})","$1 $2",["1"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["804"],"0$1"],[,"(\\d{3})(\\d)(\\d{3})(\\d{3})","$1 $2 $3 $4",["80"],"0$1"],[,"(\\d{3})(\\d{4})(\\d{4,5})","$1-$2-$3",["8"],"0$1"]],[,,,,,,,,,[-1]],,,[,,"001803\\d{6,7}|(?:007803\\d|8071)\\d{6}",,,,,,,[10,12,13]],[,,"(?:1500|8071\\d{3})\\d{3}",,,,
"8071123456",,,[7,10]],,,[,,,,,,,,,[-1]]],IE:[,[,,"(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}",,,,,,,[7,8,9,10],[5,6]],[,,"(?:1\\d|21)\\d{6,7}|(?:2[24-9]|4(?:0[24]|5\\d|7)|5(?:0[45]|1\\d|8)|6(?:1\\d|[237-9])|9(?:1\\d|[35-9]))\\d{5}|(?:23|4(?:[1-469]|8\\d)|5[23679]|6[4-6]|7[14]|9[04])\\d{7}",,,,"2212345",,,,[5,6]],[,,"8(?:22|[35-9]\\d)\\d{6}",,,,"850123456",,,[9]],[,,"1800\\d{6}",,,,"1800123456",,,[10]],[,,"15(?:1[2-8]|[2-8]0|9[089])\\d{6}",,,,"1520123456",,,[10]],[,,"18[59]0\\d{6}",,,,"1850123456",
,,[10]],[,,"700\\d{6}",,,,"700123456",,,[9]],[,,"76\\d{7}",,,,"761234567",,,[9]],"IE",353,"00","0",,,"0",,,,[[,"(\\d{2})(\\d{5})","$1 $2",["2[24-9]|47|58|6[237-9]|9[35-9]"],"(0$1)"],[,"(\\d{3})(\\d{5})","$1 $2",["[45]0"],"(0$1)"],[,"(\\d)(\\d{3,4})(\\d{4})","$1 $2 $3",["1"],"(0$1)"],[,"(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[2569]|4[1-69]|7[14]"],"(0$1)"],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["70"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["81"],"(0$1)"],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",
["[78]"],"0$1"],[,"(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1"]],[,"(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["4"],"(0$1)"],[,"(\\d{2})(\\d)(\\d{3})(\\d{4})","$1 $2 $3 $4",["8"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,"18[59]0\\d{6}",,,,,,,[10]],[,,"818\\d{6}",,,,"818123456",,,[9]],,,[,,"88210[1-9]\\d{4}|8(?:[35-79]5\\d\\d|8(?:[013-9]\\d\\d|2(?:[01][1-9]|[2-9]\\d)))\\d{5}",,,,"8551234567",,,[10]]],IL:[,[,,"1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}",,,,,,,[7,8,9,10,11,12]],[,,"153\\d{8,9}|29[1-9]\\d{5}|(?:2[0-8]|[3489]\\d)\\d{6}",
,,,"21234567",,,[8,11,12],[7]],[,,"5(?:(?:[02368]\\d|[19][2-9]|4[1-9])\\d|5(?:01|1[79]|2[2-9]|3[0-3]|4[34]|5[015689]|6[6-8]|7[0-267]|8[7-9]|9[1-9]))\\d{5}",,,,"502345678",,,[9]],[,,"1(?:255|80[019]\\d{3})\\d{3}",,,,"1800123456",,,[7,10]],[,,"1212\\d{4}|1(?:200|9(?:0[0-2]|19))\\d{6}",,,,"1919123456",,,[8,10]],[,,"1700\\d{6}",,,,"1700123456",,,[10]],[,,,,,,,,,[-1]],[,,"7(?:380|8(?:33|55|77|81))\\d{5}|7(?:18|2[23]|3[237]|47|6[258]|7\\d|82|9[2-9])\\d{6}",,,,"771234567",,,[9]],"IL",972,"0(?:0|1[2-9])",
"0",,,"0",,,,[[,"(\\d{4})(\\d{3})","$1-$2",["125"]],[,"(\\d{4})(\\d{2})(\\d{2})","$1-$2-$3",["121"]],[,"(\\d)(\\d{3})(\\d{4})","$1-$2-$3",["[2-489]"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["[57]"],"0$1"],[,"(\\d{4})(\\d{3})(\\d{3})","$1-$2-$3",["12"]],[,"(\\d{4})(\\d{6})","$1-$2",["159"]],[,"(\\d)(\\d{3})(\\d{3})(\\d{3})","$1-$2-$3-$4",["1[7-9]"]],[,"(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})","$1-$2 $3-$4",["15"]]],,[,,,,,,,,,[-1]],,,[,,"1700\\d{6}",,,,,,,[10]],[,,"1599\\d{6}",,,,"1599123456",,
,[10]],,,[,,"151\\d{8,9}",,,,"15112340000",,,[11,12]]],IM:[,[,,"1624\\d{6}|(?:[3578]\\d|90)\\d{8}",,,,,,,[10],[6]],[,,"1624(?:230|[5-8]\\d\\d)\\d{3}",,,,"1624756789",,,,[6]],[,,"76245[06]\\d{4}|7(?:4576|[59]24\\d|624[0-4689])\\d{5}",,,,"7924123456"],[,,"808162\\d{4}",,,,"8081624567"],[,,"8(?:440[49]06|72299\\d)\\d{3}|(?:8(?:45|70)|90[0167])624\\d{4}",,,,"9016247890"],[,,,,,,,,,[-1]],[,,"70\\d{8}",,,,"7012345678"],[,,"56\\d{8}",,,,"5612345678"],"IM",44,"00","0",,,"([25-8]\\d{5})$|0","1624$1",,,,,[,
,,,,,,,,[-1]],,"74576|(?:16|7[56])24",[,,,,,,,,,[-1]],[,,"3440[49]06\\d{3}|(?:3(?:08162|3\\d{4}|45624|7(?:0624|2299))|55\\d{4})\\d{4}",,,,"5512345678"],,,[,,,,,,,,,[-1]]],IN:[,[,,"(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}",,,,,,,[8,9,10,11,12,13],[6,7]],[,,"2717(?:[2-7]\\d|95)\\d{4}|(?:271[0-689]|782[0-6])[2-7]\\d{5}|(?:170[24]|2(?:(?:[02][2-79]|90)\\d|80[13468])|(?:3(?:23|80)|683|79[1-7])\\d|4(?:20[24]|72[2-8])|552[1-7])\\d{6}|(?:11|33|4[04]|80)[2-7]\\d{7}|(?:342|674|788)(?:[0189][2-7]|[2-7]\\d)\\d{5}|(?:1(?:2[0-249]|3[0-25]|4[145]|[59][14]|6[014]|7[1257]|8[01346])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568]|9[14])|3(?:26|4[13]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[014-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|2[14]|3[134]|4[47]|5[15]|[67]1)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91))[2-7]\\d{6}|(?:1(?:2[35-8]|3[346-9]|4[236-9]|[59][0235-9]|6[235-9]|7[34689]|8[257-9])|2(?:1[134689]|3[24-8]|4[2-8]|5[25689]|6[2-4679]|7[3-79]|8[2-479]|9[235-9])|3(?:01|1[79]|2[1245]|4[5-8]|5[125689]|6[235-7]|7[157-9]|8[2-46-8])|4(?:1[14578]|2[5689]|3[2-467]|5[4-7]|6[35]|73|8[2689]|9[2389])|5(?:[16][146-9]|2[14-8]|3[1346]|4[14-69]|5[46]|7[2-4]|8[2-8]|9[246])|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])|7(?:1[013-9]|2[0235-9]|3[2679]|4[1-35689]|5[2-46-9]|[67][02-9]|8[013-7]|9[089])|8(?:1[1357-9]|2[235-8]|3[03-57-9]|4[0-24-9]|5\\d|6[2457-9]|7[1-6]|8[1256]|9[2-4]))\\d[2-7]\\d{5}",
,,,"7410410123",,,[10],[6,7,8]],[,,"(?:61279|7(?:887[02-9]|9(?:313|79[07-9]))|8(?:079[04-9]|(?:84|91)7[02-8]))\\d{5}|(?:6(?:12|[2-47]1|5[17]|6[13]|80)[0189]|7(?:1(?:2[0189]|9[0-5])|2(?:[14][017-9]|8[0-59])|3(?:2[5-8]|[34][017-9]|9[016-9])|4(?:1[015-9]|[29][89]|39|8[389])|5(?:[15][017-9]|2[04-9]|9[7-9])|6(?:0[0-47]|1[0-257-9]|2[0-4]|3[19]|5[4589])|70[0289]|88[089]|97[02-8])|8(?:0(?:6[67]|7[02-8])|70[017-9]|84[01489]|91[0-289]))\\d{6}|(?:7(?:31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[0189]\\d|7[02-8])\\d{5}|(?:6(?:[09]\\d|1[04679]|2[03689]|3[05-9]|4[0489]|50|6[069]|7[07]|8[7-9])|7(?:0\\d|2[0235-79]|3[05-8]|40|5[0346-8]|6[6-9]|7[1-9]|8[0-79]|9[089])|8(?:0[01589]|1[0-57-9]|2[235-9]|3[03-57-9]|[45]\\d|6[02457-9]|7[1-69]|8[0-25-9]|9[02-9])|9\\d\\d)\\d{7}|(?:6(?:(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|8[124-6])\\d|7(?:[235689]\\d|4[0189]))|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-5])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]|881))[0189]\\d{5}",
,,,"8123456789",,,[10]],[,,"000800\\d{7}|1(?:600\\d{6}|80(?:0\\d{4,9}|3\\d{9}))",,,,"1800123456"],[,,"186[12]\\d{9}",,,,"1861123456789",,,[13]],[,,"1860\\d{7}",,,,"18603451234",,,[11]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"IN",91,"00","0",,,"0",,,,[[,"(\\d{7})","$1",["575"]],[,"(\\d{8})","$1",["5(?:0|2[23]|3[03]|[67]1|88)","5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)","5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"],,,1],[,"(\\d{4})(\\d{4,5})","$1 $2",["180","1800"],,,1],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",
["140"],,,1],[,"(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["11|2[02]|33|4[04]|79[1-7]|80[2-46]","11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])","11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"],"0$1",,1],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]",
"1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]","1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"],
"0$1",,1],[,"(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807","1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]",
"1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"],"0$1",,1],[,"(\\d{5})(\\d{5})","$1 $2",["[6-9]"],"0$1",,1],[,"(\\d{4})(\\d{2,4})(\\d{4})","$1 $2 $3",["1(?:6|8[06])","1(?:6|8[06]0)"],,,1],[,"(\\d{3})(\\d{3})(\\d{3})(\\d{4})",
"$1 $2 $3 $4",["0"]],[,"(\\d{4})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["18"],,,1]],[[,"(\\d{8})","$1",["5(?:0|2[23]|3[03]|[67]1|88)","5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)","5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"],,,1],[,"(\\d{4})(\\d{4,5})","$1 $2",["180","1800"],,,1],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["140"],,,1],[,"(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["11|2[02]|33|4[04]|79[1-7]|80[2-46]","11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])","11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"],
"0$1",,1],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]","1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]",
"1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"],
"0$1",,1],[,"(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807","1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]",
"1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"],"0$1",,1],[,"(\\d{5})(\\d{5})","$1 $2",["[6-9]"],"0$1",,1],[,"(\\d{4})(\\d{2,4})(\\d{4})","$1 $2 $3",["1(?:6|8[06])","1(?:6|8[06]0)"],,,1],[,"(\\d{4})(\\d{3})(\\d{3})(\\d{3})",
"$1 $2 $3 $4",["18"],,,1]],[,,,,,,,,,[-1]],,,[,,"1(?:600\\d{6}|800\\d{4,9})|(?:000800|18(?:03\\d\\d|6(?:0|[12]\\d\\d)))\\d{7}"],[,,"140\\d{7}",,,,"1409305260",,,[10]],,,[,,,,,,,,,[-1]]],IO:[,[,,"3\\d{6}",,,,,,,[7]],[,,"37\\d{5}",,,,"3709100"],[,,"38\\d{5}",,,,"3801234"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"IO",246,"00",,,,,,,,[[,"(\\d{3})(\\d{4})","$1 $2",["3"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],IQ:[,[,,"(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}",
,,,,,,[8,9,10],[6,7]],[,,"1\\d{7}|(?:2[13-5]|3[02367]|4[023]|5[03]|6[026])\\d{6,7}",,,,"12345678",,,[8,9],[6,7]],[,,"7[3-9]\\d{8}",,,,"7912345678",,,[10]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"IQ",964,"00","0",,,"0",,,,[[,"(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["1"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[2-6]"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["7"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],IR:[,
[,,"[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}",,,,,,,[4,5,6,7,10],[8]],[,,"(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])(?:[03-57]\\d{7}|[16]\\d{3}(?:\\d{4})?|[289]\\d{3}(?:\\d(?:\\d{3})?)?)|94(?:000[09]|2(?:121|[2689]0\\d)|30[0-2]\\d|4(?:111|40\\d))\\d{4}",,,,"2123456789",,,[6,7,10],[4,5,8]],[,,"9(?:(?:0(?:[0-35]\\d|4[4-6])|(?:[13]\\d|2[0-3])\\d)\\d|9(?:[0-46]\\d\\d|5[15]0|8(?:1\\d|88)|9(?:0[0-3]|[19]\\d|21|77|8[7-9])))\\d{5}",,,,"9123456789",,,[10]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],
[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"IR",98,"00","0",,,"0",,,,[[,"(\\d{4,5})","$1",["96"],"0$1"],[,"(\\d{2})(\\d{4,5})","$1 $2",["(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["9"],"0$1"],[,"(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["[1-8]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,"9(?:4440\\d{5}|6(?:0[12]|2[16-8]|3(?:08|[14]5|[23]|66)|4(?:0|80)|5[01]|6[89]|86|9[19]))",,,,,,,[4,5,10]],[,,"96(?:0[12]|2[16-8]|3(?:08|[14]5|[23]|66)|4(?:0|80)|5[01]|6[89]|86|9[19])",
,,,"9601",,,[4,5]],,,[,,,,,,,,,[-1]]],IS:[,[,,"(?:38\\d|[4-9])\\d{6}",,,,,,,[7,9]],[,,"(?:4(?:1[0-24-69]|2[0-7]|[37][0-8]|4[0-24589]|5[0-68]|6\\d|8[0-36-8])|5(?:05|[156]\\d|2[02578]|3[0-579]|4[03-7]|7[0-2578]|8[0-35-9]|9[013-689])|872)\\d{4}",,,,"4101234",,,[7]],[,,"(?:38[589]\\d\\d|6(?:1[1-8]|2[0-6]|3[026-9]|4[014679]|5[0159]|6[0-69]|70|8[06-8]|9\\d)|7(?:5[057]|[6-9]\\d)|8(?:2[0-59]|[3-69]\\d|8[238]))\\d{4}",,,,"6111234"],[,,"80[0-8]\\d{4}",,,,"8001234",,,[7]],[,,"90(?:0\\d|1[5-79]|2[015-79]|3[135-79]|4[125-7]|5[25-79]|7[1-37]|8[0-35-7])\\d{3}",
,,,"9001234",,,[7]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"49[0-24-79]\\d{4}",,,,"4921234",,,[7]],"IS",354,"00|1(?:0(?:01|[12]0)|100)",,,,,,"00",,[[,"(\\d{3})(\\d{4})","$1 $2",["[4-9]"]],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["3"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"809\\d{4}",,,,"8091234",,,[7]],,,[,,"(?:689|8(?:7[18]|80)|95[48])\\d{4}",,,,"6891234",,,[7]]],IT:[,[,,"0\\d{5,10}|1\\d{8,10}|3(?:[0-8]\\d{7,10}|9\\d{7,8})|(?:55|70)\\d{8}|8\\d{5}(?:\\d{2,4})?",,,,,,,[6,7,8,9,10,11,12]],[,,"0669[0-79]\\d{1,6}|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}",
,,,"0212345678",,,[6,7,8,9,10,11]],[,,"3[1-9]\\d{8}|3[2-9]\\d{7}",,,,"3123456789",,,[9,10]],[,,"80(?:0\\d{3}|3)\\d{3}",,,,"800123456",,,[6,9]],[,,"(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}",,,,"899123456",,,[6,8,9,10]],[,,"84(?:[08]\\d{3}|[17])\\d{3}",,,,"848123456",,,[6,9]],[,,"1(?:78\\d|99)\\d{6}",,,,"1781234567",,,[9,10]],[,,"55\\d{8}",,,,"5512345678",,,[10]],"IT",39,"00",,,,,,,,[[,"(\\d{4,5})","$1",["1(?:0|9[246])","1(?:0|9(?:2[2-9]|[46]))"]],
[,"(\\d{6})","$1",["1(?:1|92)"]],[,"(\\d{2})(\\d{4,6})","$1 $2",["0[26]"]],[,"(\\d{3})(\\d{3,6})","$1 $2",["0[13-57-9][0159]|8(?:03|4[17]|9[2-5])","0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"]],[,"(\\d{4})(\\d{2,6})","$1 $2",["0(?:[13-579][2-46-8]|8[236-8])"]],[,"(\\d{4})(\\d{4})","$1 $2",["894"]],[,"(\\d{2})(\\d{3,4})(\\d{4})","$1 $2 $3",["0[26]|5"]],[,"(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["1(?:44|[679])|[378]"]],[,"(\\d{3})(\\d{3,4})(\\d{4})","$1 $2 $3",["0[13-57-9][0159]|14"]],[,
"(\\d{2})(\\d{4})(\\d{5})","$1 $2 $3",["0[26]"]],[,"(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["0"]],[,"(\\d{3})(\\d{4})(\\d{4,5})","$1 $2 $3",["3"]]],[[,"(\\d{2})(\\d{4,6})","$1 $2",["0[26]"]],[,"(\\d{3})(\\d{3,6})","$1 $2",["0[13-57-9][0159]|8(?:03|4[17]|9[2-5])","0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"]],[,"(\\d{4})(\\d{2,6})","$1 $2",["0(?:[13-579][2-46-8]|8[236-8])"]],[,"(\\d{4})(\\d{4})","$1 $2",["894"]],[,"(\\d{2})(\\d{3,4})(\\d{4})","$1 $2 $3",["0[26]|5"]],[,"(\\d{3})(\\d{3})(\\d{3,4})",
"$1 $2 $3",["1(?:44|[679])|[378]"]],[,"(\\d{3})(\\d{3,4})(\\d{4})","$1 $2 $3",["0[13-57-9][0159]|14"]],[,"(\\d{2})(\\d{4})(\\d{5})","$1 $2 $3",["0[26]"]],[,"(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["0"]],[,"(\\d{3})(\\d{4})(\\d{4,5})","$1 $2 $3",["3"]]],[,,,,,,,,,[-1]],1,,[,,"848\\d{6}",,,,,,,[9]],[,,,,,,,,,[-1]],,,[,,"3[2-8]\\d{9,10}",,,,"33101234501",,,[11,12]]],JE:[,[,,"1534\\d{6}|(?:[3578]\\d|90)\\d{8}",,,,,,,[10],[6]],[,,"1534[0-24-8]\\d{5}",,,,"1534456789",,,,[6]],[,,"7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97[7-9]))\\d{5}",
,,,"7797712345"],[,,"80(?:07(?:35|81)|8901)\\d{4}",,,,"8007354567"],[,,"(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}",,,,"9018105678"],[,,,,,,,,,[-1]],[,,"701511\\d{4}",,,,"7015115678"],[,,"56\\d{8}",,,,"5612345678"],"JE",44,"00","0",,,"([0-24-8]\\d{5})$|0","1534$1",,,,,[,,"76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}",,,,"7640123456"],,,[,,,,,,,,,[-1]],[,,"(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}",
,,,"5512345678"],,,[,,,,,,,,,[-1]]],JM:[,[,,"(?:[58]\\d\\d|658|900)\\d{7}",,,,,,,[10],[7]],[,,"8766060\\d{3}|(?:658(?:2(?:[0-8]\\d|9[0-46-9])|[3-9]\\d\\d)|876(?:52[35]|6(?:0[1-3579]|1[0235-9]|[23]\\d|40|5[06]|6[2-589]|7[025-9]|8[04]|9[4-9])|7(?:0[2-689]|[1-6]\\d|8[056]|9[45])|9(?:0[1-8]|1[02378]|[2-8]\\d|9[2-468])))\\d{4}",,,,"8765230123",,,,[7]],[,,"(?:658295|876(?:2(?:0[1-9]|[13-9]\\d|2[013-9])|[348]\\d\\d|5(?:0[1-9]|[1-9]\\d)|6(?:4[89]|6[67])|7(?:0[07]|7\\d|8[1-47-9]|9[0-36-9])|9(?:[01]9|9[0579])))\\d{4}",
,,,"8762101234",,,,[7]],[,,"8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",,,,"8002123456"],[,,"900[2-9]\\d{6}",,,,"9002123456"],[,,,,,,,,,[-1]],[,,"52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",,,,"5002345678"],[,,,,,,,,,[-1]],"JM",1,"011","1",,,"1",,,,,,[,,,,,,,,,[-1]],,"658|876",[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,
,,,,[-1]]],JO:[,[,,"(?:(?:[2689]|7\\d)\\d|32|53)\\d{6}",,,,,,,[8,9]],[,,"87(?:000|90[01])\\d{3}|(?:2(?:6(?:2[0-35-9]|3[0-578]|4[24-7]|5[0-24-8]|[6-8][023]|9[0-3])|7(?:0[1-79]|10|2[014-7]|3[0-689]|4[019]|5[0-3578]))|32(?:0[1-69]|1[1-35-7]|2[024-7]|3\\d|4[0-3]|[5-7][023])|53(?:0[0-3]|[13][023]|2[0-59]|49|5[0-35-9]|6[15]|7[45]|8[1-6]|9[0-36-9])|6(?:2(?:[05]0|22)|3(?:00|33)|4(?:0[0-25]|1[2-7]|2[0569]|[38][07-9]|4[025689]|6[0-589]|7\\d|9[0-2])|5(?:[01][056]|2[034]|3[0-57-9]|4[178]|5[0-69]|6[0-35-9]|7[1-379]|8[0-68]|9[0239]))|87(?:20|7[078]|99))\\d{4}",
,,,"62001234",,,[8]],[,,"7(?:[78][0-25-9]|9\\d)\\d{6}",,,,"790123456",,,[9]],[,,"80\\d{6}",,,,"80012345",,,[8]],[,,"9\\d{7}",,,,"90012345",,,[8]],[,,"85\\d{6}",,,,"85012345",,,[8]],[,,"70\\d{7}",,,,"700123456",,,[9]],[,,,,,,,,,[-1]],"JO",962,"00","0",,,"0",,,,[[,"(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["[2356]|87"],"(0$1)"],[,"(\\d{3})(\\d{5,6})","$1 $2",["[89]"],"0$1"],[,"(\\d{2})(\\d{7})","$1 $2",["70"],"0$1"],[,"(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["7"],"0$1"]],,[,,"74(?:66|77)\\d{5}",,,,"746612345",
,,[9]],,,[,,,,,,,,,[-1]],[,,"8(?:10|8\\d)\\d{5}",,,,"88101234",,,[8]],,,[,,,,,,,,,[-1]]],JP:[,[,,"00[1-9]\\d{6,14}|[257-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}",,,,,,,[8,9,10,11,12,13,14,15,16,17]],[,,"(?:1(?:1[235-8]|2[3-6]|3[3-9]|4[2-6]|[58][2-8]|6[2-7]|7[2-9]|9[1-9])|(?:2[2-9]|[36][1-9])\\d|4(?:[2-578]\\d|6[02-8]|9[2-59])|5(?:[2-589]\\d|6[1-9]|7[2-8])|7(?:[25-9]\\d|3[4-9]|4[02-9])|8(?:[2679]\\d|3[2-9]|4[5-9]|5[1-9]|8[03-9])|9(?:[2-58]\\d|[679][1-9]))\\d{6}",,,,"312345678",,,[9]],[,,"[7-9]0[1-9]\\d{7}",
,,,"9012345678",,,[10]],[,,"00777(?:[01]|5\\d)\\d\\d|(?:00(?:7778|882[1245])|(?:120|800\\d)\\d\\d)\\d{4}|00(?:37|66|78)\\d{6,13}",,,,"120123456"],[,,"990\\d{6}",,,,"990123456",,,[9]],[,,,,,,,,,[-1]],[,,"60\\d{7}",,,,"601234567",,,[9]],[,,"50[1-9]\\d{7}",,,,"5012345678",,,[10]],"JP",81,"010","0",,,"0",,,,[[,"(\\d{4})(\\d{4})","$1-$2",["007","0077","00777","00777[01]"]],[,"(\\d{3})(\\d{3})(\\d{3})","$1-$2-$3",["(?:12|57|99)0"],"0$1"],[,"(\\d{4})(\\d)(\\d{4})","$1-$2-$3",["1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51|63)|9(?:80|9[16])",
"1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9]|636)|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]","1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9]|636[457-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["60"],"0$1"],[,"(\\d)(\\d{4})(\\d{4})","$1-$2-$3",["[36]|4(?:2[09]|7[01])","[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))"],
"0$1"],[,"(\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[27-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])","1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9])|5(?:2|3[045]|4[0-369]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|49|51|6(?:[0-24]|36|5[0-3589]|72|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:49|55|83)[29]|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]",
"1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[23]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|72|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]",
"1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|7[015-9]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17|3[015-9]))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9(?:[019]|4[1-3]|6(?:[0-47-9]|5[01346-9])))|3(?:[29]|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[23]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|72|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|829(?:2|66)|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"],
"0$1"],[,"(\\d{3})(\\d{2})(\\d{4})","$1-$2-$3",["[14]|[289][2-9]|5[3-9]|7[2-4679]"],"0$1"],[,"(\\d{4})(\\d{2})(\\d{3,4})","$1-$2-$3",["007","0077"]],[,"(\\d{4})(\\d{2})(\\d{4})","$1-$2-$3",["008"]],[,"(\\d{3})(\\d{3})(\\d{4})","$1-$2-$3",["800"],"0$1"],[,"(\\d{2})(\\d{4})(\\d{4})","$1-$2-$3",["[257-9]"],"0$1"],[,"(\\d{4})(\\d{3})(\\d{3,4})","$1-$2-$3",["0"]],[,"(\\d{4})(\\d{4})(\\d{4,5})","$1-$2-$3",["0"]],[,"(\\d{4})(\\d{5})(\\d{5,6})","$1-$2-$3",["0"]],[,"(\\d{4})(\\d{6})(\\d{6,7})","$1-$2-$3",
["0"]]],[[,"(\\d{3})(\\d{3})(\\d{3})","$1-$2-$3",["(?:12|57|99)0"],"0$1"],[,"(\\d{4})(\\d)(\\d{4})","$1-$2-$3",["1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51|63)|9(?:80|9[16])","1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9]|636)|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]","1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9]|636[457-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"],
"0$1"],[,"(\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["60"],"0$1"],[,"(\\d)(\\d{4})(\\d{4})","$1-$2-$3",["[36]|4(?:2[09]|7[01])","[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[27-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])",
"1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9])|5(?:2|3[045]|4[0-369]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|49|51|6(?:[0-24]|36|5[0-3589]|72|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:49|55|83)[29]|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]",
"1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[23]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|72|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]",
"1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|7[015-9]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17|3[015-9]))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9(?:[019]|4[1-3]|6(?:[0-47-9]|5[01346-9])))|3(?:[29]|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[23]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|72|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|829(?:2|66)|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"],
"0$1"],[,"(\\d{3})(\\d{2})(\\d{4})","$1-$2-$3",["[14]|[289][2-9]|5[3-9]|7[2-4679]"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{4})","$1-$2-$3",["800"],"0$1"],[,"(\\d{2})(\\d{4})(\\d{4})","$1-$2-$3",["[257-9]"],"0$1"]],[,,"20\\d{8}",,,,"2012345678",,,[10]],,,[,,"00(?:777(?:[01]|(?:5|8\\d)\\d)|882[1245]\\d\\d)\\d\\d|00(?:37|66|78)\\d{6,13}"],[,,"570\\d{6}",,,,"570123456",,,[9]],,,[,,,,,,,,,[-1]]],KE:[,[,,"(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}",,,,,,,[7,8,9,10]],[,,"(?:4[245]|5[1-79]|6[01457-9])\\d{5,7}|(?:4[136]|5[08]|62)\\d{7}|(?:[24]0|66)\\d{6,7}",
,,,"202012345",,,[7,8,9]],[,,"(?:1(?:0[0-6]|1[0-5]|2[014]|30)|7\\d\\d)\\d{6}",,,,"712123456",,,[9]],[,,"800[2-8]\\d{5,6}",,,,"800223456",,,[9,10]],[,,"900[02-9]\\d{5}",,,,"900223456",,,[9]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"KE",254,"000","0",,,"0",,,,[[,"(\\d{2})(\\d{5,7})","$1 $2",["[24-6]"],"0$1"],[,"(\\d{3})(\\d{6})","$1 $2",["[17]"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["[89]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],KG:[,[,,"8\\d{9}|(?:[235-8]\\d|99)\\d{7}",
,,,,,,[9,10],[5,6]],[,,"312(?:5[0-79]\\d|9(?:[0-689]\\d|7[0-24-9]))\\d{3}|(?:3(?:1(?:2[0-46-8]|3[1-9]|47|[56]\\d)|2(?:22|3[0-479]|6[0-7])|4(?:22|5[6-9]|6\\d)|5(?:22|3[4-7]|59|6\\d)|6(?:22|5[35-7]|6\\d)|7(?:22|3[468]|4[1-9]|59|[67]\\d)|9(?:22|4[1-8]|6\\d))|6(?:09|12|2[2-4])\\d)\\d{5}",,,,"312123456",,,[9],[5,6]],[,,"312(?:58\\d|973)\\d{3}|(?:2(?:0[0-35]|2\\d)|5[0-24-7]\\d|600|7(?:[07]\\d|55)|88[08]|99[05-9])\\d{6}",,,,"700123456",,,[9]],[,,"800\\d{6,7}",,,,"800123456"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],
[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"KG",996,"00","0",,,"0",,,,[[,"(\\d{4})(\\d{5})","$1 $2",["3(?:1[346]|[24-79])"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[235-79]|88"],"0$1"],[,"(\\d{3})(\\d{3})(\\d)(\\d{2,3})","$1 $2 $3 $4",["8"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],KH:[,[,,"1\\d{9}|[1-9]\\d{7,8}",,,,,,,[8,9,10],[6,7]],[,,"23(?:4(?:[2-4]|[56]\\d)|[568]\\d\\d)\\d{4}|23[236-9]\\d{5}|(?:2[4-6]|3[2-6]|4[2-4]|[5-7][2-5])(?:(?:[237-9]|4[56]|5\\d)\\d{5}|6\\d{5,6})",
,,,"23756789",,,[8,9],[6,7]],[,,"(?:(?:1[28]|3[18]|9[67])\\d|6[016-9]|7(?:[07-9]|[16]\\d)|8(?:[013-79]|8\\d))\\d{6}|(?:1\\d|9[0-57-9])\\d{6}|(?:2[3-6]|3[2-6]|4[2-4]|[5-7][2-5])48\\d{5}",,,,"91234567",,,[8,9]],[,,"1800(?:1\\d|2[019])\\d{4}",,,,"1800123456",,,[10]],[,,"1900(?:1\\d|2[09])\\d{4}",,,,"1900123456",,,[10]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"KH",855,"00[14-9]","0",,,"0",,,,[[,"(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[1-9]"],"0$1"],[,"(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1"]]],
,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],KI:[,[,,"(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}",,,,,,,[5,8]],[,,"(?:[24]\\d|3[1-9]|50|65(?:02[12]|12[56]|22[89]|[3-5]00)|7(?:27\\d\\d|3100|5(?:02[12]|12[56]|22[89]|[34](?:00|81)|500))|8[0-5])\\d{3}",,,,"31234"],[,,"(?:63\\d{3}|73(?:0[0-5]\\d|140))\\d{3}|[67]200[01]\\d{3}",,,,"72001234",,,[8]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"30(?:0[01]\\d\\d|12(?:11|20))\\d\\d",,,,"30010000",,,[8]],
"KI",686,"00","0",,,"0",,,,,,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],KM:[,[,,"[3478]\\d{6}",,,,,,,[7],[4]],[,,"7[4-7]\\d{5}",,,,"7712345",,,,[4]],[,,"[34]\\d{6}",,,,"3212345"],[,,,,,,,,,[-1]],[,,"8\\d{6}",,,,"8001234"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"KM",269,"00",,,,,,,,[[,"(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3",["[3478]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],KN:[,[,,"(?:[58]\\d\\d|900)\\d{7}",,,,,,,[10],[7]],[,,"869(?:2(?:29|36)|302|4(?:6[015-9]|70)|56[5-7])\\d{4}",
,,,"8692361234",,,,[7]],[,,"869(?:48[89]|55[6-8]|66\\d|76[02-7])\\d{4}",,,,"8697652917",,,,[7]],[,,"8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",,,,"8002123456"],[,,"900[2-9]\\d{6}",,,,"9002123456"],[,,,,,,,,,[-1]],[,,"52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",,,,"5002345678"],[,,,,,,,,,[-1]],"KN",1,"011","1",,,"([2-7]\\d{6})$|1",
"869$1",,,,,[,,,,,,,,,[-1]],,"869",[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],KP:[,[,,"85\\d{6}|(?:19\\d|[2-7])\\d{7}",,,,,,,[8,10],[6,7]],[,,"(?:(?:195|2)\\d|3[19]|4[159]|5[37]|6[17]|7[39]|85)\\d{6}",,,,"21234567",,,,[6,7]],[,,"19[1-3]\\d{7}",,,,"1921234567",,,[10]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"KP",850,"00|99","0",,,"0",,,,[[,"(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["8"],"0$1"],[,"(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["[2-7]"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{4})",
"$1 $2 $3",["1"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,"238[02-9]\\d{4}|2(?:[0-24-9]\\d|3[0-79])\\d{5}",,,,,,,[8]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],KR:[,[,,"00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}",,,,,,,[5,6,8,9,10,11,12,13,14],[3,4,7]],[,,"(?:2|3[1-3]|[46][1-4]|5[1-5])[1-9]\\d{6,7}|(?:3[1-3]|[46][1-4]|5[1-5])1\\d{2,3}",,,,"22123456",,,[5,6,8,9,10],[3,4,7]],[,,"1(?:05(?:[0-8]\\d|9[0-6])|22[13]\\d)\\d{4,5}|1(?:0[1-46-9]|[16-9]\\d|2[013-9])\\d{6,7}",
,,,"1020000000",,,[9,10]],[,,"00(?:308\\d{6,7}|798\\d{7,9})|(?:00368|80)\\d{7}",,,,"801234567",,,[9,11,12,13,14]],[,,"60[2-9]\\d{6}",,,,"602345678",,,[9]],[,,,,,,,,,[-1]],[,,"50\\d{8,9}",,,,"5012345678",,,[10,11]],[,,"70\\d{8}",,,,"7012345678",,,[10]],"KR",82,"00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))","0",,,"0(8(?:[1-46-8]|5\\d\\d))?",,,,[[,"(\\d{5})","$1",["1[016-9]1","1[016-9]11","1[016-9]114"],"0$1"],[,"(\\d{2})(\\d{3,4})","$1-$2",["(?:3[1-3]|[46][1-4]|5[1-5])1"],"0$1","0$CC-$1"],[,
"(\\d{4})(\\d{4})","$1-$2",["1"]],[,"(\\d)(\\d{3,4})(\\d{4})","$1-$2-$3",["2"],"0$1","0$CC-$1"],[,"(\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["60|8"],"0$1","0$CC-$1"],[,"(\\d{2})(\\d{3,4})(\\d{4})","$1-$2-$3",["[1346]|5[1-5]"],"0$1","0$CC-$1"],[,"(\\d{2})(\\d{4})(\\d{4})","$1-$2-$3",["[57]"],"0$1","0$CC-$1"],[,"(\\d{5})(\\d{3})(\\d{3})","$1 $2 $3",["003","0030"]],[,"(\\d{2})(\\d{5})(\\d{4})","$1-$2-$3",["5"],"0$1","0$CC-$1"],[,"(\\d{5})(\\d{3,4})(\\d{4})","$1 $2 $3",["0"]],[,"(\\d{5})(\\d{2})(\\d{3})(\\d{4})",
"$1 $2 $3 $4",["0"]]],[[,"(\\d{2})(\\d{3,4})","$1-$2",["(?:3[1-3]|[46][1-4]|5[1-5])1"],"0$1","0$CC-$1"],[,"(\\d{4})(\\d{4})","$1-$2",["1"]],[,"(\\d)(\\d{3,4})(\\d{4})","$1-$2-$3",["2"],"0$1","0$CC-$1"],[,"(\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["60|8"],"0$1","0$CC-$1"],[,"(\\d{2})(\\d{3,4})(\\d{4})","$1-$2-$3",["[1346]|5[1-5]"],"0$1","0$CC-$1"],[,"(\\d{2})(\\d{4})(\\d{4})","$1-$2-$3",["[57]"],"0$1","0$CC-$1"],[,"(\\d{2})(\\d{5})(\\d{4})","$1-$2-$3",["5"],"0$1","0$CC-$1"]],[,,"15\\d{7,8}",,,,"1523456789",
,,[9,10]],,,[,,"00(?:3(?:08\\d{6,7}|68\\d{7})|798\\d{7,9})",,,,,,,[11,12,13,14]],[,,"1(?:5(?:22|33|44|66|77|88|99)|6(?:[07]0|44|6[168]|88)|8(?:00|33|55|77|99))\\d{4}",,,,"15441234",,,[8]],,,[,,,,,,,,,[-1]]],KW:[,[,,"18\\d{5}|(?:[2569]\\d|41)\\d{6}",,,,,,,[7,8]],[,,"2(?:[23]\\d\\d|4(?:[1-35-9]\\d|44)|5(?:0[034]|[2-46]\\d|5[1-3]|7[1-7]))\\d{4}",,,,"22345678",,,[8]],[,,"(?:41\\d\\d|5(?:(?:[05]\\d|1[0-7]|6[56])\\d|2(?:22|5[25])|7(?:55|77)|88[58])|6(?:(?:0[034679]|5[015-9]|6\\d)\\d|1(?:00|11|66)|222|3[36]3|444|7(?:0[013-9]|[67]\\d)|888|9(?:[069]\\d|3[039]))|9(?:(?:0[09]|22|[4679]\\d|8[057-9])\\d|1(?:1[01]|99)|3(?:00|33)|5(?:00|5\\d)))\\d{4}",
,,,"50012345",,,[8]],[,,"18\\d{5}",,,,"1801234",,,[7]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"KW",965,"00",,,,,,,,[[,"(\\d{4})(\\d{3,4})","$1 $2",["[169]|2(?:[235]|4[1-35-9])|52"]],[,"(\\d{3})(\\d{5})","$1 $2",["[245]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],KY:[,[,,"(?:345|[58]\\d\\d|900)\\d{7}",,,,,,,[10],[7]],[,,"345(?:2(?:22|3[23]|44|66)|333|444|6(?:23|38|40)|7(?:30|4[35-79]|6[6-9]|77)|8(?:00|1[45]|[48]8)|9(?:14|4[035-9]))\\d{4}",,,,"3452221234",
,,,[7]],[,,"345(?:32[1-9]|42[0-4]|5(?:1[67]|2[5-79]|4[6-9]|50|76)|649|82[56]|9(?:1[679]|2[2-9]|3[06-9]|90))\\d{4}",,,,"3453231234",,,,[7]],[,,"8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",,,,"8002345678"],[,,"(?:345976|900[2-9]\\d\\d)\\d{4}",,,,"9002345678"],[,,,,,,,,,[-1]],[,,"52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
,,,"5002345678"],[,,,,,,,,,[-1]],"KY",1,"011","1",,,"([2-9]\\d{6})$|1","345$1",,,,,[,,"345849\\d{4}",,,,"3458491234"],,"345",[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],KZ:[,[,,"(?:33622|8\\d{8})\\d{5}|[78]\\d{9}",,,,,,,[10,14],[5,6,7]],[,,"(?:33622|7(?:1(?:0(?:[23]\\d|4[0-3]|59|63)|1(?:[23]\\d|4[0-79]|59)|2(?:[23]\\d|59)|3(?:2\\d|3[0-79]|4[0-35-9]|59)|4(?:[24]\\d|3[013-9]|5[1-9]|97)|5(?:2\\d|3[1-9]|4[0-7]|59)|6(?:[2-4]\\d|5[19]|61)|72\\d|8(?:[27]\\d|3[1-46-9]|4[0-5]|59))|2(?:1(?:[23]\\d|4[46-9]|5[3469])|2(?:2\\d|3[0679]|46|5[12679])|3(?:[2-4]\\d|5[139])|4(?:2\\d|3[1-35-9]|59)|5(?:[23]\\d|4[0-8]|59|61)|6(?:2\\d|3[1-9]|4[0-4]|59)|7(?:[2379]\\d|40|5[279])|8(?:[23]\\d|4[0-3]|59)|9(?:2\\d|3[124578]|59))))\\d{5}",
,,,"7123456789",,,[10],[5,6,7]],[,,"7(?:0[0-25-8]|47|6[0-4]|7[15-8]|85)\\d{7}",,,,"7710009998",,,[10]],[,,"8(?:00|108\\d{3})\\d{7}",,,,"8001234567"],[,,"809\\d{7}",,,,"8091234567",,,[10]],[,,,,,,,,,[-1]],[,,"808\\d{7}",,,,"8081234567",,,[10]],[,,"751\\d{7}",,,,"7511234567",,,[10]],"KZ",7,"810","8",,,"8",,"8~10",,,,[,,,,,,,,,[-1]],,"33|7",[,,"751\\d{7}",,,,,,,[10]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],LA:[,[,,"[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}",,,,,,,[8,9,10],[6]],[,,"(?:2[13]|[35-7][14]|41|8[1468])\\d{6}",
,,,"21212862",,,[8],[6]],[,,"(?:20(?:[2359]\\d|7[6-8]|88)|302\\d)\\d{6}",,,,"2023123456",,,[10]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"LA",856,"00","0",,,"0",,,,[[,"(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["2[13]|3[14]|[4-8]"],"0$1"],[,"(\\d{2})(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3 $4",["30[013-9]"],"0$1"],[,"(\\d{2})(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3 $4",["[23]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"30[013-9]\\d{6}",,,,"301234567",,,[9]],,,[,,,,,,
,,,[-1]]],LB:[,[,,"[27-9]\\d{7}|[13-9]\\d{6}",,,,,,,[7,8]],[,,"7(?:62|8[0-7]|9[04-9])\\d{4}|(?:[14-69]\\d|2(?:[14-69]\\d|[78][1-9])|7[2-57]|8[02-9])\\d{5}",,,,"1123456"],[,,"793(?:[01]\\d|2[0-4])\\d{3}|(?:(?:3|81)\\d|7(?:[01]\\d|6[013-9]|8[89]|9[12]))\\d{5}",,,,"71123456"],[,,,,,,,,,[-1]],[,,"9[01]\\d{6}",,,,"90123456",,,[8]],[,,"80\\d{6}",,,,"80123456",,,[8]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"LB",961,"00","0",,,"0",,,,[[,"(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]"],
"0$1"],[,"(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[27-9]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],LC:[,[,,"(?:[58]\\d\\d|758|900)\\d{7}",,,,,,,[10],[7]],[,,"758(?:234|4(?:30|5\\d|6[2-9]|8[0-2])|57[0-2]|(?:63|75)8)\\d{4}",,,,"7584305678",,,,[7]],[,,"758(?:28[4-7]|384|4(?:6[01]|8[4-9])|5(?:1[89]|20|84)|7(?:1[2-9]|2\\d|3[0-3])|812)\\d{4}",,,,"7582845678",,,,[7]],[,,"8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",,,,"8002123456"],[,,"900[2-9]\\d{6}",,,,"9002123456"],[,,,,,,,,,[-1]],
[,,"52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",,,,"5002345678"],[,,,,,,,,,[-1]],"LC",1,"011","1",,,"([2-8]\\d{6})$|1","758$1",,,,,[,,,,,,,,,[-1]],,"758",[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],LI:[,[,,"[68]\\d{8}|(?:[2378]\\d|90)\\d{5}",,,,,,,[7,9]],[,,"(?:2(?:01|1[27]|2[02]|3\\d|6[02-578]|96)|3(?:[24]0|33|7[0135-7]|8[048]|9[0269]))\\d{4}",
,,,"2345678",,,[7]],[,,"(?:6(?:(?:4[5-9]|5[0-4])\\d|6(?:[0245]\\d|[17]0|3[7-9]))\\d|7(?:[37-9]\\d|42|56))\\d{4}",,,,"660234567"],[,,"8002[28]\\d\\d|80(?:05\\d|9)\\d{4}",,,,"8002222"],[,,"90(?:02[258]|1(?:23|3[14])|66[136])\\d\\d",,,,"9002222",,,[7]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"LI",423,"00","0",,,"(1001)|0",,,,[[,"(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3",["[2379]|8(?:0[09]|7)","[2379]|8(?:0(?:02|9)|7)"],,"$CC $1"],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["8"]],[,"(\\d{2})(\\d{3})(\\d{4})",
"$1 $2 $3",["69"],,"$CC $1"],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["6"],,"$CC $1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"870(?:28|87)\\d\\d",,,,"8702812",,,[7]],,,[,,"697(?:42|56|[78]\\d)\\d{4}",,,,"697861234",,,[9]]],LK:[,[,,"[1-9]\\d{8}",,,,,,,[9],[7]],[,,"(?:12[2-9]|602|8[12]\\d|9(?:1\\d|22|9[245]))\\d{6}|(?:11|2[13-7]|3[1-8]|4[157]|5[12457]|6[35-7])[2-57]\\d{6}",,,,"112345678",,,,[7]],[,,"7(?:[0-25-8]\\d|4[0-4])\\d{6}",,,,"712345678"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,
,,,,,[-1]],[,,,,,,,,,[-1]],"LK",94,"00","0",,,"0",,,,[[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["7"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[1-689]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"1973\\d{5}",,,,"197312345"],,,[,,,,,,,,,[-1]]],LR:[,[,,"(?:[25]\\d|33|77|88)\\d{7}|(?:2\\d|[4-6])\\d{6}",,,,,,,[7,8,9]],[,,"(?:2\\d{3}|33333)\\d{4}",,,,"21234567",,,[8,9]],[,,"(?:(?:(?:22|33)0|555|(?:77|88)\\d)\\d|4[67])\\d{5}|[56]\\d{6}",,,,"770123456",,,[7,9]],[,,,,,,,,,[-1]],[,,"332(?:02|[34]\\d)\\d{4}",
,,,"332021234",,,[9]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"LR",231,"00","0",,,"0",,,,[[,"(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[4-6]"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["2"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[23578]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],LS:[,[,,"(?:[256]\\d\\d|800)\\d{5}",,,,,,,[8]],[,,"2\\d{7}",,,,"22123456"],[,,"[56]\\d{7}",,,,"50123456"],[,,"800[256]\\d{4}",,,,"80021234"],[,,,,,,,,,[-1]],[,,,,,,,,
,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"LS",266,"00",,,,,,,,[[,"(\\d{4})(\\d{4})","$1 $2",["[2568]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],LT:[,[,,"(?:[3469]\\d|52|[78]0)\\d{6}",,,,,,,[8]],[,,"(?:3[1478]|4[124-6]|52)\\d{6}",,,,"31234567"],[,,"6\\d{7}",,,,"61234567"],[,,"80[02]\\d{5}",,,,"80012345"],[,,"9(?:0[0239]|10)\\d{5}",,,,"90012345"],[,,"808\\d{5}",,,,"80812345"],[,,"70[05]\\d{5}",,,,"70012345"],[,,"[89]01\\d{5}",,,,"80123456"],"LT",370,"00","8",,,"[08]",,,
,[[,"(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["52[0-7]"],"(8-$1)",,1],[,"(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["[7-9]"],"8 $1",,1],[,"(\\d{2})(\\d{6})","$1 $2",["37|4(?:[15]|6[1-8])"],"(8-$1)",,1],[,"(\\d{3})(\\d{5})","$1 $2",["[3-6]"],"(8-$1)",,1]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"70[67]\\d{5}",,,,"70712345"],,,[,,,,,,,,,[-1]]],LU:[,[,,"35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}",,,,,,,[4,5,6,7,8,9,10,11]],[,,"(?:35[013-9]|80[2-9]|90[89])\\d{1,8}|(?:2[2-9]|3[0-46-9]|[457]\\d|8[13-9]|9[2-579])\\d{2,9}",
,,,"27123456"],[,,"6(?:[269][18]|5[1568]|7[189]|81)\\d{6}",,,,"628123456",,,[9]],[,,"800\\d{5}",,,,"80012345",,,[8]],[,,"90[015]\\d{5}",,,,"90012345",,,[8]],[,,"801\\d{5}",,,,"80112345",,,[8]],[,,,,,,,,,[-1]],[,,"20(?:1\\d{5}|[2-689]\\d{1,7})",,,,"20201234",,,[4,5,6,7,8,9,10]],"LU",352,"00",,,,"(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)",,,,[[,"(\\d{2})(\\d{3})","$1 $2",["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"],,"$CC $1"],[,"(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"],
,"$CC $1"],[,"(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["20[2-689]"],,"$CC $1"],[,"(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})","$1 $2 $3 $4",["2(?:[0367]|4[3-8])"],,"$CC $1"],[,"(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["80[01]|90[015]"],,"$CC $1"],[,"(\\d{2})(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3 $4",["20"],,"$CC $1"],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["6"],,"$CC $1"],[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})","$1 $2 $3 $4 $5",["2(?:[0367]|4[3-8])"],,"$CC $1"],[,"(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})","$1 $2 $3 $4",
["[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"],,"$CC $1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],LV:[,[,,"(?:[268]\\d|90)\\d{6}",,,,,,,[8]],[,,"6\\d{7}",,,,"63123456"],[,,"23(?:23[0-57-9]|33[0238])\\d{3}|2(?:[0-24-9]\\d\\d|3(?:0[07]|[14-9]\\d|2[024-9]|3[0-24-9]))\\d{4}",,,,"21234567"],[,,"80\\d{6}",,,,"80123456"],[,,"90\\d{6}",,,,"90123456"],[,,"81\\d{6}",,,,"81123456"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"LV",371,"00",,,,,,,,[[,"(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",
["[269]|8[01]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],LY:[,[,,"[2-9]\\d{8}",,,,,,,[9],[7]],[,,"(?:2(?:0[56]|[1-6]\\d|7[124579]|8[124])|3(?:1\\d|2[2356])|4(?:[17]\\d|2[1-357]|5[2-4]|8[124])|5(?:[1347]\\d|2[1-469]|5[13-5]|8[1-4])|6(?:[1-479]\\d|5[2-57]|8[1-5])|7(?:[13]\\d|2[13-79])|8(?:[124]\\d|5[124]|84))\\d{6}",,,,"212345678",,,,[7]],[,,"9[1-6]\\d{7}",,,,"912345678"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"LY",218,"00","0",
,,"0",,,,[[,"(\\d{2})(\\d{7})","$1-$2",["[2-9]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],MA:[,[,,"[5-8]\\d{8}",,,,,,,[9]],[,,"5293[01]\\d{4}|5(?:2(?:[0-25-7]\\d|3[1-578]|4[02-46-8]|8[0235-7]|9[0-289])|3(?:[0-47]\\d|5[02-9]|6[02-8]|8[0189]|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}",,,,"520123456"],[,,"(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[017]\\d|2[0-2]|6[0-8]|8[0-3]))\\d{6}",,,,"650123456"],[,,"80\\d{7}",,,,"801234567"],[,,"89\\d{7}",,,,"891234567"],[,,,,,,,,,[-1]],[,,,
,,,,,,[-1]],[,,"592(?:4[0-2]|93)\\d{4}",,,,"592401234"],"MA",212,"00","0",,,"0",,,,[[,"(\\d{5})(\\d{4})","$1-$2",["5(?:29|38)","5(?:29[1289]|389)","529(?:1[1-46-9]|2[013-8]|90)|5(?:298|389)[0-46-9]"],"0$1"],[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["5[45]"],"0$1"],[,"(\\d{4})(\\d{5})","$1-$2",["5(?:2[2-489]|3[5-9]|9)|892","5(?:2(?:[2-49]|8[235-9])|3[5-9]|9)|892"],"0$1"],[,"(\\d{2})(\\d{7})","$1-$2",["8"],"0$1"],[,"(\\d{3})(\\d{6})","$1-$2",["[5-7]"],"0$1"]],,[,,,,,,,,,[-1]],1,,[,,,,,,,,
,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],MC:[,[,,"(?:[3489]|6\\d)\\d{7}",,,,,,,[8,9]],[,,"(?:870|9[2-47-9]\\d)\\d{5}",,,,"99123456",,,[8]],[,,"4(?:[46]\\d|5[1-9])\\d{5}|(?:3|6\\d)\\d{7}",,,,"612345678"],[,,"(?:800|90\\d)\\d{5}",,,,"90123456",,,[8]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"MC",377,"00","0",,,"0",,,,[[,"(\\d{3})(\\d{3})(\\d{2})","$1 $2 $3",["87"]],[,"(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["4"],"0$1"],[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[389]"]],
[,"(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["6"],"0$1"]],[[,"(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["4"],"0$1"],[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[389]"]],[,"(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["6"],"0$1"]],[,,,,,,,,,[-1]],,,[,,"8[07]0\\d{5}",,,,,,,[8]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],MD:[,[,,"(?:[235-7]\\d|[89]0)\\d{6}",,,,,,,[8]],[,,"(?:(?:2[1-9]|3[1-79])\\d|5(?:33|5[257]))\\d{5}",,,,"22212345"],[,,"562\\d{5}|(?:6\\d|7[16-9])\\d{6}",,,,"62112345"],
[,,"800\\d{5}",,,,"80012345"],[,,"90[056]\\d{5}",,,,"90012345"],[,,"808\\d{5}",,,,"80812345"],[,,,,,,,,,[-1]],[,,"3[08]\\d{6}",,,,"30123456"],"MD",373,"00","0",,,"0",,,,[[,"(\\d{3})(\\d{5})","$1 $2",["[89]"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["22|3"],"0$1"],[,"(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["[25-7]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"803\\d{5}",,,,"80312345"],,,[,,,,,,,,,[-1]]],ME:[,[,,"(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}",,,,,,,[8,9],[6]],[,,"(?:20[2-8]|3(?:[0-2][2-7]|3[24-7])|4(?:0[2-467]|1[2467])|5(?:0[2467]|1[24-7]|2[2-467]))\\d{5}",
,,,"30234567",,,[8],[6]],[,,"6(?:[07-9]\\d|3[024]|6[0-25])\\d{5}",,,,"67622901",,,[8]],[,,"80(?:[0-2578]|9\\d)\\d{5}",,,,"80080002"],[,,"9(?:4[1568]|5[178])\\d{5}",,,,"94515151",,,[8]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"78[1-49]\\d{5}",,,,"78108780",,,[8]],"ME",382,"00","0",,,"0",,,,[[,"(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[2-9]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"77[1-9]\\d{5}",,,,"77273012",,,[8]],,,[,,,,,,,,,[-1]]],MF:[,[,,"(?:590|(?:69|80)\\d|976)\\d{6}",,,,,,,[9]],[,,"590(?:0[079]|[14]3|[27][79]|30|5[0-268]|87)\\d{4}",
,,,"590271234"],[,,"69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}",,,,"690001234"],[,,"80[0-5]\\d{6}",,,,"800012345"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"976[01]\\d{5}",,,,"976012345"],"MF",590,"00","0",,,"0",,,,,,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],MG:[,[,,"[23]\\d{8}",,,,,,,[9],[7]],[,,"2072[29]\\d{4}|20(?:2\\d|4[47]|5[3467]|6[279]|7[35]|8[268]|9[245])\\d{5}",,,,"202123456",,,,[7]],[,,"3[2-47-9]\\d{7}",,,,"321234567"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,
,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"22\\d{7}",,,,"221234567"],"MG",261,"00","0",,,"([24-9]\\d{6})$|0","20$1",,,[[,"(\\d{2})(\\d{2})(\\d{3})(\\d{2})","$1 $2 $3 $4",["[23]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],MH:[,[,,"329\\d{4}|(?:[256]\\d|45)\\d{5}",,,,,,,[7]],[,,"(?:247|528|625)\\d{4}",,,,"2471234"],[,,"(?:(?:23|54)5|329|45[356])\\d{4}",,,,"2351234"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"635\\d{4}",,,,"6351234"],"MH",692,"011",
"1",,,"1",,,,[[,"(\\d{3})(\\d{4})","$1-$2",["[2-6]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],MK:[,[,,"[2-578]\\d{7}",,,,,,,[8],[6,7]],[,,"(?:(?:2(?:62|77)0|3444)\\d|4[56]440)\\d{3}|(?:34|4[357])700\\d{3}|(?:2(?:[0-3]\\d|5[0-578]|6[01]|82)|3(?:1[3-68]|[23][2-68]|4[23568])|4(?:[23][2-68]|4[3-68]|5[2568]|6[25-8]|7[24-68]|8[4-68]))\\d{5}",,,,"22012345",,,,[6,7]],[,,"7(?:3555|(?:474|9[019]7)7)\\d{3}|7(?:[0-25-8]\\d\\d|3(?:[1-48]\\d|7[01578])|4(?:2\\d|60|7[01578])|9(?:[2-4]\\d|5[01]|7[015]))\\d{4}",
,,,"72345678"],[,,"800\\d{5}",,,,"80012345"],[,,"5\\d{7}",,,,"50012345"],[,,"8(?:0[1-9]|[1-9]\\d)\\d{5}",,,,"80123456"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"MK",389,"00","0",,,"0",,,,[[,"(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["2|34[47]|4(?:[37]7|5[47]|64)"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[347]"],"0$1"],[,"(\\d{3})(\\d)(\\d{2})(\\d{2})","$1 $2 $3 $4",["[58]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],ML:[,[,,"[24-9]\\d{7}",,,,,,,[8]],[,,"2(?:07[0-8]|12[67])\\d{4}|(?:2(?:02|1[4-689])|4(?:0[0-4]|4[1-39]))\\d{5}",
,,,"20212345"],[,,"2(?:0(?:01|79)|17\\d)\\d{4}|(?:5[01]|[679]\\d|8[2-49])\\d{6}",,,,"65012345"],[,,"80\\d{6}",,,,"80012345"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"ML",223,"00",,,,,,,,[[,"(\\d{4})","$1",["67[057-9]|74[045]","67(?:0[09]|[59]9|77|8[89])|74(?:0[02]|44|55)"]],[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[24-9]"]]],[[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[24-9]"]]],[,,,,,,,,,[-1]],,,[,,"80\\d{6}"],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],MM:[,
[,,"1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}",,,,,,,[6,7,8,9,10],[5]],[,,"(?:1(?:(?:2\\d|3[56]|[89][0-6])\\d|4(?:2[2-469]|39|46|6[25]|7[0-3]|83)|6)|2(?:2(?:00|8[34])|4(?:0\\d|2[246]|39|46|62|7[0-3]|83)|51\\d\\d)|4(?:2(?:2\\d\\d|48[0-3])|3(?:20\\d|4(?:70|83)|56)|420\\d|5470)|6(?:0(?:[23]|88\\d)|(?:124|[56]2\\d)\\d|247[23]|3(?:20\\d|470)|4(?:2[04]\\d|47[23])|7(?:(?:3\\d|8[01459])\\d|4(?:39|60|7[013]))))\\d{4}|5(?:2(?:2\\d{5,6}|47[023]\\d{4})|(?:347[23]|4(?:2(?:1|86)|470)|522\\d|6(?:20\\d|483)|7(?:20\\d|48[0-2])|8(?:20\\d|47[02])|9(?:20\\d|47[01]))\\d{4})|7(?:(?:0470|4(?:25\\d|470)|5(?:202|470|96\\d))\\d{4}|1(?:20\\d{4,5}|4(?:70|83)\\d{4}))|8(?:1(?:2\\d{5,6}|4(?:10|7[01]\\d)\\d{3})|2(?:2\\d{5,6}|(?:320|490\\d)\\d{3})|(?:3(?:2\\d\\d|470)|4[24-7]|5(?:2\\d|4[1-9]|51)\\d|6[23])\\d{4})|(?:1[2-6]\\d|4(?:2[24-8]|3[2-7]|[46][2-6]|5[3-5])|5(?:[27][2-8]|3[2-68]|4[24-8]|5[23]|6[2-4]|8[24-7]|9[2-7])|6(?:[19]20|42[03-6]|(?:52|7[45])\\d)|7(?:[04][24-8]|[15][2-7]|22|3[2-4])|8(?:1[2-689]|2[2-8]|[35]2\\d))\\d{4}|25\\d{5,6}|(?:2[2-9]|6(?:1[2356]|[24][2-6]|3[24-6]|5[2-4]|6[2-8]|7[235-7]|8[245]|9[24])|8(?:3[24]|5[245]))\\d{4}",
,,,"1234567",,,[6,7,8,9],[5]],[,,"(?:17[01]|9(?:2(?:[0-4]|[56]\\d\\d)|(?:3(?:[0-36]|4\\d)|(?:6\\d|9[4-8])\\d|7(?:3|40|[5-9]\\d)|8(?:78|[89]\\d))\\d|4(?:(?:[0245]\\d|[1379])\\d|88)|5[0-6])\\d)\\d{4}|9[69]1\\d{6}|9(?:[68]\\d|9[089])\\d{5}",,,,"92123456",,,[7,8,9,10]],[,,"80080(?:[01][1-9]|2\\d)\\d{3}",,,,"8008001234",,,[10]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"1333\\d{4}|[12]468\\d{4}",,,,"13331234",,,[8]],"MM",95,"00","0",,,"0",,,,[[,"(\\d)(\\d{2})(\\d{3})","$1 $2 $3",["16|2"],"0$1"],
[,"(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["[45]|6(?:0[23]|[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-6]"],"0$1"],[,"(\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["[12]"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[4-7]|8[1-35]"],"0$1"],[,"(\\d)(\\d{3})(\\d{4,6})","$1 $2 $3",["9(?:2[0-4]|[35-9]|4[137-9])"],"0$1"],[,"(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["2"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["8"],"0$1"],[,"(\\d)(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["92"],"0$1"],[,"(\\d)(\\d{5})(\\d{4})","$1 $2 $3",
["9"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],MN:[,[,,"[12]\\d{7,9}|[5-9]\\d{7}",,,,,,,[8,9,10],[4,5,6]],[,,"[12]2[1-3]\\d{5,6}|7(?:0[0-5]\\d|128)\\d{4}|(?:[12](?:1|27)|5[368])\\d{6}|[12](?:3[2-8]|4[2-68]|5[1-4689])\\d{6,7}",,,,"53123456",,,,[4,5,6]],[,,"(?:83[01]|920)\\d{5}|(?:5[05]|6[069]|8[015689]|9[013-9])\\d{6}",,,,"88123456",,,[8]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"712[0-79]\\d{4}|7(?:1[013-9]|[25-9]\\d)\\d{5}",,,,"75123456",
,,[8]],"MN",976,"001","0",,,"0",,,,[[,"(\\d{2})(\\d{2})(\\d{4})","$1 $2 $3",["[12]1"],"0$1"],[,"(\\d{4})(\\d{4})","$1 $2",["[5-9]"]],[,"(\\d{3})(\\d{5,6})","$1 $2",["[12]2[1-3]"],"0$1"],[,"(\\d{4})(\\d{5,6})","$1 $2",["[12](?:27|3[2-8]|4[2-68]|5[1-4689])","[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"],"0$1"],[,"(\\d{5})(\\d{4,5})","$1 $2",["[12]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],MO:[,[,,"0800\\d{3}|(?:28|[68]\\d)\\d{6}",,,,,,,[7,8]],[,,"(?:28[2-9]|8(?:11|[2-57-9]\\d))\\d{5}",
,,,"28212345",,,[8]],[,,"6800[0-79]\\d{3}|6(?:[235]\\d\\d|6(?:0[0-5]|[1-9]\\d)|8(?:0[1-9]|[14-8]\\d|2[5-9]|[39][0-4]))\\d{4}",,,,"66123456",,,[8]],[,,"0800\\d{3}",,,,"0800501",,,[7]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"MO",853,"00",,,,,,,,[[,"(\\d{4})(\\d{3})","$1 $2",["0"]],[,"(\\d{4})(\\d{4})","$1 $2",["[268]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],MP:[,[,,"[58]\\d{9}|(?:67|90)0\\d{7}",,,,,,,[10],[7]],[,,"670(?:2(?:3[3-7]|56|8[4-8])|32[1-38]|4(?:33|8[348])|5(?:32|55|88)|6(?:64|70|82)|78[3589]|8[3-9]8|989)\\d{4}",
,,,"6702345678",,,,[7]],[,,"670(?:2(?:3[3-7]|56|8[4-8])|32[1-38]|4(?:33|8[348])|5(?:32|55|88)|6(?:64|70|82)|78[3589]|8[3-9]8|989)\\d{4}",,,,"6702345678",,,,[7]],[,,"8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",,,,"8002123456"],[,,"900[2-9]\\d{6}",,,,"9002123456"],[,,,,,,,,,[-1]],[,,"52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
,,,"5002345678"],[,,,,,,,,,[-1]],"MP",1,"011","1",,,"([2-9]\\d{6})$|1","670$1",,1,,,[,,,,,,,,,[-1]],,"670",[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],MQ:[,[,,"596\\d{6}|(?:69|80|9\\d)\\d{7}",,,,,,,[9]],[,,"596(?:[03-7]\\d|10|2[7-9]|8[09]|9[4-9])\\d{4}",,,,"596301234"],[,,"69(?:6(?:[0-46-9]\\d|5[0-6])|727)\\d{4}",,,,"696201234"],[,,"80[0-5]\\d{6}",,,,"800012345"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"9(?:(?:39|47)7[01]|76(?:6\\d|7[0-367]))\\d{4}",,,,"976612345"],"MQ",596,"00",
"0",,,"0",,,,[[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[569]"],"0$1"],[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],MR:[,[,,"(?:[2-4]\\d\\d|800)\\d{5}",,,,,,,[8]],[,,"(?:25[08]|35\\d|45[1-7])\\d{5}",,,,"35123456"],[,,"[2-4][0-46-9]\\d{6}",,,,"22123456"],[,,"800\\d{5}",,,,"80012345"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"MR",222,"00",,,,,,,,[[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
"$1 $2 $3 $4",["[2-48]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],MS:[,[,,"(?:[58]\\d\\d|664|900)\\d{7}",,,,,,,[10],[7]],[,,"6644(?:1[0-3]|91)\\d{4}",,,,"6644912345",,,,[7]],[,,"664(?:3(?:49|9[1-6])|49[2-6])\\d{4}",,,,"6644923456",,,,[7]],[,,"8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",,,,"8002123456"],[,,"900[2-9]\\d{6}",,,,"9002123456"],[,,,,,,,,,[-1]],[,,"52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
,,,"5002345678"],[,,,,,,,,,[-1]],"MS",1,"011","1",,,"([34]\\d{6})$|1","664$1",,,,,[,,,,,,,,,[-1]],,"664",[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],MT:[,[,,"3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}",,,,,,,[8]],[,,"20(?:3[1-4]|6[059])\\d{4}|2(?:0[19]|[1-357]\\d|60)\\d{5}",,,,"21001234"],[,,"(?:7(?:210|[79]\\d\\d)|9(?:[29]\\d\\d|69[67]|8(?:1[1-3]|89|97)))\\d{4}",,,,"96961234"],[,,"800(?:02|[3467]\\d)\\d{3}",,,,"80071234"],[,,"5(?:0(?:0(?:37|43)|(?:6\\d|70|9[0168])\\d)|[12]\\d0[1-5])\\d{3}",,,,
"50037123"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"3550\\d{4}",,,,"35501234"],"MT",356,"00",,,,,,,,[[,"(\\d{4})(\\d{4})","$1 $2",["[2357-9]"]]],,[,,"7117\\d{4}",,,,"71171234"],,,[,,,,,,,,,[-1]],[,,"501\\d{5}",,,,"50112345"],,,[,,,,,,,,,[-1]]],MU:[,[,,"(?:[57]|8\\d\\d)\\d{7}|[2-468]\\d{6}",,,,,,,[7,8,10]],[,,"(?:2(?:[0346-8]\\d|1[0-7])|4(?:[013568]\\d|2[4-7])|54(?:[3-5]\\d|71)|6\\d\\d|8(?:14|3[129]))\\d{4}",,,,"54480123",,,[7,8]],[,,"5(?:4(?:2[1-389]|7[1-9])|87[15-8])\\d{4}|(?:5(?:2[5-9]|4[3-689]|[57]\\d|8[0-689]|9[0-8])|7(?:01|30))\\d{5}",
,,,"52512345",,,[8]],[,,"802\\d{7}|80[0-2]\\d{4}",,,,"8001234",,,[7,10]],[,,"30\\d{5}",,,,"3012345",,,[7]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"3(?:20|9\\d)\\d{4}",,,,"3201234",,,[7]],"MU",230,"0(?:0|[24-7]0|3[03])",,,,,,"020",,[[,"(\\d{3})(\\d{4})","$1 $2",["[2-46]|8[013]"]],[,"(\\d{4})(\\d{4})","$1 $2",["[57]"]],[,"(\\d{5})(\\d{5})","$1 $2",["8"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],MV:[,[,,"(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}",,,,,,,[7,10]],[,,"(?:3(?:0[0-3]|3[0-59])|6(?:[58][024689]|6[024-68]|7[02468]))\\d{4}",
,,,"6701234",,,[7]],[,,"(?:46[46]|[79]\\d\\d)\\d{4}",,,,"7712345",,,[7]],[,,"800\\d{7}",,,,"8001234567",,,[10]],[,,"900\\d{7}",,,,"9001234567",,,[10]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"MV",960,"0(?:0|19)",,,,,,"00",,[[,"(\\d{3})(\\d{4})","$1-$2",["[34679]"]],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[89]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"4(?:0[01]|50)\\d{4}",,,,"4001234",,,[7]],,,[,,,,,,,,,[-1]]],MW:[,[,,"(?:[1289]\\d|31|77)\\d{7}|1\\d{6}",,,,,,,[7,9]],[,,"(?:1[2-9]|2[12]\\d\\d)\\d{5}",
,,,"1234567"],[,,"111\\d{6}|(?:31|77|[89][89])\\d{7}",,,,"991234567",,,[9]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"MW",265,"00","0",,,"0",,,,[[,"(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["1[2-9]"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["2"],"0$1"],[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[137-9]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],MX:[,[,,"1(?:(?:[27]2|44|99)[1-9]|65[0-689])\\d{7}|(?:1(?:[01]\\d|2[13-9]|[35][1-9]|4[0-35-9]|6[0-46-9]|7[013-9]|8[1-79]|9[1-8])|[2-9]\\d)\\d{8}",
,,,,,,[10,11],[7,8]],[,,"657[12]\\d{6}|(?:2(?:0[01]|2\\d|3[1-35-8]|4[13-9]|7[1-689]|8[1-578]|9[467])|3(?:1[1-79]|[2458][1-9]|3\\d|7[1-8]|9[1-5])|4(?:1[1-57-9]|[25-7][1-9]|3[1-8]|4\\d|8[1-35-9]|9[2-689])|5(?:[56]\\d|88|9[1-79])|6(?:1[2-68]|[2-4][1-9]|5[1-3689]|6[1-57-9]|7[1-7]|8[67]|9[4-8])|7(?:[13467][1-9]|2\\d|5[13-9]|8[1-69]|9[17])|8(?:1\\d|2[13-689]|3[1-6]|4[124-6]|6[1246-9]|7[1-378]|9[12479])|9(?:1[346-9]|2[1-4]|3[2-46-8]|5[1348]|6[1-9]|7[12]|8[1-8]|9\\d))\\d{7}",,,,"2001234567",,,[10],[7,8]],
[,,"657[12]\\d{6}|(?:1(?:2(?:2[1-9]|3[1-35-8]|4[13-9]|7[1-689]|8[1-578]|9[467])|3(?:1[1-79]|[2458][1-9]|3\\d|7[1-8]|9[1-5])|4(?:1[1-57-9]|[24-7][1-9]|3[1-8]|8[1-35-9]|9[2-689])|5(?:[56]\\d|88|9[1-79])|6(?:1[2-68]|[2-4][1-9]|5[1-3689]|6[1-57-9]|7[1-7]|8[67]|9[4-8])|7(?:[1-467][1-9]|5[13-9]|8[1-69]|9[17])|8(?:1\\d|2[13-689]|3[1-6]|4[124-6]|6[1246-9]|7[1-378]|9[12479])|9(?:1[346-9]|2[1-4]|3[2-46-8]|5[1348]|[69][1-9]|7[12]|8[1-8]))|2(?:2\\d|3[1-35-8]|4[13-9]|7[1-689]|8[1-578]|9[467])|3(?:1[1-79]|[2458][1-9]|3\\d|7[1-8]|9[1-5])|4(?:1[1-57-9]|[25-7][1-9]|3[1-8]|4\\d|8[1-35-9]|9[2-689])|5(?:[56]\\d|88|9[1-79])|6(?:1[2-68]|[2-4][1-9]|5[1-3689]|6[1-57-9]|7[1-7]|8[67]|9[4-8])|7(?:[13467][1-9]|2\\d|5[13-9]|8[1-69]|9[17])|8(?:1\\d|2[13-689]|3[1-6]|4[124-6]|6[1246-9]|7[1-378]|9[12479])|9(?:1[346-9]|2[1-4]|3[2-46-8]|5[1348]|6[1-9]|7[12]|8[1-8]|9\\d))\\d{7}",
,,,"12221234567",,,,[7,8]],[,,"8(?:00|88)\\d{7}",,,,"8001234567",,,[10]],[,,"900\\d{7}",,,,"9001234567",,,[10]],[,,"300\\d{7}",,,,"3001234567",,,[10]],[,,"500\\d{7}",,,,"5001234567",,,[10]],[,,,,,,,,,[-1]],"MX",52,"0[09]","01",,,"0(?:[12]|4[45])|1",,"00",,[[,"(\\d{5})","$1",["53"]],[,"(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["33|5[56]|81"],,,1],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[2-9]"],,,1],[,"(\\d)(\\d{2})(\\d{4})(\\d{4})","$2 $3 $4",["1(?:33|5[56]|81)"],,,1],[,"(\\d)(\\d{3})(\\d{3})(\\d{4})",
"$2 $3 $4",["1"],,,1]],[[,"(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["33|5[56]|81"],,,1],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[2-9]"],,,1],[,"(\\d)(\\d{2})(\\d{4})(\\d{4})","$2 $3 $4",["1(?:33|5[56]|81)"],,,1],[,"(\\d)(\\d{3})(\\d{3})(\\d{4})","$2 $3 $4",["1"],,,1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],MY:[,[,,"1\\d{8,9}|(?:3\\d|[4-9])\\d{7}",,,,,,,[8,9,10],[6,7]],[,,"(?:3(?:2[0-36-9]|3[0-368]|4[0-278]|5[0-24-8]|6[0-467]|7[1246-9]|8\\d|9[0-57])\\d|4(?:2[0-689]|[3-79]\\d|8[1-35689])|5(?:2[0-589]|[3468]\\d|5[0-489]|7[1-9]|9[23])|6(?:2[2-9]|3[1357-9]|[46]\\d|5[0-6]|7[0-35-9]|85|9[015-8])|7(?:[2579]\\d|3[03-68]|4[0-8]|6[5-9]|8[0-35-9])|8(?:[24][2-8]|3[2-5]|5[2-7]|6[2-589]|7[2-578]|[89][2-9])|9(?:0[57]|13|[25-7]\\d|[3489][0-8]))\\d{5}",
,,,"323856789",,,[8,9],[6,7]],[,,"1(?:1888[689]|4400|8(?:47|8[27])[0-4])\\d{4}|1(?:0(?:[23568]\\d|4[0-6]|7[016-9]|9[0-8])|1(?:[1-5]\\d\\d|6(?:0[5-9]|[1-9]\\d)|7(?:[0134]\\d|2[1-9]|5[0-6]))|(?:[269]\\d|[37][1-9]|4[235-9])\\d|5(?:31|9\\d\\d)|8(?:1[23]|[236]\\d|4[06]|5(?:46|[7-9])|7[016-9]|8[01]|9[0-8]))\\d{5}",,,,"123456789",,,[9,10]],[,,"1[378]00\\d{6}",,,,"1300123456",,,[10]],[,,"1600\\d{6}",,,,"1600123456",,,[10]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"15(?:4(?:6[0-4]\\d|8(?:0[125]|[17]\\d|21|3[01]|4[01589]|5[014]|6[02]))|6(?:32[0-6]|78\\d))\\d{4}",
,,,"1546012345",,,[10]],"MY",60,"00","0",,,"0",,,,[[,"(\\d)(\\d{3})(\\d{4})","$1-$2 $3",["[4-79]"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{3,4})","$1-$2 $3",["1(?:[02469]|[378][1-9]|53)|8","1(?:[02469]|[37][1-9]|53|8(?:[1-46-9]|5[7-9]))|8"],"0$1"],[,"(\\d)(\\d{4})(\\d{4})","$1-$2 $3",["3"],"0$1"],[,"(\\d)(\\d{3})(\\d{2})(\\d{4})","$1-$2-$3-$4",["1(?:[367]|80)"]],[,"(\\d{3})(\\d{3})(\\d{4})","$1-$2 $3",["15"],"0$1"],[,"(\\d{2})(\\d{4})(\\d{4})","$1-$2 $3",["1"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,
,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],MZ:[,[,,"(?:2|8\\d)\\d{7}",,,,,,,[8,9]],[,,"2(?:[1346]\\d|5[0-2]|[78][12]|93)\\d{5}",,,,"21123456",,,[8]],[,,"8[2-79]\\d{7}",,,,"821234567",,,[9]],[,,"800\\d{6}",,,,"800123456",,,[9]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"MZ",258,"00",,,,,,,,[[,"(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["2|8[2-79]"]],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["8"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],NA:[,[,,"[68]\\d{7,8}",
,,,,,,[8,9]],[,,"64426\\d{3}|6(?:1(?:2[2-7]|3[01378]|4[0-4])|254|32[0237]|4(?:27|41|5[25])|52[236-8]|626|7(?:2[2-4]|30))\\d{4,5}|6(?:1(?:(?:0\\d|2[0189]|3[24-69]|4[5-9])\\d|17|69|7[014])|2(?:17|5[0-36-8]|69|70)|3(?:17|2[14-689]|34|6[289]|7[01]|81)|4(?:17|2[0-2]|4[06]|5[0137]|69|7[01])|5(?:17|2[0459]|69|7[01])|6(?:17|25|38|42|69|7[01])|7(?:17|2[569]|3[13]|6[89]|7[01]))\\d{4}",,,,"61221234"],[,,"(?:60|8[1245])\\d{7}",,,,"811234567",,,[9]],[,,"80\\d{7}",,,,"800123456",,,[9]],[,,"8701\\d{5}",,,,"870123456",
,,[9]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"8(?:3\\d\\d|86)\\d{5}",,,,"88612345"],"NA",264,"00","0",,,"0",,,,[[,"(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["88"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["6"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["87"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["8"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],NC:[,[,,"(?:050|[2-57-9]\\d\\d)\\d{3}",,,,,,,[6]],[,,"(?:2[03-9]|3[0-5]|4[1-7]|88)\\d{4}",,,,"201234"],[,
,"(?:5[0-4]|[79]\\d|8[0-79])\\d{4}",,,,"751234"],[,,"050\\d{3}",,,,"050012"],[,,"36\\d{4}",,,,"366711"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"NC",687,"00",,,,,,,,[[,"(\\d{3})","$1",["5[6-8]"]],[,"(\\d{2})(\\d{2})(\\d{2})","$1.$2.$3",["[02-57-9]"]]],[[,"(\\d{2})(\\d{2})(\\d{2})","$1.$2.$3",["[02-57-9]"]]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],NE:[,[,,"[027-9]\\d{7}",,,,,,,[8]],[,,"2(?:0(?:20|3[1-8]|4[13-5]|5[14]|6[14578]|7[1-578])|1(?:4[145]|5[14]|6[14-68]|7[169]|88))\\d{4}",
,,,"20201234"],[,,"(?:23|7[04]|[89]\\d)\\d{6}",,,,"93123456"],[,,"08\\d{6}",,,,"08123456"],[,,"09\\d{6}",,,,"09123456"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"NE",227,"00",,,,,,,,[[,"(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["08"]],[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[089]|2[013]|7[04]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],NF:[,[,,"[13]\\d{5}",,,,,,,[6],[5]],[,,"(?:1(?:06|17|28|39)|3[0-2]\\d)\\d{3}",,,,"106609",,,,[5]],[,,"(?:14|3[58])\\d{4}",
,,,"381234",,,,[5]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"NF",672,"00",,,,"([0-258]\\d{4})$","3$1",,,[[,"(\\d{2})(\\d{4})","$1 $2",["1[0-3]"]],[,"(\\d)(\\d{5})","$1 $2",["[13]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],NG:[,[,,"(?:[124-7]|9\\d{3})\\d{6}|[1-9]\\d{7}|[78]\\d{9,13}",,,,,,,[7,8,10,11,12,13,14],[5,6]],[,,"(?:(?:[1-356]\\d|4[02-8]|8[2-9])\\d|9(?:0[3-9]|[1-9]\\d))\\d{5}|7(?:0(?:[013-689]\\d|2[0-24-9])\\d{3,4}|[1-79]\\d{6})|(?:[12]\\d|4[147]|5[14579]|6[1578]|7[1-3578])\\d{5}",
,,,"18040123",,,[7,8],[5,6]],[,,"(?:702[0-24-9]|819[01])\\d{6}|(?:70[13-689]|8(?:0[1-9]|1[0-8])|9(?:0[1-9]|1[1-356]))\\d{7}",,,,"8021234567",,,[10]],[,,"800\\d{7,11}",,,,"80017591759",,,[10,11,12,13,14]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"NG",234,"009","0",,,"0",,,,[[,"(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["78"],"0$1"],[,"(\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["[12]|9(?:0[3-9]|[1-9])"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{2,3})","$1 $2 $3",["[3-7]|8[2-9]"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3,4})",
"$1 $2 $3",["[7-9]"],"0$1"],[,"(\\d{3})(\\d{4})(\\d{4,5})","$1 $2 $3",["[78]"],"0$1"],[,"(\\d{3})(\\d{5})(\\d{5,6})","$1 $2 $3",["[78]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"700\\d{7,11}",,,,"7001234567",,,[10,11,12,13,14]],,,[,,,,,,,,,[-1]]],NI:[,[,,"(?:1800|[25-8]\\d{3})\\d{4}",,,,,,,[8]],[,,"2\\d{7}",,,,"21234567"],[,,"(?:5(?:5[0-7]|[78]\\d)|6(?:20|3[035]|4[045]|5[05]|77|8[1-9]|9[059])|(?:7[5-8]|8\\d)\\d)\\d{5}",,,,"81234567"],[,,"1800\\d{4}",,,,"18001234"],[,,,,,,,,,[-1]],[,,,,,,,,,
[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"NI",505,"00",,,,,,,,[[,"(\\d{4})(\\d{4})","$1 $2",["[125-8]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],NL:[,[,,"(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|8\\d{6,9}|9\\d{6,10}|1\\d{4,5}",,,,,,,[5,6,7,8,9,10,11]],[,,"(?:1(?:[035]\\d|1[13-578]|6[124-8]|7[24]|8[0-467])|2(?:[0346]\\d|2[2-46-9]|5[125]|9[479])|3(?:[03568]\\d|1[3-8]|2[01]|4[1-8])|4(?:[0356]\\d|1[1-368]|7[58]|8[15-8]|9[23579])|5(?:[0358]\\d|[19][1-9]|2[1-57-9]|4[13-8]|6[126]|7[0-3578])|7\\d\\d)\\d{6}",
,,,"101234567",,,[9]],[,,"(?:6[1-58]|970\\d)\\d{7}",,,,"612345678",,,[9,11]],[,,"800\\d{4,7}",,,,"8001234",,,[7,8,9,10]],[,,"90[069]\\d{4,7}",,,,"9061234",,,[7,8,9,10]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"(?:85|91)\\d{7}",,,,"851234567",,,[9]],"NL",31,"00","0",,,"0",,,,[[,"(\\d{4})","$1",["1[238]|[34]"]],[,"(\\d{2})(\\d{3,4})","$1 $2",["14"]],[,"(\\d{6})","$1",["1"]],[,"(\\d{3})(\\d{4,7})","$1 $2",["[89]0"],"0$1"],[,"(\\d{2})(\\d{7})","$1 $2",["66"],"0$1"],[,"(\\d)(\\d{8})","$1 $2",["6"],"0$1"],[,
"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[1-578]|91"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{5})","$1 $2 $3",["9"],"0$1"]],[[,"(\\d{3})(\\d{4,7})","$1 $2",["[89]0"],"0$1"],[,"(\\d{2})(\\d{7})","$1 $2",["66"],"0$1"],[,"(\\d)(\\d{8})","$1 $2",["6"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[1-578]|91"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{5})",
"$1 $2 $3",["9"],"0$1"]],[,,"66\\d{7}",,,,"662345678",,,[9]],,,[,,"140(?:1[035]|2[0346]|3[03568]|4[0356]|5[0358]|8[458])|140(?:1[16-8]|2[259]|3[124]|4[17-9]|5[124679]|7)\\d",,,,,,,[5,6]],[,,"140(?:1[035]|2[0346]|3[03568]|4[0356]|5[0358]|8[458])|(?:140(?:1[16-8]|2[259]|3[124]|4[17-9]|5[124679]|7)|8[478]\\d{6})\\d",,,,"14020",,,[5,6,9]],,,[,,,,,,,,,[-1]]],NO:[,[,,"(?:0|[2-9]\\d{3})\\d{4}",,,,,,,[5,8]],[,,"(?:2[1-4]|3[1-3578]|5[1-35-7]|6[1-4679]|7[0-8])\\d{6}",,,,"21234567",,,[8]],[,,"(?:4[015-8]|59|9\\d)\\d{6}",
,,,"40612345",,,[8]],[,,"80[01]\\d{5}",,,,"80012345",,,[8]],[,,"82[09]\\d{5}",,,,"82012345",,,[8]],[,,"810(?:0[0-6]|[2-8]\\d)\\d{3}",,,,"81021234",,,[8]],[,,"880\\d{5}",,,,"88012345",,,[8]],[,,"85[0-5]\\d{5}",,,,"85012345",,,[8]],"NO",47,"00",,,,,,,,[[,"(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["[489]|59"]],[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[235-7]"]]],,[,,,,,,,,,[-1]],1,"[02-689]|7[0-8]",[,,,,,,,,,[-1]],[,,"(?:0[2-9]|81(?:0(?:0[7-9]|1\\d)|5\\d\\d))\\d{3}",,,,"02000"],,,[,,"81[23]\\d{5}",
,,,"81212345",,,[8]]],NP:[,[,,"(?:1\\d|9)\\d{9}|[1-9]\\d{7}",,,,,,,[8,10,11],[6,7]],[,,"(?:1[0-6]\\d|99[02-6])\\d{5}|(?:2[13-79]|3[135-8]|4[146-9]|5[135-7]|6[13-9]|7[15-9]|8[1-46-9]|9[1-7])[2-6]\\d{5}",,,,"14567890",,,[8],[6,7]],[,,"9(?:6[0-3]|7[024-6]|8[0-24-68])\\d{7}",,,,"9841234567",,,[10]],[,,"1(?:66001|800\\d\\d)\\d{5}",,,,"16600101234",,,[11]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"NP",977,"00","0",,,"0",,,,[[,"(\\d)(\\d{7})","$1-$2",["1[2-6]"],"0$1"],[,"(\\d{2})(\\d{6})",
"$1-$2",["1[01]|[2-8]|9(?:[1-59]|[67][2-6])"],"0$1"],[,"(\\d{3})(\\d{7})","$1-$2",["9"]],[,"(\\d{4})(\\d{2})(\\d{5})","$1-$2-$3",["1"]]],[[,"(\\d)(\\d{7})","$1-$2",["1[2-6]"],"0$1"],[,"(\\d{2})(\\d{6})","$1-$2",["1[01]|[2-8]|9(?:[1-59]|[67][2-6])"],"0$1"],[,"(\\d{3})(\\d{7})","$1-$2",["9"]]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],NR:[,[,,"(?:444|(?:55|8\\d)\\d|666)\\d{4}",,,,,,,[7]],[,,"444\\d{4}",,,,"4441234"],[,,"(?:55[3-9]|666|8\\d\\d)\\d{4}",,,,"5551234"],[,,,,,,
,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"NR",674,"00",,,,,,,,[[,"(\\d{3})(\\d{4})","$1 $2",["[4-68]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],NU:[,[,,"(?:[47]|888\\d)\\d{3}",,,,,,,[4,7]],[,,"[47]\\d{3}",,,,"7012",,,[4]],[,,"888[4-9]\\d{3}",,,,"8884012",,,[7]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"NU",683,"00",,,,,,,,[[,"(\\d{3})(\\d{4})","$1 $2",["8"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,
,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],NZ:[,[,,"[29]\\d{7,9}|50\\d{5}(?:\\d{2,3})?|6[0-35-9]\\d{6}|7\\d{7,8}|8\\d{4,9}|(?:11\\d|[34])\\d{7}",,,,,,,[5,6,7,8,9,10]],[,,"24099\\d{3}|(?:3[2-79]|[49][2-9]|6[235-9]|7[2-57-9])\\d{6}",,,,"32345678",,,[8],[7]],[,,"2[0-27-9]\\d{7,8}|21\\d{6}",,,,"211234567",,,[8,9,10]],[,,"508\\d{6,7}|80\\d{6,8}",,,,"800123456",,,[8,9,10]],[,,"(?:11\\d{5}|50(?:0[08]|30|66|77|88))\\d{3}|90\\d{6,8}",,,,"900123456",,,[7,8,9,10]],[,,,,,,,,,[-1]],[,,"70\\d{7}",,,,"701234567",,,[9]],[,
,,,,,,,,[-1]],"NZ",64,"0(?:0|161)","0",,,"0",,"00",,[[,"(\\d{2})(\\d{3,8})","$1 $2",["8[1-579]"],"0$1"],[,"(\\d{3})(\\d{2})(\\d{2,3})","$1 $2 $3",["50[036-8]|[89]0","50(?:[0367]|88)|[89]0"],"0$1"],[,"(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["24|[346]|7[2-57-9]|9[2-9]"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["2(?:10|74)|[59]|80"],"0$1"],[,"(\\d{2})(\\d{3,4})(\\d{4})","$1 $2 $3",["1|2[028]"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{3,5})","$1 $2 $3",["2(?:[169]|7[0-35-9])|7|86"],"0$1"]],,[,,"[28]6\\d{6,7}",
,,,"26123456",,,[8,9]],,,[,,,,,,,,,[-1]],[,,"8(?:1[6-9]|22|3\\d|4[045]|5[459]|7[0-3579]|90)\\d{2,7}",,,,"83012378"],,,[,,,,,,,,,[-1]]],OM:[,[,,"(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}",,,,,,,[7,8,9]],[,,"2[2-6]\\d{6}",,,,"23123456",,,[8]],[,,"1505\\d{4}|(?:7(?:[1289]\\d|7[0-5])|9(?:0[1-9]|[1-9]\\d))\\d{5}",,,,"92123456",,,[8]],[,,"8007\\d{4,5}|(?:500|800[05])\\d{4}",,,,"80071234"],[,,"900\\d{5}",,,,"90012345",,,[8]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"OM",968,"00",,,,,,,,[[,"(\\d{3})(\\d{4,6})",
"$1 $2",["[58]"]],[,"(\\d{2})(\\d{6})","$1 $2",["2"]],[,"(\\d{4})(\\d{4})","$1 $2",["[179]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],PA:[,[,,"(?:00800|8\\d{3})\\d{6}|[68]\\d{7}|[1-57-9]\\d{6}",,,,,,,[7,8,10,11]],[,,"(?:1(?:0\\d|1[479]|2[37]|3[0137]|4[17]|5[05]|6[58]|7[0167]|8[2358]|9[1389])|2(?:[0235-79]\\d|1[0-7]|4[013-9]|8[02-9])|3(?:[089]\\d|1[0-7]|2[0-5]|33|4[0-79]|5[0-35]|6[068]|7[0-8])|4(?:00|3[0-579]|4\\d|7[0-57-9])|5(?:[01]\\d|2[0-7]|[56]0|79)|7(?:0[09]|2[0-26-8]|3[03]|4[04]|5[05-9]|6[056]|7[0-24-9]|8[5-9]|90)|8(?:09|2[89]|3\\d|4[0-24-689]|5[014]|8[02])|9(?:0[5-9]|1[0135-8]|2[036-9]|3[35-79]|40|5[0457-9]|6[05-9]|7[04-9]|8[35-8]|9\\d))\\d{4}",
,,,"2001234",,,[7]],[,,"(?:1[16]1|21[89]|6\\d{3}|8(?:1[01]|7[23]))\\d{4}",,,,"61234567",,,[7,8]],[,,"800\\d{4,5}|(?:00800|800\\d)\\d{6}",,,,"8001234"],[,,"(?:8(?:22|55|60|7[78]|86)|9(?:00|81))\\d{4}",,,,"8601234",,,[7]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"PA",507,"00",,,,,,,,[[,"(\\d{3})(\\d{4})","$1-$2",["[1-57-9]"]],[,"(\\d{4})(\\d{4})","$1-$2",["[68]"]],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["8"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],PE:[,[,,"(?:[14-8]|9\\d)\\d{7}",
,,,,,,[8,9],[6,7]],[,,"(?:(?:4[34]|5[14])[0-8]\\d|7(?:173|3[0-8]\\d)|8(?:10[05689]|6(?:0[06-9]|1[6-9]|29)|7(?:0[569]|[56]0)))\\d{4}|(?:1[0-8]|4[12]|5[236]|6[1-7]|7[246]|8[2-4])\\d{6}",,,,"11234567",,,[8],[6,7]],[,,"9\\d{8}",,,,"912345678",,,[9]],[,,"800\\d{5}",,,,"80012345",,,[8]],[,,"805\\d{5}",,,,"80512345",,,[8]],[,,"801\\d{5}",,,,"80112345",,,[8]],[,,"80[24]\\d{5}",,,,"80212345",,,[8]],[,,,,,,,,,[-1]],"PE",51,"00|19(?:1[124]|77|90)00","0"," Anexo ",,"0",,"00",,[[,"(\\d{3})(\\d{5})","$1 $2",["80"],
"(0$1)"],[,"(\\d)(\\d{7})","$1 $2",["1"],"(0$1)"],[,"(\\d{2})(\\d{6})","$1 $2",["[4-8]"],"(0$1)"],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["9"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],PF:[,[,,"4\\d{5}(?:\\d{2})?|8\\d{7,8}",,,,,,,[6,8,9]],[,,"4(?:0[4-689]|9[4-68])\\d{5}",,,,"40412345",,,[8]],[,,"8[7-9]\\d{6}",,,,"87123456",,,[8]],[,,"80[0-5]\\d{6}",,,,"800012345",,,[9]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"499\\d{5}",,,,"49901234",,,[8]],"PF",689,"00",
,,,,,,,[[,"(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["44"]],[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["4|8[7-9]"]],[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"]]],,[,,,,,,,,,[-1]],,,[,,"44\\d{4}",,,,,,,[6]],[,,"44\\d{4}",,,,"440123",,,[6]],,,[,,,,,,,,,[-1]]],PG:[,[,,"(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}",,,,,,,[7,8]],[,,"(?:(?:3[0-2]|4[257]|5[34]|9[78])\\d|64[1-9]|85[02-46-9])\\d{4}",,,,"3123456",,,[7]],[,,"(?:7\\d|8[128])\\d{6}",,,,"70123456",,,[8]],[,,"180\\d{4}",,,
,"1801234",,,[7]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"2(?:0[0-57]|7[568])\\d{4}",,,,"2751234",,,[7]],"PG",675,"00|140[1-3]",,,,,,"00",,[[,"(\\d{3})(\\d{4})","$1 $2",["18|[2-69]|85"]],[,"(\\d{4})(\\d{4})","$1 $2",["[78]"]]],,[,,"27[01]\\d{4}",,,,"2700123",,,[7]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],PH:[,[,,"(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}",,,,,,,[6,8,9,10,11,12,13],[4,5,7]],[,,"(?:(?:2[3-8]|3[2-68]|4[2-9]|5[2-6]|6[2-58]|7[24578])\\d{3}|88(?:22\\d\\d|42))\\d{4}|(?:2|8[2-8]\\d\\d)\\d{5}",
,,,"232345678",,,[6,8,9,10],[4,5,7]],[,,"(?:8(?:1[37]|9[5-8])|9(?:0[5-9]|1[0-24-9]|[235-7]\\d|4[2-9]|8[135-9]|9[1-9]))\\d{7}",,,,"9051234567",,,[10]],[,,"1800\\d{7,9}",,,,"180012345678",,,[11,12,13]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"PH",63,"00","0",,,"0",,,,[[,"(\\d)(\\d{5})","$1 $2",["2"],"(0$1)"],[,"(\\d{4})(\\d{4,6})","$1 $2",["3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2","3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"],
"(0$1)"],[,"(\\d{5})(\\d{4})","$1 $2",["346|4(?:27|9[35])|883","3469|4(?:279|9(?:30|56))|8834"],"(0$1)"],[,"(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["2"],"(0$1)"],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[3-7]|8[2-8]"],"(0$1)"],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[89]"],"0$1"],[,"(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["1"]],[,"(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})","$1 $2 $3 $4",["1"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],PK:[,[,,"122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}",
,,,,,,[8,9,10,11,12],[5,6,7]],[,,"(?:(?:21|42)[2-9]|58[126])\\d{7}|(?:2[25]|4[0146-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]\\d{6,7}|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8]))[2-9]\\d{5,6}",,,,"2123456789",,,[9,10],[5,6,7,8]],[,,"3(?:[0-24]\\d|3[0-7]|55|64)\\d{7}",,,,"3012345678",,,[10]],[,,"800\\d{5}(?:\\d{3})?",,,,"80012345",,,[8,11]],[,,"900\\d{5}",,,,"90012345",,,[8]],[,,,,,,,,,[-1]],[,,"122\\d{6}",
,,,"122044444",,,[9]],[,,,,,,,,,[-1]],"PK",92,"00","0",,,"0",,,,[[,"(\\d{3})(\\d{3})(\\d{2,7})","$1 $2 $3",["[89]0"],"0$1"],[,"(\\d{4})(\\d{5})","$1 $2",["1"]],[,"(\\d{3})(\\d{6,7})","$1 $2",["2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])","9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"],
"(0$1)"],[,"(\\d{2})(\\d{7,8})","$1 $2",["(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"],"(0$1)"],[,"(\\d{5})(\\d{5})","$1 $2",["58"],"(0$1)"],[,"(\\d{3})(\\d{7})","$1 $2",["3"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"],"(0$1)"],[,"(\\d{3})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["[24-9]"],"(0$1)"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"(?:2(?:[125]|3[2358]|4[2-4]|9[2-8])|4(?:[0-246-9]|5[3479])|5(?:[1-35-7]|4[2-467])|6(?:0[468]|[1-8])|7(?:[14]|2[236])|8(?:[16]|2[2-689]|3[23578]|4[3478]|5[2356])|9(?:1|22|3[27-9]|4[2-6]|6[3569]|9[2-7]))111\\d{6}",
,,,"21111825888",,,[11,12]],,,[,,,,,,,,,[-1]]],PL:[,[,,"(?:6|8\\d\\d)\\d{7}|[1-9]\\d{6}(?:\\d{2})?|[26]\\d{5}",,,,,,,[6,7,8,9,10]],[,,"47\\d{7}|(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])(?:[02-9]\\d{6}|1(?:[0-8]\\d{5}|9\\d{3}(?:\\d{2})?))",,,,"123456789",,,[7,9]],[,,"21(?:1(?:[145]\\d|3[1-5])|2[0-4]\\d)\\d{4}|(?:45|5[0137]|6[069]|7[2389]|88)\\d{7}",,,,"512345678",,,[9]],[,,"800\\d{6,7}",,,,"800123456",,,[9,10]],[,,"70[01346-8]\\d{6}",,,,"701234567",,,[9]],[,,"801\\d{6}",
,,,"801234567",,,[9]],[,,,,,,,,,[-1]],[,,"39\\d{7}",,,,"391234567",,,[9]],"PL",48,"00",,,,,,,,[[,"(\\d{5})","$1",["19"]],[,"(\\d{3})(\\d{3})","$1 $2",["11|20|64"]],[,"(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1","(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"]],[,"(\\d{3})(\\d{2})(\\d{2,3})","$1 $2 $3",["64"]],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"]],
[,"(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["1[2-8]|[2-7]|8[1-79]|9[145]"]],[,"(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["8"]]],,[,,"64\\d{4,7}",,,,"641234567",,,[6,7,8,9]],,,[,,,,,,,,,[-1]],[,,"804\\d{6}",,,,"804123456",,,[9]],,,[,,,,,,,,,[-1]]],PM:[,[,,"(?:[45]|80\\d\\d)\\d{5}",,,,,,,[6,9]],[,,"(?:4[1-356]|50)\\d{4}",,,,"430123",,,[6]],[,,"(?:4[02-4]|5[056])\\d{4}",,,,"551234",,,[6]],[,,"80[0-5]\\d{6}",,,,"800012345",,,[9]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"PM",
508,"00","0",,,"0",,,,[[,"(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["[45]"],"0$1"],[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],PR:[,[,,"(?:[589]\\d\\d|787)\\d{7}",,,,,,,[10],[7]],[,,"(?:787|939)[2-9]\\d{6}",,,,"7872345678",,,,[7]],[,,"(?:787|939)[2-9]\\d{6}",,,,"7872345678",,,,[7]],[,,"8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",,,,"8002345678"],[,,"900[2-9]\\d{6}",,,,"9002345678"],[,,,,,,,,,[-1]],[,,"52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
,,,"5002345678"],[,,,,,,,,,[-1]],"PR",1,"011","1",,,"1",,,1,,,[,,,,,,,,,[-1]],,"787|939",[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],PS:[,[,,"[2489]2\\d{6}|(?:1\\d|5)\\d{8}",,,,,,,[8,9,10],[7]],[,,"(?:22[2-47-9]|42[45]|82[014-68]|92[3569])\\d{5}",,,,"22234567",,,[8],[7]],[,,"5[69]\\d{7}",,,,"599123456",,,[9]],[,,"1800\\d{6}",,,,"1800123456",,,[10]],[,,,,,,,,,[-1]],[,,"1700\\d{6}",,,,"1700123456",,,[10]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"PS",970,"00","0",,,"0",,,,[[,"(\\d)(\\d{3})(\\d{4})","$1 $2 $3",
["[2489]"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["5"],"0$1"],[,"(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],PT:[,[,,"1693\\d{5}|(?:[26-9]\\d|30)\\d{7}",,,,,,,[9]],[,,"2(?:[12]\\d|3[1-689]|4[1-59]|[57][1-9]|6[1-35689]|8[1-69]|9[1256])\\d{6}",,,,"212345678"],[,,"6(?:[06]92(?:30|9\\d)|[35]92(?:3[03]|9\\d))\\d{3}|(?:(?:16|6[0356])93|9(?:[1-36]\\d\\d|480))\\d{5}",,,,"912345678"],[,,"80[02]\\d{6}",,,,"800123456"],[,,"(?:6(?:0[178]|4[68])\\d|76(?:0[1-57]|1[2-47]|2[237]))\\d{5}",
,,,"760123456"],[,,"80(?:8\\d|9[1579])\\d{5}",,,,"808123456"],[,,"884[0-4689]\\d{5}",,,,"884123456"],[,,"30\\d{7}",,,,"301234567"],"PT",351,"00",,,,,,,,[[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["2[12]"]],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["16|[236-9]"]]],,[,,"6222\\d{5}",,,,"622212345"],,,[,,,,,,,,,[-1]],[,,"70(?:7\\d|8[17])\\d{5}",,,,"707123456"],,,[,,"600\\d{6}|6[06]9233\\d{3}",,,,"600110000"]],PW:[,[,,"(?:[24-8]\\d\\d|345|900)\\d{4}",,,,,,,[7]],[,,"(?:2(?:55|77)|345|488|5(?:35|44|87)|6(?:22|54|79)|7(?:33|47)|8(?:24|55|76)|900)\\d{4}",
,,,"2771234"],[,,"(?:(?:46|83)[0-5]|6[2-4689]0)\\d{4}|(?:45|77|88)\\d{5}",,,,"6201234"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"PW",680,"01[12]",,,,,,,,[[,"(\\d{3})(\\d{4})","$1 $2",["[2-9]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],PY:[,[,,"59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}",,,,,,,[6,7,8,9,10,11],[5]],[,,"(?:[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36])\\d{5,7}|(?:2(?:2[4-68]|[4-68]\\d|7[15]|9[1-5])|3(?:18|3[167]|4[2357]|51|[67]\\d)|4(?:3[12]|5[13]|9[1-47])|5(?:[1-4]\\d|5[02-4])|6(?:3[1-3]|44|7[1-8])|7(?:4[0-4]|5\\d|6[1-578]|75|8[0-8])|858)\\d{5,6}",
,,,"212345678",,,[7,8,9],[5,6]],[,,"9(?:51|6[129]|[78][1-6]|9[1-5])\\d{6}",,,,"961456789",,,[9]],[,,"9800\\d{5,7}",,,,"98000123456",,,[9,10,11]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"8700[0-4]\\d{4}",,,,"870012345",,,[9]],"PY",595,"00","0",,,"0",,,,[[,"(\\d{3})(\\d{3,6})","$1 $2",["[2-9]0"],"0$1"],[,"(\\d{2})(\\d{5})","$1 $2",["[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"],"(0$1)"],[,"(\\d{3})(\\d{4,5})","$1 $2",["2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"],"(0$1)"],[,"(\\d{2})(\\d{3})(\\d{3,4})",
"$1 $2 $3",["2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"],"(0$1)"],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["87"]],[,"(\\d{3})(\\d{6})","$1 $2",["9(?:[5-79]|8[1-6])"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[2-8]"],"0$1"],[,"(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["9"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"[2-9]0\\d{4,7}",,,,"201234567",,,[6,7,8,9]],,,[,,,,,,,,,[-1]]],QA:[,[,,"800\\d{4}|(?:2|800)\\d{6}|(?:0080|[3-7])\\d{7}",,,,,,,[7,8,9,11]],[,,"4(?:1111|2022)\\d{3}|4(?:[04]\\d\\d|14[0-6]|999)\\d{4}",
,,,"44123456",,,[8]],[,,"[35-7]\\d{7}",,,,"33123456",,,[8]],[,,"800\\d{4}|(?:0080[01]|800)\\d{6}",,,,"8001234",,,[7,9,11]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"QA",974,"00",,,,,,,,[[,"(\\d{3})(\\d{4})","$1 $2",["2[16]|8"]],[,"(\\d{4})(\\d{4})","$1 $2",["[3-7]"]]],,[,,"2(?:1\\d|61)\\d{4}",,,,"2123456",,,[7]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],RE:[,[,,"(?:26|[689]\\d)\\d{7}",,,,,,,[9]],[,,"26(?:2\\d\\d|3(?:0\\d|1[0-3]))\\d{4}",,,,"262161234"],[,,"(?:69(?:2\\d\\d|3(?:0[0-46]|1[013]|2[0-2]|3[0-39]|4\\d|5[0-5]|6[0-6]|7[0-27]|8[0-8]|9[0-479]))|9(?:399[0-2]|4790|76(?:2[27]|3[0-37]|9\\d)))\\d{4}",
,,,"692123456"],[,,"80\\d{7}",,,,"801234567"],[,,"89[1-37-9]\\d{6}",,,,"891123456"],[,,"8(?:1[019]|2[0156]|84|90)\\d{6}",,,,"810123456"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"RE",262,"00","0",,,"0",,,,[[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2689]"],"0$1"]],,[,,,,,,,,,[-1]],1,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],RO:[,[,,"(?:[2378]\\d|90)\\d{7}|[23]\\d{5}",,,,,,,[6,9]],[,,"[23][13-6]\\d{7}|(?:2(?:19\\d|[3-6]\\d9)|31\\d\\d)\\d\\d",,,,"211234567"],[,,"7020\\d{5}|7(?:0[013-9]|1[0-3]|[2-7]\\d|8[03-8]|9[0-29])\\d{6}",
,,,"712034567",,,[9]],[,,"800\\d{6}",,,,"800123456",,,[9]],[,,"90[0136]\\d{6}",,,,"900123456",,,[9]],[,,"801\\d{6}",,,,"801123456",,,[9]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"RO",40,"00","0"," int ",,"0",,,,[[,"(\\d{3})(\\d{3})","$1 $2",["2[3-6]","2[3-6]\\d9"],"0$1"],[,"(\\d{2})(\\d{4})","$1 $2",["219|31"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[23]1"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[237-9]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"(?:37\\d|80[578])\\d{6}",,,,"372123456",
,,[9]],,,[,,,,,,,,,[-1]]],RS:[,[,,"38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}",,,,,,,[6,7,8,9,10,11,12],[4,5]],[,,"(?:11[1-9]\\d|(?:2[389]|39)(?:0[2-9]|[2-9]\\d))\\d{3,8}|(?:1[02-9]|2[0-24-7]|3[0-8])[2-9]\\d{4,9}",,,,"10234567",,,[7,8,9,10,11,12],[4,5,6]],[,,"6(?:[0-689]|7\\d)\\d{6,7}",,,,"601234567",,,[8,9,10]],[,,"800\\d{3,9}",,,,"80012345"],[,,"(?:78\\d|90[0169])\\d{3,7}",,,,"90012345",,,[6,7,8,9,10]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,
,,,,,,,,[-1]],"RS",381,"00","0",,,"0",,,,[[,"(\\d{3})(\\d{3,9})","$1 $2",["(?:2[389]|39)0|[7-9]"],"0$1"],[,"(\\d{2})(\\d{5,10})","$1 $2",["[1-36]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"7[06]\\d{4,10}",,,,"700123456"],,,[,,,,,,,,,[-1]]],RU:[,[,,"8\\d{13}|[347-9]\\d{9}",,,,,,,[10,14],[7]],[,,"(?:3(?:0[12]|4[1-35-79]|5[1-3]|65|8[1-58]|9[0145])|4(?:01|1[1356]|2[13467]|7[1-5]|8[1-7]|9[1-689])|8(?:1[1-8]|2[01]|3[13-6]|4[0-8]|5[15]|6[1-35-79]|7[1-37-9]))\\d{7}",,,,"3011234567",,,[10],[7]],[,,"9\\d{9}",
,,,"9123456789",,,[10]],[,,"8(?:0[04]|108\\d{3})\\d{7}",,,,"8001234567"],[,,"80[39]\\d{7}",,,,"8091234567",,,[10]],[,,,,,,,,,[-1]],[,,"808\\d{7}",,,,"8081234567",,,[10]],[,,,,,,,,,[-1]],"RU",7,"810","8",,,"8",,"8~10",,[[,"(\\d{3})(\\d{2})(\\d{2})","$1-$2-$3",["[0-79]"]],[,"(\\d{4})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["7(?:1[0-8]|2[1-9])","7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))","7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"],"8 ($1)",,1],[,"(\\d{5})(\\d)(\\d{2})(\\d{2})",
"$1 $2 $3 $4",["7(?:1[0-68]|2[1-9])","7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))","7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"],"8 ($1)",,1],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["7"],"8 ($1)",,1],[,"(\\d{3})(\\d{3})(\\d{2})(\\d{2})","$1 $2-$3-$4",["[349]|8(?:[02-7]|1[1-8])"],"8 ($1)",,1],[,"(\\d{4})(\\d{4})(\\d{3})(\\d{3})",
"$1 $2 $3 $4",["8"],"8 ($1)"]],[[,"(\\d{4})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["7(?:1[0-8]|2[1-9])","7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))","7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"],"8 ($1)",,1],[,"(\\d{5})(\\d)(\\d{2})(\\d{2})","$1 $2 $3 $4",["7(?:1[0-68]|2[1-9])","7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))","7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"],
"8 ($1)",,1],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["7"],"8 ($1)",,1],[,"(\\d{3})(\\d{3})(\\d{2})(\\d{2})","$1 $2-$3-$4",["[349]|8(?:[02-7]|1[1-8])"],"8 ($1)",,1],[,"(\\d{4})(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3 $4",["8"],"8 ($1)"]],[,,,,,,,,,[-1]],1,"3[04-689]|[489]",[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],RW:[,[,,"(?:06|[27]\\d\\d|[89]00)\\d{6}",,,,,,,[8,9]],[,,"(?:06|2[23568]\\d)\\d{6}",,,,"250123456"],[,,"7[2389]\\d{7}",,,,"720123456",,,[9]],[,,"800\\d{6}",,,,"800123456",,,[9]],[,,
"900\\d{6}",,,,"900123456",,,[9]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"RW",250,"00","0",,,"0",,,,[[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["0"]],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[7-9]"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["2"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],SA:[,[,,"92\\d{7}|(?:[15]|8\\d)\\d{8}",,,,,,,[9,10],[7]],[,,"1(?:1\\d|2[24-8]|3[35-8]|4[3-68]|6[2-5]|7[235-7])\\d{6}",,,,"112345678",,,[9],[7]],[,,"579[01]\\d{5}|5(?:[013-689]\\d|7[0-35-8])\\d{6}",
,,,"512345678",,,[9]],[,,"800\\d{7}",,,,"8001234567",,,[10]],[,,"925\\d{6}",,,,"925012345",,,[9]],[,,"920\\d{6}",,,,"920012345",,,[9]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"SA",966,"00","0",,,"0",,,,[[,"(\\d{4})(\\d{5})","$1 $2",["9"]],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["1"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["5"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["81"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["8"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"811\\d{7}",,,,"8110123456",
,,[10]],,,[,,,,,,,,,[-1]]],SB:[,[,,"(?:[1-6]|[7-9]\\d\\d)\\d{4}",,,,,,,[5,7]],[,,"(?:1[4-79]|[23]\\d|4[0-2]|5[03]|6[0-37])\\d{3}",,,,"40123",,,[5]],[,,"48\\d{3}|(?:(?:7[1-9]|8[4-9])\\d|9(?:1[2-9]|2[013-9]|3[0-2]|[46]\\d|5[0-46-9]|7[0-689]|8[0-79]|9[0-8]))\\d{4}",,,,"7421234"],[,,"1[38]\\d{3}",,,,"18123",,,[5]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"5[12]\\d{3}",,,,"51123",,,[5]],"SB",677,"0[01]",,,,,,,,[[,"(\\d{2})(\\d{5})","$1 $2",["7|8[4-9]|9(?:[1-8]|9[0-8])"]]],,[,,,,,,,,,[-1]],,,
[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],SC:[,[,,"800\\d{4}|(?:[249]\\d|64)\\d{5}",,,,,,,[7]],[,,"4[2-46]\\d{5}",,,,"4217123"],[,,"2[125-8]\\d{5}",,,,"2510123"],[,,"800[08]\\d{3}",,,,"8000000"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"971\\d{4}|(?:64|95)\\d{5}",,,,"6412345"],"SC",248,"010|0[0-2]",,,,,,"00",,[[,"(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[246]|9[57]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],SD:[,[,,"[19]\\d{8}",,,,,,,[9]],[,,"1(?:5\\d|8[35-7])\\d{6}",
,,,"153123456"],[,,"(?:1[0-2]|9[0-3569])\\d{7}",,,,"911231234"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"SD",249,"00","0",,,"0",,,,[[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[19]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],SE:[,[,,"(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}",,,,,,,[6,7,8,9,10,12]],[,,"(?:(?:[12][136]|3[356]|4[0246]|6[03]|8\\d)\\d|90[1-9])\\d{4,6}|(?:1(?:2[0-35]|4[0-4]|5[0-25-9]|7[13-6]|[89]\\d)|2(?:2[0-7]|4[0136-8]|5[0138]|7[018]|8[01]|9[0-57])|3(?:0[0-4]|1\\d|2[0-25]|4[056]|7[0-2]|8[0-3]|9[023])|4(?:1[013-8]|3[0135]|5[14-79]|7[0-246-9]|8[0156]|9[0-689])|5(?:0[0-6]|[15][0-5]|2[0-68]|3[0-4]|4\\d|6[03-5]|7[013]|8[0-79]|9[01])|6(?:1[1-3]|2[0-4]|4[02-57]|5[0-37]|6[0-3]|7[0-2]|8[0247]|9[0-356])|9(?:1[0-68]|2\\d|3[02-5]|4[0-3]|5[0-4]|[68][01]|7[0135-8]))\\d{5,6}",
,,,"8123456",,,[7,8,9]],[,,"7[02369]\\d{7}",,,,"701234567",,,[9]],[,,"20\\d{4,7}",,,,"20123456",,,[6,7,8,9]],[,,"649\\d{6}|99[1-59]\\d{4}(?:\\d{3})?|9(?:00|39|44)[1-8]\\d{3,6}",,,,"9001234567",,,[7,8,9,10]],[,,"77[0-7]\\d{6}",,,,"771234567",,,[9]],[,,"75[1-8]\\d{6}",,,,"751234567",,,[9]],[,,,,,,,,,[-1]],"SE",46,"00","0",,,"0",,,,[[,"(\\d{2})(\\d{2,3})(\\d{2})","$1-$2 $3",["20"],"0$1"],[,"(\\d{3})(\\d{4})","$1-$2",["9(?:00|39|44|9)"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{2})","$1-$2 $3",["[12][136]|3[356]|4[0246]|6[03]|90[1-9]"],
"0$1"],[,"(\\d)(\\d{2,3})(\\d{2})(\\d{2})","$1-$2 $3 $4",["8"],"0$1"],[,"(\\d{3})(\\d{2,3})(\\d{2})","$1-$2 $3",["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"],"0$1"],[,"(\\d{3})(\\d{2,3})(\\d{3})","$1-$2 $3",["9(?:00|39|44)"],"0$1"],[,"(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})","$1-$2 $3 $4",["1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1-$2 $3 $4",["10|7"],"0$1"],[,"(\\d)(\\d{3})(\\d{3})(\\d{2})",
"$1-$2 $3 $4",["8"],"0$1"],[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1-$2 $3 $4",["[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"],"0$1"],[,"(\\d{3})(\\d{2})(\\d{2})(\\d{3})","$1-$2 $3 $4",["9"],"0$1"],[,"(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1-$2 $3 $4 $5",["[26]"],"0$1"]],[[,"(\\d{2})(\\d{2,3})(\\d{2})","$1 $2 $3",["20"]],[,"(\\d{3})(\\d{4})","$1 $2",["9(?:00|39|44|9)"]],[,"(\\d{2})(\\d{3})(\\d{2})","$1 $2 $3",["[12][136]|3[356]|4[0246]|6[03]|90[1-9]"]],[,"(\\d)(\\d{2,3})(\\d{2})(\\d{2})",
"$1 $2 $3 $4",["8"]],[,"(\\d{3})(\\d{2,3})(\\d{2})","$1 $2 $3",["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"]],[,"(\\d{3})(\\d{2,3})(\\d{3})","$1 $2 $3",["9(?:00|39|44)"]],[,"(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"]],[,"(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["10|7"]],[,"(\\d)(\\d{3})(\\d{3})(\\d{2})","$1 $2 $3 $4",["8"]],[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
"$1 $2 $3 $4",["[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"]],[,"(\\d{3})(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3 $4",["9"]],[,"(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["[26]"]]],[,,"74[02-9]\\d{6}",,,,"740123456",,,[9]],,,[,,,,,,,,,[-1]],[,,"10[1-8]\\d{6}",,,,"102345678",,,[9]],,,[,,"(?:25[245]|67[3-68])\\d{9}",,,,"254123456789",,,[12]]],SG:[,[,,"(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}",,,,,,,[8,10,11]],[,,"662[0-24-9]\\d{4}|6(?:[0-578]\\d|6[013-57-9]|9[0-35-9])\\d{5}",
,,,"61234567",,,[8]],[,,"8(?:06[0-6]|95[0-2])\\d{4}|(?:8(?:0[1-5]|[1-8]\\d|9[0-4])|9[0-8]\\d)\\d{5}",,,,"81234567",,,[8]],[,,"(?:18|8)00\\d{7}",,,,"18001234567",,,[10,11]],[,,"1900\\d{7}",,,,"19001234567",,,[11]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"(?:3[12]\\d|666)\\d{5}",,,,"31234567",,,[8]],"SG",65,"0[0-3]\\d",,,,,,,,[[,"(\\d{4,5})","$1",["1[013-9]|77","1(?:[013-8]|9(?:0[1-9]|[1-9]))|77"]],[,"(\\d{4})(\\d{4})","$1 $2",["[369]|8(?:0[1-6]|[1-9])"]],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["8"]],[,
"(\\d{4})(\\d{4})(\\d{3})","$1 $2 $3",["7"]],[,"(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["1"]]],[[,"(\\d{4})(\\d{4})","$1 $2",["[369]|8(?:0[1-6]|[1-9])"]],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["8"]],[,"(\\d{4})(\\d{4})(\\d{3})","$1 $2 $3",["7"]],[,"(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["1"]]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"7000\\d{7}",,,,"70001234567",,,[11]],,,[,,,,,,,,,[-1]]],SH:[,[,,"(?:[256]\\d|8)\\d{3}",,,,,,,[4,5]],[,,"2(?:[0-57-9]\\d|6[4-9])\\d\\d",,,,"22158"],[,,"[56]\\d{4}",,,,"51234",
,,[5]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"262\\d\\d",,,,"26212",,,[5]],"SH",290,"00",,,,,,,,,,[,,,,,,,,,[-1]],1,"[256]",[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],SI:[,[,,"[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}",,,,,,,[5,6,7,8]],[,,"(?:[1-357][2-8]|4[24-8])\\d{6}",,,,"12345678",,,[8],[7]],[,,"65(?:[178]\\d|5[56]|6[01])\\d{4}|(?:[37][01]|4[0139]|51|6[489])\\d{6}",,,,"31234567",,,[8]],[,,"80\\d{4,6}",,,,"80123456",,,[6,7,8]],[,,"89[1-3]\\d{2,5}|90\\d{4,6}",,,,"90123456"],
[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"(?:59\\d\\d|8(?:1(?:[67]\\d|8[0-589])|2(?:0\\d|2[0-37-9]|8[0-2489])|3[389]\\d))\\d{4}",,,,"59012345",,,[8]],"SI",386,"00|10(?:22|66|88|99)","0",,,"0",,"00",,[[,"(\\d{2})(\\d{3,6})","$1 $2",["8[09]|9"],"0$1"],[,"(\\d{3})(\\d{5})","$1 $2",["59|8"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[37][01]|4[0139]|51|6"],"0$1"],[,"(\\d)(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[1-57]"],"(0$1)"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],
SJ:[,[,,"0\\d{4}|(?:[489]\\d|[57]9)\\d{6}",,,,,,,[5,8]],[,,"79\\d{6}",,,,"79123456",,,[8]],[,,"(?:4[015-8]|59|9\\d)\\d{6}",,,,"41234567",,,[8]],[,,"80[01]\\d{5}",,,,"80012345",,,[8]],[,,"82[09]\\d{5}",,,,"82012345",,,[8]],[,,"810(?:0[0-6]|[2-8]\\d)\\d{3}",,,,"81021234",,,[8]],[,,"880\\d{5}",,,,"88012345",,,[8]],[,,"85[0-5]\\d{5}",,,,"85012345",,,[8]],"SJ",47,"00",,,,,,,,,,[,,,,,,,,,[-1]],,"79",[,,,,,,,,,[-1]],[,,"(?:0[2-9]|81(?:0(?:0[7-9]|1\\d)|5\\d\\d))\\d{3}",,,,"02000"],,,[,,"81[23]\\d{5}",,,,
"81212345",,,[8]]],SK:[,[,,"[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}",,,,,,,[6,7,9]],[,,"(?:2(?:16|[2-9]\\d{3})|(?:(?:[3-5][1-8]\\d|819)\\d|601[1-5])\\d)\\d{4}|(?:2|[3-5][1-8])1[67]\\d{3}|[3-5][1-8]16\\d\\d",,,,"221234567"],[,,"909[1-9]\\d{5}|9(?:0[1-8]|1[0-24-9]|4[03-57-9]|5\\d)\\d{6}",,,,"912123456",,,[9]],[,,"800\\d{6}",,,,"800123456",,,[9]],[,,"9(?:00|[78]\\d)\\d{6}",,,,"900123456",,,[9]],[,,"8[5-9]\\d{7}",,,,"850123456",,,[9]],[,,,,,,,,,[-1]],[,,"6(?:02|5[0-4]|9[0-6])\\d{6}",,,,"690123456",,,[9]],
"SK",421,"00","0",,,"0",,,,[[,"(\\d)(\\d{2})(\\d{3,4})","$1 $2 $3",["21"],"0$1"],[,"(\\d{2})(\\d{2})(\\d{2,3})","$1 $2 $3",["[3-5][1-8]1","[3-5][1-8]1[67]"],"0$1"],[,"(\\d{4})(\\d{3})","$1 $2",["909","9090"],"0$1"],[,"(\\d)(\\d{3})(\\d{3})(\\d{2})","$1/$2 $3 $4",["2"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[689]"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1/$2 $3 $4",["[3-5]"],"0$1"]],[[,"(\\d)(\\d{2})(\\d{3,4})","$1 $2 $3",["21"],"0$1"],[,"(\\d{2})(\\d{2})(\\d{2,3})","$1 $2 $3",["[3-5][1-8]1",
"[3-5][1-8]1[67]"],"0$1"],[,"(\\d)(\\d{3})(\\d{3})(\\d{2})","$1/$2 $3 $4",["2"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[689]"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1/$2 $3 $4",["[3-5]"],"0$1"]],[,,"9090\\d{3}",,,,"9090123",,,[7]],,,[,,"9090\\d{3}|(?:602|8(?:00|[5-9]\\d)|9(?:00|[78]\\d))\\d{6}",,,,,,,[7,9]],[,,"96\\d{7}",,,,"961234567",,,[9]],,,[,,,,,,,,,[-1]]],SL:[,[,,"(?:[237-9]\\d|66)\\d{6}",,,,,,,[8],[6]],[,,"22[2-4][2-9]\\d{4}",,,,"22221234",,,,[6]],[,,"(?:25|3[0-5]|66|7[2-9]|8[08]|9[09])\\d{6}",
,,,"25123456"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"SL",232,"00","0",,,"0",,,,[[,"(\\d{2})(\\d{6})","$1 $2",["[236-9]"],"(0$1)"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],SM:[,[,,"(?:0549|[5-7]\\d)\\d{6}",,,,,,,[8,10],[6]],[,,"0549(?:8[0157-9]|9\\d)\\d{4}",,,,"0549886377",,,[10],[6]],[,,"6[16]\\d{6}",,,,"66661212",,,[8]],[,,,,,,,,,[-1]],[,,"7[178]\\d{6}",,,,"71123456",,,[8]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"5[158]\\d{6}",
,,,"58001110",,,[8]],"SM",378,"00",,,,"([89]\\d{5})$","0549$1",,,[[,"(\\d{6})","$1",["[89]"]],[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[5-7]"]],[,"(\\d{4})(\\d{6})","$1 $2",["0"]]],[[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[5-7]"]],[,"(\\d{4})(\\d{6})","$1 $2",["0"]]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],SN:[,[,,"(?:[378]\\d|93)\\d{7}",,,,,,,[9]],[,,"3(?:0(?:1[0-2]|80)|282|3(?:8[1-9]|9[3-9])|611)\\d{5}",,,,"301012345"],[,,"7(?:(?:[06-8]\\d|21|90)\\d|5(?:01|[19]0|25|[38]3|[4-7]\\d))\\d{5}",
,,,"701234567"],[,,"800\\d{6}",,,,"800123456"],[,,"88[4689]\\d{6}",,,,"884123456"],[,,"81[02468]\\d{6}",,,,"810123456"],[,,,,,,,,,[-1]],[,,"(?:3(?:392|9[01]\\d)\\d|93(?:3[13]0|929))\\d{4}",,,,"933301234"],"SN",221,"00",,,,,,,,[[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"]],[,"(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[379]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],SO:[,[,,"[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}",,,,,,,[6,7,8,9]],[,,
"(?:1\\d|2[0-79]|3[0-46-8]|4[0-7]|5[57-9])\\d{5}|(?:[134]\\d|8[125])\\d{4}",,,,"4012345",,,[6,7]],[,,"(?:(?:15|(?:3[59]|4[89]|79|8[08])\\d|6(?:0[5-7]|[1-9]\\d)|9(?:0\\d|[2-9]))\\d|2(?:4\\d|8))\\d{5}|(?:[67]\\d\\d|904)\\d{5}",,,,"71123456",,,[7,8,9]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"SO",252,"00","0",,,"0",,,,[[,"(\\d{2})(\\d{4})","$1 $2",["8[125]"]],[,"(\\d{6})","$1",["[134]"]],[,"(\\d)(\\d{6})","$1 $2",["[15]|2[0-79]|3[0-46-8]|4[0-7]"]],[,"(\\d)(\\d{7})",
"$1 $2",["(?:2|90)4|[67]"]],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[3478]|64|90"]],[,"(\\d{2})(\\d{5,7})","$1 $2",["1|28|6(?:0[5-7]|[1-35-9])|9[2-9]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],SR:[,[,,"(?:[2-5]|68|[78]\\d)\\d{5}",,,,,,,[6,7]],[,,"(?:2[1-3]|3[0-7]|(?:4|68)\\d|5[2-58])\\d{4}",,,,"211234"],[,,"(?:7[124-7]|8[124-9])\\d{5}",,,,"7412345",,,[7]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"56\\d{4}",,,,"561234",,,[6]],"SR",597,"00",
,,,,,,,[[,"(\\d{2})(\\d{2})(\\d{2})","$1-$2-$3",["56"]],[,"(\\d{3})(\\d{3})","$1-$2",["[2-5]"]],[,"(\\d{3})(\\d{4})","$1-$2",["[6-8]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],SS:[,[,,"[19]\\d{8}",,,,,,,[9]],[,,"1[89]\\d{7}",,,,"181234567"],[,,"(?:12|9[1257-9])\\d{7}",,,,"977123456"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"SS",211,"00","0",,,"0",,,,[[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[19]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,
,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],ST:[,[,,"(?:22|9\\d)\\d{5}",,,,,,,[7]],[,,"22\\d{5}",,,,"2221234"],[,,"900[5-9]\\d{3}|9(?:0[1-9]|[89]\\d)\\d{4}",,,,"9812345"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"ST",239,"00",,,,,,,,[[,"(\\d{3})(\\d{4})","$1 $2",["[29]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],SV:[,[,,"[267]\\d{7}|[89]00\\d{4}(?:\\d{4})?",,,,,,,[7,8,11]],[,,"2(?:[1-6]\\d{3}|[79]90[034]|890[0245])\\d{3}",,
,,"21234567",,,[8]],[,,"66(?:[02-9]\\d\\d|1(?:[02-9]\\d|16))\\d{3}|(?:6[0-57-9]|7\\d)\\d{6}",,,,"70123456",,,[8]],[,,"800\\d{4}(?:\\d{4})?",,,,"8001234",,,[7,11]],[,,"900\\d{4}(?:\\d{4})?",,,,"9001234",,,[7,11]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"SV",503,"00",,,,,,,,[[,"(\\d{3})(\\d{4})","$1 $2",["[89]"]],[,"(\\d{4})(\\d{4})","$1 $2",["[267]"]],[,"(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["[89]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],SX:[,[,,"7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}",
,,,,,,[10],[7]],[,,"7215(?:4[2-8]|8[239]|9[056])\\d{4}",,,,"7215425678",,,,[7]],[,,"7215(?:1[02]|2\\d|5[034679]|8[014-8])\\d{4}",,,,"7215205678",,,,[7]],[,,"8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",,,,"8002123456"],[,,"900[2-9]\\d{6}",,,,"9002123456"],[,,,,,,,,,[-1]],[,,"52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
,,,"5002345678"],[,,,,,,,,,[-1]],"SX",1,"011","1",,,"(5\\d{6})$|1","721$1",,,,,[,,,,,,,,,[-1]],,"721",[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],SY:[,[,,"[1-39]\\d{8}|[1-5]\\d{7}",,,,,,,[8,9],[6,7]],[,,"21\\d{6,7}|(?:1(?:[14]\\d|[2356])|2[235]|3(?:[13]\\d|4)|4[134]|5[1-3])\\d{6}",,,,"112345678",,,,[6,7]],[,,"9[1-689]\\d{7}",,,,"944567890",,,[9]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"SY",963,"00","0",,,"0",,,,[[,"(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",
["[1-5]"],"0$1",,1],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["9"],"0$1",,1]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],SZ:[,[,,"0800\\d{4}|(?:[237]\\d|900)\\d{6}",,,,,,,[8,9]],[,,"[23][2-5]\\d{6}",,,,"22171234",,,[8]],[,,"7[6-9]\\d{6}",,,,"76123456",,,[8]],[,,"0800\\d{4}",,,,"08001234",,,[8]],[,,"900\\d{6}",,,,"900012345",,,[9]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"70\\d{6}",,,,"70012345",,,[8]],"SZ",268,"00",,,,,,,,[[,"(\\d{4})(\\d{4})","$1 $2",["[0237]"]],[,"(\\d{5})(\\d{4})",
"$1 $2",["9"]]],,[,,,,,,,,,[-1]],,,[,,"0800\\d{4}",,,,,,,[8]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],TA:[,[,,"8\\d{3}",,,,,,,[4]],[,,"8\\d{3}",,,,"8999"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"TA",290,"00",,,,,,,,,,[,,,,,,,,,[-1]],,"8",[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],TC:[,[,,"(?:[58]\\d\\d|649|900)\\d{7}",,,,,,,[10],[7]],[,,"649(?:266|712|9(?:4\\d|50))\\d{4}",,,,"6497121234",,,,[7]],[,,"649(?:2(?:3[129]|4[1-79])|3\\d\\d|4[34][1-3])\\d{4}",
,,,"6492311234",,,,[7]],[,,"8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",,,,"8002345678"],[,,"900[2-9]\\d{6}",,,,"9002345678"],[,,,,,,,,,[-1]],[,,"52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",,,,"5002345678"],[,,"649(?:71[01]|966)\\d{4}",,,,"6497101234",,,,[7]],"TC",1,"011","1",,,"([2-479]\\d{6})$|1","649$1",,,,,[,,,,,
,,,,[-1]],,"649",[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],TD:[,[,,"(?:22|[69]\\d|77)\\d{6}",,,,,,,[8]],[,,"22(?:[37-9]0|5[0-5]|6[89])\\d{4}",,,,"22501234"],[,,"(?:6[0235689]|77|9\\d)\\d{6}",,,,"63012345"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"TD",235,"00|16",,,,,,"00",,[[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2679]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],TG:[,[,,"[279]\\d{7}",,,,,,,[8]],[,,"2(?:2[2-7]|3[23]|4[45]|55|6[67]|77)\\d{5}",
,,,"22212345"],[,,"(?:7[019]|9[0-36-9])\\d{6}",,,,"90112345"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"TG",228,"00",,,,,,,,[[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[279]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],TH:[,[,,"(?:001800|[2-57]|[689]\\d)\\d{7}|1\\d{7,9}",,,,,,,[8,9,10,13]],[,,"(?:1[0689]|2\\d|3[2-9]|4[2-5]|5[2-6]|7[3-7])\\d{6}",,,,"21234567",,,[8]],[,,"671[0-8]\\d{5}|(?:14|6[1-6]|[89]\\d)\\d{7}",,,,"812345678",
,,[9]],[,,"(?:001800\\d|1800)\\d{6}",,,,"1800123456",,,[10,13]],[,,"1900\\d{6}",,,,"1900123456",,,[10]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"6[08]\\d{7}",,,,"601234567",,,[9]],"TH",66,"00[1-9]","0",,,"0",,,,[[,"(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["2"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[13-9]"],"0$1"],[,"(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],TJ:[,[,,"(?:00|[1-57-9]\\d)\\d{7}",,,,,,,[9],[3,5,6,7]],[,,"(?:3(?:1[3-5]|2[245]|3[12]|4[24-7]|5[25]|72)|4(?:46|74|87))\\d{6}",
,,,"372123456",,,,[3,5,6,7]],[,,"41[18]\\d{6}|(?:[034]0|1[017]|2[02]|5[05]|7[0178]|8[078]|9\\d)\\d{7}",,,,"917123456"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"TJ",992,"810",,,,,,"8~10",,[[,"(\\d{6})(\\d)(\\d{2})","$1 $2 $3",["331","3317"]],[,"(\\d{3})(\\d{2})(\\d{4})","$1 $2 $3",["[34]7|91[78]"]],[,"(\\d{4})(\\d)(\\d{4})","$1 $2 $3",["3[1-5]"]],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[0-57-9]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,
,,,,,[-1]]],TK:[,[,,"[2-47]\\d{3,6}",,,,,,,[4,5,6,7]],[,,"(?:2[2-4]|[34]\\d)\\d{2,5}",,,,"3101"],[,,"7[2-4]\\d{2,5}",,,,"7290"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"TK",690,"00",,,,,,,,,,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],TL:[,[,,"7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}",,,,,,,[7,8]],[,,"(?:2[1-5]|3[1-9]|4[1-4])\\d{5}",,,,"2112345",,,[7]],[,,"7[2-8]\\d{6}",,,,"77212345",,,[8]],[,,"80\\d{5}",,,,"8012345",,,[7]],[,,"90\\d{5}",,
,,"9012345",,,[7]],[,,,,,,,,,[-1]],[,,"70\\d{5}",,,,"7012345",,,[7]],[,,,,,,,,,[-1]],"TL",670,"00",,,,,,,,[[,"(\\d{3})(\\d{4})","$1 $2",["[2-489]|70"]],[,"(\\d{4})(\\d{4})","$1 $2",["7"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],TM:[,[,,"[1-6]\\d{7}",,,,,,,[8]],[,,"(?:1(?:2\\d|3[1-9])|2(?:22|4[0-35-8])|3(?:22|4[03-9])|4(?:22|3[128]|4\\d|6[15])|5(?:22|5[7-9]|6[014-689]))\\d{5}",,,,"12345678"],[,,"6\\d{7}",,,,"66123456"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],
[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"TM",993,"810","8",,,"8",,"8~10",,[[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2-$3-$4",["12"],"(8 $1)"],[,"(\\d{3})(\\d)(\\d{2})(\\d{2})","$1 $2-$3-$4",["[1-5]"],"(8 $1)"],[,"(\\d{2})(\\d{6})","$1 $2",["6"],"8 $1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],TN:[,[,,"[2-57-9]\\d{7}",,,,,,,[8]],[,,"81200\\d{3}|(?:3[0-2]|7\\d)\\d{6}",,,,"30010123"],[,,"3(?:001|[12]40)\\d{4}|(?:(?:[259]\\d|4[0-7])\\d|3(?:1[1-35]|6[0-4]|91))\\d{5}",,,,"20123456"],
[,,"8010\\d{4}",,,,"80101234"],[,,"88\\d{6}",,,,"88123456"],[,,"8[12]10\\d{4}",,,,"81101234"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"TN",216,"00",,,,,,,,[[,"(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[2-57-9]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],TO:[,[,,"(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}",,,,,,,[5,7]],[,,"(?:2\\d|3[0-8]|4[0-4]|50|6[09]|7[0-24-69]|8[05])\\d{3}",,,,"20123",,,[5]],[,,"(?:55[4-6]|6(?:[09]\\d|3[02]|8[15-9])|(?:7\\d|8[46-9])\\d|999)\\d{4}",,,,
"7715123",,,[7]],[,,"0800\\d{3}",,,,"0800222",,,[7]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"55[0-37-9]\\d{4}",,,,"5510123",,,[7]],"TO",676,"00",,,,,,,,[[,"(\\d{2})(\\d{3})","$1-$2",["[2-4]|50|6[09]|7[0-24-69]|8[05]"]],[,"(\\d{4})(\\d{3})","$1 $2",["0"]],[,"(\\d{3})(\\d{4})","$1 $2",["[5-9]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],TR:[,[,,"4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}",,,,,,,[7,10,12,13]],[,,"(?:2(?:[13][26]|[28][2468]|[45][268]|[67][246])|3(?:[13][28]|[24-6][2468]|[78][02468]|92)|4(?:[16][246]|[23578][2468]|4[26]))\\d{7}",
,,,"2123456789",,,[10]],[,,"56161\\d{5}|5(?:0[15-7]|1[06]|24|[34]\\d|5[1-59]|9[46])\\d{7}",,,,"5012345678",,,[10]],[,,"8(?:00\\d{7}(?:\\d{2,3})?|11\\d{7})",,,,"8001234567",,,[10,12,13]],[,,"(?:8[89]8|900)\\d{7}",,,,"9001234567",,,[10]],[,,,,,,,,,[-1]],[,,"592(?:21[12]|461)\\d{4}",,,,"5922121234",,,[10]],[,,"850\\d{7}",,,,"8500123456",,,[10]],"TR",90,"00","0",,,"0",,,,[[,"(\\d{3})(\\d)(\\d{3})","$1 $2 $3",["444"],,,1],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["512|8[01589]|90"],"0$1",,1],[,"(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
"$1 $2 $3 $4",["5(?:[0-59]|61)","5(?:[0-59]|616)","5(?:[0-59]|6161)"],"0$1",,1],[,"(\\d{3})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[24][1-8]|3[1-9]"],"(0$1)",,1],[,"(\\d{3})(\\d{3})(\\d{6,7})","$1 $2 $3",["80"],"0$1",,1]],[[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["512|8[01589]|90"],"0$1",,1],[,"(\\d{3})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["5(?:[0-59]|61)","5(?:[0-59]|616)","5(?:[0-59]|6161)"],"0$1",,1],[,"(\\d{3})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[24][1-8]|3[1-9]"],"(0$1)",,1],[,"(\\d{3})(\\d{3})(\\d{6,7})",
"$1 $2 $3",["80"],"0$1",,1]],[,,"512\\d{7}",,,,"5123456789",,,[10]],,,[,,"(?:444|811\\d{3})\\d{4}",,,,,,,[7,10]],[,,"444\\d{4}",,,,"4441444",,,[7]],,,[,,,,,,,,,[-1]]],TT:[,[,,"(?:[58]\\d\\d|900)\\d{7}",,,,,,,[10],[7]],[,,"868(?:2(?:01|1[5-9]|[23]\\d|4[0-2])|6(?:0[7-9]|1[02-8]|2[1-9]|[3-69]\\d|7[0-79])|82[124])\\d{4}",,,,"8682211234",,,,[7]],[,,"868(?:(?:2[5-9]|3\\d)\\d|4(?:3[0-6]|[6-9]\\d)|6(?:20|78|8\\d)|7(?:0[1-9]|1[02-9]|[2-9]\\d))\\d{4}",,,,"8682911234",,,,[7]],[,,"8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
,,,"8002345678"],[,,"900[2-9]\\d{6}",,,,"9002345678"],[,,,,,,,,,[-1]],[,,"52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",,,,"5002345678"],[,,,,,,,,,[-1]],"TT",1,"011","1",,,"([2-46-8]\\d{6})$|1","868$1",,,,,[,,,,,,,,,[-1]],,"868",[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,"868619\\d{4}",,,,"8686191234",,,,[7]]],TV:[,[,,
"(?:2|7\\d\\d|90)\\d{4}",,,,,,,[5,6,7]],[,,"2[02-9]\\d{3}",,,,"20123",,,[5]],[,,"(?:7[01]\\d|90)\\d{4}",,,,"901234",,,[6,7]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"TV",688,"00",,,,,,,,[[,"(\\d{2})(\\d{3})","$1 $2",["2"]],[,"(\\d{2})(\\d{4})","$1 $2",["90"]],[,"(\\d{2})(\\d{5})","$1 $2",["7"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],TW:[,[,,"[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}",,,,,,,[7,8,9,10,11]],[,,"(?:2[2-8]\\d|370|55[01]|7[1-9])\\d{6}|4(?:(?:0(?:0[1-9]|[2-48]\\d)|1[023]\\d)\\d{4,5}|(?:[239]\\d\\d|4(?:0[56]|12|49))\\d{5})|6(?:[01]\\d{7}|4(?:0[56]|12|24|4[09])\\d{4,5})|8(?:(?:2(?:3\\d|4[0-269]|[578]0|66)|36[24-9]|90\\d\\d)\\d{4}|4(?:0[56]|12|24|4[09])\\d{4,5})|(?:2(?:2(?:0\\d\\d|4(?:0[68]|[249]0|3[0-467]|5[0-25-9]|6[0235689]))|(?:3(?:[09]\\d|1[0-4])|(?:4\\d|5[0-49]|6[0-29]|7[0-5])\\d)\\d)|(?:(?:3[2-9]|5[2-8]|6[0-35-79]|8[7-9])\\d\\d|4(?:2(?:[089]\\d|7[1-9])|(?:3[0-4]|[78]\\d|9[01])\\d))\\d)\\d{3}",
,,,"221234567",,,[8,9]],[,,"(?:40001[0-2]|9[0-8]\\d{4})\\d{3}",,,,"912345678",,,[9]],[,,"80[0-79]\\d{6}|800\\d{5}",,,,"800123456",,,[8,9]],[,,"20(?:[013-9]\\d\\d|2)\\d{4}",,,,"203123456",,,[7,9]],[,,,,,,,,,[-1]],[,,"99\\d{7}",,,,"990123456",,,[9]],[,,"7010(?:[0-2679]\\d|3[0-7]|8[0-5])\\d{5}|70\\d{8}",,,,"7012345678",,,[10,11]],"TW",886,"0(?:0[25-79]|19)","0","#",,"0",,,,[[,"(\\d{2})(\\d)(\\d{4})","$1 $2 $3",["202"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[258]0"],"0$1"],[,"(\\d)(\\d{3,4})(\\d{4})",
"$1 $2 $3",["[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]","[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[49]"],"0$1"],[,"(\\d{2})(\\d{4})(\\d{4,5})","$1 $2 $3",["7"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"50[0-46-9]\\d{6}",,,,"500123456",,,[9]],,,[,,,,,,,,,[-1]]],TZ:[,[,,"(?:[25-8]\\d|41|90)\\d{7}",,,,,,,[9]],[,,"2[2-8]\\d{7}",,,,"222345678"],[,,"77[2-9]\\d{6}|(?:6[125-9]|7[13-689])\\d{7}",,,,"621234567"],[,,"80[08]\\d{6}",,,,"800123456"],[,,"90\\d{7}",
,,,"900123456"],[,,"8(?:40|6[01])\\d{6}",,,,"840123456"],[,,,,,,,,,[-1]],[,,"41\\d{7}",,,,"412345678"],"TZ",255,"00[056]","0",,,"0",,,,[[,"(\\d{3})(\\d{2})(\\d{4})","$1 $2 $3",["[89]"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[24]"],"0$1"],[,"(\\d{2})(\\d{7})","$1 $2",["5"]],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[67]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,"(?:8(?:[04]0|6[01])|90\\d)\\d{6}"],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],UA:[,[,,"[89]\\d{9}|[3-9]\\d{8}",,,,,,,[9,10],[5,6,7]],[,,"(?:3[1-8]|4[13-8]|5[1-7]|6[12459])\\d{7}",
,,,"311234567",,,[9],[5,6,7]],[,,"(?:39|50|6[36-8]|7[1-3]|9[1-9])\\d{7}",,,,"501234567",,,[9]],[,,"800[1-8]\\d{5,6}",,,,"800123456"],[,,"900[239]\\d{5,6}",,,,"900212345"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"89[1-579]\\d{6}",,,,"891234567",,,[9]],"UA",380,"00","0",,,"0",,"0~0",,[[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]","6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"],"0$1"],[,"(\\d{4})(\\d{5})","$1 $2",
["3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6[0135689]|7[4-6])|6(?:[12][3-7]|[459])","3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6(?:[015689]|3[02389])|7[4-6])|6(?:[12][3-7]|[459])"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[3-7]|89|9[1-9]"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["[89]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],UG:[,[,,"800\\d{6}|(?:[29]0|[347]\\d)\\d{7}",,,,,,,[9],[5,6,7]],[,,"20(?:(?:240|30[67])\\d|6(?:00[0-2]|30[0-4]))\\d{3}|(?:20(?:[017]\\d|2[5-9]|32|5[0-4]|6[15-9])|[34]\\d{3})\\d{5}",
,,,"312345678",,,,[5,6,7]],[,,"726[01]\\d{5}|7(?:[01578]\\d|20|36|[46][0-4]|9[89])\\d{6}",,,,"712345678"],[,,"800[1-3]\\d{5}",,,,"800123456"],[,,"90[1-3]\\d{6}",,,,"901123456"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"UG",256,"00[057]","0",,,"0",,,,[[,"(\\d{4})(\\d{5})","$1 $2",["202","2024"],"0$1"],[,"(\\d{3})(\\d{6})","$1 $2",["[27-9]|4(?:6[45]|[7-9])"],"0$1"],[,"(\\d{2})(\\d{7})","$1 $2",["[34]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],US:[,[,,"[2-9]\\d{9}|3\\d{6}",
,,,,,,[10],[7]],[,,"(?:47220[01]|5(?:05(?:[2-57-9]\\d\\d|6(?:[0-35-9]\\d|4[46]))|57200))\\d{4}|(?:2(?:0[1-35-9]|1[02-9]|2[03-589]|3[149]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-57-9]|1[02-9]|2[01356]|3[0-24679]|4[167]|5[0-2]|6[014]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[19]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|[34][016]|5[01679]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-7]|3[1247]|4[037]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[068]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}",
,,,"2015550123",,,,[7]],[,,"(?:47220[01]|5(?:05(?:[2-57-9]\\d\\d|6(?:[0-35-9]\\d|4[46]))|57200))\\d{4}|(?:2(?:0[1-35-9]|1[02-9]|2[03-589]|3[149]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-57-9]|1[02-9]|2[01356]|3[0-24679]|4[167]|5[0-2]|6[014]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[19]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|[34][016]|5[01679]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-7]|3[1247]|4[037]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[068]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}",
,,,"2015550123",,,,[7]],[,,"8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",,,,"8002345678"],[,,"900[2-9]\\d{6}",,,,"9002345678"],[,,,,,,,,,[-1]],[,,"52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",,,,"5002345678"],[,,,,,,,,,[-1]],"US",1,"011","1",,,"1",,,1,[[,"(\\d{3})(\\d{4})","$1-$2",["310"],,,1],[,"(\\d{3})(\\d{4})","$1-$2",
["[24-9]|3(?:[02-9]|1[1-9])"]],[,"(\\d{3})(\\d{3})(\\d{4})","($1) $2-$3",["[2-9]"],,,1]],[[,"(\\d{3})(\\d{4})","$1-$2",["310"],,,1],[,"(\\d{3})(\\d{3})(\\d{4})","$1-$2-$3",["[2-9]"]]],[,,,,,,,,,[-1]],1,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],UY:[,[,,"(?:0004|4)\\d{9}|[1249]\\d{7}|(?:[49]\\d|80)\\d{5}",,,,,,,[7,8,10,13]],[,,"(?:1(?:770|987)|(?:2\\d|4[2-7])\\d\\d)\\d{4}",,,,"21231234",,,[8],[7]],[,,"9[1-9]\\d{6}",,,,"94231234",,,[8]],[,,"(?:(?:0004|4)\\d{5}|80[05])\\d{4}|405\\d{4}",,,,"8001234",
,,[7,10,13]],[,,"90[0-8]\\d{4}",,,,"9001234",,,[7]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"UY",598,"0(?:0|1[3-9]\\d)","0"," int. ",,"0",,"00",,[[,"(\\d{3})(\\d{4})","$1 $2",["405|8|90"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["9"],"0$1"],[,"(\\d{4})(\\d{4})","$1 $2",["[124]"]],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["4"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3 $4",["0"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],UZ:[,[,,"(?:33|[5-79]\\d|88)\\d{7}",
,,,,,,[9]],[,,"(?:55\\d\\d|6(?:1(?:22|3[124]|4[1-4]|5[1-3578]|64)|2(?:22|3[0-57-9]|41)|5(?:22|3[3-7]|5[024-8])|6\\d\\d|7(?:[23]\\d|7[69])|9(?:22|4[1-8]|6[135]))|7(?:0(?:5[4-9]|6[0146]|7[124-6]|9[135-8])|(?:1[12]|8\\d)\\d|2(?:22|3[13-57-9]|4[1-3579]|5[14])|3(?:2\\d|3[1578]|4[1-35-7]|5[1-57]|61)|4(?:2\\d|3[1-579]|7[1-79])|5(?:22|5[1-9]|6[1457])|6(?:22|3[12457]|4[13-8])|9(?:22|5[1-9])))\\d{5}",,,,"669050123"],[,,"(?:(?:33|50|88|9[0-57-9])\\d{3}|6(?:1(?:2(?:2[01]|98)|35[0-4]|50\\d|61[23]|7(?:[01][017]|4\\d|55|9[5-9]))|2(?:(?:11|7\\d)\\d|2(?:[12]1|9[01379])|5(?:[126]\\d|3[0-4]))|5(?:19[01]|2(?:27|9[26])|(?:30|59|7\\d)\\d)|6(?:2(?:1[5-9]|2[0367]|38|41|52|60)|(?:3[79]|9[0-3])\\d|4(?:56|83)|7(?:[07]\\d|1[017]|3[07]|4[047]|5[057]|67|8[0178]|9[79]))|7(?:2(?:24|3[237]|4[5-9]|7[15-8])|5(?:7[12]|8[0589])|7(?:0\\d|[39][07])|9(?:0\\d|7[079]))|9(?:2(?:1[1267]|3[01]|5\\d|7[0-4])|(?:5[67]|7\\d)\\d|6(?:2[0-26]|8\\d)))|7(?:[07]\\d{3}|1(?:13[01]|6(?:0[47]|1[67]|66)|71[3-69]|98\\d)|2(?:2(?:2[79]|95)|3(?:2[5-9]|6[0-6])|57\\d|7(?:0\\d|1[17]|2[27]|3[37]|44|5[057]|66|88))|3(?:2(?:1[0-6]|21|3[469]|7[159])|(?:33|9[4-6])\\d|5(?:0[0-4]|5[579]|9\\d)|7(?:[0-3579]\\d|4[0467]|6[67]|8[078]))|4(?:2(?:29|5[0257]|6[0-7]|7[1-57])|5(?:1[0-4]|8\\d|9[5-9])|7(?:0\\d|1[024589]|2[0-27]|3[0137]|[46][07]|5[01]|7[5-9]|9[079])|9(?:7[015-9]|[89]\\d))|5(?:112|2(?:0\\d|2[29]|[49]4)|3[1568]\\d|52[6-9]|7(?:0[01578]|1[017]|[23]7|4[047]|[5-7]\\d|8[78]|9[079]))|6(?:2(?:2[1245]|4[2-4])|39\\d|41[179]|5(?:[349]\\d|5[0-2])|7(?:0[017]|[13]\\d|22|44|55|67|88))|9(?:22[128]|3(?:2[0-4]|7\\d)|57[02569]|7(?:2[05-9]|3[37]|4\\d|60|7[2579]|87|9[07]))))\\d{4}",
,,,"912345678"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"UZ",998,"810","8",,,"8",,"8~10",,[[,"(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[35-9]"],"8 $1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],VA:[,[,,"0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}",,,,,,,[6,7,8,9,10,11,12]],[,,"06698\\d{1,6}",,,,"0669812345",,,[6,7,8,9,10,11]],[,,"3[1-9]\\d{8}|3[2-9]\\d{7}",,,,"3123456789",,,[9,10]],[,,"80(?:0\\d{3}|3)\\d{3}",
,,,"800123456",,,[6,9]],[,,"(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}",,,,"899123456",,,[6,8,9,10]],[,,"84(?:[08]\\d{3}|[17])\\d{3}",,,,"848123456",,,[6,9]],[,,"1(?:78\\d|99)\\d{6}",,,,"1781234567",,,[9,10]],[,,"55\\d{8}",,,,"5512345678",,,[10]],"VA",39,"00",,,,,,,,,,[,,,,,,,,,[-1]],,"06698",[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,"3[2-8]\\d{9,10}",,,,"33101234501",,,[11,12]]],VC:[,[,,"(?:[58]\\d\\d|784|900)\\d{7}",,,,,,,[10],[7]],
[,,"784(?:266|3(?:6[6-9]|7\\d|8[0-6])|4(?:38|5[0-36-8]|8[0-8])|5(?:55|7[0-2]|93)|638|784)\\d{4}",,,,"7842661234",,,,[7]],[,,"784(?:4(?:3[0-5]|5[45]|89|9[0-8])|5(?:2[6-9]|3[0-4])|720)\\d{4}",,,,"7844301234",,,,[7]],[,,"8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",,,,"8002345678"],[,,"900[2-9]\\d{6}",,,,"9002345678"],[,,,,,,,,,[-1]],[,,"52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
,,,"5002345678"],[,,"78451[0-2]\\d{4}",,,,"7845101234",,,,[7]],"VC",1,"011","1",,,"([2-7]\\d{6})$|1","784$1",,,,,[,,,,,,,,,[-1]],,"784",[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],VE:[,[,,"[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}",,,,,,,[10],[7]],[,,"(?:2(?:12|3[457-9]|[467]\\d|[58][1-9]|9[1-6])|[4-6]00)\\d{7}",,,,"2121234567",,,,[7]],[,,"4(?:1[24-8]|2[46])\\d{7}",,,,"4121234567"],[,,"800\\d{7}",,,,"8001234567"],[,,"90[01]\\d{7}",,,,"9001234567"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],
"VE",58,"00","0",,,"0",,,,[[,"(\\d{3})(\\d{7})","$1-$2",["[24-689]"],"0$1","$CC $1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"501\\d{7}",,,,"5010123456",,,,[7]],,,[,,,,,,,,,[-1]]],VG:[,[,,"(?:284|[58]\\d\\d|900)\\d{7}",,,,,,,[10],[7]],[,,"284(?:229|4(?:22|9[45])|774|8(?:52|6[459]))\\d{4}",,,,"2842291234",,,,[7]],[,,"284(?:245|3(?:0[0-3]|4[0-7]|68|9[34])|4(?:4[0-6]|68|9[69])|5(?:4[0-7]|68|9[69]))\\d{4}",,,,"2843001234",,,,[7]],[,,"8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",,,,"8002345678"],[,,"900[2-9]\\d{6}",
,,,"9002345678"],[,,,,,,,,,[-1]],[,,"52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",,,,"5002345678"],[,,,,,,,,,[-1]],"VG",1,"011","1",,,"([2-578]\\d{6})$|1","284$1",,,,,[,,,,,,,,,[-1]],,"284",[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],VI:[,[,,"[58]\\d{9}|(?:34|90)0\\d{7}",,,,,,,[10],[7]],[,,"340(?:2(?:0[0-368]|2[06-8]|4[49]|77)|3(?:32|44)|4(?:2[23]|44|7[34]|89)|5(?:1[34]|55)|6(?:2[56]|4[23]|77|9[023])|7(?:1[2-57-9]|2[57]|7\\d)|884|998)\\d{4}",
,,,"3406421234",,,,[7]],[,,"340(?:2(?:0[0-368]|2[06-8]|4[49]|77)|3(?:32|44)|4(?:2[23]|44|7[34]|89)|5(?:1[34]|55)|6(?:2[56]|4[23]|77|9[023])|7(?:1[2-57-9]|2[57]|7\\d)|884|998)\\d{4}",,,,"3406421234",,,,[7]],[,,"8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",,,,"8002345678"],[,,"900[2-9]\\d{6}",,,,"9002345678"],[,,,,,,,,,[-1]],[,,"52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
,,,"5002345678"],[,,,,,,,,,[-1]],"VI",1,"011","1",,,"([2-9]\\d{6})$|1","340$1",,1,,,[,,,,,,,,,[-1]],,"340",[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],VN:[,[,,"[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}",,,,,,,[7,8,9,10]],[,,"2(?:0[3-9]|1[0-689]|2[0-25-9]|[38][2-9]|4[2-8]|5[124-9]|6[0-39]|7[0-7]|9[0-4679])\\d{7}",,,,"2101234567",,,[10]],[,,"(?:5(?:2[238]|59)|89[6-9]|99[013-9])\\d{6}|(?:3\\d|5[689]|7[06-9]|8[1-8]|9[0-8])\\d{7}",,,,"912345678",,,[9]],[,,"1800\\d{4,6}|12(?:0[13]|28)\\d{4}",
,,,"1800123456",,,[8,9,10]],[,,"1900\\d{4,6}",,,,"1900123456",,,[8,9,10]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"672\\d{6}",,,,"672012345",,,[9]],"VN",84,"00","0",,,"0",,,,[[,"(\\d{3})(\\d{4})","$1 $2",["[17]99"],"0$1",,1],[,"(\\d{2})(\\d{5})","$1 $2",["80"],"0$1",,1],[,"(\\d{3})(\\d{4,5})","$1 $2",["69"],"0$1",,1],[,"(\\d{4})(\\d{4,6})","$1 $2",["1"],,,1],[,"(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[69]"],"0$1",,1],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[3578]"],"0$1",,1],[,"(\\d{2})(\\d{4})(\\d{4})",
"$1 $2 $3",["2[48]"],"0$1",,1],[,"(\\d{3})(\\d{4})(\\d{3})","$1 $2 $3",["2"],"0$1",,1]],[[,"(\\d{2})(\\d{5})","$1 $2",["80"],"0$1",,1],[,"(\\d{4})(\\d{4,6})","$1 $2",["1"],,,1],[,"(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[69]"],"0$1",,1],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[3578]"],"0$1",,1],[,"(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["2[48]"],"0$1",,1],[,"(\\d{3})(\\d{4})(\\d{3})","$1 $2 $3",["2"],"0$1",,1]],[,,,,,,,,,[-1]],,,[,,"[17]99\\d{4}|69\\d{5,6}",,,,,,,[7,8]],[,,"(?:[17]99|80\\d)\\d{4}|69\\d{5,6}",
,,,"1992000",,,[7,8]],,,[,,,,,,,,,[-1]]],VU:[,[,,"[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}",,,,,,,[5,7]],[,,"(?:38[0-8]|48[4-9])\\d\\d|(?:2[02-9]|3[4-7]|88)\\d{3}",,,,"22123",,,[5]],[,,"(?:[58]\\d|7[013-7])\\d{5}",,,,"5912345",,,[7]],[,,"81[18]\\d\\d",,,,"81123",,,[5]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"9(?:0[1-9]|1[01])\\d{4}",,,,"9010123",,,[7]],"VU",678,"00",,,,,,,,[[,"(\\d{3})(\\d{4})","$1 $2",["[57-9]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"(?:3[03]|900\\d)\\d{3}",,,,"30123"],,
,[,,,,,,,,,[-1]]],WF:[,[,,"(?:40|72)\\d{4}|8\\d{5}(?:\\d{3})?",,,,,,,[6,9]],[,,"72\\d{4}",,,,"721234",,,[6]],[,,"(?:72|8[23])\\d{4}",,,,"821234",,,[6]],[,,"80[0-5]\\d{6}",,,,"800012345",,,[9]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"WF",681,"00",,,,,,,,[[,"(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["[478]"]],[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,"[48]0\\d{4}",,,,"401234",,,[6]]],WS:[,[,,"(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}",
,,,,,,[5,6,7,10]],[,,"6[1-9]\\d{3}|(?:[2-5]|60)\\d{4}",,,,"22123",,,[5,6]],[,,"(?:7[1-35-7]|8(?:[3-7]|9\\d{3}))\\d{5}",,,,"7212345",,,[7,10]],[,,"800\\d{3}",,,,"800123",,,[6]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"WS",685,"0",,,,,,,,[[,"(\\d{5})","$1",["[2-5]|6[1-9]"]],[,"(\\d{3})(\\d{3,7})","$1 $2",["[68]"]],[,"(\\d{2})(\\d{5})","$1 $2",["7"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],XK:[,[,,"[23]\\d{7,8}|(?:4\\d\\d|[89]00)\\d{5}",,,,,,,[8,
9]],[,,"(?:2[89]|39)0\\d{6}|[23][89]\\d{6}",,,,"28012345"],[,,"4[3-9]\\d{6}",,,,"43201234",,,[8]],[,,"800\\d{5}",,,,"80001234",,,[8]],[,,"900\\d{5}",,,,"90001234",,,[8]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"XK",383,"00","0",,,"0",,,,[[,"(\\d{3})(\\d{5})","$1 $2",["[89]"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[2-4]"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[23]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],YE:[,[,,"(?:1|7\\d)\\d{7}|[1-7]\\d{6}",
,,,,,,[7,8,9],[6]],[,,"78[0-7]\\d{4}|17\\d{6}|(?:[12][2-68]|3[2358]|4[2-58]|5[2-6]|6[3-58]|7[24-6])\\d{5}",,,,"1234567",,,[7,8],[6]],[,,"7[01378]\\d{7}",,,,"712345678",,,[9]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"YE",967,"00","0",,,"0",,,,[[,"(\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["[1-6]|7(?:[24-6]|8[0-7])"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["7"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],YT:[,[,,"(?:(?:(?:26|63)9|80\\d)\\d\\d|93980)\\d{4}",
,,,,,,[9]],[,,"269(?:0[0-467]|5[0-3]|6\\d|[78]0)\\d{4}",,,,"269601234"],[,,"(?:639(?:0[0-79]|1[019]|[267]\\d|3[09]|40|5[05-9]|9[04-79])|93980)\\d{4}",,,,"639012345"],[,,"80\\d{7}",,,,"801234567"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"YT",262,"00","0",,,"0",,,,,,[,,,,,,,,,[-1]],,"269|63|9398",[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],ZA:[,[,,"[1-79]\\d{8}|8\\d{4,9}",,,,,,,[5,6,7,8,9,10]],[,,"(?:2(?:0330|4302)|52087)0\\d{3}|(?:1[0-8]|2[1-378]|3[1-69]|4\\d|5[1346-8])\\d{7}",
,,,"101234567",,,[9]],[,,"(?:1(?:3492[0-25]|4495[0235]|549(?:20|5[01]))|4[34]492[01])\\d{3}|8[1-4]\\d{3,7}|(?:2[27]|47|54)4950\\d{3}|(?:1(?:049[2-4]|9[12]\\d\\d)|(?:6\\d|7[0-46-9])\\d{3}|8(?:5\\d{3}|7(?:08[67]|158|28[5-9]|310)))\\d{4}|(?:1[6-8]|28|3[2-69]|4[025689]|5[36-8])4920\\d{3}|(?:12|[2-5]1)492\\d{4}",,,,"711234567",,,[5,6,7,8,9]],[,,"80\\d{7}",,,,"801234567",,,[9]],[,,"(?:86[2-9]|9[0-2]\\d)\\d{6}",,,,"862345678",,,[9]],[,,"860\\d{6}",,,,"860123456",,,[9]],[,,,,,,,,,[-1]],[,,"87(?:08[0-589]|15[0-79]|28[0-4]|31[1-9])\\d{4}|87(?:[02][0-79]|1[0-46-9]|3[02-9]|[4-9]\\d)\\d{5}",
,,,"871234567",,,[9]],"ZA",27,"00","0",,,"0",,,,[[,"(\\d{2})(\\d{3,4})","$1 $2",["8[1-4]"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{2,3})","$1 $2 $3",["8[1-4]"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["860"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[1-9]"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["8"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"861\\d{6,7}",,,,"861123456",,,[9,10]],,,[,,,,,,,,,[-1]]],ZM:[,[,,"800\\d{6}|(?:21|63|[79]\\d)\\d{7}",,,,,,,[9],[6]],[,,"21[1-8]\\d{6}",,,,
"211234567",,,,[6]],[,,"(?:7[5-79]|9[5-8])\\d{7}",,,,"955123456"],[,,"800\\d{6}",,,,"800123456"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"63\\d{7}",,,,"630123456"],"ZM",260,"00","0",,,"0",,,,[[,"(\\d{3})(\\d{3})","$1 $2",["[1-9]"]],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[28]"],"0$1"],[,"(\\d{2})(\\d{7})","$1 $2",["[79]"],"0$1"]],[[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[28]"],"0$1"],[,"(\\d{2})(\\d{7})","$1 $2",["[79]"],"0$1"]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,
,,,,,,,,[-1]]],ZW:[,[,,"2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}",,,,,,,[5,6,7,8,9,10],[3,4]],[,,"(?:1(?:(?:3\\d|9)\\d|[4-8])|2(?:(?:(?:0(?:2[014]|5)|(?:2[0157]|31|84|9)\\d\\d|[56](?:[14]\\d\\d|20)|7(?:[089]|2[03]|[35]\\d\\d))\\d|4(?:2\\d\\d|8))\\d|1(?:2|[39]\\d{4}))|3(?:(?:123|(?:29\\d|92)\\d)\\d\\d|7(?:[19]|[56]\\d))|5(?:0|1[2-478]|26|[37]2|4(?:2\\d{3}|83)|5(?:25\\d\\d|[78])|[689]\\d)|6(?:(?:[16-8]21|28|52[013])\\d\\d|[39])|8(?:[1349]28|523)\\d\\d)\\d{3}|(?:4\\d\\d|9[2-9])\\d{4,5}|(?:(?:2(?:(?:(?:0|8[146])\\d|7[1-7])\\d|2(?:[278]\\d|92)|58(?:2\\d|3))|3(?:[26]|9\\d{3})|5(?:4\\d|5)\\d\\d)\\d|6(?:(?:(?:[0-246]|[78]\\d)\\d|37)\\d|5[2-8]))\\d\\d|(?:2(?:[569]\\d|8[2-57-9])|3(?:[013-59]\\d|8[37])|6[89]8)\\d{3}",
,,,"1312345",,,,[3,4]],[,,"7(?:[178]\\d|3[1-9])\\d{6}",,,,"712345678",,,[9]],[,,"80(?:[01]\\d|20|8[0-8])\\d{3}",,,,"8001234",,,[7]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"86(?:1[12]|22|30|44|55|77|8[368])\\d{6}",,,,"8686123456",,,[10]],"ZW",263,"00","0",,,"0",,,,[[,"(\\d{3})(\\d{3,5})","$1 $2",["2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"],"0$1"],[,"(\\d)(\\d{3})(\\d{2,4})","$1 $2 $3",["[49]"],"0$1"],[,"(\\d{3})(\\d{4})","$1 $2",["80"],"0$1"],
[,"(\\d{2})(\\d{7})","$1 $2",["24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2","2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"],"(0$1)"],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["7"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)","2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"],"0$1"],[,"(\\d{4})(\\d{6})","$1 $2",["8"],"0$1"],[,"(\\d{2})(\\d{3,5})","$1 $2",["1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"],
"0$1"],[,"(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["29[013-9]|39|54"],"0$1"],[,"(\\d{4})(\\d{3,5})","$1 $2",["(?:25|54)8","258|5483"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],800:[,[,,"(?:00|[1-9]\\d)\\d{6}",,,,,,,[8]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"(?:00|[1-9]\\d)\\d{6}",,,,"12345678"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"001",800,,,,,,,,1,[[,"(\\d{4})(\\d{4})","$1 $2",["\\d"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],
,,[,,,,,,,,,[-1]]],808:[,[,,"[1-9]\\d{7}",,,,,,,[8]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"[1-9]\\d{7}",,,,"12345678"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"001",808,,,,,,,,1,[[,"(\\d{4})(\\d{4})","$1 $2",["[1-9]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],870:[,[,,"7\\d{11}|[35-7]\\d{8}",,,,,,,[9,12]],[,,,,,,,,,[-1]],[,,"(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}",,,,"301234567"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,
,,,,,,[-1]],"001",870,,,,,,,,,[[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[35-7]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],878:[,[,,"10\\d{10}",,,,,,,[12]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"10\\d{10}",,,,"101234567890"],"001",878,,,,,,,,1,[[,"(\\d{2})(\\d{5})(\\d{5})","$1 $2 $3",["1"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],881:[,[,,"[0-36-9]\\d{8}",,,,,,,[9]],[,,,,,,,,
,[-1]],[,,"[0-36-9]\\d{8}",,,,"612345678"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"001",881,,,,,,,,,[[,"(\\d)(\\d{3})(\\d{5})","$1 $2 $3",["[0-36-9]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],882:[,[,,"[13]\\d{6}(?:\\d{2,5})?|[19]\\d{7}|(?:[25]\\d\\d|4)\\d{7}(?:\\d{2})?",,,,,,,[7,8,9,10,11,12]],[,,,,,,,,,[-1]],[,,"342\\d{4}|(?:337|49)\\d{6}|(?:3(?:2|47|7\\d{3})|50\\d{3})\\d{7}",,,,"3421234",,,[7,8,9,10,12]],[,,,,,,,,,[-1]],[,
,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:345\\d|9[89])\\d{6}|(?:10|2(?:3|85\\d)|3(?:[15]|[69]\\d\\d)|4[15-8]|51)\\d{8}",,,,"390123456789"],"001",882,,,,,,,,,[[,"(\\d{2})(\\d{5})","$1 $2",["16|342"]],[,"(\\d{2})(\\d{6})","$1 $2",["49"]],[,"(\\d{2})(\\d{2})(\\d{4})","$1 $2 $3",["1[36]|9"]],[,"(\\d{2})(\\d{4})(\\d{3})","$1 $2 $3",["3[23]"]],[,"(\\d{2})(\\d{3,4})(\\d{4})","$1 $2 $3",["16"]],[,"(\\d{2})(\\d{4})(\\d{4})",
"$1 $2 $3",["10|23|3(?:[15]|4[57])|4|51"]],[,"(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["34"]],[,"(\\d{2})(\\d{4,5})(\\d{5})","$1 $2 $3",["[1-35]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,"348[57]\\d{7}",,,,"34851234567",,,[11]]],883:[,[,,"(?:[1-4]\\d|51)\\d{6,10}",,,,,,,[8,9,10,11,12]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"(?:2(?:00\\d\\d|10)|(?:370[1-9]|51\\d0)\\d)\\d{7}|51(?:00\\d{5}|[24-9]0\\d{4,7})|(?:1[013-79]|2[24-689]|3[02-689]|4[0-4])0\\d{5,9}",
,,,"510012345"],"001",883,,,,,,,,1,[[,"(\\d{3})(\\d{3})(\\d{2,8})","$1 $2 $3",["[14]|2[24-689]|3[02-689]|51[24-9]"]],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["510"]],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["21"]],[,"(\\d{4})(\\d{4})(\\d{4})","$1 $2 $3",["51[13]"]],[,"(\\d{3})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["[235]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],888:[,[,,"\\d{11}",,,,,,,[11]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,
,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"001",888,,,,,,,,1,[[,"(\\d{3})(\\d{3})(\\d{5})","$1 $2 $3"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"\\d{11}",,,,"12345678901"],,,[,,,,,,,,,[-1]]],979:[,[,,"[1359]\\d{8}",,,,,,,[9],[8]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"[1359]\\d{8}",,,,"123456789",,,,[8]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"001",979,,,,,,,,1,[[,"(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["[1359]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]]};/*

 Copyright (C) 2010 The Libphonenumber Authors.

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

 http://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
*/
function H(){this.g={};}H.g=void 0;H.h=function(){return H.g?H.g:H.g=new H};
var wa={0:"0",1:"1",2:"2",3:"3",4:"4",5:"5",6:"6",7:"7",8:"8",9:"9","\uff10":"0","\uff11":"1","\uff12":"2","\uff13":"3","\uff14":"4","\uff15":"5","\uff16":"6","\uff17":"7","\uff18":"8","\uff19":"9","\u0660":"0","\u0661":"1","\u0662":"2","\u0663":"3","\u0664":"4","\u0665":"5","\u0666":"6","\u0667":"7","\u0668":"8","\u0669":"9","\u06f0":"0","\u06f1":"1","\u06f2":"2","\u06f3":"3","\u06f4":"4","\u06f5":"5","\u06f6":"6","\u06f7":"7","\u06f8":"8","\u06f9":"9"},xa={0:"0",1:"1",2:"2",3:"3",4:"4",5:"5",6:"6",
7:"7",8:"8",9:"9","+":"+","*":"*","#":"#"},ya={0:"0",1:"1",2:"2",3:"3",4:"4",5:"5",6:"6",7:"7",8:"8",9:"9","\uff10":"0","\uff11":"1","\uff12":"2","\uff13":"3","\uff14":"4","\uff15":"5","\uff16":"6","\uff17":"7","\uff18":"8","\uff19":"9","\u0660":"0","\u0661":"1","\u0662":"2","\u0663":"3","\u0664":"4","\u0665":"5","\u0666":"6","\u0667":"7","\u0668":"8","\u0669":"9","\u06f0":"0","\u06f1":"1","\u06f2":"2","\u06f3":"3","\u06f4":"4","\u06f5":"5","\u06f6":"6","\u06f7":"7","\u06f8":"8","\u06f9":"9",A:"2",
B:"2",C:"2",D:"3",E:"3",F:"3",G:"4",H:"4",I:"4",J:"5",K:"5",L:"5",M:"6",N:"6",O:"6",P:"7",Q:"7",R:"7",S:"7",T:"8",U:"8",V:"8",W:"9",X:"9",Y:"9",Z:"9"},za=/[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?/,Aa=RegExp("[+\uff0b]+"),I=RegExp("^[+\uff0b]+"),Ba=RegExp("([0-9\uff10-\uff19\u0660-\u0669\u06f0-\u06f9])"),Ca=RegExp("[+\uff0b0-9\uff10-\uff19\u0660-\u0669\u06f0-\u06f9]"),Da=/[\\\/] *x/,Ea=RegExp("[^0-9\uff10-\uff19\u0660-\u0669\u06f0-\u06f9A-Za-z#]+$"),Fa=/(?:.*?[A-Za-z]){3}.*/;
function J(a){return "([0-9\uff10-\uff19\u0660-\u0669\u06f0-\u06f9]{1,"+a+"})"}
function Ga(){return ";ext="+J("20")+"|[ \u00a0\\t,]*(?:e?xt(?:ensi(?:o\u0301?|\u00f3))?n?|\uff45?\uff58\uff54\uff4e?|\u0434\u043e\u0431|anexo)[:\\.\uff0e]?[ \u00a0\\t,-]*"+(J("20")+"#?|[ \u00a0\\t,]*(?:[x\uff58#\uff03~\uff5e]|int|\uff49\uff4e\uff54)[:\\.\uff0e]?[ \u00a0\\t,-]*")+(J("9")+"#?|[- ]+")+(J("6")+"#|[ \u00a0\\t]*(?:,{2}|;)[:\\.\uff0e]?[ \u00a0\\t,-]*")+(J("15")+"#?|[ \u00a0\\t]*(?:,)+[:\\.\uff0e]?[ \u00a0\\t,-]*")+(J("9")+"#?")}
var Ha=new RegExp("(?:"+Ga()+")$","i"),Ia=new RegExp("^[0-9\uff10-\uff19\u0660-\u0669\u06f0-\u06f9]{2}$|^[+\uff0b]*(?:[-x\u2010-\u2015\u2212\u30fc\uff0d-\uff0f \u00a0\u00ad\u200b\u2060\u3000()\uff08\uff09\uff3b\uff3d.\\[\\]/~\u2053\u223c\uff5e*]*[0-9\uff10-\uff19\u0660-\u0669\u06f0-\u06f9]){3,}[-x\u2010-\u2015\u2212\u30fc\uff0d-\uff0f \u00a0\u00ad\u200b\u2060\u3000()\uff08\uff09\uff3b\uff3d.\\[\\]/~\u2053\u223c\uff5e*A-Za-z0-9\uff10-\uff19\u0660-\u0669\u06f0-\u06f9]*(?:"+Ga()+")?$","i"),Ja=/(\$\d)/,
Ka=/^\(?\$1\)?$/;function La(a){return 2>a.length?!1:K(Ia,a)}function Ma(a){return K(Fa,a)?Na(a,ya):Na(a,wa)}function Oa(a){var b=Ma(a.toString());A(a);a.g(b);}function Pa(){return Object.keys(G).filter(function(a){return isNaN(a)})}function Qa(){return Object.keys(G).filter(function(a){return !isNaN(a)}).map(function(a){return parseInt(a,10)})}function Ra(){var a=Object.keys(F);return [...Qa(),...a.map(function(b){return parseInt(b,10)})]}function Sa(a){return null!=a&&(1!=v(a,9)||-1!=r(a,9)[0])}
function Na(a,b){for(var c=new z,d,e=a.length,f=0;f<e;++f)d=a.charAt(f),d=b[d.toUpperCase()],null!=d&&c.g(d);return c.toString()}function Ta(a){return 0==a.length||Ka.test(a)}function L(a){return null!=a&&isNaN(a)&&a.toUpperCase()in G}function M(a,b,c){if(0==n(b,2)&&m(b,5)){var d=u(b,5);if(0<d.length)return d}d=u(b,1);var e=N(b);if(0==c)return Ua(d,0,e,"");if(!(d in F))return e;a=O(a,d,P(d));b=Va(b,a,c);e=Wa(e,a,c);return Ua(d,c,e,b)}function O(a,b,c){return "001"==c?Q(a,""+b):Q(a,c)}
function Xa(a,b){var c=S;if(!L(b))return M(c,a,1);var d=u(a,1),e=N(a);if(!(d in F))return e;if(1==d){if(null!=b&&F[1].includes(b.toUpperCase()))return d+" "+M(c,a,2)}else if(d==T(c,b))return M(c,a,2);var f=Q(c,b),g=u(f,11);b="";m(f,17)?b=u(f,17):K(za,g)&&(b=g);c=O(c,d,P(d));e=Wa(e,c,1);a=Va(a,c,1);return 0<b.length?b+" "+d+" "+e+a:Ua(d,1,e,a)}function N(a){if(!m(a,2))return "";var b=""+n(a,2);return m(a,4)&&n(a,4)&&0<u(a,8)?Array(u(a,8)+1).join("0")+b:b}
function Ua(a,b,c,d){switch(b){case 0:return "+"+a+c+d;case 1:return "+"+a+" "+c+d;case 3:return "tel:+"+a+"-"+c+d;default:return c+d}}
function Wa(a,b,c){a:{b=0==r(b,20).length||2==c?r(b,19):r(b,20);for(var d,e=b.length,f=0;f<e;++f){d=b[f];var g=v(d,3);if(0==g||0==a.search(n(d,3,g-1)))if(g=new RegExp(n(d,1)),K(g,a)){b=d;break a}}b=null;}null==b?c=a:(e=b,b=u(e,2),d=new RegExp(n(e,1)),u(e,5),e=u(e,4),a=2==c&&null!=e&&0<e.length?a.replace(d,b.replace(Ja,e)):a.replace(d,b),3==c&&(a=a.replace(RegExp("^[-x\u2010-\u2015\u2212\u30fc\uff0d-\uff0f \u00a0\u00ad\u200b\u2060\u3000()\uff08\uff09\uff3b\uff3d.\\[\\]/~\u2053\u223c\uff5e]+"),""),a=
a.replace(RegExp("[-x\u2010-\u2015\u2212\u30fc\uff0d-\uff0f \u00a0\u00ad\u200b\u2060\u3000()\uff08\uff09\uff3b\uff3d.\\[\\]/~\u2053\u223c\uff5e]+","g"),"-")),c=a);return c}function Ya(a,b){var c=S;if(!L(a))return null;b=Za(Q(c,a),b);try{if(m(b,6)){var d=n(b,6);return $a(c,d,a)}}catch(e){}return null}function Va(a,b,c){return m(a,3)&&0!=n(a,3).length?3==c?";ext="+n(a,3):m(b,13)?n(b,13)+u(a,3):" ext. "+u(a,3):""}
function Za(a,b){switch(b){case 4:return n(a,5);case 3:return n(a,4);case 1:return n(a,3);case 0:case 2:return n(a,2);case 5:return n(a,6);case 6:return n(a,8);case 7:return n(a,7);case 8:return n(a,21);case 9:return n(a,25);case 10:return n(a,28);default:return n(a,1)}}function ab(a,b){return U(a,n(b,1))?U(a,n(b,5))?4:U(a,n(b,4))?3:U(a,n(b,6))?5:U(a,n(b,8))?6:U(a,n(b,7))?7:U(a,n(b,21))?8:U(a,n(b,25))?9:U(a,n(b,28))?10:U(a,n(b,2))?n(b,18)||U(a,n(b,3))?2:0:!n(b,18)&&U(a,n(b,3))?1:-1:-1}
function Q(a,b){if(null==b)return null;b=b.toUpperCase();var c=a.g[b];if(null==c){c=G[b];if(null==c)return null;c=(new y).g(D.o(),c);a.g[b]=c;}return c}function U(a,b){var c=a.length;return 0<v(b,9)&&-1==r(b,9).indexOf(c)?!1:K(u(b,2),a)}function bb(a){var b=S,c=cb(b,a);var d=u(a,1);var e=O(b,d,c);null==e||"001"!=c&&d!=T(b,c)?e=!1:(a=N(a),e=-1!=ab(a,e));return e}
function cb(a,b){if(null==b)return null;var c=u(b,1);c=F[c];if(null==c)a=null;else if(1==c.length)a=c[0];else a:{b=N(b);for(var d,e=c.length,f=0;f<e;f++){d=c[f];var g=Q(a,d);if(m(g,23)){if(0==b.search(n(g,23))){a=d;break a}}else if(-1!=ab(b,g)){a=d;break a}}a=null;}return a}function P(a){a=F[a];return null==a?"ZZ":a[0]}function T(a,b){a=Q(a,b);if(null==a)throw Error("Invalid region code: "+b);return u(a,10)}function db(a){a=eb(a);return 0==a||4==a}
function fb(a,b,c,d){var e=Za(c,d),f=0==v(e,9)?r(n(c,1),9):r(e,9);e=r(e,10);if(2==d)if(Sa(Za(c,0)))a=Za(c,1),Sa(a)&&(f=f.concat(0==v(a,9)?r(n(c,1),9):r(a,9)),f.sort(),0==e.length?e=r(a,10):(e=e.concat(r(a,10)),e.sort()));else return fb(a,b,c,1);if(-1==f[0])return 5;b=b.length;if(-1<e.indexOf(b))return 4;c=f[0];return c==b?0:c>b?2:f[f.length-1]<b?3:-1<f.indexOf(b,1)?0:5}function eb(a){var b=S,c=N(a);a=u(a,1);if(!(a in F))return 1;a=O(b,a,P(a));return fb(b,c,a,-1)}
function gb(a,b){a=a.toString();if(0==a.length||"0"==a.charAt(0))return 0;for(var c,d=a.length,e=1;3>=e&&e<=d;++e)if(c=parseInt(a.substring(0,e),10),c in F)return b.g(a.substring(e)),c;return 0}
function hb(a,b,c,d,e){if(0==b.length)return 0;b=new z(b);var f;null!=c&&(f=n(c,11));null==f&&(f="NonMatch");var g=b.toString();if(0==g.length)f=20;else if(I.test(g))g=g.replace(I,""),A(b),b.g(Ma(g)),f=1;else {g=new RegExp(f);Oa(b);f=b.toString();if(0==f.search(g)){g=f.match(g)[0].length;var l=f.substring(g).match(Ba);l&&null!=l[1]&&0<l[1].length&&"0"==Na(l[1],wa)?f=!1:(A(b),b.g(f.substring(g)),f=!0);}else f=!1;f=f?5:20;}if(20!=f){if(2>=b.h.length)throw Error("Phone number too short after IDD");a=gb(b,
d);if(0!=a)return p(e,1,a),a;throw Error("Invalid country calling code");}if(null!=c&&(f=u(c,10),g=""+f,l=b.toString(),0==l.lastIndexOf(g,0)&&(g=new z(l.substring(g.length)),l=n(c,1),l=new RegExp(u(l,2)),ib(g,c,null),g=g.toString(),!K(l,b.toString())&&K(l,g)||3==fb(a,b.toString(),c,-1))))return d.g(g),p(e,1,f),f;p(e,1,0);return 0}
function ib(a,b,c){var d=a.toString(),e=d.length,f=n(b,15);if(0!=e&&null!=f&&0!=f.length){var g=new RegExp("^(?:"+f+")");if(e=g.exec(d)){f=new RegExp(u(n(b,1),2));var l=K(f,d),q=e.length-1;b=n(b,16);if(null==b||0==b.length||null==e[q]||0==e[q].length){if(!l||K(f,d.substring(e[0].length)))null!=c&&0<q&&null!=e[q]&&c.g(e[1]),a.set(d.substring(e[0].length));}else if(d=d.replace(g,b),!l||K(f,d))null!=c&&0<q&&c.g(e[1]),a.set(d);}}}
function $a(a,b,c){if(null==b)throw Error("The string supplied did not seem to be a phone number");if(250<b.length)throw Error("The string supplied is too long to be a phone number");var d=new z,e=b.indexOf(";phone-context=");if(0<=e){var f=e+15;if("+"==b.charAt(f)){var g=b.indexOf(";",f);0<g?d.g(b.substring(f,g)):d.g(b.substring(f));}f=b.indexOf("tel:");d.g(b.substring(0<=f?f+4:0,e));}else e=d.g,f=b.search(Ca),0<=f?(b=b.substring(f),b=b.replace(Ea,""),f=b.search(Da),0<=f&&(b=b.substring(0,f))):b="",
e.call(d,b);b=d.toString();e=b.indexOf(";isub=");0<e&&(A(d),d.g(b.substring(0,e)));if(!La(d.toString()))throw Error("The string supplied did not seem to be a phone number");b=d.toString();if(!(L(c)||null!=b&&0<b.length&&I.test(b)))throw Error("Invalid country calling code");b=new E;a:{e=d.toString();f=e.search(Ha);if(0<=f&&La(e.substring(0,f))){g=e.match(Ha);for(var l=g.length,q=1;q<l;++q)if(null!=g[q]&&0<g[q].length){A(d);d.g(e.substring(0,f));e=g[q];break a}}e="";}0<e.length&&p(b,3,e);f=Q(a,c);e=
new z;g=0;l=d.toString();try{g=hb(a,l,f,e,b);}catch(R){if("Invalid country calling code"==R.message&&I.test(l)){if(l=l.replace(I,""),g=hb(a,l,f,e,b),0==g)throw R;}else throw R;}0!=g?(d=P(g),d!=c&&(f=O(a,g,d))):(Oa(d),e.g(d.toString()),null!=c&&(g=u(f,10),p(b,1,g)));if(2>e.h.length)throw Error("The string supplied is too short to be a phone number");null!=f&&(c=new z(e.toString()),ib(c,f,new z),a=fb(a,c.toString(),f,-1),2!=a&&4!=a&&5!=a&&(e=c));a=e.toString();c=a.length;if(2>c)throw Error("The string supplied is too short to be a phone number");
if(17<c)throw Error("The string supplied is too long to be a phone number");if(1<a.length&&"0"==a.charAt(0)){p(b,4,!0);for(c=1;c<a.length-1&&"0"==a.charAt(c);)c++;1!=c&&p(b,8,c);}p(b,2,parseInt(a,10));return b}H.prototype.ja=function(a){var b=Q(this,cb(this,a));if(null==b)return !0;a=N(a);return !U(a,n(b,24))};function K(a,b){return (a="string"==typeof a?b.match("^(?:"+a+")$"):b.match(a))&&a[0].length==b.length?!0:!1}function jb(a){this.ka=RegExp("\u2008");this.la="";this.$=new z;this.da="";this.u=new z;this.ba=new z;this.v=!0;this.ea=this.ca=this.oa=!1;this.pa=H.h();this.aa=0;this.h=new z;this.ha=!1;this.s="";this.g=new z;this.j=[];this.ma=a;this.wa=this.m=kb(this,this.ma);}var lb=new D;p(lb,11,"NA");
var mb=RegExp("^[-x\u2010-\u2015\u2212\u30fc\uff0d-\uff0f \u00a0\u00ad\u200b\u2060\u3000()\uff08\uff09\uff3b\uff3d.\\[\\]/~\u2053\u223c\uff5e]*\\$1[-x\u2010-\u2015\u2212\u30fc\uff0d-\uff0f \u00a0\u00ad\u200b\u2060\u3000()\uff08\uff09\uff3b\uff3d.\\[\\]/~\u2053\u223c\uff5e]*(\\$\\d[-x\u2010-\u2015\u2212\u30fc\uff0d-\uff0f \u00a0\u00ad\u200b\u2060\u3000()\uff08\uff09\uff3b\uff3d.\\[\\]/~\u2053\u223c\uff5e]*)*$"),nb=/[- ]/;function kb(a,b){b=L(b)?T(a.pa,b):0;a=Q(a.pa,P(b));return null!=a?a:lb}
function ob(a){for(var b=a.j.length,c=0;c<b;++c){var d=a.j[c],e=u(d,1);if(a.da==e)return !1;var f=a;var g=d,l=u(g,1);A(f.$);var q=f;g=u(g,2);var R="999999999999999".match(l)[0];R.length<q.g.h.length?q="":(q=R.replace(new RegExp(l,"g"),g),q=q.replace(RegExp("9","g"),"\u2008"));0<q.length?(f.$.g(q),f=!0):f=!1;if(f)return a.da=e,a.ha=nb.test(n(d,4)),a.aa=0,!0}return a.v=!1}
function pb(a,b){for(var c=[],d=b.length-3,e=a.j.length,f=0;f<e;++f){var g=a.j[f];0==v(g,3)?c.push(a.j[f]):(g=n(g,3,Math.min(d,v(g,3)-1)),0==b.search(g)&&c.push(a.j[f]));}a.j=c;}
function qb(a,b){a.u.g(b);var c=b;Ba.test(c)||1==a.u.h.length&&Aa.test(c)?("+"==b?(c=b,a.ba.g(b)):(c=wa[b],a.ba.g(c),a.g.g(c)),b=c):(a.v=!1,a.oa=!0);if(!a.v){if(!a.oa)if(rb(a)){if(sb(a))return tb(a)}else if(0<a.s.length&&(b=a.g.toString(),A(a.g),a.g.g(a.s),a.g.g(b),b=a.h.toString(),c=b.lastIndexOf(a.s),A(a.h),a.h.g(b.substring(0,c))),a.s!=ub(a))return a.h.g(" "),tb(a);return a.u.toString()}switch(a.ba.h.length){case 0:case 1:case 2:return a.u.toString();case 3:if(rb(a))a.ea=!0;else return a.s=ub(a),
vb(a);default:if(a.ea)return sb(a)&&(a.ea=!1),a.h.toString()+a.g.toString();if(0<a.j.length){b=wb(a,b);c=xb(a);if(0<c.length)return c;pb(a,a.g.toString());return ob(a)?yb(a):a.v?zb(a,b):a.u.toString()}return vb(a)}}function tb(a){a.v=!0;a.ea=!1;a.j=[];a.aa=0;A(a.$);a.da="";return vb(a)}
function xb(a){for(var b=a.g.toString(),c=a.j.length,d=0;d<c;++d){var e=a.j[d],f=u(e,1);if((new RegExp("^(?:"+f+")$")).test(b)&&(a.ha=nb.test(n(e,4)),e=b.replace(new RegExp(f,"g"),n(e,2)),e=zb(a,e),Na(e,xa)==a.ba))return e}return ""}function zb(a,b){var c=a.h.h.length;return a.ha&&0<c&&" "!=a.h.toString().charAt(c-1)?a.h+" "+b:a.h+b}
function vb(a){var b=a.g.toString();if(3<=b.length){for(var c=a.ca&&0==a.s.length&&0<v(a.m,20)?r(a.m,20):r(a.m,19),d=c.length,e=0;e<d;++e){var f=c[e];0<a.s.length&&Ta(u(f,4))&&!n(f,6)&&!m(f,5)||(0!=a.s.length||a.ca||Ta(u(f,4))||n(f,6))&&mb.test(u(f,2))&&a.j.push(f);}pb(a,b);b=xb(a);return 0<b.length?b:ob(a)?yb(a):a.u.toString()}return zb(a,b)}function yb(a){var b=a.g.toString(),c=b.length;if(0<c){for(var d="",e=0;e<c;e++)d=wb(a,b.charAt(e));return a.v?zb(a,d):a.u.toString()}return a.h.toString()}
function ub(a){var b=a.g.toString(),c=0;if(1!=a.m.ia())var d=!1;else d=a.g.toString(),d="1"==d.charAt(0)&&"0"!=d.charAt(1)&&"1"!=d.charAt(1);d?(c=1,a.h.g("1").g(" "),a.ca=!0):m(a.m,15)&&(d=new RegExp("^(?:"+n(a.m,15)+")"),d=b.match(d),null!=d&&null!=d[0]&&0<d[0].length&&(a.ca=!0,c=d[0].length,a.h.g(b.substring(0,c))));A(a.g);a.g.g(b.substring(c));return b.substring(0,c)}
function rb(a){var b=a.ba.toString(),c=new RegExp("^(?:\\+|"+n(a.m,11)+")");c=b.match(c);return null!=c&&null!=c[0]&&0<c[0].length?(a.ca=!0,c=c[0].length,A(a.g),a.g.g(b.substring(c)),A(a.h),a.h.g(b.substring(0,c)),"+"!=b.charAt(0)&&a.h.g(" "),!0):!1}function sb(a){if(0==a.g.h.length)return !1;var b=new z,c=gb(a.g,b);if(0==c)return !1;A(a.g);a.g.g(b.toString());b=P(c);"001"==b?a.m=Q(a.pa,""+c):b!=a.ma&&(a.m=kb(a,b));a.h.g(""+c).g(" ");a.s="";return !0}
function wb(a,b){var c=a.$.toString();if(0<=c.substring(a.aa).search(a.ka)){var d=c.search(a.ka);b=c.replace(a.ka,b);A(a.$);a.$.g(b);a.aa=d;return b.substring(0,a.aa+1)}1==a.j.length&&(a.v=!1);a.da="";return a.u.toString()}var S=H.h();function Ab(a){var b=S,c=cb(b,a);b=O(b,u(a,1),c);null==b?a=-1:(a=N(a),a=ab(a,b));switch(a){case 0:return "fixed-line";case 2:return "fixed-line-or-mobile";case 1:return "mobile";case 8:return "pager";case 7:return "personal-number";case 4:return "premium-rate";case 5:return "shared-cost";case 3:return "toll-free";case 9:return "uan";case 6:return "voip";default:case -1:return "unknown"}}
function Bb(a){switch(a){case "fixed-line":return 0;case "fixed-line-or-mobile":return 2;case "mobile":return 1;case "pager":return 8;case "personal-number":return 7;case "premium-rate":return 4;case "shared-cost":return 5;case "toll-free":return 3;case "uan":return 9;case "voip":return 6;default:case "unknown":return -1}}
function Cb(a){try{switch(eb(a)){case 0:return "is-possible";case 1:return "invalid-country-code";case 3:return "too-long";case 2:return "too-short"}if(db(a))return "is-possible"}catch(b){}return "unknown"}
function Db(a,b){if("+"!==a.charAt(0)&&"00"!==a.slice(0,2))return {parsed:c,fa:d};try{var c=$a(S,a,b);}catch(e){}if(c){var d=cb(S,c);if(null!=d&&"ZZ"!==d)return {parsed:c,fa:d}}for(b=1;4>b;++b){d=void 0;if(a.length<b+1)return {parsed:c,fa:d};d=P(a.substring(1,b+1));if("ZZ"!==d)return {fa:d}}return {parsed:c,fa:void 0}}var Eb;a:{try{Eb=new WeakMap;break a}catch(a){}Eb=void 0;}var Fb=Eb;
function V(a,b){if(!(this instanceof V))return new V(a,b);var c=null==b?void 0:b.regionCode;if("string"===typeof a)var d=!1;else try{bb(a),d=!0;}catch(f){d=!1;}let e;if(!d&&"string"!==typeof a)throw Error("Invalid phone number, expected a string");if(!d&&"object"!==typeof b&&"undefined"!==typeof b)throw Error(`Invalid options, expected object, got ${typeof b}. `+"This may be because of not yet upgraded code.");if(!d&&null!=c&&"string"!==typeof c)throw Error("Invalid region code, expected a string, got "+
`${typeof c} ${c}`);d||(a=a.trim(),c&&"+"===a.charAt(0)&&(c=null),c&&"+"!==a.charAt(0)&&"00"!==a.slice(0,2)||({fa:c=null,parsed:e}=Db(a,c)));this.g={number:{},regionCode:c,valid:!1,possible:!1};Fb&&Fb.set(this.g,this);if(d)this.l=a;else {this.l=null;this.g.number.input=a;if(!c){this.g.possibility="invalid-country-code";return}if(0===Gb(c)){this.g.possibility="invalid-country-code";return}try{this.l=e?e:$a(S,a,c);}catch(f){this.g.possibility=Cb(a);return}}this.g.number.international=M(S,this.l,1);this.g.number.national=
M(S,this.l,2);this.g.number.e164=M(S,this.l,0);this.g.number.rfc3966=M(S,this.l,3);this.g.number.significant=N(this.l);this.g.canBeInternationallyDialled=S.ja(this.l);this.g.possible=db(this.l);this.g.valid=bb(this.l);this.g.type=Ab(this.l);this.g.possibility=Cb(this.l);this.g.typeIsMobile=this.sa();this.g.typeIsFixedLine=this.ra();this.g.countryCode=L(c)?T(S,c):0;}var W=["PhoneNumber$$module$src$index"],X=aa;W[0]in X||"undefined"==typeof X.execScript||X.execScript("var "+W[0]);
for(var Y;W.length&&(Y=W.shift());)W.length||void 0===V?X[Y]&&X[Y]!==Object.prototype[Y]?X=X[Y]:X=X[Y]={}:X[Y]=V;function Gb(a){return L(a)?T(S,a):0}V.getCountryCodeForRegionCode=Gb;V.getRegionCodeForCountryCode=function(a){return P(a)};function Hb(a){var b={};return a.filter(c=>{if(b.hasOwnProperty(c))return !1;b[c]=1;return !0})}V.getSupportedRegionCodes=function(){return Hb(Pa())};V.getSupportedCallingCodes=function(){return Hb(Ra())};
V.getExample=function(a,b){var c;b?c=Ya(a,Bb(b)):c=Ya(a,0);return (new V(c,a)).toJSON()};V.getAsYouType=function(a){return new Z(a)};V.getNumberFrom=function(a,b){try{a:{if(Fb){var e=Fb.get(a);if(e){var c=e;break a}}let d;c=new V(null==a?void 0:null==(d=a.number)?void 0:d.e164,{});}return {valid:!0,number:Xa(c.l,b)}}catch(d){return {valid:!1,error:d}}};V.prototype.toJSON=function(){return this.g};V.prototype.toJSON=V.prototype.toJSON;V.prototype.ja=function(){return this.g.canBeInternationallyDialled};
V.prototype.canBeInternationallyDialled=V.prototype.ja;V.prototype.ya=function(){return this.g.valid};V.prototype.isValid=V.prototype.ya;V.prototype.xa=function(){return this.g.possible};V.prototype.isPossible=V.prototype.xa;V.prototype.getType=function(){return this.g.type};V.prototype.getType=V.prototype.getType;V.prototype.sa=function(){return "mobile"===this.g.type||"fixed-line-or-mobile"===this.g.type};V.prototype.isMobile=V.prototype.sa;
V.prototype.ra=function(){return "fixed-line"===this.g.type||"fixed-line-or-mobile"===this.g.type};V.prototype.isFixedLine=V.prototype.ra;V.prototype.ta=function(a){return this.g.number[null==a?"e164":a]};V.prototype.getNumber=V.prototype.ta;V.prototype.va=function(){return this.g.regionCode};V.prototype.getRegionCode=V.prototype.va;V.prototype.ia=function(){return Gb(this.g.regionCode)};V.prototype.getCountryCode=V.prototype.ia;function Z(a){this.j=a;this.h=new jb(a);this.l=this.g="";}
Z.prototype.qa=function(a){this.g+=a;var b=this.h;b.la=qb(b,a);return this.l=b.la};Z.prototype.addChar=Z.prototype.qa;Z.prototype.za=function(){return this.l};Z.prototype.number=Z.prototype.za;Z.prototype.Aa=function(){return ""===this.g?this.l:this.reset(this.g.slice(0,this.g.length-1))};Z.prototype.removeChar=Z.prototype.Aa;
Z.prototype.reset=function(a){var b=this.h;b.la="";A(b.u);A(b.ba);A(b.$);b.aa=0;b.da="";A(b.h);b.s="";A(b.g);b.v=!0;b.oa=!1;b.ca=!1;b.ea=!1;b.j=[];b.ha=!1;b.m!=b.wa&&(b.m=kb(b,b.ma));this.l=this.g="";if(a){b=0;for(var c=a.length;b<c;++b)this.qa(a.charAt(b));}return this.l};Z.prototype.reset=Z.prototype.reset;Z.prototype.ua=function(){return (new V(this.l,{regionCode:this.j})).toJSON()};Z.prototype.getPhoneNumber=Z.prototype.ua;}).call(
	(module.exports)
	|| typeof globalThis !== 'undefined' && globalThis
	|| typeof commonjsGlobal !== 'undefined' && commonjsGlobal
	|| typeof window !== 'undefined' && window
	|| typeof self !== 'undefined' && self
	|| commonjsGlobal
);
}(lib));

(function (module) {
const exportedName = 'PhoneNumber$$module$src$index';

module.exports =
	lib.exports[ exportedName ] ||
	(
		typeof globalThis !== 'undefined' && globalThis
		|| typeof commonjsGlobal !== 'undefined' && commonjsGlobal
		|| typeof window !== 'undefined' && window
		|| typeof self !== 'undefined' && self
		|| commonjsGlobal
	)[ exportedName ];

Object.defineProperty(
	module.exports,
	"__esModule",
	{
		value: true
	}
);

module.exports.parsePhoneNumber = ( ...args ) =>
{
	try
	{
		const ret = module.exports( ...args ).toJSON( );
		if ( !ret.valid && !ret.possible )
		{
			ret.possible = false;
			if ( !ret.possibility )
				ret.possibility = 'invalid';
		}
		return ret;
	}
	catch ( error )
	{
		return {
			valid: false,
			possible: false,
			possibility: 'invalid',
			error,
		};
	}
};

module.exports.getCountryCodeForRegionCode = module.exports.getCountryCodeForRegionCode;
module.exports.getRegionCodeForCountryCode = module.exports.getRegionCodeForCountryCode;
module.exports.getSupportedCallingCodes = module.exports.getSupportedCallingCodes;
module.exports.getSupportedRegionCodes = module.exports.getSupportedRegionCodes;
module.exports.getExample = module.exports.getExample;
module.exports.getAsYouType = module.exports.getAsYouType;
module.exports.getNumberFrom = module.exports.getNumberFrom;
}(awesomePhonenumber));

var index = /*@__PURE__*/getDefaultExportFromCjs(awesomePhonenumber.exports);

const {
	PhoneNumber,
	AsYouType,
	getCountryCodeForRegionCode,
	getRegionCodeForCountryCode,
	getSupportedCallingCodes,
	getSupportedRegionCodes,
	getExample,
	getAsYouType,
	getNumberFrom,
} = index;

const parsePhoneNumber = ( ...args ) =>
{
	try
	{
		const ret = index( ...args ).toJSON( );
		if ( !ret.valid && !ret.possible )
		{
			ret.possible = false;
			if ( !ret.possibility )
				ret.possibility = 'invalid';
		}
		return ret;
	}
	catch ( error )
	{
		return {
			valid: false,
			possible: false,
			possibility: 'invalid',
			error,
		};
	}
};

const phoneInputConfig = {
  fixedClasses: {
    wrapper: "relative",
    inputsContainer: "rounded-lg -space-y-px",
    input: {
      fixedClasses: {
        addonBeforeInputClasses: "pl-12"
      }
    }
  },
  classes: {
    wrapper: "",
    inputsContainer: "",
    input: {
      fixedClasses: {
        addonBeforeInputClasses: ""
      }
    }
  },
  variants: {
    error: {
      input: {
        fixedClasses: {
          addonBeforeInputClasses: ""
        }
      }
    }
  }
};
const phoneInputClassesKeys = Object.keys(phoneInputConfig.classes);

const __default__$a = {
  name: "VanillaPhoneInput",
  inheritAttrs: false
};
const _sfc_main$a = /* @__PURE__ */ defineComponent({
  ...__default__$a,
  props: {
    ...useVariantProps$1(),
    modelValue: {
      type: [String, Number],
      default: void 0
    },
    countryCode: {
      type: [String],
      default: ""
    },
    phonePlaceholder: {
      type: [String, Number],
      default: "Your national number"
    },
    countryPlaceholder: {
      type: [String, Number],
      default: "Select your phone indicative"
    },
    favoriteCountries: {
      type: [Array, Object, void 0],
      required: false,
      default: () => ["US", "GB", "PT", "FR", "DE"]
    },
    searchBoxPlaceholder: {
      type: String,
      default: "Your Phone Number country"
    },
    noResultsText: {
      type: String,
      default: "😟 Sorry but we did not find any countries to your query. Try another one query?"
    },
    searchingText: {
      type: String,
      default: "Please wait, searching for results..."
    },
    loadingClosedPlaceholder: {
      type: String,
      default: "Loading, please wait ..."
    },
    loadingMoreResultsText: {
      type: String,
      default: "Loading more options..."
    },
    minimumInputLengthText: {
      type: [Function, String],
      default: () => (minimumInputLength) => `Search more countries by entering ${minimumInputLength} or more characters`
    }
  },
  emits: [
    "update:countryDialCode",
    "update:countryCode",
    "update:countryName",
    "update:modelValue",
    "update:phoneNumberNational",
    "update:phoneNumberInternational",
    "update:phoneNumberIsValid"
  ],
  setup(__props, { emit }) {
    const props = __props;
    const rootPhone = ref(null);
    const rootCountry = ref(null);
    const localValue = useVModel(props, "modelValue");
    const phoneCountryCode = ref(props.countryCode);
    const phoneDialCode = ref(null);
    const phoneNumber = ref(localValue.value);
    const isValidPhoneNumber = ref(false);
    const placeholder = ref(props.phonePlaceholder);
    const parsedPhoneNumber = ref(null);
    const attemptToParseNumber = (phoneNumberValue, phoneCountryCodeValue = void 0) => {
      if (!phoneNumberValue) {
        return;
      }
      if (phoneCountryCodeValue) {
        phoneDialCode.value = getCountryCodeForRegionCode(phoneCountryCodeValue);
      }
      parsedPhoneNumber.value = parsePhoneNumber(phoneNumberValue || "", { regionCode: phoneCountryCodeValue });
      if (parsedPhoneNumber.value && parsedPhoneNumber.value?.countryCode) {
        isValidPhoneNumber.value = true;
        phoneCountryCode.value = parsedPhoneNumber.value?.regionCode;
        phoneDialCode.value = parsedPhoneNumber.value?.countryCode;
        phoneNumber.value = parsedPhoneNumber.value?.number?.significant;
        localValue.value = `+${phoneDialCode.value}${phoneNumber.value}`;
      } else {
        isValidPhoneNumber.value = false;
        localValue.value = void 0;
      }
    };
    attemptToParseNumber(localValue.value, phoneCountryCode.value || void 0);
    const { configuration, errors, hasErrors, variant } = useConfiguration(phoneInputConfig, "PhoneInput", localValue);
    watch([phoneCountryCode, phoneNumber], ([newPhoneCountryCode, newPhoneNumber]) => {
      attemptToParseNumber(newPhoneNumber, newPhoneCountryCode || void 0);
      if (newPhoneCountryCode) {
        const examplePlaceHolder = getExample(newPhoneCountryCode, "mobile")?.number?.significant;
        if (examplePlaceHolder && (props.phonePlaceholder === "" || props.phonePlaceholder === void 0)) {
          placeholder.value = examplePlaceHolder;
        }
      }
      if (phoneCountryCode.value) {
        phoneDialCode.value = getCountryCodeForRegionCode(phoneCountryCode.value);
      }
      emit("update:countryDialCode", phoneDialCode.value);
      emit("update:countryCode", phoneCountryCode.value);
      emit("update:phoneNumberNational", phoneNumber.value);
      emit("update:phoneNumberInternational", localValue.value);
      emit("update:phoneNumberIsValid", isValidPhoneNumber.value);
    }, { immediate: false });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(["vanilla-input-phone-number", unref(configuration).classesList.wrapper])
      }, [
        createElementVNode("div", {
          class: normalizeClass([unref(configuration).classesList.inputsContainer])
        }, [
          createVNode(_sfc_main$z, {
            ref_key: "rootCountry",
            ref: rootCountry,
            modelValue: phoneCountryCode.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => phoneCountryCode.value = $event),
            modelModifiers: { lazy: true },
            "favorite-countries": __props.favoriteCountries,
            variant: unref(variant),
            "show-errors": false,
            "label-with-dial-code": true,
            placeholder: __props.countryPlaceholder,
            clearable: false,
            "search-box-placeholder": __props.searchBoxPlaceholder,
            "no-results-text": __props.noResultsText,
            "searching-text": __props.searchingText,
            "loading-closed-placeholder": __props.loadingClosedPlaceholder,
            "loading-more-results-text": __props.loadingMoreResultsText,
            rounded: "top"
          }, null, 8, ["modelValue", "favorite-countries", "variant", "placeholder", "search-box-placeholder", "no-results-text", "searching-text", "loading-closed-placeholder", "loading-more-results-text"]),
          createVNode(_sfc_main$t, {
            ref_key: "rootPhone",
            ref: rootPhone,
            modelValue: phoneNumber.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => phoneNumber.value = $event),
            modelModifiers: { lazy: true },
            variant: unref(variant),
            "show-errors": false,
            placeholder: placeholder.value,
            autocomplete: props.autocomplete,
            "fixed-classes": unref(configuration).classesList.input.fixedClasses,
            rounded: "bottom"
          }, {
            before: withCtx(({ className }) => [
              renderSlot(_ctx.$slots, "dialCode", normalizeProps(guardReactiveProps({ phoneDialCode: phoneDialCode.value })), () => [
                createElementVNode("span", {
                  class: normalizeClass(["sm:text-sm", className])
                }, "+" + toDisplayString(phoneDialCode.value), 3)
              ])
            ]),
            _: 3
          }, 8, ["modelValue", "variant", "placeholder", "autocomplete", "fixed-classes"])
        ], 2),
        renderSlot(_ctx.$slots, "errors", normalizeProps(guardReactiveProps({ hasErrors: unref(hasErrors), errors: unref(errors) })), () => [
          unref(hasErrors) && props.showErrors ? (openBlock(), createBlock(_sfc_main$Z, {
            key: 0,
            errors: unref(errors)
          }, null, 8, ["errors"])) : createCommentVNode("", true)
        ]),
        renderSlot(_ctx.$slots, "feedback", normalizeProps(guardReactiveProps({ hasErrors: unref(hasErrors), feedback: props.feedback })), () => [
          !unref(hasErrors) && props.feedback && props.showFeedback ? (openBlock(), createBlock(_sfc_main$Y, {
            key: 0,
            text: props.feedback
          }, null, 8, ["text"])) : createCommentVNode("", true)
        ])
      ], 2);
    };
  }
});

const richRadioOptionConfig = {
  fixedClasses: {
    disabled: commonClasses.optionOrItemDisabled,
    option: "select-none",
    checked: "",
    unchecked: "",
    highlighted: "",
    nonHighlighted: "",
    separated: "",
    firstItem: "rounded-tl-lg rounded-tr-lg",
    lastItem: "rounded-bl-lg rounded-br-lg",
    compact: "px-4 py-2",
    nonCompact: "px-5 py-4",
    radio: "",
    radioHighlighted: "ring-2 ring-offset-2",
    radioChecked: "",
    radioUnchecked: "",
    radioInner: "",
    checkedIconWrapper: "",
    checkedIcon: "w-6 h-6",
    checkedIconOpacity: "",
    contentWrapper: "",
    contentWrapperIfNotRadio: "",
    contentInner: "",
    content: "",
    label: "",
    labelChecked: "",
    labelUnchecked: "",
    description: "",
    descriptionChecked: "",
    descriptionUnchecked: ""
  },
  classes: {
    disabled: "",
    option: "relative flex px-5 py-4 cursor-pointer focus:outline-none",
    checked: "bg-primary-100 dark:bg-primary-500/60 text-white border-primary-200 dark:border-primary-500 z-10",
    unchecked: "bg-white dark:bg-gray-900",
    highlighted: "ring-2 ring-offset-2 ring-offset-white dark:ring-offset-gray-900 ring-primary-600 border border-primary-200 dark:bg-primary-500 dark:border-primary-500 z-10",
    nonHighlighted: "border border-gray-200 dark:border-gray-700",
    separated: "rounded-lg",
    firstItem: "",
    lastItem: "",
    compact: "",
    nonCompact: "",
    radio: "h-4 w-4 mt-1 cursor-pointer rounded-full border flex items-center justify-center flex-shrink-0",
    radioHighlighted: "ring-primary-500",
    radioChecked: "bg-primary-600 border-transparent dark:bg-gray-900 ring-offset-white dark:ring-offset-gray-900",
    radioUnchecked: "bg-white dark:bg-gray-700 border-gray-300",
    radioInner: "rounded-full bg-white w-1.5 h-1.5",
    checkedIconWrapper: "flex-shrink-0",
    checkedIcon: "w-6 h-6",
    checkedIconOpacity: "fill-opacity-90 dark:fill-opacity-30 fill-[#4f46e5] dark:fill-[#fff]",
    contentWrapper: "ml-3 flex items-center justify-between text-sm",
    contentWrapperIfNotRadio: "w-full",
    contentInner: "",
    content: "flex items-center",
    label: "font-medium",
    labelChecked: "font-bold text-primary-900 dark:text-white",
    labelUnchecked: "font-normal text-gray-900 dark:text-white",
    description: "inline",
    descriptionChecked: "text-primary-700 dark:text-gray-200",
    descriptionUnchecked: "text-gray-500 dark:text-gray-400"
  },
  // Variants
  variants: {
    // Used for Errors
    error: {
      classes: {
        disabled: "",
        option: "relative flex px-5 py-4 cursor-pointer focus:outline-none",
        checked: "bg-red-100 dark:bg-red-500/30 text-white border-red-200 dark:border-red-500 z-10",
        unchecked: "bg-white dark:bg-gray-900",
        highlighted: "ring-2 ring-offset-2 ring-offset-white dark:ring-offset-gray-900 ring-red-600 border border-red-200 dark:bg-red-500 dark:border-red-500 z-10",
        nonHighlighted: "border border-gray-200 dark:border-gray-700",
        separated: "rounded-lg",
        firstItem: "",
        lastItem: "",
        compact: "",
        nonCompact: "",
        radio: "h-4 w-4 mt-1 cursor-pointer rounded-full border flex items-center justify-center",
        radioHighlighted: "ring-red-500",
        radioChecked: "bg-red-600 border-transparent dark:bg-red-700 ring-offset-white dark:ring-offset-gray-90",
        radioUnchecked: "bg-white dark:bg-gray-700 border-gray-300",
        radioInner: "rounded-full bg-white w-1.5 h-1.5",
        checkedIconWrapper: "flex-shrink-0",
        checkedIcon: "w-6 h-6",
        checkedIconOpacity: "fill-opacity-90 dark:fill-opacity-30 fill-red-300 dark:fill-[#fff]",
        contentWrapper: "ml-3 flex items-center justify-between text-sm",
        contentWrapperIfNotRadio: "w-full",
        contentInner: "",
        content: "flex items-center",
        label: "font-medium",
        labelChecked: "font-bold text-red-900 dark:text-white",
        labelUnchecked: "font-normal text-gray-900 dark:text-white",
        description: "inline",
        descriptionChecked: "text-red-700 dark:text-gray-200",
        descriptionUnchecked: "text-gray-500 dark:text-gray-400"
      }
    },
    success: {
      classes: {
        disabled: "",
        option: "relative flex px-5 py-4 cursor-pointer focus:outline-none",
        checked: "bg-green-100 dark:bg-green-500/30 text-green-700 border-green-200 dark:border-green-500 z-10",
        unchecked: "bg-white dark:bg-gray-900",
        highlighted: "ring-2 ring-offset-2 ring-offset-white dark:ring-offset-gray-900 ring-green-600 border border-green-200 dark:bg-green-500 dark:border-green-500 z-10",
        nonHighlighted: "border border-gray-200 dark:border-gray-700",
        separated: "rounded-lg",
        firstItem: "",
        lastItem: "",
        compact: "",
        nonCompact: "",
        radio: "h-4 w-4 mt-1 cursor-pointer rounded-full border flex items-center justify-center",
        radioHighlighted: "ring-green-500",
        radioChecked: "bg-green-600 border-transparent dark:bg-green-700 ring-offset-white dark:ring-offset-gray-90",
        radioUnchecked: "bg-white dark:bg-gray-700 border-gray-300",
        radioInner: "rounded-full bg-white w-1.5 h-1.5",
        checkedIconWrapper: "flex-shrink-0",
        checkedIcon: "w-6 h-6",
        checkedIconOpacity: "fill-opacity-90 dark:fill-opacity-30 fill-green-300 dark:fill-[#fff]",
        contentWrapper: "ml-3 flex items-center justify-between text-sm",
        contentWrapperIfNotRadio: "w-full",
        contentInner: "",
        content: "flex items-center",
        label: "font-medium",
        labelChecked: "font-bold text-green-900 dark:text-white",
        labelUnchecked: "font-normal text-gray-900 dark:text-white",
        description: "inline",
        descriptionChecked: "text-green-700 dark:text-gray-200",
        descriptionUnchecked: "text-gray-500 dark:text-gray-400"
      }
    },
    orange: {
      classes: {
        disabled: "",
        option: "relative flex px-5 py-4 cursor-pointer focus:outline-none",
        checked: "bg-orange-100 dark:bg-orange-500/30 text-orange-700 border-orange-200 dark:border-orange-500 z-10",
        unchecked: "bg-white dark:bg-gray-900",
        highlighted: "ring-2 ring-offset-2 ring-offset-white dark:ring-offset-gray-900 ring-orange-600 border border-orange-200 dark:bg-orange-500 dark:border-orange-500 z-10",
        nonHighlighted: "border border-gray-200 dark:border-gray-700",
        separated: "rounded-lg",
        firstItem: "",
        lastItem: "",
        compact: "",
        nonCompact: "",
        radio: "h-4 w-4 mt-1 cursor-pointer rounded-full border flex items-center justify-center",
        radioHighlighted: "ring-orange-500",
        radioChecked: "bg-orange-600 border-transparent dark:bg-orange-700 ring-offset-white dark:ring-offset-gray-90",
        radioUnchecked: "bg-white dark:bg-gray-700 border-gray-300",
        radioInner: "rounded-full bg-white w-1.5 h-1.5",
        checkedIconWrapper: "flex-shrink-0",
        checkedIcon: "w-6 h-6",
        checkedIconOpacity: "fill-opacity-90 dark:fill-opacity-30 fill-orange-300 dark:fill-[#fff]",
        contentWrapper: "ml-3 flex items-center justify-between text-sm",
        contentWrapperIfNotRadio: "w-full",
        contentInner: "",
        content: "flex items-center",
        label: "font-medium",
        labelChecked: "font-bold text-orange-900 dark:text-white",
        labelUnchecked: "font-normal text-gray-900 dark:text-white",
        description: "inline",
        descriptionChecked: "text-orange-700 dark:text-gray-200",
        descriptionUnchecked: "text-gray-500 dark:text-gray-400"
      }
    },
    purple: {
      classes: {
        disabled: "",
        option: "relative flex px-5 py-4 cursor-pointer focus:outline-none",
        checked: "bg-purple-100 dark:bg-purple-500/30 text-purple-700 border-purple-200 dark:border-purple-500 z-10",
        unchecked: "bg-white dark:bg-gray-900",
        highlighted: "ring-2 ring-offset-2 ring-offset-white dark:ring-offset-gray-900 ring-purple-600 border border-purple-200 dark:bg-purple-500 dark:border-purple-500 z-10",
        nonHighlighted: "border border-gray-200 dark:border-gray-700",
        separated: "rounded-lg",
        firstItem: "",
        lastItem: "",
        compact: "",
        nonCompact: "",
        radio: "h-4 w-4 mt-1 cursor-pointer rounded-full border flex items-center justify-center",
        radioHighlighted: "ring-purple-500",
        radioChecked: "bg-purple-600 border-transparent dark:bg-purple-700 ring-offset-white dark:ring-offset-gray-90",
        radioUnchecked: "bg-white dark:bg-gray-700 border-gray-300",
        radioInner: "rounded-full bg-white w-1.5 h-1.5",
        checkedIconWrapper: "flex-shrink-0",
        checkedIcon: "w-6 h-6",
        checkedIconOpacity: "fill-opacity-90 dark:fill-opacity-30 fill-purple-300 dark:fill-[#fff]",
        contentWrapper: "ml-3 flex items-center justify-between text-sm",
        contentWrapperIfNotRadio: "w-full",
        contentInner: "",
        content: "flex items-center",
        label: "font-medium",
        labelChecked: "font-bold text-purple-900 dark:text-white",
        labelUnchecked: "font-normal text-gray-900 dark:text-white",
        description: "inline",
        descriptionChecked: "text-purple-700 dark:text-gray-200",
        descriptionUnchecked: "text-gray-500 dark:text-gray-400"
      }
    }
  }
};
const richRadioOptionClassesKeys = Object.keys(richRadioOptionConfig.classes);

const _hoisted_1$8 = ["innerHTML"];
const _hoisted_2$6 = /* @__PURE__ */ createElementVNode("path", {
  d: "M7 13l3 3 7-7",
  stroke: "#fff",
  "stroke-width": "1.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1);
const __default__$9 = {
  name: "VanillaRichRadioOption",
  inheritAttrs: false
};
const _sfc_main$9 = /* @__PURE__ */ defineComponent({
  ...__default__$9,
  props: {
    ...useVariantProps$1(),
    radio: {
      type: Boolean,
      default: false
    },
    checked: {
      type: Boolean,
      default: false
    },
    active: {
      type: Boolean,
      default: false
    },
    option: {
      type: [Array, Object, void 0],
      required: true
    },
    compact: {
      type: Boolean,
      default: false
    },
    separated: {
      type: Boolean,
      default: false
    },
    optionIndex: {
      type: [Number, void 0],
      default: void 0
    },
    totalOptions: {
      type: [Number],
      default: void 0
    },
    disabled: {
      type: [Boolean, String],
      default: false
    }
  },
  setup(__props) {
    const { configuration } = useConfiguration(richRadioOptionConfig, "RichRadioOption");
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass([
          unref(configuration).classesList?.option,
          __props.compact ? unref(configuration).classesList?.compact : unref(configuration).classesList?.nonCompact,
          __props.separated ? unref(configuration).classesList?.separated : "",
          !__props.separated && __props.optionIndex === 0 ? unref(configuration).classesList?.firstItem : "",
          !__props.separated && __props.optionIndex === __props.totalOptions - 1 ? unref(configuration).classesList?.lastItem : "",
          __props.checked ? unref(configuration).classesList?.checked : unref(configuration).classesList?.unchecked,
          __props.active ? unref(configuration).classesList?.highlighted : unref(configuration).classesList?.nonHighlighted,
          __props.disabled ? unref(configuration).classesList?.disabled : ""
        ])
      }, [
        renderSlot(_ctx.$slots, "radioIcon", normalizeProps(guardReactiveProps({ checked: __props.checked })), () => [
          __props.radio ? (openBlock(), createElementBlock("span", {
            key: 0,
            class: normalizeClass([
              unref(configuration).classesList?.radio,
              __props.active ? unref(configuration).classesList?.radioHighlighted : "",
              __props.checked ? unref(configuration).classesList?.radioChecked : unref(configuration).classesList?.radioUnchecked
            ]),
            "aria-hidden": "true"
          }, [
            createElementVNode("span", {
              class: normalizeClass(unref(configuration).classesList?.radioInner)
            }, null, 2)
          ], 2)) : createCommentVNode("", true)
        ]),
        createElementVNode("div", {
          class: normalizeClass([
            unref(configuration).classesList?.contentWrapper,
            !__props.radio ? unref(configuration).classesList?.contentWrapperIfNotRadio : ""
          ])
        }, [
          renderSlot(_ctx.$slots, "default", normalizeProps(guardReactiveProps({ checked: __props.checked, option: __props.option })), () => [
            createElementVNode("div", {
              class: normalizeClass(unref(configuration).classesList?.content)
            }, [
              createElementVNode("div", {
                class: normalizeClass(unref(configuration).classesList?.contentInner)
              }, [
                renderSlot(_ctx.$slots, "label", normalizeProps(guardReactiveProps({ checked: __props.checked, option: __props.option })), () => [
                  createVNode(unref(RadioGroupLabel), {
                    as: "div",
                    class: normalizeClass([
                      __props.checked ? unref(configuration).classesList?.labelChecked : unref(configuration).classesList?.labelUnchecked,
                      unref(configuration).classesList?.label
                    ])
                  }, {
                    default: withCtx(() => [
                      renderSlot(_ctx.$slots, "labelText", normalizeProps(guardReactiveProps({ checked: __props.checked, option: __props.option })), () => [
                        createTextVNode(toDisplayString(__props.option.text), 1)
                      ])
                    ]),
                    _: 3
                  }, 8, ["class"])
                ]),
                renderSlot(_ctx.$slots, "description", normalizeProps(guardReactiveProps({ checked: __props.checked, option: __props.option })), () => [
                  __props.option?.raw?.description && !__props.compact ? (openBlock(), createBlock(unref(RadioGroupDescription), {
                    key: 0,
                    as: "span",
                    class: normalizeClass([
                      unref(configuration).classesList?.description,
                      __props.checked ? unref(configuration).classesList?.descriptionChecked : unref(configuration).classesList?.descriptionUnchecked
                    ])
                  }, {
                    default: withCtx(() => [
                      renderSlot(_ctx.$slots, "descriptionText", normalizeProps(guardReactiveProps({ checked: __props.checked, option: __props.option, description: __props.option?.raw?.description })), () => [
                        createElementVNode("span", {
                          innerHTML: __props.option?.raw?.description
                        }, null, 8, _hoisted_1$8)
                      ])
                    ]),
                    _: 3
                  }, 8, ["class"])) : createCommentVNode("", true)
                ])
              ], 2)
            ], 2)
          ]),
          withDirectives(createElementVNode("div", {
            class: normalizeClass(unref(configuration).classesList?.checkedIconWrapper)
          }, [
            renderSlot(_ctx.$slots, "svgIcon", normalizeProps(guardReactiveProps({ checked: __props.checked })), () => [
              (openBlock(), createElementBlock("svg", {
                class: normalizeClass(unref(configuration).classesList?.checkedIcon),
                viewBox: "0 0 24 24",
                fill: "none"
              }, [
                createElementVNode("circle", {
                  cx: "12",
                  cy: "12",
                  r: "12",
                  class: normalizeClass(unref(configuration).classesList?.checkedIconOpacity)
                }, null, 2),
                _hoisted_2$6
              ], 2))
            ])
          ], 2), [
            [vShow, __props.checked && !__props.radio]
          ])
        ], 2)
      ], 2);
    };
  }
});

const richRadioConfig = {
  fixedClasses: {
    container: "relative flex-1",
    optionContainer: "rounded-lg",
    optionContainerSeparated: "space-y-2",
    optionContainerNonSeparated: "-space-y-px",
    optionWrapper: "outline-none focus:outline-none"
  },
  // Default Input appearance
  classes: {
    wrapper: "",
    container: "",
    optionContainer: "",
    optionContainerSeparated: "",
    optionContainerNonSeparated: "",
    optionWrapper: ""
  },
  // Variants
  variants: {
    // Used for Errors
    error: {
      classes: {
        wrapper: "",
        container: "",
        optionContainer: "",
        optionContainerSeparated: "",
        optionContainerNonSeparated: "",
        optionWrapper: ""
      }
    }
  }
};
const richRadioClassesKeys = Object.keys(richRadioConfig.classes);

const __default__$8 = {
  name: "VanillaRichRadio",
  inheritAttrs: false
};
const _sfc_main$8 = /* @__PURE__ */ defineComponent({
  ...__default__$8,
  props: {
    ...useVariantProps$1(),
    modelValue: {
      type: [String, Number, Boolean, Array, Object, Date, Function, Symbol],
      default: void 0
    },
    disabled: {
      type: Boolean,
      default: false
    },
    options: {
      type: [Array, Object],
      default: void 0
    },
    normalizeOptions: {
      type: Boolean,
      default: true
    },
    valueAttribute: {
      type: String,
      default: "value"
    },
    textAttribute: {
      type: String,
      default: "text"
    },
    separated: {
      type: Boolean,
      default: true
    },
    allowEmpty: {
      type: Boolean,
      default: false
    },
    radio: {
      type: Boolean,
      default: true
    },
    compact: {
      type: Boolean,
      default: false
    }
  },
  emits: ["update:modelValue", "focus", "focusout", "click"],
  setup(__props, { emit }) {
    const props = __props;
    const localValue = useVModel(props, "modelValue");
    const { configuration, errors, hasErrors, variant } = useConfiguration(richRadioConfig, "RichRadio", localValue);
    const normalizedOptions = normalizeOptions$1(
      props.options,
      props.textAttribute,
      props.valueAttribute
    );
    const triggerClicks = ref(0);
    const selectedOption = ref(void 0);
    const onModelUpdated = (value) => {
      if (props.disabled) {
        return;
      }
      localValue.value = value;
    };
    const onClickOption = (option) => {
      if (props.disabled || option.disabled) {
        return;
      }
      if (!props.allowEmpty) {
        return;
      }
      if (selectedOption.value && selectedOption.value.value === option.value) {
        selectedOption.value = void 0;
        triggerClicks.value = 0;
        localValue.value = void 0;
      } else {
        selectedOption.value = option;
        triggerClicks.value = 1;
        localValue.value = option.value;
      }
      emit("click", option);
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(["vanilla-input", unref(configuration).classesList?.wrapper])
      }, [
        createVNode(unref(RadioGroup), {
          "model-value": unref(localValue),
          class: normalizeClass(unref(configuration).classesList?.container),
          disabled: __props.disabled,
          "onUpdate:modelValue": onModelUpdated
        }, {
          default: withCtx(() => [
            createElementVNode("div", {
              class: normalizeClass([
                unref(configuration).classesList?.optionContainer,
                __props.separated ? unref(configuration).classesList?.optionContainerSeparated : unref(configuration).classesList?.optionContainerNonSeparated
              ])
            }, [
              (openBlock(true), createElementBlock(Fragment, null, renderList(unref(normalizedOptions), (option, index) => {
                return openBlock(), createBlock(unref(RadioGroupOption), {
                  key: option.value.toString(),
                  as: "div",
                  value: option.value,
                  disabled: __props.disabled || option?.disabled || false,
                  class: normalizeClass(unref(configuration).classesList?.optionWrapper),
                  onClick: ($event) => onClickOption(option),
                  onFocus: _cache[2] || (_cache[2] = ($event) => _ctx.$emit("focus", $event)),
                  onFocusout: _cache[3] || (_cache[3] = ($event) => _ctx.$emit("focusout", $event))
                }, {
                  default: withCtx(({ active, checked }) => [
                    renderSlot(_ctx.$slots, "option", normalizeProps(guardReactiveProps({
                      option,
                      active,
                      checked,
                      index,
                      totalOptions: unref(normalizeOptions$1).length,
                      separated: __props.separated,
                      radio: __props.radio,
                      variant: unref(variant),
                      disabled: option.disabled || false
                    })), () => [
                      createVNode(_sfc_main$9, mergeProps({
                        option,
                        active,
                        checked: checked && unref(localValue) === option.value,
                        "option-index": index,
                        "total-options": unref(normalizedOptions).length,
                        separated: __props.separated,
                        compact: __props.compact,
                        radio: __props.radio,
                        variant: unref(variant),
                        "variant-error": _ctx.variantError
                      }, _ctx.$attrs, {
                        disabled: __props.disabled || option?.disabled || false,
                        onFocus: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("focus", $event)),
                        onFocusout: _cache[1] || (_cache[1] = ($event) => _ctx.$emit("focusout", $event))
                      }), {
                        radioIcon: withCtx(() => [
                          renderSlot(_ctx.$slots, "radioIcon", normalizeProps(guardReactiveProps({ option, active, checked, index, compact: __props.compact, radio: __props.radio })))
                        ]),
                        label: withCtx(() => [
                          renderSlot(_ctx.$slots, "label", normalizeProps(guardReactiveProps({ option, active, checked, index, compact: __props.compact, radio: __props.radio })))
                        ]),
                        labelText: withCtx(() => [
                          renderSlot(_ctx.$slots, "labelText", normalizeProps(guardReactiveProps({ option, active, checked, index, compact: __props.compact, radio: __props.radio })))
                        ]),
                        description: withCtx(() => [
                          renderSlot(_ctx.$slots, "description", normalizeProps(guardReactiveProps({ option, active, checked, index, compact: __props.compact, radio: __props.radio })))
                        ]),
                        descriptionText: withCtx(() => [
                          renderSlot(_ctx.$slots, "descriptionText", normalizeProps(guardReactiveProps({ option, active, checked, index, compact: __props.compact, radio: __props.radio })))
                        ]),
                        svgIcon: withCtx(() => [
                          renderSlot(_ctx.$slots, "svgIcon", normalizeProps(guardReactiveProps({ option, active, checked, index, compact: __props.compact, radio: __props.radio })))
                        ]),
                        _: 2
                      }, 1040, ["option", "active", "checked", "option-index", "total-options", "separated", "compact", "radio", "variant", "variant-error", "disabled"])
                    ])
                  ]),
                  _: 2
                }, 1032, ["value", "disabled", "class", "onClick"]);
              }), 128))
            ], 2)
          ]),
          _: 3
        }, 8, ["model-value", "class", "disabled"]),
        renderSlot(_ctx.$slots, "errors", normalizeProps(guardReactiveProps({ hasErrors: unref(hasErrors), errors: unref(errors) })), () => [
          unref(hasErrors) && props.showErrors ? (openBlock(), createBlock(_sfc_main$Z, {
            key: 0,
            errors: unref(errors)
          }, null, 8, ["errors"])) : createCommentVNode("", true)
        ]),
        renderSlot(_ctx.$slots, "feedback", normalizeProps(guardReactiveProps({ hasErrors: unref(hasErrors), feedback: _ctx.feedback })), () => [
          !unref(hasErrors) && props.feedback && props.showFeedback ? (openBlock(), createBlock(_sfc_main$Y, {
            key: 0,
            text: props.feedback
          }, null, 8, ["text"])) : createCommentVNode("", true)
        ])
      ], 2);
    };
  }
});

const richSelectOptionWithImageConfig = {
  classes: {
    wrapper: "relative group",
    disabled: commonClasses.optionOrItemDisabled,
    labelAndImageWrapper: "relative",
    labelAndImageContainer: "flex items-center space-x-2 text-sm block",
    labelAndImageContainerSelected: "font-semibold",
    labelAndImageContainerRegular: "font-normal",
    image: "flex-shrink-0 w-6 h-6 bg-gray-500 dark:bg-gray-800 bg-center bg-cover rounded-full border border-gray-300 dark:border-gray-500 shadow",
    label: "block whitespace-nowrap truncate",
    description: "w-100 text-xs text-left mt-1 truncate",
    descriptionSelected: "font-normal opacity-60",
    descriptionRegular: "opacity-60",
    selectedIconContainer: "absolute inset-y-0 right-0 flex items-center pl-3 pr-3 text-primary-600",
    icon: commonClasses.iconsSize
  }
};
const richSelectOptionWithImageClassesKeys = Object.keys(richSelectOptionWithImageConfig.classes);

const _hoisted_1$7 = ["innerHTML"];
const _hoisted_2$5 = ["innerHTML"];
const __default__$7 = {
  name: "VanillaRichSelectOptionWithImage",
  inheritAttrs: false
};
const _sfc_main$7 = /* @__PURE__ */ defineComponent({
  ...__default__$7,
  props: {
    ...useVariantProps$1(),
    name: {
      type: String,
      default: void 0
    },
    image: {
      type: String,
      default: void 0
    },
    selected: {
      type: Boolean,
      default: false
    },
    description: {
      type: [String],
      default: void 0
    },
    hasErrors: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    parentClasses: {
      type: [String, Array],
      default: ""
    }
  },
  setup(__props) {
    const { configuration } = useConfiguration(richSelectOptionWithImageConfig, "RichSelectOptionWithImage");
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", mergeProps(_ctx.$attrs, {
        class: [
          __props.parentClasses,
          unref(configuration).classesList.wrapper,
          __props.disabled ? unref(configuration).classesList.disabled : ""
        ]
      }), [
        createElementVNode("div", {
          class: normalizeClass([unref(configuration).classesList.labelAndImageWrapper])
        }, [
          createElementVNode("div", {
            class: normalizeClass([
              __props.selected ? unref(configuration).classesList.labelAndImageContainerSelected : "",
              !__props.selected ? unref(configuration).classesList.labelAndImageContainerRegular : "",
              unref(configuration).classesList.labelAndImageContainer
            ])
          }, [
            createElementVNode("div", {
              class: normalizeClass([
                unref(configuration).classesList.image
              ]),
              style: normalizeStyle({
                backgroundImage: `url(${__props.image})`
              })
            }, null, 6),
            createElementVNode("span", {
              class: normalizeClass([
                unref(configuration).classesList.label
              ]),
              innerHTML: __props.name
            }, null, 10, _hoisted_1$7)
          ], 2)
        ], 2),
        __props.description ? (openBlock(), createElementBlock("p", {
          key: 0,
          class: normalizeClass([
            unref(configuration).classesList.description,
            __props.selected ? unref(configuration).classesList.descriptionSelected : "",
            !__props.selected ? unref(configuration).classesList.descriptionRegular : ""
          ]),
          innerHTML: __props.description
        }, null, 10, _hoisted_2$5)) : createCommentVNode("", true),
        __props.selected ? (openBlock(), createElementBlock("span", {
          key: 1,
          class: normalizeClass([unref(configuration).classesList.selectedIconContainer])
        }, [
          renderSlot(_ctx.$slots, "selectedIcon", {}, () => [
            createVNode(unref(CheckIcon$1), {
              "aria-hidden": "true",
              class: normalizeClass([unref(configuration).classesList.icon])
            }, null, 8, ["class"])
          ])
        ], 2)) : createCommentVNode("", true)
      ], 16);
    };
  }
});

const richSelectOptionWithIndicatorsConfig = {
  classes: {
    wrapper: "relative group",
    disabled: commonClasses.optionOrItemDisabled,
    labelAndImageWrapper: "relative",
    labelAndImageContainer: "flex items-center space-x-2 text-sm block",
    labelAndImageContainerSelected: "font-semibold",
    labelAndImageContainerRegular: "font-normal",
    indicator: "flex-shrink-0 inline-block h-2 w-2 rounded-full",
    label: "block whitespace-nowrap truncate",
    description: "w-100 text-xs text-left mt-1",
    descriptionSelected: "font-normal opacity-60",
    descriptionRegular: "opacity-60",
    selectedIconContainer: "absolute inset-y-0 right-0 flex items-center pl-3 pr-3 text-primary-600",
    icon: commonClasses.iconsSize,
    indicatorGreen: "bg-green-400",
    indicatorGray: "bg-gray-200",
    indicatorRed: "bg-red-400",
    indicatorYellow: "bg-yellow-400",
    indicatorBlue: "bg-blue-400"
  }
};
const richSelectOptionWithIndicatorsClassesKeys = Object.keys(richSelectOptionWithIndicatorsConfig.classes);

const _hoisted_1$6 = ["innerHTML"];
const _hoisted_2$4 = ["innerHTML"];
const __default__$6 = {
  name: "VanillaRichSelectOptionWithIndicator",
  inheritAttrs: false
};
const _sfc_main$6 = /* @__PURE__ */ defineComponent({
  ...__default__$6,
  props: {
    name: {
      type: String,
      default: void 0
    },
    status: {
      type: String,
      required: true
    },
    selected: {
      type: Boolean,
      default: false
    },
    description: {
      type: [String],
      default: void 0
    },
    hasErrors: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    parentClasses: {
      type: [String, Array],
      default: ""
    }
  },
  setup(__props) {
    const props = __props;
    const { configuration } = useConfiguration(richSelectOptionWithIndicatorsConfig, "RichSelectOptionWithIndicators");
    const indicatorClass = computed(() => {
      return {
        green: configuration.classesList?.indicatorGreen,
        gray: configuration.classesList?.indicatorGray,
        red: configuration.classesList?.indicatorRed,
        yellow: configuration.classesList?.indicatorYellow,
        blue: configuration.classesList?.indicatorBlue
      }[props.status];
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass([
          __props.parentClasses,
          unref(configuration).classesList.wrapper,
          __props.disabled ? unref(configuration).classesList.disabled : ""
        ])
      }, [
        createElementVNode("div", {
          class: normalizeClass([unref(configuration).classesList.labelAndImageWrapper])
        }, [
          createElementVNode("div", {
            class: normalizeClass([
              __props.selected ? unref(configuration).classesList.labelAndImageContainerSelected : "",
              !__props.selected ? unref(configuration).classesList.labelAndImageContainerRegular : "",
              unref(configuration).classesList.labelAndImageContainer
            ])
          }, [
            createElementVNode("span", {
              class: normalizeClass([
                unref(configuration).classesList.indicator,
                unref(indicatorClass)
              ]),
              "aria-hidden": "true"
            }, null, 2),
            createElementVNode("span", {
              class: normalizeClass([
                unref(configuration).classesList.label
              ]),
              innerHTML: __props.name
            }, null, 10, _hoisted_1$6)
          ], 2)
        ], 2),
        __props.description ? (openBlock(), createElementBlock("div", {
          key: 0,
          class: normalizeClass([
            unref(configuration).classesList.description,
            __props.selected ? unref(configuration).classesList.descriptionSelected : "",
            !__props.selected ? unref(configuration).classesList.descriptionRegular : ""
          ]),
          innerHTML: __props.description
        }, null, 10, _hoisted_2$4)) : createCommentVNode("", true),
        __props.selected ? (openBlock(), createElementBlock("span", {
          key: 1,
          class: normalizeClass([unref(configuration).classesList.selectedIconContainer])
        }, [
          renderSlot(_ctx.$slots, "selectedIcon", {}, () => [
            createVNode(unref(CheckIcon$1), {
              "aria-hidden": "true",
              class: normalizeClass([unref(configuration).classesList.icon])
            }, null, 8, ["class"])
          ])
        ], 2)) : createCommentVNode("", true)
      ], 2);
    };
  }
});

const richSelectTagWithImageConfig = {
  classes: {
    wrapper: "relative group",
    disabled: commonClasses.optionOrItemDisabled,
    labelAndImageWrapper: "relative",
    labelAndImageContainer: "flex items-center space-x-2 text-sm block",
    labelAndImageContainerSelected: "font-semibold",
    labelAndImageContainerRegular: "font-normal",
    image: "flex-shrink-0 w-6 h-6 bg-gray-500 dark:bg-gray-800 bg-center bg-cover rounded-full border border-gray-300 dark:border-gray-500 shadow",
    label: "block whitespace-nowrap truncate font-semibold"
  }
};
const richSelectTagWithImageClassesKeys = Object.keys(richSelectTagWithImageConfig.classes);

const _hoisted_1$5 = ["innerHTML"];
const __default__$5 = {
  name: "VanillaRichSelectOptionTagWithImage",
  inheritAttrs: true
};
const _sfc_main$5 = /* @__PURE__ */ defineComponent({
  ...__default__$5,
  props: {
    name: {
      type: String,
      default: void 0
    },
    image: {
      type: String,
      required: true
    },
    selected: {
      type: Boolean,
      default: false
    },
    description: {
      type: [String],
      default: void 0
    },
    hasErrors: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    parentClasses: {
      type: [String, Array],
      default: ""
    }
  },
  setup(__props) {
    const { configuration } = useConfiguration(richSelectTagWithImageConfig, "RichSelectTagWithImage");
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass([
          __props.parentClasses,
          unref(configuration).classesList.wrapper,
          __props.disabled ? unref(configuration).classesList.disabled : ""
        ])
      }, [
        createElementVNode("div", {
          class: normalizeClass([unref(configuration).classesList.labelAndImageWrapper])
        }, [
          createElementVNode("div", {
            class: normalizeClass([
              __props.selected ? unref(configuration).classesList.labelAndImageContainerSelected : "",
              !__props.selected ? unref(configuration).classesList.labelAndImageContainerRegular : "",
              unref(configuration).classesList.labelAndImageContainer
            ])
          }, [
            createElementVNode("div", {
              class: normalizeClass([
                unref(configuration).classesList.image
              ]),
              style: normalizeStyle({
                backgroundImage: `url(${__props.image})`
              })
            }, null, 6),
            createElementVNode("span", {
              class: normalizeClass([
                unref(configuration).classesList.label
              ]),
              innerHTML: __props.name
            }, null, 10, _hoisted_1$5)
          ], 2)
        ], 2)
      ], 2);
    };
  }
});

const slideoverConfig = {
  fixedClasses: {},
  // Default appearance
  classes: {
    wrapper: "absolute inset-0 z-30 overflow-hidden",
    overlay: "fixed inset-0 transition-opacity bg-gray-700/50 dark:bg-gray-700/50 backdrop-blur-sm",
    innerLeft: "fixed inset-y-0 left-0 pr-10 max-w-full flex ",
    innerRight: "fixed inset-y-0 right-0 pl-10 max-w-full flex",
    innerTop: "fixed inset-x-0 pb-10 max-w-full flex",
    innerBottom: "fixed bottom-0 pt-10 max-w-full flex",
    slideover: "pointer-events-auto w-screen mx-auto",
    slideoverContainer: "flex h-full flex-col bg-white dark:bg-gray-800 shadow-xl overflow-y-auto",
    slideOverContainerWithPadding: "py-6",
    sizeWidthDefault: "max-w-sm",
    sizeWidthSmall: "max-w-xs",
    sizeWidthMedium: "max-w-md",
    sizeWidthLarge: "max-w-lg",
    sizeWidthExtraLarge: "max-w-2xl",
    sizeWidthFull: " w-full",
    sizeHeightDefault: "max-h-sm",
    sizeHeightSmall: "max-h-xs",
    sizeHeightMedium: "max-h-md",
    sizeHeightLarge: "max-h-lg",
    sizeHeightExtraLarge: "max-h-2xl",
    sizeHeightFull: " h-full",
    // Body
    body: "relative flex-1",
    bodyWithPadding: "px-4 sm:px-6",
    bodyWithTitle: "mt-6",
    // Close button
    closeButtonContainer: "flex h-7 items-center",
    // closeButton: 'rounded-md bg-white dark:bg-gray-800 text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2',
    closeButton: mergeClasses(
      commonClasses.buttonRadius,
      commonClasses.buttonText,
      commonClasses.buttonRing,
      "focus:ring-primary-600",
      "text-gray-700 focus:text-gray-600 dark:text-white dark:hover:text-white",
      "bg-white dark:bg-gray-700",
      "p-0.5 hover:text-gray-500 dark:hover:text-gray-300"
    ),
    closeButtonIcon: "h-6 w-6",
    // Title
    titleContainer: "flex items-start justify-between space-x-3",
    titleWrapper: "px-4 sm:px-6",
    titleInner: "space-y-1",
    titleText: "text-lg font-medium text-gray-900 dark:text-white",
    // Subtitle
    subtitle: "text-sm text-gray-500 dark:text-gray-400",
    // Transition backdrop
    overlayEnter: "duration-300 ease-out",
    overlayEnterFrom: "opacity-0",
    overlayEnterTo: "opacity-100",
    overlayLeave: "duration-200 ease-in",
    overlayLeaveFrom: "opacity-100",
    overlayLeaveTo: "opacity-0",
    // Transition for Modal from left
    dialogLeftEnter: "transform transition ease-in-out duration-500 sm:duration-700",
    dialogLeftEnterFrom: "-translate-x-full",
    dialogLeftEnterTo: "translate-x-0",
    dialogLeftLeave: "transform transition ease-in-out duration-500 sm:duration-700",
    dialogLeftLeaveFrom: "translate-x-0",
    dialogLeftLeaveTo: "-translate-x-full",
    // Transition for Modal from left
    dialogRightEnter: "transform transition ease-in-out duration-500 sm:duration-700",
    dialogRightEnterFrom: "translate-x-full",
    dialogRightEnterTo: "translate-x-0",
    dialogRightLeave: "transform transition ease-in-out duration-500 sm:duration-700",
    dialogRightLeaveFrom: "translate-x-0",
    dialogRightLeaveTo: "translate-x-full",
    // Transition for Modal from Top
    dialogTopEnter: "transform transition ease-in-out duration-500 sm:duration-700",
    dialogTopEnterFrom: "-translate-y-full",
    dialogTopEnterTo: "translate-y-0",
    dialogTopLeave: "transform transition ease-in-out duration-500 sm:duration-700",
    dialogTopLeaveFrom: "translate-y-0",
    dialogTopLeaveTo: "-translate-y-full",
    // Transition for Modal from Bottom
    dialogBottomEnter: "transform transition ease-in-out duration-500 sm:duration-700",
    dialogBottomEnterFrom: "translate-y-full",
    dialogBottomEnterTo: "translate-y-0",
    dialogBottomLeave: "transform transition ease-in-out duration-500 sm:duration-700",
    dialogBottomLeaveFrom: "translate-y-0",
    dialogBottomLeaveTo: "translate-y-full"
  }
};
const slideoverClassesKeys = Object.keys(slideoverConfig.classes);

const _hoisted_1$4 = {
  viewBox: "0 0 24 24",
  width: "1.2em",
  height: "1.2em"
};
const _hoisted_2$3 = /*#__PURE__*/createElementVNode("path", {
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.5",
  d: "M6 18L18 6M6 6l12 12"
}, null, -1);
const _hoisted_3$1 = [
  _hoisted_2$3
];

function render(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$4, _hoisted_3$1))
}

const XMarkIcon = { name: 'heroicons-x-mark', render };
/* vite-plugin-components disabled */

const _hoisted_1$3 = ["textContent"];
const _hoisted_2$2 = /* @__PURE__ */ createElementVNode("span", { class: "sr-only" }, "Close", -1);
const __default__$4 = {
  name: "VanillaSlideover",
  inheritAttrs: false
};
const _sfc_main$4 = /* @__PURE__ */ defineComponent({
  ...__default__$4,
  props: {
    ...useVariantProps$1(),
    modelValue: {
      type: [Boolean],
      default: false
    },
    title: {
      type: [String],
      default: void 0
    },
    subtitle: {
      type: [String],
      default: void 0
    },
    teleport: {
      type: Boolean,
      default: true
    },
    teleportTo: {
      type: [String, Object],
      default: "body"
    },
    overlay: {
      type: Boolean,
      default: false
    },
    closeable: {
      type: Boolean,
      default: true
    },
    closeableOnClickOutside: {
      type: Boolean,
      default: true
    },
    closeableOnPressEscape: {
      type: Boolean,
      default: true
    },
    paddingOnBody: {
      type: Boolean,
      default: true
    },
    paddingOnContainer: {
      type: Boolean,
      default: true
    },
    showHeader: {
      type: Boolean,
      default: true
    },
    as: {
      type: [String],
      default: "div"
    },
    position: {
      type: [String],
      required: false,
      default: "right",
      validator(position) {
        return ["left", "right", "top", "bottom"].includes(position);
      }
    },
    size: {
      type: [String],
      required: false,
      default: "medium",
      validator(align) {
        return ["default", "small", "medium", "large", "extraLarge", "full"].includes(align);
      }
    }
  },
  emits: [
    "update:modelValue",
    "open",
    "close",
    "opening",
    "opened",
    "closing",
    "closed"
  ],
  setup(__props, { expose, emit }) {
    const props = __props;
    const localValue = useVModel(props, "modelValue");
    const { configuration } = useConfiguration(slideoverConfig, "Slideover", localValue);
    const close = () => {
      setTimeout(() => {
        localValue.value = false;
        emit("close");
      }, 50);
    };
    const open = () => {
      localValue.value = true;
      emit("open");
    };
    const emitTransitionEvent = (event) => emit(event);
    const closeOnClickOutside = () => props.closeableOnClickOutside && close();
    const innerClasses = computed(() => {
      return {
        right: configuration.classesList.innerRight,
        left: configuration.classesList.innerLeft,
        top: configuration.classesList.innerTop,
        bottom: configuration.classesList.innerBottom
      }[props.position];
    });
    const enterClass = computed(() => {
      return {
        right: configuration.classesList.dialogRightEnter,
        left: configuration.classesList.dialogLeftEnter,
        top: configuration.classesList.dialogTopEnter,
        bottom: configuration.classesList.dialogBottomEnter
      }[props.position];
    });
    const enterFromClass = computed(() => {
      return {
        right: configuration.classesList.dialogRightEnterFrom,
        left: configuration.classesList.dialogLeftEnterFrom,
        top: configuration.classesList.dialogTopEnterFrom,
        bottom: configuration.classesList.dialogBottomEnterFrom
      }[props.position];
    });
    const enterToClass = computed(() => {
      return {
        right: configuration.classesList.dialogRightEnterTo,
        left: configuration.classesList.dialogLeftEnterTo,
        top: configuration.classesList.dialogTopEnterTo,
        bottom: configuration.classesList.dialogBottomEnterTo
      }[props.position];
    });
    const leaveClass = computed(() => {
      return {
        right: configuration.classesList.dialogRightLeave,
        left: configuration.classesList.dialogLeftLeave,
        top: configuration.classesList.dialogTopLeave,
        bottom: configuration.classesList.dialogBottomLeave
      }[props.position];
    });
    const leaveFromClass = computed(() => {
      return {
        right: configuration.classesList.dialogRightLeaveFrom,
        left: configuration.classesList.dialogLeftLeaveFrom,
        top: configuration.classesList.dialogTopLeaveFrom,
        bottom: configuration.classesList.dialogBottomLeaveFrom
      }[props.position];
    });
    const leaveToClass = computed(() => {
      return {
        right: configuration.classesList.dialogRightLeaveTo,
        left: configuration.classesList.dialogLeftLeaveTo,
        top: configuration.classesList.dialogTopLeaveTo,
        bottom: configuration.classesList.dialogBottomLeaveTo
      }[props.position];
    });
    const sizeClass = computed(() => {
      if (props.position === "right" || props.position === "left") {
        return {
          default: configuration.classesList.sizeWidthDefault,
          small: configuration.classesList.sizeWidthSmall,
          medium: configuration.classesList.sizeWidthMedium,
          large: configuration.classesList.sizeWidthLarge,
          extraLarge: configuration.classesList.sizeWidthExtraLarge,
          full: configuration.classesList.sizeWidthFull
        }[props.size];
      }
      return {
        default: configuration.classesList.sizeHeightDefault,
        small: configuration.classesList.sizeHeightSmall,
        medium: configuration.classesList.sizeHeightMedium,
        large: configuration.classesList.sizeHeightLarge,
        extraLarge: configuration.classesList.sizeHeightExtraLarge,
        full: configuration.classesList.sizeHeightFull
      }[props.size];
    });
    expose({ open, close });
    provide("configuration_vanilla", configuration);
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(TransitionRoot), {
        show: unref(localValue),
        as: "div",
        onBeforeEnter: _cache[0] || (_cache[0] = ($event) => emitTransitionEvent("opening")),
        onAfterEnter: _cache[1] || (_cache[1] = ($event) => emitTransitionEvent("opened")),
        onBeforeLeave: _cache[2] || (_cache[2] = ($event) => emitTransitionEvent("closing")),
        onAfterLeave: _cache[3] || (_cache[3] = ($event) => emitTransitionEvent("closed"))
      }, {
        default: withCtx(() => [
          createVNode(unref(Dialog), {
            as: __props.as,
            "initial-focus": null,
            onClose: close
          }, {
            default: withCtx(() => [
              createElementVNode("div", {
                class: normalizeClass(unref(configuration).classesList.wrapper)
              }, [
                createVNode(unref(TransitionChild), {
                  as: "template",
                  enter: unref(configuration).classesList.overlayEnter,
                  "enter-from": unref(configuration).classesList.overlayEnterFrom,
                  "enter-to": unref(configuration).classesList.overlayEnterTo,
                  leave: unref(configuration).classesList.overlayLeave,
                  "leave-from": unref(configuration).classesList.overlayLeaveFrom,
                  "leave-to": unref(configuration).classesList.overlayLeaveTo
                }, {
                  default: withCtx(() => [
                    createVNode(unref(DialogOverlay), {
                      class: normalizeClass(unref(configuration).classesList.overlay),
                      onClick: closeOnClickOutside
                    }, null, 8, ["class"])
                  ]),
                  _: 1
                }, 8, ["enter", "enter-from", "enter-to", "leave", "leave-from", "leave-to"]),
                createElementVNode("div", {
                  class: normalizeClass(unref(innerClasses))
                }, [
                  createVNode(unref(TransitionChild), {
                    as: "template",
                    enter: unref(enterClass),
                    "enter-from": unref(enterFromClass),
                    "enter-to": unref(enterToClass),
                    leave: unref(leaveClass),
                    "leave-from": unref(leaveFromClass),
                    "leave-to": unref(leaveToClass)
                  }, {
                    default: withCtx(() => [
                      createElementVNode("div", {
                        class: normalizeClass([
                          unref(configuration).classesList.slideover,
                          unref(sizeClass)
                        ])
                      }, [
                        createElementVNode("div", {
                          class: normalizeClass([
                            unref(configuration).classesList.slideoverContainer,
                            __props.paddingOnContainer ? unref(configuration).classesList.slideOverContainerWithPadding : ""
                          ])
                        }, [
                          renderSlot(_ctx.$slots, "header", normalizeProps(guardReactiveProps({
                            showHeader: __props.showHeader,
                            title: __props.title,
                            subtitle: __props.subtitle,
                            close
                          })), () => [
                            __props.showHeader || unref(hasSlot)(_ctx.$slots.header) ? (openBlock(), createElementBlock("div", {
                              key: 0,
                              class: normalizeClass(unref(configuration).classesList.titleWrapper)
                            }, [
                              createElementVNode("div", {
                                class: normalizeClass(unref(configuration).classesList.titleContainer)
                              }, [
                                renderSlot(_ctx.$slots, "top", normalizeProps(guardReactiveProps({ title: __props.title, subtitle: __props.subtitle })), () => [
                                  createElementVNode("div", {
                                    class: normalizeClass(unref(configuration).classesList.titleInner)
                                  }, [
                                    renderSlot(_ctx.$slots, "title", normalizeProps(guardReactiveProps({ title: __props.title })), () => [
                                      createVNode(unref(DialogTitle), {
                                        class: normalizeClass(unref(configuration).classesList.titleText),
                                        textContent: toDisplayString(__props.title)
                                      }, null, 8, ["class", "textContent"])
                                    ]),
                                    renderSlot(_ctx.$slots, "subtitle", normalizeProps(guardReactiveProps({ subtitle: __props.subtitle })), () => [
                                      createElementVNode("p", {
                                        class: normalizeClass(unref(configuration).classesList.subtitle),
                                        textContent: toDisplayString(__props.subtitle)
                                      }, null, 10, _hoisted_1$3)
                                    ])
                                  ], 2)
                                ]),
                                __props.closeable ? (openBlock(), createElementBlock("div", {
                                  key: 0,
                                  class: normalizeClass(unref(configuration).classesList.closeButtonContainer)
                                }, [
                                  renderSlot(_ctx.$slots, "closeIcon", normalizeProps(guardReactiveProps({ closeable: __props.closeable, close })), () => [
                                    createElementVNode("button", {
                                      type: "button",
                                      class: normalizeClass(unref(configuration).classesList.closeButton),
                                      onClick: close
                                    }, [
                                      _hoisted_2$2,
                                      createVNode(unref(XMarkIcon), {
                                        class: normalizeClass(unref(configuration).classesList.closeButtonIcon),
                                        "aria-hidden": "true"
                                      }, null, 8, ["class"])
                                    ], 2)
                                  ])
                                ], 2)) : createCommentVNode("", true)
                              ], 2)
                            ], 2)) : createCommentVNode("", true)
                          ]),
                          createElementVNode("div", {
                            class: normalizeClass([
                              unref(configuration).classesList.body,
                              __props.paddingOnBody ? unref(configuration).classesList.bodyWithPadding : "",
                              __props.title !== void 0 ? unref(configuration).classesList.bodyWithTitle : ""
                            ])
                          }, [
                            renderSlot(_ctx.$slots, "default")
                          ], 2)
                        ], 2)
                      ], 2)
                    ]),
                    _: 3
                  }, 8, ["enter", "enter-from", "enter-to", "leave", "leave-from", "leave-to"])
                ], 2)
              ], 2)
            ]),
            _: 3
          }, 8, ["as"])
        ]),
        _: 3
      }, 8, ["show"]);
    };
  }
});

const statusIndicatorConfig = {
  fixedClasses: {
    wrapper: "relative",
    container: "flex h-3 w-3 flex-shrink-0",
    pulsing: "animate-ping absolute inline-flex h-full w-full rounded-full opacity-75",
    regular: "relative inline-flex rounded-full h-3 w-3",
    background: ""
  },
  classes: {
    wrapper: "",
    container: "",
    pulsing: "",
    regular: "",
    background: "bg-gray-500"
  },
  variants: {
    green: {
      classes: {
        background: "bg-green-500"
      }
    },
    indigo: {
      classes: {
        background: "bg-indigo-500"
      }
    },
    red: {
      classes: {
        background: "bg-red-500"
      }
    },
    blue: {
      classes: {
        background: "bg-blue-500"
      }
    },
    orange: {
      classes: {
        background: "bg-orange-500"
      }
    }
  }
};
const statusIndicatorClassesKeys = Object.keys(statusIndicatorConfig.classes);

const __default__$3 = {
  name: "VanillaStatusIndicator",
  inheritAttrs: false
};
const _sfc_main$3 = /* @__PURE__ */ defineComponent({
  ...__default__$3,
  props: {
    ...useVariantProps$1(),
    pulse: {
      type: [Boolean],
      default: true
    }
  },
  setup(__props) {
    const { configuration } = useConfiguration(statusIndicatorConfig, "StatusIndicator");
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(unref(configuration).classesList.wrapper)
      }, [
        createElementVNode("span", {
          class: normalizeClass(unref(configuration).classesList.container)
        }, [
          __props.pulse ? (openBlock(), createElementBlock("span", {
            key: 0,
            class: normalizeClass([
              unref(configuration).classesList.pulsing,
              unref(configuration).classesList.background
            ])
          }, null, 2)) : createCommentVNode("", true),
          createElementVNode("span", {
            class: normalizeClass([
              unref(configuration).classesList.regular,
              unref(configuration).classesList.background
            ])
          }, null, 2)
        ], 2)
      ], 2);
    };
  }
});

const tagsInputConfig = {
  fixedClasses: {
    input: mergeClasses(
      "appearance-none px-2 m-1 focus:ring-0 focus:outline-none focus:shadow-none w-full bg-transparent",
      commonClasses.inputsRadius
    ),
    inputWrapper: "inline-flex flex-grow",
    tagsWrapper: "flex flex-wrap overflow-hidden -my-2 py-1 w-full",
    tagDeleteButtonIcon: "w-3 h-3",
    tagLabel: "px-3"
  },
  classes: {
    input: "",
    inputWrapper: "",
    tagsWrapper: "",
    tagDeleteButtonIcon: "",
    tagLabel: "",
    tag: mergeClasses(
      "rounded shadow-sm flex items-center cursor-pointer",
      "bg-primary-100 dark:bg-primary-500/20 dark:border dark:border-gray-700",
      "m-0.5 h-8 max-w-full",
      "text-primary-900 dark:text-white white-space-no text-sm font-semibold",
      commonClasses.buttonRing,
      "focus:ring-opacity-50 focus:ring-primary-600",
      commonClasses.inputsTransition,
      commonClasses.inputsDisabled
    ),
    tagDeleteButton: mergeClasses(
      commonClasses.inputsTransition,
      commonClasses.buttonRing,
      "focus:ring-opacity-50 focus:ring-primary-600",
      "-ml-1.5 h-full hover:shadow-sm inline-flex items-center px-2 rounded-r",
      "text-primary-400 focus:text-white hover:text-primary-500 dark:hover:text-white",
      "hover:bg-primary-200 focus:bg-primary-500 dark:hover:bg-primary-400/20 dark:focus:bg-primary-500/20"
    ),
    trigger: mergeClasses(
      commonClasses.inputsBackground,
      commonClasses.inputsBorder,
      commonClasses.inputsRingBase,
      commonClasses.inputsRing,
      commonClasses.inputsText,
      commonClasses.inputsTransition,
      commonClasses.inputsShadows,
      commonClasses.inputsDisabled,
      commonClasses.inputsRadius,
      "px-2 py-3",
      "relative flex items-center w-full focus:z-10 cursor-pointer max-w-full w-full"
    )
  },
  // Variants
  variants: {
    // Used for Errors
    error: {
      classes: {
        input: mergeClasses(
          commonClasses.inputsErrorsRing,
          commonClasses.inputsErrorTextColor,
          commonClasses.inputsText
        ),
        inputWrapper: "",
        tagsWrapper: "",
        tagDeleteButtonIcon: "",
        tagLabel: "",
        tag: mergeClasses(
          "rounded shadow-sm flex items-center cursor-pointer",
          "bg-red-100 dark:bg-red-500/20 dark:border dark:border-gray-700",
          "m-0.5 h-8 max-w-full",
          "text-red-900 dark:text-red-300 white-space-no text-sm font-semibold",
          "focus:ring-opacity-50 focus:ring-red-600",
          commonClasses.buttonErrorsRing,
          commonClasses.inputsTransition,
          commonClasses.inputsDisabled
        ),
        tagDeleteButton: mergeClasses(
          commonClasses.inputsTransition,
          commonClasses.buttonErrorsRing,
          "focus:ring-opacity-50",
          "-ml-1.5 h-full hover:shadow-sm inline-flex items-center px-2 rounded-r",
          "text-red-900 dark:text-red-300 focus:text-white hover:text-red-800 dark:hover:text-red-200",
          "hover:bg-red-200 focus:bg-red-500 dark:hover:bg-red-400/20 dark:focus:bg-red-500/20"
        ),
        trigger: mergeClasses(
          commonClasses.inputsRingBase,
          commonClasses.inputsErrorsBackground,
          commonClasses.inputsErrorsBorder,
          commonClasses.inputsErrorsRing,
          commonClasses.inputsErrorTextColor,
          commonClasses.inputsText,
          commonClasses.inputsTransition,
          commonClasses.inputsShadows,
          commonClasses.inputsDisabled,
          commonClasses.inputsRadius,
          "px-2 py-3",
          "relative flex items-center w-full focus:z-10 cursor-pointer max-w-full w-full"
        )
      }
    }
  }
};
const tagsInputClassesKeys = Object.keys(tagsInputConfig.classes);

const _hoisted_1$2 = { class: "vc-input" };
const _hoisted_2$1 = ["disabled", "onKeydown"];
const _hoisted_3 = ["onClick"];
const _hoisted_4 = ["id", "name", "autocomplete", "placeholder", "disabled", "list", "onKeydown"];
const _hoisted_5 = ["id"];
const _hoisted_6 = ["value", "option"];
const __default__$2 = {
  name: "VanillaTagsInput",
  inheritAttrs: false
};
const _sfc_main$2 = /* @__PURE__ */ defineComponent({
  ...__default__$2,
  props: {
    ...useVariantProps$1(),
    modelValue: {
      type: [
        Array
      ],
      default: () => []
    },
    allowDuplicates: {
      type: Boolean,
      default: false
    },
    allowedOptions: {
      type: Array,
      default: () => []
    },
    allowSymbols: {
      type: Boolean,
      default: false
    },
    allowCustom: {
      type: Boolean,
      default: false
    },
    clearOnInvalid: {
      type: Boolean,
      default: true
    },
    transformValue: {
      type: Function,
      default: (value) => value
    },
    placeholder: {
      type: String,
      default: "Add new tag here"
    },
    errorTagNotAllowed: {
      type: String,
      default: "Sorry but this tag is not allowed. Allowed Tags are : "
    },
    errorTagDuplicated: {
      type: String,
      default: "This tag is already in the list, please choose another one"
    },
    errorTagInvalid: {
      type: String,
      default: "Sorry but this tag is not allowed, invalid or duplicated"
    }
  },
  emits: {
    "update:modelValue": (value) => true,
    "click": (event) => true,
    "focus": (event) => true,
    "focusout": (event) => true
  },
  setup(__props, { expose, emit: emits }) {
    const props = __props;
    const root = ref(null);
    const input = ref(null);
    const { localValue } = useMultipleVModel(props, "modelValue", true);
    const tag = ref("");
    const { configuration, errors, hasErrors } = useConfiguration(tagsInputConfig, "TagsInput", localValue);
    const handleDataListInput = (event) => {
      const target = event.target;
      if (!(event instanceof InputEvent) || event.inputType === "insertReplacementText") {
        tag.value = target.value;
        addOnPressEnter();
      }
    };
    const focusInput = () => {
      input.value?.focus();
    };
    const add = (value) => {
      if (props.disabled) {
        return;
      }
      const formattedValue = props.allowSymbols ? value : value.trim().replace(/[^a-zA-Z0-9\s]/g, "");
      let localErrors = "";
      if (formattedValue.length === 0 || !props.allowDuplicates && localValue.value?.includes(value) || props.allowedOptions.length > 0 && !props.allowCustom && !props.allowedOptions.includes(value)) {
        if (!props.allowDuplicates && localValue.value?.includes(value)) {
          localErrors = props.errorTagDuplicated;
        } else if (props.allowedOptions.length > 0 && !props.allowCustom && !props.allowedOptions.includes(value)) {
          localErrors = props.errorTagNotAllowed + props.allowedOptions.join(", ");
        } else {
          localErrors = props.errorTagInvalid;
        }
        if (props.clearOnInvalid) {
          tag.value = "";
          nextTick(() => errors.value = localErrors);
        }
        return;
      }
      localValue.value = [
        ...localValue.value || [],
        props.transformValue(props.allowSymbols ? value : formattedValue)
      ];
      tag.value = "";
    };
    const addOnPressEnter = () => {
      if (props.disabled) {
        return;
      }
      add(tag.value);
    };
    const remove = (tag2) => {
      if (props.disabled) {
        return;
      }
      localValue.value = localValue.value?.filter((t) => t !== tag2);
      focusInput();
    };
    const focusElement = (currentIndex, direction) => {
      const group = root.value?.children;
      let newIndex;
      if (group) {
        const buttonGroup = Array.from(group).filter((el) => el.tagName === "BUTTON");
        newIndex = (currentIndex + direction + buttonGroup.length) % buttonGroup.length;
        buttonGroup[newIndex].focus();
      }
    };
    const handleKeydown = (event, currentIndex, option) => {
      if (!event.target || !root.value?.contains(event.target)) {
        return;
      }
      if (event.key === "ArrowLeft" || event.key === "ArrowUp") {
        if (event.target === input.value) {
          const group = root.value?.children;
          if (group) {
            const buttonGroup = Array.from(group).filter((el) => el.tagName === "BUTTON");
            focusElement(buttonGroup.length - 1, 0);
          }
        } else {
          focusElement(currentIndex, -1);
        }
        return;
      }
      if (event.key === "ArrowRight" || event.key === "ArrowDown") {
        focusElement(currentIndex, 1);
        return;
      }
      if (event.key === "Backspace" && event.target.value === "") {
        event.preventDefault();
        remove(option);
        focusElement(currentIndex, -1);
      }
    };
    watch(() => [localValue.value, tag.value], () => {
      errors.value = "";
    });
    expose({
      add,
      remove
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$2, [
        renderSlot(_ctx.$slots, "before"),
        createElementVNode("div", {
          class: normalizeClass(unref(configuration).classesList.trigger)
        }, [
          createElementVNode("div", {
            ref_key: "root",
            ref: root,
            class: normalizeClass([
              unref(configuration).classesList.tagsWrapper
            ])
          }, [
            (openBlock(true), createElementBlock(Fragment, null, renderList(unref(localValue), (option, index) => {
              return renderSlot(_ctx.$slots, "tag", normalizeProps(mergeProps({ key: option }, {
                option,
                classes: unref(configuration).classesList,
                disabled: props.disabled,
                keyDown: handleKeydown,
                remove
              })), () => [
                createElementVNode("button", {
                  class: normalizeClass(unref(configuration).classesList.tag),
                  type: "button",
                  disabled: props.disabled,
                  onKeydown: ($event) => handleKeydown($event, index, option)
                }, [
                  createElementVNode("span", {
                    class: normalizeClass(unref(configuration).classesList.tagLabel)
                  }, [
                    renderSlot(_ctx.$slots, "tagLabel", { option }, () => [
                      createTextVNode(toDisplayString(option), 1)
                    ])
                  ], 2),
                  !props.disabled ? (openBlock(), createElementBlock("span", {
                    key: 0,
                    tabindex: "0",
                    class: normalizeClass(unref(configuration).classesList.tagDeleteButton),
                    onClick: ($event) => remove(option)
                  }, [
                    renderSlot(_ctx.$slots, "tagCloseIcon", { option }, () => [
                      createVNode(unref(CloseIcon), {
                        ref_for: true,
                        ref: "closeIcon",
                        class: normalizeClass(unref(configuration).classesList.tagDeleteButtonIcon)
                      }, null, 8, ["class"])
                    ])
                  ], 10, _hoisted_3)) : createCommentVNode("", true)
                ], 42, _hoisted_2$1)
              ]);
            }), 128)),
            createElementVNode("div", {
              class: normalizeClass(unref(configuration).classesList.inputWrapper)
            }, [
              withDirectives(createElementVNode("input", mergeProps({
                id: _ctx.name,
                ref_key: "input",
                ref: input,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => tag.value = $event),
                name: _ctx.name,
                autocomplete: props.autocomplete,
                placeholder: props.placeholder,
                class: unref(configuration).classesList.input,
                disabled: props.disabled
              }, _ctx.$attrs, {
                list: `${_ctx.name}-datalist`,
                onKeydown: [
                  handleKeydown,
                  withKeys(withModifiers(addOnPressEnter, ["prevent"]), ["enter"])
                ],
                onInput: handleDataListInput,
                onClick: _cache[1] || (_cache[1] = ($event) => _ctx.$emit("click", $event)),
                onFocus: _cache[2] || (_cache[2] = ($event) => _ctx.$emit("focus", $event)),
                onFocusout: _cache[3] || (_cache[3] = ($event) => _ctx.$emit("focusout", $event))
              }), null, 16, _hoisted_4), [
                [vModelDynamic, tag.value]
              ]),
              __props.allowedOptions.length > 0 ? (openBlock(), createElementBlock("datalist", {
                key: 0,
                id: `${_ctx.name}-datalist`
              }, [
                (openBlock(true), createElementBlock(Fragment, null, renderList(__props.allowedOptions, (option) => {
                  return openBlock(), createElementBlock("option", {
                    key: option,
                    value: option,
                    option
                  }, null, 8, _hoisted_6);
                }), 128))
              ], 8, _hoisted_5)) : createCommentVNode("", true)
            ], 2)
          ], 2)
        ], 2),
        renderSlot(_ctx.$slots, "after"),
        renderSlot(_ctx.$slots, "errors", normalizeProps(guardReactiveProps({ hasErrors: unref(hasErrors), errors: unref(errors) })), () => [
          unref(hasErrors) && props.showErrors ? (openBlock(), createBlock(_sfc_main$Z, {
            key: 0,
            errors: unref(errors)
          }, null, 8, ["errors"])) : createCommentVNode("", true)
        ]),
        renderSlot(_ctx.$slots, "feedback", normalizeProps(guardReactiveProps({ hasErrors: unref(hasErrors), feedback: props.feedback })), () => [
          !unref(hasErrors) && props?.feedback && props.showFeedback ? (openBlock(), createBlock(_sfc_main$Y, {
            key: 0,
            text: props.feedback
          }, null, 8, ["text"])) : createCommentVNode("", true)
        ])
      ]);
    };
  }
});

const textareaConfig = merge$1({}, inputConfig, {
  fixedClasses: {
    input: mergeClasses(
      commonClasses.inputsText,
      "appearance-none w-full focus:outline-none",
      commonClasses.inputsShadows,
      commonClasses.inputsDisabled,
      commonClasses.inputsBorder,
      "resize-y max-h-[10rem]",
      "scrollbar-thin"
    ),
    addonBefore: "absolute top-[0.8rem] left-0 pl-3 flex items-center cursor-pointer",
    addonAfter: "absolute inset-y-0 right-0 pr-3 flex items-center cursor-pointer"
  }
});
const textareaClassesKeys = Object.keys(textareaConfig.classes);

const _hoisted_1$1 = { class: "vanilla-input" };
const _hoisted_2 = ["id", "name", "autocomplete", "placeholder", "disabled"];
const __default__$1 = {
  name: "VanillaTextarea",
  inheritAttrs: false
};
const _sfc_main$1 = /* @__PURE__ */ defineComponent({
  ...__default__$1,
  props: {
    ...useVariantProps$1(),
    modelValue: {
      type: [String, Number],
      default: void 0
    },
    placeholder: {
      type: [String],
      default: ""
    },
    copiable: {
      type: [Boolean],
      default: false
    },
    autosize: {
      type: [Boolean],
      default: false
    },
    maxHeight: {
      type: [String, Number],
      default: "auto"
    }
  },
  emits: ["click", "update:modelValue", "focus", "focusout"],
  setup(__props, { emit }) {
    const props = __props;
    const root = ref(void 0);
    const localValue = useVModel(props, "modelValue");
    const { configuration, errors, hasErrors } = useConfiguration(textareaConfig, "Textarea", localValue);
    const { text, copy, copied, isSupported } = useClipboard();
    const resize = async () => {
      await nextTick(() => {
        if (root.value) {
          const maxHeight = root.value.scrollHeight > Number(props.maxHeight) ? props.maxHeight : root.value.scrollHeight;
          if (maxHeight <= 0) {
            return;
          }
          root.value.style.height = "auto";
          root.value.style.height = `${maxHeight}px`;
        }
      });
    };
    onMounted(async () => {
      if (props.autosize) {
        await resize();
      }
    });
    watch(localValue, async () => {
      if (props.autosize) {
        await resize();
      }
    }, { immediate: false });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$1, [
        createElementVNode("div", {
          class: normalizeClass(unref(configuration).classesList.wrapper)
        }, [
          unref(hasSlot)(_ctx.$slots.before) ? (openBlock(), createElementBlock("div", {
            key: 0,
            class: normalizeClass(unref(configuration).classesList.addonBefore)
          }, [
            renderSlot(_ctx.$slots, "before", normalizeProps(guardReactiveProps({ className: unref(configuration).classesList.addonClasses })))
          ], 2)) : createCommentVNode("", true),
          withDirectives(createElementVNode("textarea", mergeProps({
            id: _ctx.name,
            ref_key: "root",
            ref: root,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => isRef(localValue) ? localValue.value = $event : null),
            name: _ctx.name,
            autocomplete: props.autocomplete,
            placeholder: props.placeholder,
            class: [
              unref(hasSlot)(_ctx.$slots.before) ? unref(configuration).classesList.addonBeforeInputClasses : "",
              unref(hasSlot)(_ctx.$slots.after) || unref(hasErrors) ? unref(configuration).classesList.addonAfterInputClasses : "",
              unref(configuration).classesList.input,
              unref(configuration).classesList.inputBorder,
              props.rounded === "full" ? unref(configuration).classesList.roundedFull : "",
              props.rounded === "top" ? unref(configuration).classesList.roundedTop : "",
              props.rounded === "bottom" ? unref(configuration).classesList.roundedBottom : "",
              props.rounded === "left" ? unref(configuration).classesList.roundedLeft : "",
              props.rounded === "right" ? unref(configuration).classesList.roundedRight : "",
              props.rounded === "top-left" ? unref(configuration).classesList.roundedTopLeft : "",
              props.rounded === "top-right" ? unref(configuration).classesList.roundedTopRight : "",
              props.rounded === "bottom-left" ? unref(configuration).classesList.roundedBottomLeft : "",
              props.rounded === "bottom-right" ? unref(configuration).classesList.roundedBottomRight : "",
              props.disabled ? unref(configuration).classesList.disabled : ""
            ],
            disabled: _ctx.disabled
          }, _ctx.$attrs, {
            onClick: _cache[1] || (_cache[1] = ($event) => _ctx.$emit("click", $event)),
            onFocus: _cache[2] || (_cache[2] = ($event) => _ctx.$emit("focus", $event)),
            onFocusout: _cache[3] || (_cache[3] = ($event) => _ctx.$emit("focusout", $event))
          }), null, 16, _hoisted_2), [
            [vModelText, unref(localValue)]
          ]),
          unref(hasSlot)(_ctx.$slots.after) || unref(hasErrors) || props.copiable ? (openBlock(), createElementBlock("div", mergeProps({ key: 1 }, { hasErrors: unref(hasErrors), className: unref(configuration).classesList.addonClasses }, {
            class: unref(configuration).classesList.addonAfter
          }), [
            renderSlot(_ctx.$slots, "after", {}, () => [
              unref(hasErrors) ? (openBlock(), createBlock(unref(ExclamationCircleIcon), {
                key: 0,
                class: normalizeClass(unref(configuration).classesList.addonClasses)
              }, null, 8, ["class"])) : createCommentVNode("", true),
              withDirectives(createVNode(unref(ClipboardIcon), {
                class: normalizeClass(unref(configuration).classesList.addonClasses),
                onClick: _cache[4] || (_cache[4] = ($event) => unref(copy)(unref(localValue)))
              }, null, 8, ["class"]), [
                [vShow, props.copiable && !unref(copied)]
              ]),
              withDirectives(createVNode(unref(CheckIcon$1), {
                class: normalizeClass(unref(configuration).classesList.addonClasses)
              }, null, 8, ["class"]), [
                [vShow, props.copiable && unref(copied)]
              ])
            ])
          ], 16)) : createCommentVNode("", true)
        ], 2),
        renderSlot(_ctx.$slots, "errors", normalizeProps(guardReactiveProps({ hasErrors: unref(hasErrors), errors: unref(errors) })), () => [
          unref(hasErrors) && props.showErrors ? (openBlock(), createBlock(_sfc_main$Z, {
            key: 0,
            errors: unref(errors)
          }, null, 8, ["errors"])) : createCommentVNode("", true)
        ]),
        renderSlot(_ctx.$slots, "feedback", normalizeProps(guardReactiveProps({ hasErrors: unref(hasErrors), feedback: props.feedback })), () => [
          !unref(hasErrors) && props.feedback && props.showFeedback ? (openBlock(), createBlock(_sfc_main$Y, {
            key: 0,
            text: props.feedback
          }, null, 8, ["text"])) : createCommentVNode("", true)
        ])
      ]);
    };
  }
});

const _hoisted_1 = ["textContent"];
const __default__ = {
  name: "VanillaToggleGroup",
  inheritAttrs: false
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  ...__default__,
  props: {
    ...useVariantProps$1(),
    modelValue: {
      type: [
        String,
        Number,
        Boolean,
        Array,
        Object,
        Date,
        Function,
        Symbol
      ],
      default: void 0
    },
    options: {
      type: [Array, Object],
      default: void 0
    },
    normalizeOptions: {
      type: Boolean,
      default: true
    },
    valueAttribute: {
      type: String,
      default: "value"
    },
    textAttribute: {
      type: String,
      default: "text"
    }
  },
  emits: ["update:modelValue", "focus", "focusout", "click"],
  setup(__props, { emit }) {
    const props = __props;
    const { localValue } = useMultipleVModel(props, "modelValue", true);
    const { configuration, errors, hasErrors, variant } = useConfiguration(toggleConfig, "ToggleGroup", localValue);
    const { normalizedOptions } = useMultipleOptions(
      computed(() => props.options),
      computed(() => props.textAttribute),
      computed(() => props.valueAttribute),
      computed(() => props.normalizeOptions)
    );
    const generateUniqueId = (name, id) => `${props.name}_${name.toLowerCase().replace(/\s+/g, "-")}_${id}`;
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(["vanilla-toggle-group", [
          unref(configuration).classesList.container,
          unref(configuration).classesList.groupContainer,
          _ctx.disabled ? unref(configuration).classesList.disabled : ""
        ]])
      }, [
        (openBlock(true), createElementBlock(Fragment, null, renderList(unref(normalizedOptions), (option, index) => {
          return openBlock(), createElementBlock("div", { key: index }, [
            createElementVNode("div", {
              class: normalizeClass(unref(configuration).classesList.groupToggleWrapper)
            }, [
              createElementVNode("div", {
                class: normalizeClass(unref(configuration).classesList.groupToggle)
              }, [
                createVNode(_sfc_main$l, {
                  modelValue: unref(localValue),
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => isRef(localValue) ? localValue.value = $event : null),
                  name: generateUniqueId(option.value.toString(), index),
                  value: option.value,
                  variant: unref(variant),
                  disabled: _ctx.disabled || option?.disabled,
                  onFocus: _cache[1] || (_cache[1] = ($event) => _ctx.$emit("focus", $event)),
                  onFocusout: _cache[2] || (_cache[2] = ($event) => _ctx.$emit("focusout", $event))
                }, null, 8, ["modelValue", "name", "value", "variant", "disabled"])
              ], 2),
              createElementVNode("div", {
                class: normalizeClass(unref(configuration).classesList.groupLabelWrapper)
              }, [
                createVNode(_sfc_main$R, {
                  for: generateUniqueId(option.value.toString(), index),
                  label: option.text.toString(),
                  classes: unref(configuration).classesList.label,
                  disabled: _ctx.disabled || option?.disabled
                }, null, 8, ["for", "label", "classes", "disabled"]),
                option.raw?.description ? (openBlock(), createElementBlock("span", {
                  key: 0,
                  class: normalizeClass(unref(configuration).classesList.groupLabelFeedback),
                  textContent: toDisplayString(option.raw?.description)
                }, null, 10, _hoisted_1)) : createCommentVNode("", true)
              ], 2)
            ], 2)
          ]);
        }), 128)),
        renderSlot(_ctx.$slots, "errors", normalizeProps(guardReactiveProps({ hasErrors: unref(hasErrors), errors: unref(errors) })), () => [
          unref(hasErrors) && unref(errors) ? (openBlock(), createBlock(_sfc_main$Z, {
            key: 0,
            errors: unref(errors)
          }, null, 8, ["errors"])) : createCommentVNode("", true)
        ]),
        renderSlot(_ctx.$slots, "feedback", normalizeProps(guardReactiveProps({ hasErrors: unref(hasErrors), feedback: props.feedback })), () => [
          !unref(hasErrors) && props.feedback && props.showFeedback ? (openBlock(), createBlock(_sfc_main$Y, {
            key: 0,
            text: props.feedback
          }, null, 8, ["text"])) : createCommentVNode("", true)
        ])
      ], 2);
    };
  }
});

const defaultConfiguration = {
  Alert: alertConfig,
  Avatar: avatarConfig,
  Button: buttonConfig,
  Card: cardConfig,
  Checkbox: checkboxConfig,
  CountryInput: countryInputConfig,
  Datatable: datatableConfig,
  DateTimeInput: dateTimeInputConfig,
  Dialog: dialogConfig,
  Dropdown: dropdownConfig,
  FormErrors: formsConfig,
  FormFeedback: formsConfig,
  FormLabel: formsConfig,
  FormSection: formsConfig,
  Input: inputConfig,
  InputGroup: inputGroupConfig,
  PhoneInput: phoneInputConfig,
  RichRadio: richRadioConfig,
  RichRadioOption: richRadioOptionConfig,
  RichSelect: richSelectConfig,
  RichSelectOptionWithImage: richSelectOptionWithImageConfig,
  RichSelectOptionWithIndicators: richSelectOptionWithIndicatorsConfig,
  RichSelectTagWithImage: richSelectTagWithImageConfig,
  Select: selectConfig,
  SkeletonBar: skeletonConfig,
  Slideover: slideoverConfig,
  StatusIndicator: statusIndicatorConfig,
  TagsInput: tagsInputConfig,
  Textarea: textareaConfig,
  Toggle: toggleConfig
};
const mergeConfiguration = (userConfiguration = {}) => {
  return merge$1(defaultConfiguration, userConfiguration);
};
const defineConfiguration = (userConfiguration = {}, preset = {}) => {
  if (preset) {
    return merge$1(preset, userConfiguration);
  }
  return merge$1(defaultConfiguration, userConfiguration);
};
const defaultOptions = {
  swapErrorsVariantOnModelValueChanges: false
};
const defineOptions = (userOptions = {}) => {
  return merge$1(defaultOptions, userOptions);
};

const plugin = {
  install: (app, configuration = {}, options = {}) => {
    app.config.globalProperties.$vanillaComponents = true;
    const mergedConfiguration = mergeConfiguration(configuration);
    app.provide("vanilla_configuration", mergedConfiguration);
    app.provide("vanilla_components_options", defineOptions(options));
  }
};
const plugin$1 = plugin;

export { useConfiguration as $, _sfc_main$o as A, _sfc_main$x as B, _sfc_main$y as C, _sfc_main$N as D, _sfc_main$Z as E, _sfc_main$Y as F, _sfc_main$R as G, _sfc_main$j as H, Flag as I, _sfc_main$k as J, _sfc_main$b as K, _sfc_main$$ as L, _sfc_main$d as M, _sfc_main$a as N, _sfc_main$8 as O, _sfc_main$9 as P, _sfc_main$7 as Q, _sfc_main$6 as R, _sfc_main$5 as S, _sfc_main$M as T, _sfc_main$v as U, _sfc_main$4 as V, _sfc_main$3 as W, _sfc_main$2 as X, _sfc_main as Y, plugin$1 as Z, _sfc_main$L as _, _sfc_main$A as a, useVModel as a0, useVariantProps$1 as a1, useMultipleVModel as a2, defaultConfiguration as a3, mergeConfiguration as a4, defineConfiguration as a5, defineOptions as a6, avatarConfig as a7, avatarClassesKeys as a8, buttonConfig as a9, richRadioOptionClassesKeys as aA, richSelectConfig as aB, richSelectClassesKeys as aC, richSelectOptionWithImageConfig as aD, richSelectOptionWithImageClassesKeys as aE, richSelectOptionWithIndicatorsConfig as aF, richSelectOptionWithIndicatorsClassesKeys as aG, richSelectTagWithImageConfig as aH, richSelectTagWithImageClassesKeys as aI, selectConfig as aJ, selectClassesKeys as aK, countryInputConfig as aL, countryInputOptionConfig as aM, countryInputClassesKeys as aN, countryInputOptionClassesKeys as aO, skeletonConfig as aP, skeletonClassesKeys as aQ, slideoverConfig as aR, slideoverClassesKeys as aS, statusIndicatorConfig as aT, statusIndicatorClassesKeys as aU, tagsInputConfig as aV, tagsInputClassesKeys as aW, textareaConfig as aX, textareaClassesKeys as aY, toggleConfig as aZ, toggleClassesKeys as a_, buttonClassesKeys as aa, cardConfig as ab, cardClassesKeys as ac, checkboxConfig as ad, checkboxClassesKeys as ae, datatableConfig as af, datatableClassesKeys as ag, dateTimeInputConfig as ah, dateTimeInputClassesKeys as ai, dialogConfig as aj, dialogClassesKeys as ak, dropdownConfig as al, dropdownPopperDefaultOptions as am, dropdownClassesKeys as an, validDropdownPlacements as ao, formsConfig as ap, formClassesKeys as aq, inputConfig as ar, inputClassesKeys as as, inputGroupConfig as at, inputGroupClassesKeys as au, phoneInputConfig as av, phoneInputClassesKeys as aw, richRadioConfig as ax, richRadioClassesKeys as ay, richRadioOptionConfig as az, _sfc_main$S as b, _sfc_main$l as c, _sfc_main$t as d, _sfc_main$1 as e, _sfc_main$c as f, _export_sfc as g, _sfc_main$_ as h, _sfc_main$W as i, _sfc_main$X as j, _sfc_main$U as k, _sfc_main$V as l, _sfc_main$T as m, _sfc_main$Q as n, _sfc_main$z as o, _sfc_main$e as p, _sfc_main$p as q, _sfc_main$m as r, _sfc_main$h as s, _sfc_main$i as t, _sfc_main$g as u, _sfc_main$w as v, _sfc_main$q as w, _sfc_main$u as x, _sfc_main$s as y, _sfc_main$n as z };
//# sourceMappingURL=index-6341170e.js.map
